import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: { input: any; output: any; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: any; output: any; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar.This scalar is serialized to a string in ISO 8601 format and parsed from a string in ISO 8601 format. */
  DateTimeISO: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: { input: any; output: any; }
};

export type AcceptInviteDto = {
  id: Scalars['String']['input'];
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type AccessGrant = {
  constraints?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['DateTime']['output'];
  grantedByName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  permission: Scalars['String']['output'];
  resourceId: Scalars['String']['output'];
  resourceType: Scalars['String']['output'];
  subjectId: Scalars['String']['output'];
  subjectLabel?: Maybe<Scalars['String']['output']>;
  subjectType: Scalars['String']['output'];
};

export type AccountBankTransaction = {
  amount: Scalars['String']['output'];
  bank?: Maybe<BankAccount>;
  bankId: Scalars['ID']['output'];
  challanId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  journal?: Maybe<JournalHeader>;
  journalId: Scalars['ID']['output'];
  refId?: Maybe<Scalars['String']['output']>;
  secondaryId?: Maybe<Scalars['Float']['output']>;
  transactionDate: Scalars['DateTime']['output'];
  type: AccountBankTransactionType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum AccountBankTransactionType {
  Payment = 'PAYMENT',
  Receipt = 'RECEIPT'
}

export type AccountBankTransactionsResponseDto = {
  data: Array<AccountBankTransaction>;
  meta: MetaResponse;
};

export enum AccountDimension {
  Group = 'GROUP',
  Posting = 'POSTING'
}

export enum AccountPayableEntryMethod {
  Automatic = 'AUTOMATIC',
  Manual = 'MANUAL'
}

export type AccountPayableInvoice = {
  aging?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['ID']['output'];
  createdByName?: Maybe<Scalars['String']['output']>;
  discountAmount?: Maybe<Scalars['Float']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  entityId: Scalars['ID']['output'];
  entityName?: Maybe<Scalars['String']['output']>;
  entryMethod: AccountPayableEntryMethod;
  fiscalPeriodId?: Maybe<Scalars['ID']['output']>;
  fiscalPeriodName?: Maybe<Scalars['String']['output']>;
  grnId?: Maybe<Scalars['ID']['output']>;
  grnInvoiceNumber?: Maybe<Scalars['String']['output']>;
  grnSecondaryId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  invoiceDate: Scalars['DateTime']['output'];
  invoiceNo?: Maybe<Scalars['String']['output']>;
  invoiceType: AccountPayableInvoiceType;
  journal?: Maybe<JournalHeader>;
  journalId?: Maybe<Scalars['ID']['output']>;
  journalNo?: Maybe<Scalars['String']['output']>;
  lines?: Maybe<Array<AccountPayableInvoiceLine>>;
  locationId?: Maybe<Scalars['ID']['output']>;
  locationName?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  outstandingAmount: Scalars['Float']['output'];
  partnerId?: Maybe<Scalars['ID']['output']>;
  partnerName?: Maybe<Scalars['String']['output']>;
  paymentTerms?: Maybe<PaymentTerms>;
  paymentTermsId?: Maybe<Scalars['ID']['output']>;
  paymentTermsName?: Maybe<Scalars['String']['output']>;
  poId?: Maybe<Scalars['ID']['output']>;
  poSecondaryId?: Maybe<Scalars['Int']['output']>;
  postedAt?: Maybe<Scalars['DateTime']['output']>;
  postedBy?: Maybe<Scalars['String']['output']>;
  postedByName?: Maybe<Scalars['String']['output']>;
  relatedInvoice?: Maybe<AccountPayableInvoice>;
  relatedInvoiceId?: Maybe<Scalars['ID']['output']>;
  relationType?: Maybe<AccountPayableInvoiceRelationType>;
  roundingAdjustment?: Maybe<Scalars['Float']['output']>;
  secondaryId?: Maybe<Scalars['Float']['output']>;
  settlementLines?: Maybe<Array<ApSettlementLine>>;
  status: AccountPayableInvoiceStatus;
  subtotal: Scalars['Float']['output'];
  taxAmount: Scalars['Float']['output'];
  threeWayMatch: Scalars['Boolean']['output'];
  totalAmount: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
  vendorId?: Maybe<Scalars['ID']['output']>;
  vendorName?: Maybe<Scalars['String']['output']>;
  whtAmount: Scalars['Float']['output'];
  writeoffs?: Maybe<Array<AccountPayableWriteoff>>;
};

export type AccountPayableInvoiceLine = {
  chartOfAccounts?: Maybe<ChartOfAccounts>;
  chartOfAccountsId?: Maybe<Scalars['ID']['output']>;
  costCenterId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  discountAmount: Scalars['Float']['output'];
  grnId?: Maybe<Scalars['ID']['output']>;
  grnLineId?: Maybe<Scalars['ID']['output']>;
  grossAmount: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  invoice?: Maybe<AccountPayableInvoice>;
  invoiceId: Scalars['ID']['output'];
  lineTotal: Scalars['Float']['output'];
  locationId?: Maybe<Scalars['ID']['output']>;
  locationName?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['ID']['output']>;
  orderSecondaryId?: Maybe<Scalars['Int']['output']>;
  poId?: Maybe<Scalars['ID']['output']>;
  poLineId?: Maybe<Scalars['ID']['output']>;
  productId?: Maybe<Scalars['ID']['output']>;
  profitCenterId?: Maybe<Scalars['ID']['output']>;
  qty: Scalars['Float']['output'];
  secondaryId?: Maybe<Scalars['Float']['output']>;
  taxAmount: Scalars['Float']['output'];
  taxType: Tax_Type;
  type?: Maybe<ApInvoiceLineType>;
  unitPrice: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum AccountPayableInvoiceRelationType {
  Adjustment = 'ADJUSTMENT',
  Reversal = 'REVERSAL'
}

export type AccountPayableInvoiceResponseDto = {
  data: Array<AccountPayableInvoice>;
  meta: MetaResponse;
};

export enum AccountPayableInvoiceStatus {
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Draft = 'DRAFT',
  PartiallySettled = 'PARTIALLY_SETTLED',
  Posted = 'POSTED',
  Settled = 'SETTLED'
}

export enum AccountPayableInvoiceType {
  Bill = 'BILL',
  CreditNote = 'CREDIT_NOTE',
  DebitNote = 'DEBIT_NOTE'
}

export type AccountPayablePayment = {
  advanceDate?: Maybe<Scalars['DateTime']['output']>;
  advancePayment?: Maybe<Scalars['Float']['output']>;
  advanceRemarks?: Maybe<Scalars['String']['output']>;
  amount: Scalars['Float']['output'];
  apSettlementLines?: Maybe<Array<ApSettlementLine>>;
  bank?: Maybe<BankAccount>;
  bankId?: Maybe<Scalars['ID']['output']>;
  cashId?: Maybe<Scalars['ID']['output']>;
  challanId?: Maybe<Scalars['String']['output']>;
  chartOfAccount?: Maybe<ChartOfAccounts>;
  chartOfAccountsId?: Maybe<Scalars['ID']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  costCenterId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  createdByName?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['ID']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['ID']['output']>;
  fiscalPeriodId?: Maybe<Scalars['ID']['output']>;
  fiscalPeriodName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  journal?: Maybe<JournalHeader>;
  journalId?: Maybe<Scalars['ID']['output']>;
  method: AccountPayablePaymentMethod;
  offsetDescription?: Maybe<Scalars['String']['output']>;
  offsetTaxHandling?: Maybe<Scalars['String']['output']>;
  partnerId?: Maybe<Scalars['ID']['output']>;
  partnerName?: Maybe<Scalars['String']['output']>;
  paymentDate: Scalars['DateTime']['output'];
  postedAt?: Maybe<Scalars['DateTime']['output']>;
  postedBy?: Maybe<Scalars['String']['output']>;
  postedByName?: Maybe<Scalars['String']['output']>;
  profitCenterId?: Maybe<Scalars['ID']['output']>;
  refId?: Maybe<Scalars['String']['output']>;
  secondaryId?: Maybe<Scalars['Float']['output']>;
  status: ApPaymentStatus;
  vendorId?: Maybe<Scalars['ID']['output']>;
  vendorName?: Maybe<Scalars['String']['output']>;
};

export enum AccountPayablePaymentMethod {
  Adjustment = 'ADJUSTMENT',
  Bank = 'BANK',
  Cash = 'CASH',
  OffsetAccount = 'OFFSET_ACCOUNT'
}

export type AccountPayablePaymentResponseDto = {
  data: Array<AccountPayablePayment>;
  meta: MetaResponse;
};

export type AccountPayableWriteoff = {
  amount: Scalars['Float']['output'];
  costCenterId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['ID']['output'];
  createdByName?: Maybe<Scalars['String']['output']>;
  entityId: Scalars['ID']['output'];
  fiscalPeriodId?: Maybe<Scalars['ID']['output']>;
  fiscalPeriodName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoice: AccountPayableInvoice;
  invoiceId: Scalars['ID']['output'];
  journal?: Maybe<JournalHeader>;
  journalId?: Maybe<Scalars['ID']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  postedAt?: Maybe<Scalars['DateTime']['output']>;
  postedBy?: Maybe<Scalars['String']['output']>;
  postedByName?: Maybe<Scalars['String']['output']>;
  profitCenterId?: Maybe<Scalars['ID']['output']>;
  reasonCode: ApWriteoffReasonCode;
  secondaryId?: Maybe<Scalars['Float']['output']>;
  status: ApWriteoffStatus;
  updatedAt: Scalars['DateTime']['output'];
  writeoffDate: Scalars['DateTime']['output'];
};

export type AccountPayableWriteoffResponseDto = {
  data: Array<AccountPayableWriteoff>;
  meta: MetaResponse;
};

export enum AccountReceivableEntryMethod {
  Automatic = 'AUTOMATIC',
  Manual = 'MANUAL'
}

export type AccountReceivableInvoice = {
  aging?: Maybe<Scalars['String']['output']>;
  arInvoice?: Maybe<AccountReceivableInvoice>;
  arInvoiceId?: Maybe<Scalars['ID']['output']>;
  contactOn?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['ID']['output']>;
  createdByName?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['ID']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  discountTotal?: Maybe<Scalars['Float']['output']>;
  dueDate: Scalars['DateTime']['output'];
  entityId: Scalars['ID']['output'];
  entryMethod: AccountReceivableEntryMethod;
  fiscalPeriodId?: Maybe<Scalars['ID']['output']>;
  fiscalPeriodName?: Maybe<Scalars['String']['output']>;
  fxRate?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  invoiceDate: Scalars['DateTime']['output'];
  invoiceType: AccountReceivableInvoiceType;
  journal?: Maybe<JournalHeader>;
  journalId?: Maybe<Scalars['ID']['output']>;
  journalNo?: Maybe<Scalars['String']['output']>;
  lines?: Maybe<Array<AccountReceivableInvoiceLine>>;
  locationId?: Maybe<Scalars['ID']['output']>;
  locationName?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  outstandingAmount: Scalars['Float']['output'];
  partnerId?: Maybe<Scalars['ID']['output']>;
  partnerName?: Maybe<Scalars['String']['output']>;
  paymentTerms?: Maybe<PaymentTerms>;
  paymentTermsId?: Maybe<Scalars['ID']['output']>;
  paymentTermsName?: Maybe<Scalars['String']['output']>;
  postedAt?: Maybe<Scalars['DateTime']['output']>;
  postedBy?: Maybe<Scalars['ID']['output']>;
  postedByName?: Maybe<Scalars['String']['output']>;
  relatedInvoice?: Maybe<AccountReceivableInvoice>;
  relatedInvoiceId?: Maybe<Scalars['ID']['output']>;
  relatedInvoiceSecondaryId?: Maybe<Scalars['Int']['output']>;
  relationType?: Maybe<AccountReceivableInvoiceRelationType>;
  roundingAdjustment?: Maybe<Scalars['Float']['output']>;
  secondaryId?: Maybe<Scalars['Float']['output']>;
  settlementLines?: Maybe<Array<ArSettlementLine>>;
  status: AccountReceivableInvoiceStatus;
  subtotalAmount: Scalars['Float']['output'];
  taxAmount: Scalars['Float']['output'];
  totalAmount: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
  whtAmount: Scalars['Float']['output'];
  writeoffAmount?: Maybe<Scalars['Float']['output']>;
  writeoffs?: Maybe<Array<AccountReceivableWriteoff>>;
};

export type AccountReceivableInvoiceLine = {
  chartOfAccounts?: Maybe<ChartOfAccounts>;
  chartOfAccountsId?: Maybe<Scalars['ID']['output']>;
  costCenterId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  discountAmount: Scalars['Float']['output'];
  grossAmount: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  invoice?: Maybe<AccountReceivableInvoice>;
  invoiceId: Scalars['ID']['output'];
  lineTotal: Scalars['Float']['output'];
  locationId?: Maybe<Scalars['ID']['output']>;
  locationName?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['ID']['output']>;
  orderLineId?: Maybe<Scalars['ID']['output']>;
  orderSecondaryId?: Maybe<Scalars['Int']['output']>;
  productId?: Maybe<Scalars['ID']['output']>;
  profitCenterId?: Maybe<Scalars['ID']['output']>;
  qty: Scalars['Float']['output'];
  secondaryId?: Maybe<Scalars['Float']['output']>;
  taxAmount: Scalars['Float']['output'];
  type?: Maybe<ArInvoiceLineType>;
  unitPrice: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum AccountReceivableInvoiceRelationType {
  Adjustment = 'ADJUSTMENT',
  Reversal = 'REVERSAL'
}

export type AccountReceivableInvoiceResponseDto = {
  data?: Maybe<Array<AccountReceivableInvoice>>;
  meta?: Maybe<MetaResponse>;
};

export enum AccountReceivableInvoiceStatus {
  Cancelled = 'CANCELLED',
  Draft = 'DRAFT',
  PartiallySettled = 'PARTIALLY_SETTLED',
  Posted = 'POSTED',
  Settled = 'SETTLED',
  WrittenOff = 'WRITTEN_OFF'
}

export enum AccountReceivableInvoiceType {
  CreditMemo = 'CREDIT_MEMO',
  DebitMemo = 'DEBIT_MEMO',
  Invoice = 'INVOICE'
}

export type AccountReceivableReceipt = {
  advanceDate?: Maybe<Scalars['DateTime']['output']>;
  advancePayment?: Maybe<Scalars['Float']['output']>;
  advanceRemarks?: Maybe<Scalars['String']['output']>;
  amountReceived: Scalars['String']['output'];
  arInvoice?: Maybe<AccountReceivableInvoice>;
  bank?: Maybe<BankAccount>;
  bankId?: Maybe<Scalars['ID']['output']>;
  cash?: Maybe<CashAccount>;
  cashId?: Maybe<Scalars['ID']['output']>;
  challanId?: Maybe<Scalars['String']['output']>;
  chartOfAccounts?: Maybe<ChartOfAccounts>;
  chartOfAccountsId?: Maybe<Scalars['ID']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  costCenterId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['ID']['output']>;
  createdByName?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['ID']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  dateReceived: Scalars['DateTime']['output'];
  entityId: Scalars['ID']['output'];
  fiscalPeriodId?: Maybe<Scalars['ID']['output']>;
  fiscalPeriodName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  journal?: Maybe<JournalHeader>;
  journalId?: Maybe<Scalars['ID']['output']>;
  mode: AccountReceivableReceiptMode;
  offsetDescription?: Maybe<Scalars['String']['output']>;
  offsetTaxHandling?: Maybe<Scalars['String']['output']>;
  partnerId?: Maybe<Scalars['ID']['output']>;
  partnerName?: Maybe<Scalars['String']['output']>;
  postedAt?: Maybe<Scalars['DateTime']['output']>;
  postedBy?: Maybe<Scalars['ID']['output']>;
  postedByName?: Maybe<Scalars['String']['output']>;
  profitCenterId?: Maybe<Scalars['ID']['output']>;
  refId?: Maybe<Scalars['String']['output']>;
  secondaryId?: Maybe<Scalars['Float']['output']>;
  settlementLines?: Maybe<Array<ArSettlementLine>>;
  status: ArReceiptStatus;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  vendorId?: Maybe<Scalars['ID']['output']>;
};

export enum AccountReceivableReceiptMode {
  Adjustment = 'ADJUSTMENT',
  Bank = 'BANK',
  Cash = 'CASH',
  OffsetAccount = 'OFFSET_ACCOUNT'
}

export type AccountReceivableReceiptResponseDto = {
  data: Array<AccountReceivableReceipt>;
  meta: MetaResponse;
};

export type AccountReceivableWriteoff = {
  amount: Scalars['Float']['output'];
  costCenterId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['ID']['output'];
  createdByName?: Maybe<Scalars['String']['output']>;
  entity?: Maybe<EntityModel>;
  entityId?: Maybe<Scalars['ID']['output']>;
  fiscalPeriodId?: Maybe<Scalars['ID']['output']>;
  fiscalPeriodName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoice: AccountReceivableInvoice;
  invoiceId: Scalars['ID']['output'];
  journal?: Maybe<JournalHeader>;
  journalId?: Maybe<Scalars['ID']['output']>;
  postedAt?: Maybe<Scalars['DateTime']['output']>;
  postedBy?: Maybe<Scalars['ID']['output']>;
  postedByName?: Maybe<Scalars['String']['output']>;
  profitCenterId?: Maybe<Scalars['ID']['output']>;
  reason: Scalars['String']['output'];
  reasonCode: ArWriteoffReasonCode;
  secondaryId?: Maybe<Scalars['Float']['output']>;
  status: ArWriteoffStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type AccountReceivableWriteoffResponseDto = {
  data: Array<AccountReceivableWriteoff>;
  meta: MetaResponse;
};

export enum AccountStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Deactive = 'DEACTIVE',
  Inactive = 'INACTIVE'
}

export type AccountSubtype = {
  canonical?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isCashLike: Scalars['Boolean']['output'];
  isControlSubtype: Scalars['Boolean']['output'];
  isReconcilable: Scalars['Boolean']['output'];
  isSystemManaged: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  secondaryId?: Maybe<Scalars['Float']['output']>;
  status: AccountStatus;
  subledgerType: SubledgerType;
  type: AccountType;
};

export type AccountSubtypeResponseDto = {
  data: Array<AccountSubtype>;
  meta: MetaResponse;
};

export enum AccountType {
  Asset = 'ASSET',
  Equity = 'EQUITY',
  Expense = 'EXPENSE',
  Liability = 'LIABILITY',
  Revenue = 'REVENUE'
}

export type AddFusionIntegrationProductsInput = {
  connectionId: Scalars['String']['input'];
  productIds: Array<Scalars['String']['input']>;
};

export type AddProductionLineDto = {
  bomVersionId: Scalars['String']['input'];
  multiplierFactor: Scalars['Int']['input'];
  outputProductId: Scalars['String']['input'];
  productionPlanId: Scalars['String']['input'];
};

export type AddStockOperationItemDto = {
  batchExpiry?: InputMaybe<Scalars['String']['input']>;
  batchNumber?: InputMaybe<Scalars['String']['input']>;
  gstValue?: InputMaybe<Scalars['Float']['input']>;
  manufacturerCode?: InputMaybe<Scalars['String']['input']>;
  mfgDate?: InputMaybe<Scalars['String']['input']>;
  mrp?: InputMaybe<Scalars['Float']['input']>;
  productId: Scalars['String']['input'];
  productLotId?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Float']['input'];
  stockOperationId: Scalars['String']['input'];
  tradePrice?: InputMaybe<Scalars['Float']['input']>;
};

export type AddWithdrawBalanceLocationRegisterSession = {
  amount: Scalars['Float']['input'];
  note: Scalars['String']['input'];
};

export type Address = {
  additionalNumber?: Maybe<Scalars['String']['output']>;
  buildingNo?: Maybe<Scalars['String']['output']>;
  city?: Maybe<City>;
  cityId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customerId: Scalars['String']['output'];
  districtName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  landmark?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  secondaryId?: Maybe<Scalars['Float']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  streetAddress1?: Maybe<Scalars['String']['output']>;
  streetAddress2?: Maybe<Scalars['String']['output']>;
  streetName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type AddressResponseDto = {
  data: Array<Address>;
  meta: MetaResponse;
};

export type Adjustment = {
  adjustedQuantity: Scalars['Int']['output'];
  adjustmentType: AdjustmentType;
  auditId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['String']['output'];
  itemCount: Scalars['Int']['output'];
  locationId?: Maybe<Scalars['String']['output']>;
  lotCount: Scalars['Int']['output'];
  products: Array<AdjustmentProduct>;
  remarks?: Maybe<Scalars['String']['output']>;
  secondaryId: Scalars['Float']['output'];
  status: AdjustmentStatus;
  stockValue: Scalars['Float']['output'];
  stockValueExcludingTax: Scalars['Float']['output'];
  taxValue: Scalars['Float']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export enum AdjustmentDirection {
  Decrease = 'DECREASE',
  Increase = 'INCREASE'
}

export type AdjustmentLot = {
  actionId?: Maybe<Scalars['String']['output']>;
  adjustedExpiryDate?: Maybe<Scalars['String']['output']>;
  adjustedLocation?: Maybe<Location>;
  adjustedLocationId?: Maybe<Scalars['String']['output']>;
  adjustedQuantity?: Maybe<Scalars['Int']['output']>;
  adjustedStatus?: Maybe<ProductLotStatus>;
  adjustment: Adjustment;
  adjustmentId?: Maybe<Scalars['String']['output']>;
  adjustmentProduct: AdjustmentProduct;
  adjustmentProductId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  damageQuantity?: Maybe<Scalars['Int']['output']>;
  damageQuantityUnit?: Maybe<DamageQuantityUnit>;
  expiryDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  location?: Maybe<Location>;
  locationId?: Maybe<Scalars['String']['output']>;
  lotId: Scalars['String']['output'];
  netQuantity?: Maybe<Scalars['Int']['output']>;
  originalQuantity?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  stockValue?: Maybe<Scalars['Float']['output']>;
  stockValueExcludingTax?: Maybe<Scalars['Float']['output']>;
  taxValue?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AdjustmentLotValidationError = {
  actionId: Scalars['String']['output'];
  errors: Array<Scalars['String']['output']>;
  locationId: Scalars['String']['output'];
};

export type AdjustmentProduct = {
  adjustedLocationId?: Maybe<Scalars['String']['output']>;
  adjustedQuantity: Scalars['Int']['output'];
  adjustedStatus?: Maybe<Scalars['String']['output']>;
  adjustment: Adjustment;
  adjustmentId?: Maybe<Scalars['String']['output']>;
  adjustmentLot: Array<AdjustmentLot>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  locationId?: Maybe<Scalars['String']['output']>;
  netQuantity: Scalars['Int']['output'];
  originalQuantity?: Maybe<Scalars['Int']['output']>;
  productId: Scalars['String']['output'];
  productName: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  stockValue: Scalars['Float']['output'];
  stockValueExcludingTax: Scalars['Float']['output'];
  taxValue: Scalars['Float']['output'];
  uomFactor: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AdjustmentResponseDto = {
  data: Array<Adjustment>;
  meta: MetaResponse;
};

export enum AdjustmentStatus {
  Approved = 'APPROVED',
  InReview = 'IN_REVIEW',
  Rejected = 'REJECTED'
}

export enum AdjustmentType {
  Damage = 'DAMAGE',
  ExpiryDate = 'EXPIRY_DATE',
  Inventory = 'INVENTORY',
  Location = 'LOCATION',
  Status = 'STATUS'
}

export type AdminAuditLog = {
  action: Scalars['String']['output'];
  actorEmail: Scalars['String']['output'];
  actorId: Scalars['String']['output'];
  actorRole?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  ipAddress?: Maybe<Scalars['String']['output']>;
  metadataJson?: Maybe<Scalars['String']['output']>;
  targetId?: Maybe<Scalars['String']['output']>;
  targetName?: Maybe<Scalars['String']['output']>;
  targetType?: Maybe<Scalars['String']['output']>;
};

export type AdminAuditLogFilterInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  actorId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  targetType?: InputMaybe<Scalars['String']['input']>;
};

export type AdminAuditLogListResponse = {
  data: Array<AdminAuditLog>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type AdminChangePasswordInput = {
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};

export type AdminCreatePoolInput = {
  cacheHost?: InputMaybe<Scalars['String']['input']>;
  cachePassword?: InputMaybe<Scalars['String']['input']>;
  cachePort?: InputMaybe<Scalars['Float']['input']>;
  databaseHost: Scalars['String']['input'];
  databaseName: Scalars['String']['input'];
  databasePassword: Scalars['String']['input'];
  databasePort?: Scalars['Float']['input'];
  databaseUsername: Scalars['String']['input'];
  maxTenants?: Scalars['Float']['input'];
  name: Scalars['String']['input'];
  readDatabaseHost?: InputMaybe<Scalars['String']['input']>;
  readDatabaseName?: InputMaybe<Scalars['String']['input']>;
  readDatabasePassword?: InputMaybe<Scalars['String']['input']>;
  readDatabasePort?: InputMaybe<Scalars['Float']['input']>;
  readDatabaseUsername?: InputMaybe<Scalars['String']['input']>;
};

export type AdminCreateTenantInput = {
  accountId: Scalars['String']['input'];
  adminEmail: Scalars['String']['input'];
  adminFirstName?: InputMaybe<Scalars['String']['input']>;
  adminLastName?: InputMaybe<Scalars['String']['input']>;
  adminPassword: Scalars['String']['input'];
  cacheHost?: InputMaybe<Scalars['String']['input']>;
  cachePassword?: InputMaybe<Scalars['String']['input']>;
  cachePort?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  databaseHost?: InputMaybe<Scalars['String']['input']>;
  databaseName?: InputMaybe<Scalars['String']['input']>;
  databasePassword?: InputMaybe<Scalars['String']['input']>;
  databasePort?: InputMaybe<Scalars['Float']['input']>;
  databaseUsername?: InputMaybe<Scalars['String']['input']>;
  deploymentType: DeploymentType;
  fusionEnabled?: Scalars['Boolean']['input'];
  logo?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  poolId?: InputMaybe<Scalars['String']['input']>;
  spectrumEnabled?: Scalars['Boolean']['input'];
};

export type AdminCreateUserInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  platformRole?: InputMaybe<PlatformRole>;
};

export type AdminInviteToTenantInput = {
  globalUserId: Scalars['String']['input'];
  roleId?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};

export type AdminLoginInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type AdminLoginResponse = {
  mustChangePassword: Scalars['Boolean']['output'];
  token: Scalars['String']['output'];
  user: GlobalUser;
};

export type AdminMigrateToDedicatedInput = {
  cacheHost?: InputMaybe<Scalars['String']['input']>;
  cachePassword?: InputMaybe<Scalars['String']['input']>;
  cachePort?: InputMaybe<Scalars['Float']['input']>;
  databaseHost: Scalars['String']['input'];
  databaseName: Scalars['String']['input'];
  databasePassword: Scalars['String']['input'];
  databasePort?: Scalars['Float']['input'];
  databaseUsername: Scalars['String']['input'];
  readDatabaseHost?: InputMaybe<Scalars['String']['input']>;
  readDatabaseName?: InputMaybe<Scalars['String']['input']>;
  readDatabasePassword?: InputMaybe<Scalars['String']['input']>;
  readDatabasePort?: InputMaybe<Scalars['Float']['input']>;
  readDatabaseUsername?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};

export type AdminMigrateToSharedInput = {
  poolId?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};

export type AdminMigrationCompleteResponse = {
  durationMs?: Maybe<Scalars['Float']['output']>;
  message: Scalars['String']['output'];
  newDeploymentType: DeploymentType;
  rowsMigrated?: Maybe<Scalars['Float']['output']>;
  success: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
};

export type AdminOrderLine = {
  lineId: Scalars['String']['output'];
  lineStatus: FulfillmentOrderLineStatus;
  locationName?: Maybe<Scalars['String']['output']>;
  pickedQuantity: Scalars['Int']['output'];
  productId: Scalars['String']['output'];
  productName?: Maybe<Scalars['String']['output']>;
  productSku?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
  readyQuantity: Scalars['Int']['output'];
  sentQuantity: Scalars['Int']['output'];
  taskId?: Maybe<Scalars['String']['output']>;
  trackingLevel?: Maybe<TrackingLevel>;
};

export type AdminOrderListItem = {
  consignmentNumber?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customerName?: Maybe<Scalars['String']['output']>;
  fulfillmentId?: Maybe<Scalars['String']['output']>;
  fulfillmentOrderId: Scalars['String']['output'];
  fulfillmentOrderStatus: FulfillmentOrderStatus;
  lines: Array<AdminOrderLine>;
  lotsLockedAt?: Maybe<Scalars['DateTime']['output']>;
  orderChannel?: Maybe<Scalars['String']['output']>;
  orderId: Scalars['String']['output'];
  orderNumber: Scalars['Int']['output'];
  orderSource?: Maybe<Scalars['String']['output']>;
  partnerName?: Maybe<Scalars['String']['output']>;
  registerId?: Maybe<Scalars['String']['output']>;
  shippingProvider?: Maybe<Scalars['String']['output']>;
  totalPicked: Scalars['Int']['output'];
  totalQuantity: Scalars['Int']['output'];
  totalReady: Scalars['Int']['output'];
};

export type AdminOrderListResponseDto = {
  data: Array<AdminOrderListItem>;
  meta: MetaResponse;
};

export type AdminOrderTabCounts = {
  all: Scalars['Int']['output'];
  delivered: Scalars['Int']['output'];
  dispatched: Scalars['Int']['output'];
  picked: Scalars['Int']['output'];
  picking: Scalars['Int']['output'];
  readyForDispatch: Scalars['Int']['output'];
};

export type AdminPoolListResponse = {
  data: Array<TenantPool>;
  totalCount: Scalars['Int']['output'];
};

export type AdminSetMaintenanceInput = {
  enabled: Scalars['Boolean']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  scheduledEndAt?: InputMaybe<Scalars['String']['input']>;
  scheduledStartAt?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type AdminTenantFilterInput = {
  deploymentType?: InputMaybe<DeploymentType>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  poolId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type AdminTenantListResponse = {
  data: Array<Tenant>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type AdminTenantStatsResponse = {
  activeTenants: Scalars['Int']['output'];
  dedicatedTenants: Scalars['Int']['output'];
  inactiveTenants: Scalars['Int']['output'];
  sharedTenants: Scalars['Int']['output'];
  totalPools: Scalars['Int']['output'];
  totalTenants: Scalars['Int']['output'];
  totalUsers: Scalars['Int']['output'];
};

export type AdminUpdatePoolInput = {
  cacheHost?: InputMaybe<Scalars['String']['input']>;
  cachePassword?: InputMaybe<Scalars['String']['input']>;
  cachePort?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['String']['input'];
  maxTenants?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type AdminUpdateTenantInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  dunsNumber?: InputMaybe<Scalars['String']['input']>;
  fusionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  invertedLogo?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ntnNumber?: InputMaybe<Scalars['String']['input']>;
  online_store_url?: InputMaybe<Scalars['String']['input']>;
  parentCompanyLogo?: InputMaybe<Scalars['String']['input']>;
  postingGoLiveDate?: InputMaybe<Scalars['String']['input']>;
  /** Orders created from this date use the new mode */
  revenueRecognitionEffectiveFrom?: InputMaybe<Scalars['String']['input']>;
  /** AT_ORDER or AT_DELIVERY (AT_DISPATCH is reserved) */
  revenueRecognitionMode?: InputMaybe<RevenueRecognitionMode>;
  saleTaxNumber?: InputMaybe<Scalars['String']['input']>;
  spectrumEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  taxNumber?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type AdminUserFilterInput = {
  limit?: InputMaybe<Scalars['Float']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  platformRole?: InputMaybe<PlatformRole>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type AdminUserListResponse = {
  data: Array<GlobalUser>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export enum AllowedOrderType {
  Normal = 'NORMAL',
  Return = 'RETURN'
}

export enum AnalyticsCompareWith {
  None = 'NONE',
  PreviousPeriod = 'PREVIOUS_PERIOD',
  PreviousYear = 'PREVIOUS_YEAR'
}

export enum AnalyticsDatePreset {
  Custom = 'CUSTOM',
  Last_7Days = 'LAST_7_DAYS',
  Last_30Days = 'LAST_30_DAYS',
  LastMonth = 'LAST_MONTH',
  ThisMonth = 'THIS_MONTH',
  ThisQuarter = 'THIS_QUARTER',
  ThisWeek = 'THIS_WEEK',
  ThisYear = 'THIS_YEAR',
  Today = 'TODAY',
  Yesterday = 'YESTERDAY'
}

export type AnalyticsFilterInput = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
  compareWith?: InputMaybe<AnalyticsCompareWith>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  fulfillmentStatus?: InputMaybe<FulfillmentStatus>;
  granularity?: InputMaybe<AnalyticsGranularity>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  locationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderChannel?: InputMaybe<OrderChannel>;
  orderSource?: InputMaybe<OrderSource>;
  partnerId?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<PaymentMethod>;
  paymentStatus?: InputMaybe<PaymentStatus>;
  preset?: InputMaybe<AnalyticsDatePreset>;
  productId?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<OrderStatus>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export enum AnalyticsGranularity {
  Day = 'DAY',
  Hour = 'HOUR',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

export enum ApInvoiceLineType {
  Adjustment = 'ADJUSTMENT',
  Asset = 'ASSET',
  Expense = 'EXPENSE',
  GrnItem = 'GRN_ITEM',
  Return = 'RETURN'
}

export enum ApPaymentStatus {
  Allocated = 'ALLOCATED',
  Cancelled = 'CANCELLED',
  Draft = 'DRAFT',
  PartiallyAllocated = 'PARTIALLY_ALLOCATED',
  Posted = 'POSTED'
}

export enum ApSettlementFromType {
  CreditNote = 'CREDIT_NOTE',
  DebitNote = 'DEBIT_NOTE',
  OffsetAccount = 'OFFSET_ACCOUNT',
  Payment = 'PAYMENT',
  WriteOff = 'WRITE_OFF'
}

export type ApSettlementLine = {
  aging?: Maybe<Scalars['Float']['output']>;
  allocatedAmount: Scalars['Float']['output'];
  allocationDate: Scalars['DateTime']['output'];
  chartOfAccounts?: Maybe<ChartOfAccounts>;
  chartOfAccountsId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['ID']['output'];
  creditMemo?: Maybe<AccountPayableInvoice>;
  creditMemoId?: Maybe<Scalars['ID']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  entityId?: Maybe<Scalars['ID']['output']>;
  fromType: ApSettlementFromType;
  fxAllocatedAmount?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  invoice?: Maybe<AccountPayableInvoice>;
  invoiceDate?: Maybe<Scalars['DateTime']['output']>;
  invoiceId: Scalars['ID']['output'];
  invoiceSecondaryId?: Maybe<Scalars['Int']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  offsetDescription?: Maybe<Scalars['String']['output']>;
  offsetTaxHandling?: Maybe<Scalars['String']['output']>;
  outstandingAmount?: Maybe<Scalars['Float']['output']>;
  payment?: Maybe<AccountPayablePayment>;
  paymentId?: Maybe<Scalars['ID']['output']>;
  postedAt?: Maybe<Scalars['DateTime']['output']>;
  postedBy?: Maybe<Scalars['String']['output']>;
  secondaryId?: Maybe<Scalars['Float']['output']>;
  settlementAllocatedAmount?: Maybe<Scalars['Float']['output']>;
  status: ApPaymentStatus;
  totalAmount?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  writeoff?: Maybe<AccountPayableWriteoff>;
  writeoffId?: Maybe<Scalars['ID']['output']>;
};

export type ApSettlementLineResponseDto = {
  data: Array<ApSettlementLine>;
  meta: MetaResponse;
};

export enum ApWriteoffReasonCode {
  FxDifference = 'FX_DIFFERENCE',
  Other = 'OTHER',
  Overbilling = 'OVERBILLING',
  SmallBalance = 'SMALL_BALANCE',
  VendorDispute = 'VENDOR_DISPUTE'
}

export enum ApWriteoffStatus {
  Cancelled = 'CANCELLED',
  Draft = 'DRAFT',
  Posted = 'POSTED'
}

export enum ApplicableOn {
  ApInvoice = 'AP_INVOICE',
  ArInvoice = 'AR_INVOICE',
  Both = 'BOTH'
}

export type ApplyDiscountDto = {
  cityId?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  items: Array<OrderItemDto>;
  locationId: Scalars['String']['input'];
  orderType?: OrderType;
  registerId?: InputMaybe<Scalars['String']['input']>;
  removedPlatformFeeIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ApproveQcBatchDto = {
  batchResults?: Array<BatchQcResult>;
  id: Scalars['String']['input'];
  qcNotes?: InputMaybe<Scalars['String']['input']>;
};

export type ApproveQcSerialDto = {
  batchResults?: Array<BatchSerialQcResult>;
  id: Scalars['String']['input'];
  qcNotes?: InputMaybe<Scalars['String']['input']>;
};

export enum ArInvoiceLineType {
  Adjustment = 'ADJUSTMENT',
  CreditOrder = 'CREDIT_ORDER',
  DiscountOrder = 'DISCOUNT_ORDER',
  IntegrationCharges = 'INTEGRATION_CHARGES',
  Liability = 'LIABILITY',
  Order = 'ORDER',
  PlatformFee = 'PLATFORM_FEE',
  Revenue = 'REVENUE',
  ShippingFee = 'SHIPPING_FEE'
}

export enum ArReceiptStatus {
  Allocated = 'ALLOCATED',
  Cancelled = 'CANCELLED',
  Draft = 'DRAFT',
  PartiallyAllocated = 'PARTIALLY_ALLOCATED',
  Posted = 'POSTED'
}

export enum ArSettlementFromType {
  CreditMemo = 'CREDIT_MEMO',
  DebitMemo = 'DEBIT_MEMO',
  OffsetAccount = 'OFFSET_ACCOUNT',
  Receipt = 'RECEIPT',
  WriteOff = 'WRITE_OFF'
}

export type ArSettlementLine = {
  aging?: Maybe<Scalars['Float']['output']>;
  allocatedAmount: Scalars['Float']['output'];
  allocationDate: Scalars['DateTime']['output'];
  chartOfAccounts?: Maybe<ChartOfAccounts>;
  chartOfAccountsId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['ID']['output'];
  creditMemo?: Maybe<AccountReceivableInvoice>;
  creditMemoId?: Maybe<Scalars['ID']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  entity?: Maybe<EntityModel>;
  entityId?: Maybe<Scalars['ID']['output']>;
  fromType: ArSettlementFromType;
  fxAllocatedAmount?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  invoice?: Maybe<AccountReceivableInvoice>;
  invoiceId: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  offsetDescription?: Maybe<Scalars['String']['output']>;
  offsetTaxHandling?: Maybe<Scalars['String']['output']>;
  outstandingAmount?: Maybe<Scalars['Float']['output']>;
  postedAt?: Maybe<Scalars['DateTime']['output']>;
  postedBy?: Maybe<Scalars['ID']['output']>;
  receipt?: Maybe<AccountReceivableReceipt>;
  receiptId?: Maybe<Scalars['ID']['output']>;
  secondaryId?: Maybe<Scalars['Float']['output']>;
  settlementAllocatedAmount?: Maybe<Scalars['Float']['output']>;
  status: ArReceiptStatus;
  totalAmount?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  writeoff?: Maybe<AccountReceivableWriteoff>;
  writeoffId?: Maybe<Scalars['ID']['output']>;
};

export type ArSettlementLineResponseDto = {
  data: Array<ArSettlementLine>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export enum ArWriteoffReasonCode {
  BadDebt = 'BAD_DEBT',
  Dispute = 'DISPUTE',
  Other = 'OTHER',
  SmallBalance = 'SMALL_BALANCE'
}

export enum ArWriteoffStatus {
  Cancelled = 'CANCELLED',
  Draft = 'DRAFT',
  Posted = 'POSTED'
}

export type AssignFulfillmentOrderLinesInput = {
  fulfillmentOrderId: Scalars['ID']['input'];
  fulfillmentOrderLineIds: Array<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};

export type Audit = {
  auditProducts?: Maybe<Array<AuditProduct>>;
  closureReason?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['String']['output'];
  locationId: Scalars['String']['output'];
  secondaryId?: Maybe<Scalars['Float']['output']>;
  status: AuditStatus;
  type: AuditSelectionType;
  updatedAt: Scalars['DateTime']['output'];
};

export type AuditListDto = {
  createdAt: Scalars['DateTime']['output'];
  excessLoose: Scalars['Int']['output'];
  excessProducts: Scalars['Int']['output'];
  excessStockValue: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  itemCount: Scalars['Int']['output'];
  lotCount: Scalars['Int']['output'];
  matchedProducts: Scalars['Int']['output'];
  secondaryId: Scalars['String']['output'];
  shortLoose: Scalars['Int']['output'];
  shortProducts: Scalars['Int']['output'];
  shortStockValue: Scalars['Float']['output'];
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AuditLot = {
  actionId?: Maybe<Scalars['String']['output']>;
  actualQuantity?: Maybe<Scalars['Float']['output']>;
  auditProductId: Scalars['String']['output'];
  baseQuantity?: Maybe<Scalars['Float']['output']>;
  countedAt?: Maybe<Scalars['DateTime']['output']>;
  countedBy?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  expectedQuantity?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  lotStatus?: Maybe<AuditLotResultStatus>;
  lotStockValue?: Maybe<Scalars['Float']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  productLotId: Scalars['String']['output'];
  status: AuditLotStatus;
  trackingLevel?: Maybe<TrackingLevel>;
  updatedAt: Scalars['DateTime']['output'];
  variance?: Maybe<Scalars['Float']['output']>;
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
  verifiedBy?: Maybe<Scalars['String']['output']>;
};

export type AuditLotResponseDto = {
  data: Array<AuditLot>;
  meta: MetaResponse;
};

export enum AuditLotResultStatus {
  Excess = 'EXCESS',
  Match = 'MATCH',
  Short = 'SHORT'
}

export enum AuditLotStatus {
  Counted = 'COUNTED',
  Discrepancy = 'DISCREPANCY',
  Excess = 'EXCESS',
  InAudit = 'IN_AUDIT',
  Matched = 'MATCHED',
  Pending = 'PENDING',
  Short = 'SHORT',
  Verified = 'VERIFIED'
}

export type AuditProduct = {
  auditId: Scalars['String']['output'];
  auditLots?: Maybe<Array<AuditLot>>;
  createdAt: Scalars['DateTime']['output'];
  excessLoose: Scalars['Int']['output'];
  excessPacked: Scalars['Int']['output'];
  excessProducts: Scalars['Int']['output'];
  excessStockValue: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  lotCount: Scalars['Int']['output'];
  product: Product;
  productId: Scalars['String']['output'];
  secondaryId?: Maybe<Scalars['Float']['output']>;
  shortLoose: Scalars['Int']['output'];
  shortPacked: Scalars['Int']['output'];
  shortStockValue: Scalars['Float']['output'];
  status: AuditProductStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export enum AuditProductStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

export type AuditResponseDto = {
  data: Array<AuditListDto>;
  meta: MetaResponse;
};

export enum AuditSelectionType {
  All = 'ALL',
  HighSelling = 'HIGH_SELLING',
  LowSelling = 'LOW_SELLING',
  Random = 'RANDOM',
  SpecificProduct = 'SPECIFIC_PRODUCT'
}

export enum AuditStatus {
  Closed = 'CLOSED',
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS'
}

export type AuditSummaryDto = {
  actualQuantity?: Maybe<Scalars['Int']['output']>;
  auditId?: Maybe<Scalars['String']['output']>;
  excessAmount?: Maybe<Scalars['Float']['output']>;
  excessCount?: Maybe<Scalars['Int']['output']>;
  expectedQuantity?: Maybe<Scalars['Int']['output']>;
  lotCount?: Maybe<Scalars['Int']['output']>;
  matchedCount?: Maybe<Scalars['Int']['output']>;
  productCount?: Maybe<Scalars['Int']['output']>;
  productSummaries: Array<AuditSummaryProductsDto>;
  shortAmount?: Maybe<Scalars['Float']['output']>;
  shortCount?: Maybe<Scalars['Int']['output']>;
  totalStockValue?: Maybe<Scalars['Float']['output']>;
};

export type AuditSummaryProductsDto = {
  actualQuantity?: Maybe<Scalars['Int']['output']>;
  excessAmount?: Maybe<Scalars['Float']['output']>;
  excessCount?: Maybe<Scalars['Int']['output']>;
  expectedQuantity?: Maybe<Scalars['Int']['output']>;
  isComplete?: Maybe<Scalars['Boolean']['output']>;
  lotCount?: Maybe<Scalars['Int']['output']>;
  matchedCount?: Maybe<Scalars['Int']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  shortAmount?: Maybe<Scalars['Float']['output']>;
  shortCount?: Maybe<Scalars['Int']['output']>;
  stockValue?: Maybe<Scalars['Float']['output']>;
};

export type AuthResponseDto = {
  allowedLocations: Array<LocationDtoResponse>;
  permissions: Array<PermissionDto>;
  tenant: TenantDto;
  token: Scalars['String']['output'];
  user: LoggedInUserDto;
};

export type AutomationFlow = {
  armed: Scalars['Boolean']['output'];
  consecutiveFailures: Scalars['Int']['output'];
  cooldownMinutes: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  createdByName?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  graph: Scalars['JSON']['output'];
  id: Scalars['String']['output'];
  intervalSeconds: Scalars['Int']['output'];
  lastError?: Maybe<Scalars['String']['output']>;
  lastEvalAt?: Maybe<Scalars['DateTime']['output']>;
  lastTriggeredAt?: Maybe<Scalars['DateTime']['output']>;
  lastValue?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  reportId: Scalars['String']['output'];
  reportName?: Maybe<Scalars['String']['output']>;
  trigger: Scalars['JSON']['output'];
  updatedAt: Scalars['DateTime']['output'];
  webhookSecret?: Maybe<Scalars['String']['output']>;
};

export type AutomationFlowPage = {
  data: Array<AutomationFlow>;
  total: Scalars['Int']['output'];
};

export type BalanceSheetReportResponse = {
  asOfDate: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  isBalanced: Scalars['Boolean']['output'];
  netIncome: Scalars['String']['output'];
  rows: Array<FinanceReportRow>;
  totalAssets: Scalars['String']['output'];
  totalEquity: Scalars['String']['output'];
  totalLiabilities: Scalars['String']['output'];
};

export enum BalanceType {
  Credit = 'CREDIT',
  Debit = 'DEBIT'
}

export type BankAccount = {
  accountNumber: Scalars['String']['output'];
  accountTitle: Scalars['String']['output'];
  coaAccount?: Maybe<ChartOfAccounts>;
  coaAccountId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['ID']['output'];
  createdByName?: Maybe<Scalars['String']['output']>;
  currency: CurrencyTypeEnum;
  entity?: Maybe<EntityModel>;
  entityId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  locations?: Maybe<Array<BankAccountLocation>>;
  name: Scalars['String']['output'];
  openingBalance?: Maybe<Scalars['Float']['output']>;
  openingBalanceDate?: Maybe<Scalars['DateTime']['output']>;
  secondaryId?: Maybe<Scalars['Float']['output']>;
  status: BankAccountStatus;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['ID']['output']>;
  updatedByName?: Maybe<Scalars['String']['output']>;
};

export type BankAccountLocation = {
  bankAccount?: Maybe<BankAccount>;
  bankAccountId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  locationId: Scalars['ID']['output'];
  locationName?: Maybe<Scalars['String']['output']>;
};

export enum BankAccountStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type BankAccountsResponseDto = {
  data: Array<BankAccount>;
  meta: MetaResponse;
};

export enum BaseDateType {
  Custom = 'CUSTOM',
  InvoiceDate = 'INVOICE_DATE',
  MonthEnd = 'MONTH_END',
  PostingDate = 'POSTING_DATE'
}

export type BaseQuantityByLocationDto = {
  locationId: Scalars['String']['output'];
  locationName: Scalars['String']['output'];
  totalBaseQuantity: Scalars['Float']['output'];
  totalSellableQuantity: Scalars['Float']['output'];
  uomFactor?: Maybe<Scalars['Float']['output']>;
};

export type BatchQcResult = {
  batchId: Scalars['String']['input'];
  qcNotes?: InputMaybe<Scalars['String']['input']>;
  rejectedQty?: Scalars['Float']['input'];
};

export enum BatchQcStatus {
  Pending = 'PENDING',
  QcApproved = 'QC_APPROVED',
  QcRejected = 'QC_REJECTED',
  QcSubmitted = 'QC_SUBMITTED'
}

export type BatchSerialQcResult = {
  batchId: Scalars['String']['input'];
  qcNotes?: InputMaybe<Scalars['String']['input']>;
  rejectedCount?: Scalars['Int']['input'];
};

export type Bom = {
  bomCode: Scalars['String']['output'];
  bomName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  outputProduct?: Maybe<Product>;
  outputProductId: Scalars['String']['output'];
  productionProcessType: ProductionProcessType;
  secondaryId?: Maybe<Scalars['Int']['output']>;
  status: BomStatus;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
  versions?: Maybe<Array<BomVersion>>;
};

export enum BomApprovalStatus {
  Approved = 'APPROVED',
  Draft = 'DRAFT',
  PendingApproval = 'PENDING_APPROVAL',
  Rejected = 'REJECTED',
  Retired = 'RETIRED'
}

export enum BomLifecycleStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Inactive = 'INACTIVE',
  Superseded = 'SUPERSEDED'
}

export type BomResponseDto = {
  data: Array<Bom>;
  meta: MetaResponse;
};

export enum BomStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Inactive = 'INACTIVE'
}

export type BomVersion = {
  activatedAt?: Maybe<Scalars['DateTime']['output']>;
  activatedBy?: Maybe<Scalars['String']['output']>;
  activatedByUser?: Maybe<User>;
  approvalStatus: BomApprovalStatus;
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  approvedBy?: Maybe<Scalars['String']['output']>;
  approvedByUser?: Maybe<User>;
  batchQuantity: Scalars['Int']['output'];
  bom?: Maybe<Bom>;
  bomId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  effectiveFrom?: Maybe<Scalars['Date']['output']>;
  effectiveTo?: Maybe<Scalars['Date']['output']>;
  id: Scalars['String']['output'];
  lifecycleStatus: BomLifecycleStatus;
  lineItems?: Maybe<Array<BomVersionLineItem>>;
  location?: Maybe<Location>;
  locationId?: Maybe<Scalars['String']['output']>;
  referenceVersion?: Maybe<BomVersion>;
  referenceVersionId?: Maybe<Scalars['String']['output']>;
  rejectedAt?: Maybe<Scalars['DateTime']['output']>;
  rejectedBy?: Maybe<Scalars['String']['output']>;
  rejectedByUser?: Maybe<User>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  secondaryId?: Maybe<Scalars['Int']['output']>;
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  submittedBy?: Maybe<Scalars['String']['output']>;
  submittedByUser?: Maybe<User>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
  versionLabel?: Maybe<Scalars['String']['output']>;
  versionNo: Scalars['Int']['output'];
};

export type BomVersionLineItem = {
  bomVersion?: Maybe<BomVersion>;
  bomVersionId: Scalars['String']['output'];
  componentProduct?: Maybe<Product>;
  componentProductId: Scalars['String']['output'];
  consumableQuantity: Scalars['Float']['output'];
  consumableQuantityPerUnit?: Maybe<Scalars['Float']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  costPerUnit?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  isMandatory: Scalars['Boolean']['output'];
  lineNo?: Maybe<Scalars['Int']['output']>;
  secondaryId?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  wastagePercentage: Scalars['Float']['output'];
  wastageQuantity?: Maybe<Scalars['Float']['output']>;
};

export type BomVersionResponseDto = {
  data: Array<BomVersion>;
  meta: MetaResponse;
};

export type BookFusionShipmentInput = {
  connectorCode: Scalars['String']['input'];
  fragile?: InputMaybe<Scalars['Boolean']['input']>;
  fulfillmentOrderId: Scalars['ID']['input'];
  pieces: Scalars['Float']['input'];
  referenceNo?: InputMaybe<Scalars['String']['input']>;
  riderId?: InputMaybe<Scalars['ID']['input']>;
  serviceCode?: InputMaybe<Scalars['String']['input']>;
  weightKg?: InputMaybe<Scalars['Float']['input']>;
};

export type BulkProductLotError = {
  actionId: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type BulkProductLotResponse = {
  errors: Array<BulkProductLotError>;
  results: Array<ProductLot>;
};

export enum BulkUploadFileType {
  Csv = 'CSV'
}

export type BulkUploadProductDto = {
  fileBase64: Scalars['String']['input'];
  fileType: BulkUploadFileType;
  /** Client-generated UUID for idempotency */
  requestId: Scalars['String']['input'];
};

export type BulkUploadProductResponse = {
  createdProductIds: Array<Scalars['String']['output']>;
  errors?: Maybe<Array<BulkUploadRowError>>;
  successCount: Scalars['Int']['output'];
};

export type BulkUploadRowError = {
  message: Scalars['String']['output'];
  row: Scalars['Int']['output'];
};

export type CalculatedColumn = {
  createdAt: Scalars['DateTime']['output'];
  createdByName?: Maybe<Scalars['String']['output']>;
  datasetKey: Scalars['String']['output'];
  expression: Scalars['String']['output'];
  format?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  resultType: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CalculatedColumnCheck = {
  error?: Maybe<Scalars['String']['output']>;
  resultType?: Maybe<Scalars['String']['output']>;
  valid: Scalars['Boolean']['output'];
  volatile: Scalars['Boolean']['output'];
};

export type CalculatedColumnInfo = {
  expression: Scalars['String']['output'];
  libraryId?: Maybe<Scalars['String']['output']>;
};

export type CalculatedColumnInput = {
  expression: Scalars['String']['input'];
  format?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
};

export type CalculatedColumnUsage = {
  columns: Array<CalculatedColumnUser>;
  reports: Array<CalculatedColumnUser>;
};

export type CalculatedColumnUser = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum CalculationBasis {
  Fixed = 'FIXED',
  Percent = 'PERCENT',
  Remainder = 'REMAINDER'
}

export type CancelOrderInput = {
  /** Lines whose units go to quarantine instead of back on sale. */
  damagedLineItemIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  idempotencyKey: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['ID']['input'];
  /** Lines to cancel. Omit to cancel every open line. */
  orderLineItemIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  reason: CancellationReason;
  /** An open session at the order's location: required for a cash refund, and for orders reported to FBR. */
  registerSessionId?: InputMaybe<Scalars['ID']['input']>;
};

export type CancelOrderResult = {
  cancellation: OrderCancellation;
  /** True when the order was reported to FBR, so the till must report a credit note. */
  fbrCreditNoteRequired: Scalars['Boolean']['output'];
  /** True when the whole order is now cancelled. */
  orderCancelled: Scalars['Boolean']['output'];
};

export enum CancellationLotSource {
  Picked = 'PICKED',
  Reserved = 'RESERVED',
  Scanned = 'SCANNED'
}

export enum CancellationReason {
  AddressIssue = 'ADDRESS_ISSUE',
  CustomerRequest = 'CUSTOMER_REQUEST',
  DeliveryFailed = 'DELIVERY_FAILED',
  DuplicateOrder = 'DUPLICATE_ORDER',
  FraudRisk = 'FRAUD_RISK',
  LostInTransit = 'LOST_IN_TRANSIT',
  Other = 'OTHER',
  PaymentIssue = 'PAYMENT_ISSUE',
  StockIssue = 'STOCK_ISSUE'
}

export type CartSummaryDto = {
  deliveryCharges: Scalars['Float']['output'];
  discounts?: Maybe<Array<DiscountSummaryDto>>;
  integrationCharges: Scalars['Float']['output'];
  integrations?: Maybe<Array<IntegrationConfig>>;
  platformFee: Scalars['Float']['output'];
  platformFees?: Maybe<Array<PlatformFeeSummaryDto>>;
  posFees: Scalars['Float']['output'];
  products?: Maybe<Array<ProductSummaryDto>>;
  subtotal: Scalars['Float']['output'];
  tax: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  totalDiscount: Scalars['Float']['output'];
};

export type CashAccount = {
  cashRegister?: Maybe<Scalars['String']['output']>;
  coaAccount?: Maybe<ChartOfAccounts>;
  coaAccountId: Scalars['ID']['output'];
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['ID']['output'];
  createdByName?: Maybe<Scalars['String']['output']>;
  currency: CurrencyTypeEnum;
  entity?: Maybe<EntityModel>;
  entityId: Scalars['ID']['output'];
  financeDrawerId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  locations?: Maybe<Array<CashAccountLocation>>;
  name: Scalars['String']['output'];
  posRegisterMaps?: Maybe<Array<PosRegisterCashMap>>;
  secondaryId?: Maybe<Scalars['Float']['output']>;
  status: CashAccountStatus;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['ID']['output']>;
  updatedByName?: Maybe<Scalars['String']['output']>;
};

export type CashAccountLocation = {
  cashAccount?: Maybe<CashAccount>;
  cashAccountId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  locationId: Scalars['ID']['output'];
  locationName?: Maybe<Scalars['String']['output']>;
};

export enum CashAccountStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type CashAccountsResponseDto = {
  data: Array<CashAccount>;
  meta: MetaResponse;
};

export type CashDeposit = {
  attachmentId?: Maybe<Scalars['ID']['output']>;
  bankAccountId: Scalars['ID']['output'];
  bankTransactionId?: Maybe<Scalars['ID']['output']>;
  businessDate: Scalars['DateTime']['output'];
  cashDepositControlId: Scalars['ID']['output'];
  comments?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  depositAmount: Scalars['Float']['output'];
  depositDate: Scalars['DateTime']['output'];
  depositNo?: Maybe<Scalars['String']['output']>;
  depositSlipNo?: Maybe<Scalars['String']['output']>;
  entityId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  journalEntryId?: Maybe<Scalars['ID']['output']>;
  locationId: Scalars['ID']['output'];
  netDepositableCashAmount?: Maybe<Scalars['Float']['output']>;
  postedAt?: Maybe<Scalars['DateTime']['output']>;
  postedBy?: Maybe<Scalars['String']['output']>;
  postedByName?: Maybe<Scalars['String']['output']>;
  remainingAfterDepositAmount?: Maybe<Scalars['Float']['output']>;
  remainingBeforeDepositAmount?: Maybe<Scalars['Float']['output']>;
  status: CashDepositStatus;
  toBankCoaAccountId: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CashDepositConfig = {
  allowOverDeposit: Scalars['Boolean']['output'];
  allowRegisterLines: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByName?: Maybe<Scalars['String']['output']>;
  entityId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  status: Status;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedByName?: Maybe<Scalars['String']['output']>;
};

export type CashDepositControl = {
  alreadyDepositedAmount: Scalars['Float']['output'];
  businessDate: Scalars['DateTime']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dayEndSummaryId?: Maybe<Scalars['ID']['output']>;
  entityId: Scalars['ID']['output'];
  expectedCashAmount: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  locationId: Scalars['ID']['output'];
  netDepositableCashAmount: Scalars['Float']['output'];
  remainingDepositAmount: Scalars['Float']['output'];
  status: CashDepositControlStatus;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CashDepositControlFilter = {
  businessDateFrom?: InputMaybe<Scalars['String']['input']>;
  businessDateTo?: InputMaybe<Scalars['String']['input']>;
  entityId: Scalars['ID']['input'];
  locationId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<CashDepositControlStatus>;
};

export enum CashDepositControlStatus {
  Deposited = 'DEPOSITED',
  Draft = 'DRAFT',
  PartiallyDeposited = 'PARTIALLY_DEPOSITED'
}

export type CashDepositLineInput = {
  amount: Scalars['Float']['input'];
  registerId?: InputMaybe<Scalars['ID']['input']>;
};

export enum CashDepositStatus {
  Cancelled = 'CANCELLED',
  Draft = 'DRAFT',
  Posted = 'POSTED'
}

export type CashVarianceDto = {
  cashSales: Scalars['Float']['output'];
  cashierName?: Maybe<Scalars['String']['output']>;
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  closingAmount: Scalars['Float']['output'];
  expectedCash: Scalars['Float']['output'];
  locationId: Scalars['String']['output'];
  openedAt: Scalars['DateTime']['output'];
  openingAmount: Scalars['Float']['output'];
  registerId?: Maybe<Scalars['String']['output']>;
  sessionId: Scalars['String']['output'];
  status: Scalars['String']['output'];
  variance: Scalars['Float']['output'];
};

export type CashierSalesDto = {
  avgOrderValue: Scalars['Float']['output'];
  lastSessionDate?: Maybe<Scalars['DateTime']['output']>;
  orderCount: Scalars['Float']['output'];
  sessionId?: Maybe<Scalars['String']['output']>;
  totalDiscount: Scalars['Float']['output'];
  totalReturns: Scalars['Float']['output'];
  totalSales: Scalars['Float']['output'];
  userId: Scalars['String']['output'];
  userName: Scalars['String']['output'];
};

export type Category = {
  banner_image?: Maybe<Scalars['String']['output']>;
  categoryIcon?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  level?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  parentCategory?: Maybe<Category>;
  parentId?: Maybe<Scalars['String']['output']>;
  secondaryId?: Maybe<Scalars['Float']['output']>;
  status: Scalars['String']['output'];
};

export type CategoryMaxLevelDto = {
  current: Scalars['Int']['output'];
  max: Scalars['Int']['output'];
};

export type CategoryResponseDto = {
  data: Array<Category>;
  meta: MetaResponse;
};

export enum CenterSource {
  Category = 'CATEGORY',
  Location = 'LOCATION',
  Manual = 'MANUAL',
  Product = 'PRODUCT'
}

export type ChannelSalesDto = {
  avgOrderValue: Scalars['Float']['output'];
  channel: Scalars['String']['output'];
  orderCount: Scalars['Float']['output'];
  totalSales: Scalars['Float']['output'];
};

export enum ChartAccountType {
  Asset = 'ASSET',
  Equity = 'EQUITY',
  Expense = 'EXPENSE',
  Liability = 'LIABILITY',
  Memo = 'MEMO',
  Revenue = 'REVENUE',
  Statistical = 'STATISTICAL'
}

export type ChartOfAccounts = {
  accountId: Scalars['String']['output'];
  accountSubtypeId?: Maybe<Scalars['ID']['output']>;
  balanceType: BalanceType;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['ID']['output']>;
  createdByName?: Maybe<Scalars['String']['output']>;
  dimension: AccountDimension;
  entity?: Maybe<EntityModel>;
  entityId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  isControl: Scalars['Boolean']['output'];
  isReconciliation: Scalars['Boolean']['output'];
  isSystem: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  openingBalance?: Maybe<Scalars['Float']['output']>;
  parentAccount?: Maybe<ChartOfAccounts>;
  parentAccountId?: Maybe<Scalars['ID']['output']>;
  reportingGroup: ReportingGroup;
  secondaryId?: Maybe<Scalars['Float']['output']>;
  status: AccountStatus;
  subtype?: Maybe<AccountSubtype>;
  type: ChartAccountType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['ID']['output']>;
  updatedByName?: Maybe<Scalars['String']['output']>;
};

export type ChartOfAccountsResponse = {
  data: Array<ChartOfAccounts>;
  meta: MetaResponse;
};

export type CheckCalculatedColumnInput = {
  calculatedColumns?: InputMaybe<Array<CalculatedColumnInput>>;
  datasetKey: Scalars['String']['input'];
  expression: Scalars['String']['input'];
  joins?: InputMaybe<Array<ReportJoinInput>>;
  libraryId?: InputMaybe<Scalars['String']['input']>;
};

export type City = {
  country?: Maybe<Country>;
  countryId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CityResponseDto = {
  data: Array<City>;
  meta: MetaResponse;
};

export type CloseLocationRegisterSessionDto = {
  closingAmount: Scalars['Float']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};

export type CompleteRegisterFulfillmentInput = {
  fulfillmentOrderId: Scalars['ID']['input'];
  idempotencyKey: Scalars['String']['input'];
  lots: Array<RegisterFulfillmentLotInput>;
};

export type ComputedMeasureInput = {
  expression: Scalars['String']['input'];
  key: Scalars['String']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
};

export type ConfirmOnlineOrderDto = {
  orderId: Scalars['String']['input'];
  overrideLocationId?: InputMaybe<Scalars['String']['input']>;
  shippingProvider?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectFusionIntegrationInput = {
  connectorCode: Scalars['String']['input'];
  credentials?: Array<FusionIntegrationSettingInput>;
  displayName: Scalars['String']['input'];
  environment?: Scalars['String']['input'];
  settings?: Array<FusionIntegrationSettingInput>;
};

export type ConnectionSetting = {
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ConnectionSettingInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type ConnectorEntitlement = {
  accountId?: Maybe<Scalars['String']['output']>;
  connectorCode: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export enum CostBehavior {
  Fixed = 'FIXED',
  Mixed = 'MIXED',
  Variable = 'VARIABLE'
}

export type CostCenter = {
  coaAccounts?: Maybe<Array<CostCenterCoa>>;
  code: Scalars['String']['output'];
  costBehavior?: Maybe<CostBehavior>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['ID']['output'];
  createdByName?: Maybe<Scalars['String']['output']>;
  effectiveFrom?: Maybe<Scalars['DateTime']['output']>;
  effectiveTo?: Maybe<Scalars['DateTime']['output']>;
  entity?: Maybe<EntityModel>;
  entityId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  locations?: Maybe<Array<CostCenterLocation>>;
  managerId?: Maybe<Scalars['ID']['output']>;
  managerName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  parentCc?: Maybe<CostCenter>;
  parentCcId?: Maybe<Scalars['ID']['output']>;
  secondaryId: Scalars['Int']['output'];
  status: Status;
  type: CostCenterType;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['ID']['output']>;
  updatedByName?: Maybe<Scalars['String']['output']>;
};

export type CostCenterCoa = {
  coaAccount?: Maybe<ChartOfAccounts>;
  coaAccountId: Scalars['ID']['output'];
  costCenterId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
};

export type CostCenterLocation = {
  costCenterId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  locationId: Scalars['ID']['output'];
  locationName?: Maybe<Scalars['String']['output']>;
};

export enum CostCenterType {
  Branch = 'BRANCH',
  Department = 'DEPARTMENT',
  HeadOffice = 'HEAD_OFFICE',
  Service = 'SERVICE',
  Warehouse = 'WAREHOUSE'
}

export type CostCentersResponseDto = {
  data: Array<CostCenter>;
  meta: MetaResponse;
};

export type Country = {
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export enum CoverageModeCode {
  DiscountOnly = 'DISCOUNT_ONLY',
  Fixed = 'FIXED',
  PercentOfOrder = 'PERCENT_OF_ORDER'
}

export type CreateAccountBankTransactionInput = {
  amount: Scalars['String']['input'];
  bankId: Scalars['String']['input'];
  challanId?: InputMaybe<Scalars['String']['input']>;
  journalId: Scalars['String']['input'];
  refId?: InputMaybe<Scalars['String']['input']>;
  transactionDate: Scalars['DateTime']['input'];
  type: Scalars['String']['input'];
};

export type CreateAccountPayableInvoiceInput = {
  currency?: InputMaybe<CurrencyTypeEnum>;
  discountAmount?: InputMaybe<Scalars['Float']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  entityId: Scalars['ID']['input'];
  grnId?: InputMaybe<Scalars['ID']['input']>;
  invoiceDate: Scalars['DateTime']['input'];
  invoiceNo?: InputMaybe<Scalars['String']['input']>;
  invoiceType: AccountPayableInvoiceType;
  lines?: InputMaybe<Array<CreateAccountPayableInvoiceLineInput>>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['ID']['input']>;
  paymentTermsId?: InputMaybe<Scalars['ID']['input']>;
  poId?: InputMaybe<Scalars['ID']['input']>;
  relatedInvoiceId?: InputMaybe<Scalars['ID']['input']>;
  relationType?: InputMaybe<AccountPayableInvoiceRelationType>;
  roundingAdjustment?: InputMaybe<Scalars['Float']['input']>;
  status: AccountPayableInvoiceStatus;
  subtotal: Scalars['Float']['input'];
  taxAmount: Scalars['Float']['input'];
  threeWayMatch: Scalars['Boolean']['input'];
  totalAmount: Scalars['Float']['input'];
  vendorId?: InputMaybe<Scalars['ID']['input']>;
  whtAmount: Scalars['Float']['input'];
};

export type CreateAccountPayableInvoiceLineInput = {
  chartOfAccountsId?: InputMaybe<Scalars['ID']['input']>;
  costCenterId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discountAmount: Scalars['Float']['input'];
  grnId?: InputMaybe<Scalars['ID']['input']>;
  grnLineId?: InputMaybe<Scalars['ID']['input']>;
  lineTotal: Scalars['Float']['input'];
  locationId?: InputMaybe<Scalars['ID']['input']>;
  poId?: InputMaybe<Scalars['ID']['input']>;
  poLineId?: InputMaybe<Scalars['ID']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  profitCenterId?: InputMaybe<Scalars['ID']['input']>;
  qty: Scalars['Float']['input'];
  taxAmount: Scalars['Float']['input'];
  taxType: Tax_Type;
  type: ApInvoiceLineType;
  unitPrice: Scalars['Float']['input'];
};

export type CreateAccountPayablePaymentInput = {
  advanceDate?: InputMaybe<Scalars['DateTime']['input']>;
  advancePayment?: InputMaybe<Scalars['Float']['input']>;
  advanceRemarks?: InputMaybe<Scalars['String']['input']>;
  apSettlementLines?: InputMaybe<Array<CreateApSettlementLineInput>>;
  bankId?: InputMaybe<Scalars['ID']['input']>;
  cashId?: InputMaybe<Scalars['ID']['input']>;
  challanId?: InputMaybe<Scalars['String']['input']>;
  chartOfAccountsId?: InputMaybe<Scalars['ID']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  method: AccountPayablePaymentMethod;
  offsetDescription?: InputMaybe<Scalars['String']['input']>;
  offsetTaxHandling?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['ID']['input']>;
  paymentDate: Scalars['DateTime']['input'];
  refId?: InputMaybe<Scalars['String']['input']>;
  status: ApPaymentStatus;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateAccountPayableWriteoffInput = {
  amount: Scalars['Float']['input'];
  apSettlementLines?: InputMaybe<Array<CreateApSettlementLineInput>>;
  entityId: Scalars['ID']['input'];
  invoiceId: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  reasonCode: ApWriteoffReasonCode;
  status?: InputMaybe<ApWriteoffStatus>;
  writeoffDate: Scalars['DateTime']['input'];
};

export type CreateAccountReceivableInvoiceInput = {
  arInvoiceId?: InputMaybe<Scalars['String']['input']>;
  contactOn?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<CurrencyTypeEnum>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  discountTotal?: InputMaybe<Scalars['Float']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  entityId: Scalars['ID']['input'];
  fxRate?: InputMaybe<Scalars['Float']['input']>;
  invoiceDate: Scalars['DateTime']['input'];
  invoiceType: AccountReceivableInvoiceType;
  lines?: InputMaybe<Array<CreateAccountReceivableInvoiceLineInput>>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['String']['input']>;
  paymentTermsId?: InputMaybe<Scalars['String']['input']>;
  relatedInvoiceId?: InputMaybe<Scalars['ID']['input']>;
  relationType?: InputMaybe<AccountReceivableInvoiceRelationType>;
  roundingAdjustment?: InputMaybe<Scalars['Float']['input']>;
  status?: AccountReceivableInvoiceStatus;
  subtotalAmount?: InputMaybe<Scalars['Float']['input']>;
  taxAmount?: InputMaybe<Scalars['Float']['input']>;
  totalAmount?: InputMaybe<Scalars['Float']['input']>;
  whtAmount?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateAccountReceivableInvoiceLineInput = {
  chartOfAccountsId?: InputMaybe<Scalars['ID']['input']>;
  costCenterId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discountAmount: Scalars['Float']['input'];
  lineTotal: Scalars['Float']['input'];
  locationId?: InputMaybe<Scalars['ID']['input']>;
  orderId?: InputMaybe<Scalars['ID']['input']>;
  orderLineId?: InputMaybe<Scalars['ID']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  profitCenterId?: InputMaybe<Scalars['ID']['input']>;
  qty: Scalars['Float']['input'];
  taxAmount: Scalars['Float']['input'];
  type: ArInvoiceLineType;
  unitPrice: Scalars['Float']['input'];
};

export type CreateAccountReceivableReceiptInput = {
  advanceDate?: InputMaybe<Scalars['DateTime']['input']>;
  advancePayment?: InputMaybe<Scalars['Float']['input']>;
  advanceRemarks?: InputMaybe<Scalars['String']['input']>;
  arSettlementLines?: InputMaybe<Array<CreateArSettlementLineInput>>;
  bankAccountId?: InputMaybe<Scalars['String']['input']>;
  bankId?: InputMaybe<Scalars['ID']['input']>;
  cashAccountId?: InputMaybe<Scalars['String']['input']>;
  cashId?: InputMaybe<Scalars['ID']['input']>;
  challanId?: InputMaybe<Scalars['String']['input']>;
  chartOfAccountsId?: InputMaybe<Scalars['ID']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  dateReceived: Scalars['DateTime']['input'];
  mode: AccountReceivableReceiptMode;
  partnerId?: InputMaybe<Scalars['ID']['input']>;
  receivableAccountId?: InputMaybe<Scalars['String']['input']>;
  refId?: InputMaybe<Scalars['String']['input']>;
  status: ArReceiptStatus;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateAccountReceivableWriteoffInput = {
  amount: Scalars['Float']['input'];
  fxAllocatedAmount?: InputMaybe<Scalars['Float']['input']>;
  invoiceId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
  reasonCode: ArWriteoffReasonCode;
  status: ArWriteoffStatus;
};

export type CreateAccountSubtypeInput = {
  isCashLike?: Scalars['Boolean']['input'];
  isControlSubtype?: Scalars['Boolean']['input'];
  isReconcilable?: Scalars['Boolean']['input'];
  isSystemManaged?: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  status?: AccountStatus;
  subledgerType?: SubledgerType;
  type: AccountType;
};

export type CreateAddressDto = {
  additionalNumber?: InputMaybe<Scalars['String']['input']>;
  buildingNo?: InputMaybe<Scalars['String']['input']>;
  cityId: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  districtName?: InputMaybe<Scalars['String']['input']>;
  landmark?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  streetAddress1?: InputMaybe<Scalars['String']['input']>;
  streetAddress2?: InputMaybe<Scalars['String']['input']>;
  streetName?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAdjustmentDto = {
  adjustmentType: AdjustmentType;
  auditId?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['String']['input'];
  lots: Array<CreateAdjustmentLotDto>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type CreateAdjustmentLotDto = {
  actionId: Scalars['String']['input'];
  adjustedExpiryDate?: InputMaybe<Scalars['String']['input']>;
  adjustedLocationId?: InputMaybe<Scalars['String']['input']>;
  adjustedQuantity?: InputMaybe<Scalars['Int']['input']>;
  adjustedStatus?: InputMaybe<ProductLotStatus>;
  damageQuantity?: InputMaybe<Scalars['Int']['input']>;
  damageQuantityUnit?: InputMaybe<DamageQuantityUnit>;
  locationId: Scalars['String']['input'];
  productSecondaryId: Scalars['String']['input'];
};

export type CreateApSettlementLineInput = {
  allocatedAmount: Scalars['Float']['input'];
  allocationDate: Scalars['DateTime']['input'];
  chartOfAccountsId?: InputMaybe<Scalars['ID']['input']>;
  fromType: ApSettlementFromType;
  fxAllocatedAmount?: InputMaybe<Scalars['Float']['input']>;
  invoiceId: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  offsetDescription?: InputMaybe<Scalars['String']['input']>;
  offsetTaxHandling?: InputMaybe<Scalars['String']['input']>;
};

export type CreateArSettlementLineInput = {
  allocatedAmount: Scalars['Float']['input'];
  allocationDate: Scalars['DateTime']['input'];
  chartOfAccountsId?: InputMaybe<Scalars['ID']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  fromType: ArSettlementFromType;
  fxAllocatedAmount?: InputMaybe<Scalars['Float']['input']>;
  invoiceId: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  offsetDescription?: InputMaybe<Scalars['String']['input']>;
  offsetTaxHandling?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAuditDto = {
  locationId: Scalars['String']['input'];
  percentage?: InputMaybe<Scalars['Float']['input']>;
  productIds?: InputMaybe<Array<Scalars['String']['input']>>;
  selectionType: AuditSelectionType;
};

export type CreateAutomationFlowInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  graph: Scalars['JSON']['input'];
  name: Scalars['String']['input'];
  reportId: Scalars['String']['input'];
};

export type CreateBankAccountInput = {
  accountNumber: Scalars['String']['input'];
  accountTitle: Scalars['String']['input'];
  coaAccountId: Scalars['ID']['input'];
  currency: CurrencyTypeEnum;
  entityId: Scalars['ID']['input'];
  locationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  name: Scalars['String']['input'];
  openingBalance?: InputMaybe<Scalars['Float']['input']>;
  openingBalanceDate?: InputMaybe<Scalars['DateTime']['input']>;
  status: BankAccountStatus;
};

export type CreateBomDto = {
  bomCode: Scalars['String']['input'];
  bomName: Scalars['String']['input'];
  outputProductId: Scalars['String']['input'];
  productionProcessType?: ProductionProcessType;
  status?: InputMaybe<BomStatus>;
};

export type CreateBomVersionDto = {
  batchQuantity?: Scalars['Int']['input'];
  bomId: Scalars['String']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  referenceVersionId?: InputMaybe<Scalars['String']['input']>;
  versionLabel?: InputMaybe<Scalars['String']['input']>;
};

export type CreateBomVersionLineItemDto = {
  bomVersionId: Scalars['String']['input'];
  componentProductId: Scalars['String']['input'];
  consumableQuantity: Scalars['Float']['input'];
  isMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  lineNo?: InputMaybe<Scalars['Int']['input']>;
  wastagePercentage?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateCalculatedColumnInput = {
  datasetKey: Scalars['String']['input'];
  expression: Scalars['String']['input'];
  format?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
};

export type CreateCashAccountInput = {
  cashRegister?: InputMaybe<Scalars['String']['input']>;
  coaAccountId: Scalars['ID']['input'];
  code: Scalars['String']['input'];
  currency: CurrencyTypeEnum;
  entityId: Scalars['ID']['input'];
  financeDrawerId?: InputMaybe<Scalars['ID']['input']>;
  locationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  name: Scalars['String']['input'];
  posRegisterIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  status: CashAccountStatus;
};

export type CreateCashDepositInput = {
  attachmentId?: InputMaybe<Scalars['ID']['input']>;
  bankAccountId: Scalars['ID']['input'];
  cashDepositControlId: Scalars['ID']['input'];
  comments?: InputMaybe<Scalars['String']['input']>;
  depositDate: Scalars['String']['input'];
  depositSlipNo?: InputMaybe<Scalars['String']['input']>;
  lines: Array<CashDepositLineInput>;
};

export type CreateCategoryDto = {
  bannerImage?: InputMaybe<Scalars['String']['input']>;
  categoryIcon?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['String']['input']>;
  status: Status;
};

export type CreateChartOfAccountsInput = {
  balanceType: BalanceType;
  dimension?: AccountDimension;
  entityId: Scalars['String']['input'];
  isControl?: Scalars['Boolean']['input'];
  isReconciliation?: Scalars['Boolean']['input'];
  isSystem?: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  openingBalance?: InputMaybe<Scalars['Float']['input']>;
  parentAccountId?: InputMaybe<Scalars['String']['input']>;
  reportingGroup: ReportingGroup;
  subtypeId?: InputMaybe<Scalars['String']['input']>;
  type: ChartAccountType;
};

export type CreateCostCenterInput = {
  coaAccountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  code: Scalars['String']['input'];
  costBehavior?: InputMaybe<CostBehavior>;
  effectiveFrom?: InputMaybe<Scalars['DateTime']['input']>;
  effectiveTo?: InputMaybe<Scalars['DateTime']['input']>;
  entityId: Scalars['ID']['input'];
  isDefault?: Scalars['Boolean']['input'];
  locationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  managerId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  parentCcId?: InputMaybe<Scalars['ID']['input']>;
  status?: Status;
  type: CostCenterType;
};

export type CreateCustomerDto = {
  additionalNumber?: InputMaybe<Scalars['String']['input']>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  buildingNo?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['String']['input']>;
  commercialRegisterNumber?: InputMaybe<Scalars['String']['input']>;
  districtName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  name?: InputMaybe<Scalars['String']['input']>;
  nationalId?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['String']['input']>;
  partnerNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  streetName?: InputMaybe<Scalars['String']['input']>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CreateDashboardInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateDemandNoteDto = {
  deliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
  demandNoteProducts?: InputMaybe<Array<DemandNoteProductInput>>;
  requestedFromId: Scalars['String']['input'];
  requestedToId: Scalars['String']['input'];
  type: DemandType;
};

export type CreateDiscountDto = {
  buyX?: InputMaybe<Scalars['Int']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  code?: InputMaybe<Scalars['String']['input']>;
  combinable?: Scalars['Boolean']['input'];
  customerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  getY?: InputMaybe<Scalars['Int']['input']>;
  getYDiscount?: InputMaybe<Scalars['Float']['input']>;
  limitUses?: InputMaybe<Scalars['Int']['input']>;
  locationIds: Array<Scalars['String']['input']>;
  maxDiscountAmount?: InputMaybe<Scalars['Float']['input']>;
  minPurchaseAmount?: InputMaybe<Scalars['Float']['input']>;
  minQuantity?: InputMaybe<Scalars['Int']['input']>;
  partnerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  productIds?: InputMaybe<Array<Scalars['String']['input']>>;
  scope: DiscountScope;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: DiscountStatus;
  tagIds?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: DiscountType;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateEntityInput = {
  country: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  fiscalYearType: FiscalYearType;
};

export type CreateExportJobInput = {
  calculatedColumns?: InputMaybe<Array<CalculatedColumnInput>>;
  detailFilters?: InputMaybe<Array<RawFilterInput>>;
  detailInput?: InputMaybe<RunReportDetailInput>;
  filename: Scalars['String']['input'];
  input?: InputMaybe<RunReportInput>;
  kind: Scalars['String']['input'];
  parameterDefs?: InputMaybe<Scalars['JSON']['input']>;
  parameters?: InputMaybe<Scalars['JSON']['input']>;
  pivot?: InputMaybe<RawPivotInput>;
  reportId?: InputMaybe<Scalars['String']['input']>;
  sql?: InputMaybe<Scalars['String']['input']>;
};

export type CreateFinancialTermsDto = {
  coverageFixedAmount?: InputMaybe<Scalars['Float']['input']>;
  coverageModeCode?: InputMaybe<CoverageModeCode>;
  coveragePercent?: InputMaybe<Scalars['Float']['input']>;
  direction?: InputMaybe<Direction>;
  effectiveFrom: Scalars['DateTime']['input'];
  effectiveTo?: InputMaybe<Scalars['DateTime']['input']>;
  isCreditCover?: InputMaybe<Scalars['Boolean']['input']>;
  partnerId: Scalars['String']['input'];
  status?: InputMaybe<Status>;
};

export type CreateFiscalPeriodInput = {
  endDate: Scalars['DateTime']['input'];
  fiscalYearId: Scalars['String']['input'];
  isOpen: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  startDate: Scalars['DateTime']['input'];
};

export type CreateFiscalYearInput = {
  endDate: Scalars['DateTime']['input'];
  entityId: Scalars['String']['input'];
  fiscalYearName: Scalars['String']['input'];
  startDate: Scalars['DateTime']['input'];
};

export type CreateFulfillmentOrderAssignmentInput = {
  consignmentNumber?: InputMaybe<Scalars['String']['input']>;
  consignmentUrl?: InputMaybe<Scalars['String']['input']>;
  lines: Array<CreateFulfillmentOrderLineInput>;
  locationId: Scalars['ID']['input'];
  registerId?: InputMaybe<Scalars['ID']['input']>;
  shippingProvider?: InputMaybe<Scalars['String']['input']>;
  trackingUrl?: InputMaybe<Scalars['String']['input']>;
};

export type CreateFulfillmentOrderInput = {
  assignments: Array<CreateFulfillmentOrderAssignmentInput>;
  orderId: Scalars['ID']['input'];
};

export type CreateFulfillmentOrderLineInput = {
  orderLineItemId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};

export type CreateFusionCarrierCostCentreInput = {
  cityName: Scalars['String']['input'];
  code: Scalars['String']['input'];
  connectionId: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  pickupAddress: Scalars['String']['input'];
  printLabel?: Scalars['Boolean']['input'];
  returnAddress: Scalars['String']['input'];
};

export type CreateFusionConnectionInput = {
  accountId: Scalars['String']['input'];
  connectorCode: Scalars['String']['input'];
  connectorVersion: Scalars['String']['input'];
  credentials?: Array<ConnectionSettingInput>;
  defaultCurrency: Scalars['String']['input'];
  environment: Scalars['String']['input'];
  externalAccountId: Scalars['String']['input'];
  externalAccountName: Scalars['String']['input'];
  provider: Scalars['String']['input'];
  providerApiVersion?: InputMaybe<Scalars['String']['input']>;
  settings?: Array<ConnectionSettingInput>;
  timezone: Scalars['String']['input'];
};

export type CreateFusionRiderInput = {
  connectionId: Scalars['String']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  vehicle?: InputMaybe<Scalars['String']['input']>;
};

export type CreateGenericFormulaDto = {
  name?: InputMaybe<Scalars['String']['input']>;
  status: Status;
};

export type CreateGrnDto = {
  advanceIncomeTax?: InputMaybe<Scalars['String']['input']>;
  grnItems: Array<GrnItem>;
  invoiceDate?: InputMaybe<Scalars['String']['input']>;
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  poId: Scalars['String']['input'];
  stockArrivalDate?: InputMaybe<Scalars['String']['input']>;
};

export type CreateIntegrationConfigDto = {
  allowedOrderType?: InputMaybe<Array<AllowedOrderType>>;
  charges?: InputMaybe<Scalars['Float']['input']>;
  locationId: Scalars['String']['input'];
  logo?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  registerId: Scalars['String']['input'];
  status?: Scalars['String']['input'];
  type: IntegrationType;
};

export type CreateInvoicePolicyConfigDto = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  effectiveDate: Scalars['DateTime']['input'];
  effectiveTillDate?: InputMaybe<Scalars['DateTime']['input']>;
  groupByBusinessDate?: InputMaybe<Scalars['Boolean']['input']>;
  groupByEntity?: InputMaybe<Scalars['Boolean']['input']>;
  groupByLocation?: InputMaybe<Scalars['Boolean']['input']>;
  invoicePolicyCode: InvoicePolicyCode;
  partnerId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Status>;
};

export type CreateJournalHeaderInput = {
  entityId: Scalars['String']['input'];
  journalDate: Scalars['DateTime']['input'];
  lines?: InputMaybe<Array<CreateJournalLineInput>>;
  sourceDocId?: InputMaybe<Scalars['String']['input']>;
  sourceDocType?: InputMaybe<SourceDocType>;
  sourceModuleId: Scalars['ID']['input'];
  status: JournalStatus;
};

export type CreateJournalLineInput = {
  accountId: Scalars['String']['input'];
  costCenterId?: InputMaybe<Scalars['String']['input']>;
  costCenterSource?: InputMaybe<CenterSource>;
  credit?: InputMaybe<Scalars['Float']['input']>;
  currencyId?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  debit?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['String']['input']>;
  profitCenterId?: InputMaybe<Scalars['String']['input']>;
  profitCenterSource?: InputMaybe<CenterSource>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  refId?: InputMaybe<Scalars['String']['input']>;
  vendorId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateLocationRegisterDto = {
  allowedPaymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  assignedUserId?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<CurrencyTypeEnum>;
  locationId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  printMode?: InputMaybe<PrintModeType>;
  receiptTemplate?: InputMaybe<ReceiptTemplateType>;
  status?: InputMaybe<Status>;
  terminalTaxId?: InputMaybe<Scalars['String']['input']>;
  type: LocationRegisterType;
};

export type CreateLocationRegisterSessionDto = {
  openingAmount: Scalars['Float']['input'];
};

export type CreateLostSaleDto = {
  currentInventory?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateManufacturerDto = {
  description?: InputMaybe<Scalars['String']['input']>;
  lineOfBusiness: Array<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  status: Status;
};

export type CreateOrderAddressDto = {
  additionalNumber?: InputMaybe<Scalars['String']['input']>;
  buildingNo?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['String']['input']>;
  districtName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  landmark?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  streetAddress1?: InputMaybe<Scalars['String']['input']>;
  streetAddress2?: InputMaybe<Scalars['String']['input']>;
  streetName?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOrderCustomerDto = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOrderDto = {
  address?: InputMaybe<CreateOrderAddressDto>;
  comment?: InputMaybe<Scalars['String']['input']>;
  customer: CreateOrderCustomerDto;
  discountCode?: InputMaybe<Scalars['String']['input']>;
  items: Array<CreateOrderItemDto>;
  locationId: Scalars['String']['input'];
  mrNo?: InputMaybe<Scalars['String']['input']>;
  orderChannel: OrderChannel;
  orderSource?: InputMaybe<OrderSource>;
  orderType: OrderType;
  partnerAllocationAmount?: InputMaybe<Scalars['Float']['input']>;
  partnerFinancialTermsIds?: InputMaybe<Array<Scalars['String']['input']>>;
  partnerId?: InputMaybe<Scalars['String']['input']>;
  partnerReferenceNo?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<PaymentMethod>;
  pickupTime?: InputMaybe<Scalars['DateTime']['input']>;
  registerId: Scalars['String']['input'];
  registerSessionId: Scalars['String']['input'];
  removedPlatformFeeIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateOrderItemDto = {
  productId: Scalars['String']['input'];
  productLots?: InputMaybe<Array<ProductLotDto>>;
  quantity: Scalars['Int']['input'];
};

export type CreatePartnerDto = {
  address?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['String']['input']>;
  contactPerson?: InputMaybe<Scalars['String']['input']>;
  defaultFinancialTermsId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  status: Status;
  taxId?: InputMaybe<Scalars['String']['input']>;
  type: PartnerType;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePaymentTermDiscountInput = {
  calculationMethod: DiscountCalculationMethod;
  discountDays: Scalars['Int']['input'];
  discountPercent: Scalars['Float']['input'];
};

export type CreatePaymentTermsInput = {
  applicableOn: ApplicableOn;
  baseDate?: InputMaybe<Scalars['DateTime']['input']>;
  baseDateType: BaseDateType;
  description?: InputMaybe<Scalars['String']['input']>;
  discounts?: InputMaybe<Array<CreatePaymentTermDiscountInput>>;
  entityId: Scalars['String']['input'];
  graceDays?: Scalars['Int']['input'];
  isActive?: Scalars['Boolean']['input'];
  isDiscountApplicable?: Scalars['Boolean']['input'];
  isInstallmentBased?: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  schedules?: InputMaybe<Array<CreatePaymentTermsScheduleInput>>;
};

export type CreatePaymentTermsScheduleInput = {
  calculationBasis: CalculationBasis;
  dueOffsetDays: Scalars['Int']['input'];
  duePercent: Scalars['Float']['input'];
  fixedAmount?: InputMaybe<Scalars['Float']['input']>;
  paymentNo: Scalars['Int']['input'];
};

export type CreatePlatformFeeConfigDto = {
  isRemovable?: InputMaybe<Scalars['Boolean']['input']>;
  locationId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  orderType: Scalars['String']['input'];
  platformFeeAccountCode?: InputMaybe<Scalars['String']['input']>;
  platformFeeTaxRate: Scalars['Float']['input'];
  platformFeeTaxable: Scalars['Boolean']['input'];
  platformFeeType: PlatformFeeType;
  platformFeeValue: Scalars['Float']['input'];
  status?: InputMaybe<Status>;
};

export type CreatePrinterConfigDto = {
  batchNumberFontSize?: Scalars['Float']['input'];
  columnGap?: Scalars['Float']['input'];
  columns?: Scalars['Int']['input'];
  expiryFontSize?: Scalars['Float']['input'];
  isDefault?: Scalars['Boolean']['input'];
  labelHeight?: Scalars['Float']['input'];
  labelWidth?: Scalars['Float']['input'];
  marginBottom?: Scalars['Float']['input'];
  marginLeft?: Scalars['Float']['input'];
  marginRight?: Scalars['Float']['input'];
  marginTop?: Scalars['Float']['input'];
  name: Scalars['String']['input'];
  orientation?: Scalars['String']['input'];
  padding?: Scalars['Float']['input'];
  productNameFontSize?: Scalars['Float']['input'];
  productNameMaxLines?: Scalars['Int']['input'];
  productNameWrap?: Scalars['String']['input'];
  qrCodeAlignment?: Scalars['String']['input'];
  qrCodeMarginRight?: Scalars['Float']['input'];
  qrCodeSize?: Scalars['Float']['input'];
  textAlignment?: Scalars['String']['input'];
  zoom?: Scalars['Float']['input'];
};

export type CreateProductConversionDto = {
  id?: InputMaybe<Scalars['String']['input']>;
  itemConversion?: InputMaybe<Scalars['Float']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  sellingUnit: UomUnit;
  sorting: Scalars['Int']['input'];
};

export type CreateProductDto = {
  buyingUnit?: InputMaybe<UomUnit>;
  categoryIds: Array<Scalars['String']['input']>;
  conversions: Array<CreateProductConversionDto>;
  description?: InputMaybe<Scalars['String']['input']>;
  discountPercentage?: InputMaybe<Scalars['Float']['input']>;
  dosageInstruction?: InputMaybe<Scalars['String']['input']>;
  drugRegulatorId?: InputMaybe<Scalars['Int']['input']>;
  genericFormulaIds?: InputMaybe<Array<Scalars['String']['input']>>;
  gtin?: InputMaybe<Scalars['String']['input']>;
  images: Array<InputMaybe<Scalars['String']['input']>>;
  isDiscountApplicableOnTax?: InputMaybe<Scalars['Boolean']['input']>;
  isManufacturable?: Scalars['Boolean']['input'];
  isManufacturerTracking?: InputMaybe<Scalars['Boolean']['input']>;
  isPurchasable?: Scalars['Boolean']['input'];
  isSellable?: Scalars['Boolean']['input'];
  isTaxInclusive?: InputMaybe<Scalars['Boolean']['input']>;
  itemNature: Scalars['String']['input'];
  itemReleaseChannels: Array<InputMaybe<ItemReleaseChannel>>;
  manufacturerId?: InputMaybe<Scalars['String']['input']>;
  margins: Scalars['Float']['input'];
  maximumRetailPrice: Scalars['Float']['input'];
  name: Scalars['String']['input'];
  prescriptionRequired?: Scalars['Boolean']['input'];
  purchasingPrice: Scalars['Float']['input'];
  sellingTaxRate?: InputMaybe<Scalars['Float']['input']>;
  sellingUnit?: InputMaybe<UomUnit>;
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  seoUrl?: InputMaybe<Scalars['String']['input']>;
  sideEffects?: InputMaybe<Scalars['String']['input']>;
  skuCode?: InputMaybe<Scalars['String']['input']>;
  skuDepartment: Scalars['String']['input'];
  skuMaximumLevel?: InputMaybe<Scalars['Int']['input']>;
  skuMinimumLevel?: InputMaybe<Scalars['Int']['input']>;
  skuReorderLevel?: InputMaybe<Scalars['Int']['input']>;
  skuWarehouseLeadTime?: InputMaybe<Scalars['Int']['input']>;
  status: Status;
  stockNature: Scalars['String']['input'];
  tagIds: Array<InputMaybe<Scalars['String']['input']>>;
  taxCode?: InputMaybe<Scalars['Int']['input']>;
  taxGroupId: Scalars['String']['input'];
  trackingLevel: TrackingLevel;
  tradeDiscount?: InputMaybe<Scalars['Float']['input']>;
  tradePrice: Scalars['Float']['input'];
  uomType?: UomType;
  vendorIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateProductLotDto = {
  batch_expiry_date: Scalars['DateTime']['input'];
  batch_number: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  discount_value?: InputMaybe<Scalars['Float']['input']>;
  gst_rate: Scalars['Float']['input'];
  location_id: Scalars['String']['input'];
  product_id: Scalars['String']['input'];
  quantity: Scalars['Float']['input'];
  trade_price: Scalars['Float']['input'];
};

export type CreateProductManufacturingPriceDto = {
  effectiveFrom: Scalars['Date']['input'];
  effectiveTo?: InputMaybe<Scalars['Date']['input']>;
  /** MRP per pack */
  maximumRetailPrice: Scalars['Float']['input'];
  productId: Scalars['String']['input'];
  /** Tax rate in percent */
  taxRate: Scalars['Float']['input'];
  /** Selling TP to trade, per pack */
  tradePriceOutward: Scalars['Float']['input'];
};

export type CreateProductionOrderDto = {
  bomVersionId?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  multiplierFactor?: InputMaybe<Scalars['Int']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  orderCode: Scalars['String']['input'];
  productionLineId?: InputMaybe<Scalars['String']['input']>;
  productionPlanId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateProductionPlanDto = {
  notes?: InputMaybe<Scalars['String']['input']>;
  planCode: Scalars['String']['input'];
  plannedEndDate?: InputMaybe<Scalars['Date']['input']>;
  plannedStartDate?: InputMaybe<Scalars['Date']['input']>;
  productionLocationId: Scalars['String']['input'];
  sourceLocationId: Scalars['String']['input'];
};

export type CreateProfitCenterInput = {
  coaAccountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  code: Scalars['String']['input'];
  effectiveFrom?: InputMaybe<Scalars['DateTime']['input']>;
  effectiveTo?: InputMaybe<Scalars['DateTime']['input']>;
  entityId: Scalars['ID']['input'];
  isDefault?: Scalars['Boolean']['input'];
  locationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  managerId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  parentPcId?: InputMaybe<Scalars['ID']['input']>;
  status?: Status;
  type: ProfitCenterType;
};

export type CreatePurchaseOrderDto = {
  additionalTerms?: InputMaybe<Scalars['String']['input']>;
  expectedDeliveryDate: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  orderItems: Array<OrderItem>;
  orderType: PurchaseOrderType;
  returnRfid?: InputMaybe<Scalars['String']['input']>;
  vendorId: Scalars['String']['input'];
};

export type CreateReportInput = {
  chartConfig?: InputMaybe<Scalars['JSON']['input']>;
  definition: RunReportInput;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateSourceModuleInput = {
  allowManualNumber: Scalars['Boolean']['input'];
  autoPostEnabled: Scalars['Boolean']['input'];
  code: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  entityId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  padding?: InputMaybe<Scalars['Int']['input']>;
  prefix: Scalars['String']['input'];
  resetCycle: ResetCycle;
};

export type CreateSqlReportInput = {
  calculatedColumns?: InputMaybe<Array<CalculatedColumnInput>>;
  chartConfig?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  parameters?: InputMaybe<Scalars['JSON']['input']>;
  sql: Scalars['String']['input'];
};

export type CreateStockOperationDto = {
  locationId: Scalars['String']['input'];
  operationType: StockOperationType;
  remarks?: InputMaybe<Scalars['String']['input']>;
};

export type CreateStockReturnDto = {
  gatePassNumber: Scalars['String']['input'];
  items: Array<StockReturnItemInput>;
  locationId: Scalars['String']['input'];
  vendorId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTagDto = {
  name?: InputMaybe<Scalars['String']['input']>;
  status: Status;
};

export type CreateTaxGroupDto = {
  name?: InputMaybe<Scalars['String']['input']>;
  status: Status;
  taxPercentage: Scalars['Float']['input'];
};

export type CreateTenantDto = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  allowedSellingUnits?: InputMaybe<Scalars['JSONObject']['input']>;
  cacheHost?: InputMaybe<Scalars['String']['input']>;
  cachePassword?: InputMaybe<Scalars['String']['input']>;
  cachePort?: InputMaybe<Scalars['Float']['input']>;
  cacheType?: InputMaybe<Scalars['String']['input']>;
  databaseHost?: InputMaybe<Scalars['String']['input']>;
  databaseName?: InputMaybe<Scalars['String']['input']>;
  databasePassword?: InputMaybe<Scalars['String']['input']>;
  databasePort?: InputMaybe<Scalars['Float']['input']>;
  databaseType?: InputMaybe<Scalars['String']['input']>;
  databaseUsername?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ntnNumber?: InputMaybe<Scalars['String']['input']>;
  saleTaxNumber?: InputMaybe<Scalars['String']['input']>;
  taxNumber?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTransferDto = {
  demandNoteId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  expectedDeliveryDate: Scalars['DateTime']['input'];
  locationFrom: Scalars['String']['input'];
  locationTo: Scalars['String']['input'];
  productLots: Array<CreateTransferProductLotInput>;
};

export type CreateTransferProductLotInput = {
  productLotId: Scalars['String']['input'];
  quantity: Scalars['Float']['input'];
};

export type CreateVendorDto = {
  bankName?: InputMaybe<Scalars['String']['input']>;
  branchCityId?: InputMaybe<Scalars['String']['input']>;
  branchCode?: InputMaybe<Scalars['String']['input']>;
  businessAddress?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['String']['input']>;
  classification?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  contactPerson?: InputMaybe<Scalars['String']['input']>;
  corporateWebsite?: InputMaybe<Scalars['String']['input']>;
  creditLimit?: InputMaybe<Scalars['Float']['input']>;
  document?: InputMaybe<Scalars['String']['input']>;
  documentExpiryDate?: InputMaybe<Scalars['String']['input']>;
  drugLicenseNo?: InputMaybe<Scalars['Int']['input']>;
  drugSaleLicense?: InputMaybe<Scalars['Boolean']['input']>;
  duns_number?: InputMaybe<Scalars['String']['input']>;
  ibanNumber?: InputMaybe<Scalars['String']['input']>;
  leadTime?: InputMaybe<Scalars['Float']['input']>;
  manufacturerIds: Array<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationType?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  paymentTerms?: InputMaybe<Scalars['String']['input']>;
  primaryEmailAddress?: InputMaybe<Scalars['String']['input']>;
  primaryPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  secondaryEmailAddress?: InputMaybe<Scalars['String']['input']>;
  secondaryPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  stateProvince?: InputMaybe<Scalars['String']['input']>;
  status: Status;
  stockReturnPolicy?: InputMaybe<Scalars['String']['input']>;
  strn?: InputMaybe<Scalars['String']['input']>;
  taxExemption?: InputMaybe<Scalars['Boolean']['input']>;
  taxExemptionValidity?: InputMaybe<Scalars['String']['input']>;
  taxReturn?: InputMaybe<Scalars['Boolean']['input']>;
  taxationNumber?: InputMaybe<Scalars['String']['input']>;
  type: Array<Scalars['String']['input']>;
  withHoldTaxGroup?: InputMaybe<Scalars['String']['input']>;
  withHoldTaxPercentage?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export enum CurrencyTypeEnum {
  Aed = 'AED',
  Afn = 'AFN',
  All = 'ALL',
  Amd = 'AMD',
  Ang = 'ANG',
  Aoa = 'AOA',
  Ars = 'ARS',
  Aud = 'AUD',
  Awg = 'AWG',
  Azn = 'AZN',
  Bam = 'BAM',
  Bbd = 'BBD',
  Bdt = 'BDT',
  Bgn = 'BGN',
  Bhd = 'BHD',
  Bif = 'BIF',
  Bmd = 'BMD',
  Bnd = 'BND',
  Bob = 'BOB',
  Brl = 'BRL',
  Bsd = 'BSD',
  Btc = 'BTC',
  Btn = 'BTN',
  Bwp = 'BWP',
  Byn = 'BYN',
  Byr = 'BYR',
  Bzd = 'BZD',
  Cad = 'CAD',
  Cdf = 'CDF',
  Chf = 'CHF',
  Clf = 'CLF',
  Clp = 'CLP',
  Cny = 'CNY',
  Cop = 'COP',
  Crc = 'CRC',
  Cuc = 'CUC',
  Cup = 'CUP',
  Cve = 'CVE',
  Czk = 'CZK',
  Djf = 'DJF',
  Dkk = 'DKK',
  Dop = 'DOP',
  Dzd = 'DZD',
  Eek = 'EEK',
  Egp = 'EGP',
  Ern = 'ERN',
  Etb = 'ETB',
  Eur = 'EUR',
  Fjd = 'FJD',
  Fkp = 'FKP',
  Gbp = 'GBP',
  Gel = 'GEL',
  Ggp = 'GGP',
  Ghs = 'GHS',
  Gip = 'GIP',
  Gmd = 'GMD',
  Gnf = 'GNF',
  Gtq = 'GTQ',
  Gyd = 'GYD',
  Hkd = 'HKD',
  Hnl = 'HNL',
  Hrk = 'HRK',
  Htg = 'HTG',
  Huf = 'HUF',
  Idr = 'IDR',
  Ils = 'ILS',
  Imp = 'IMP',
  Inr = 'INR',
  Iqd = 'IQD',
  Irr = 'IRR',
  Isk = 'ISK',
  Jep = 'JEP',
  Jmd = 'JMD',
  Jod = 'JOD',
  Jpy = 'JPY',
  Kes = 'KES',
  Kgs = 'KGS',
  Khr = 'KHR',
  Kmf = 'KMF',
  Kpw = 'KPW',
  Krw = 'KRW',
  Kwd = 'KWD',
  Kyd = 'KYD',
  Kzt = 'KZT',
  Lak = 'LAK',
  Lbp = 'LBP',
  Lkr = 'LKR',
  Lrd = 'LRD',
  Lsl = 'LSL',
  Ltl = 'LTL',
  Lvl = 'LVL',
  Lyd = 'LYD',
  Mad = 'MAD',
  Mdl = 'MDL',
  Mga = 'MGA',
  Mkd = 'MKD',
  Mmk = 'MMK',
  Mnt = 'MNT',
  Mop = 'MOP',
  Mro = 'MRO',
  Mtl = 'MTL',
  Mur = 'MUR',
  Mvr = 'MVR',
  Mwk = 'MWK',
  Mxn = 'MXN',
  Myr = 'MYR',
  Mzn = 'MZN',
  Nad = 'NAD',
  Ngn = 'NGN',
  Nio = 'NIO',
  Nok = 'NOK',
  Npr = 'NPR',
  Nzd = 'NZD',
  Omr = 'OMR',
  Pab = 'PAB',
  Pen = 'PEN',
  Pgk = 'PGK',
  Php = 'PHP',
  Pkr = 'PKR',
  Pln = 'PLN',
  Pyg = 'PYG',
  Qar = 'QAR',
  Ron = 'RON',
  Rsd = 'RSD',
  Rub = 'RUB',
  Rwf = 'RWF',
  Sar = 'SAR',
  Sbd = 'SBD',
  Scr = 'SCR',
  Sdg = 'SDG',
  Sek = 'SEK',
  Sgd = 'SGD',
  Shp = 'SHP',
  Skk = 'SKK',
  Sll = 'SLL',
  Sos = 'SOS',
  Srd = 'SRD',
  Ssp = 'SSP',
  Std = 'STD',
  Svc = 'SVC',
  Syp = 'SYP',
  Szl = 'SZL',
  Thb = 'THB',
  Tjs = 'TJS',
  Tmm = 'TMM',
  Tmt = 'TMT',
  Tnd = 'TND',
  Top = 'TOP',
  Try = 'TRY',
  Ttd = 'TTD',
  Twd = 'TWD',
  Tzs = 'TZS',
  Uah = 'UAH',
  Ugx = 'UGX',
  Usd = 'USD',
  Uyu = 'UYU',
  Uzs = 'UZS',
  Vef = 'VEF',
  Vnd = 'VND',
  Vuv = 'VUV',
  Wst = 'WST',
  Xaf = 'XAF',
  Xag = 'XAG',
  Xau = 'XAU',
  Xcd = 'XCD',
  Xdr = 'XDR',
  Xof = 'XOF',
  Xpf = 'XPF',
  Yer = 'YER',
  Zac = 'ZAC',
  Zar = 'ZAR',
  Zmk = 'ZMK',
  Zmw = 'ZMW',
  Zwd = 'ZWD',
  Zwl = 'ZWL',
  Zwn = 'ZWN',
  Zwr = 'ZWR'
}

export type Customer = {
  additionalNumber?: Maybe<Scalars['String']['output']>;
  addresses?: Maybe<Array<Address>>;
  birthday?: Maybe<Scalars['Date']['output']>;
  buildingNo?: Maybe<Scalars['String']['output']>;
  city?: Maybe<City>;
  cityId?: Maybe<Scalars['String']['output']>;
  commercialRegisterNumber?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  districtName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Gender>;
  id?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  nationalId?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  orders: Array<Order>;
  partner?: Maybe<Partner>;
  partnerId?: Maybe<Scalars['String']['output']>;
  partnerNumber?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  secondaryId?: Maybe<Scalars['Float']['output']>;
  streetName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  vatNumber?: Maybe<Scalars['String']['output']>;
};

export type CustomerResponseDto = {
  data: Array<Customer>;
  meta: MetaResponse;
};

export enum DamageQuantityUnit {
  Base = 'BASE',
  Sellable = 'SELLABLE'
}

export type Dashboard = {
  config?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isSystem: Scalars['Boolean']['output'];
  myAccess?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  ownerName?: Maybe<Scalars['String']['output']>;
  ownerUserId?: Maybe<Scalars['String']['output']>;
  sharedWithMe?: Maybe<Scalars['Boolean']['output']>;
  systemKey?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  visibility: ReportVisibility;
};

export type DashboardLocationOption = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type DashboardPage = {
  data: Array<Dashboard>;
  meta: DashboardPageMeta;
};

export type DashboardPageMeta = {
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type DashboardWidget = {
  dashboardId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  reportId: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
  span: Scalars['Int']['output'];
  tab?: Maybe<Scalars['String']['output']>;
};

export type DashboardWidgetWithReport = {
  dashboardId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  report: ReportDefinition;
  reportId: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
  span: Scalars['Int']['output'];
  tab?: Maybe<Scalars['String']['output']>;
};

export type DashboardWithWidgets = {
  config?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isSystem: Scalars['Boolean']['output'];
  myAccess?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  ownerName?: Maybe<Scalars['String']['output']>;
  ownerUserId?: Maybe<Scalars['String']['output']>;
  sharedWithMe?: Maybe<Scalars['Boolean']['output']>;
  systemKey?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  visibility: ReportVisibility;
  widgets: Array<DashboardWidgetWithReport>;
};

export type DayEndSummaryDto = {
  bankTransferAmount: Scalars['Float']['output'];
  cardAmount: Scalars['Float']['output'];
  cashAmount: Scalars['Float']['output'];
  creditAmount: Scalars['Float']['output'];
  discount: Scalars['Float']['output'];
  gross: Scalars['Float']['output'];
  integrationCharges: Scalars['Float']['output'];
  locationId: Scalars['String']['output'];
  netAmount: Scalars['Float']['output'];
  netSale: Scalars['Float']['output'];
  orderCount: Scalars['Float']['output'];
  platformFee: Scalars['Float']['output'];
  reportDate: Scalars['String']['output'];
  returned: Scalars['Float']['output'];
  shippingFee: Scalars['Float']['output'];
  tax: Scalars['Float']['output'];
};

export type DemandNote = {
  closureReason?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdBy: Scalars['String']['output'];
  deliveryDate?: Maybe<Scalars['Date']['output']>;
  demandNoteProducts?: Maybe<Array<DemandNoteProduct>>;
  fulfillmentStatus: DemandNoteFulfillmentStatus;
  id: Scalars['String']['output'];
  productionPlanId?: Maybe<Scalars['String']['output']>;
  requestedFrom: Location;
  requestedTo: Location;
  secondaryId?: Maybe<Scalars['Int']['output']>;
  type: DemandType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum DemandNoteFulfillmentStatus {
  Cancelled = 'CANCELLED',
  Closed = 'CLOSED',
  Fulfilled = 'FULFILLED',
  Open = 'OPEN',
  Partial = 'PARTIAL'
}

export type DemandNoteGql = {
  closureReason?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdBy: Scalars['String']['output'];
  deliveryDate?: Maybe<Scalars['Date']['output']>;
  demandNoteProducts?: Maybe<Array<DemandNoteProduct>>;
  fulfillmentRatio: Scalars['Float']['output'];
  fulfillmentStatus: DemandNoteFulfillmentStatus;
  id: Scalars['String']['output'];
  isPartial: Scalars['Boolean']['output'];
  productionPlanId?: Maybe<Scalars['String']['output']>;
  requestedFrom: Location;
  requestedTo: Location;
  secondaryId?: Maybe<Scalars['Int']['output']>;
  stockValue: Scalars['Float']['output'];
  totalItems: Scalars['Int']['output'];
  totalRequestedQuantity: Scalars['Int']['output'];
  transferSecondaryIds: Array<Scalars['Int']['output']>;
  type: DemandType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DemandNoteGqlListResponse = {
  data: Array<DemandNoteGql>;
  meta: MetaResponse;
};

export type DemandNoteProduct = {
  currentInventory: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  product: Product;
  remainingQuantity?: Maybe<Scalars['Float']['output']>;
  requestedQuantity: Scalars['Int']['output'];
  secondaryId?: Maybe<Scalars['Int']['output']>;
  value: Scalars['Float']['output'];
};

export type DemandNoteProductInput = {
  productId: Scalars['String']['input'];
  requestedQuantity: Scalars['Int']['input'];
};

export enum DemandType {
  Commercial = 'COMMERCIAL',
  Monthly = 'MONTHLY',
  Partner = 'PARTNER',
  ProductionPlan = 'PRODUCTION_PLAN',
  Urgent = 'URGENT',
  Weekly = 'WEEKLY'
}

export enum DeploymentType {
  Dedicated = 'DEDICATED',
  Shared = 'SHARED'
}

export enum Direction {
  Payable = 'PAYABLE',
  Receivable = 'RECEIVABLE'
}

export type Discount = {
  applicableCategories?: Maybe<Array<Category>>;
  applicableCustomers?: Maybe<Array<Customer>>;
  applicablePartners?: Maybe<Array<Partner>>;
  applicableProducts?: Maybe<Array<Product>>;
  applicableTags?: Maybe<Array<Tag>>;
  buyX?: Maybe<Scalars['Float']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  combinable?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  getY?: Maybe<Scalars['Float']['output']>;
  getYDiscount?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  limitUses?: Maybe<Scalars['Float']['output']>;
  locations?: Maybe<Array<Location>>;
  maxDiscountAmount?: Maybe<Scalars['Float']['output']>;
  minPurchaseAmount?: Maybe<Scalars['Float']['output']>;
  minQuantity?: Maybe<Scalars['Float']['output']>;
  scope?: Maybe<DiscountScope>;
  secondaryId?: Maybe<Scalars['Float']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status: DiscountStatus;
  title?: Maybe<Scalars['String']['output']>;
  type: DiscountType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export enum DiscountCalculationMethod {
  Gross = 'GROSS',
  Net = 'NET'
}

export type DiscountPerformanceDto = {
  avgDiscountAmount: Scalars['Float']['output'];
  discountCode?: Maybe<Scalars['String']['output']>;
  discountId: Scalars['String']['output'];
  discountTitle: Scalars['String']['output'];
  totalDiscountAmount: Scalars['Float']['output'];
  totalOrdersAffected: Scalars['Float']['output'];
  usageCount: Scalars['Float']['output'];
};

export type DiscountResponseDto = {
  data: Array<Discount>;
  meta: MetaResponse;
};

export enum DiscountScope {
  BuyXGetY = 'BUY_X_GET_Y',
  Cart = 'CART',
  FreeShipping = 'FREE_SHIPPING',
  Product = 'PRODUCT'
}

export enum DiscountStatus {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  InActive = 'IN_ACTIVE',
  Scheduled = 'SCHEDULED'
}

export type DiscountSummaryDto = {
  amount: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export enum DiscountType {
  FixedAmount = 'FIXED_AMOUNT',
  Percentage = 'PERCENTAGE'
}

export type EditOrderDto = {
  cityId?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
};

export type EntityModel = {
  country: Scalars['String']['output'];
  entityName: Scalars['String']['output'];
  fiscalYearType: FiscalYearType;
  id: Scalars['ID']['output'];
  secondaryId?: Maybe<Scalars['Float']['output']>;
};

export type EntityResponseDto = {
  data: Array<EntityModel>;
  meta: MetaResponse;
};

export enum EntryMethod {
  Automatic = 'AUTOMATIC',
  Manual = 'MANUAL'
}

export type ExportJob = {
  byteSize?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  downloadUrl?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  filename: Scalars['String']['output'];
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  requestedBy?: Maybe<Scalars['String']['output']>;
  requestedByName?: Maybe<Scalars['String']['output']>;
  rowCount?: Maybe<Scalars['Float']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
};

export type ExternalObjectLinkInput = {
  externalObjectId: Scalars['String']['input'];
  oneObjectId: Scalars['String']['input'];
};

export type FilterCondition = {
  field: Scalars['String']['input'];
  operator: FilterOperator;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type FilterGroup = {
  conditions: Array<FilterCondition>;
  logicalOperator: LogicalOperator;
};

export enum FilterOperator {
  Between = 'BETWEEN',
  Equal = 'EQUAL',
  Gt = 'GT',
  Gte = 'GTE',
  Like = 'LIKE',
  Lt = 'LT',
  Lte = 'LTE',
  Ne = 'NE'
}

export type FinanceReportRow = {
  accountCode?: Maybe<Scalars['String']['output']>;
  accountId: Scalars['ID']['output'];
  accountName: Scalars['String']['output'];
  accountType?: Maybe<ChartAccountType>;
  balance: Scalars['String']['output'];
  balanceType?: Maybe<BalanceType>;
  closingCredit: Scalars['String']['output'];
  closingDebit: Scalars['String']['output'];
  credit: Scalars['String']['output'];
  debit: Scalars['String']['output'];
  isGroup: Scalars['Boolean']['output'];
  level: Scalars['Int']['output'];
  openingCredit: Scalars['String']['output'];
  openingDebit: Scalars['String']['output'];
  parentAccountId?: Maybe<Scalars['ID']['output']>;
  reportingGroup?: Maybe<ReportingGroup>;
};

export type FinancialTermsResponseDto = {
  data: Array<PartnerFinancialTerms>;
  meta: MetaResponse;
};

export type FiscalPeriod = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['ID']['output']>;
  createdByName?: Maybe<Scalars['String']['output']>;
  endDate: Scalars['DateTime']['output'];
  fiscalYear?: Maybe<FiscalYear>;
  fiscalYearId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  isOpen: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  secondaryId?: Maybe<Scalars['Float']['output']>;
  startDate: Scalars['DateTime']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['ID']['output']>;
  updatedByName?: Maybe<Scalars['String']['output']>;
};

export type FiscalPeriodStatsDto = {
  endDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isOpen: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  startDate: Scalars['DateTime']['output'];
};

export type FiscalPeriodsResponseDto = {
  data: Array<FiscalPeriod>;
  meta: MetaResponse;
};

export type FiscalYear = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['ID']['output']>;
  createdByName?: Maybe<Scalars['String']['output']>;
  endDate: Scalars['DateTime']['output'];
  entity?: Maybe<EntityModel>;
  entityId: Scalars['ID']['output'];
  fiscalYearName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  secondaryId?: Maybe<Scalars['Float']['output']>;
  startDate: Scalars['DateTime']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['ID']['output']>;
  updatedByName?: Maybe<Scalars['String']['output']>;
};

export enum FiscalYearType {
  Calendar = 'CALENDAR',
  Custom = 'CUSTOM'
}

export type FiscalYearsResponseDto = {
  data: Array<FiscalYear>;
  meta: MetaResponse;
};

export type FlowRun = {
  createdAt: Scalars['DateTime']['output'];
  error?: Maybe<Scalars['String']['output']>;
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  flowId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  op?: Maybe<Scalars['String']['output']>;
  reportId?: Maybe<Scalars['String']['output']>;
  results?: Maybe<Scalars['JSON']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
  threshold?: Maybe<Scalars['Float']['output']>;
  triggeredValue?: Maybe<Scalars['Float']['output']>;
};

export type FormulaFunction = {
  category: Scalars['String']['output'];
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  signature: Scalars['String']['output'];
};

export type FulfillmentHold = {
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  entityId: Scalars['String']['output'];
  entityType: HoldEntityType;
  heldAt: Scalars['DateTime']['output'];
  heldByUserId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  reason: HoldReason;
  releasedAt?: Maybe<Scalars['DateTime']['output']>;
  releasedByUserId?: Maybe<Scalars['String']['output']>;
  status: HoldStatus;
};

export type FulfillmentOrder = {
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  acceptedByUserId?: Maybe<Scalars['String']['output']>;
  codAmount?: Maybe<Scalars['Float']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  consignmentNumber?: Maybe<Scalars['String']['output']>;
  consignmentUrl?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deliveredAt?: Maybe<Scalars['DateTime']['output']>;
  deliveredByUserId?: Maybe<Scalars['String']['output']>;
  dispatchedAt?: Maybe<Scalars['DateTime']['output']>;
  dispatchedByUserId?: Maybe<Scalars['String']['output']>;
  fulfillmentId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lines?: Maybe<Array<FulfillmentOrderLine>>;
  location?: Maybe<Location>;
  locationId: Scalars['String']['output'];
  lotsLockedAt?: Maybe<Scalars['DateTime']['output']>;
  lotsLockedByUserId?: Maybe<Scalars['String']['output']>;
  order: Order;
  orderId: Scalars['String']['output'];
  packedAt?: Maybe<Scalars['DateTime']['output']>;
  packedByUserId?: Maybe<Scalars['String']['output']>;
  register?: Maybe<LocationRegister>;
  registerId?: Maybe<Scalars['String']['output']>;
  rerouteCount: Scalars['Float']['output'];
  secondaryId?: Maybe<Scalars['Float']['output']>;
  shippingProvider?: Maybe<Scalars['String']['output']>;
  source: FulfillmentOrderSource;
  status: FulfillmentOrderStatus;
  trackingUrl?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type FulfillmentOrderEvent = {
  /** When it happened in the real world */
  at: Scalars['DateTime']['output'];
  /** When it was entered */
  createdAt: Scalars['DateTime']['output'];
  data?: Maybe<Scalars['JSON']['output']>;
  fulfillmentOrderId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  type: FulfillmentOrderEventType;
  userId?: Maybe<Scalars['String']['output']>;
};

export enum FulfillmentOrderEventType {
  Booked = 'BOOKED',
  BookingVoided = 'BOOKING_VOIDED',
  Delivered = 'DELIVERED',
  DeliveryFailed = 'DELIVERY_FAILED',
  Dispatched = 'DISPATCHED',
  LotsLocked = 'LOTS_LOCKED',
  LotRejected = 'LOT_REJECTED',
  LotSwapped = 'LOT_SWAPPED',
  ParcelReturned = 'PARCEL_RETURNED',
  Released = 'RELEASED',
  Unpacked = 'UNPACKED'
}

export type FulfillmentOrderLine = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  fulfilledQuantity: Scalars['Float']['output'];
  fulfillmentOrder: FulfillmentOrder;
  fulfillmentOrderId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  orderLineItem: OrderLineItem;
  orderLineItemId: Scalars['String']['output'];
  pickerAssignedAt?: Maybe<Scalars['DateTime']['output']>;
  pickerTaskId?: Maybe<Scalars['String']['output']>;
  pickerTasks?: Maybe<Array<FulfillmentPickerTask>>;
  pickerUserId?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Product>;
  productId: Scalars['String']['output'];
  quantity: Scalars['Float']['output'];
  secondaryId?: Maybe<Scalars['Float']['output']>;
  status: FulfillmentOrderLineStatus;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum FulfillmentOrderLineStatus {
  Cancelled = 'CANCELLED',
  Fulfilled = 'FULFILLED',
  PartiallyFulfilled = 'PARTIALLY_FULFILLED',
  Pending = 'PENDING'
}

export type FulfillmentOrderListFilter = {
  fulfillmentOrderIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  tab?: InputMaybe<FulfillmentOrderTab>;
};

export type FulfillmentOrderResponseDto = {
  data: Array<FulfillmentOrder>;
  meta: MetaResponse;
};

export enum FulfillmentOrderSource {
  External = 'EXTERNAL',
  Pos = 'POS'
}

export enum FulfillmentOrderStatus {
  Assigned = 'ASSIGNED',
  Cancelled = 'CANCELLED',
  Delivered = 'DELIVERED',
  DeliveryFailed = 'DELIVERY_FAILED',
  Dispatched = 'DISPATCHED',
  Fulfilled = 'FULFILLED',
  InProgress = 'IN_PROGRESS',
  InTransit = 'IN_TRANSIT',
  OnHold = 'ON_HOLD',
  PartiallyAssigned = 'PARTIALLY_ASSIGNED',
  PartiallyFulfilled = 'PARTIALLY_FULFILLED',
  ReadyToDispatch = 'READY_TO_DISPATCH',
  Unassigned = 'UNASSIGNED'
}

export enum FulfillmentOrderTab {
  All = 'ALL',
  Delivered = 'DELIVERED',
  Dispatched = 'DISPATCHED',
  Picked = 'PICKED',
  Picking = 'PICKING',
  ReadyForDispatch = 'READY_FOR_DISPATCH'
}

export type FulfillmentPickerTask = {
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  fulfillmentOrder?: Maybe<FulfillmentOrder>;
  fulfillmentOrderId: Scalars['String']['output'];
  fulfillmentOrderLine?: Maybe<FulfillmentOrderLine>;
  fulfillmentOrderLineId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  location?: Maybe<Location>;
  locationId?: Maybe<Scalars['String']['output']>;
  lots?: Maybe<Array<FulfillmentPickerTaskLot>>;
  picker?: Maybe<User>;
  pickerAssignedAt?: Maybe<Scalars['DateTime']['output']>;
  pickerUserId: Scalars['String']['output'];
  quantityToPick: Scalars['Int']['output'];
  scannedQuantity: Scalars['Int']['output'];
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: PickingTaskStatus;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type FulfillmentPickerTaskLot = {
  actionId?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  lotId: Scalars['String']['output'];
  pickerTask?: Maybe<FulfillmentPickerTask>;
  pickerTaskId: Scalars['String']['output'];
  sellableQuantity: Scalars['Int']['output'];
  status: PickerTaskLotStatus;
};

export type FulfillmentStatDto = {
  count: Scalars['Float']['output'];
  fulfillmentStatus: Scalars['String']['output'];
  percentage: Scalars['Float']['output'];
};

export enum FulfillmentStatus {
  Fulfilled = 'FULFILLED',
  InProgress = 'IN_PROGRESS',
  PartiallyFulfilled = 'PARTIALLY_FULFILLED',
  Pending = 'PENDING',
  Unfulfilled = 'UNFULFILLED'
}

export type FusionCarrierCostCentre = {
  cityName?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  pickupAddress?: Maybe<Scalars['String']['output']>;
  returnAddress?: Maybe<Scalars['String']['output']>;
};

export type FusionCarrierHealth = {
  connectionId: Scalars['String']['output'];
  credentialExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  daysUntilExpiry?: Maybe<Scalars['Int']['output']>;
  expiringSoon: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type FusionCarrierLabel = {
  base64Data: Scalars['String']['output'];
  consignmentNumber: Scalars['String']['output'];
  contentType: Scalars['String']['output'];
};

export type FusionCarrierLocationMapping = {
  costCentreCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  locationId: Scalars['String']['output'];
  locationName: Scalars['String']['output'];
};

export type FusionCatalogSyncResult = {
  batchCount: Scalars['Float']['output'];
  error?: Maybe<Scalars['String']['output']>;
  externalVendorId: Scalars['String']['output'];
  itemCount: Scalars['Float']['output'];
  jobIds: Array<Scalars['String']['output']>;
  locationId: Scalars['String']['output'];
  operationIds: Array<Scalars['String']['output']>;
  queuedCount: Scalars['Int']['output'];
  status: Scalars['String']['output'];
};

export enum FusionCodDestinationType {
  BankDeposit = 'BANK_DEPOSIT',
  BranchTill = 'BRANCH_TILL',
  CashOffice = 'CASH_OFFICE',
  Other = 'OTHER'
}

export type FusionCodSettlement = {
  /** Handed in */
  amount: Scalars['String']['output'];
  /** The parcels' COD */
  expectedAmount: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  riderId: Scalars['ID']['output'];
  settledAt: Scalars['DateTime']['output'];
  shipmentCount: Scalars['Int']['output'];
  /** Expected less handed in, owed by the rider */
  shortfall: Scalars['String']['output'];
};

export type FusionConnection = {
  callbackKey?: Maybe<Scalars['String']['output']>;
  connectorCode: Scalars['String']['output'];
  connectorVersion: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  defaultCurrency: Scalars['String']['output'];
  environment: Scalars['String']['output'];
  externalAccountId: Scalars['String']['output'];
  externalAccountName: Scalars['String']['output'];
  hasCredentials: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  provider: Scalars['String']['output'];
  providerApiVersion?: Maybe<Scalars['String']['output']>;
  settings: Array<ConnectionSetting>;
  status: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  timezone: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type FusionCourier = {
  connectorCode: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  environment: Scalars['String']['output'];
  id: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type FusionExternalObjectMapping = {
  connectionId: Scalars['String']['output'];
  externalObjectId: Scalars['String']['output'];
  externalObjectType: Scalars['String']['output'];
  id: Scalars['String']['output'];
  oneObjectId: Scalars['String']['output'];
  oneObjectType: Scalars['String']['output'];
};

export type FusionIntegration = {
  authFlow?: Maybe<Scalars['String']['output']>;
  callbackKey?: Maybe<Scalars['String']['output']>;
  capabilities: Array<Scalars['String']['output']>;
  connectorCode: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  environment: Scalars['String']['output'];
  externalAccountId?: Maybe<Scalars['String']['output']>;
  features: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  mappedLocationCount: Scalars['Float']['output'];
  mappedProductCount: Scalars['Float']['output'];
  settingSpecs: Array<FusionIntegrationSettingSpec>;
  settings: Array<FusionIntegrationSettingValue>;
  status: Scalars['String']['output'];
};

export type FusionIntegrationAuthorization = {
  authorizeUrl: Scalars['String']['output'];
};

export type FusionIntegrationCatalogueEntry = {
  authFlow?: Maybe<Scalars['String']['output']>;
  category: Scalars['String']['output'];
  connectionId?: Maybe<Scalars['String']['output']>;
  connectorCode: Scalars['String']['output'];
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  entitled: Scalars['Boolean']['output'];
  features: Array<Scalars['String']['output']>;
  settings: Array<FusionIntegrationSettingSpec>;
  supportedEvents: Array<Scalars['String']['output']>;
};

export type FusionIntegrationEventSubscription = {
  enabled: Scalars['Boolean']['output'];
  eventType: Scalars['String']['output'];
};

export type FusionIntegrationExternalLocation = {
  address?: Maybe<Scalars['String']['output']>;
  fulfillsOnlineOrders: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  linkedLocationId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type FusionIntegrationLocation = {
  externalVendorId?: Maybe<Scalars['String']['output']>;
  locationId: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type FusionIntegrationOperation = {
  attemptCount: Scalars['Float']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  error?: Maybe<Scalars['String']['output']>;
  externalObjectId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  oneObjectId: Scalars['String']['output'];
  operationType: Scalars['String']['output'];
  requestPayload: Scalars['JSON']['output'];
  responsePayload?: Maybe<Scalars['JSON']['output']>;
  status: Scalars['String']['output'];
};

export type FusionIntegrationProduct = {
  active: Scalars['Boolean']['output'];
  barcode?: Maybe<Scalars['String']['output']>;
  externalSku?: Maybe<Scalars['String']['output']>;
  externalUrl?: Maybe<Scalars['String']['output']>;
  lastError?: Maybe<Scalars['String']['output']>;
  lastPushedAt?: Maybe<Scalars['DateTime']['output']>;
  listingStatus?: Maybe<Scalars['String']['output']>;
  maximumSalesQuantity?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  productId: Scalars['String']['output'];
  stockBuffer?: Maybe<Scalars['Int']['output']>;
};

export type FusionIntegrationProductActionInput = {
  connectionId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};

export type FusionIntegrationProductSync = {
  busy: Scalars['Boolean']['output'];
  failed: Scalars['Int']['output'];
  lastError?: Maybe<Scalars['String']['output']>;
  onChannel: Scalars['Int']['output'];
  productUpdatesOff: Scalars['Boolean']['output'];
  pushed: Scalars['Int']['output'];
  remaining: Scalars['Int']['output'];
};

export type FusionIntegrationProductTemplateRow = {
  active: Scalars['Boolean']['output'];
  externalSku?: Maybe<Scalars['String']['output']>;
  maximumSalesQuantity?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  productCode: Scalars['String']['output'];
  stockBuffer?: Maybe<Scalars['Int']['output']>;
};

export type FusionIntegrationSettingInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type FusionIntegrationSettingOption = {
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type FusionIntegrationSettingSpec = {
  defaultValue?: Maybe<Scalars['String']['output']>;
  helpText?: Maybe<Scalars['String']['output']>;
  inputType: Scalars['String']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  options: Array<FusionIntegrationSettingOption>;
  required: Scalars['Boolean']['output'];
  secret: Scalars['Boolean']['output'];
  visibleWhenKey?: Maybe<Scalars['String']['output']>;
  visibleWhenValue?: Maybe<Scalars['String']['output']>;
};

export type FusionIntegrationSettingValue = {
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type FusionProductMappingImportError = {
  externalSku: Scalars['String']['output'];
  message: Scalars['String']['output'];
  productCode: Scalars['String']['output'];
  rowNumber: Scalars['Int']['output'];
};

export type FusionProductMappingImportResult = {
  created: Scalars['Int']['output'];
  dryRun: Scalars['Boolean']['output'];
  errors: Array<FusionProductMappingImportError>;
  salesLimitsChanged: Scalars['Int']['output'];
  stockBuffersChanged: Scalars['Int']['output'];
  totalRows: Scalars['Int']['output'];
  unchanged: Scalars['Int']['output'];
  updated: Scalars['Int']['output'];
};

export type FusionProductMappingImportRow = {
  externalSku: Scalars['String']['input'];
  maximumSalesQuantity?: InputMaybe<Scalars['String']['input']>;
  productCode: Scalars['String']['input'];
  rowNumber: Scalars['Int']['input'];
  stockBuffer?: InputMaybe<Scalars['String']['input']>;
};

export type FusionRider = {
  active: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  locationId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  vehicle?: Maybe<Scalars['String']['output']>;
};

export type FusionRiderCodBalance = {
  lastSettledAt?: Maybe<Scalars['DateTime']['output']>;
  owedAmount: Scalars['String']['output'];
  repaidTotal: Scalars['String']['output'];
  riderId: Scalars['ID']['output'];
  riderName: Scalars['String']['output'];
  riderPhone: Scalars['String']['output'];
  shortfallTotal: Scalars['String']['output'];
};

export type FusionRiderCodOutstanding = {
  oldestBookedAt?: Maybe<Scalars['DateTime']['output']>;
  oldestDeliveredAt?: Maybe<Scalars['DateTime']['output']>;
  /** COD of parcels still out for delivery */
  outForDeliveryAmount: Scalars['String']['output'];
  outForDeliveryCount: Scalars['Int']['output'];
  outstandingAmount: Scalars['String']['output'];
  /** Shortfalls on earlier handovers not yet repaid */
  owedAmount: Scalars['String']['output'];
  riderId: Scalars['ID']['output'];
  riderName: Scalars['String']['output'];
  riderPhone: Scalars['String']['output'];
  /** Delivered parcels whose cash is with the rider */
  shipmentCount: Scalars['Int']['output'];
};

export type FusionRiderCodParcel = {
  codAmount: Scalars['String']['output'];
  consignmentNumber?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  deliveredAt?: Maybe<Scalars['DateTime']['output']>;
  fulfillmentId?: Maybe<Scalars['String']['output']>;
  fulfillmentOrderId: Scalars['ID']['output'];
  orderNumber?: Maybe<Scalars['Int']['output']>;
  shipmentId: Scalars['ID']['output'];
};

export type FusionRiderRepayment = {
  amount: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Still owed after this repayment */
  owedAmount: Scalars['String']['output'];
  repaidAt: Scalars['DateTime']['output'];
  riderId: Scalars['ID']['output'];
};

export type FusionShipment = {
  bookedAt?: Maybe<Scalars['DateTime']['output']>;
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  capabilities: Array<Scalars['String']['output']>;
  carrierCode: Scalars['String']['output'];
  connectionId: Scalars['ID']['output'];
  consignmentUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  direction: Scalars['String']['output'];
  fulfillmentOrderId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  needsAttention: Scalars['Boolean']['output'];
  quarkSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
  trackingNumber?: Maybe<Scalars['String']['output']>;
};

export enum Gender {
  Female = 'FEMALE',
  Male = 'MALE',
  Other = 'OTHER'
}

export enum GenderType {
  Female = 'FEMALE',
  Male = 'MALE',
  Prefernottosay = 'PREFERNOTTOSAY'
}

export type GeneralLedgerReportResponse = {
  currency: Scalars['String']['output'];
  endDate: Scalars['DateTime']['output'];
  rows: Array<FinanceReportRow>;
  startDate: Scalars['DateTime']['output'];
  totalBalance: Scalars['String']['output'];
  totalCredit: Scalars['String']['output'];
  totalDebit: Scalars['String']['output'];
};

export type GenerateDepositControlInput = {
  businessDate: Scalars['String']['input'];
  entityId: Scalars['ID']['input'];
  locationId: Scalars['ID']['input'];
};

export type GenericFormula = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  secondaryId?: Maybe<Scalars['Float']['output']>;
  status: Scalars['String']['output'];
};

export type GenericFormulaResponseDto = {
  data: Array<GenericFormula>;
  meta: MetaResponse;
};

export type GlobalUser = {
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  gender?: Maybe<GenderType>;
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  memberships?: Maybe<Array<TenantMember>>;
  mustChangePassword: Scalars['Boolean']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  platformRole: PlatformRole;
  status: User_Status;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type Grn = {
  advanceIncomeTax?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdByName?: Maybe<Scalars['String']['output']>;
  designation?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  grnItems: Array<GrnItems>;
  id: Scalars['String']['output'];
  invoiceDate?: Maybe<Scalars['String']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Scalars['Int']['output']>;
  poId?: Maybe<Scalars['String']['output']>;
  purchaseOrder?: Maybe<PurchaseOrder>;
  receivedQuantity?: Maybe<Scalars['Float']['output']>;
  rejectComment?: Maybe<Scalars['String']['output']>;
  secondaryId?: Maybe<Scalars['Float']['output']>;
  status: GrnStatusApproval;
  stockArrivalDate?: Maybe<Scalars['String']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type GrnItem = {
  batchExpiry?: InputMaybe<Scalars['String']['input']>;
  batchNumber?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  discValue: Scalars['Float']['input'];
  gstValue: Scalars['Float']['input'];
  manufacturerCode?: InputMaybe<Scalars['String']['input']>;
  mfgDate?: InputMaybe<Scalars['String']['input']>;
  mrp?: InputMaybe<Scalars['Float']['input']>;
  poItemId: Scalars['String']['input'];
  receivedQuantity: Scalars['Int']['input'];
  serialNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  tradePrice?: InputMaybe<Scalars['Float']['input']>;
};

export type GrnItemResponseDto = {
  data: Array<GrnItems>;
  meta: MetaResponse;
};

export enum GrnItemStatusApproval {
  Completed = 'COMPLETED',
  Qc = 'QC',
  Received = 'RECEIVED',
  Rejected = 'REJECTED'
}

export type GrnItems = {
  actionId?: Maybe<Scalars['String']['output']>;
  batchExpiry?: Maybe<Scalars['String']['output']>;
  batchNumber?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  discValue?: Maybe<Scalars['Float']['output']>;
  foc?: Maybe<Scalars['Boolean']['output']>;
  grn?: Maybe<Grn>;
  grnId?: Maybe<Scalars['String']['output']>;
  gstValue?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isManufacturerTracking?: Maybe<Scalars['Boolean']['output']>;
  manufacturerCode?: Maybe<Scalars['String']['output']>;
  mfgDate?: Maybe<Scalars['String']['output']>;
  mrp?: Maybe<Scalars['Float']['output']>;
  poId?: Maybe<Scalars['String']['output']>;
  purchaseOrderItem?: Maybe<PurchaseOrderItem>;
  purchaseOrderItemId?: Maybe<Scalars['String']['output']>;
  receivedQuantity?: Maybe<Scalars['Float']['output']>;
  rejectComment?: Maybe<Scalars['String']['output']>;
  requiredQuantity?: Maybe<Scalars['Float']['output']>;
  secondaryId?: Maybe<Scalars['Float']['output']>;
  serialNumbers?: Maybe<Array<Scalars['String']['output']>>;
  status: GrnItemStatusApproval;
  trackingLevel?: Maybe<TrackingLevel>;
  tradePrice?: Maybe<Scalars['Float']['output']>;
  uomFactor?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type GrnResponseDto = {
  data: Array<Grn>;
  meta: MetaResponse;
};

export enum GrnStatusApproval {
  Accepted = 'ACCEPTED',
  Fulfilled = 'FULFILLED',
  Open = 'OPEN',
  Partial = 'PARTIAL',
  Rejected = 'REJECTED'
}

export type GrnSummaryDto = {
  accepted: Scalars['Int']['output'];
  grn: Scalars['Int']['output'];
  partial: Scalars['Int']['output'];
  rejected: Scalars['Int']['output'];
};

export enum HoldEntityType {
  FulfillmentOrder = 'FULFILLMENT_ORDER',
  Order = 'ORDER'
}

export type HoldPosOrderInput = {
  locationId?: InputMaybe<Scalars['String']['input']>;
  registerId?: InputMaybe<Scalars['String']['input']>;
  registerSessionId?: InputMaybe<Scalars['String']['input']>;
  snapshot: Scalars['JSON']['input'];
};

export enum HoldReason {
  AddressIssue = 'ADDRESS_ISSUE',
  CustomerRequest = 'CUSTOMER_REQUEST',
  Other = 'OTHER',
  PaymentReview = 'PAYMENT_REVIEW',
  RiskReview = 'RISK_REVIEW',
  StockIssue = 'STOCK_ISSUE'
}

export enum HoldStatus {
  Active = 'ACTIVE',
  Released = 'RELEASED'
}

export type ImportFusionIntegrationProductsInput = {
  connectionId: Scalars['String']['input'];
  dryRun?: Scalars['Boolean']['input'];
  rows: Array<FusionProductMappingImportRow>;
};

export type IncomeStatementReportResponse = {
  currency: Scalars['String']['output'];
  endDate: Scalars['DateTime']['output'];
  netIncome: Scalars['String']['output'];
  rows: Array<FinanceReportRow>;
  startDate: Scalars['DateTime']['output'];
  totalExpense: Scalars['String']['output'];
  totalRevenue: Scalars['String']['output'];
};

export type IntegrationConfig = {
  allowedOrderType?: Maybe<Array<AllowedOrderType>>;
  charges?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  integrationId?: Maybe<Scalars['String']['output']>;
  location: Location;
  locationId?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  registerId?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  type: IntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type IntegrationResponseDto = {
  data: Array<IntegrationConfig>;
  meta: MetaResponse;
};

export enum IntegrationType {
  Fbr = 'FBR',
  Srb = 'SRB'
}

export type InviteUserDto = {
  designation?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<GenderType>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  origin: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  roleId?: InputMaybe<Scalars['String']['input']>;
  tokenExpiryInSeconds?: InputMaybe<Scalars['Float']['input']>;
};

export type InvoicePolicyBatchResultDto = {
  errors: Scalars['Int']['output'];
  processed: Scalars['Int']['output'];
};

export enum InvoicePolicyCode {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  PerOrder = 'PER_ORDER',
  Weekly = 'WEEKLY'
}

export type InvoicePolicyConfig = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByName?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  effectiveDate: Scalars['DateTime']['output'];
  effectiveTillDate?: Maybe<Scalars['DateTime']['output']>;
  groupByBusinessDate: Scalars['Boolean']['output'];
  groupByEntity: Scalars['Boolean']['output'];
  groupByLocation: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  invoicePolicyCode: InvoicePolicyCode;
  partnerId?: Maybe<Scalars['String']['output']>;
  partnerName?: Maybe<Scalars['String']['output']>;
  secondaryId: Scalars['Float']['output'];
  status: Status;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedByName?: Maybe<Scalars['String']['output']>;
};

export type InvoicePolicyConfigResponseDto = {
  data: Array<InvoicePolicyConfig>;
  meta: MetaResponse;
};

export enum ItemReleaseChannel {
  App = 'APP',
  Ecom = 'ECOM',
  Pos = 'POS',
  Whatsapp = 'WHATSAPP'
}

export type JournalHeader = {
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  createdByName?: Maybe<Scalars['String']['output']>;
  entity?: Maybe<EntityModel>;
  entityId: Scalars['ID']['output'];
  entryMethod: EntryMethod;
  fiscalPeriod?: Maybe<FiscalPeriod>;
  fiscalPeriodId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  journalDate: Scalars['DateTime']['output'];
  journalNo?: Maybe<Scalars['String']['output']>;
  lines?: Maybe<Array<JournalLine>>;
  postedAt?: Maybe<Scalars['DateTime']['output']>;
  postedBy?: Maybe<Scalars['String']['output']>;
  postedByName?: Maybe<Scalars['String']['output']>;
  reversalRef?: Maybe<JournalHeader>;
  reversalRefId?: Maybe<Scalars['ID']['output']>;
  secondaryId?: Maybe<Scalars['Float']['output']>;
  sourceDocId?: Maybe<Scalars['ID']['output']>;
  sourceDocType?: Maybe<SourceDocType>;
  sourceModule?: Maybe<SourceModuleEntity>;
  sourceModuleId: Scalars['ID']['output'];
  status: JournalStatus;
  totalCredit?: Maybe<Scalars['Float']['output']>;
  totalDebit?: Maybe<Scalars['Float']['output']>;
};

export type JournalHeaderResponse = {
  data: Array<JournalHeader>;
  meta: MetaResponse;
};

export type JournalLine = {
  account?: Maybe<ChartOfAccounts>;
  accountId: Scalars['ID']['output'];
  costCenter?: Maybe<CostCenter>;
  costCenterId?: Maybe<Scalars['ID']['output']>;
  costCenterSource?: Maybe<CenterSource>;
  credit: Scalars['Float']['output'];
  currencyId?: Maybe<Scalars['ID']['output']>;
  customerId?: Maybe<Scalars['ID']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  debit: Scalars['Float']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  journalHeader?: Maybe<JournalHeader>;
  journalHeaderId: Scalars['ID']['output'];
  locationId?: Maybe<Scalars['ID']['output']>;
  locationName?: Maybe<Scalars['String']['output']>;
  partnerId?: Maybe<Scalars['ID']['output']>;
  partnerName?: Maybe<Scalars['String']['output']>;
  profitCenter?: Maybe<ProfitCenter>;
  profitCenterId?: Maybe<Scalars['ID']['output']>;
  profitCenterSource?: Maybe<CenterSource>;
  project?: Maybe<ProjectMaster>;
  projectId?: Maybe<Scalars['ID']['output']>;
  refId?: Maybe<Scalars['String']['output']>;
  vendorId?: Maybe<Scalars['ID']['output']>;
  vendorName?: Maybe<Scalars['String']['output']>;
};

export type JournalLineResponse = {
  data: Array<JournalLine>;
  meta: MetaResponse;
};

export enum JournalStatus {
  Draft = 'DRAFT',
  Posted = 'POSTED',
  Reversed = 'REVERSED'
}

export type KeyValue = {
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type LinkExternalObjectsInput = {
  accountId: Scalars['String']['input'];
  connectionId: Scalars['String']['input'];
  externalObjectType: Scalars['String']['input'];
  links: Array<ExternalObjectLinkInput>;
  oneObjectType: Scalars['String']['input'];
};

export type ListFusionShipmentsInput = {
  fulfillmentOrderIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  needsAttentionOnly?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Location = {
  area?: Maybe<Scalars['String']['output']>;
  city?: Maybe<City>;
  cityId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dailyOrderCapacity?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  orderCutoffTime?: Maybe<Scalars['String']['output']>;
  requireQcOverride?: Maybe<Scalars['Boolean']['output']>;
  salesTaxNumber?: Maybe<Scalars['String']['output']>;
  secondaryId?: Maybe<Scalars['Float']['output']>;
  status: Scalars['String']['output'];
  storeFulfillmentMode?: Maybe<StoreFulfillmentMode>;
  taxNumber?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  type: LocationType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  warehouse?: Maybe<Location>;
  warehouseId?: Maybe<Scalars['String']['output']>;
};

export type LocationDto = {
  area?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  salesTaxNumber?: InputMaybe<Scalars['String']['input']>;
  status: Status;
  taxNumber?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  type: LocationType;
  warehouse_id?: InputMaybe<Scalars['String']['input']>;
};

export type LocationDtoResponse = {
  countryId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type LocationRegister = {
  assignedUserId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<CurrencyTypeEnum>;
  id: Scalars['String']['output'];
  lastClosedAt?: Maybe<Scalars['DateTime']['output']>;
  lastClosedBy?: Maybe<User>;
  lastClosedByUserId?: Maybe<Scalars['String']['output']>;
  lastOpenedAt?: Maybe<Scalars['DateTime']['output']>;
  lastOpenedBy?: Maybe<User>;
  lastOpenedByUserId?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Location>;
  name: Scalars['String']['output'];
  order?: Maybe<Order>;
  printMode?: Maybe<PrintModeType>;
  receiptTemplate?: Maybe<ReceiptTemplateType>;
  secondaryId?: Maybe<Scalars['Float']['output']>;
  session?: Maybe<LocationRegisterSession>;
  status?: Maybe<Scalars['String']['output']>;
  terminalTaxId?: Maybe<Scalars['String']['output']>;
  type: LocationRegisterType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LocationRegisterSession = {
  balance?: Maybe<Scalars['Float']['output']>;
  balanceHistory?: Maybe<LocationRegisterSessionBalance>;
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  closedBy?: Maybe<User>;
  closedByUserId?: Maybe<Scalars['String']['output']>;
  closingAmount?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  isAmountMatched?: Maybe<Scalars['Boolean']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  openedAt?: Maybe<Scalars['DateTime']['output']>;
  openedBy?: Maybe<User>;
  openedByUserId?: Maybe<Scalars['String']['output']>;
  openingAmount?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Order>;
  register?: Maybe<LocationRegister>;
  registerId?: Maybe<Scalars['String']['output']>;
  secondaryId?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LocationRegisterSessionBalance = {
  amount?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
};

export type LocationRegisterSessionBalance_ = {
  data: Array<LocationRegisterSessionBalance>;
  meta: MetaResponse;
};

export type LocationRegisterSession_ = {
  data: Array<LocationRegisterSession>;
  meta: MetaResponse;
};

export enum LocationRegisterType {
  CartRegister = 'CART_REGISTER',
  SalesRegister = 'SALES_REGISTER'
}

export type LocationResponseDto = {
  data: Array<Location>;
  meta: MetaResponse;
};

export type LocationSalesDto = {
  avgOrderValue: Scalars['Float']['output'];
  locationId: Scalars['String']['output'];
  locationName: Scalars['String']['output'];
  orderCount: Scalars['Float']['output'];
  totalSales: Scalars['Float']['output'];
};

export enum LocationType {
  Plant = 'PLANT',
  Retail = 'RETAIL',
  Warehouse = 'WAREHOUSE'
}

export type LoggedInUserDto = {
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  role: RoleDto;
};

export enum LogicalOperator {
  And = 'AND',
  Or = 'OR'
}

export type LoginUserDto = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type LostSale = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  currentInventory?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Location>;
  locationId?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  product?: Maybe<Product>;
  productId?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  secondaryId?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type: LostSaleType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type LostSaleResponseDto = {
  data: Array<LostSale>;
  meta: MetaResponse;
};

export enum LostSaleType {
  Catalog = 'CATALOG',
  Custom = 'CUSTOM'
}

export enum LotAssignmentStrategy {
  Fefo = 'FEFO',
  Fifo = 'FIFO',
  Manual = 'MANUAL'
}

export enum LotOverrideReason {
  Damaged = 'DAMAGED',
  Expired = 'EXPIRED',
  NotFound = 'NOT_FOUND',
  Other = 'OTHER'
}

export type MaintenanceStatus = {
  enabled: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  scheduledEndAt?: Maybe<Scalars['String']['output']>;
  scheduledStartAt?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedByEmail?: Maybe<Scalars['String']['output']>;
};

export type Manufacturer = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastReason?: Maybe<Scalars['String']['output']>;
  lineOfBusiness?: Maybe<Array<Scalars['String']['output']>>;
  name?: Maybe<Scalars['String']['output']>;
  secondaryId?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ManufacturerResponseDto = {
  data: Array<Manufacturer>;
  meta: MetaResponse;
};

export type MarkDeliveredInput = {
  deliveredAt?: InputMaybe<Scalars['DateTime']['input']>;
  fulfillmentOrderIds: Array<Scalars['ID']['input']>;
  items?: InputMaybe<Array<MarkDeliveredItemInput>>;
};

export type MarkDeliveredItemInput = {
  deliveredAt: Scalars['DateTime']['input'];
  fulfillmentOrderId: Scalars['ID']['input'];
};

export type MarkDeliveryFailedInput = {
  /** The courier's final return-to-origin date. Defaults to now. */
  failedAt?: InputMaybe<Scalars['DateTime']['input']>;
  fulfillmentOrderId: Scalars['ID']['input'];
  idempotencyKey: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};

export type MarkDispatchedInput = {
  fulfillmentOrderIds: Array<Scalars['ID']['input']>;
};

export type MaterialLotInput = {
  productLotId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

export type MediaAsset = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  fileSize?: Maybe<Scalars['Int']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  mimeType?: Maybe<Scalars['String']['output']>;
  storageKey?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
  width?: Maybe<Scalars['Int']['output']>;
};

export type MediaAssetResponseDto = {
  data: Array<MediaAsset>;
  meta: MetaResponse;
};

export type MetaResponse = {
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type Mutation = {
  acceptFulfillmentOrderOnRegister: FulfillmentOrder;
  acceptInvite: Scalars['Boolean']['output'];
  activateBomVersion: BomVersion;
  activateUser: Scalars['Boolean']['output'];
  addDashboardWidget: DashboardWidget;
  addFusionIntegrationProducts: Array<FusionIntegrationProduct>;
  addOrRemovePermissionsByRoleId: Scalars['Boolean']['output'];
  addProductionLine: ProductionLine;
  addStockOperationItems: Scalars['Boolean']['output'];
  addWithdrawRegisterBalance: LocationRegisterSession;
  adminActivateTenant: Tenant;
  adminChangePassword: Scalars['Boolean']['output'];
  adminClearTenantCache: Scalars['Boolean']['output'];
  adminCreatePlatformPermission: PlatformPermission;
  adminCreatePool: TenantPool;
  adminCreateTenant: Tenant;
  adminCreateUser: GlobalUser;
  adminDeactivatePool: TenantPool;
  adminDeactivateTenant: Tenant;
  adminDeletePlatformPermission: Scalars['Boolean']['output'];
  adminDemoteFromAdmin: GlobalUser;
  adminForceLogoutTenant: Scalars['Int']['output'];
  adminInviteToTenant: TenantMember;
  adminLogin: AdminLoginResponse;
  adminMigrateToDedicated: AdminMigrationCompleteResponse;
  adminMigrateToShared: AdminMigrationCompleteResponse;
  adminPromoteToAdmin: GlobalUser;
  adminRemoveFromTenant: Scalars['Boolean']['output'];
  adminSetMaintenance: MaintenanceStatus;
  adminSyncAllPermissions: SyncResult;
  adminUpdatePool: TenantPool;
  adminUpdateTenant: Tenant;
  approveBomVersion: BomVersion;
  approveProductionOrderQcBatches: ProductionOrder;
  approveProductionOrderQcBatchesSerial: ProductionOrder;
  approveProductionPlan: ProductionPlan;
  archiveBomVersion: BomVersion;
  assignFulfillmentOrderLines: FulfillmentOrder;
  assignPosRegister: Scalars['Boolean']['output'];
  bookFusionReturnShipment: FusionShipment;
  bookFusionShipment: FusionShipment;
  bulkUploadProducts: BulkUploadProductResponse;
  cancelAccountPayableWriteoff?: Maybe<AccountPayableWriteoff>;
  cancelAccountReceivableWriteoff?: Maybe<AccountReceivableWriteoff>;
  cancelCashDeposit: CashDeposit;
  cancelFulfillmentOrder: FulfillmentOrder;
  cancelFusionShipment: FusionShipment;
  cancelInvite: Scalars['Boolean']['output'];
  cancelOrder: CancelOrderResult;
  cancelProductionOrder: ProductionOrder;
  cancelProductionPlan: ProductionPlan;
  cloneReport: ReportDefinition;
  closeAllLocationsRegisters: LocationRegister;
  closeAudit: Scalars['Boolean']['output'];
  closeDemandNote: DemandNote;
  closeFiscalPeriod: FiscalPeriod;
  closeLocationRegister: LocationRegisterSession;
  closePurchaseOrder: PurchaseOrder;
  completeAudit: Scalars['Boolean']['output'];
  completePickerTask: FulfillmentPickerTask;
  completeProductAudit: Scalars['Boolean']['output'];
  completeRegisterFulfillment: FulfillmentOrder;
  confirmAudit: Scalars['Boolean']['output'];
  confirmOrder: Scalars['Boolean']['output'];
  confirmStockOperation: Scalars['Boolean']['output'];
  connectFusionIntegration: FusionIntegration;
  createAccountBankTransaction: AccountBankTransaction;
  createAccountPayableInvoice: AccountPayableInvoice;
  createAccountPayablePayment: AccountPayablePayment;
  createAccountPayableWriteoff: AccountPayableWriteoff;
  createAccountReceivableInvoice: AccountReceivableInvoice;
  createAccountReceivableReceipt: AccountReceivableReceipt;
  createAccountReceivableWriteoff: AccountReceivableWriteoff;
  createAccountSubtype: AccountSubtype;
  createAddress: Address;
  createAdjustment: Scalars['Boolean']['output'];
  createApSettlementLine: ApSettlementLine;
  createArSettlementLine: ArSettlementLine;
  createAudit: Audit;
  createAutomationFlow: AutomationFlow;
  createBankAccount: BankAccount;
  createBom: Bom;
  createBomVersion: BomVersion;
  createBomVersionLineItem: BomVersionLineItem;
  createCalculatedColumn: CalculatedColumn;
  createCashAccount: CashAccount;
  createCashDepositDraft: CashDeposit;
  createCategory: Category;
  createChartOfAccount: ChartOfAccounts;
  createCity: City;
  createCostCenter: CostCenter;
  createCountry: Country;
  createCustomer: Customer;
  createDashboard: Dashboard;
  createDemandNote: DemandNote;
  createDiscount: Discount;
  createEntity: EntityModel;
  createExportJob: ExportJob;
  createFiscalPeriod: FiscalPeriod;
  createFiscalYear: FiscalYear;
  createFulfillmentOrder: Array<FulfillmentOrder>;
  createFusionCarrierCostCentre: Scalars['Boolean']['output'];
  createFusionConnection: FusionConnection;
  createFusionRider: FusionRider;
  createGenericFormula: GenericFormula;
  createGrn: Scalars['Boolean']['output'];
  createIntegration: IntegrationConfig;
  createInvoicePolicyConfig: InvoicePolicyConfig;
  createJournalHeader: JournalHeader;
  createJournalLine: JournalLine;
  createLocation: Location;
  createLocationRegister: LocationRegister;
  createLostSale: LostSale;
  createManufacturer: Manufacturer;
  createOrder: Order;
  createPartner: Partner;
  createPartnerFinancialTerms: PartnerFinancialTerms;
  createPaymentTerms: PaymentTerms;
  createPlatformFeeConfig: PlatformFeeConfig;
  createPrinterConfig: PrinterConfig;
  createProduct: Product;
  createProductLot: ProductLot;
  createProductManufacturingPrice: ProductManufacturingPrice;
  createProductionOrder: ProductionOrder;
  createProductionPlan: ProductionPlan;
  createProfitCenter: ProfitCenter;
  createPurchaseOrder: PurchaseOrder;
  createReport: ReportDefinition;
  createRole: Role;
  createSourceModule: SourceModuleEntity;
  createSqlReport: ReportDefinition;
  createStockOperation: StockOperation;
  createStockReturn: Return;
  createTag: Tag;
  createTaxGroup: TaxGroup;
  createTenant: Tenant;
  createTransfer: Transfer;
  createVendor: Vendor;
  deactivateUser: Scalars['Boolean']['output'];
  deleteAccountBankTransaction: Scalars['Boolean']['output'];
  deleteAccountPayableInvoice: Scalars['Boolean']['output'];
  deleteAccountPayableInvoiceLine: Scalars['Boolean']['output'];
  deleteAccountPayablePayment: Scalars['Boolean']['output'];
  deleteAccountReceivableInvoice: Scalars['Boolean']['output'];
  deleteAccountReceivableInvoiceLine: Scalars['Boolean']['output'];
  deleteAccountReceivableReceipt: Scalars['Boolean']['output'];
  deleteAccountSubtype: Scalars['Boolean']['output'];
  deleteApSettlementLine: Scalars['Boolean']['output'];
  deleteArSettlementLine: Scalars['Boolean']['output'];
  deleteAutomationFlow: Scalars['Boolean']['output'];
  deleteBankAccount: Scalars['Boolean']['output'];
  deleteBomVersionLineItem: Scalars['Boolean']['output'];
  deleteCalculatedColumn: Scalars['Boolean']['output'];
  deleteCashAccount: Scalars['Boolean']['output'];
  deleteChartOfAccount: Scalars['Boolean']['output'];
  deleteCostCenter: Scalars['Boolean']['output'];
  deleteDashboard: Scalars['Boolean']['output'];
  deleteEntity: Scalars['Boolean']['output'];
  deleteFiscalPeriod: Scalars['Boolean']['output'];
  deleteFiscalYear: Scalars['Boolean']['output'];
  deleteMediaAsset: Scalars['Boolean']['output'];
  deletePaymentTerms: Scalars['Boolean']['output'];
  deletePermission: Scalars['Boolean']['output'];
  deletePrinterConfig: Scalars['Boolean']['output'];
  deleteProfitCenter: Scalars['Boolean']['output'];
  deleteReport: Scalars['Boolean']['output'];
  deleteRole: Scalars['Boolean']['output'];
  deleteSourceModule: Scalars['Boolean']['output'];
  duplicateDashboardTab: Array<DashboardWidget>;
  editOrder: Scalars['Boolean']['output'];
  flushTenantCache: Scalars['Boolean']['output'];
  forgotPassword: Scalars['Boolean']['output'];
  generateDepositControl: Array<CashDepositControl>;
  grantAccess: AccessGrant;
  holdPosOrder: PosHeldOrder;
  importFusionIntegrationProducts: FusionProductMappingImportResult;
  inviteUser: User;
  linkFusionExternalObjects: Array<FusionExternalObjectMapping>;
  loginUser: AuthResponseDto;
  markAllNotificationsRead: Scalars['Boolean']['output'];
  markDelivered: Array<FulfillmentOrder>;
  markDeliveryFailed: FulfillmentOrder;
  markDispatched: Array<FulfillmentOrder>;
  markNotificationRead: Scalars['Boolean']['output'];
  openFiscalPeriod: FiscalPeriod;
  openLocationRegister: LocationRegisterSession;
  placeHold: FulfillmentHold;
  postAccountPayableWriteoff?: Maybe<AccountPayableWriteoff>;
  postAccountReceivableWriteoff?: Maybe<AccountReceivableWriteoff>;
  postCashDeposit: CashDeposit;
  postJournalHeader?: Maybe<JournalHeader>;
  processFulfillment: Scalars['Boolean']['output'];
  processOrder: Scalars['Boolean']['output'];
  processShipping: Scalars['Boolean']['output'];
  publishDashboard: Dashboard;
  publishReport: ReportDefinition;
  pushFusionIntegrationProduct: FusionIntegrationProduct;
  readyToDispatch: FulfillmentOrder;
  receiveAllTransferItems: Scalars['Boolean']['output'];
  receiveReturnedParcel: CancelOrderResult;
  receiveTransferItems: Scalars['Boolean']['output'];
  refreshReportPersistence: ReportPersistence;
  rejectBomVersion: BomVersion;
  rejectLot: RejectLotResult;
  releaseHold: FulfillmentHold;
  releasePosOrder: ReleasePosOrderPayload;
  removeDashboardWidget: Scalars['Boolean']['output'];
  removeFusionCarrierLocationMapping: Scalars['Boolean']['output'];
  removeFusionConnection: Scalars['Boolean']['output'];
  removeFusionConnectorTenantOverride: Scalars['Boolean']['output'];
  removeFusionIntegrationLocation: Scalars['Boolean']['output'];
  removeFusionIntegrationProduct: Scalars['Boolean']['output'];
  removeProductionLine: Scalars['Boolean']['output'];
  removeProductionOrderMaterialLot: ProductionOrderMaterial;
  removeStockOperationItem: Scalars['Boolean']['output'];
  repayFusionRider: FusionRiderRepayment;
  requestProductionPlanIssuance: ProductionPlan;
  resendInvite: Scalars['Boolean']['output'];
  resetPassword: Scalars['Boolean']['output'];
  retireSystemReportTemplate: Scalars['Boolean']['output'];
  retryFusionShipmentQuarkSync: FusionShipment;
  returnOrder: ReturnOrder;
  returnOrder1: Scalars['Boolean']['output'];
  revokeAccess: Scalars['Boolean']['output'];
  scanAuditLot: Scalars['Boolean']['output'];
  scanPickerTaskUnit: FulfillmentPickerTask;
  setFlowEnabled: AutomationFlow;
  setFusionCarrierLocationMapping: FusionCarrierLocationMapping;
  setFusionConnectorPlatformDefault: ConnectorEntitlement;
  setFusionConnectorTenantOverride: ConnectorEntitlement;
  setFusionIntegrationEvent: FusionIntegrationEventSubscription;
  setFusionIntegrationLocation: FusionIntegrationLocation;
  setFusionIntegrationProduct: FusionIntegrationProduct;
  setFusionIntegrationProductStockBuffer: FusionIntegrationProduct;
  setFusionRiderActive: FusionRider;
  setReportCacheTtl: ReportDefinition;
  setReportPersistence: ReportPersistence;
  setReportSavedDataset: ReportDefinition;
  settleFusionRiderCod: FusionCodSettlement;
  startAudit: Scalars['Boolean']['output'];
  startFusionIntegrationAuthorization: FusionIntegrationAuthorization;
  startPickerTask: FulfillmentPickerTask;
  submitBomVersionForApproval: BomVersion;
  submitProductionOrderToQc: ProductionOrder;
  submitProductionPlanForApproval: ProductionPlan;
  swapReservedLot: Scalars['Boolean']['output'];
  syncFusionCatalog: Array<FusionCatalogSyncResult>;
  syncFusionIntegrationCatalog: Array<FusionCatalogSyncResult>;
  syncFusionIntegrationProducts: FusionIntegrationProductSync;
  syncSystemReportTemplates: Array<SystemReportSyncResult>;
  testFlow: FlowRun;
  togglePaymentTermsStatus: PaymentTerms;
  transitionFulfillmentOrderStatus: FulfillmentOrder;
  triggerInvoicePolicyBatch: InvoicePolicyBatchResultDto;
  unassignFulfillmentOrderLines: FulfillmentOrder;
  unlinkFusionExternalObject: Scalars['Boolean']['output'];
  unlistFusionIntegrationProduct: Scalars['Boolean']['output'];
  unpackFulfillmentOrder: FulfillmentOrder;
  updateAccountBankTransaction?: Maybe<AccountBankTransaction>;
  updateAccountPayableInvoice?: Maybe<AccountPayableInvoice>;
  updateAccountPayablePayment?: Maybe<AccountPayablePayment>;
  updateAccountPayableWriteoff?: Maybe<AccountPayableWriteoff>;
  updateAccountReceivableInvoice?: Maybe<AccountReceivableInvoice>;
  updateAccountReceivableReceipt?: Maybe<AccountReceivableReceipt>;
  updateAccountReceivableWriteoff?: Maybe<AccountReceivableWriteoff>;
  updateAccountSubtype?: Maybe<AccountSubtype>;
  updateAddress: Address;
  updateAdjustmentStatus: Scalars['Boolean']['output'];
  updateApSettlementLine?: Maybe<ApSettlementLine>;
  updateArSettlementLine?: Maybe<ArSettlementLine>;
  updateAutomationFlow: AutomationFlow;
  updateBankAccount?: Maybe<BankAccount>;
  updateBom: Bom;
  updateBomStatus: Bom;
  updateBomVersion: BomVersion;
  updateBomVersionLineItem: BomVersionLineItem;
  updateCalculatedColumn: CalculatedColumn;
  updateCancellationFbrInvoiceId: Scalars['Boolean']['output'];
  updateCashAccount?: Maybe<CashAccount>;
  updateCategory: Category;
  updateChartOfAccount?: Maybe<ChartOfAccounts>;
  updateCostCenter?: Maybe<CostCenter>;
  updateCustomer: Customer;
  updateDashboard: Dashboard;
  updateDashboardWidget: DashboardWidget;
  updateDemandNoteFulfillmentStatus: DemandNote;
  updateDiscount: Discount;
  updateEntity?: Maybe<EntityModel>;
  updateFbrInvoiceId: Scalars['Boolean']['output'];
  updateFiscalPeriod?: Maybe<FiscalPeriod>;
  updateFiscalYear?: Maybe<FiscalYear>;
  updateFusionConnection: FusionConnection;
  updateFusionIntegration: FusionIntegration;
  updateFusionIntegrationProduct: FusionIntegrationProduct;
  updateGenericFormula: GenericFormula;
  updateGrnItemSerialNumbers: Scalars['Boolean']['output'];
  updateGrnQCStatus: Scalars['Boolean']['output'];
  updateGrnReceivedStatus: Scalars['Boolean']['output'];
  updateIntegration: IntegrationConfig;
  updateInvoicePolicyConfig: InvoicePolicyConfig;
  updateJournalHeader?: Maybe<JournalHeader>;
  updateJournalLine?: Maybe<JournalLine>;
  updateLocation: Location;
  updateLocationRegister: LocationRegister;
  updateManufacturer: Manufacturer;
  updatePartner: Partner;
  updatePartnerFinancialTerms: PartnerFinancialTerms;
  updatePaymentStatus: Scalars['Boolean']['output'];
  updatePaymentTerms?: Maybe<PaymentTerms>;
  updatePermission: Scalars['Boolean']['output'];
  updatePlatformFeeConfig: PlatformFeeConfig;
  updatePrinterConfig: PrinterConfig;
  updateProduct: Product;
  updateProductLot: ProductLot;
  updateProductManufacturingPrice: ProductManufacturingPrice;
  updateProductionLine: ProductionLine;
  updateProductionOrder: ProductionOrder;
  updateProductionOrderBatch: ProductionOrderBatch;
  updateProductionOrderMaterial: ProductionOrderMaterial;
  updateProductionPlan: ProductionPlan;
  updateProfitCenter?: Maybe<ProfitCenter>;
  updateReport: ReportDefinition;
  updateReturnFbrInvoiceId: Scalars['Boolean']['output'];
  updateRole: Scalars['Boolean']['output'];
  updateSourceModule?: Maybe<SourceModuleEntity>;
  updateSqlReport: ReportDefinition;
  updateStockOperation: StockOperation;
  updateStockOperationItem: Scalars['Boolean']['output'];
  updateTag: Tag;
  updateTaxGroup: TaxGroup;
  updateTenant: Tenant;
  updateTenantFulfillmentConfig: TenantFulfillmentConfig;
  updateUser: Scalars['Boolean']['output'];
  updateVendor: Vendor;
  uploadMediaImage: MediaAsset;
  uploadStockOperationItemImport: StockOperationImportJob;
  upsertCashDepositConfig: CashDepositConfig;
  upsertSystemReportTemplate: Scalars['Boolean']['output'];
  validateEmailToken: Scalars['Boolean']['output'];
  validateInviteToken: Scalars['Boolean']['output'];
  voidShipmentBooking: FulfillmentOrder;
};


export type MutationAcceptFulfillmentOrderOnRegisterArgs = {
  fulfillmentOrderId: Scalars['ID']['input'];
  registerId: Scalars['ID']['input'];
};


export type MutationAcceptInviteArgs = {
  acceptInviteDTO: AcceptInviteDto;
};


export type MutationActivateBomVersionArgs = {
  effectiveFrom?: InputMaybe<Scalars['Date']['input']>;
  effectiveTo?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['String']['input'];
};


export type MutationActivateUserArgs = {
  id: Scalars['String']['input'];
};


export type MutationAddDashboardWidgetArgs = {
  dashboardId: Scalars['String']['input'];
  reportId: Scalars['String']['input'];
  span?: InputMaybe<Scalars['Int']['input']>;
  tab?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddFusionIntegrationProductsArgs = {
  input: AddFusionIntegrationProductsInput;
};


export type MutationAddOrRemovePermissionsByRoleIdArgs = {
  permissionIds: Array<Scalars['String']['input']>;
  roleId: Scalars['String']['input'];
};


export type MutationAddProductionLineArgs = {
  addProductionLineDTO: AddProductionLineDto;
};


export type MutationAddStockOperationItemsArgs = {
  AddStockOperationItemsDTO: Array<AddStockOperationItemDto>;
};


export type MutationAddWithdrawRegisterBalanceArgs = {
  registerBalanceDTO: AddWithdrawBalanceLocationRegisterSession;
  registerSessionId: Scalars['String']['input'];
};


export type MutationAdminActivateTenantArgs = {
  id: Scalars['String']['input'];
};


export type MutationAdminChangePasswordArgs = {
  input: AdminChangePasswordInput;
};


export type MutationAdminClearTenantCacheArgs = {
  id: Scalars['String']['input'];
};


export type MutationAdminCreatePlatformPermissionArgs = {
  action: Scalars['String']['input'];
  module: Scalars['String']['input'];
  subModule: Scalars['String']['input'];
};


export type MutationAdminCreatePoolArgs = {
  input: AdminCreatePoolInput;
};


export type MutationAdminCreateTenantArgs = {
  input: AdminCreateTenantInput;
};


export type MutationAdminCreateUserArgs = {
  input: AdminCreateUserInput;
};


export type MutationAdminDeactivatePoolArgs = {
  id: Scalars['String']['input'];
};


export type MutationAdminDeactivateTenantArgs = {
  id: Scalars['String']['input'];
};


export type MutationAdminDeletePlatformPermissionArgs = {
  id: Scalars['String']['input'];
};


export type MutationAdminDemoteFromAdminArgs = {
  id: Scalars['String']['input'];
};


export type MutationAdminForceLogoutTenantArgs = {
  id: Scalars['String']['input'];
};


export type MutationAdminInviteToTenantArgs = {
  input: AdminInviteToTenantInput;
};


export type MutationAdminLoginArgs = {
  input: AdminLoginInput;
};


export type MutationAdminMigrateToDedicatedArgs = {
  input: AdminMigrateToDedicatedInput;
};


export type MutationAdminMigrateToSharedArgs = {
  input: AdminMigrateToSharedInput;
};


export type MutationAdminPromoteToAdminArgs = {
  id: Scalars['String']['input'];
};


export type MutationAdminRemoveFromTenantArgs = {
  globalUserId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


export type MutationAdminSetMaintenanceArgs = {
  input: AdminSetMaintenanceInput;
};


export type MutationAdminUpdatePoolArgs = {
  input: AdminUpdatePoolInput;
};


export type MutationAdminUpdateTenantArgs = {
  input: AdminUpdateTenantInput;
};


export type MutationApproveBomVersionArgs = {
  id: Scalars['String']['input'];
};


export type MutationApproveProductionOrderQcBatchesArgs = {
  approveQcBatchDTO: ApproveQcBatchDto;
};


export type MutationApproveProductionOrderQcBatchesSerialArgs = {
  approveQcSerialDTO: ApproveQcSerialDto;
};


export type MutationApproveProductionPlanArgs = {
  id: Scalars['String']['input'];
};


export type MutationArchiveBomVersionArgs = {
  id: Scalars['String']['input'];
};


export type MutationAssignFulfillmentOrderLinesArgs = {
  input: AssignFulfillmentOrderLinesInput;
};


export type MutationAssignPosRegisterArgs = {
  fulfillmentOrderId: Scalars['ID']['input'];
  registerId: Scalars['ID']['input'];
};


export type MutationBookFusionReturnShipmentArgs = {
  returnOrderId: Scalars['String']['input'];
};


export type MutationBookFusionShipmentArgs = {
  input: BookFusionShipmentInput;
};


export type MutationBulkUploadProductsArgs = {
  input: BulkUploadProductDto;
};


export type MutationCancelAccountPayableWriteoffArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCancelAccountReceivableWriteoffArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCancelCashDepositArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCancelFulfillmentOrderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCancelFusionShipmentArgs = {
  reason?: InputMaybe<Scalars['String']['input']>;
  shipmentId: Scalars['String']['input'];
};


export type MutationCancelInviteArgs = {
  id: Scalars['String']['input'];
};


export type MutationCancelOrderArgs = {
  input: CancelOrderInput;
};


export type MutationCancelProductionOrderArgs = {
  cancellationReason: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type MutationCancelProductionPlanArgs = {
  cancellationReason: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type MutationCloneReportArgs = {
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCloseAuditArgs = {
  auditId: Scalars['String']['input'];
  closureReason: Scalars['String']['input'];
};


export type MutationCloseDemandNoteArgs = {
  closureReason: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type MutationCloseFiscalPeriodArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCloseLocationRegisterArgs = {
  closeLocationRegisterSessionDto: CloseLocationRegisterSessionDto;
  registerSessionId: Scalars['String']['input'];
};


export type MutationClosePurchaseOrderArgs = {
  id: Scalars['String']['input'];
};


export type MutationCompleteAuditArgs = {
  auditId: Scalars['String']['input'];
};


export type MutationCompletePickerTaskArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCompleteProductAuditArgs = {
  auditId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};


export type MutationCompleteRegisterFulfillmentArgs = {
  input: CompleteRegisterFulfillmentInput;
};


export type MutationConfirmAuditArgs = {
  auditId: Scalars['String']['input'];
};


export type MutationConfirmOrderArgs = {
  input: ConfirmOnlineOrderDto;
};


export type MutationConfirmStockOperationArgs = {
  stockOperationId: Scalars['String']['input'];
};


export type MutationConnectFusionIntegrationArgs = {
  input: ConnectFusionIntegrationInput;
};


export type MutationCreateAccountBankTransactionArgs = {
  createAccountBankTransaction: CreateAccountBankTransactionInput;
};


export type MutationCreateAccountPayableInvoiceArgs = {
  createAccountPayableInvoice: CreateAccountPayableInvoiceInput;
};


export type MutationCreateAccountPayablePaymentArgs = {
  createAccountPayablePayment: CreateAccountPayablePaymentInput;
};


export type MutationCreateAccountPayableWriteoffArgs = {
  createAccountPayableWriteoff: CreateAccountPayableWriteoffInput;
};


export type MutationCreateAccountReceivableInvoiceArgs = {
  createAccountReceivableInvoice: CreateAccountReceivableInvoiceInput;
};


export type MutationCreateAccountReceivableReceiptArgs = {
  createAccountReceivableReceipt: CreateAccountReceivableReceiptInput;
};


export type MutationCreateAccountReceivableWriteoffArgs = {
  createAccountReceivableWriteoff: CreateAccountReceivableWriteoffInput;
};


export type MutationCreateAccountSubtypeArgs = {
  createAccountSubtype: CreateAccountSubtypeInput;
};


export type MutationCreateAddressArgs = {
  createAddressDTO: CreateAddressDto;
};


export type MutationCreateAdjustmentArgs = {
  createAdjustmentDto: CreateAdjustmentDto;
};


export type MutationCreateApSettlementLineArgs = {
  createApSettlementLine: CreateApSettlementLineInput;
};


export type MutationCreateArSettlementLineArgs = {
  createArSettlementLine: CreateArSettlementLineInput;
};


export type MutationCreateAuditArgs = {
  createAuditDto: CreateAuditDto;
};


export type MutationCreateAutomationFlowArgs = {
  input: CreateAutomationFlowInput;
};


export type MutationCreateBankAccountArgs = {
  createBankAccount: CreateBankAccountInput;
};


export type MutationCreateBomArgs = {
  createBomDTO: CreateBomDto;
};


export type MutationCreateBomVersionArgs = {
  createBomVersionDTO: CreateBomVersionDto;
};


export type MutationCreateBomVersionLineItemArgs = {
  createBomVersionLineItemDTO: CreateBomVersionLineItemDto;
};


export type MutationCreateCalculatedColumnArgs = {
  input: CreateCalculatedColumnInput;
};


export type MutationCreateCashAccountArgs = {
  createCashAccount: CreateCashAccountInput;
};


export type MutationCreateCashDepositDraftArgs = {
  input: CreateCashDepositInput;
};


export type MutationCreateCategoryArgs = {
  createCategoryDTO: CreateCategoryDto;
};


export type MutationCreateChartOfAccountArgs = {
  input: CreateChartOfAccountsInput;
};


export type MutationCreateCityArgs = {
  countryId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationCreateCostCenterArgs = {
  createCostCenter: CreateCostCenterInput;
};


export type MutationCreateCountryArgs = {
  name: Scalars['String']['input'];
};


export type MutationCreateCustomerArgs = {
  createCustomerDTO: CreateCustomerDto;
};


export type MutationCreateDashboardArgs = {
  input: CreateDashboardInput;
};


export type MutationCreateDemandNoteArgs = {
  createDemandNoteDTO: CreateDemandNoteDto;
};


export type MutationCreateDiscountArgs = {
  createDiscountDto: CreateDiscountDto;
};


export type MutationCreateEntityArgs = {
  input: CreateEntityInput;
};


export type MutationCreateExportJobArgs = {
  input: CreateExportJobInput;
};


export type MutationCreateFiscalPeriodArgs = {
  createFiscalPeriod: CreateFiscalPeriodInput;
};


export type MutationCreateFiscalYearArgs = {
  createFiscalYear: CreateFiscalYearInput;
};


export type MutationCreateFulfillmentOrderArgs = {
  input: CreateFulfillmentOrderInput;
};


export type MutationCreateFusionCarrierCostCentreArgs = {
  input: CreateFusionCarrierCostCentreInput;
};


export type MutationCreateFusionConnectionArgs = {
  input: CreateFusionConnectionInput;
};


export type MutationCreateFusionRiderArgs = {
  input: CreateFusionRiderInput;
};


export type MutationCreateGenericFormulaArgs = {
  createGenericFormulaDTO: CreateGenericFormulaDto;
};


export type MutationCreateGrnArgs = {
  CreateGrnDTO: CreateGrnDto;
};


export type MutationCreateIntegrationArgs = {
  createIntegrationDTO: CreateIntegrationConfigDto;
};


export type MutationCreateInvoicePolicyConfigArgs = {
  createInvoicePolicyConfigDTO: CreateInvoicePolicyConfigDto;
};


export type MutationCreateJournalHeaderArgs = {
  input: CreateJournalHeaderInput;
};


export type MutationCreateJournalLineArgs = {
  input: CreateJournalLineInput;
  journalHeaderId: Scalars['ID']['input'];
};


export type MutationCreateLocationArgs = {
  LocationDTO: LocationDto;
};


export type MutationCreateLocationRegisterArgs = {
  createLocationRegisterDTO: CreateLocationRegisterDto;
};


export type MutationCreateLostSaleArgs = {
  CreateLostSaleDto: CreateLostSaleDto;
};


export type MutationCreateManufacturerArgs = {
  CreateManufacturerDTO: CreateManufacturerDto;
};


export type MutationCreateOrderArgs = {
  CreateOrderDTO: CreateOrderDto;
};


export type MutationCreatePartnerArgs = {
  createPartnerDTO: CreatePartnerDto;
};


export type MutationCreatePartnerFinancialTermsArgs = {
  createFinancialTermsDTO: CreateFinancialTermsDto;
};


export type MutationCreatePaymentTermsArgs = {
  createPaymentTerms: CreatePaymentTermsInput;
};


export type MutationCreatePlatformFeeConfigArgs = {
  createPlatformFeeConfigInput: CreatePlatformFeeConfigDto;
};


export type MutationCreatePrinterConfigArgs = {
  createPrinterConfigDTO: CreatePrinterConfigDto;
};


export type MutationCreateProductArgs = {
  createProductDTO: CreateProductDto;
};


export type MutationCreateProductLotArgs = {
  createProductLotDTO: CreateProductLotDto;
};


export type MutationCreateProductManufacturingPriceArgs = {
  input: CreateProductManufacturingPriceDto;
};


export type MutationCreateProductionOrderArgs = {
  createProductionOrderDTO: CreateProductionOrderDto;
};


export type MutationCreateProductionPlanArgs = {
  createProductionPlanDTO: CreateProductionPlanDto;
};


export type MutationCreateProfitCenterArgs = {
  createProfitCenter: CreateProfitCenterInput;
};


export type MutationCreatePurchaseOrderArgs = {
  createPurchaseOrderDTO: CreatePurchaseOrderDto;
};


export type MutationCreateReportArgs = {
  input: CreateReportInput;
};


export type MutationCreateRoleArgs = {
  roleInputDTO: RoleInputDto;
};


export type MutationCreateSourceModuleArgs = {
  input: CreateSourceModuleInput;
};


export type MutationCreateSqlReportArgs = {
  input: CreateSqlReportInput;
};


export type MutationCreateStockOperationArgs = {
  CreateStockOperationDTO: CreateStockOperationDto;
};


export type MutationCreateStockReturnArgs = {
  createStockReturnDTO: CreateStockReturnDto;
};


export type MutationCreateTagArgs = {
  createTagDTO: CreateTagDto;
};


export type MutationCreateTaxGroupArgs = {
  createTaxGroupDTO: CreateTaxGroupDto;
};


export type MutationCreateTenantArgs = {
  createTenantDTO: CreateTenantDto;
};


export type MutationCreateTransferArgs = {
  createTransferDTO: CreateTransferDto;
};


export type MutationCreateVendorArgs = {
  createVendorDTO: CreateVendorDto;
};


export type MutationDeactivateUserArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteAccountBankTransactionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAccountPayableInvoiceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAccountPayableInvoiceLineArgs = {
  lineId: Scalars['ID']['input'];
};


export type MutationDeleteAccountPayablePaymentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAccountReceivableInvoiceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAccountReceivableInvoiceLineArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAccountReceivableReceiptArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAccountSubtypeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteApSettlementLineArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteArSettlementLineArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAutomationFlowArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteBankAccountArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBomVersionLineItemArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteCalculatedColumnArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteCashAccountArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteChartOfAccountArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCostCenterArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDashboardArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteEntityArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFiscalPeriodArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFiscalYearArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMediaAssetArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeletePaymentTermsArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePermissionArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeletePrinterConfigArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteProfitCenterArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteReportArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteRoleArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteSourceModuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDuplicateDashboardTabArgs = {
  dashboardId: Scalars['String']['input'];
  newName: Scalars['String']['input'];
  tab: Scalars['String']['input'];
};


export type MutationEditOrderArgs = {
  input: EditOrderDto;
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String']['input'];
  origin: Scalars['String']['input'];
};


export type MutationGenerateDepositControlArgs = {
  input: GenerateDepositControlInput;
};


export type MutationGrantAccessArgs = {
  constraints?: InputMaybe<Scalars['JSON']['input']>;
  permission?: InputMaybe<Scalars['String']['input']>;
  resourceId: Scalars['String']['input'];
  resourceType: Scalars['String']['input'];
  subjectId: Scalars['String']['input'];
  subjectType: Scalars['String']['input'];
};


export type MutationHoldPosOrderArgs = {
  input: HoldPosOrderInput;
};


export type MutationImportFusionIntegrationProductsArgs = {
  input: ImportFusionIntegrationProductsInput;
};


export type MutationInviteUserArgs = {
  inviteUser: InviteUserDto;
  locationIds: Array<Scalars['String']['input']>;
};


export type MutationLinkFusionExternalObjectsArgs = {
  input: LinkExternalObjectsInput;
};


export type MutationLoginUserArgs = {
  loginUserDTO: LoginUserDto;
};


export type MutationMarkDeliveredArgs = {
  input: MarkDeliveredInput;
};


export type MutationMarkDeliveryFailedArgs = {
  input: MarkDeliveryFailedInput;
};


export type MutationMarkDispatchedArgs = {
  input: MarkDispatchedInput;
};


export type MutationMarkNotificationReadArgs = {
  id: Scalars['String']['input'];
};


export type MutationOpenFiscalPeriodArgs = {
  id: Scalars['ID']['input'];
};


export type MutationOpenLocationRegisterArgs = {
  createLocationRegisterSessionDto: CreateLocationRegisterSessionDto;
  registerId: Scalars['String']['input'];
};


export type MutationPlaceHoldArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  entityId: Scalars['ID']['input'];
  entityType: HoldEntityType;
  reason: HoldReason;
};


export type MutationPostAccountPayableWriteoffArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPostAccountReceivableWriteoffArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPostCashDepositArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPostJournalHeaderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationProcessFulfillmentArgs = {
  processOrder: ProcessFulfillmentDto;
};


export type MutationProcessOrderArgs = {
  processOrder: ProcessOrderDto;
};


export type MutationProcessShippingArgs = {
  processOrder: ProcessShippingDto;
};


export type MutationPublishDashboardArgs = {
  id: Scalars['String']['input'];
  visibility: ReportVisibility;
};


export type MutationPublishReportArgs = {
  id: Scalars['String']['input'];
  visibility: ReportVisibility;
};


export type MutationPushFusionIntegrationProductArgs = {
  input: FusionIntegrationProductActionInput;
};


export type MutationReadyToDispatchArgs = {
  input: ReadyToDispatchInput;
};


export type MutationReceiveAllTransferItemsArgs = {
  transferId: Scalars['String']['input'];
};


export type MutationReceiveReturnedParcelArgs = {
  input: ReceiveReturnedParcelInput;
};


export type MutationReceiveTransferItemsArgs = {
  receiveTransferItemsInput: ReceiveTransferItemsInput;
};


export type MutationRefreshReportPersistenceArgs = {
  reportId: Scalars['String']['input'];
};


export type MutationRejectBomVersionArgs = {
  id: Scalars['String']['input'];
  rejectionReason: Scalars['String']['input'];
};


export type MutationRejectLotArgs = {
  input: RejectLotInput;
};


export type MutationReleaseHoldArgs = {
  holdId: Scalars['ID']['input'];
};


export type MutationReleasePosOrderArgs = {
  input: ReleasePosOrderInput;
};


export type MutationRemoveDashboardWidgetArgs = {
  widgetId: Scalars['String']['input'];
};


export type MutationRemoveFusionCarrierLocationMappingArgs = {
  input: RemoveFusionCarrierLocationMappingInput;
};


export type MutationRemoveFusionConnectionArgs = {
  accountId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type MutationRemoveFusionConnectorTenantOverrideArgs = {
  input: RemoveTenantOverrideInput;
};


export type MutationRemoveFusionIntegrationLocationArgs = {
  input: RemoveFusionIntegrationMappingInput;
};


export type MutationRemoveFusionIntegrationProductArgs = {
  input: RemoveFusionIntegrationMappingInput;
};


export type MutationRemoveProductionLineArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveProductionOrderMaterialLotArgs = {
  lotAssignmentId: Scalars['String']['input'];
};


export type MutationRemoveStockOperationItemArgs = {
  stockOperationItemId: Scalars['String']['input'];
};


export type MutationRepayFusionRiderArgs = {
  input: RepayFusionRiderInput;
};


export type MutationRequestProductionPlanIssuanceArgs = {
  id: Scalars['String']['input'];
};


export type MutationResendInviteArgs = {
  id: Scalars['String']['input'];
  origin: Scalars['String']['input'];
};


export type MutationResetPasswordArgs = {
  id: Scalars['String']['input'];
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationRetireSystemReportTemplateArgs = {
  systemKey: Scalars['String']['input'];
};


export type MutationRetryFusionShipmentQuarkSyncArgs = {
  shipmentId: Scalars['String']['input'];
};


export type MutationReturnOrderArgs = {
  ReturnOrderDto: ReturnOrderDto;
};


export type MutationRevokeAccessArgs = {
  id: Scalars['String']['input'];
};


export type MutationScanAuditLotArgs = {
  scanLotsDto: ScanLotsDto;
};


export type MutationScanPickerTaskUnitArgs = {
  input: ScanPickerTaskUnitInput;
};


export type MutationSetFlowEnabledArgs = {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
};


export type MutationSetFusionCarrierLocationMappingArgs = {
  input: SetFusionCarrierLocationMappingInput;
};


export type MutationSetFusionConnectorPlatformDefaultArgs = {
  input: SetPlatformDefaultInput;
};


export type MutationSetFusionConnectorTenantOverrideArgs = {
  input: SetTenantOverrideInput;
};


export type MutationSetFusionIntegrationEventArgs = {
  input: SetFusionIntegrationEventInput;
};


export type MutationSetFusionIntegrationLocationArgs = {
  input: SetFusionIntegrationLocationInput;
};


export type MutationSetFusionIntegrationProductArgs = {
  input: SetFusionIntegrationProductInput;
};


export type MutationSetFusionIntegrationProductStockBufferArgs = {
  input: SetFusionIntegrationProductStockBufferInput;
};


export type MutationSetFusionRiderActiveArgs = {
  input: SetFusionRiderActiveInput;
};


export type MutationSetReportCacheTtlArgs = {
  id: Scalars['String']['input'];
  seconds?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSetReportPersistenceArgs = {
  enabled: Scalars['Boolean']['input'];
  refreshIntervalSeconds?: InputMaybe<Scalars['Int']['input']>;
  reportId: Scalars['String']['input'];
};


export type MutationSetReportSavedDatasetArgs = {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
};


export type MutationSettleFusionRiderCodArgs = {
  input: SettleFusionRiderCodInput;
};


export type MutationStartAuditArgs = {
  auditId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};


export type MutationStartFusionIntegrationAuthorizationArgs = {
  input: StartFusionIntegrationAuthorizationInput;
};


export type MutationStartPickerTaskArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSubmitBomVersionForApprovalArgs = {
  id: Scalars['String']['input'];
};


export type MutationSubmitProductionOrderToQcArgs = {
  submitToQcDTO: SubmitToQcDto;
};


export type MutationSubmitProductionPlanForApprovalArgs = {
  id: Scalars['String']['input'];
};


export type MutationSwapReservedLotArgs = {
  input: SwapReservedLotInput;
};


export type MutationSyncFusionCatalogArgs = {
  accountId: Scalars['String']['input'];
  connectionId: Scalars['String']['input'];
  force?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSyncFusionIntegrationCatalogArgs = {
  connectionId: Scalars['String']['input'];
  force?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSyncFusionIntegrationProductsArgs = {
  connectionId: Scalars['String']['input'];
};


export type MutationTestFlowArgs = {
  id: Scalars['String']['input'];
};


export type MutationTogglePaymentTermsStatusArgs = {
  id: Scalars['ID']['input'];
};


export type MutationTransitionFulfillmentOrderStatusArgs = {
  id: Scalars['ID']['input'];
  status: FulfillmentOrderStatus;
};


export type MutationTriggerInvoicePolicyBatchArgs = {
  date?: InputMaybe<Scalars['String']['input']>;
  force?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUnassignFulfillmentOrderLinesArgs = {
  input: UnassignFulfillmentOrderLinesInput;
};


export type MutationUnlinkFusionExternalObjectArgs = {
  input: UnlinkExternalObjectInput;
};


export type MutationUnlistFusionIntegrationProductArgs = {
  input: FusionIntegrationProductActionInput;
};


export type MutationUnpackFulfillmentOrderArgs = {
  fulfillmentOrderId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationUpdateAccountBankTransactionArgs = {
  updateAccountBankTransaction: UpdateAccountBankTransactionInput;
};


export type MutationUpdateAccountPayableInvoiceArgs = {
  updateAccountPayableInvoice: UpdateAccountPayableInvoiceInput;
};


export type MutationUpdateAccountPayablePaymentArgs = {
  updateAccountPayablePayment: UpdateAccountPayablePaymentInput;
};


export type MutationUpdateAccountPayableWriteoffArgs = {
  updateAccountPayableWriteoff: UpdateAccountPayableWriteoffInput;
};


export type MutationUpdateAccountReceivableInvoiceArgs = {
  updateAccountReceivableInvoice: UpdateAccountReceivableInvoiceInput;
};


export type MutationUpdateAccountReceivableReceiptArgs = {
  updateAccountReceivableReceipt: UpdateAccountReceivableReceiptInput;
};


export type MutationUpdateAccountReceivableWriteoffArgs = {
  updateAccountReceivableWriteoff: UpdateAccountReceivableWriteoffInput;
};


export type MutationUpdateAccountSubtypeArgs = {
  updateAccountSubtype: UpdateAccountSubtypeInput;
};


export type MutationUpdateAddressArgs = {
  updateAddressDTO: UpdateAddressDto;
};


export type MutationUpdateAdjustmentStatusArgs = {
  id: Scalars['String']['input'];
  status: AdjustmentStatus;
};


export type MutationUpdateApSettlementLineArgs = {
  updateApSettlementLine: UpdateApSettlementLineInput;
};


export type MutationUpdateArSettlementLineArgs = {
  updateArSettlementLine: UpdateArSettlementLineInput;
};


export type MutationUpdateAutomationFlowArgs = {
  id: Scalars['String']['input'];
  input: UpdateAutomationFlowInput;
};


export type MutationUpdateBankAccountArgs = {
  updateBankAccount: UpdateBankAccountInput;
};


export type MutationUpdateBomArgs = {
  updateBomDTO: UpdateBomDto;
};


export type MutationUpdateBomStatusArgs = {
  id: Scalars['String']['input'];
  status: BomStatus;
};


export type MutationUpdateBomVersionArgs = {
  updateBomVersionDTO: UpdateBomVersionDto;
};


export type MutationUpdateBomVersionLineItemArgs = {
  updateBomVersionLineItemDTO: UpdateBomVersionLineItemDto;
};


export type MutationUpdateCalculatedColumnArgs = {
  id: Scalars['String']['input'];
  input: UpdateCalculatedColumnInput;
};

export type MutationUpdateCancellationFbrInvoiceIdArgs = {
  cancellationId: Scalars['ID']['input'];
  fbrInvoiceId: Scalars['String']['input'];
};


export type MutationUpdateCashAccountArgs = {
  updateCashAccount: UpdateCashAccountInput;
};


export type MutationUpdateCategoryArgs = {
  updateCategoryDTO: UpdateCategoryDto;
};


export type MutationUpdateChartOfAccountArgs = {
  input: UpdateChartOfAccountsInput;
};


export type MutationUpdateCostCenterArgs = {
  updateCostCenter: UpdateCostCenterInput;
};


export type MutationUpdateCustomerArgs = {
  updateCustomerDTO: UpdateCustomerDto;
};


export type MutationUpdateDashboardArgs = {
  id: Scalars['String']['input'];
  input: UpdateDashboardInput;
};


export type MutationUpdateDashboardWidgetArgs = {
  input: UpdateDashboardWidgetInput;
  widgetId: Scalars['String']['input'];
};


export type MutationUpdateDemandNoteFulfillmentStatusArgs = {
  id: Scalars['String']['input'];
  status: DemandNoteFulfillmentStatus;
};


export type MutationUpdateDiscountArgs = {
  updateDiscountDTO: UpdateDiscountDto;
};


export type MutationUpdateEntityArgs = {
  input: UpdateEntityInput;
};


export type MutationUpdateFbrInvoiceIdArgs = {
  invoiceId: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
};


export type MutationUpdateFiscalPeriodArgs = {
  updateFiscalPeriod: UpdateFiscalPeriodInput;
};


export type MutationUpdateFiscalYearArgs = {
  updateFiscalYear: UpdateFiscalYearInput;
};


export type MutationUpdateFusionConnectionArgs = {
  input: UpdateFusionConnectionInput;
};


export type MutationUpdateFusionIntegrationArgs = {
  input: UpdateFusionIntegrationInput;
};


export type MutationUpdateFusionIntegrationProductArgs = {
  input: UpdateFusionIntegrationProductInput;
};


export type MutationUpdateGenericFormulaArgs = {
  updateGenericFormulaDTO: UpdateGenericFormulaDto;
};


export type MutationUpdateGrnItemSerialNumbersArgs = {
  grnItemId: Scalars['String']['input'];
  serialNumbers: Array<Scalars['String']['input']>;
};


export type MutationUpdateGrnQcStatusArgs = {
  UpdateGrnItemStatusDTO: UpdateGrnItemStatus;
};


export type MutationUpdateGrnReceivedStatusArgs = {
  grnId: Array<Scalars['String']['input']>;
};


export type MutationUpdateIntegrationArgs = {
  updateIntegrationInput: UpdateIntegrationConfigDto;
};


export type MutationUpdateInvoicePolicyConfigArgs = {
  updateInvoicePolicyConfigDTO: UpdateInvoicePolicyConfigDto;
};


export type MutationUpdateJournalHeaderArgs = {
  input: UpdateJournalHeaderInput;
};


export type MutationUpdateJournalLineArgs = {
  input: UpdateJournalLineInput;
};


export type MutationUpdateLocationArgs = {
  LocationDTO: LocationDto;
  id: Scalars['String']['input'];
};


export type MutationUpdateLocationRegisterArgs = {
  updateLocationRegisterDTO: UpdateLocationRegisterDto;
};


export type MutationUpdateManufacturerArgs = {
  UpdateManufacturerDTO: UpdateManufacturerDto;
};


export type MutationUpdatePartnerArgs = {
  updatePartnerDTO: UpdatePartnerDto;
};


export type MutationUpdatePartnerFinancialTermsArgs = {
  updateFinancialTermsDTO: UpdateFinancialTermsDto;
};


export type MutationUpdatePaymentStatusArgs = {
  orderId: Scalars['String']['input'];
  paymentStatus: PaymentStatus;
};


export type MutationUpdatePaymentTermsArgs = {
  updatePaymentTerms: UpdatePaymentTermsInput;
};


export type MutationUpdatePermissionArgs = {
  id: Scalars['String']['input'];
  permissionInputDTO: PermissionInputDto;
};


export type MutationUpdatePlatformFeeConfigArgs = {
  updatePlatformFeeConfigInput: UpdatePlatformFeeConfigDto;
};


export type MutationUpdatePrinterConfigArgs = {
  updatePrinterConfigDTO: UpdatePrinterConfigDto;
};


export type MutationUpdateProductArgs = {
  updateProductDTO: UpdateProductDto;
};


export type MutationUpdateProductLotArgs = {
  updateProductLotDTO: UpdateProductLotDto;
};


export type MutationUpdateProductManufacturingPriceArgs = {
  input: UpdateProductManufacturingPriceDto;
};


export type MutationUpdateProductionLineArgs = {
  updateProductionLineDTO: UpdateProductionLineDto;
};


export type MutationUpdateProductionOrderArgs = {
  updateProductionOrderDTO: UpdateProductionOrderDto;
};


export type MutationUpdateProductionOrderBatchArgs = {
  updateProductionOrderBatchDTO: UpdateProductionOrderBatchDto;
};


export type MutationUpdateProductionOrderMaterialArgs = {
  updateProductionOrderMaterialDTO: UpdateProductionOrderMaterialDto;
};


export type MutationUpdateProductionPlanArgs = {
  updateProductionPlanDTO: UpdateProductionPlanDto;
};


export type MutationUpdateProfitCenterArgs = {
  updateProfitCenter: UpdateProfitCenterInput;
};


export type MutationUpdateReportArgs = {
  id: Scalars['String']['input'];
  input: UpdateReportInput;
};


export type MutationUpdateReturnFbrInvoiceIdArgs = {
  invoiceId: Scalars['String']['input'];
  returnOrderId: Scalars['String']['input'];
};


export type MutationUpdateRoleArgs = {
  id: Scalars['String']['input'];
  roleInputDTO: RoleInputDto;
};


export type MutationUpdateSourceModuleArgs = {
  input: UpdateSourceModuleInput;
};


export type MutationUpdateSqlReportArgs = {
  id: Scalars['String']['input'];
  input: UpdateSqlReportInput;
};


export type MutationUpdateStockOperationArgs = {
  UpdateStockOperationDTO: UpdateStockOperationDto;
};


export type MutationUpdateStockOperationItemArgs = {
  UpdateStockOperationItemDTO: UpdateStockOperationItemDto;
};


export type MutationUpdateTagArgs = {
  updateTagDTO: UpdateTagDto;
};


export type MutationUpdateTaxGroupArgs = {
  updateTaxGroupDTO: UpdateTaxGroupDto;
};


export type MutationUpdateTenantArgs = {
  updateTenantDTO: UpdateTenantDto;
};


export type MutationUpdateTenantFulfillmentConfigArgs = {
  input: UpdateTenantFulfillmentConfigInput;
};


export type MutationUpdateUserArgs = {
  id: Scalars['String']['input'];
  locationIds: Array<Scalars['String']['input']>;
  userDTO: UserDto;
};


export type MutationUpdateVendorArgs = {
  updateVendorDTO: UpdateVendorDto;
};


export type MutationUploadMediaImageArgs = {
  input: UploadMediaImageInput;
};


export type MutationUploadStockOperationItemImportArgs = {
  fileBase64: Scalars['String']['input'];
  fileType: StockOperationImportFileType;
  stockOperationId: Scalars['String']['input'];
};


export type MutationUpsertCashDepositConfigArgs = {
  input: UpsertCashDepositConfigInput;
};


export type MutationUpsertSystemReportTemplateArgs = {
  input: SystemReportTemplateInput;
  systemKey: Scalars['String']['input'];
};


export type MutationValidateEmailTokenArgs = {
  id: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationValidateInviteTokenArgs = {
  id: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationVoidShipmentBookingArgs = {
  fulfillmentOrderId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};

export type NewVsReturningDto = {
  newCustomerPercentage: Scalars['Float']['output'];
  newCustomerRevenue: Scalars['Float']['output'];
  newCustomers: Scalars['Float']['output'];
  returningCustomerRevenue: Scalars['Float']['output'];
  returningCustomers: Scalars['Float']['output'];
};

export type Order = {
  address?: Maybe<OrderAddress>;
  addressId?: Maybe<Scalars['String']['output']>;
  /** Still owed: the total less cancelled lines and charges, less what was paid with the order net of refunds */
  amountDue?: Maybe<Scalars['Float']['output']>;
  cancelledReason?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  costTax?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByUserId?: Maybe<Scalars['String']['output']>;
  customer: Customer;
  customerId?: Maybe<Scalars['String']['output']>;
  deliveryCharges: Scalars['Float']['output'];
  discountLines?: Maybe<Array<OrderDiscountLine>>;
  estimatedDeliveryDate?: Maybe<Scalars['DateTime']['output']>;
  externalOrderId?: Maybe<Scalars['String']['output']>;
  externalPlatform?: Maybe<Scalars['String']['output']>;
  fulfillmentStatus: FulfillmentStatus;
  id: Scalars['String']['output'];
  integrationCharges: Scalars['Float']['output'];
  integrationConfigs?: Maybe<Array<OrderIntegrationConfig>>;
  items: Array<OrderLineItem>;
  location?: Maybe<Location>;
  locationId?: Maybe<Scalars['String']['output']>;
  locationRegister?: Maybe<LocationRegister>;
  locationRegisterSession?: Maybe<LocationRegisterSession>;
  mrNo?: Maybe<Scalars['String']['output']>;
  orderChannel: OrderChannel;
  orderPlatformFees?: Maybe<Array<OrderPlatformFee>>;
  orderSource?: Maybe<OrderSource>;
  orderType: OrderType;
  parentOrder?: Maybe<Order>;
  parentOrderId?: Maybe<Scalars['String']['output']>;
  partner?: Maybe<Partner>;
  partnerAllocationAmount?: Maybe<Scalars['Float']['output']>;
  partnerFinancialTermsIds?: Maybe<Array<Scalars['String']['output']>>;
  partnerId?: Maybe<Scalars['String']['output']>;
  partnerReferenceNo?: Maybe<Scalars['String']['output']>;
  payments?: Maybe<Array<OrderPayment>>;
  platformFee: Scalars['Float']['output'];
  posFees: Scalars['Float']['output'];
  postingRule?: Maybe<Scalars['String']['output']>;
  registerId?: Maybe<Scalars['String']['output']>;
  registerSessionId?: Maybe<Scalars['String']['output']>;
  riskFlags?: Maybe<Array<Scalars['String']['output']>>;
  riskReviewedByUserId?: Maybe<Scalars['String']['output']>;
  riskScore?: Maybe<Scalars['Float']['output']>;
  secondaryId?: Maybe<Scalars['Float']['output']>;
  shippingStatus: ShippingStatus;
  status: OrderStatus;
  subtotal: Scalars['Float']['output'];
  tax: Scalars['Float']['output'];
  totalAmount: Scalars['Float']['output'];
  totalDiscount: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OrderAddress = {
  additionalNumber?: Maybe<Scalars['String']['output']>;
  buildingNo?: Maybe<Scalars['String']['output']>;
  city?: Maybe<City>;
  cityId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  districtName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  landmark?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  streetAddress1?: Maybe<Scalars['String']['output']>;
  streetAddress2?: Maybe<Scalars['String']['output']>;
  streetName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type OrderCancellation = {
  backfilled: Scalars['Boolean']['output'];
  cancelledBy?: Maybe<Scalars['String']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  costTax?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deliveryCharges: Scalars['Float']['output'];
  fbrInvoiceId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  integrationCharges: Scalars['Float']['output'];
  isFull: Scalars['Boolean']['output'];
  lines?: Maybe<Array<OrderCancellationLine>>;
  locationId: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  orderId: Scalars['String']['output'];
  orderStatusSnapshot?: Maybe<Scalars['String']['output']>;
  paymentMethodSnapshot?: Maybe<Scalars['String']['output']>;
  paymentStatusSnapshot?: Maybe<Scalars['String']['output']>;
  platformFee: Scalars['Float']['output'];
  postingRule?: Maybe<Scalars['String']['output']>;
  reason: CancellationReason;
  refundAmount: Scalars['Float']['output'];
  refundMethod?: Maybe<Scalars['String']['output']>;
  refundRegisterSessionId?: Maybe<Scalars['String']['output']>;
};

export type OrderCancellationLine = {
  cancellationId: Scalars['String']['output'];
  cost?: Maybe<Scalars['Float']['output']>;
  costTax?: Maybe<Scalars['Float']['output']>;
  discount: Scalars['Float']['output'];
  fulfillmentOrderId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lots?: Maybe<Array<OrderCancellationLineLot>>;
  orderLineItemId: Scalars['String']['output'];
  productId?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
  restockTo: RestockTarget;
  subTotal: Scalars['Float']['output'];
  tax: Scalars['Float']['output'];
  taxRate: Scalars['Float']['output'];
  totalPrice: Scalars['Float']['output'];
  unitPrice: Scalars['Float']['output'];
};

export type OrderCancellationLineLot = {
  cancellationLineId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  productLotId: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  restockTo: RestockTarget;
  source: CancellationLotSource;
  unitCost?: Maybe<Scalars['Float']['output']>;
  unitCostTax?: Maybe<Scalars['Float']['output']>;
};

/** Possible statuses for an order */
export enum OrderChannel {
  Marketplace = 'MARKETPLACE',
  MobileApp = 'MOBILE_APP',
  Pos = 'POS',
  Website = 'WEBSITE'
}

export type OrderDiscountLine = {
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  discount?: Maybe<Discount>;
  discountAmount: Scalars['Float']['output'];
  discountId?: Maybe<Scalars['String']['output']>;
  discountTitle?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  order: Order;
  orderId?: Maybe<Scalars['String']['output']>;
  orderLineItem: OrderLineItem;
  scope: DiscountScope;
  secondaryId?: Maybe<Scalars['Float']['output']>;
  type: DiscountType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type OrderFulfillment = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  orderLineItemId?: Maybe<Scalars['String']['output']>;
  status: FulfillmentStatus;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Possible statuses for an order */
export enum OrderFulfillmentStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Fulfilled = 'FULFILLED',
  Hold = 'HOLD'
}

export type OrderIntegrationConfig = {
  apiResponseId?: Maybe<Scalars['String']['output']>;
  charges?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastFailedAt?: Maybe<Scalars['DateTime']['output']>;
  lastFailedReason?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order: Order;
  orderId?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  type: IntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OrderItem = {
  foc: Scalars['Boolean']['input'];
  productId: Scalars['String']['input'];
  requiredQuantity: Scalars['Int']['input'];
  tradeDiscountPercentage: Scalars['Float']['input'];
  tradePrice: Scalars['Float']['input'];
};

export type OrderItemDto = {
  productId: Scalars['String']['input'];
  productLots?: InputMaybe<Array<OrderProductLotDto>>;
  quantity: Scalars['Int']['input'];
};

export type OrderLineItem = {
  cancelledQuantity: Scalars['Float']['output'];
  cost?: Maybe<Scalars['Float']['output']>;
  costTax?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discount: Scalars['Float']['output'];
  discountId?: Maybe<Scalars['String']['output']>;
  fulfillmentStatus: FulfillmentStatus;
  fulfillments: Array<OrderFulfillment>;
  id: Scalars['String']['output'];
  image?: Maybe<Scalars['String']['output']>;
  lots?: Maybe<Array<OrderLineItemLot>>;
  name: Scalars['String']['output'];
  order: Order;
  orderDiscount: OrderDiscountLine;
  orderId?: Maybe<Scalars['String']['output']>;
  partnerAllocationAmount?: Maybe<Scalars['Float']['output']>;
  partnerFinancialTerms?: Maybe<PartnerFinancialTerms>;
  partnerFinancialTermsId?: Maybe<Scalars['String']['output']>;
  product: Product;
  productId?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Float']['output'];
  returnedQuantity: Scalars['Float']['output'];
  secondaryId?: Maybe<Scalars['Float']['output']>;
  shipments?: Maybe<Array<OrderShipment>>;
  subTotal: Scalars['Float']['output'];
  tax: Scalars['Float']['output'];
  taxRate: Scalars['Float']['output'];
  totalPrice: Scalars['Float']['output'];
  unitPrice: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OrderLineItemLot = {
  fulfillmentOrderId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  orderLineItem: OrderLineItem;
  orderLineItemId?: Maybe<Scalars['String']['output']>;
  productLot: ProductLot;
  productLotId?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Float']['output'];
  returnedQuantity: Scalars['Float']['output'];
  source: OrderLineItemLotSource;
};

export type OrderLineItemLotResponseDto = {
  data: Array<OrderLineItemLot>;
  meta: MetaResponse;
};

export enum OrderLineItemLotSource {
  Picked = 'PICKED',
  Reserved = 'RESERVED'
}

export type OrderListItem = {
  address?: Maybe<OrderAddress>;
  addressId?: Maybe<Scalars['String']['output']>;
  /** Still owed: the total less cancelled lines and charges, less what was paid net of refunds */
  amountDue?: Maybe<Scalars['Float']['output']>;
  cancelledReason?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  costTax?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByUserId?: Maybe<Scalars['String']['output']>;
  customer: Customer;
  customerId?: Maybe<Scalars['String']['output']>;
  deliveryCharges: Scalars['Float']['output'];
  discountLines?: Maybe<Array<OrderDiscountLine>>;
  estimatedDeliveryDate?: Maybe<Scalars['DateTime']['output']>;
  externalOrderId?: Maybe<Scalars['String']['output']>;
  externalPlatform?: Maybe<Scalars['String']['output']>;
  fulfillmentStatus: FulfillmentStatus;
  id: Scalars['String']['output'];
  integrationCharges: Scalars['Float']['output'];
  integrationConfigs?: Maybe<Array<OrderIntegrationConfig>>;
  itemsCount: Scalars['Int']['output'];
  location?: Maybe<Location>;
  locationId?: Maybe<Scalars['String']['output']>;
  locationRegister?: Maybe<LocationRegister>;
  locationRegisterSession?: Maybe<LocationRegisterSession>;
  mrNo?: Maybe<Scalars['String']['output']>;
  orderChannel: OrderChannel;
  orderPlatformFees?: Maybe<Array<OrderPlatformFee>>;
  orderSource?: Maybe<OrderSource>;
  orderType: OrderType;
  parentOrder?: Maybe<Order>;
  parentOrderId?: Maybe<Scalars['String']['output']>;
  partner?: Maybe<Partner>;
  partnerAllocationAmount?: Maybe<Scalars['Float']['output']>;
  partnerFinancialTermsIds?: Maybe<Array<Scalars['String']['output']>>;
  partnerId?: Maybe<Scalars['String']['output']>;
  partnerReferenceNo?: Maybe<Scalars['String']['output']>;
  payments?: Maybe<Array<OrderPayment>>;
  platformFee: Scalars['Float']['output'];
  posFees: Scalars['Float']['output'];
  postingRule?: Maybe<Scalars['String']['output']>;
  registerId?: Maybe<Scalars['String']['output']>;
  registerSessionId?: Maybe<Scalars['String']['output']>;
  riskFlags?: Maybe<Array<Scalars['String']['output']>>;
  riskReviewedByUserId?: Maybe<Scalars['String']['output']>;
  riskScore?: Maybe<Scalars['Float']['output']>;
  secondaryId?: Maybe<Scalars['Float']['output']>;
  shippingStatus: ShippingStatus;
  status: OrderStatus;
  subtotal: Scalars['Float']['output'];
  tax: Scalars['Float']['output'];
  totalAmount: Scalars['Float']['output'];
  totalDiscount: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OrderManagementSummaryDto = {
  orders: Scalars['Int']['output'];
  partiallyReturned: Scalars['Int']['output'];
  pending: Scalars['Int']['output'];
  returned: Scalars['Int']['output'];
  totalAmount: Scalars['Float']['output'];
};

export type OrderPayment = {
  amount: Scalars['Float']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  method: PaymentMethod;
  order: Order;
  orderId?: Maybe<Scalars['String']['output']>;
  paidOnCreation: Scalars['Boolean']['output'];
  status: PaymentStatus;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OrderPlatformFee = {
  amount: Scalars['Float']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  order: Order;
  orderId: Scalars['String']['output'];
  platformFeeConfig?: Maybe<PlatformFeeConfig>;
  platformFeeConfigId: Scalars['String']['output'];
};

export type OrderProductLotDto = {
  id: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

export type OrderResponseDto = {
  data: Array<OrderListItem>;
  meta: MetaResponse;
};

export type OrderReturnItemInput = {
  itemId?: InputMaybe<Scalars['String']['input']>;
  lotId?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  /** Back to sale (default) or quarantine. */
  restockTo?: InputMaybe<RestockTarget>;
};

export type OrderShipment = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  logisticsPartner?: Maybe<Scalars['String']['output']>;
  orderLineItemId: Scalars['String']['output'];
  status: OrderShippingStatus;
  trackingNumber?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Possible statuses for an order */
export enum OrderShippingStatus {
  InTransit = 'IN_TRANSIT',
  Pending = 'PENDING',
  Shipped = 'SHIPPED'
}

/** Possible statuses for an order */
export enum OrderSource {
  Custom = 'CUSTOM',
  Daraz = 'DARAZ',
  Shopify = 'SHOPIFY',
  Whatsapp = 'WHATSAPP',
  Woocommerce = 'WOOCOMMERCE'
}

/** Possible statuses for an order */
export enum OrderStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Draft = 'DRAFT',
  Fulfilled = 'FULFILLED',
  Hold = 'HOLD',
  PartiallyReturned = 'PARTIALLY_RETURNED',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Returned = 'RETURNED',
  ReturnRequested = 'RETURN_REQUESTED'
}

export type OrderStatusCountDto = {
  count: Scalars['Float']['output'];
  status: Scalars['String']['output'];
  totalAmount: Scalars['Float']['output'];
};

export type OrderStatusHistory = {
  changedByUserId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  entityId: Scalars['String']['output'];
  entityType: StatusHistoryEntityType;
  fromStatus: Scalars['String']['output'];
  id: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  toStatus: Scalars['String']['output'];
};

export type OrderSummaryDto = {
  discount: Scalars['Float']['output'];
  gross: Scalars['Float']['output'];
  integrationCharges: Scalars['Float']['output'];
  netAmount: Scalars['Float']['output'];
  netSale: Scalars['Float']['output'];
  orderCount: Scalars['Int']['output'];
  paymentMethod: PaymentMethod;
  platformFee: Scalars['Float']['output'];
  returned: Scalars['Float']['output'];
  shippingFee: Scalars['Float']['output'];
  tax: Scalars['Float']['output'];
};

/** Possible statuses for an order */
export enum OrderType {
  Delivery = 'DELIVERY',
  Pickup = 'PICKUP',
  Return = 'RETURN'
}

export type OutstandingApInvoiceFilterInput = {
  customerId?: InputMaybe<Scalars['ID']['input']>;
  partnerId?: InputMaybe<Scalars['ID']['input']>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};

export type OutstandingApInvoiceItem = {
  aging?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  invoiceDate: Scalars['DateTime']['output'];
  invoiceNo?: Maybe<Scalars['Float']['output']>;
  outstandingAmount: Scalars['Float']['output'];
  settlementAllocatedAmount: Scalars['Float']['output'];
  totalAmount: Scalars['Float']['output'];
  type: AccountPayableInvoiceType;
};

export type OutstandingApInvoiceResponseDto = {
  data: Array<OutstandingApInvoiceItem>;
  meta: MetaResponse;
};

export type OutstandingArInvoiceItem = {
  aging?: Maybe<Scalars['String']['output']>;
  dueDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  invoiceDate: Scalars['DateTime']['output'];
  invoiceNo?: Maybe<Scalars['Float']['output']>;
  outstandingAmount: Scalars['Float']['output'];
  settlementAllocatedAmount: Scalars['Float']['output'];
  totalAmount: Scalars['Float']['output'];
  type: AccountReceivableInvoiceType;
};

export type OutstandingInvoiceFilterInput = {
  customerId?: InputMaybe<Scalars['ID']['input']>;
  partnerId?: InputMaybe<Scalars['ID']['input']>;
};

export type OutstandingInvoiceResponseDto = {
  data: Array<OutstandingArInvoiceItem>;
  meta: MetaResponse;
};

export type Partner = {
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<City>;
  cityId?: Maybe<Scalars['String']['output']>;
  contactPerson?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customers?: Maybe<Array<Customer>>;
  defaultFinancialTermsId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  secondaryId: Scalars['Float']['output'];
  status: Status;
  taxId?: Maybe<Scalars['String']['output']>;
  type: PartnerType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

export type PartnerFinancialTerms = {
  coverageFixedAmount?: Maybe<Scalars['Float']['output']>;
  coverageModeCode: CoverageModeCode;
  coveragePercent?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  direction: Direction;
  effectiveFrom: Scalars['Date']['output'];
  effectiveTo?: Maybe<Scalars['Date']['output']>;
  id: Scalars['String']['output'];
  isCreditCover: Scalars['Boolean']['output'];
  partner?: Maybe<Partner>;
  partnerId: Scalars['String']['output'];
  secondaryId: Scalars['Float']['output'];
  status: Status;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PartnerResponseDto = {
  data: Array<Partner>;
  meta: MetaResponse;
};

export enum PartnerType {
  Affiliate = 'AFFILIATE',
  Corporate = 'CORPORATE',
  Discount = 'DISCOUNT',
  Distributor = 'DISTRIBUTOR',
  Reseller = 'RESELLER'
}

/** Possible statuses for an order */
export enum PaymentMethod {
  BankTransfer = 'BANK_TRANSFER',
  Card = 'CARD',
  Cash = 'CASH',
  Cod = 'COD',
  Credit = 'CREDIT'
}

export type PaymentMethodBreakdownDto = {
  paymentMethod: Scalars['String']['output'];
  percentage: Scalars['Float']['output'];
  totalAmount: Scalars['Float']['output'];
  transactionCount: Scalars['Float']['output'];
};

export enum PaymentStatus {
  Authorized = 'AUTHORIZED',
  Failed = 'FAILED',
  Paid = 'PAID',
  PartiallyCaptured = 'PARTIALLY_CAPTURED',
  PartiallyPaid = 'PARTIALLY_PAID',
  PartiallyRefunded = 'PARTIALLY_REFUNDED',
  Pending = 'PENDING',
  Refunded = 'REFUNDED',
  Unpaid = 'UNPAID'
}

export type PaymentTermDiscount = {
  calculationMethod: DiscountCalculationMethod;
  createdBy?: Maybe<Scalars['String']['output']>;
  discountDays: Scalars['Int']['output'];
  discountPercent: Scalars['Float']['output'];
  entityId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  paymentTermId: Scalars['ID']['output'];
  secondaryId?: Maybe<Scalars['Float']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PaymentTerms = {
  applicableOn: ApplicableOn;
  baseDate?: Maybe<Scalars['DateTime']['output']>;
  baseDateType: BaseDateType;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  createdByName?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discounts?: Maybe<Array<PaymentTermDiscount>>;
  entityId: Scalars['ID']['output'];
  graceDays: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isDiscountApplicable: Scalars['Boolean']['output'];
  isInstallmentBased: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  schedules?: Maybe<Array<PaymentTermsSchedule>>;
  secondaryId?: Maybe<Scalars['Float']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['ID']['output']>;
  updatedByName?: Maybe<Scalars['String']['output']>;
};

export type PaymentTermsResponseDto = {
  data: Array<PaymentTerms>;
  meta: MetaResponse;
};

export type PaymentTermsSchedule = {
  calculationBasis: CalculationBasis;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  dueOffsetDays: Scalars['Int']['output'];
  duePercent: Scalars['Float']['output'];
  entityId: Scalars['ID']['output'];
  fixedAmount?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  paymentNo: Scalars['Int']['output'];
  paymentTermId: Scalars['ID']['output'];
  secondaryId?: Maybe<Scalars['Float']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PeriodComparisonDto = {
  changePercent: Scalars['Float']['output'];
  current: Scalars['Float']['output'];
  previous: Scalars['Float']['output'];
};

export type Permission = {
  action?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  module?: Maybe<Scalars['String']['output']>;
  permission?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Status>;
  subModule?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PermissionDto = {
  id: Scalars['String']['output'];
  permission: Scalars['String']['output'];
};

export type PermissionInputDto = {
  action: Scalars['String']['input'];
  module: Scalars['String']['input'];
  status: Scalars['String']['input'];
  subModule: Scalars['String']['input'];
};

export type PermissionResponseDto_ = {
  data: Array<Permission>;
  meta: MetaResponse;
};

export type PickerTaskGroup = {
  customerName?: Maybe<Scalars['String']['output']>;
  fulfillmentId?: Maybe<Scalars['String']['output']>;
  fulfillmentOrderId?: Maybe<Scalars['String']['output']>;
  fulfillmentStatus: FulfillmentStatus;
  orderChannel?: Maybe<Scalars['String']['output']>;
  orderId: Scalars['String']['output'];
  orderNumber: Scalars['Int']['output'];
  orderSource?: Maybe<Scalars['String']['output']>;
  partnerName?: Maybe<Scalars['String']['output']>;
  pickedItems: Scalars['Int']['output'];
  tasks: Array<PickerTaskSummaryItem>;
  totalItems: Scalars['Int']['output'];
};

export type PickerTaskGroupResponseDto = {
  data: Array<PickerTaskGroup>;
  meta: MetaResponse;
};

export enum PickerTaskLotStatus {
  Rejected = 'REJECTED',
  Scanned = 'SCANNED'
}

export type PickerTaskSummary = {
  cancelled: Scalars['Int']['output'];
  completed: Scalars['Int']['output'];
  inProgress: Scalars['Int']['output'];
  toStart: Scalars['Int']['output'];
  unitsLeft: Scalars['Int']['output'];
};

export type PickerTaskSummaryItem = {
  completedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  fulfillmentId?: Maybe<Scalars['String']['output']>;
  fulfillmentOrderId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  locationId?: Maybe<Scalars['String']['output']>;
  locationName?: Maybe<Scalars['String']['output']>;
  orderCancelled: Scalars['Boolean']['output'];
  productGtin?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  productSku?: Maybe<Scalars['String']['output']>;
  quantityToPick: Scalars['Int']['output'];
  scannedQuantity: Scalars['Int']['output'];
  startedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  status: PickingTaskStatus;
};

export enum PickerTaskTab {
  All = 'ALL',
  InProgress = 'IN_PROGRESS',
  Picked = 'PICKED',
  ToPick = 'TO_PICK'
}

export type PickerTaskTabFilter = {
  tab?: InputMaybe<PickerTaskTab>;
};

export type PickingProgress = {
  assignedUnits: Scalars['Int']['output'];
  beingPickedUnits: Scalars['Int']['output'];
  dispatchedUnits: Scalars['Int']['output'];
  fulfillmentOrderId: Scalars['ID']['output'];
  pickedUnits: Scalars['Int']['output'];
  readyToDispatchUnits: Scalars['Int']['output'];
  totalUnits: Scalars['Int']['output'];
  unassignedUnits: Scalars['Int']['output'];
};

export enum PickingTaskStatus {
  Cancelled = 'CANCELLED',
  PartiallyPicked = 'PARTIALLY_PICKED',
  Picked = 'PICKED',
  Picking = 'PICKING',
  ToBePicked = 'TO_BE_PICKED'
}

export type PlatformFeeConfig = {
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  isRemovable: Scalars['Boolean']['output'];
  location: Location;
  locationId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  orderType: Scalars['String']['output'];
  platformFeeAccountCode?: Maybe<Scalars['String']['output']>;
  platformFeeTaxRate: Scalars['Float']['output'];
  platformFeeTaxable: Scalars['Boolean']['output'];
  platformFeeType: PlatformFeeType;
  platformFeeValue: Scalars['Float']['output'];
  status: Status;
  updatedAt: Scalars['DateTime']['output'];
};

export type PlatformFeeConfigResponseDto = {
  data: Array<PlatformFeeConfig>;
  meta: MetaResponse;
};

export type PlatformFeeSummaryDto = {
  amount: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  isRemovable: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export enum PlatformFeeType {
  Flat = 'FLAT',
  Percentage = 'PERCENTAGE'
}

export type PlatformPermission = {
  action: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  module: Scalars['String']['output'];
  status: Scalars['String']['output'];
  subModule: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum PlatformRole {
  Manager = 'MANAGER',
  PlatformAdmin = 'PLATFORM_ADMIN',
  Staff = 'STAFF',
  User = 'USER'
}

export type PlatformTenantReport = {
  datasetKey: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  kind?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type PlatformTenantReportDetail = {
  chartConfig?: Maybe<Scalars['JSON']['output']>;
  datasetKey: Scalars['String']['output'];
  definition: Scalars['JSON']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum PoolStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type PosHeldOrder = {
  createdBy?: Maybe<Scalars['String']['output']>;
  customerName: Scalars['String']['output'];
  heldAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  identifier: Scalars['String']['output'];
  locationId: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  registerId: Scalars['String']['output'];
  registerSessionId?: Maybe<Scalars['String']['output']>;
  snapshot: Scalars['JSON']['output'];
  totalAmount: Scalars['Float']['output'];
};

export type PosHeldOrderResponseDto = {
  data: Array<PosHeldOrder>;
  meta: MetaResponse;
};

export type PosHeldOrdersInput = {
  filter?: InputMaybe<Array<FilterGroup>>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  registerId?: InputMaybe<Scalars['String']['input']>;
  registerSessionId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortCondition>>;
};

export type PosRegisterCashMap = {
  cashAccount?: Maybe<CashAccount>;
  cashAccountId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  posRegisterId: Scalars['ID']['output'];
  posRegisterName?: Maybe<Scalars['String']['output']>;
};

export enum PrintModeType {
  A4 = 'A4',
  Thermal = 'THERMAL'
}

export type PrinterConfig = {
  batchNumberFontSize: Scalars['Float']['output'];
  columnGap: Scalars['Float']['output'];
  columns: Scalars['Int']['output'];
  expiryFontSize: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  labelHeight: Scalars['Float']['output'];
  labelWidth: Scalars['Float']['output'];
  marginBottom: Scalars['Float']['output'];
  marginLeft: Scalars['Float']['output'];
  marginRight: Scalars['Float']['output'];
  marginTop: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  orientation: Scalars['String']['output'];
  padding: Scalars['Float']['output'];
  productNameFontSize: Scalars['Float']['output'];
  productNameMaxLines: Scalars['Int']['output'];
  productNameWrap: Scalars['String']['output'];
  qrCodeAlignment: Scalars['String']['output'];
  qrCodeMarginRight: Scalars['Float']['output'];
  qrCodeSize: Scalars['Float']['output'];
  textAlignment: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  zoom: Scalars['Float']['output'];
};

export type PrinterConfigResponseDto = {
  data: Array<PrinterConfig>;
  meta: MetaResponse;
};

export type PrismNotification = {
  body?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  flowId?: Maybe<Scalars['String']['output']>;
  flowName?: Maybe<Scalars['String']['output']>;
  flowRunId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  link?: Maybe<Scalars['String']['output']>;
  readAt?: Maybe<Scalars['DateTime']['output']>;
  severity: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type PrismNotificationPage = {
  data: Array<PrismNotification>;
  total: Scalars['Int']['output'];
  unread: Scalars['Int']['output'];
};

export type ProcessFulfillmentDto = {
  orderId: Scalars['String']['input'];
  status: OrderFulfillmentStatus;
};

export type ProcessOrderDto = {
  orderId: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  status: OrderStatus;
};

export type ProcessShippingDto = {
  logisticsPartner?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
  status: OrderShippingStatus;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
};

export type Product = {
  activeLotsCount?: Maybe<Scalars['Float']['output']>;
  buyingUnit?: Maybe<UomUnit>;
  categories?: Maybe<Array<Category>>;
  conversions: Array<ProductConversion>;
  description?: Maybe<Scalars['String']['output']>;
  discountPercentage?: Maybe<Scalars['Float']['output']>;
  dosageInstruction?: Maybe<Scalars['String']['output']>;
  drugRegulatorId?: Maybe<Scalars['Int']['output']>;
  genericFormula?: Maybe<Array<GenericFormula>>;
  gtin?: Maybe<Scalars['String']['output']>;
  heightCm?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  images?: Maybe<Array<Scalars['String']['output']>>;
  isDiscountApplicableOnTax?: Maybe<Scalars['Boolean']['output']>;
  isManufacturable: Scalars['Boolean']['output'];
  isManufacturerTracking?: Maybe<Scalars['Boolean']['output']>;
  isPurchasable: Scalars['Boolean']['output'];
  isSellable: Scalars['Boolean']['output'];
  isTaxInclusive?: Maybe<Scalars['Boolean']['output']>;
  itemNature?: Maybe<Scalars['String']['output']>;
  itemReleaseChannels?: Maybe<Array<Scalars['String']['output']>>;
  lastUpdatedBy?: Maybe<Scalars['String']['output']>;
  lengthCm?: Maybe<Scalars['Float']['output']>;
  lots: Array<ProductLot>;
  manufacturer?: Maybe<Manufacturer>;
  manufacturerId?: Maybe<Scalars['String']['output']>;
  margins?: Maybe<Scalars['Float']['output']>;
  maximumRetailPrice?: Maybe<Scalars['Float']['output']>;
  maximumRetailUnitPrice?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  prescriptionRequired?: Maybe<Scalars['Boolean']['output']>;
  productImages?: Maybe<Array<ProductImage>>;
  purchasingPrice?: Maybe<Scalars['Float']['output']>;
  secondaryId?: Maybe<Scalars['Float']['output']>;
  sellingTaxRate?: Maybe<Scalars['Float']['output']>;
  sellingUnit?: Maybe<UomUnit>;
  seoDescription?: Maybe<Scalars['String']['output']>;
  seoTitle?: Maybe<Scalars['String']['output']>;
  seoUrl?: Maybe<Scalars['String']['output']>;
  sideEffects?: Maybe<Scalars['String']['output']>;
  skuCode?: Maybe<Scalars['String']['output']>;
  skuDepartment?: Maybe<Scalars['String']['output']>;
  skuMaximumLevel?: Maybe<Scalars['Int']['output']>;
  skuMinimumLevel?: Maybe<Scalars['Int']['output']>;
  skuReorderLevel?: Maybe<Scalars['Float']['output']>;
  skuWarehouseLeadTime?: Maybe<Scalars['Float']['output']>;
  sorting?: Maybe<Scalars['Int']['output']>;
  status: Status;
  stockNature?: Maybe<StockNature>;
  tags?: Maybe<Array<Tag>>;
  taxCode?: Maybe<Scalars['String']['output']>;
  taxGroup?: Maybe<TaxGroup>;
  taxGroupId?: Maybe<Scalars['String']['output']>;
  trackingLevel?: Maybe<TrackingLevel>;
  tradeDiscount?: Maybe<Scalars['Float']['output']>;
  tradePrice?: Maybe<Scalars['Float']['output']>;
  tradePriceOutward?: Maybe<Scalars['Float']['output']>;
  uomFactor?: Maybe<Scalars['Float']['output']>;
  uomType: UomType;
  vendors?: Maybe<Array<Vendor>>;
  weightGrams?: Maybe<Scalars['Float']['output']>;
  widthCm?: Maybe<Scalars['Float']['output']>;
};

export type ProductAuditSummaryDto = {
  actualQuantity?: Maybe<Scalars['Int']['output']>;
  excessAmount?: Maybe<Scalars['Float']['output']>;
  excessCount?: Maybe<Scalars['Int']['output']>;
  expectedQuantity?: Maybe<Scalars['Int']['output']>;
  looseQuantity?: Maybe<Scalars['Int']['output']>;
  matchedCount?: Maybe<Scalars['Int']['output']>;
  packedQuantity?: Maybe<Scalars['Int']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  remainingLots?: Maybe<Scalars['Int']['output']>;
  scannedLots?: Maybe<Scalars['Int']['output']>;
  shortAmount?: Maybe<Scalars['Float']['output']>;
  shortCount?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  stockValue?: Maybe<Scalars['Float']['output']>;
  totalLots?: Maybe<Scalars['Int']['output']>;
  uomFactor?: Maybe<Scalars['Float']['output']>;
};

export type ProductConversion = {
  id?: Maybe<Scalars['String']['output']>;
  itemConversion: Scalars['Float']['output'];
  product: Product;
  productId?: Maybe<Scalars['String']['output']>;
  sellingUnit: UomUnit;
  sorting: Scalars['Float']['output'];
};

export type ProductImage = {
  altText?: Maybe<Scalars['String']['output']>;
  asset?: Maybe<MediaAsset>;
  assetId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  productId: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

export type ProductListSummaryDto = {
  activeProductsCount: Scalars['Int']['output'];
  inactiveProductsCount: Scalars['Int']['output'];
  totalProductsCount: Scalars['Int']['output'];
};

export type ProductLot = {
  actionId?: Maybe<Scalars['String']['output']>;
  baseQuantity?: Maybe<Scalars['Float']['output']>;
  batchExpiry?: Maybe<Scalars['String']['output']>;
  batchNumber?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  grnItem?: Maybe<GrnItems>;
  gstValue?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  initialSellableQuantity?: Maybe<Scalars['Float']['output']>;
  isOpened?: Maybe<Scalars['Boolean']['output']>;
  mfgDate?: Maybe<Scalars['String']['output']>;
  mrpSellingUnit?: Maybe<Scalars['Float']['output']>;
  product: Product;
  productionOrderId?: Maybe<Scalars['String']['output']>;
  purchasingPrice?: Maybe<Scalars['Float']['output']>;
  purchasingPriceUnit?: Maybe<Scalars['Float']['output']>;
  receivedQuantity?: Maybe<Scalars['Float']['output']>;
  rejectedQuantity?: Maybe<Scalars['Float']['output']>;
  sellableQuantity?: Maybe<Scalars['Float']['output']>;
  status: ProductLotStatus;
  stockOperationItemId?: Maybe<Scalars['String']['output']>;
  taxSellingUnit?: Maybe<Scalars['Float']['output']>;
  trackingLevel?: Maybe<TrackingLevel>;
  tradePrice?: Maybe<Scalars['Float']['output']>;
  tradePriceOutward?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  warehouse?: Maybe<Location>;
};

export type ProductLotDto = {
  id: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

export enum ProductLotStatus {
  AdjustedLocation = 'ADJUSTED_LOCATION',
  AdjustedStockOut = 'ADJUSTED_STOCK_OUT',
  Damaged = 'DAMAGED',
  Excess = 'EXCESS',
  InAdjustment = 'IN_ADJUSTMENT',
  InAudit = 'IN_AUDIT',
  InInventory = 'IN_INVENTORY',
  InQc = 'IN_QC',
  InTransfer = 'IN_TRANSFER',
  Matched = 'MATCHED',
  QcRejected = 'QC_REJECTED',
  Returned = 'RETURNED',
  Short = 'SHORT',
  StockOpsOut = 'STOCK_OPS_OUT',
  StockOut = 'STOCK_OUT',
  TransferStockOut = 'TRANSFER_STOCK_OUT'
}

export type ProductLotSummaryDto = {
  actionId?: Maybe<Scalars['String']['output']>;
  batchExpiry?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  mrpSellingUnit?: Maybe<Scalars['Float']['output']>;
  purchasingPrice?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  sellableQuantity?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  taxSellingUnit?: Maybe<Scalars['Float']['output']>;
};

export type ProductManufacturingPrice = {
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  effectiveFrom: Scalars['Date']['output'];
  effectiveTo?: Maybe<Scalars['Date']['output']>;
  id: Scalars['String']['output'];
  maximumRetailPrice: Scalars['Float']['output'];
  product?: Maybe<Product>;
  productId: Scalars['String']['output'];
  secondaryId?: Maybe<Scalars['Int']['output']>;
  taxRate: Scalars['Float']['output'];
  tradePriceOutward: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type ProductResponseDto = {
  data: Array<Product>;
  meta: MetaResponse;
};

export type ProductStockReportArgs = {
  filter?: InputMaybe<ProductStockReportFilterrArgs>;
  limit?: Scalars['Int']['input'];
  locationId: Scalars['String']['input'];
  page?: Scalars['Int']['input'];
};

export type ProductStockReportDto = {
  buyingUnit: Scalars['String']['output'];
  categoryNames?: Maybe<Array<Scalars['String']['output']>>;
  inTransitQuantity: Scalars['Float']['output'];
  inTransitStock: Scalars['Float']['output'];
  inTransitStockValue: Scalars['Float']['output'];
  locationName: Scalars['String']['output'];
  looseSellableQuantity: Scalars['Float']['output'];
  looseStock: Scalars['Float']['output'];
  looseStockValue: Scalars['Float']['output'];
  manufacturerName: Scalars['String']['output'];
  maximumRetailPrice: Scalars['Float']['output'];
  packedSellableQuantity: Scalars['Float']['output'];
  packedStock: Scalars['Float']['output'];
  packedStockValue?: Maybe<Scalars['Float']['output']>;
  productId: Scalars['String']['output'];
  productName: Scalars['String']['output'];
  productSecondaryId?: Maybe<Scalars['Float']['output']>;
  purchasingPrice: Scalars['Float']['output'];
  sellingUnit: Scalars['String']['output'];
  taxRate: Scalars['String']['output'];
  totalStockQuantity: Scalars['Float']['output'];
  totalStockValue: Scalars['Float']['output'];
  totalStockValueExcludingTax: Scalars['Float']['output'];
  totalTax: Scalars['Float']['output'];
  tradePrice: Scalars['Float']['output'];
  uomFactor?: Maybe<Scalars['Float']['output']>;
};

export type ProductStockReportFilterrArgs = {
  buyingUnit?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['JSON']['input']>;
  manufacturerName?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  sellingUnit?: InputMaybe<Scalars['String']['input']>;
};

export type ProductStockReportResponseDto = {
  data: Array<ProductStockReportDto>;
  meta: MetaResponse;
};

export type ProductSummaryDto = {
  discount?: Maybe<Scalars['Float']['output']>;
  discountId?: Maybe<Scalars['String']['output']>;
  discountTitle?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  productLots: Array<ProductLotSummaryDto>;
  secondaryId?: Maybe<Scalars['Float']['output']>;
  subTotal?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  title: Scalars['String']['output'];
  total?: Maybe<Scalars['Float']['output']>;
};

export type ProductionLine = {
  bom?: Maybe<Bom>;
  bomVersion?: Maybe<BomVersion>;
  bomVersionId: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  materialLines?: Maybe<Array<ProductionMaterialLine>>;
  multiplierFactor: Scalars['Int']['output'];
  outputProduct?: Maybe<Product>;
  outputProductId: Scalars['String']['output'];
  plannedQty: Scalars['Float']['output'];
  productionPlan?: Maybe<ProductionPlan>;
  productionPlanId: Scalars['String']['output'];
  secondaryId?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export type ProductionMaterialLine = {
  componentProduct?: Maybe<Product>;
  componentProductId: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  isMandatory: Scalars['Boolean']['output'];
  productionLine?: Maybe<ProductionLine>;
  productionLineId: Scalars['String']['output'];
  requiredQty: Scalars['Float']['output'];
  secondaryId?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export type ProductionOrder = {
  batches?: Maybe<Array<ProductionOrderBatch>>;
  bomVersion?: Maybe<BomVersion>;
  bomVersionId: Scalars['String']['output'];
  cancellationReason?: Maybe<Scalars['String']['output']>;
  cancelledAt?: Maybe<Scalars['Date']['output']>;
  cancelledBy?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['Date']['output']>;
  completedBy?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  location?: Maybe<Location>;
  locationId?: Maybe<Scalars['String']['output']>;
  manufacturingCostPerUnit?: Maybe<Scalars['Float']['output']>;
  materials?: Maybe<Array<ProductionOrderMaterial>>;
  notes?: Maybe<Scalars['String']['output']>;
  orderCode: Scalars['String']['output'];
  outputProduct?: Maybe<Product>;
  outputProductId: Scalars['String']['output'];
  plannedQty: Scalars['Float']['output'];
  productionLine?: Maybe<ProductionLine>;
  productionLineId?: Maybe<Scalars['String']['output']>;
  productionPlan?: Maybe<ProductionPlan>;
  productionPlanId?: Maybe<Scalars['String']['output']>;
  qcAt?: Maybe<Scalars['Date']['output']>;
  qcBy?: Maybe<Scalars['String']['output']>;
  qcNotes?: Maybe<Scalars['String']['output']>;
  qcPassedQty?: Maybe<Scalars['Float']['output']>;
  qcRejectedQty?: Maybe<Scalars['Float']['output']>;
  secondaryId?: Maybe<Scalars['Int']['output']>;
  status: ProductionOrderStatus;
  totalAdjustment: Scalars['Float']['output'];
  totalProducedQuantity: Scalars['Float']['output'];
  updatedAt: Scalars['Date']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type ProductionOrderBatch = {
  adjustmentDirection?: Maybe<AdjustmentDirection>;
  adjustmentQuantity?: Maybe<Scalars['Float']['output']>;
  batchNumber: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  productionOrder?: Maybe<ProductionOrder>;
  productionOrderId: Scalars['String']['output'];
  qcAt?: Maybe<Scalars['Date']['output']>;
  qcBy?: Maybe<Scalars['String']['output']>;
  qcNotes?: Maybe<Scalars['String']['output']>;
  qcRejectedQty?: Maybe<Scalars['Float']['output']>;
  qcStatus: BatchQcStatus;
  standardQuantity: Scalars['Float']['output'];
  submittedToQcAt?: Maybe<Scalars['Date']['output']>;
  submittedToQcBy?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export type ProductionOrderMaterial = {
  actualQty?: Maybe<Scalars['Float']['output']>;
  componentProduct?: Maybe<Product>;
  componentProductId: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  isMandatory: Scalars['Boolean']['output'];
  isOverridden: Scalars['Boolean']['output'];
  lots?: Maybe<Array<ProductionOrderMaterialLot>>;
  plannedQty: Scalars['Float']['output'];
  productionOrder?: Maybe<ProductionOrder>;
  productionOrderId: Scalars['String']['output'];
  secondaryId?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export type ProductionOrderMaterialLot = {
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  productLot?: Maybe<ProductLot>;
  productLotId: Scalars['String']['output'];
  productionOrderMaterial?: Maybe<ProductionOrderMaterial>;
  productionOrderMaterialId: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type ProductionOrderResponseDto = {
  data: Array<ProductionOrder>;
  meta: MetaResponse;
};

export enum ProductionOrderStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Draft = 'DRAFT',
  QcPending = 'QC_PENDING'
}

export type ProductionPlan = {
  approvedAt?: Maybe<Scalars['Date']['output']>;
  approvedBy?: Maybe<Scalars['String']['output']>;
  cancellationReason?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  demandNote?: Maybe<DemandNote>;
  demandNoteId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  issuanceRequestedAt?: Maybe<Scalars['Date']['output']>;
  issuanceRequestedBy?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  planCode: Scalars['String']['output'];
  plannedEndDate?: Maybe<Scalars['Date']['output']>;
  plannedStartDate?: Maybe<Scalars['Date']['output']>;
  productionLines?: Maybe<Array<ProductionLine>>;
  productionLocation?: Maybe<Location>;
  productionLocationId: Scalars['String']['output'];
  secondaryId?: Maybe<Scalars['Int']['output']>;
  sourceLocation?: Maybe<Location>;
  sourceLocationId: Scalars['String']['output'];
  status: ProductionPlanStatus;
  updatedAt: Scalars['Date']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type ProductionPlanResponseDto = {
  data: Array<ProductionPlan>;
  meta: MetaResponse;
};

export enum ProductionPlanStatus {
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Draft = 'DRAFT',
  IssuanceRequested = 'ISSUANCE_REQUESTED',
  PendingApproval = 'PENDING_APPROVAL'
}

export enum ProductionProcessType {
  Assembly = 'ASSEMBLY',
  Manufacturing = 'MANUFACTURING',
  Packing = 'PACKING',
  Process = 'PROCESS',
  Repacking = 'REPACKING'
}

export type ProfitCenter = {
  coaAccounts?: Maybe<Array<ProfitCenterCoa>>;
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['ID']['output'];
  createdByName?: Maybe<Scalars['String']['output']>;
  effectiveFrom?: Maybe<Scalars['DateTime']['output']>;
  effectiveTo?: Maybe<Scalars['DateTime']['output']>;
  entity?: Maybe<EntityModel>;
  entityId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  locations?: Maybe<Array<ProfitCenterLocation>>;
  managerId?: Maybe<Scalars['ID']['output']>;
  managerName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  parentPc?: Maybe<ProfitCenter>;
  parentPcId?: Maybe<Scalars['ID']['output']>;
  secondaryId: Scalars['Int']['output'];
  status: Status;
  type: ProfitCenterType;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['ID']['output']>;
  updatedByName?: Maybe<Scalars['String']['output']>;
};

export type ProfitCenterCoa = {
  coaAccount?: Maybe<ChartOfAccounts>;
  coaAccountId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  profitCenterId: Scalars['ID']['output'];
};

export type ProfitCenterLocation = {
  id: Scalars['ID']['output'];
  locationId: Scalars['ID']['output'];
  locationName?: Maybe<Scalars['String']['output']>;
  profitCenterId: Scalars['ID']['output'];
};

export enum ProfitCenterType {
  Branch = 'BRANCH',
  Department = 'DEPARTMENT',
  HeadOffice = 'HEAD_OFFICE',
  Service = 'SERVICE',
  Warehouse = 'WAREHOUSE'
}

export type ProfitCentersResponseDto = {
  data: Array<ProfitCenter>;
  meta: MetaResponse;
};

export type ProjectMaster = {
  budget: Scalars['String']['output'];
  endDate: Scalars['DateTime']['output'];
  entity?: Maybe<EntityModel>;
  entityId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  projectCode: Scalars['String']['output'];
  projectName: Scalars['String']['output'];
  startDate: Scalars['DateTime']['output'];
};

export type PurchaseOrder = {
  additionalTerms?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByName?: Maybe<Scalars['String']['output']>;
  deliveryLocation: Location;
  designation?: Maybe<Scalars['String']['output']>;
  expectedDeliveryDate?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  netAmount?: Maybe<Scalars['Float']['output']>;
  orderItems: Array<PurchaseOrderItem>;
  orderType: PurchaseOrderType;
  poType?: Maybe<Scalars['String']['output']>;
  returnRfid?: Maybe<Scalars['String']['output']>;
  salesTax?: Maybe<Scalars['Float']['output']>;
  secondaryId?: Maybe<Scalars['Float']['output']>;
  status: PurchaseOrderStatusApproval;
  tenantId?: Maybe<Scalars['String']['output']>;
  totalAmount?: Maybe<Scalars['Float']['output']>;
  totalDiscount?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  vendor: Vendor;
};

export type PurchaseOrderItem = {
  foc?: Maybe<Scalars['Boolean']['output']>;
  grnRemainingQuantity?: Maybe<Scalars['Int']['output']>;
  gstAmount?: Maybe<Scalars['Float']['output']>;
  gstPercentage?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  itemConversion?: Maybe<Scalars['Float']['output']>;
  product: Product;
  productId?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  purchaseOrder?: Maybe<PurchaseOrder>;
  purchaseOrderId?: Maybe<Scalars['String']['output']>;
  requiredQuantity?: Maybe<Scalars['Int']['output']>;
  salesTaxPercentage?: Maybe<Scalars['Float']['output']>;
  secondaryId?: Maybe<Scalars['Float']['output']>;
  totalPrice?: Maybe<Scalars['Float']['output']>;
  tradeDiscountPercentage?: Maybe<Scalars['Float']['output']>;
  tradeDiscountValue?: Maybe<Scalars['Float']['output']>;
  tradePrice?: Maybe<Scalars['Float']['output']>;
  tradePriceAfterApplyingGst?: Maybe<Scalars['Float']['output']>;
  tradePriceAfterTradeDiscount?: Maybe<Scalars['Float']['output']>;
  uom?: Maybe<Scalars['String']['output']>;
};

export type PurchaseOrderResponseDto = {
  data: Array<PurchaseOrder>;
  meta: MetaResponse;
};

export enum PurchaseOrderStatusApproval {
  Accepted = 'ACCEPTED',
  Closed = 'CLOSED',
  Fulfilled = 'FULFILLED',
  Partial = 'PARTIAL',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type PurchaseOrderSummaryDto = {
  amount: Scalars['Float']['output'];
  fulfilled: Scalars['Int']['output'];
  partial: Scalars['Int']['output'];
  pending: Scalars['Int']['output'];
  purchaseOrder: Scalars['Int']['output'];
};

export enum PurchaseOrderType {
  Advance = 'ADVANCE',
  Foc = 'FOC',
  Normal = 'NORMAL'
}

export type Query = {
  accessGrants: Array<AccessGrant>;
  accountBankTransaction?: Maybe<AccountBankTransaction>;
  accountBankTransactions: AccountBankTransactionsResponseDto;
  accountBankTransactionsByBank: AccountBankTransactionsResponseDto;
  accountPayableInvoice?: Maybe<AccountPayableInvoice>;
  accountPayableInvoices: AccountPayableInvoiceResponseDto;
  accountPayableInvoicesByVendor: AccountPayableInvoiceResponseDto;
  accountPayablePayment?: Maybe<AccountPayablePayment>;
  accountPayablePayments: AccountPayablePaymentResponseDto;
  accountPayablePaymentsByVendor: AccountPayablePaymentResponseDto;
  accountPayableWriteoff?: Maybe<AccountPayableWriteoff>;
  accountPayableWriteoffs: AccountPayableWriteoffResponseDto;
  accountPayableWriteoffsByInvoice: AccountPayableWriteoffResponseDto;
  accountReceivableInvoice?: Maybe<AccountReceivableInvoice>;
  accountReceivableInvoices: AccountReceivableInvoiceResponseDto;
  accountReceivableInvoicesByCustomer: AccountReceivableInvoiceResponseDto;
  accountReceivableReceipt?: Maybe<AccountReceivableReceipt>;
  accountReceivableReceipts: AccountReceivableReceiptResponseDto;
  accountReceivableReceiptsByCustomer: AccountReceivableReceiptResponseDto;
  accountReceivableReceiptsByInvoice: AccountReceivableReceiptResponseDto;
  accountReceivableWriteoff?: Maybe<AccountReceivableWriteoff>;
  accountReceivableWriteoffs: AccountReceivableWriteoffResponseDto;
  accountReceivableWriteoffsByInvoice: AccountReceivableWriteoffResponseDto;
  accountSubtype?: Maybe<AccountSubtype>;
  accountSubtypes: AccountSubtypeResponseDto;
  activeHolds: Array<FulfillmentHold>;
  adminAuditLogs: AdminAuditLogListResponse;
  adminCheckAccountId: Scalars['Boolean']['output'];
  adminMaintenanceStatus: MaintenanceStatus;
  adminPlatformPermissions: Array<PlatformPermission>;
  adminPool: TenantPool;
  adminPools: AdminPoolListResponse;
  adminTenant: Tenant;
  adminTenantStats: AdminTenantStatsResponse;
  adminTenants: AdminTenantListResponse;
  adminUser: GlobalUser;
  adminUsers: AdminUserListResponse;
  aiAssistEnabled: Scalars['Boolean']['output'];
  aiDraftReport: Scalars['JSON']['output'];
  apSettlementLine?: Maybe<ApSettlementLine>;
  apSettlementLines: ApSettlementLineResponseDto;
  apSettlementLinesByInvoice: ApSettlementLineResponseDto;
  apSettlementLinesByPayment: ApSettlementLineResponseDto;
  arSettlementLine?: Maybe<ArSettlementLine>;
  arSettlementLines: ArSettlementLineResponseDto;
  arSettlementLinesByInvoice: ArSettlementLineResponseDto;
  arSettlementLinesByReceipt: ArSettlementLineResponseDto;
  authenticateToken: AuthResponseDto;
  automationFlow: AutomationFlow;
  automationFlows: AutomationFlowPage;
  balanceSheetReport: BalanceSheetReportResponse;
  bankAccount?: Maybe<BankAccount>;
  bankAccounts: BankAccountsResponseDto;
  bankAccountsByEntity: BankAccountsResponseDto;
  bulkValidateProductLots: Array<ScanProductLotOutput>;
  calculateCartSummary: CartSummaryDto;
  calculatedColumnFunctions: Array<FormulaFunction>;
  calculatedColumnUsage: CalculatedColumnUsage;
  cashAccount?: Maybe<CashAccount>;
  cashAccounts: CashAccountsResponseDto;
  cashAccountsByEntity: CashAccountsResponseDto;
  cashDepositConfig?: Maybe<CashDepositConfig>;
  cashDepositControls: Array<CashDepositControl>;
  cashDeposits: Array<CashDeposit>;
  cashVarianceReport: Array<CashVarianceDto>;
  chartOfAccount?: Maybe<ChartOfAccounts>;
  chartOfAccounts: ChartOfAccountsResponse;
  checkCalculatedColumn: CalculatedColumnCheck;
  costCenter?: Maybe<CostCenter>;
  costCenters: CostCentersResponseDto;
  customerNewVsReturning: NewVsReturningDto;
  dashboard: DashboardWithWidgets;
  dashboardLocations: Array<DashboardLocationOption>;
  dashboards: DashboardPage;
  dayEndSummary: Array<DayEndSummaryDto>;
  discountPerformance: Array<DiscountPerformanceDto>;
  downloadAllGrnItems: Scalars['String']['output'];
  downloadFPInventory: Scalars['String']['output'];
  downloadGetProductLotStockReport: Scalars['String']['output'];
  downloadOrderItemReport: Scalars['String']['output'];
  downloadOrderReport: Scalars['String']['output'];
  downloadPurchaseOrderItem: Scalars['String']['output'];
  downloadPurchaseOrders: Scalars['String']['output'];
  downloadTransferItems: Scalars['String']['output'];
  downloadTransfers: Scalars['String']['output'];
  entities: EntityResponseDto;
  entity?: Maybe<EntityModel>;
  exportJobs: Array<ExportJob>;
  finance_stats: StatsResponseDto;
  fiscalPeriod?: Maybe<FiscalPeriod>;
  fiscalPeriods: FiscalPeriodsResponseDto;
  fiscalPeriodsByFiscalYear: FiscalPeriodsResponseDto;
  fiscalYear?: Maybe<FiscalYear>;
  fiscalYears: FiscalYearsResponseDto;
  fiscalYearsByEntity: FiscalYearsResponseDto;
  flowRecipients: Scalars['JSON']['output'];
  flowRuns: Array<FlowRun>;
  fulfillmentOrder?: Maybe<FulfillmentOrder>;
  fulfillmentOrderEvents: Array<FulfillmentOrderEvent>;
  fulfillmentOrderGroup: Array<FulfillmentOrder>;
  fulfillmentOrderList: AdminOrderListResponseDto;
  fulfillmentOrderPickingProgress: PickingProgress;
  fulfillmentOrderTabCounts: AdminOrderTabCounts;
  fulfillmentOrders: FulfillmentOrderResponseDto;
  fulfillmentStats: Array<FulfillmentStatDto>;
  fusionCarrierCostCentres: Array<FusionCarrierCostCentre>;
  fusionCarrierHealth: FusionCarrierHealth;
  fusionCarrierLabel: FusionCarrierLabel;
  fusionCarrierLocationMappings: Array<FusionCarrierLocationMapping>;
  fusionConnection: FusionConnection;
  fusionConnections: Array<FusionConnection>;
  fusionConnectorEntitlements: Array<ConnectorEntitlement>;
  fusionCouriers: Array<FusionCourier>;
  fusionExternalObjectMappings: Array<FusionExternalObjectMapping>;
  fusionIntegration: FusionIntegration;
  fusionIntegrationCatalogue: Array<FusionIntegrationCatalogueEntry>;
  fusionIntegrationEvents: Array<FusionIntegrationEventSubscription>;
  fusionIntegrationExternalLocations: Array<FusionIntegrationExternalLocation>;
  fusionIntegrationLocations: Array<FusionIntegrationLocation>;
  fusionIntegrationOperations: Array<FusionIntegrationOperation>;
  fusionIntegrationProductSearch: Array<FusionIntegrationProduct>;
  fusionIntegrationProductTemplate: Array<FusionIntegrationProductTemplateRow>;
  fusionIntegrationProducts: Array<FusionIntegrationProduct>;
  fusionRiderCodBalances: Array<FusionRiderCodBalance>;
  fusionRiderCodOutstanding: Array<FusionRiderCodOutstanding>;
  fusionRiderCodParcels: Array<FusionRiderCodParcel>;
  fusionRiders: Array<FusionRider>;
  fusionShipments: Array<FusionShipment>;
  generalLedgerReport: GeneralLedgerReportResponse;
  getAddress?: Maybe<Address>;
  getAddresses: AddressResponseDto;
  getAdjustment: Adjustment;
  getAdjustments: AdjustmentResponseDto;
  getAllAuditLots: AuditLotResponseDto;
  getAllAudits: AuditResponseDto;
  getAllGrnItems: GrnItemResponseDto;
  getAllGrns: GrnResponseDto;
  getAllStockOperations: StockOperationResponseDto;
  getAudit: Audit;
  getAuditLot: AuditLot;
  getAuditProductSummary: ProductAuditSummaryDto;
  getAuditSummary: AuditSummaryDto;
  getBaseQuantityByProductAndLocation: Array<BaseQuantityByLocationDto>;
  getBom: Bom;
  getBomVersion: BomVersion;
  getBomVersions: BomVersionResponseDto;
  getBoms: BomResponseDto;
  getBulkProductLots: BulkProductLotResponse;
  getCategories: CategoryResponseDto;
  getCategory: Category;
  getCategoryLevel: CategoryMaxLevelDto;
  getCities: CityResponseDto;
  getCitiesByCountry: Array<City>;
  getCountries: Array<Country>;
  getCountry: Country;
  getCustomer?: Maybe<Customer>;
  getCustomers: CustomerResponseDto;
  getDemandNote: DemandNoteGql;
  getDemandNotes: DemandNoteGqlListResponse;
  getDiscount?: Maybe<Discount>;
  getDiscounts: DiscountResponseDto;
  getGenericFormula: GenericFormula;
  getGenericFormulas: GenericFormulaResponseDto;
  getGrnByProductId: Grn;
  getIntegration: IntegrationConfig;
  getIntegrations: IntegrationResponseDto;
  getInvoicePolicyConfig?: Maybe<InvoicePolicyConfig>;
  getInvoicePolicyConfigs: InvoicePolicyConfigResponseDto;
  getLocation: Location;
  getLocationRegister: LocationRegister;
  getLocationRegisterBalanceHistoryBySessionId: LocationRegisterSessionBalance_;
  getLocationRegisterSessions: LocationRegisterSession_;
  getLocationRegisterTypes: Array<KeyValue>;
  getLocationRegisters: Array<LocationRegister>;
  getLocationSessionSummaryById: Array<OrderSummaryDto>;
  getLocations: LocationResponseDto;
  getLostSale: LostSale;
  getLostSales: LostSaleResponseDto;
  getManufacturer: Manufacturer;
  getManufacturers: ManufacturerResponseDto;
  getMediaAssets: MediaAssetResponseDto;
  getOneGrn: Grn;
  getOneStockOperation: StockOperation;
  getOrder: Order;
  getOrderLineItemLots: OrderLineItemLotResponseDto;
  getOrders: OrderResponseDto;
  getPDFStockReturn: ReturnProductInfoDto;
  getPartner?: Maybe<Partner>;
  getPartnerFinancialTerm?: Maybe<PartnerFinancialTerms>;
  getPartnerFinancialTerms: FinancialTermsResponseDto;
  getPartnerFinancialTermsByPartner: FinancialTermsResponseDto;
  getPartners: PartnerResponseDto;
  getPermission: Permission;
  getPermissionByRoleId: Array<Permission>;
  getPermissions: PermissionResponseDto_;
  getPickerUsers: UserResponseDto_;
  getPlatformFeeConfig: PlatformFeeConfig;
  getPlatformFeeConfigs: PlatformFeeConfigResponseDto;
  getPrinterConfig: PrinterConfig;
  getPrinterConfigs: PrinterConfigResponseDto;
  getProduct: Product;
  getProductLot: ProductLot;
  getProductLotStockReport: ProductStockReportResponseDto;
  getProductLots: Array<ProductLot>;
  getProductManufacturingPrices: Array<ProductManufacturingPrice>;
  getProductionOrder: ProductionOrder;
  getProductionOrders: ProductionOrderResponseDto;
  getProductionPlan: ProductionPlan;
  getProductionPlanMaterialReference: Array<ProductionMaterialLine>;
  getProductionPlans: ProductionPlanResponseDto;
  getProducts: ProductResponseDto;
  getProductsByVendor: ProductResponseDto;
  getPurchaseOrder: PurchaseOrder;
  getPurchaseOrders: PurchaseOrderResponseDto;
  getRegisterSummaryById: RegisterSessionSummaryDto;
  getReturnOrder: ReturnOrder;
  getReturnOrderLineItemLots: ReturnOrderLineItemLotResponseDto;
  getReturnedOrders: ReturnOrderResponseDto;
  getRole: Role;
  getRoles: RoleResponseDto_;
  getStockReturn: Return;
  getStockReturns: StockReturnResponseDto;
  getTag: Tag;
  getTags: TagResponseDto;
  getTaxGroup: TaxGroup;
  getTaxGroups: TaxGroupResponseDto;
  getTenant: Tenant;
  getTenants: Array<Tenant>;
  getTransfer: Transfer;
  getTransferProducts?: Maybe<Array<TransferProductDto>>;
  getTransferReceives: TransferResponseDto;
  getTransfers: TransferResponseDto;
  getUnexpiredProductLots: Array<ProductLot>;
  getUser: User;
  getUsers: UserResponseDto_;
  getVendor: Vendor;
  getVendors: VendorResponseDto;
  getZReportByLocationAndDate: Array<OrderSummaryDto>;
  grnSummary: GrnSummaryDto;
  helloFusion: Scalars['String']['output'];
  helloPrism: Scalars['String']['output'];
  helloSpectrum: Scalars['String']['output'];
  incomeStatementReport: IncomeStatementReportResponse;
  journalHeader?: Maybe<JournalHeader>;
  journalHeaders: JournalHeaderResponse;
  journalLine?: Maybe<JournalLine>;
  journalLines: JournalLineResponse;
  journalLinesByHeaderId: Array<JournalLine>;
  maintenanceStatus: MaintenanceStatus;
  myFusionIntegrations: Array<FusionIntegration>;
  notificationCount: Scalars['Int']['output'];
  notifications: PrismNotificationPage;
  openFiscalPeriods: FiscalPeriodsResponseDto;
  orderCancellations: Array<OrderCancellation>;
  orderManagementSummary: OrderManagementSummaryDto;
  orderStatusHistory: Array<OrderStatusHistory>;
  ordersByStatus: Array<OrderStatusCountDto>;
  outstandingAccountPayableInvoices: OutstandingApInvoiceResponseDto;
  outstandingAccountReceivableInvoices: OutstandingInvoiceResponseDto;
  paymentMethodBreakdown: Array<PaymentMethodBreakdownDto>;
  paymentTerm?: Maybe<PaymentTerms>;
  paymentTerms: PaymentTermsResponseDto;
  pickerTask: FulfillmentPickerTask;
  pickerTaskLots: Array<FulfillmentPickerTaskLot>;
  pickerTaskSummary: PickerTaskSummary;
  pickerTasks: PickerTaskGroupResponseDto;
  platformTenantReport: PlatformTenantReportDetail;
  platformTenantReports: Array<PlatformTenantReport>;
  posHeldOrders: PosHeldOrderResponseDto;
  productSummary: ProductListSummaryDto;
  profitCenter?: Maybe<ProfitCenter>;
  profitCenters: ProfitCentersResponseDto;
  profitCentersByEntity: ProfitCentersResponseDto;
  purchaseOrderSummary: PurchaseOrderSummaryDto;
  rawParameterOptions: Array<Scalars['String']['output']>;
  report: ReportDefinition;
  reportDatasets: Array<ReportDataset>;
  reportEntityOptions: Array<ReportEntityOption>;
  reports: ReportDefinitionPage;
  resolveFusionConnectorEntitlement: Scalars['Boolean']['output'];
  returnOverview: ReturnOverviewDto;
  returnsByProduct: Array<ReturnsByProductDto>;
  returnsOverTime: Array<ReturnDataPointDto>;
  runRawReport: ReportResult;
  runReport: ReportResult;
  runReportDetail: ReportResult;
  salesByCashier: Array<CashierSalesDto>;
  salesByChannel: Array<ChannelSalesDto>;
  salesByLocation: Array<LocationSalesDto>;
  salesOverTime: Array<SalesDataPointDto>;
  salesOverview: SalesOverviewDto;
  savedDatasetUsage: SavedDatasetUsage;
  shareableSubjects: Scalars['JSON']['output'];
  someField: Scalars['Boolean']['output'];
  sourceModule?: Maybe<SourceModuleEntity>;
  sourceModules: SourceModuleResponse;
  sqlTables: Array<SqlTable>;
  stockIntakeSummary: StockIntakeSummaryDto;
  stockOperationItemImportJob: StockOperationImportJob;
  systemReportTemplates: Array<SystemReportTemplate>;
  tenantFulfillmentConfig: TenantFulfillmentConfig;
  topCustomers: Array<TopCustomerDto>;
  topProducts: Array<TopProductDto>;
  trialBalanceReport: TrialBalanceReportResponse;
  unopenedProductLotInfo: UnopenedProductLotInfoDto;
  validateAdjustmentLots: Array<AdjustmentLotValidationError>;
  validateInvitation: ValidateInvitationDto;
};


export type QueryAccessGrantsArgs = {
  resourceId: Scalars['String']['input'];
  resourceType: Scalars['String']['input'];
};


export type QueryAccountBankTransactionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAccountBankTransactionsArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryAccountBankTransactionsByBankArgs = {
  bankId: Scalars['ID']['input'];
  filter?: InputMaybe<Array<FilterGroup>>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryAccountPayableInvoiceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAccountPayableInvoicesArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryAccountPayableInvoicesByVendorArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortCondition>>;
  vendorId: Scalars['ID']['input'];
};


export type QueryAccountPayablePaymentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAccountPayablePaymentsArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryAccountPayablePaymentsByVendorArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortCondition>>;
  vendorId: Scalars['ID']['input'];
};


export type QueryAccountPayableWriteoffArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAccountPayableWriteoffsArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryAccountPayableWriteoffsByInvoiceArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  invoiceId: Scalars['ID']['input'];
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryAccountReceivableInvoiceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAccountReceivableInvoicesArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryAccountReceivableInvoicesByCustomerArgs = {
  customerId: Scalars['ID']['input'];
  filter?: InputMaybe<Array<FilterGroup>>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryAccountReceivableReceiptArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAccountReceivableReceiptsArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryAccountReceivableReceiptsByCustomerArgs = {
  customerId: Scalars['ID']['input'];
  filter?: InputMaybe<Array<FilterGroup>>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryAccountReceivableReceiptsByInvoiceArgs = {
  arId: Scalars['ID']['input'];
  filter?: InputMaybe<Array<FilterGroup>>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryAccountReceivableWriteoffArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAccountReceivableWriteoffsArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryAccountReceivableWriteoffsByInvoiceArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  invoiceId: Scalars['ID']['input'];
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryAccountSubtypeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAccountSubtypesArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryActiveHoldsArgs = {
  entityId: Scalars['ID']['input'];
  entityType: HoldEntityType;
};


export type QueryAdminAuditLogsArgs = {
  filter?: InputMaybe<AdminAuditLogFilterInput>;
};


export type QueryAdminCheckAccountIdArgs = {
  accountId: Scalars['String']['input'];
};


export type QueryAdminPoolArgs = {
  id: Scalars['String']['input'];
};


export type QueryAdminTenantArgs = {
  id: Scalars['String']['input'];
};


export type QueryAdminTenantsArgs = {
  filter?: InputMaybe<AdminTenantFilterInput>;
};


export type QueryAdminUserArgs = {
  id: Scalars['String']['input'];
};


export type QueryAdminUsersArgs = {
  filter?: InputMaybe<AdminUserFilterInput>;
};


export type QueryAiDraftReportArgs = {
  datasetKey?: InputMaybe<Scalars['String']['input']>;
  history?: InputMaybe<Scalars['JSON']['input']>;
  prompt: Scalars['String']['input'];
};


export type QueryApSettlementLineArgs = {
  id: Scalars['ID']['input'];
};


export type QueryApSettlementLinesArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryApSettlementLinesByInvoiceArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  invoiceId: Scalars['ID']['input'];
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryApSettlementLinesByPaymentArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  paymentId: Scalars['ID']['input'];
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryArSettlementLineArgs = {
  id: Scalars['ID']['input'];
};


export type QueryArSettlementLinesArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryArSettlementLinesByInvoiceArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  invoiceId: Scalars['ID']['input'];
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryArSettlementLinesByReceiptArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  receiptId: Scalars['ID']['input'];
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryAutomationFlowArgs = {
  id: Scalars['String']['input'];
};


export type QueryAutomationFlowsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  reportId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBalanceSheetReportArgs = {
  asOfDate: Scalars['DateTime']['input'];
  costCenterIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  entityId: Scalars['ID']['input'];
  locationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  profitCenterIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryBankAccountArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBankAccountsArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryBankAccountsByEntityArgs = {
  entityId: Scalars['ID']['input'];
  filter?: InputMaybe<Array<FilterGroup>>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryBulkValidateProductLotsArgs = {
  locationId: Scalars['String']['input'];
  scanProductLots: Array<ScanProductLotInput>;
};


export type QueryCalculateCartSummaryArgs = {
  discountCode?: InputMaybe<Scalars['String']['input']>;
  order: ApplyDiscountDto;
};


export type QueryCalculatedColumnUsageArgs = {
  id: Scalars['String']['input'];
};


export type QueryCashAccountArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCashAccountsArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryCashAccountsByEntityArgs = {
  entityId: Scalars['ID']['input'];
  filter?: InputMaybe<Array<FilterGroup>>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryCashDepositConfigArgs = {
  entityId: Scalars['ID']['input'];
};


export type QueryCashDepositControlsArgs = {
  filter: CashDepositControlFilter;
};


export type QueryCashDepositsArgs = {
  controlId: Scalars['ID']['input'];
};


export type QueryCashVarianceReportArgs = {
  filter: AnalyticsFilterInput;
};


export type QueryChartOfAccountArgs = {
  id: Scalars['ID']['input'];
};


export type QueryChartOfAccountsArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryCheckCalculatedColumnArgs = {
  input: CheckCalculatedColumnInput;
};


export type QueryCostCenterArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCostCentersArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryCustomerNewVsReturningArgs = {
  filter: AnalyticsFilterInput;
};


export type QueryDashboardArgs = {
  id: Scalars['String']['input'];
};


export type QueryDashboardsArgs = {
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDayEndSummaryArgs = {
  filter: AnalyticsFilterInput;
};


export type QueryDiscountPerformanceArgs = {
  filter: AnalyticsFilterInput;
};


export type QueryDownloadAllGrnItemsArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  isRegisterAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  registerId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryDownloadFpInventoryArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  isRegisterAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  registerId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryDownloadGetProductLotStockReportArgs = {
  filters: ProductStockReportArgs;
};


export type QueryDownloadOrderItemReportArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  isRegisterAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  registerId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryDownloadOrderReportArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  isRegisterAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  registerId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryDownloadPurchaseOrderItemArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  isRegisterAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  registerId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryDownloadPurchaseOrdersArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  isRegisterAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  registerId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryDownloadTransferItemsArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  isRegisterAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  registerId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryDownloadTransfersArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  isRegisterAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  registerId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryEntitiesArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryEntityArgs = {
  id: Scalars['ID']['input'];
};


export type QueryExportJobsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFiscalPeriodArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFiscalPeriodsArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryFiscalPeriodsByFiscalYearArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  fiscalYearId: Scalars['ID']['input'];
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryFiscalYearArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFiscalYearsArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryFiscalYearsByEntityArgs = {
  entityId: Scalars['ID']['input'];
  filter?: InputMaybe<Array<FilterGroup>>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryFlowRecipientsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFlowRunsArgs = {
  flowId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFulfillmentOrderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFulfillmentOrderEventsArgs = {
  fulfillmentOrderId: Scalars['ID']['input'];
};


export type QueryFulfillmentOrderGroupArgs = {
  orderId: Scalars['ID']['input'];
};


export type QueryFulfillmentOrderListArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  isRegisterAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  registerId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortCondition>>;
  tabFilter?: InputMaybe<FulfillmentOrderListFilter>;
};


export type QueryFulfillmentOrderPickingProgressArgs = {
  fulfillmentOrderId: Scalars['ID']['input'];
};


export type QueryFulfillmentOrderTabCountsArgs = {
  locationId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFulfillmentOrdersArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  isRegisterAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  registerId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryFulfillmentStatsArgs = {
  filter: AnalyticsFilterInput;
};


export type QueryFusionCarrierCostCentresArgs = {
  connectionId: Scalars['String']['input'];
};


export type QueryFusionCarrierHealthArgs = {
  connectionId: Scalars['String']['input'];
  probe?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryFusionCarrierLabelArgs = {
  connectionId: Scalars['String']['input'];
  trackingNumber: Scalars['String']['input'];
};


export type QueryFusionCarrierLocationMappingsArgs = {
  connectionId: Scalars['String']['input'];
};


export type QueryFusionConnectionArgs = {
  accountId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type QueryFusionConnectionsArgs = {
  accountId: Scalars['String']['input'];
  connectorCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFusionConnectorEntitlementsArgs = {
  connectorCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFusionExternalObjectMappingsArgs = {
  accountId: Scalars['String']['input'];
  connectionId: Scalars['String']['input'];
  oneObjectType: Scalars['String']['input'];
};


export type QueryFusionIntegrationArgs = {
  connectionId: Scalars['String']['input'];
};


export type QueryFusionIntegrationEventsArgs = {
  connectionId: Scalars['String']['input'];
};


export type QueryFusionIntegrationExternalLocationsArgs = {
  connectionId: Scalars['String']['input'];
};


export type QueryFusionIntegrationLocationsArgs = {
  connectionId: Scalars['String']['input'];
};


export type QueryFusionIntegrationOperationsArgs = {
  connectionId: Scalars['String']['input'];
};


export type QueryFusionIntegrationProductSearchArgs = {
  query: Scalars['String']['input'];
};


export type QueryFusionIntegrationProductTemplateArgs = {
  connectionId: Scalars['String']['input'];
};


export type QueryFusionIntegrationProductsArgs = {
  connectionId: Scalars['String']['input'];
};


export type QueryFusionRiderCodBalancesArgs = {
  connectionId: Scalars['String']['input'];
};


export type QueryFusionRiderCodOutstandingArgs = {
  connectionId: Scalars['String']['input'];
};


export type QueryFusionRiderCodParcelsArgs = {
  connectionId: Scalars['String']['input'];
  riderId: Scalars['String']['input'];
};


export type QueryFusionRidersArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  connectionId: Scalars['String']['input'];
};


export type QueryFusionShipmentsArgs = {
  input?: InputMaybe<ListFusionShipmentsInput>;
};


export type QueryGeneralLedgerReportArgs = {
  costCenterIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  endDate: Scalars['DateTime']['input'];
  entityId: Scalars['ID']['input'];
  locationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  profitCenterIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate: Scalars['DateTime']['input'];
};


export type QueryGetAddressArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetAddressesArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  isRegisterAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  registerId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryGetAdjustmentArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetAdjustmentsArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  isRegisterAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  registerId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryGetAllAuditLotsArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  isRegisterAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  registerId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryGetAllAuditsArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  isRegisterAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  registerId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryGetAllGrnItemsArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  isRegisterAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  registerId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryGetAllGrnsArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  isRegisterAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  registerId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryGetAllStockOperationsArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  isRegisterAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  registerId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryGetAuditArgs = {
  auditId: Scalars['String']['input'];
};


export type QueryGetAuditLotArgs = {
  actionId: Scalars['String']['input'];
  auditProductId: Scalars['String']['input'];
};


export type QueryGetAuditProductSummaryArgs = {
  auditProductId: Scalars['String']['input'];
};


export type QueryGetAuditSummaryArgs = {
  auditId: Scalars['String']['input'];
};


export type QueryGetBaseQuantityByProductAndLocationArgs = {
  productId: Scalars['String']['input'];
};


export type QueryGetBomArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetBomVersionArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetBomVersionsArgs = {
  bomId?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Array<FilterGroup>>;
  isRegisterAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  registerId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryGetBomsArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  isRegisterAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  registerId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryGetBulkProductLotsArgs = {
  actionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  anyOneActionIds?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
  locationId: Scalars['String']['input'];
};


export type QueryGetCategoriesArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  isRegisterAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  registerId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryGetCategoryArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetCitiesArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  isRegisterAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  registerId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryGetCitiesByCountryArgs = {
  countryId: Scalars['String']['input'];
};


export type QueryGetCountryArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetCustomerArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetCustomersArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  isRegisterAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  registerId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryGetDemandNoteArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['Float']['input']>;
  secondaryId?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryGetDemandNotesArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  isRegisterAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  registerId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryGetDiscountArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetDiscountsArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  isRegisterAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  registerId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryGetGenericFormulaArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetGenericFormulasArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  isRegisterAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  registerId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryGetGrnByProductIdArgs = {
  productId: Array<Scalars['String']['input']>;
};


export type QueryGetIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetIntegrationsArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  isRegisterAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  registerId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryGetInvoicePolicyConfigArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetInvoicePolicyConfigsArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryGetLocationArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetLocationRegisterArgs = {
  id: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
};


export type QueryGetLocationRegisterBalanceHistoryBySessionIdArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  isRegisterAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  registerId?: InputMaybe<Scalars['String']['input']>;
  sessionId: Scalars['String']['input'];
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryGetLocationRegisterSessionsArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  isRegisterAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  registerId?: InputMaybe<Scalars['String']['input']>;
  registerSessionId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryGetLocationRegistersArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  isRegisterAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  registerId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryGetLocationSessionSummaryByIdArgs = {
  sessionId: Scalars['String']['input'];
};


export type QueryGetLocationsArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  isRegisterAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  registerId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryGetLostSaleArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetLostSalesArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  isRegisterAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  registerId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryGetManufacturerArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetManufacturersArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  isRegisterAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  registerId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryGetMediaAssetsArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  isRegisterAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  registerId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryGetOneGrnArgs = {
  grnId: Scalars['String']['input'];
};


export type QueryGetOneStockOperationArgs = {
  stockOperationId: Scalars['String']['input'];
};


export type QueryGetOrderArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  secondaryId?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryGetOrderLineItemLotsArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  isRegisterAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  orderLineItemId: Scalars['String']['input'];
  page?: Scalars['Int']['input'];
  registerId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryGetOrdersArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  isRegisterAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  registerId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryGetPdfStockReturnArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetPartnerArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetPartnerFinancialTermArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetPartnerFinancialTermsArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  isRegisterAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  registerId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryGetPartnerFinancialTermsByPartnerArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  isRegisterAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  partnerId: Scalars['String']['input'];
  registerId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryGetPartnersArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  isRegisterAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  registerId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryGetPermissionArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetPermissionByRoleIdArgs = {
  role_id: Scalars['String']['input'];
};


export type QueryGetPermissionsArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  isRegisterAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  registerId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryGetPickerUsersArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  isRegisterAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  registerId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryGetPlatformFeeConfigArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetPlatformFeeConfigsArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  isRegisterAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  registerId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryGetPrinterConfigArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetPrinterConfigsArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  isRegisterAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  registerId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryGetProductArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetProductLotArgs = {
  actionId?: InputMaybe<Scalars['String']['input']>;
  anyOneActionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  locationId: Scalars['String']['input'];
};


export type QueryGetProductLotStockReportArgs = {
  productStockReportDTO: ProductStockReportArgs;
};


export type QueryGetProductLotsArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  isRegisterAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  registerId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryGetProductManufacturingPricesArgs = {
  productId: Scalars['String']['input'];
};


export type QueryGetProductionOrderArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetProductionOrdersArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  isRegisterAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  registerId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryGetProductionPlanArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetProductionPlanMaterialReferenceArgs = {
  productionOrderId: Scalars['String']['input'];
};


export type QueryGetProductionPlansArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  isRegisterAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  registerId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryGetProductsArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  isRegisterAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  registerId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryGetProductsByVendorArgs = {
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  vendorId: Scalars['String']['input'];
};


export type QueryGetPurchaseOrderArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  secondaryId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetPurchaseOrdersArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  isRegisterAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  registerId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryGetRegisterSummaryByIdArgs = {
  sessionId: Scalars['String']['input'];
};


export type QueryGetReturnOrderArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetReturnOrderLineItemLotsArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  isRegisterAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  registerId?: InputMaybe<Scalars['String']['input']>;
  returnOrderLineItemId: Scalars['String']['input'];
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryGetReturnedOrdersArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  isRegisterAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  registerId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryGetRoleArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetRolesArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  isRegisterAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  registerId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryGetStockReturnArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetStockReturnsArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  isRegisterAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  registerId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryGetTagArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetTagsArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  isRegisterAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  registerId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryGetTaxGroupArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetTaxGroupsArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  isRegisterAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  registerId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryGetTenantArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetTransferArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetTransferProductsArgs = {
  transferId: Scalars['String']['input'];
};


export type QueryGetTransferReceivesArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  isRegisterAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  locationId: Scalars['String']['input'];
  page?: Scalars['Int']['input'];
  registerId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryGetTransfersArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  isRegisterAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  registerId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryGetUnexpiredProductLotsArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  isRegisterAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  registerId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryGetUserArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetUsersArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  isRegisterAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  registerId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryGetVendorArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetVendorsArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  isRegisterAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  registerId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryGetZReportByLocationAndDateArgs = {
  endDate: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


export type QueryGrnSummaryArgs = {
  endDate: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


export type QueryIncomeStatementReportArgs = {
  costCenterIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  endDate: Scalars['DateTime']['input'];
  entityId: Scalars['ID']['input'];
  locationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  profitCenterIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate: Scalars['DateTime']['input'];
};


export type QueryJournalHeaderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryJournalHeadersArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryJournalLineArgs = {
  id: Scalars['ID']['input'];
};


export type QueryJournalLinesArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryJournalLinesByHeaderIdArgs = {
  journalHeaderId: Scalars['ID']['input'];
};


export type QueryNotificationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  readOnly?: InputMaybe<Scalars['Boolean']['input']>;
  unreadOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryOpenFiscalPeriodsArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  fiscalYearId: Scalars['ID']['input'];
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryOrderCancellationsArgs = {
  orderId: Scalars['ID']['input'];
};


export type QueryOrderManagementSummaryArgs = {
  endDate: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


export type QueryOrderStatusHistoryArgs = {
  entityId: Scalars['ID']['input'];
  entityType: StatusHistoryEntityType;
};


export type QueryOrdersByStatusArgs = {
  filter: AnalyticsFilterInput;
};


export type QueryOutstandingAccountPayableInvoicesArgs = {
  filter: OutstandingApInvoiceFilterInput;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryOutstandingAccountReceivableInvoicesArgs = {
  filter: OutstandingInvoiceFilterInput;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryPaymentMethodBreakdownArgs = {
  filter: AnalyticsFilterInput;
};


export type QueryPaymentTermArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPaymentTermsArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryPickerTaskArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPickerTaskLotsArgs = {
  taskId: Scalars['ID']['input'];
};


export type QueryPickerTasksArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  isRegisterAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  registerId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortCondition>>;
  tabFilter?: InputMaybe<PickerTaskTabFilter>;
};


export type QueryPlatformTenantReportArgs = {
  accountId: Scalars['String']['input'];
  reportId: Scalars['String']['input'];
};


export type QueryPlatformTenantReportsArgs = {
  accountId: Scalars['String']['input'];
};


export type QueryPosHeldOrdersArgs = {
  input: PosHeldOrdersInput;
};


export type QueryProfitCenterArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProfitCentersArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryProfitCentersByEntityArgs = {
  entityId: Scalars['ID']['input'];
  filter?: InputMaybe<Array<FilterGroup>>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryPurchaseOrderSummaryArgs = {
  endDate: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


export type QueryRawParameterOptionsArgs = {
  input: RawParameterOptionsInput;
};


export type QueryReportArgs = {
  id: Scalars['String']['input'];
};


export type QueryReportsArgs = {
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryResolveFusionConnectorEntitlementArgs = {
  accountId: Scalars['String']['input'];
  connectorCode: Scalars['String']['input'];
};


export type QueryReturnOverviewArgs = {
  filter: AnalyticsFilterInput;
};


export type QueryReturnsByProductArgs = {
  filter: AnalyticsFilterInput;
};


export type QueryReturnsOverTimeArgs = {
  filter: AnalyticsFilterInput;
};


export type QueryRunRawReportArgs = {
  input: RunRawReportInput;
};


export type QueryRunReportArgs = {
  input: RunReportInput;
};


export type QueryRunReportDetailArgs = {
  input: RunReportDetailInput;
};


export type QuerySalesByCashierArgs = {
  filter: AnalyticsFilterInput;
};


export type QuerySalesByChannelArgs = {
  filter: AnalyticsFilterInput;
};


export type QuerySalesByLocationArgs = {
  filter: AnalyticsFilterInput;
};


export type QuerySalesOverTimeArgs = {
  filter: AnalyticsFilterInput;
};


export type QuerySalesOverviewArgs = {
  filter: AnalyticsFilterInput;
};


export type QuerySavedDatasetUsageArgs = {
  id: Scalars['String']['input'];
};


export type QueryShareableSubjectsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySourceModuleArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySourceModulesArgs = {
  filter?: InputMaybe<Array<FilterGroup>>;
  limit?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortCondition>>;
};


export type QueryStockIntakeSummaryArgs = {
  endDate: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


export type QueryStockOperationItemImportJobArgs = {
  importJobId: Scalars['String']['input'];
};


export type QueryTopCustomersArgs = {
  filter: AnalyticsFilterInput;
};


export type QueryTopProductsArgs = {
  filter: AnalyticsFilterInput;
};


export type QueryTrialBalanceReportArgs = {
  costCenterIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  endDate: Scalars['DateTime']['input'];
  entityId: Scalars['ID']['input'];
  locationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  profitCenterIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate: Scalars['DateTime']['input'];
};


export type QueryUnopenedProductLotInfoArgs = {
  locationId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};


export type QueryValidateAdjustmentLotsArgs = {
  validateAdjustmentDto: ValidateAdjustmentDto;
};


export type QueryValidateInvitationArgs = {
  id: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type RawFilterInput = {
  field: Scalars['String']['input'];
  op?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['JSON']['input'];
};

export type RawParameterOptionsInput = {
  parameterDefs?: InputMaybe<Scalars['JSON']['input']>;
  parameterName: Scalars['String']['input'];
  reportId?: InputMaybe<Scalars['String']['input']>;
};

export type RawPivotInput = {
  column?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<RawFilterInput>>;
  rows: Array<Scalars['String']['input']>;
  values: Array<RawPivotValueInput>;
};

export type RawPivotValueInput = {
  agg: Scalars['String']['input'];
  field: Scalars['String']['input'];
};

export type ReadyToDispatchInput = {
  consignmentNumber?: InputMaybe<Scalars['String']['input']>;
  consignmentUrl?: InputMaybe<Scalars['String']['input']>;
  fulfillmentOrderId: Scalars['ID']['input'];
  shippingProvider?: InputMaybe<Scalars['String']['input']>;
  trackingUrl?: InputMaybe<Scalars['String']['input']>;
};

export enum ReceiptTemplateType {
  Template_1 = 'TEMPLATE_1',
  Template_2 = 'TEMPLATE_2',
  Template_3 = 'TEMPLATE_3'
}

export type ReceiveReturnedParcelInput = {
  fulfillmentOrderId: Scalars['ID']['input'];
  idempotencyKey: Scalars['String']['input'];
  /** An open session at the location: for a cash refund, and the till for FBR-reported orders. */
  registerSessionId?: InputMaybe<Scalars['ID']['input']>;
};

export type ReceiveTransferItemsInput = {
  transferId: Scalars['String']['input'];
  transferItemsWithQuantities: Array<TransferItemReceiveInput>;
};

export type RegisterFulfillmentLotInput = {
  lotId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};

export type RegisterSessionSummaryDto = {
  balance: Scalars['Float']['output'];
  cashRefundTotal: Scalars['Float']['output'];
  closingAmount: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  openingAmount: Scalars['Float']['output'];
  returnTotalAmount: Scalars['Float']['output'];
  totalAdditions: Scalars['Float']['output'];
  totalAmount: Scalars['Float']['output'];
  totalDiscount: Scalars['Float']['output'];
  totalWithdrawals: Scalars['Float']['output'];
};

export type RejectLotInput = {
  fromRegister?: InputMaybe<Scalars['Boolean']['input']>;
  lots: Array<RejectLotItemInput>;
};

export type RejectLotItemInput = {
  actionId: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  fulfillmentOrderId: Scalars['ID']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
  reason: LotOverrideReason;
};

export type RejectLotItemResult = {
  actionId: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type RejectLotResult = {
  results: Array<RejectLotItemResult>;
  success: Scalars['Boolean']['output'];
};

export type ReleasePosOrderInput = {
  id: Scalars['String']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  registerId?: InputMaybe<Scalars['String']['input']>;
};

export type ReleasePosOrderPayload = {
  releasedOrder?: Maybe<PosHeldOrder>;
  snapshot: Scalars['JSON']['output'];
};

export type RemoveFusionCarrierLocationMappingInput = {
  connectionId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
};

export type RemoveFusionIntegrationMappingInput = {
  connectionId: Scalars['String']['input'];
  oneObjectId: Scalars['String']['input'];
};

export type RemoveTenantOverrideInput = {
  accountId: Scalars['String']['input'];
  connectorCode: Scalars['String']['input'];
};

export type RepayFusionRiderInput = {
  amount: Scalars['Float']['input'];
  connectionId: Scalars['String']['input'];
  destinationType?: FusionCodDestinationType;
  note?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  riderId: Scalars['String']['input'];
};

export type ReportBucketsInput = {
  boundaries: Array<Scalars['Float']['input']>;
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ReportColumn = {
  format?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  kind: ReportColumnKind;
  label: Scalars['String']['output'];
  table?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export enum ReportColumnKind {
  Dimension = 'DIMENSION',
  Measure = 'MEASURE'
}

export type ReportComparison = {
  end: Scalars['DateTime']['output'];
  rows: Scalars['JSON']['output'];
  start: Scalars['DateTime']['output'];
};

export type ReportDataset = {
  defaultDateDimension?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dimensions: Array<ReportDimensionMeta>;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  measures: Array<ReportMeasureMeta>;
  service: Scalars['String']['output'];
  source: Scalars['String']['output'];
  supportsEntity: Scalars['Boolean']['output'];
  supportsLocationScope: Scalars['Boolean']['output'];
};

export type ReportDateRangeInput = {
  dimensionKey?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  preset?: InputMaybe<AnalyticsDatePreset>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ReportDefinition = {
  cacheTtlSeconds?: Maybe<Scalars['Int']['output']>;
  chartConfig?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['DateTime']['output'];
  datasetKey: Scalars['String']['output'];
  definition: Scalars['JSON']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isSavedDataset: Scalars['Boolean']['output'];
  isSystem: Scalars['Boolean']['output'];
  myAccess?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  ownerName?: Maybe<Scalars['String']['output']>;
  ownerUserId?: Maybe<Scalars['String']['output']>;
  persistence?: Maybe<ReportPersistence>;
  sharedWithMe?: Maybe<Scalars['Boolean']['output']>;
  systemKey?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  visibility: ReportVisibility;
};

export type ReportDefinitionPage = {
  data: Array<ReportDefinition>;
  meta: ReportPageMeta;
};

export type ReportDimensionInput = {
  buckets?: InputMaybe<ReportBucketsInput>;
  granularity?: InputMaybe<AnalyticsGranularity>;
  key: Scalars['String']['input'];
};

export type ReportDimensionMeta = {
  calculated?: Maybe<CalculatedColumnInfo>;
  enumValues?: Maybe<Array<Scalars['String']['output']>>;
  filterOnly: Scalars['Boolean']['output'];
  format?: Maybe<Scalars['String']['output']>;
  joinLabel?: Maybe<Scalars['String']['output']>;
  joinTable?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  noAverage: Scalars['Boolean']['output'];
  supportsBucketing: Scalars['Boolean']['output'];
  supportsGranularity: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
};

export type ReportEntityOption = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ReportFilterCondition = {
  field: Scalars['String']['input'];
  operator: ReportFilterOperator;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type ReportFilterGroup = {
  conditions: Array<ReportFilterCondition>;
  logicalOperator: LogicalOperator;
};

export enum ReportFilterOperator {
  Between = 'BETWEEN',
  DatePreset = 'DATE_PRESET',
  EndsWith = 'ENDS_WITH',
  Equal = 'EQUAL',
  Gt = 'GT',
  Gte = 'GTE',
  IsBlank = 'IS_BLANK',
  Like = 'LIKE',
  Lt = 'LT',
  Lte = 'LTE',
  Ne = 'NE',
  NotBlank = 'NOT_BLANK',
  NotLike = 'NOT_LIKE',
  StartsWith = 'STARTS_WITH'
}

export type ReportHavingInput = {
  measure: Scalars['String']['input'];
  operator: ReportFilterOperator;
  value: Scalars['Float']['input'];
};

export type ReportJoinInput = {
  leftField: Scalars['String']['input'];
  rightField: Scalars['String']['input'];
  table: Scalars['String']['input'];
};

export type ReportMeasureMeta = {
  format: Scalars['String']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type ReportPageMeta = {
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type ReportPersistence = {
  enabled: Scalars['Boolean']['output'];
  lastRefreshedAt?: Maybe<Scalars['DateTime']['output']>;
  refreshIntervalSeconds: Scalars['Int']['output'];
  rowCount?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type ReportResult = {
  columnTotals?: Maybe<Scalars['JSON']['output']>;
  columns: Array<ReportColumn>;
  comparison?: Maybe<ReportComparison>;
  executionMs: Scalars['Int']['output'];
  groupCount?: Maybe<Scalars['Int']['output']>;
  hasMore: Scalars['Boolean']['output'];
  rows: Scalars['JSON']['output'];
  totals?: Maybe<Scalars['JSON']['output']>;
};

export type ReportSortInput = {
  direction: SortDirection;
  key: Scalars['String']['input'];
};

export enum ReportVisibility {
  Private = 'PRIVATE',
  Published = 'PUBLISHED'
}

export enum ReportingGroup {
  Bs = 'BS',
  Pl = 'PL'
}

export enum ResetCycle {
  CalendarYear = 'CALENDAR_YEAR',
  FiscalYear = 'FISCAL_YEAR',
  Never = 'NEVER'
}

export enum RestockTarget {
  Quarantine = 'QUARANTINE',
  Sellable = 'SELLABLE'
}

export type Return = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  createdByUser?: Maybe<User>;
  gatePassNumber: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isVendorOverwritet: Scalars['Boolean']['output'];
  location: Location;
  returnItems: Array<ReturnItem>;
  secondaryId?: Maybe<Scalars['Float']['output']>;
  status: Scalars['String']['output'];
  totalProducts?: Maybe<Scalars['Int']['output']>;
  totalQty?: Maybe<Scalars['Int']['output']>;
  totalValue?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  vendor: Vendor;
  vendorId?: Maybe<Scalars['String']['output']>;
};

export type ReturnDataPointDto = {
  period: Scalars['DateTime']['output'];
  returnAmount: Scalars['Float']['output'];
  returnCount: Scalars['Float']['output'];
};

export type ReturnItem = {
  id: Scalars['String']['output'];
  product: Product;
  productLot: ProductLot;
  quantity: Scalars['Float']['output'];
  return: Return;
  secondaryId?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type ReturnOrder = {
  comment?: Maybe<Scalars['String']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  costTax?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customer?: Maybe<Customer>;
  customerId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  integrationCharges: Scalars['Float']['output'];
  integrationConfigs: Array<ReturnOrderIntegrationConfig>;
  items: Array<ReturnOrderLineItem>;
  location?: Maybe<Location>;
  locationId?: Maybe<Scalars['String']['output']>;
  locationRegisterSession?: Maybe<LocationRegisterSession>;
  order?: Maybe<Order>;
  parentOrderId?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<ReturnOrderPaymentMethod>;
  reason?: Maybe<Scalars['String']['output']>;
  registerSessionId?: Maybe<Scalars['String']['output']>;
  returnedBy?: Maybe<Scalars['String']['output']>;
  secondaryId?: Maybe<Scalars['Float']['output']>;
  status: OrderStatus;
  totalAmount: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ReturnOrderDto = {
  /** Generated once when the return screen opens, so a double submit can't refund twice. */
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  items: Array<OrderReturnItemInput>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
  paymentMethod?: InputMaybe<ReturnOrderPaymentMethod>;
  reason?: InputMaybe<ReturnReason>;
  registerSessionId?: InputMaybe<Scalars['String']['input']>;
  returnReason?: InputMaybe<Scalars['String']['input']>;
};

export type ReturnOrderIntegrationConfig = {
  apiResponseId?: Maybe<Scalars['String']['output']>;
  charges?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastFailedAt?: Maybe<Scalars['DateTime']['output']>;
  lastFailedReason?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  returnOrder: Order;
  returnOrderId?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  type: IntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ReturnOrderLineItem = {
  cost?: Maybe<Scalars['Float']['output']>;
  costTax?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discount: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  image?: Maybe<Scalars['String']['output']>;
  lots?: Maybe<Array<ReturnOrderLineItemLot>>;
  name: Scalars['String']['output'];
  orderId?: Maybe<Scalars['String']['output']>;
  orderLineItemId?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Product>;
  productId?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Float']['output'];
  restockTo: RestockTarget;
  returnOrder: ReturnOrder;
  secondaryId?: Maybe<Scalars['Float']['output']>;
  subTotal: Scalars['Float']['output'];
  tax?: Maybe<Scalars['Float']['output']>;
  taxRate?: Maybe<Scalars['Float']['output']>;
  totalPrice: Scalars['Float']['output'];
  unitPrice: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ReturnOrderLineItemLot = {
  id: Scalars['String']['output'];
  orderLineItemId?: Maybe<Scalars['String']['output']>;
  productLot: ProductLot;
  productLotId?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Float']['output'];
  returnOrderLineItem: ReturnOrderLineItem;
};

export type ReturnOrderLineItemLotResponseDto = {
  data: Array<ReturnOrderLineItemLot>;
  meta: MetaResponse;
};

/** Possible statuses for an ReturnOrder */
export enum ReturnOrderPaymentMethod {
  BankTransfer = 'BANK_TRANSFER',
  Card = 'CARD',
  Cash = 'CASH',
  CodNotCollected = 'COD_NOT_COLLECTED',
  Credit = 'CREDIT',
  Voucher = 'VOUCHER'
}

export type ReturnOrderResponseDto = {
  data: Array<ReturnOrder>;
  meta: MetaResponse;
};

export type ReturnOverviewDto = {
  avgReturnOrderValue: Scalars['Float']['output'];
  returnRate: Scalars['Float']['output'];
  totalReturnAmount: Scalars['Float']['output'];
  totalReturnOrders: Scalars['Float']['output'];
  totalReturnTax: Scalars['Float']['output'];
  totalReturnedItems: Scalars['Float']['output'];
};

export type ReturnProductInfoDto = {
  createdByName?: Maybe<Scalars['String']['output']>;
  designation?: Maybe<Scalars['String']['output']>;
  gatepass?: Maybe<Scalars['String']['output']>;
  grandTotal?: Maybe<Scalars['Float']['output']>;
  returnDate?: Maybe<Scalars['DateTime']['output']>;
  returnId: Scalars['ID']['output'];
  returns?: Maybe<Array<ReturnProductObjDto>>;
  vendorName?: Maybe<Scalars['String']['output']>;
};

export type ReturnProductObjDto = {
  averagePurchasingPrice?: Maybe<Scalars['Float']['output']>;
  gatepass?: Maybe<Scalars['String']['output']>;
  grandTotal?: Maybe<Scalars['Float']['output']>;
  lotCount?: Maybe<Scalars['Int']['output']>;
  productId: Scalars['ID']['output'];
  productName?: Maybe<Scalars['String']['output']>;
  returnDate?: Maybe<Scalars['DateTime']['output']>;
  returnId?: Maybe<Scalars['ID']['output']>;
  totalPurchasingPrice?: Maybe<Scalars['Float']['output']>;
  vendorName?: Maybe<Scalars['String']['output']>;
};

export enum ReturnReason {
  CustomerChangedMind = 'CUSTOMER_CHANGED_MIND',
  Damaged = 'DAMAGED',
  DeliveredByMistake = 'DELIVERED_BY_MISTAKE',
  Expired = 'EXPIRED',
  Other = 'OTHER',
  RefusedAtDoor = 'REFUSED_AT_DOOR',
  WrongItem = 'WRONG_ITEM'
}

export type ReturnsByProductDto = {
  productId: Scalars['String']['output'];
  productName: Scalars['String']['output'];
  returnAmount: Scalars['Float']['output'];
  returnCount: Scalars['Float']['output'];
  returnQuantity: Scalars['Float']['output'];
  returnRate: Scalars['Float']['output'];
};

/** When a tenant's sales are recognised: at order confirmation, at delivery, or at dispatch (reserved) */
export enum RevenueRecognitionMode {
  AtDelivery = 'AT_DELIVERY',
  AtDispatch = 'AT_DISPATCH',
  AtOrder = 'AT_ORDER'
}

export type Role = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  secondaryId?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Status>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type RoleDto = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type RoleInputDto = {
  name: Scalars['String']['input'];
  status: Scalars['String']['input'];
};

export type RoleResponseDto_ = {
  data: Array<Role>;
  meta: MetaResponse;
};

export enum RoutingStrategy {
  LineFirstFit = 'LINE_FIRST_FIT',
  SingleLocationFirst = 'SINGLE_LOCATION_FIRST'
}

export type RunRawReportInput = {
  calculatedColumns?: InputMaybe<Array<CalculatedColumnInput>>;
  dashboardId?: InputMaybe<Scalars['String']['input']>;
  detailFilters?: InputMaybe<Array<RawFilterInput>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  parameterDefs?: InputMaybe<Scalars['JSON']['input']>;
  parameters?: InputMaybe<Scalars['JSON']['input']>;
  pivot?: InputMaybe<RawPivotInput>;
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
  reportId?: InputMaybe<Scalars['String']['input']>;
  sampleRows?: InputMaybe<Scalars['Int']['input']>;
  sql: Scalars['String']['input'];
};

export type RunReportDetailInput = {
  calculatedColumns?: InputMaybe<Array<CalculatedColumnInput>>;
  columns?: InputMaybe<Array<Scalars['String']['input']>>;
  dashboardId?: InputMaybe<Scalars['String']['input']>;
  datasetKey: Scalars['String']['input'];
  dateRange?: InputMaybe<ReportDateRangeInput>;
  dimensions?: InputMaybe<Array<ReportDimensionInput>>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<ReportFilterGroup>>;
  includeCount?: InputMaybe<Scalars['Boolean']['input']>;
  joins?: InputMaybe<Array<ReportJoinInput>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
  reportId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<ReportSortInput>>;
};

export type RunReportInput = {
  calculatedColumns?: InputMaybe<Array<CalculatedColumnInput>>;
  compareWith?: InputMaybe<AnalyticsCompareWith>;
  computedMeasures?: InputMaybe<Array<ComputedMeasureInput>>;
  dashboardId?: InputMaybe<Scalars['String']['input']>;
  datasetKey: Scalars['String']['input'];
  dateRange?: InputMaybe<ReportDateRangeInput>;
  dimensions?: Array<ReportDimensionInput>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<ReportFilterGroup>>;
  having?: InputMaybe<Array<ReportHavingInput>>;
  includeTotals?: InputMaybe<Scalars['Boolean']['input']>;
  joins?: InputMaybe<Array<ReportJoinInput>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  listColumns?: InputMaybe<Array<Scalars['String']['input']>>;
  locationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  measures?: Array<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
  reportId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<ReportSortInput>>;
  totalsDimensions?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SalesDataPointDto = {
  avgOrderValue: Scalars['Float']['output'];
  netSales: Scalars['Float']['output'];
  orderCount: Scalars['Float']['output'];
  period: Scalars['DateTime']['output'];
  totalSales: Scalars['Float']['output'];
};

export type SalesOverviewDto = {
  avgOrderValue: Scalars['Float']['output'];
  avgOrderValueComparison?: Maybe<PeriodComparisonDto>;
  bankTransferCollected: Scalars['Float']['output'];
  cancelledOrders: Scalars['Float']['output'];
  cardCollected: Scalars['Float']['output'];
  cashCollected: Scalars['Float']['output'];
  completedOrders: Scalars['Float']['output'];
  creditSales: Scalars['Float']['output'];
  grossSales: Scalars['Float']['output'];
  grossSalesComparison?: Maybe<PeriodComparisonDto>;
  netSales: Scalars['Float']['output'];
  netSalesComparison?: Maybe<PeriodComparisonDto>;
  newCustomers: Scalars['Float']['output'];
  pendingOrders: Scalars['Float']['output'];
  returnedOrders: Scalars['Float']['output'];
  returnedOrdersComparison?: Maybe<PeriodComparisonDto>;
  returningCustomers: Scalars['Float']['output'];
  totalCustomers: Scalars['Float']['output'];
  totalCustomersComparison?: Maybe<PeriodComparisonDto>;
  totalDeliveryCharges: Scalars['Float']['output'];
  totalDeliveryChargesComparison?: Maybe<PeriodComparisonDto>;
  totalDiscount: Scalars['Float']['output'];
  totalDiscountComparison?: Maybe<PeriodComparisonDto>;
  totalIntegrationCharges: Scalars['Float']['output'];
  totalIntegrationChargesComparison?: Maybe<PeriodComparisonDto>;
  totalOrders: Scalars['Float']['output'];
  totalOrdersComparison?: Maybe<PeriodComparisonDto>;
  totalPlatformFee: Scalars['Float']['output'];
  totalPlatformFeeComparison?: Maybe<PeriodComparisonDto>;
  totalReturnAmount: Scalars['Float']['output'];
  totalReturnAmountComparison?: Maybe<PeriodComparisonDto>;
  totalSales: Scalars['Float']['output'];
  totalSalesComparison?: Maybe<PeriodComparisonDto>;
  totalTax: Scalars['Float']['output'];
  totalTaxComparison?: Maybe<PeriodComparisonDto>;
};

export type SavedDatasetUsage = {
  columns: Array<SavedDatasetUser>;
  reports: Array<SavedDatasetUser>;
};

export type SavedDatasetUser = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ScanLotsDto = {
  auditId: Scalars['String']['input'];
  boxQuantity?: InputMaybe<Scalars['Int']['input']>;
  force: Scalars['Boolean']['input'];
  openQuantity?: InputMaybe<Scalars['Int']['input']>;
  productId: Scalars['String']['input'];
  scannedLotActionId: Scalars['String']['input'];
};

export type ScanPickerTaskUnitInput = {
  actionId?: InputMaybe<Scalars['String']['input']>;
  anyOneActionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  lotId?: InputMaybe<Scalars['ID']['input']>;
  quantity?: Scalars['Int']['input'];
  taskId: Scalars['ID']['input'];
};

export type ScanProductLotInput = {
  actionId?: InputMaybe<Scalars['String']['input']>;
  lotId?: InputMaybe<Scalars['String']['input']>;
  productSecondaryId?: InputMaybe<Scalars['Int']['input']>;
  quantity: Scalars['Int']['input'];
};

export type ScanProductLotOutput = {
  actionId?: Maybe<Scalars['String']['output']>;
  batchExpiry?: Maybe<Scalars['String']['output']>;
  batchNumber?: Maybe<Scalars['String']['output']>;
  cartQuantity?: Maybe<Scalars['Float']['output']>;
  gstValue?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isOpened?: Maybe<Scalars['Boolean']['output']>;
  mrpSellingUnit?: Maybe<Scalars['Float']['output']>;
  product: Product;
  purchasingPrice?: Maybe<Scalars['Float']['output']>;
  purchasingPriceUnit?: Maybe<Scalars['Float']['output']>;
  receivedQuantity?: Maybe<Scalars['Float']['output']>;
  sellableQuantity?: Maybe<Scalars['Float']['output']>;
  status: ScanStatus;
  taxSellingUnit?: Maybe<Scalars['Float']['output']>;
  tradePrice?: Maybe<Scalars['Float']['output']>;
};

export enum ScanStatus {
  Exceeded = 'EXCEEDED',
  Expired = 'EXPIRED',
  InvalidLocation = 'INVALID_LOCATION',
  NotFound = 'NOT_FOUND',
  Ok = 'OK'
}

export enum SerialGenerationType {
  Random = 'RANDOM',
  Series = 'SERIES'
}

export type SetFusionCarrierLocationMappingInput = {
  connectionId: Scalars['String']['input'];
  costCentreCode: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
};

export type SetFusionIntegrationEventInput = {
  connectionId: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  eventType: Scalars['String']['input'];
};

export type SetFusionIntegrationLocationInput = {
  connectionId: Scalars['String']['input'];
  externalVendorId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
};

export type SetFusionIntegrationProductInput = {
  connectionId: Scalars['String']['input'];
  externalSku: Scalars['String']['input'];
  maximumSalesQuantity?: InputMaybe<Scalars['Int']['input']>;
  productId: Scalars['String']['input'];
  stockBuffer?: InputMaybe<Scalars['Int']['input']>;
};

export type SetFusionIntegrationProductStockBufferInput = {
  connectionId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  stockBuffer?: InputMaybe<Scalars['Int']['input']>;
};

export type SetFusionRiderActiveInput = {
  active: Scalars['Boolean']['input'];
  riderId: Scalars['String']['input'];
};

export type SetPlatformDefaultInput = {
  connectorCode: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
};

export type SetTenantOverrideInput = {
  accountId: Scalars['String']['input'];
  connectorCode: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
};

export type SettleFusionRiderCodInput = {
  amount: Scalars['Float']['input'];
  connectionId: Scalars['String']['input'];
  destinationReference?: InputMaybe<Scalars['String']['input']>;
  destinationType?: FusionCodDestinationType;
  fulfillmentOrderIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  note?: InputMaybe<Scalars['String']['input']>;
  riderId: Scalars['String']['input'];
};

/** Possible statuses for an order */
export enum ShippingStatus {
  Delivered = 'DELIVERED',
  InTransit = 'IN_TRANSIT',
  NotApplicable = 'NOT_APPLICABLE',
  NotShipped = 'NOT_SHIPPED',
  PartiallyDelivered = 'PARTIALLY_DELIVERED',
  PartiallyShipped = 'PARTIALLY_SHIPPED',
  Shipped = 'SHIPPED'
}

export type SortCondition = {
  direction: SortDirection;
  field: Scalars['String']['input'];
};

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum SourceDocType {
  Adjustment = 'ADJUSTMENT',
  ApInvoice = 'AP_INVOICE',
  ApPayment = 'AP_PAYMENT',
  ApWriteoff = 'AP_WRITEOFF',
  ArInvoice = 'AR_INVOICE',
  ArReceipt = 'AR_RECEIPT',
  ArWriteoff = 'AR_WRITEOFF',
  CashDeposit = 'CASH_DEPOSIT',
  DayEndSummary = 'DAY_END_SUMMARY',
  Grn = 'GRN',
  Return = 'RETURN',
  Sales = 'SALES',
  SalesReturn = 'SALES_RETURN',
  Transfer = 'TRANSFER',
  TransferReceipt = 'TRANSFER_RECEIPT'
}

export type SourceModuleEntity = {
  allowManualNumber: Scalars['Boolean']['output'];
  autoPostEnabled: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  createdByName?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  entity?: Maybe<EntityModel>;
  entityId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  padding: Scalars['Int']['output'];
  prefix: Scalars['String']['output'];
  resetCycle: ResetCycle;
  secondaryId?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['ID']['output']>;
  updatedByName?: Maybe<Scalars['String']['output']>;
};

export type SourceModuleResponse = {
  data: Array<SourceModuleEntity>;
  meta: MetaResponse;
};

export type SqlColumn = {
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type SqlTable = {
  columns: Array<SqlColumn>;
  table: Scalars['String']['output'];
};

export type StartFusionIntegrationAuthorizationInput = {
  connectionId: Scalars['String']['input'];
  returnUrl: Scalars['String']['input'];
};

export type StatsResponseDto = {
  currentFiscalPeriod?: Maybe<FiscalPeriodStatsDto>;
  openJournalsCount: Scalars['Int']['output'];
  payablesOutstandingAmount: Scalars['Float']['output'];
  receivablesOutstandingAmount: Scalars['Float']['output'];
  totalPayablesCount: Scalars['Int']['output'];
  totalReceivablesCount: Scalars['Int']['output'];
};

export enum Status {
  Active = 'ACTIVE',
  Deactive = 'DEACTIVE',
  Inactive = 'INACTIVE'
}

export enum StatusApproval {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export enum StatusHistoryEntityType {
  Dispatch = 'DISPATCH',
  FulfillmentOrder = 'FULFILLMENT_ORDER',
  Order = 'ORDER'
}

export type StockIntakeSummaryDto = {
  gst: Scalars['Float']['output'];
  items: Scalars['Int']['output'];
  quantity: Scalars['Float']['output'];
  value: Scalars['Float']['output'];
};

export enum StockNature {
  FinishedGood = 'FINISHED_GOOD',
  FixedAsset = 'FIXED_ASSET',
  InternalConsumption = 'INTERNAL_CONSUMPTION',
  Packaging = 'PACKAGING',
  RawMaterial = 'RAW_MATERIAL'
}

export type StockOperation = {
  confirmedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  itemCount?: Maybe<Scalars['Int']['output']>;
  items?: Maybe<Array<StockOperationItem>>;
  location?: Maybe<Location>;
  operationType: StockOperationType;
  remarks?: Maybe<Scalars['String']['output']>;
  secondaryId?: Maybe<Scalars['Float']['output']>;
  status: StockOperationStatus;
  totalQuantity?: Maybe<Scalars['Int']['output']>;
  totalValue?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  warehouse?: Maybe<Location>;
};

export enum StockOperationImportFileType {
  Csv = 'CSV',
  Xlsx = 'XLSX'
}

export type StockOperationImportJob = {
  createdAt: Scalars['DateTime']['output'];
  errorCount?: Maybe<Scalars['Int']['output']>;
  errors?: Maybe<Array<StockOperationImportRowError>>;
  failureReason?: Maybe<Scalars['String']['output']>;
  fileType: StockOperationImportFileType;
  id: Scalars['String']['output'];
  processedRows?: Maybe<Scalars['Int']['output']>;
  status: StockOperationImportStatus;
  stockOperationId: Scalars['String']['output'];
  successCount?: Maybe<Scalars['Int']['output']>;
  totalRows?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type StockOperationImportRowError = {
  gtin?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  quantity?: Maybe<Scalars['Float']['output']>;
  row: Scalars['Int']['output'];
  secondaryId?: Maybe<Scalars['String']['output']>;
  skuCode?: Maybe<Scalars['String']['output']>;
};

export enum StockOperationImportStatus {
  Completed = 'COMPLETED',
  CompletedWithErrors = 'COMPLETED_WITH_ERRORS',
  Failed = 'FAILED',
  PendingUpload = 'PENDING_UPLOAD',
  Processing = 'PROCESSING',
  Queued = 'QUEUED'
}

export type StockOperationItem = {
  actionId?: Maybe<Scalars['String']['output']>;
  batchExpiry?: Maybe<Scalars['String']['output']>;
  batchNumber?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  gstValue?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  isManufacturerTracking: Scalars['Boolean']['output'];
  manufacturerCode?: Maybe<Scalars['String']['output']>;
  mfgDate?: Maybe<Scalars['String']['output']>;
  mrp?: Maybe<Scalars['Float']['output']>;
  product: Product;
  productLot?: Maybe<ProductLot>;
  productLotId?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Float']['output'];
  trackingLevel: TrackingLevel;
  tradePrice?: Maybe<Scalars['Float']['output']>;
  uomFactor?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type StockOperationResponseDto = {
  data: Array<StockOperation>;
  meta: MetaResponse;
};

export enum StockOperationStatus {
  Confirmed = 'CONFIRMED',
  Draft = 'DRAFT'
}

export enum StockOperationType {
  PriceUpdate = 'PRICE_UPDATE',
  StockIn = 'STOCK_IN',
  StockOut = 'STOCK_OUT'
}

export type StockReturnItemInput = {
  productLotId: Scalars['String']['input'];
  quantity: Scalars['Float']['input'];
};

export type StockReturnResponseDto = {
  data?: Maybe<Array<Return>>;
  meta: MetaResponse;
};

export enum StoreFulfillmentMode {
  Full = 'FULL',
  RegisterLite = 'REGISTER_LITE'
}

export enum SubledgerType {
  AccountsPayable = 'ACCOUNTS_PAYABLE',
  AccountsReceivable = 'ACCOUNTS_RECEIVABLE',
  Deferred = 'DEFERRED',
  FixedAssets = 'FIXED_ASSETS',
  Inventory = 'INVENTORY',
  None = 'NONE',
  Prepaid = 'PREPAID'
}

export type SubmitToQcDto = {
  batchIds?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['String']['input'];
  qcNotes?: InputMaybe<Scalars['String']['input']>;
};

export type SwapReservedLotInput = {
  fromLotId: Scalars['ID']['input'];
  idempotencyKey: Scalars['String']['input'];
  orderLineItemId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
  reason: LotOverrideReason;
  toLotId: Scalars['ID']['input'];
};

export type SyncResult = {
  failed: Array<Scalars['String']['output']>;
  synced: Scalars['Int']['output'];
};

export type SystemReportSyncResult = {
  accountId: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  removed?: Maybe<Scalars['Int']['output']>;
  upserted?: Maybe<Scalars['Int']['output']>;
};

export type SystemReportTemplate = {
  cacheTtlSeconds?: Maybe<Scalars['Int']['output']>;
  chartConfig?: Maybe<Scalars['JSON']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  datasetKey: Scalars['String']['output'];
  dedicatedOnly: Scalars['Boolean']['output'];
  definition: Scalars['JSON']['output'];
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
  systemKey: Scalars['String']['output'];
  targetAccountIds?: Maybe<Array<Scalars['String']['output']>>;
  targetDeployment: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SystemReportTemplateInput = {
  cacheTtlSeconds?: InputMaybe<Scalars['Int']['input']>;
  chartConfig?: InputMaybe<Scalars['JSON']['input']>;
  datasetKey: Scalars['String']['input'];
  dedicatedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  definition: Scalars['JSON']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  targetAccountIds?: InputMaybe<Array<Scalars['String']['input']>>;
  targetDeployment?: InputMaybe<Scalars['String']['input']>;
};

export enum Tax_Type {
  NotRecoverable = 'NOT_RECOVERABLE',
  Recoverable = 'RECOVERABLE'
}

export type Tag = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type TagResponseDto = {
  data: Array<Tag>;
  meta: MetaResponse;
};

export type TaxGroup = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  products?: Maybe<Array<Product>>;
  status: Scalars['String']['output'];
  taxPercentage: Scalars['Float']['output'];
};

export type TaxGroupResponseDto = {
  data: Array<TaxGroup>;
  meta: MetaResponse;
};

export type Tenant = {
  accountId: Scalars['String']['output'];
  allowedSellingUnits?: Maybe<Scalars['JSONObject']['output']>;
  currency?: Maybe<CurrencyTypeEnum>;
  deploymentType: DeploymentType;
  dunsNumber?: Maybe<Scalars['String']['output']>;
  fusionEnabled: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  invertedLogo?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  ntnNumber?: Maybe<Scalars['String']['output']>;
  online_store_url?: Maybe<Scalars['String']['output']>;
  parentCompanyLogo?: Maybe<Scalars['String']['output']>;
  poolId?: Maybe<Scalars['String']['output']>;
  postingGoLiveDate?: Maybe<Scalars['String']['output']>;
  qrInvertedLogo?: Maybe<Scalars['String']['output']>;
  revenueRecognitionEffectiveFrom?: Maybe<Scalars['String']['output']>;
  revenueRecognitionMode: RevenueRecognitionMode;
  revenueRecognitionPreviousMode?: Maybe<RevenueRecognitionMode>;
  saleTaxNumber?: Maybe<Scalars['String']['output']>;
  serialGeneration?: Maybe<SerialGenerationType>;
  spectrumEnabled: Scalars['Boolean']['output'];
  status: Scalars['String']['output'];
  taxNumber?: Maybe<Scalars['String']['output']>;
  timezone: Scalars['String']['output'];
  website?: Maybe<Scalars['String']['output']>;
};

export type TenantDto = {
  accountId: Scalars['String']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  invertedLogo?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  onlineStoreURL?: Maybe<Scalars['String']['output']>;
  parentCompanyLogo?: Maybe<Scalars['String']['output']>;
  qrInvertedLogo?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type TenantFulfillmentConfig = {
  allowedOnlineChannels: Array<Scalars['String']['output']>;
  autoReRouteOnCancel: Scalars['Boolean']['output'];
  autoRoutingEnabled: Scalars['Boolean']['output'];
  autoShipPartial: Scalars['Boolean']['output'];
  codAmountThreshold?: Maybe<Scalars['Float']['output']>;
  codRiskScoringEnabled: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  draftOrderExpiryMinutes: Scalars['Int']['output'];
  enable3PLWarehousing: Scalars['Boolean']['output'];
  enableShipFromStore: Scalars['Boolean']['output'];
  failedDeliveryAlertDays: Scalars['Int']['output'];
  fulfillmentBufferDays: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  lotAssignmentStrategy: LotAssignmentStrategy;
  marketplaceInboundEnabled: Scalars['Boolean']['output'];
  marketplaceSyncEnabled: Scalars['Boolean']['output'];
  maxReRouteAttempts: Scalars['Int']['output'];
  onlineStockBuffer: Scalars['Int']['output'];
  requireQCBeforeDispatch: Scalars['Boolean']['output'];
  requireScanToPack: Scalars['Boolean']['output'];
  routingStrategy: RoutingStrategy;
  slaDispatchHours: Scalars['Int']['output'];
  slaPickAssignHours: Scalars['Int']['output'];
  slaPickStartHours: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  useDispatchManifest: Scalars['Boolean']['output'];
  validateStockOnOnlineOrder: Scalars['Boolean']['output'];
};

export type TenantMember = {
  createdAt: Scalars['DateTime']['output'];
  globalUser?: Maybe<GlobalUser>;
  globalUserId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  roleId?: Maybe<Scalars['String']['output']>;
  status: User_Status;
  tenant?: Maybe<Tenant>;
  tenantId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type TenantPool = {
  createdAt: Scalars['DateTime']['output'];
  currentTenantCount: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  maxTenants: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  status: PoolStatus;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type TopCustomerDto = {
  avgOrderValue: Scalars['Float']['output'];
  customerId: Scalars['String']['output'];
  customerName: Scalars['String']['output'];
  lastOrderDate?: Maybe<Scalars['DateTime']['output']>;
  orderCount: Scalars['Float']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  totalSpend: Scalars['Float']['output'];
};

export type TopProductDto = {
  avgUnitPrice: Scalars['Float']['output'];
  orderCount: Scalars['Float']['output'];
  productId: Scalars['String']['output'];
  productName: Scalars['String']['output'];
  totalQuantity: Scalars['Float']['output'];
  totalRevenue: Scalars['Float']['output'];
};

export enum TrackingLevel {
  Batch = 'BATCH',
  Serial = 'SERIAL',
  Sku = 'SKU'
}

export type Transfer = {
  createdAt: Scalars['DateTime']['output'];
  demandNote?: Maybe<DemandNote>;
  demandNoteId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  expectedDeliveryDate: Scalars['String']['output'];
  id: Scalars['String']['output'];
  locationFrom?: Maybe<Location>;
  locationFromId: Scalars['String']['output'];
  locationTo?: Maybe<Location>;
  secondaryId?: Maybe<Scalars['Float']['output']>;
  status: TransferStatus;
  transferItems?: Maybe<Array<TransferItem>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type TransferItem = {
  actionId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  productId?: Maybe<Scalars['String']['output']>;
  productLot?: Maybe<ProductLot>;
  productLotId: Scalars['String']['output'];
  productName?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Float']['output'];
  remainingQuantity?: Maybe<Scalars['Float']['output']>;
  status: TransferItemStatus;
  transferId: Scalars['String']['output'];
};

export type TransferItemReceiveInput = {
  receivedQuantity: Scalars['Float']['input'];
  transferItemId: Scalars['String']['input'];
};

export enum TransferItemStatus {
  Cancelled = 'CANCELLED',
  InPartial = 'IN_PARTIAL',
  Pending = 'PENDING',
  Received = 'RECEIVED'
}

export type TransferProductDto = {
  manufacturerName: Scalars['String']['output'];
  productId: Scalars['String']['output'];
  productName: Scalars['String']['output'];
  quantity: Scalars['String']['output'];
};

export type TransferResponseDto = {
  data: Array<Transfer>;
  meta: MetaResponse;
};

export enum TransferStatus {
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  InTransit = 'IN_TRANSIT',
  PartiallyReceived = 'PARTIALLY_RECEIVED',
  Pending = 'PENDING',
  Received = 'RECEIVED'
}

export type TrialBalanceReportResponse = {
  currency: Scalars['String']['output'];
  endDate: Scalars['DateTime']['output'];
  isBalanced: Scalars['Boolean']['output'];
  rows: Array<FinanceReportRow>;
  startDate: Scalars['DateTime']['output'];
  totalClosingCredit: Scalars['String']['output'];
  totalClosingDebit: Scalars['String']['output'];
  totalCredit: Scalars['String']['output'];
  totalDebit: Scalars['String']['output'];
  totalOpeningCredit: Scalars['String']['output'];
  totalOpeningDebit: Scalars['String']['output'];
};

export enum User_Status {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  InviteCancelled = 'INVITE_CANCELLED',
  InvitePending = 'INVITE_PENDING'
}

export type UnassignFulfillmentOrderLinesInput = {
  fulfillmentOrderId: Scalars['ID']['input'];
  fulfillmentOrderLineIds: Array<Scalars['ID']['input']>;
};

export type UnlinkExternalObjectInput = {
  accountId: Scalars['String']['input'];
  connectionId: Scalars['String']['input'];
  oneObjectId: Scalars['String']['input'];
  oneObjectType: Scalars['String']['input'];
};

export type UnopenedProductLotInfoDto = {
  productStatus?: Maybe<Scalars['String']['output']>;
  unopenedCount: Scalars['Float']['output'];
};

/** Family of unit-of-measure used by a product */
export enum UomType {
  Length = 'LENGTH',
  Pack = 'PACK',
  Volume = 'VOLUME',
  Weight = 'WEIGHT'
}

/** All unit values across PACK/WEIGHT/VOLUME/LENGTH families. Validity per uomType is enforced server-side. */
export enum UomUnit {
  Box = 'BOX',
  Carton = 'CARTON',
  Cm = 'CM',
  FlOzImp = 'FL_OZ_IMP',
  FlOzUs = 'FL_OZ_US',
  Ft = 'FT',
  G = 'G',
  GalImp = 'GAL_IMP',
  GalUs = 'GAL_US',
  In = 'IN',
  Kg = 'KG',
  Kl = 'KL',
  Km = 'KM',
  L = 'L',
  Lb = 'LB',
  M = 'M',
  Mg = 'MG',
  Mi = 'MI',
  Ml = 'ML',
  Mm = 'MM',
  Oz = 'OZ',
  Piece = 'PIECE',
  PtImp = 'PT_IMP',
  PtUs = 'PT_US',
  QtImp = 'QT_IMP',
  QtUs = 'QT_US',
  Stone = 'STONE',
  Ton = 'TON',
  Ug = 'UG',
  Unit = 'UNIT',
  Yd = 'YD'
}

export type UpdateAccountBankTransactionInput = {
  amount?: InputMaybe<Scalars['String']['input']>;
  bankId?: InputMaybe<Scalars['String']['input']>;
  challanId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  journalId?: InputMaybe<Scalars['String']['input']>;
  refId?: InputMaybe<Scalars['String']['input']>;
  transactionDate?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAccountPayableInvoiceInput = {
  currency?: InputMaybe<CurrencyTypeEnum>;
  discountAmount?: InputMaybe<Scalars['Float']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  grnId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['String']['input'];
  invoiceDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceNo?: InputMaybe<Scalars['String']['input']>;
  invoiceType?: InputMaybe<AccountPayableInvoiceType>;
  lines?: InputMaybe<Array<UpdateAccountPayableInvoiceLineInput>>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['ID']['input']>;
  paymentTermsId?: InputMaybe<Scalars['ID']['input']>;
  poId?: InputMaybe<Scalars['ID']['input']>;
  relatedInvoiceId?: InputMaybe<Scalars['ID']['input']>;
  relationType?: InputMaybe<AccountPayableInvoiceRelationType>;
  roundingAdjustment?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<AccountPayableInvoiceStatus>;
  subtotal?: InputMaybe<Scalars['Float']['input']>;
  taxAmount?: InputMaybe<Scalars['Float']['input']>;
  threeWayMatch?: InputMaybe<Scalars['Boolean']['input']>;
  totalAmount?: InputMaybe<Scalars['Float']['input']>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
  whtAmount?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateAccountPayableInvoiceLineInput = {
  chartOfAccountsId?: InputMaybe<Scalars['ID']['input']>;
  costCenterId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discountAmount?: InputMaybe<Scalars['Float']['input']>;
  grnId?: InputMaybe<Scalars['ID']['input']>;
  grnLineId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lineTotal?: InputMaybe<Scalars['Float']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  poId?: InputMaybe<Scalars['ID']['input']>;
  poLineId?: InputMaybe<Scalars['ID']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  profitCenterId?: InputMaybe<Scalars['ID']['input']>;
  qty?: InputMaybe<Scalars['Float']['input']>;
  taxAmount?: InputMaybe<Scalars['Float']['input']>;
  taxType?: InputMaybe<Tax_Type>;
  type?: InputMaybe<ApInvoiceLineType>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateAccountPayablePaymentInput = {
  advanceDate?: InputMaybe<Scalars['DateTime']['input']>;
  advancePayment?: InputMaybe<Scalars['Float']['input']>;
  advanceRemarks?: InputMaybe<Scalars['String']['input']>;
  apSettlementLines?: InputMaybe<Array<CreateApSettlementLineInput>>;
  bankId?: InputMaybe<Scalars['ID']['input']>;
  cashId?: InputMaybe<Scalars['ID']['input']>;
  challanId?: InputMaybe<Scalars['String']['input']>;
  chartOfAccountsId?: InputMaybe<Scalars['ID']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  method?: InputMaybe<AccountPayablePaymentMethod>;
  offsetDescription?: InputMaybe<Scalars['String']['input']>;
  offsetTaxHandling?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['ID']['input']>;
  paymentDate?: InputMaybe<Scalars['DateTime']['input']>;
  refId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ApPaymentStatus>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateAccountPayableWriteoffInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  apSettlementLines?: InputMaybe<Array<CreateApSettlementLineInput>>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  invoiceId?: InputMaybe<Scalars['ID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  reasonCode?: InputMaybe<ApWriteoffReasonCode>;
  status?: InputMaybe<ApWriteoffStatus>;
  writeoffDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateAccountReceivableInvoiceInput = {
  arInvoiceId?: InputMaybe<Scalars['String']['input']>;
  contactOn?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<CurrencyTypeEnum>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  discountTotal?: InputMaybe<Scalars['Float']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  fxRate?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  invoiceDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceType?: InputMaybe<AccountReceivableInvoiceType>;
  lines?: InputMaybe<Array<UpdateAccountReceivableInvoiceLineInput>>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['String']['input']>;
  paymentTermsId?: InputMaybe<Scalars['String']['input']>;
  relatedInvoiceId?: InputMaybe<Scalars['ID']['input']>;
  relationType?: InputMaybe<AccountReceivableInvoiceRelationType>;
  roundingAdjustment?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<AccountReceivableInvoiceStatus>;
  subtotalAmount?: InputMaybe<Scalars['Float']['input']>;
  taxAmount?: InputMaybe<Scalars['Float']['input']>;
  totalAmount?: InputMaybe<Scalars['Float']['input']>;
  whtAmount?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateAccountReceivableInvoiceLineInput = {
  chartOfAccountsId?: InputMaybe<Scalars['ID']['input']>;
  costCenterId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discountAmount?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lineTotal?: InputMaybe<Scalars['Float']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  orderId?: InputMaybe<Scalars['ID']['input']>;
  orderLineId?: InputMaybe<Scalars['ID']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  profitCenterId?: InputMaybe<Scalars['ID']['input']>;
  qty?: InputMaybe<Scalars['Float']['input']>;
  taxAmount?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<ArInvoiceLineType>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateAccountReceivableReceiptInput = {
  advanceDate?: InputMaybe<Scalars['DateTime']['input']>;
  advancePayment?: InputMaybe<Scalars['Float']['input']>;
  advanceRemarks?: InputMaybe<Scalars['String']['input']>;
  arSettlementLines?: InputMaybe<Array<CreateArSettlementLineInput>>;
  bankAccountId?: InputMaybe<Scalars['String']['input']>;
  bankId?: InputMaybe<Scalars['ID']['input']>;
  cashAccountId?: InputMaybe<Scalars['String']['input']>;
  cashId?: InputMaybe<Scalars['ID']['input']>;
  challanId?: InputMaybe<Scalars['String']['input']>;
  chartOfAccountsId?: InputMaybe<Scalars['ID']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  dateReceived?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['String']['input'];
  mode?: InputMaybe<AccountReceivableReceiptMode>;
  partnerId?: InputMaybe<Scalars['ID']['input']>;
  receivableAccountId?: InputMaybe<Scalars['String']['input']>;
  refId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ArReceiptStatus>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateAccountReceivableWriteoffInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  fxAllocatedAmount?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  invoiceId?: InputMaybe<Scalars['ID']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  reasonCode?: InputMaybe<ArWriteoffReasonCode>;
  status?: InputMaybe<ArWriteoffStatus>;
};

export type UpdateAccountSubtypeInput = {
  id: Scalars['String']['input'];
  isCashLike?: InputMaybe<Scalars['Boolean']['input']>;
  isControlSubtype?: InputMaybe<Scalars['Boolean']['input']>;
  isReconcilable?: InputMaybe<Scalars['Boolean']['input']>;
  isSystemManaged?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<AccountStatus>;
  subledgerType?: InputMaybe<SubledgerType>;
  type?: InputMaybe<AccountType>;
};

export type UpdateAddressDto = {
  additionalNumber?: InputMaybe<Scalars['String']['input']>;
  buildingNo?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  districtName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  landmark?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  streetAddress1?: InputMaybe<Scalars['String']['input']>;
  streetAddress2?: InputMaybe<Scalars['String']['input']>;
  streetName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateApSettlementLineInput = {
  allocatedAmount?: InputMaybe<Scalars['Float']['input']>;
  allocationDate?: InputMaybe<Scalars['DateTime']['input']>;
  chartOfAccountsId?: InputMaybe<Scalars['ID']['input']>;
  fromType?: InputMaybe<ApSettlementFromType>;
  fxAllocatedAmount?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  invoiceId?: InputMaybe<Scalars['ID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  offsetDescription?: InputMaybe<Scalars['String']['input']>;
  offsetTaxHandling?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateArSettlementLineInput = {
  allocatedAmount?: InputMaybe<Scalars['Float']['input']>;
  allocationDate?: InputMaybe<Scalars['DateTime']['input']>;
  fxAllocatedAmount?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAutomationFlowInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  graph?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBankAccountInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  accountTitle?: InputMaybe<Scalars['String']['input']>;
  coaAccountId?: InputMaybe<Scalars['ID']['input']>;
  currency?: InputMaybe<CurrencyTypeEnum>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  locationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  openingBalance?: InputMaybe<Scalars['Float']['input']>;
  openingBalanceDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<BankAccountStatus>;
};

export type UpdateBomDto = {
  bomName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  productionProcessType?: InputMaybe<ProductionProcessType>;
  status?: InputMaybe<BomStatus>;
};

export type UpdateBomVersionDto = {
  batchQuantity?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['String']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  referenceVersionId?: InputMaybe<Scalars['String']['input']>;
  versionLabel?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBomVersionLineItemDto = {
  consumableQuantity?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['String']['input'];
  isMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  lineNo?: InputMaybe<Scalars['Int']['input']>;
  wastagePercentage?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateCalculatedColumnInput = {
  expression?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCashAccountInput = {
  cashRegister?: InputMaybe<Scalars['String']['input']>;
  coaAccountId?: InputMaybe<Scalars['ID']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<CurrencyTypeEnum>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  financeDrawerId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  locationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  posRegisterIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<CashAccountStatus>;
};

export type UpdateCategoryDto = {
  bannerImage?: InputMaybe<Scalars['String']['input']>;
  categoryIcon?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  status: Status;
};

export type UpdateChartOfAccountsInput = {
  balanceType?: InputMaybe<BalanceType>;
  dimension?: InputMaybe<AccountDimension>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isControl?: InputMaybe<Scalars['Boolean']['input']>;
  isReconciliation?: InputMaybe<Scalars['Boolean']['input']>;
  isSystem?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  openingBalance?: InputMaybe<Scalars['Float']['input']>;
  parentAccountId?: InputMaybe<Scalars['String']['input']>;
  reportingGroup?: InputMaybe<ReportingGroup>;
  subtypeId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ChartAccountType>;
};

export type UpdateCostCenterInput = {
  coaAccountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  code?: InputMaybe<Scalars['String']['input']>;
  costBehavior?: InputMaybe<CostBehavior>;
  effectiveFrom?: InputMaybe<Scalars['DateTime']['input']>;
  effectiveTo?: InputMaybe<Scalars['DateTime']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  locationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  managerId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentCcId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Status>;
  type?: InputMaybe<CostCenterType>;
};

export type UpdateCustomerDto = {
  additionalNumber?: InputMaybe<Scalars['String']['input']>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  buildingNo?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['String']['input']>;
  commercialRegisterNumber?: InputMaybe<Scalars['String']['input']>;
  districtName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  nationalId?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['String']['input']>;
  partnerNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  streetName?: InputMaybe<Scalars['String']['input']>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDashboardInput = {
  config?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDashboardWidgetInput = {
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  span?: InputMaybe<Scalars['Int']['input']>;
  tab?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDiscountDto = {
  buyX?: InputMaybe<Scalars['Int']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  code?: InputMaybe<Scalars['String']['input']>;
  combinable?: InputMaybe<Scalars['Boolean']['input']>;
  customerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  getY?: InputMaybe<Scalars['Int']['input']>;
  getYDiscount?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['String']['input'];
  limitUses?: InputMaybe<Scalars['Int']['input']>;
  locationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  maxDiscountAmount?: InputMaybe<Scalars['Float']['input']>;
  minPurchaseAmount?: InputMaybe<Scalars['Float']['input']>;
  minQuantity?: InputMaybe<Scalars['Int']['input']>;
  partnerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  productIds?: InputMaybe<Array<Scalars['String']['input']>>;
  scope?: InputMaybe<DiscountScope>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<DiscountStatus>;
  tagIds?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<DiscountType>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateEntityInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  fiscalYearType?: InputMaybe<FiscalYearType>;
  id: Scalars['String']['input'];
};

export type UpdateFinancialTermsDto = {
  coverageFixedAmount?: InputMaybe<Scalars['Float']['input']>;
  coverageModeCode?: InputMaybe<CoverageModeCode>;
  coveragePercent?: InputMaybe<Scalars['Float']['input']>;
  direction?: InputMaybe<Direction>;
  effectiveFrom?: InputMaybe<Scalars['DateTime']['input']>;
  effectiveTo?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['String']['input'];
  isCreditCover?: InputMaybe<Scalars['Boolean']['input']>;
  partnerId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Status>;
};

export type UpdateFiscalPeriodInput = {
  id: Scalars['String']['input'];
  isOpen: Scalars['Boolean']['input'];
};

export type UpdateFiscalYearInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  fiscalYearName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateFusionConnectionInput = {
  accountId: Scalars['String']['input'];
  credentials?: InputMaybe<Array<ConnectionSettingInput>>;
  defaultCurrency?: InputMaybe<Scalars['String']['input']>;
  externalAccountName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  settings?: InputMaybe<Array<ConnectionSettingInput>>;
  status?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFusionIntegrationInput = {
  connectionId: Scalars['String']['input'];
  credentials?: InputMaybe<Array<FusionIntegrationSettingInput>>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Array<FusionIntegrationSettingInput>>;
};

export type UpdateFusionIntegrationProductInput = {
  connectionId: Scalars['String']['input'];
  maximumSalesQuantity?: InputMaybe<Scalars['Int']['input']>;
  productId: Scalars['String']['input'];
  stockBuffer?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateGenericFormulaDto = {
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Status>;
};

export type UpdateGrnItemStatus = {
  grnId: Scalars['String']['input'];
  grnItems: Array<UpdateGrnItemStatusArgs>;
};

export type UpdateGrnItemStatusArgs = {
  grnItemId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
  status: StatusApproval;
};

export type UpdateIntegrationConfigDto = {
  allowedOrderType?: InputMaybe<Array<AllowedOrderType>>;
  charges?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['String']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  registerId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<IntegrationType>;
};

export type UpdateInvoicePolicyConfigDto = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  effectiveDate?: InputMaybe<Scalars['DateTime']['input']>;
  effectiveTillDate?: InputMaybe<Scalars['DateTime']['input']>;
  groupByBusinessDate?: InputMaybe<Scalars['Boolean']['input']>;
  groupByEntity?: InputMaybe<Scalars['Boolean']['input']>;
  groupByLocation?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  invoicePolicyCode?: InputMaybe<InvoicePolicyCode>;
  partnerId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Status>;
};

export type UpdateJournalHeaderInput = {
  id: Scalars['ID']['input'];
  journalDate?: InputMaybe<Scalars['DateTime']['input']>;
  lines?: InputMaybe<Array<UpdateJournalLineInput>>;
  newLines?: InputMaybe<Array<CreateJournalLineInput>>;
  reversalRefId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<JournalStatus>;
};

export type UpdateJournalLineInput = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  costCenterId?: InputMaybe<Scalars['String']['input']>;
  costCenterSource?: InputMaybe<CenterSource>;
  credit?: InputMaybe<Scalars['Float']['input']>;
  currencyId?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  debit?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['String']['input']>;
  profitCenterId?: InputMaybe<Scalars['String']['input']>;
  profitCenterSource?: InputMaybe<CenterSource>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  refId?: InputMaybe<Scalars['String']['input']>;
  vendorId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLocationRegisterDto = {
  allowedPaymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  assignedUserId?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<CurrencyTypeEnum>;
  id: Scalars['String']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  printMode?: InputMaybe<PrintModeType>;
  receiptTemplate?: InputMaybe<ReceiptTemplateType>;
  status?: InputMaybe<Status>;
  terminalTaxId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<LocationRegisterType>;
};

export type UpdateManufacturerDto = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  lineOfBusiness?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Status>;
};

export type UpdatePartnerDto = {
  address?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['String']['input']>;
  contactPerson?: InputMaybe<Scalars['String']['input']>;
  defaultFinancialTermsId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Status>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PartnerType>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePaymentTermsInput = {
  applicableOn?: InputMaybe<ApplicableOn>;
  baseDate?: InputMaybe<Scalars['DateTime']['input']>;
  baseDateType?: InputMaybe<BaseDateType>;
  description?: InputMaybe<Scalars['String']['input']>;
  discounts?: InputMaybe<Array<CreatePaymentTermDiscountInput>>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  graceDays?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDiscountApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  isInstallmentBased?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  schedules?: InputMaybe<Array<CreatePaymentTermsScheduleInput>>;
};

export type UpdatePlatformFeeConfigDto = {
  id: Scalars['String']['input'];
  isRemovable?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderType?: InputMaybe<Scalars['String']['input']>;
  platformFeeAccountCode?: InputMaybe<Scalars['String']['input']>;
  platformFeeTaxRate?: InputMaybe<Scalars['Float']['input']>;
  platformFeeTaxable?: InputMaybe<Scalars['Boolean']['input']>;
  platformFeeType?: InputMaybe<PlatformFeeType>;
  platformFeeValue?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<Status>;
};

export type UpdatePrinterConfigDto = {
  batchNumberFontSize?: InputMaybe<Scalars['Float']['input']>;
  columnGap?: InputMaybe<Scalars['Float']['input']>;
  columns?: InputMaybe<Scalars['Int']['input']>;
  expiryFontSize?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['String']['input'];
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  labelHeight?: InputMaybe<Scalars['Float']['input']>;
  labelWidth?: InputMaybe<Scalars['Float']['input']>;
  marginBottom?: InputMaybe<Scalars['Float']['input']>;
  marginLeft?: InputMaybe<Scalars['Float']['input']>;
  marginRight?: InputMaybe<Scalars['Float']['input']>;
  marginTop?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orientation?: InputMaybe<Scalars['String']['input']>;
  padding?: InputMaybe<Scalars['Float']['input']>;
  productNameFontSize?: InputMaybe<Scalars['Float']['input']>;
  productNameMaxLines?: InputMaybe<Scalars['Int']['input']>;
  productNameWrap?: InputMaybe<Scalars['String']['input']>;
  qrCodeAlignment?: InputMaybe<Scalars['String']['input']>;
  qrCodeMarginRight?: InputMaybe<Scalars['Float']['input']>;
  qrCodeSize?: InputMaybe<Scalars['Float']['input']>;
  textAlignment?: InputMaybe<Scalars['String']['input']>;
  zoom?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateProductDto = {
  buyingUnit?: InputMaybe<UomUnit>;
  categoryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  conversions?: InputMaybe<Array<CreateProductConversionDto>>;
  description?: InputMaybe<Scalars['String']['input']>;
  discountPercentage?: InputMaybe<Scalars['Float']['input']>;
  dosageInstruction?: InputMaybe<Scalars['String']['input']>;
  drugRegulatorId?: InputMaybe<Scalars['Int']['input']>;
  genericFormulaIds?: InputMaybe<Array<Scalars['String']['input']>>;
  gtin?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  images?: InputMaybe<Array<Scalars['String']['input']>>;
  isDiscountApplicableOnTax?: InputMaybe<Scalars['Boolean']['input']>;
  isManufacturable?: InputMaybe<Scalars['Boolean']['input']>;
  isManufacturerTracking?: InputMaybe<Scalars['Boolean']['input']>;
  isPurchasable?: InputMaybe<Scalars['Boolean']['input']>;
  isSellable?: InputMaybe<Scalars['Boolean']['input']>;
  isTaxInclusive?: InputMaybe<Scalars['Boolean']['input']>;
  itemNature?: InputMaybe<Scalars['String']['input']>;
  itemReleaseChannels?: InputMaybe<Array<ItemReleaseChannel>>;
  manufacturerId?: InputMaybe<Scalars['String']['input']>;
  margins?: InputMaybe<Scalars['Float']['input']>;
  maximumRetailPrice?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  prescriptionRequired?: InputMaybe<Scalars['Boolean']['input']>;
  purchasingPrice?: InputMaybe<Scalars['Float']['input']>;
  sellingTaxRate?: InputMaybe<Scalars['Float']['input']>;
  sellingUnit?: InputMaybe<UomUnit>;
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  seoUrl?: InputMaybe<Scalars['String']['input']>;
  sideEffects?: InputMaybe<Scalars['String']['input']>;
  skuCode?: InputMaybe<Scalars['String']['input']>;
  skuDepartment?: InputMaybe<Scalars['String']['input']>;
  skuMaximumLevel?: InputMaybe<Scalars['Int']['input']>;
  skuMinimumLevel?: InputMaybe<Scalars['Int']['input']>;
  skuReorderLevel?: InputMaybe<Scalars['Int']['input']>;
  skuWarehouseLeadTime?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Status>;
  stockNature?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<Scalars['String']['input']>>;
  taxCode?: InputMaybe<Scalars['Int']['input']>;
  taxGroupId?: InputMaybe<Scalars['String']['input']>;
  trackingLevel?: InputMaybe<TrackingLevel>;
  tradeDiscount?: InputMaybe<Scalars['Float']['input']>;
  tradePrice?: InputMaybe<Scalars['Float']['input']>;
  uomType?: InputMaybe<UomType>;
  vendorIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateProductLotDto = {
  batch_expiry_date?: InputMaybe<Scalars['DateTime']['input']>;
  batch_number?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  discount_value?: InputMaybe<Scalars['Float']['input']>;
  gst_rate?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['String']['input'];
  location_id?: InputMaybe<Scalars['String']['input']>;
  product_id?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  trade_price?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateProductManufacturingPriceDto = {
  effectiveFrom?: InputMaybe<Scalars['Date']['input']>;
  effectiveTo?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['String']['input'];
  maximumRetailPrice?: InputMaybe<Scalars['Float']['input']>;
  taxRate?: InputMaybe<Scalars['Float']['input']>;
  tradePriceOutward?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateProductionLineDto = {
  bomVersionId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  multiplierFactor?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateProductionOrderBatchDto = {
  adjustmentDirection?: InputMaybe<AdjustmentDirection>;
  adjustmentQuantity?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['String']['input'];
};

export type UpdateProductionOrderDto = {
  id: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProductionOrderMaterialDto = {
  actualQty: Scalars['Int']['input'];
  id: Scalars['String']['input'];
  lots: Array<MaterialLotInput>;
};

export type UpdateProductionPlanDto = {
  id: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  plannedEndDate?: InputMaybe<Scalars['Date']['input']>;
  plannedStartDate?: InputMaybe<Scalars['Date']['input']>;
  productionLocationId?: InputMaybe<Scalars['String']['input']>;
  sourceLocationId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProfitCenterInput = {
  coaAccountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  code?: InputMaybe<Scalars['String']['input']>;
  effectiveFrom?: InputMaybe<Scalars['DateTime']['input']>;
  effectiveTo?: InputMaybe<Scalars['DateTime']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  locationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  managerId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentPcId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Status>;
  type?: InputMaybe<ProfitCenterType>;
};

export type UpdateReportInput = {
  chartConfig?: InputMaybe<Scalars['JSON']['input']>;
  definition?: InputMaybe<RunReportInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSourceModuleInput = {
  allowManualNumber?: InputMaybe<Scalars['Boolean']['input']>;
  autoPostEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  padding?: InputMaybe<Scalars['Int']['input']>;
  prefix?: InputMaybe<Scalars['String']['input']>;
  resetCycle?: InputMaybe<ResetCycle>;
};

export type UpdateSqlReportInput = {
  calculatedColumns?: InputMaybe<Array<CalculatedColumnInput>>;
  chartConfig?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parameters?: InputMaybe<Scalars['JSON']['input']>;
  sql?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateStockOperationDto = {
  locationId?: InputMaybe<Scalars['String']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  stockOperationId: Scalars['String']['input'];
};

export type UpdateStockOperationItemDto = {
  batchExpiry?: InputMaybe<Scalars['String']['input']>;
  batchNumber?: InputMaybe<Scalars['String']['input']>;
  gstValue?: InputMaybe<Scalars['Float']['input']>;
  manufacturerCode?: InputMaybe<Scalars['String']['input']>;
  mfgDate?: InputMaybe<Scalars['String']['input']>;
  mrp?: InputMaybe<Scalars['Float']['input']>;
  productLotId?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  stockOperationItemId: Scalars['String']['input'];
  tradePrice?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateTagDto = {
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Status>;
};

export type UpdateTaxGroupDto = {
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Status>;
  taxPercentage?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateTenantDto = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  allowedSellingUnits?: InputMaybe<Scalars['JSONObject']['input']>;
  cacheHost?: InputMaybe<Scalars['String']['input']>;
  cachePassword?: InputMaybe<Scalars['String']['input']>;
  cachePort?: InputMaybe<Scalars['Float']['input']>;
  cacheType?: InputMaybe<Scalars['String']['input']>;
  databaseHost?: InputMaybe<Scalars['String']['input']>;
  databaseName?: InputMaybe<Scalars['String']['input']>;
  databasePassword?: InputMaybe<Scalars['String']['input']>;
  databasePort?: InputMaybe<Scalars['Float']['input']>;
  databaseType?: InputMaybe<Scalars['String']['input']>;
  databaseUsername?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  ntnNumber?: InputMaybe<Scalars['String']['input']>;
  saleTaxNumber?: InputMaybe<Scalars['String']['input']>;
  taxNumber?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTenantFulfillmentConfigInput = {
  allowedOnlineChannels?: InputMaybe<Array<Scalars['String']['input']>>;
  autoReRouteOnCancel?: InputMaybe<Scalars['Boolean']['input']>;
  autoRoutingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  autoShipPartial?: InputMaybe<Scalars['Boolean']['input']>;
  codAmountThreshold?: InputMaybe<Scalars['Float']['input']>;
  codRiskScoringEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  draftOrderExpiryMinutes?: InputMaybe<Scalars['Int']['input']>;
  enable3PLWarehousing?: InputMaybe<Scalars['Boolean']['input']>;
  enableShipFromStore?: InputMaybe<Scalars['Boolean']['input']>;
  failedDeliveryAlertDays?: InputMaybe<Scalars['Int']['input']>;
  fulfillmentBufferDays?: InputMaybe<Scalars['Int']['input']>;
  lotAssignmentStrategy?: InputMaybe<LotAssignmentStrategy>;
  marketplaceInboundEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  marketplaceSyncEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  maxReRouteAttempts?: InputMaybe<Scalars['Int']['input']>;
  onlineStockBuffer?: InputMaybe<Scalars['Int']['input']>;
  requireQCBeforeDispatch?: InputMaybe<Scalars['Boolean']['input']>;
  requireScanToPack?: InputMaybe<Scalars['Boolean']['input']>;
  routingStrategy?: InputMaybe<RoutingStrategy>;
  slaDispatchHours?: InputMaybe<Scalars['Int']['input']>;
  slaPickAssignHours?: InputMaybe<Scalars['Int']['input']>;
  slaPickStartHours?: InputMaybe<Scalars['Int']['input']>;
  useDispatchManifest?: InputMaybe<Scalars['Boolean']['input']>;
  validateStockOnOnlineOrder?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateVendorDto = {
  bankName?: InputMaybe<Scalars['String']['input']>;
  branchCityId?: InputMaybe<Scalars['String']['input']>;
  branchCode?: InputMaybe<Scalars['String']['input']>;
  businessAddress?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['String']['input']>;
  classification?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  contactPerson?: InputMaybe<Scalars['String']['input']>;
  corporateWebsite?: InputMaybe<Scalars['String']['input']>;
  creditLimit?: InputMaybe<Scalars['Float']['input']>;
  document?: InputMaybe<Scalars['String']['input']>;
  documentExpiryDate?: InputMaybe<Scalars['String']['input']>;
  drugLicenseNo?: InputMaybe<Scalars['Int']['input']>;
  drugSaleLicense?: InputMaybe<Scalars['Boolean']['input']>;
  duns_number?: InputMaybe<Scalars['String']['input']>;
  ibanNumber?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  leadTime?: InputMaybe<Scalars['Float']['input']>;
  manufacturerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationType?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  paymentTerms?: InputMaybe<Scalars['String']['input']>;
  primaryEmailAddress?: InputMaybe<Scalars['String']['input']>;
  primaryPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  secondaryEmailAddress?: InputMaybe<Scalars['String']['input']>;
  secondaryPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  stateProvince?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Status>;
  stockReturnPolicy?: InputMaybe<Scalars['String']['input']>;
  strn?: InputMaybe<Scalars['String']['input']>;
  taxExemption?: InputMaybe<Scalars['Boolean']['input']>;
  taxExemptionValidity?: InputMaybe<Scalars['String']['input']>;
  taxReturn?: InputMaybe<Scalars['Boolean']['input']>;
  taxationNumber?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Array<Scalars['String']['input']>>;
  withHoldTaxGroup?: InputMaybe<Scalars['String']['input']>;
  withHoldTaxPercentage?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type UploadMediaImageInput = {
  base64Data: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type UpsertCashDepositConfigInput = {
  allowOverDeposit?: InputMaybe<Scalars['Boolean']['input']>;
  allowRegisterLines?: InputMaybe<Scalars['Boolean']['input']>;
  entityId: Scalars['ID']['input'];
};

export type User = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  designation?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<GenderType>;
  id: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Array<Location>>;
  phone?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Role>;
  roleId?: Maybe<Scalars['String']['output']>;
  secondaryId?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<User_Status>;
  tokenExpiry?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type UserDto = {
  designation?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  gender: GenderType;
  lastName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  roleId: Scalars['String']['input'];
};

export type UserResponseDto_ = {
  data: Array<User>;
  meta: MetaResponse;
};

export type ValidateAdjustmentDto = {
  adjustmentType: AdjustmentType;
  locationId: Scalars['String']['input'];
  lots: Array<CreateAdjustmentLotDto>;
};

export type ValidateInvitationDto = {
  email: Scalars['String']['output'];
  tokenExpired: Scalars['Boolean']['output'];
  tokenValid: Scalars['Boolean']['output'];
};

export type Vendor = {
  bankName?: Maybe<Scalars['String']['output']>;
  branchCity?: Maybe<City>;
  branchCityId?: Maybe<Scalars['String']['output']>;
  branchCode?: Maybe<Scalars['String']['output']>;
  businessAddress?: Maybe<Scalars['String']['output']>;
  city?: Maybe<City>;
  cityId?: Maybe<Scalars['String']['output']>;
  classification?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  contactPerson?: Maybe<Scalars['String']['output']>;
  corporateWebsite?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  creditLimit?: Maybe<Scalars['Float']['output']>;
  document?: Maybe<Scalars['String']['output']>;
  documentExpiryDate?: Maybe<Scalars['String']['output']>;
  drugLicenseNo?: Maybe<Scalars['String']['output']>;
  drugSaleLicense: Scalars['Boolean']['output'];
  duns_number?: Maybe<Scalars['String']['output']>;
  ibanNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  leadTime?: Maybe<Scalars['Int']['output']>;
  manufacturers?: Maybe<Array<Manufacturer>>;
  name?: Maybe<Scalars['String']['output']>;
  organizationType?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<Scalars['String']['output']>;
  paymentTerms?: Maybe<Scalars['String']['output']>;
  primaryEmailAddress?: Maybe<Scalars['String']['output']>;
  primaryPhoneNumber?: Maybe<Scalars['String']['output']>;
  registrationNumber?: Maybe<Scalars['String']['output']>;
  secondaryEmailAddress?: Maybe<Scalars['String']['output']>;
  secondaryId?: Maybe<Scalars['Float']['output']>;
  secondaryPhoneNumber?: Maybe<Scalars['String']['output']>;
  stateProvince?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  stockReturnPolicy?: Maybe<Scalars['String']['output']>;
  strn?: Maybe<Scalars['String']['output']>;
  taxExemption?: Maybe<Scalars['Boolean']['output']>;
  taxExemptionValidity?: Maybe<Scalars['String']['output']>;
  taxReturn?: Maybe<Scalars['Boolean']['output']>;
  taxationNumber?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Array<Scalars['String']['output']>>;
  withHoldTaxGroup?: Maybe<Scalars['String']['output']>;
  withHoldTaxPercentage?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type VendorResponseDto = {
  data: Array<Vendor>;
  meta: MetaResponse;
};

export type CreateAccountSubtypeMutationVariables = Exact<{
  createAccountSubtype: CreateAccountSubtypeInput;
}>;


export type CreateAccountSubtypeMutation = { createAccountSubtype: { id: string, code: string, name: string, type: AccountType, isSystemManaged: boolean, isCashLike: boolean, isControlSubtype: boolean, isReconcilable: boolean, subledgerType: SubledgerType, status: AccountStatus } };

export type AccountSubtypesQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
}>;


export type AccountSubtypesQuery = { accountSubtypes: { data: Array<{ id: string, secondaryId?: number | null, code: string, name: string, type: AccountType, isSystemManaged: boolean, isCashLike: boolean, isControlSubtype: boolean, isReconcilable: boolean, subledgerType: SubledgerType, status: AccountStatus }>, meta: { page?: number | null, limit?: number | null, totalCount?: number | null, total?: number | null } } };

export type AccountSubtypesListForOptionsQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
}>;


export type AccountSubtypesListForOptionsQuery = { accountSubtypes: { data: Array<{ id: string, name: string, type: AccountType }>, meta: { page?: number | null, limit?: number | null, totalCount?: number | null, total?: number | null } } };

export type AccountPayableInvoicesForOptionsQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
}>;


export type AccountPayableInvoicesForOptionsQuery = { accountPayableInvoices: { data: Array<{ id: string, secondaryId?: number | null, vendorId?: string | null, vendorName?: string | null, partnerId?: string | null, partnerName?: string | null }>, meta: { page?: number | null, limit?: number | null, totalCount?: number | null, total?: number | null } } };

export type AccountPayableInvoicesQueryVariables = Exact<{
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
}>;


export type AccountPayableInvoicesQuery = { accountPayableInvoices: { data: Array<{ id: string, secondaryId?: number | null, invoiceNo?: string | null, invoiceType: AccountPayableInvoiceType, vendorId?: string | null, vendorName?: string | null, partnerId?: string | null, partnerName?: string | null, relatedInvoiceId?: string | null, relationType?: AccountPayableInvoiceRelationType | null, invoiceDate: any, dueDate?: any | null, subtotal: number, taxAmount: number, whtAmount: number, totalAmount: number, discountAmount?: number | null, roundingAdjustment?: number | null, outstandingAmount: number, status: AccountPayableInvoiceStatus, notes?: string | null, locationId?: string | null, locationName?: string | null, threeWayMatch: boolean, poId?: string | null, entryMethod: AccountPayableEntryMethod, entityId: string, createdBy: string, createdAt: any, updatedAt: any, postedBy?: string | null, postedAt?: any | null, aging?: string | null, grnInvoiceNumber?: string | null, createdByName?: string | null, postedByName?: string | null, fiscalPeriodName?: string | null, entityName?: string | null, grnSecondaryId?: number | null, poSecondaryId?: number | null, paymentTerms?: { name: string } | null, journal?: { journalNo?: string | null } | null }>, meta: { totalCount?: number | null, page?: number | null, limit?: number | null, total?: number | null } } };

export type AccountPayableInvoiceQueryVariables = Exact<{
  accountPayableInvoiceId: Scalars['ID']['input'];
}>;


export type AccountPayableInvoiceQuery = { accountPayableInvoice?: { id: string, secondaryId?: number | null, invoiceNo?: string | null, invoiceType: AccountPayableInvoiceType, vendorId?: string | null, vendorName?: string | null, partnerId?: string | null, partnerName?: string | null, relatedInvoiceId?: string | null, relationType?: AccountPayableInvoiceRelationType | null, grnId?: string | null, invoiceDate: any, dueDate?: any | null, subtotal: number, taxAmount: number, whtAmount: number, totalAmount: number, discountAmount?: number | null, roundingAdjustment?: number | null, outstandingAmount: number, journalId?: string | null, status: AccountPayableInvoiceStatus, notes?: string | null, locationId?: string | null, locationName?: string | null, threeWayMatch: boolean, poId?: string | null, entryMethod: AccountPayableEntryMethod, entityId: string, createdBy: string, createdAt: any, updatedAt: any, postedBy?: string | null, postedAt?: any | null, aging?: string | null, createdByName?: string | null, fiscalPeriodName?: string | null, postedByName?: string | null, grnInvoiceNumber?: string | null, grnSecondaryId?: number | null, entityName?: string | null, journalNo?: string | null, poSecondaryId?: number | null, lines?: Array<{ id: string, secondaryId?: number | null, invoiceId: string, description: string, qty: number, unitPrice: number, discountAmount: number, taxAmount: number, taxType: Tax_Type, lineTotal: number, type?: ApInvoiceLineType | null, chartOfAccountsId?: string | null, grnId?: string | null, grnLineId?: string | null, productId?: string | null, poId?: string | null, poLineId?: string | null, locationId?: string | null, locationName?: string | null, profitCenterId?: string | null, costCenterId?: string | null, createdAt: any, updatedAt: any, grossAmount: number, chartOfAccounts?: { id: string, accountId: string, name: string } | null }> | null, paymentTerms?: { id: string, name: string } | null } | null };

export type AccountPayableWriteoffsQueryVariables = Exact<{
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type AccountPayableWriteoffsQuery = { accountPayableWriteoffs: { data: Array<{ id: string, secondaryId?: number | null, invoiceId: string, amount: number, notes?: string | null, reasonCode: ApWriteoffReasonCode, status: ApWriteoffStatus, entityId: string, createdBy: string, createdAt: any, writeoffDate: any, updatedAt: any, createdByName?: string | null, postedAt?: any | null, postedByName?: string | null }>, meta: { totalCount?: number | null, page?: number | null, limit?: number | null, total?: number | null } } };

export type CreateAccountPayableInvoiceMutationVariables = Exact<{
  createAccountPayableInvoice: CreateAccountPayableInvoiceInput;
}>;


export type CreateAccountPayableInvoiceMutation = { createAccountPayableInvoice: { id: string } };

export type UpdateAccountPayableInvoiceMutationVariables = Exact<{
  updateAccountPayableInvoice: UpdateAccountPayableInvoiceInput;
}>;


export type UpdateAccountPayableInvoiceMutation = { updateAccountPayableInvoice?: { id: string } | null };

export type CreateAccountPayableWriteoffMutationVariables = Exact<{
  createAccountPayableWriteoff: CreateAccountPayableWriteoffInput;
}>;


export type CreateAccountPayableWriteoffMutation = { createAccountPayableWriteoff: { id: string, status: ApWriteoffStatus } };

export type UpdateAccountPayableWriteoffMutationVariables = Exact<{
  updateAccountPayableWriteoff: UpdateAccountPayableWriteoffInput;
}>;


export type UpdateAccountPayableWriteoffMutation = { updateAccountPayableWriteoff?: { id: string, status: ApWriteoffStatus, amount: number, notes?: string | null, reasonCode: ApWriteoffReasonCode, writeoffDate: any, updatedAt: any } | null };

export type OutstandingAccountPayableInvoicesQueryVariables = Exact<{
  filter: OutstandingApInvoiceFilterInput;
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type OutstandingAccountPayableInvoicesQuery = { outstandingAccountPayableInvoices: { data: Array<{ id: string, invoiceNo?: number | null, type: AccountPayableInvoiceType, invoiceDate: any, dueDate?: any | null, totalAmount: number, outstandingAmount: number, aging?: string | null }> } };

export type CreateAccountPayablePaymentMutationVariables = Exact<{
  createAccountPayablePayment: CreateAccountPayablePaymentInput;
}>;


export type CreateAccountPayablePaymentMutation = { createAccountPayablePayment: { id: string } };

export type AccountPayablePaymentQueryVariables = Exact<{
  accountPayablePaymentId: Scalars['ID']['input'];
}>;


export type AccountPayablePaymentQuery = { accountPayablePayment?: { id: string, secondaryId?: number | null, vendorId?: string | null, customerId?: string | null, customerName?: string | null, partnerId?: string | null, paymentDate: any, amount: number, refId?: string | null, challanId?: string | null, method: AccountPayablePaymentMethod, bankId?: string | null, cashId?: string | null, chartOfAccountsId?: string | null, status: ApPaymentStatus, entityId?: string | null, postedBy?: string | null, postedAt?: any | null, comment?: string | null, advancePayment?: number | null, advanceDate?: any | null, advanceRemarks?: string | null, fiscalPeriodName?: string | null, createdByName?: string | null, createdAt?: any | null, offsetTaxHandling?: string | null, offsetDescription?: string | null, partnerName?: string | null, postedByName?: string | null, vendorName?: string | null, bank?: { id: string, name: string, coaAccount?: { accountId: string, name: string } | null } | null, cash?: { id: string, name: string, coaAccount?: { accountId: string, name: string } | null } | null, apSettlementLines?: Array<{ id: string, secondaryId?: number | null, fromType: ApSettlementFromType, paymentId?: string | null, creditMemoId?: string | null, writeoffId?: string | null, invoiceId: string, allocatedAmount: number, fxAllocatedAmount?: number | null, chartOfAccountsId?: string | null, offsetDescription?: string | null, offsetTaxHandling?: string | null, allocationDate: any, status: ApPaymentStatus, notes?: string | null, entityId?: string | null, createdBy: string, createdAt: any, postedAt?: any | null, postedBy?: string | null, updatedAt: any, totalAmount?: number | null, settlementAllocatedAmount?: number | null, outstandingAmount?: number | null, dueDate?: any | null, aging?: number | null, invoiceSecondaryId?: number | null, invoiceDate?: any | null }> | null, journal?: { id: string, journalNo?: string | null, lines?: Array<{ id: string, description?: string | null, debit: number, credit: number, account?: { accountId: string, name: string } | null }> | null } | null, chartOfAccount?: { id: string, accountId: string, name: string } | null } | null };

export type AccountPayablePaymentsQueryVariables = Exact<{
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type AccountPayablePaymentsQuery = { accountPayablePayments: { data: Array<{ id: string, secondaryId?: number | null, vendorId?: string | null, customerId?: string | null, partnerId?: string | null, paymentDate: any, amount: number, refId?: string | null, challanId?: string | null, method: AccountPayablePaymentMethod, bankId?: string | null, cashId?: string | null, chartOfAccountsId?: string | null, offsetDescription?: string | null, offsetTaxHandling?: string | null, journalId?: string | null, status: ApPaymentStatus, entityId?: string | null, postedAt?: any | null, comment?: string | null, advancePayment?: number | null, advanceDate?: any | null, advanceRemarks?: string | null, customerName?: string | null, createdByName?: string | null, createdAt?: any | null, fiscalPeriodName?: string | null, partnerName?: string | null, postedByName?: string | null, vendorName?: string | null, journal?: { id: string, journalNo?: string | null } | null }>, meta: { page?: number | null, limit?: number | null, totalCount?: number | null, total?: number | null } } };

export type UpdateAccountPayablePaymentMutationVariables = Exact<{
  updateAccountPayablePayment: UpdateAccountPayablePaymentInput;
}>;


export type UpdateAccountPayablePaymentMutation = { updateAccountPayablePayment?: { id: string } | null };

export type AccountReceivableInvoicesForOptionsQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
}>;


export type AccountReceivableInvoicesForOptionsQuery = { accountReceivableInvoices: { data?: Array<{ id: string, secondaryId?: number | null, customerId?: string | null, customerName?: string | null, partnerId?: string | null, partnerName?: string | null }> | null, meta?: { totalCount?: number | null, page?: number | null, limit?: number | null, total?: number | null } | null } };

export type AccountReceivableInvoicesQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
}>;


export type AccountReceivableInvoicesQuery = { accountReceivableInvoices: { data?: Array<{ id: string, secondaryId?: number | null, arInvoiceId?: string | null, invoiceType: AccountReceivableInvoiceType, customerId?: string | null, partnerId?: string | null, contactOn?: string | null, relatedInvoiceId?: string | null, relationType?: AccountReceivableInvoiceRelationType | null, invoiceDate: any, dueDate: any, paymentTermsId?: string | null, fxRate?: number | null, discountTotal?: number | null, subtotalAmount: number, taxAmount: number, whtAmount: number, totalAmount: number, roundingAdjustment?: number | null, outstandingAmount: number, writeoffAmount?: number | null, journalId?: string | null, status: AccountReceivableInvoiceStatus, notes?: string | null, locationId?: string | null, partnerName?: string | null, customerName?: string | null, entryMethod: AccountReceivableEntryMethod, createdBy?: string | null, createdAt: any, updatedAt: any, locationName?: string | null, createdByName?: string | null, postedByName?: string | null, fiscalPeriodName?: string | null, paymentTermsName?: string | null, relatedInvoiceSecondaryId?: number | null, journalNo?: string | null, lines?: Array<{ id: string, description: string, discountAmount: number, lineTotal: number, qty: number, taxAmount: number, unitPrice: number, type?: ArInvoiceLineType | null }> | null, journal?: { journalNo?: string | null, id: string } | null }> | null, meta?: { totalCount?: number | null, page?: number | null, limit?: number | null, total?: number | null } | null } };

export type AccountReceivableInvoiceQueryVariables = Exact<{
  accountReceivableInvoiceId: Scalars['ID']['input'];
}>;


export type AccountReceivableInvoiceQuery = { accountReceivableInvoice?: { id: string, secondaryId?: number | null, invoiceType: AccountReceivableInvoiceType, customerId?: string | null, partnerId?: string | null, contactOn?: string | null, arInvoiceId?: string | null, relatedInvoiceId?: string | null, relationType?: AccountReceivableInvoiceRelationType | null, invoiceDate: any, dueDate: any, paymentTermsId?: string | null, fxRate?: number | null, discountTotal?: number | null, subtotalAmount: number, taxAmount: number, whtAmount: number, totalAmount: number, roundingAdjustment?: number | null, outstandingAmount: number, writeoffAmount?: number | null, journalId?: string | null, status: AccountReceivableInvoiceStatus, notes?: string | null, locationId?: string | null, partnerName?: string | null, customerName?: string | null, entryMethod: AccountReceivableEntryMethod, createdBy?: string | null, createdAt: any, updatedAt: any, aging?: string | null, relatedInvoiceSecondaryId?: number | null, locationName?: string | null, journalNo?: string | null, entityId: string, lines?: Array<{ id: string, secondaryId?: number | null, invoiceId: string, productId?: string | null, description: string, qty: number, unitPrice: number, discountAmount: number, taxAmount: number, lineTotal: number, chartOfAccountsId?: string | null, orderId?: string | null, orderLineId?: string | null, orderSecondaryId?: number | null, type?: ArInvoiceLineType | null, locationId?: string | null, locationName?: string | null, profitCenterId?: string | null, costCenterId?: string | null, createdAt: any, updatedAt: any, chartOfAccounts?: { id: string, accountId: string, name: string } | null }> | null, paymentTerms?: { id: string, name: string } | null } | null };

export type AccountReceivableWriteoffsQueryVariables = Exact<{
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
}>;


export type AccountReceivableWriteoffsQuery = { accountReceivableWriteoffs: { data: Array<{ id: string, amount: number, reason: string, reasonCode: ArWriteoffReasonCode, status: ArWriteoffStatus, updatedAt: any, createdAt: any, createdByName?: string | null, postedAt?: any | null, postedByName?: string | null, secondaryId?: number | null }> } };

export type CreateAccountReceivableInvoiceMutationVariables = Exact<{
  createAccountReceivableInvoice: CreateAccountReceivableInvoiceInput;
}>;


export type CreateAccountReceivableInvoiceMutation = { createAccountReceivableInvoice: { id: string } };

export type UpdateAccountReceivableInvoiceMutationVariables = Exact<{
  updateAccountReceivableInvoice: UpdateAccountReceivableInvoiceInput;
}>;


export type UpdateAccountReceivableInvoiceMutation = { updateAccountReceivableInvoice?: { id: string } | null };

export type CreateAccountReceivableWriteoffMutationVariables = Exact<{
  createAccountReceivableWriteoff: CreateAccountReceivableWriteoffInput;
}>;


export type CreateAccountReceivableWriteoffMutation = { createAccountReceivableWriteoff: { id: string, status: ArWriteoffStatus, amount: number, reason: string, reasonCode: ArWriteoffReasonCode } };

export type UpdateAccountReceivableWriteoffMutationVariables = Exact<{
  updateAccountReceivableWriteoff: UpdateAccountReceivableWriteoffInput;
}>;


export type UpdateAccountReceivableWriteoffMutation = { updateAccountReceivableWriteoff?: { id: string, status: ArWriteoffStatus, amount: number, reason: string, reasonCode: ArWriteoffReasonCode, updatedAt: any } | null };

export type OutstandingAccountReceivableInvoicesQueryVariables = Exact<{
  filter: OutstandingInvoiceFilterInput;
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type OutstandingAccountReceivableInvoicesQuery = { outstandingAccountReceivableInvoices: { data: Array<{ id: string, invoiceNo?: number | null, type: AccountReceivableInvoiceType, invoiceDate: any, dueDate: any, totalAmount: number, outstandingAmount: number, aging?: string | null }>, meta: { totalCount?: number | null, page?: number | null, limit?: number | null, total?: number | null } } };

export type CreateAccountReceivableReceiptMutationVariables = Exact<{
  createAccountReceivableReceipt: CreateAccountReceivableReceiptInput;
}>;


export type CreateAccountReceivableReceiptMutation = { createAccountReceivableReceipt: { __typename: 'AccountReceivableReceipt' } };

export type UpdateAccountReceivableReceiptMutationVariables = Exact<{
  updateAccountReceivableReceipt: UpdateAccountReceivableReceiptInput;
}>;


export type UpdateAccountReceivableReceiptMutation = { updateAccountReceivableReceipt?: { id: string } | null };

export type AccountReceivableReceiptsQueryVariables = Exact<{
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type AccountReceivableReceiptsQuery = { accountReceivableReceipts: { data: Array<{ id: string, secondaryId?: number | null, entityId: string, customerId?: string | null, partnerId?: string | null, vendorId?: string | null, amountReceived: string, mode: AccountReceivableReceiptMode, status: ArReceiptStatus, refId?: string | null, challanId?: string | null, bankId?: string | null, cashId?: string | null, chartOfAccountsId?: string | null, offsetDescription?: string | null, offsetTaxHandling?: string | null, journalId?: string | null, dateReceived: any, postedAt?: any | null, postedBy?: string | null, comment?: string | null, advancePayment?: number | null, advanceDate?: any | null, advanceRemarks?: string | null, createdByName?: string | null, postedByName?: string | null, arInvoice?: { id: string, secondaryId?: number | null, arInvoiceId?: string | null, invoiceType: AccountReceivableInvoiceType, customerId?: string | null, partnerId?: string | null, invoiceDate: any, dueDate: any, totalAmount: number, outstandingAmount: number, status: AccountReceivableInvoiceStatus, customerName?: string | null, partnerName?: string | null, notes?: string | null } | null, bank?: { id: string, secondaryId?: number | null, name: string, accountNumber: string } | null, journal?: { id: string, secondaryId?: number | null, journalNo?: string | null, journalDate: any, status: JournalStatus, entityId: string } | null }>, meta: { page?: number | null, limit?: number | null, totalCount?: number | null, total?: number | null } } };

export type AccountReceivableReceiptsByInvoiceQueryVariables = Exact<{
  arId: Scalars['ID']['input'];
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type AccountReceivableReceiptsByInvoiceQuery = { accountReceivableReceiptsByInvoice: { data: Array<{ id: string, secondaryId?: number | null, customerId?: string | null, partnerId?: string | null, amountReceived: string, mode: AccountReceivableReceiptMode, status: ArReceiptStatus, refId?: string | null, challanId?: string | null, journalId?: string | null, dateReceived: any, postedAt?: any | null, postedBy?: string | null, comment?: string | null, arInvoice?: { id: string } | null }>, meta: { page?: number | null, limit?: number | null, totalCount?: number | null, total?: number | null } } };

export type AccountReceivableReceiptQueryVariables = Exact<{
  accountReceivableReceiptId: Scalars['ID']['input'];
}>;


export type AccountReceivableReceiptQuery = { accountReceivableReceipt?: { id: string, secondaryId?: number | null, entityId: string, customerId?: string | null, customerName?: string | null, partnerId?: string | null, partnerName?: string | null, vendorId?: string | null, createdByName?: string | null, createdAt?: any | null, amountReceived: string, mode: AccountReceivableReceiptMode, status: ArReceiptStatus, refId?: string | null, challanId?: string | null, bankId?: string | null, cashId?: string | null, chartOfAccountsId?: string | null, offsetDescription?: string | null, offsetTaxHandling?: string | null, journalId?: string | null, dateReceived: any, postedAt?: any | null, postedBy?: string | null, postedByName?: string | null, comment?: string | null, advancePayment?: number | null, advanceDate?: any | null, advanceRemarks?: string | null, arInvoice?: { id: string, secondaryId?: number | null, arInvoiceId?: string | null, invoiceType: AccountReceivableInvoiceType, customerId?: string | null, partnerId?: string | null, contactOn?: string | null, invoiceDate: any, dueDate: any, paymentTermsId?: string | null, fxRate?: number | null, discountTotal?: number | null, subtotalAmount: number, taxAmount: number, whtAmount: number, totalAmount: number, roundingAdjustment?: number | null, outstandingAmount: number, writeoffAmount?: number | null, journalId?: string | null, status: AccountReceivableInvoiceStatus, notes?: string | null, locationId?: string | null, partnerName?: string | null, customerName?: string | null, entryMethod: AccountReceivableEntryMethod, createdBy?: string | null, createdAt: any, updatedAt: any, lines?: Array<{ id: string, secondaryId?: number | null, invoiceId: string, description: string, qty: number, unitPrice: number, discountAmount: number, taxAmount: number, lineTotal: number, type?: ArInvoiceLineType | null }> | null } | null, bank?: { id: string, secondaryId?: number | null, name: string, accountNumber: string, entityId: string, entity?: { entityName: string } | null, coaAccount?: { accountId: string, name: string } | null } | null, cash?: { id: string, code: string, name: string, coaAccount?: { accountId: string, name: string } | null } | null, chartOfAccounts?: { accountId: string, name: string } | null, journal?: { id: string, secondaryId?: number | null, journalNo?: string | null, journalDate: any, status: JournalStatus, entityId: string, lines?: Array<{ id: string, description?: string | null, debit: number, credit: number, account?: { accountId: string, name: string } | null }> | null } | null, settlementLines?: Array<{ id: string, secondaryId?: number | null, invoiceId: string, allocatedAmount: number, allocationDate: any, notes?: string | null, fxAllocatedAmount?: number | null, fromType: ArSettlementFromType, status: ArReceiptStatus, receiptId?: string | null, dueDate?: any | null, aging?: number | null, outstandingAmount?: number | null, totalAmount?: number | null, settlementAllocatedAmount?: number | null, invoice?: { id: string, secondaryId?: number | null, arInvoiceId?: string | null, status: AccountReceivableInvoiceStatus } | null }> | null } | null };

export type BalanceSheetReportQueryVariables = Exact<{
  entityId: Scalars['ID']['input'];
  asOfDate: Scalars['DateTime']['input'];
  costCenterIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  profitCenterIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  locationIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type BalanceSheetReportQuery = { balanceSheetReport: { totalAssets: string, totalLiabilities: string, totalEquity: string, netIncome: string, isBalanced: boolean, asOfDate: any, currency: string, rows: Array<{ accountId: string, accountCode?: string | null, accountName: string, parentAccountId?: string | null, level: number, isGroup: boolean, accountType?: ChartAccountType | null, debit: string, credit: string, balance: string }> } };

export type CreateBankAccountMutationVariables = Exact<{
  createBankAccount: CreateBankAccountInput;
}>;


export type CreateBankAccountMutation = { createBankAccount: { id: string } };

export type UpdateBankAccountMutationVariables = Exact<{
  updateBankAccount: UpdateBankAccountInput;
}>;


export type UpdateBankAccountMutation = { updateBankAccount?: { id: string } | null };

export type DeleteBankAccountMutationVariables = Exact<{
  deleteBankAccountId: Scalars['ID']['input'];
}>;


export type DeleteBankAccountMutation = { deleteBankAccount: boolean };

export type BankAccountsQueryVariables = Exact<{
  locationId?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
}>;


export type BankAccountsQuery = { bankAccounts: { meta: { page?: number | null, limit?: number | null, totalCount?: number | null, total?: number | null }, data: Array<{ id: string, secondaryId?: number | null, name: string, accountNumber: string, accountTitle: string, currency: CurrencyTypeEnum, coaAccountId: string, openingBalance?: number | null, openingBalanceDate?: any | null, status: BankAccountStatus, entityId: string, createdAt: any, createdByName?: string | null, updatedAt?: any | null, updatedByName?: string | null, coaAccount?: { id: string, name: string } | null, entity?: { id: string, entityName: string } | null, locations?: Array<{ locationName?: string | null, locationId: string }> | null }> } };

export type BankAccountsForOptionsQueryVariables = Exact<{
  locationId?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
}>;


export type BankAccountsForOptionsQuery = { bankAccounts: { meta: { page?: number | null, limit?: number | null, totalCount?: number | null }, data: Array<{ id: string, secondaryId?: number | null, name: string }> } };

export type BankAccountQueryVariables = Exact<{
  bankAccountId: Scalars['ID']['input'];
}>;


export type BankAccountQuery = { bankAccount?: { id: string, secondaryId?: number | null, name: string, currency: CurrencyTypeEnum, accountNumber: string, accountTitle: string, coaAccountId: string, openingBalance?: number | null, openingBalanceDate?: any | null, status: BankAccountStatus, entityId: string, createdAt: any, createdByName?: string | null, updatedAt?: any | null, updatedByName?: string | null, entity?: { id: string, entityName: string } | null, coaAccount?: { id: string, name: string } | null, locations?: Array<{ locationId: string, locationName?: string | null, id: string }> | null } | null };

export type CreateCashAccountMutationVariables = Exact<{
  createCashAccount: CreateCashAccountInput;
}>;


export type CreateCashAccountMutation = { createCashAccount: { id: string } };

export type UpdateCashAccountMutationVariables = Exact<{
  updateCashAccount: UpdateCashAccountInput;
}>;


export type UpdateCashAccountMutation = { updateCashAccount?: { id: string } | null };

export type CashAccountsListQueryVariables = Exact<{
  locationId?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
}>;


export type CashAccountsListQuery = { cashAccounts: { meta: { page?: number | null, limit?: number | null, totalCount?: number | null, total?: number | null }, data: Array<{ id: string, secondaryId?: number | null, code: string, cashRegister?: string | null, name: string, financeDrawerId?: string | null, currency: CurrencyTypeEnum, coaAccountId: string, status: CashAccountStatus, entityId: string, createdAt: any, createdBy: string, locations?: Array<{ locationId: string, id: string }> | null, entity?: { id: string, entityName: string } | null, coaAccount?: { id: string, name: string } | null, posRegisterMaps?: Array<{ posRegisterId: string, id: string }> | null }> } };

export type CashAccountsForOptionsQueryVariables = Exact<{
  locationId?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
}>;


export type CashAccountsForOptionsQuery = { cashAccounts: { meta: { page?: number | null, limit?: number | null, totalCount?: number | null }, data: Array<{ id: string, secondaryId?: number | null, name: string }> } };

export type CashAccountDetailQueryVariables = Exact<{
  cashAccountId: Scalars['ID']['input'];
}>;


export type CashAccountDetailQuery = { cashAccount?: { id: string, secondaryId?: number | null, code: string, cashRegister?: string | null, name: string, financeDrawerId?: string | null, currency: CurrencyTypeEnum, coaAccountId: string, status: CashAccountStatus, entityId: string, createdAt: any, createdBy: string, locations?: Array<{ locationId: string, id: string }> | null, entity?: { id: string, entityName: string } | null, coaAccount?: { id: string, name: string } | null, posRegisterMaps?: Array<{ posRegisterId: string, id: string }> | null } | null };

export type CashDepositControlsQueryVariables = Exact<{
  filter: CashDepositControlFilter;
}>;


export type CashDepositControlsQuery = { cashDepositControls: Array<{ id: string, entityId: string, locationId: string, businessDate: any, expectedCashAmount: number, netDepositableCashAmount: number, alreadyDepositedAmount: number, remainingDepositAmount: number, status: CashDepositControlStatus }> };

export type CashDepositsQueryVariables = Exact<{
  controlId: Scalars['ID']['input'];
}>;


export type CashDepositsQuery = { cashDeposits: Array<{ id: string, depositNo?: string | null, depositDate: any, depositAmount: number, bankAccountId: string, depositSlipNo?: string | null, status: CashDepositStatus, postedBy?: string | null, postedByName?: string | null, postedAt?: any | null }> };

export type CashDepositConfigQueryVariables = Exact<{
  entityId: Scalars['ID']['input'];
}>;


export type CashDepositConfigQuery = { cashDepositConfig?: { id: string, entityId: string, allowRegisterLines: boolean, allowOverDeposit: boolean, status: Status } | null };

export type GenerateDepositControlMutationVariables = Exact<{
  input: GenerateDepositControlInput;
}>;


export type GenerateDepositControlMutation = { generateDepositControl: Array<{ id: string, status: CashDepositControlStatus, expectedCashAmount: number, netDepositableCashAmount: number }> };

export type CreateCashDepositDraftMutationVariables = Exact<{
  input: CreateCashDepositInput;
}>;


export type CreateCashDepositDraftMutation = { createCashDepositDraft: { id: string, depositNo?: string | null, status: CashDepositStatus } };

export type PostCashDepositMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PostCashDepositMutation = { postCashDeposit: { id: string, status: CashDepositStatus, journalEntryId?: string | null, bankTransactionId?: string | null, depositNo?: string | null } };

export type CancelCashDepositMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CancelCashDepositMutation = { cancelCashDeposit: { id: string, status: CashDepositStatus } };

export type UpsertCashDepositConfigMutationVariables = Exact<{
  input: UpsertCashDepositConfigInput;
}>;


export type UpsertCashDepositConfigMutation = { upsertCashDepositConfig: { id: string, allowRegisterLines: boolean, allowOverDeposit: boolean } };

export type ChartOfAccountsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
}>;


export type ChartOfAccountsQuery = { chartOfAccounts: { data: Array<{ accountId: string, balanceType: BalanceType, entityId: string, id: string, isControl: boolean, isReconciliation: boolean, isSystem: boolean, name: string, type: ChartAccountType, reportingGroup: ReportingGroup, status: AccountStatus, createdByName?: string | null, createdAt?: any | null, updatedByName?: string | null, updatedAt?: any | null, secondaryId?: number | null, parentAccountId?: string | null, accountSubtypeId?: string | null, entity?: { entityName: string } | null, parentAccount?: { name: string } | null, subtype?: { id: string, name: string, code: string } | null }>, meta: { page?: number | null, limit?: number | null, totalCount?: number | null, total?: number | null } } };

export type CreateChartOfAccountMutationVariables = Exact<{
  input: CreateChartOfAccountsInput;
}>;


export type CreateChartOfAccountMutation = { createChartOfAccount: { id: string, accountId: string, name: string, balanceType: BalanceType, entityId: string, type: ChartAccountType, reportingGroup: ReportingGroup, status: AccountStatus, isSystem: boolean, isControl: boolean, isReconciliation: boolean, parentAccount?: { name: string } | null } };

export type ChartOfAccountsListForOptionsQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
}>;


export type ChartOfAccountsListForOptionsQuery = { chartOfAccounts: { data: Array<{ id: string, accountId: string, name: string, type: ChartAccountType, parentAccountId?: string | null }>, meta: { page?: number | null, limit?: number | null, totalCount?: number | null, total?: number | null } } };

export type CreateCostCenterMutationVariables = Exact<{
  createCostCenter: CreateCostCenterInput;
}>;


export type CreateCostCenterMutation = { createCostCenter: { id: string } };

export type UpdateCostCenterMutationVariables = Exact<{
  updateCostCenter: UpdateCostCenterInput;
}>;


export type UpdateCostCenterMutation = { updateCostCenter?: { id: string } | null };

export type CostCenterQueryVariables = Exact<{
  costCenterId: Scalars['ID']['input'];
}>;


export type CostCenterQuery = { costCenter?: { id: string, secondaryId: number, code: string, name: string, type: CostCenterType, isDefault: boolean, costBehavior?: CostBehavior | null, effectiveFrom?: any | null, effectiveTo?: any | null, status: Status, parentCcId?: string | null, managerId?: string | null, managerName?: string | null, entityId: string, createdBy: string, createdAt: any, updatedBy?: string | null, updatedAt: any, createdByName?: string | null, updatedByName?: string | null, locations?: Array<{ id: string, locationId: string, locationName?: string | null }> | null, parentCc?: { name: string, id: string } | null, entity?: { id: string, entityName: string } | null, coaAccounts?: Array<{ id: string, coaAccountId: string, coaAccount?: { id: string, name: string } | null }> | null } | null };

export type CostCentersListQueryVariables = Exact<{
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CostCentersListQuery = { costCenters: { meta: { page?: number | null, limit?: number | null, totalCount?: number | null, total?: number | null }, data: Array<{ id: string, secondaryId: number, code: string, name: string, type: CostCenterType, isDefault: boolean, costBehavior?: CostBehavior | null, effectiveFrom?: any | null, effectiveTo?: any | null, status: Status, parentCcId?: string | null, managerId?: string | null, createdBy: string, createdAt: any, updatedBy?: string | null, updatedAt: any, managerName?: string | null, createdByName?: string | null, updatedByName?: string | null, parentCc?: { id: string, name: string } | null, locations?: Array<{ locationId: string, locationName?: string | null }> | null, coaAccounts?: Array<{ coaAccount?: { id: string, name: string } | null }> | null, entity?: { id: string, entityName: string } | null }> } };

export type CostCentersListForOptionsQueryVariables = Exact<{
  locationId?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
}>;


export type CostCentersListForOptionsQuery = { costCenters: { meta: { page?: number | null, limit?: number | null, totalCount?: number | null, total?: number | null }, data: Array<{ id: string, secondaryId: number, code: string, name: string }> } };

export type CreateEntityMutationVariables = Exact<{
  input: CreateEntityInput;
}>;


export type CreateEntityMutation = { createEntity: { id: string, country: string, entityName: string, fiscalYearType: FiscalYearType, secondaryId?: number | null } };

export type EntitiesListQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
}>;


export type EntitiesListQuery = { entities: { data: Array<{ country: string, entityName: string, fiscalYearType: FiscalYearType, secondaryId?: number | null, id: string }>, meta: { page?: number | null, limit?: number | null, totalCount?: number | null, total?: number | null } } };

export type EntitiesQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type EntitiesQuery = { entities: { data: Array<{ country: string, entityName: string, fiscalYearType: FiscalYearType, secondaryId?: number | null, id: string }>, meta: { page?: number | null, limit?: number | null, totalCount?: number | null, total?: number | null } } };

export type FinanceStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type FinanceStatsQuery = { finance_stats: { openJournalsCount: number, receivablesOutstandingAmount: number, totalReceivablesCount: number, payablesOutstandingAmount: number, totalPayablesCount: number, currentFiscalPeriod?: { id: string, name: string, startDate: any, endDate: any, isOpen: boolean } | null } };

export type CreateFiscalYearMutationVariables = Exact<{
  createFiscalYear: CreateFiscalYearInput;
}>;


export type CreateFiscalYearMutation = { createFiscalYear: { id: string } };

export type CreateFiscalPeriodMutationVariables = Exact<{
  createFiscalPeriod: CreateFiscalPeriodInput;
}>;


export type CreateFiscalPeriodMutation = { createFiscalPeriod: { id: string } };

export type UpdateFiscalPeriodMutationVariables = Exact<{
  updateFiscalPeriod: UpdateFiscalPeriodInput;
}>;


export type UpdateFiscalPeriodMutation = { updateFiscalPeriod?: { id: string } | null };

export type FiscalYearsListQueryVariables = Exact<{
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type FiscalYearsListQuery = { fiscalYears: { meta: { page?: number | null, limit?: number | null, totalCount?: number | null, total?: number | null }, data: Array<{ id: string, secondaryId?: number | null, fiscalYearName: string, startDate: any, endDate: any, entityId: string, createdByName?: string | null, createdAt?: any | null }> } };

export type FiscalPeriodsQueryVariables = Exact<{
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type FiscalPeriodsQuery = { fiscalPeriods: { data: Array<{ id: string, secondaryId?: number | null, fiscalYearId: string, name: string, startDate: any, endDate: any, isOpen: boolean, createdByName?: string | null, createdAt?: any | null }>, meta: { page?: number | null, limit?: number | null, totalCount?: number | null, total?: number | null } } };

export type GeneralLedgerReportQueryVariables = Exact<{
  entityId: Scalars['ID']['input'];
  startDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
  costCenterIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  profitCenterIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  locationIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type GeneralLedgerReportQuery = { generalLedgerReport: { totalDebit: string, totalCredit: string, totalBalance: string, startDate: any, endDate: any, currency: string, rows: Array<{ accountId: string, accountCode?: string | null, accountName: string, parentAccountId?: string | null, level: number, isGroup: boolean, accountType?: ChartAccountType | null, debit: string, credit: string, balance: string }> } };

export type IncomeStatementReportQueryVariables = Exact<{
  entityId: Scalars['ID']['input'];
  startDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
  costCenterIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  profitCenterIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  locationIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type IncomeStatementReportQuery = { incomeStatementReport: { totalRevenue: string, totalExpense: string, netIncome: string, startDate: any, endDate: any, currency: string, rows: Array<{ accountId: string, accountCode?: string | null, accountName: string, parentAccountId?: string | null, level: number, isGroup: boolean, accountType?: ChartAccountType | null, debit: string, credit: string, balance: string }> } };

export type CreateInvoicePolicyConfigMutationVariables = Exact<{
  createInvoicePolicyConfigDto: CreateInvoicePolicyConfigDto;
}>;


export type CreateInvoicePolicyConfigMutation = { createInvoicePolicyConfig: { id: string } };

export type UpdateInvoicePolicyConfigMutationVariables = Exact<{
  updateInvoicePolicyConfigDto: UpdateInvoicePolicyConfigDto;
}>;


export type UpdateInvoicePolicyConfigMutation = { updateInvoicePolicyConfig: { id: string } };

export type GetInvoicePolicyConfigQueryVariables = Exact<{
  getInvoicePolicyConfigId: Scalars['String']['input'];
}>;


export type GetInvoicePolicyConfigQuery = { getInvoicePolicyConfig?: { id: string, partnerId?: string | null, customerId?: string | null, invoicePolicyCode: InvoicePolicyCode, effectiveDate: any, effectiveTillDate?: any | null, groupByLocation: boolean, groupByEntity: boolean, groupByBusinessDate: boolean, status: Status, createdAt?: any | null, updatedAt?: any | null, updatedByName?: string | null, createdByName?: string | null, secondaryId: number } | null };

export type GetInvoicePolicyConfigsListQueryVariables = Exact<{
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetInvoicePolicyConfigsListQuery = { getInvoicePolicyConfigs: { meta: { page?: number | null, limit?: number | null, totalCount?: number | null, total?: number | null }, data: Array<{ id: string, partnerId?: string | null, customerId?: string | null, invoicePolicyCode: InvoicePolicyCode, effectiveDate: any, effectiveTillDate?: any | null, groupByLocation: boolean, groupByEntity: boolean, groupByBusinessDate: boolean, status: Status, createdAt?: any | null, updatedAt?: any | null, updatedByName?: string | null, createdByName?: string | null, secondaryId: number, partnerName?: string | null, customerName?: string | null }> } };

export type CreateJournalHeaderMutationVariables = Exact<{
  input: CreateJournalHeaderInput;
}>;


export type CreateJournalHeaderMutation = { createJournalHeader: { id: string } };

export type UpdateJournalHeaderMutationVariables = Exact<{
  input: UpdateJournalHeaderInput;
}>;


export type UpdateJournalHeaderMutation = { updateJournalHeader?: { id: string } | null };

export type JournalHeaderByIdQueryVariables = Exact<{
  journalHeaderId: Scalars['ID']['input'];
}>;


export type JournalHeaderByIdQuery = { journalHeader?: { id: string, secondaryId?: number | null, journalNo?: string | null, sourceModuleId: string, entryMethod: EntryMethod, sourceDocType?: SourceDocType | null, sourceDocId?: string | null, journalDate: any, fiscalPeriodId: string, status: JournalStatus, reversalRefId?: string | null, entityId: string, createdBy: string, createdByName?: string | null, createdAt: any, postedBy?: string | null, postedByName?: string | null, postedAt?: any | null, fiscalPeriod?: { id: string, name: string, secondaryId?: number | null } | null, entity?: { id: string, entityName: string } | null, sourceModule?: { id: string, name: string } | null } | null };

export type JournalHeadersListQueryVariables = Exact<{
  locationId?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
}>;


export type JournalHeadersListQuery = { journalHeaders: { data: Array<{ id: string, secondaryId?: number | null, journalNo?: string | null, journalDate: any, status: JournalStatus, createdBy: string, createdAt: any, postedBy?: string | null, postedAt?: any | null, totalDebit?: number | null, totalCredit?: number | null, createdByName?: string | null, postedByName?: string | null, sourceModule?: { id: string, name: string } | null, fiscalPeriod?: { id: string, name: string } | null }>, meta: { page?: number | null, limit?: number | null, totalCount?: number | null, total?: number | null } } };

export type JournalLinesByHeaderIdQueryVariables = Exact<{
  journalHeaderId: Scalars['ID']['input'];
}>;


export type JournalLinesByHeaderIdQuery = { journalLinesByHeaderId: Array<{ id: string, journalHeaderId: string, debit: number, credit: number, costCenterId?: string | null, profitCenterId?: string | null, projectId?: string | null, partnerId?: string | null, customerId?: string | null, vendorId?: string | null, currencyId?: string | null, refId?: string | null, description?: string | null, profitCenterSource?: CenterSource | null, costCenterSource?: CenterSource | null, locationId?: string | null, customerName?: string | null, vendorName?: string | null, partnerName?: string | null, locationName?: string | null, account?: { id: string, accountId: string, name: string } | null }> };

export type PaymentTermsQueryVariables = Exact<{
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type PaymentTermsQuery = { paymentTerms: { meta: { page?: number | null, limit?: number | null, totalCount?: number | null, total?: number | null }, data: Array<{ id: string, secondaryId?: number | null, name: string, description?: string | null, graceDays: number, baseDateType: BaseDateType, baseDate?: any | null, isInstallmentBased: boolean, isDiscountApplicable: boolean, applicableOn: ApplicableOn, isActive: boolean, entityId: string, updatedAt: any, createdBy?: string | null, createdByName?: string | null, updatedByName?: string | null, schedules?: Array<{ id: string, secondaryId?: number | null, paymentTermId: string, paymentNo: number, dueOffsetDays: number, duePercent: number, fixedAmount?: number | null, calculationBasis: CalculationBasis, entityId: string, updatedAt: any, createdBy?: string | null }> | null, discounts?: Array<{ id: string, calculationMethod: DiscountCalculationMethod, discountDays: number, discountPercent: number }> | null }> } };

export type PaymentTermsForOptionsQueryVariables = Exact<{
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type PaymentTermsForOptionsQuery = { paymentTerms: { data: Array<{ id: string, name: string, graceDays: number }>, meta: { limit?: number | null, page?: number | null, totalCount?: number | null } } };

export type GetPaymentTermQueryVariables = Exact<{
  paymentTermId: Scalars['ID']['input'];
}>;


export type GetPaymentTermQuery = { paymentTerm?: { applicableOn: ApplicableOn, baseDate?: any | null, baseDateType: BaseDateType, description?: string | null, entityId: string, graceDays: number, id: string, isActive: boolean, isDiscountApplicable: boolean, isInstallmentBased: boolean, name: string, discounts?: Array<{ discountDays: number, discountPercent: number, calculationMethod: DiscountCalculationMethod }> | null, schedules?: Array<{ paymentNo: number, fixedAmount?: number | null, duePercent: number, dueOffsetDays: number, calculationBasis: CalculationBasis }> | null } | null };

export type CreatePaymentTermsMutationVariables = Exact<{
  createPaymentTerms: CreatePaymentTermsInput;
}>;


export type CreatePaymentTermsMutation = { createPaymentTerms: { id: string } };

export type UpdatePaymentTermsMutationVariables = Exact<{
  updatePaymentTerms: UpdatePaymentTermsInput;
}>;


export type UpdatePaymentTermsMutation = { updatePaymentTerms?: { id: string } | null };

export type UpdateProfitCenterMutationVariables = Exact<{
  updateProfitCenter: UpdateProfitCenterInput;
}>;


export type UpdateProfitCenterMutation = { updateProfitCenter?: { id: string } | null };

export type CreateProfitCenterMutationVariables = Exact<{
  createProfitCenter: CreateProfitCenterInput;
}>;


export type CreateProfitCenterMutation = { createProfitCenter: { id: string } };

export type ProfitCenterDetailQueryVariables = Exact<{
  profitCenterId: Scalars['ID']['input'];
}>;


export type ProfitCenterDetailQuery = { profitCenter?: { id: string, secondaryId: number, code: string, name: string, type: ProfitCenterType, isDefault: boolean, effectiveFrom?: any | null, effectiveTo?: any | null, status: Status, parentPcId?: string | null, managerId?: string | null, managerName?: string | null, entityId: string, createdBy: string, createdAt: any, updatedBy?: string | null, updatedAt: any, createdByName?: string | null, updatedByName?: string | null, parentPc?: { id: string, name: string } | null, entity?: { id: string, entityName: string } | null, coaAccounts?: Array<{ id: string, coaAccountId: string, coaAccount?: { id: string, name: string } | null }> | null, locations?: Array<{ locationId: string, id: string, locationName?: string | null }> | null } | null };

export type ProfitCentersListQueryVariables = Exact<{
  locationId?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
}>;


export type ProfitCentersListQuery = { profitCenters: { meta: { page?: number | null, limit?: number | null, totalCount?: number | null, total?: number | null }, data: Array<{ id: string, secondaryId: number, code: string, name: string, type: ProfitCenterType, isDefault: boolean, effectiveFrom?: any | null, effectiveTo?: any | null, status: Status, parentPcId?: string | null, managerId?: string | null, entityId: string, createdBy: string, createdAt: any, updatedBy?: string | null, updatedAt: any, managerName?: string | null, updatedByName?: string | null, createdByName?: string | null, parentPc?: { id: string, name: string } | null, locations?: Array<{ locationId: string, id: string, locationName?: string | null }> | null, entity?: { id: string, entityName: string } | null, coaAccounts?: Array<{ coaAccount?: { id: string, name: string } | null }> | null }> } };

export type ProfitCentersListForOptionsQueryVariables = Exact<{
  locationId?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
}>;


export type ProfitCentersListForOptionsQuery = { profitCenters: { meta: { page?: number | null, limit?: number | null, totalCount?: number | null, total?: number | null }, data: Array<{ id: string, secondaryId: number, code: string, name: string }> } };

export type CreateSourceModuleMutationVariables = Exact<{
  input: CreateSourceModuleInput;
}>;


export type CreateSourceModuleMutation = { createSourceModule: { id: string } };

export type DeleteSourceModuleMutationVariables = Exact<{
  deleteSourceModuleId: Scalars['ID']['input'];
}>;


export type DeleteSourceModuleMutation = { deleteSourceModule: boolean };

export type UpdateSourceModuleMutationVariables = Exact<{
  input: UpdateSourceModuleInput;
}>;


export type UpdateSourceModuleMutation = { updateSourceModule?: { id: string } | null };

export type SourceModuleQueryVariables = Exact<{
  sourceModuleId: Scalars['ID']['input'];
}>;


export type SourceModuleQuery = { sourceModule?: { id: string, code: string, name: string, prefix: string, autoPostEnabled: boolean, resetCycle: ResetCycle, allowManualNumber: boolean, description?: string | null, entityId: string, createdBy: string, createdAt: any, entity?: { entityName: string, id: string } | null } | null };

export type SourceModulesListQueryVariables = Exact<{
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
}>;


export type SourceModulesListQuery = { sourceModules: { meta: { page?: number | null, limit?: number | null, totalCount?: number | null, total?: number | null }, data: Array<{ id: string, code: string, name: string, prefix: string, autoPostEnabled: boolean, resetCycle: ResetCycle, allowManualNumber: boolean, description?: string | null, createdBy: string, createdAt: any, secondaryId?: number | null, entity?: { id: string, entityName: string } | null }> } };

export type SourceModulesListForOptionsQueryVariables = Exact<{
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
}>;


export type SourceModulesListForOptionsQuery = { sourceModules: { data: Array<{ id: string, name: string }> } };

export type TrialBalanceReportExtendedQueryVariables = Exact<{
  entityId: Scalars['ID']['input'];
  startDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
  costCenterIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  profitCenterIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  locationIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type TrialBalanceReportExtendedQuery = { trialBalanceReport: { totalOpeningDebit: string, totalOpeningCredit: string, totalDebit: string, totalCredit: string, totalClosingDebit: string, totalClosingCredit: string, isBalanced: boolean, startDate: any, endDate: any, currency: string, rows: Array<{ accountId: string, accountCode?: string | null, accountName: string, parentAccountId?: string | null, level: number, isGroup: boolean, accountType?: ChartAccountType | null, debit: string, credit: string, balance: string, openingDebit: string, openingCredit: string, closingDebit: string, closingCredit: string }> } };

export type GetAdjustmentsListQueryVariables = Exact<{
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
  page: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
}>;


export type GetAdjustmentsListQuery = { getAdjustments: { meta: { limit?: number | null, page?: number | null, total?: number | null, totalCount?: number | null }, data: Array<{ adjustedQuantity: number, adjustmentType: AdjustmentType, auditId?: string | null, id: string, createdAt: any, createdBy: string, itemCount: number, lotCount: number, remarks?: string | null, secondaryId: number, status: AdjustmentStatus, stockValue: number, stockValueExcludingTax: number, taxValue: number, title: string, updatedAt: any, updatedBy?: string | null }> } };

export type UpdateAdjustmentStatusMutationVariables = Exact<{
  updateAdjustmentStatusId: Scalars['String']['input'];
  status: AdjustmentStatus;
}>;


export type UpdateAdjustmentStatusMutation = { updateAdjustmentStatus: boolean };

export type CreateAdjustmentMutationVariables = Exact<{
  createAdjustmentDto: CreateAdjustmentDto;
}>;


export type CreateAdjustmentMutation = { createAdjustment: boolean };

export type GetAdjustmentQueryVariables = Exact<{
  getAdjustmentId: Scalars['String']['input'];
}>;


export type GetAdjustmentQuery = { getAdjustment: { id: string, adjustmentType: AdjustmentType, secondaryId: number, remarks?: string | null, status: AdjustmentStatus, title: string, createdAt: any, updatedAt: any, products: Array<{ id: string, locationId?: string | null, productName: string, netQuantity: number, stockValue: number, adjustmentLot: Array<{ id: string, actionId?: string | null, status?: string | null, adjustedStatus?: ProductLotStatus | null, adjustedExpiryDate?: string | null, expiryDate?: string | null, adjustedQuantity?: number | null, damageQuantity?: number | null, damageQuantityUnit?: DamageQuantityUnit | null, originalQuantity?: number | null, adjustedLocation?: { name: string } | null, location?: { name: string } | null }> }> } };

export type ValidateAdjustmentLotsQueryVariables = Exact<{
  validateAdjustmentDto: ValidateAdjustmentDto;
}>;


export type ValidateAdjustmentLotsQuery = { validateAdjustmentLots: Array<{ actionId: string, locationId: string, errors: Array<string> }> };

export type CalculatedColumnFunctionsQueryVariables = Exact<{ [key: string]: never; }>;


export type CalculatedColumnFunctionsQuery = { calculatedColumnFunctions: Array<{ name: string, category: string, signature: string, description: string }> };

export type CheckCalculatedColumnQueryVariables = Exact<{
  input: CheckCalculatedColumnInput;
}>;


export type CheckCalculatedColumnQuery = { checkCalculatedColumn: { valid: boolean, resultType?: string | null, volatile: boolean, error?: string | null } };

export type CalculatedColumnUsageQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type CalculatedColumnUsageQuery = { calculatedColumnUsage: { reports: Array<{ id: string, name: string }>, columns: Array<{ id: string, name: string }> } };

export type CreateCalculatedColumnMutationVariables = Exact<{
  input: CreateCalculatedColumnInput;
}>;


export type CreateCalculatedColumnMutation = { createCalculatedColumn: { id: string, key: string, label: string, expression: string, resultType: string, format?: string | null } };

export type UpdateCalculatedColumnMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: UpdateCalculatedColumnInput;
}>;


export type UpdateCalculatedColumnMutation = { updateCalculatedColumn: { id: string, key: string, label: string, expression: string, resultType: string, format?: string | null } };

export type DeleteCalculatedColumnMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteCalculatedColumnMutation = { deleteCalculatedColumn: boolean };

export type DashboardsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type DashboardsQuery = { dashboards: { data: Array<{ sharedWithMe?: boolean | null, id: string, name: string, description?: string | null, visibility: ReportVisibility, isSystem: boolean, systemKey?: string | null, ownerName?: string | null, updatedAt?: any | null }>, meta: { totalCount: number, page: number, limit: number } } };

export type DashboardQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DashboardQuery = { dashboard: { myAccess?: any | null, sharedWithMe?: boolean | null, id: string, name: string, description?: string | null, visibility: ReportVisibility, isSystem: boolean, ownerUserId?: string | null, config?: any | null, widgets: Array<{ dashboardId: string, id: string, span: number, sortOrder: number, tab?: string | null, report: { id: string, name: string, datasetKey: string, definition: any, chartConfig?: any | null, persistence?: { lastRefreshedAt?: any | null, status?: string | null } | null } }> } };

export type DashboardLocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type DashboardLocationsQuery = { dashboardLocations: Array<{ id: string, name: string }> };

export type CreateDashboardMutationVariables = Exact<{
  input: CreateDashboardInput;
}>;


export type CreateDashboardMutation = { createDashboard: { id: string, name: string } };

export type UpdateDashboardMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: UpdateDashboardInput;
}>;


export type UpdateDashboardMutation = { updateDashboard: { id: string, name: string, description?: string | null } };

export type DeleteDashboardMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteDashboardMutation = { deleteDashboard: boolean };

export type PublishDashboardMutationVariables = Exact<{
  id: Scalars['String']['input'];
  visibility: ReportVisibility;
}>;


export type PublishDashboardMutation = { publishDashboard: { id: string, visibility: ReportVisibility } };

export type AddDashboardWidgetMutationVariables = Exact<{
  dashboardId: Scalars['String']['input'];
  reportId: Scalars['String']['input'];
  span?: InputMaybe<Scalars['Int']['input']>;
  tab?: InputMaybe<Scalars['String']['input']>;
}>;


export type AddDashboardWidgetMutation = { addDashboardWidget: { id: string } };

export type UpdateDashboardWidgetMutationVariables = Exact<{
  widgetId: Scalars['String']['input'];
  input: UpdateDashboardWidgetInput;
}>;


export type UpdateDashboardWidgetMutation = { updateDashboardWidget: { id: string, span: number, sortOrder: number, tab?: string | null } };

export type RemoveDashboardWidgetMutationVariables = Exact<{
  widgetId: Scalars['String']['input'];
}>;


export type RemoveDashboardWidgetMutation = { removeDashboardWidget: boolean };

export type DuplicateDashboardTabMutationVariables = Exact<{
  dashboardId: Scalars['String']['input'];
  tab: Scalars['String']['input'];
  newName: Scalars['String']['input'];
}>;


export type DuplicateDashboardTabMutation = { duplicateDashboardTab: Array<{ id: string }> };

export type AutomationFlowsQueryVariables = Exact<{
  reportId?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type AutomationFlowsQuery = { automationFlows: { total: number, data: Array<{ id: string, name: string, description?: string | null, reportId: string, reportName?: string | null, enabled: boolean, armed: boolean, trigger: any, intervalSeconds: number, cooldownMinutes: number, lastValue?: number | null, lastTriggeredAt?: any | null, lastEvalAt?: any | null, lastError?: string | null, consecutiveFailures: number, createdAt: any, updatedAt: any }> } };

export type AutomationFlowQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type AutomationFlowQuery = { automationFlow: { id: string, name: string, description?: string | null, reportId: string, reportName?: string | null, enabled: boolean, armed: boolean, trigger: any, graph: any, intervalSeconds: number, cooldownMinutes: number, lastValue?: number | null, lastTriggeredAt?: any | null, lastError?: string | null, webhookSecret?: string | null, createdAt: any, updatedAt: any } };

export type FlowRunsQueryVariables = Exact<{
  flowId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FlowRunsQuery = { flowRuns: Array<{ id: string, kind: string, status: string, triggeredValue?: number | null, threshold?: number | null, op?: string | null, results?: any | null, error?: string | null, startedAt?: any | null, finishedAt?: any | null, createdAt: any }> };

export type FlowRecipientsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type FlowRecipientsQuery = { flowRecipients: any };

export type CreateAutomationFlowMutationVariables = Exact<{
  input: CreateAutomationFlowInput;
}>;


export type CreateAutomationFlowMutation = { createAutomationFlow: { id: string } };

export type UpdateAutomationFlowMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: UpdateAutomationFlowInput;
}>;


export type UpdateAutomationFlowMutation = { updateAutomationFlow: { id: string } };

export type SetFlowEnabledMutationVariables = Exact<{
  id: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
}>;


export type SetFlowEnabledMutation = { setFlowEnabled: { id: string, enabled: boolean, armed: boolean } };

export type DeleteAutomationFlowMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteAutomationFlowMutation = { deleteAutomationFlow: boolean };

export type TestFlowMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type TestFlowMutation = { testFlow: { id: string, status: string, results?: any | null, error?: string | null } };

export type NotificationsQueryVariables = Exact<{
  unreadOnly?: InputMaybe<Scalars['Boolean']['input']>;
  readOnly?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type NotificationsQuery = { notifications: { total: number, unread: number, data: Array<{ id: string, title: string, body?: string | null, severity: string, link?: string | null, flowName?: string | null, readAt?: any | null, createdAt: any }> } };

export type NotificationCountQueryVariables = Exact<{ [key: string]: never; }>;


export type NotificationCountQuery = { notificationCount: number };

export type MarkNotificationReadMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type MarkNotificationReadMutation = { markNotificationRead: boolean };

export type MarkAllNotificationsReadMutationVariables = Exact<{ [key: string]: never; }>;


export type MarkAllNotificationsReadMutation = { markAllNotificationsRead: boolean };

export type ReportDatasetsQueryVariables = Exact<{ [key: string]: never; }>;


export type ReportDatasetsQuery = { reportDatasets: Array<{ key: string, source: string, label: string, description?: string | null, service: string, supportsEntity: boolean, supportsLocationScope: boolean, defaultDateDimension?: string | null, dimensions: Array<{ key: string, label: string, type: string, supportsGranularity: boolean, supportsBucketing: boolean, filterOnly: boolean, enumValues?: Array<string> | null, joinTable?: string | null, joinLabel?: string | null, format?: string | null, noAverage: boolean, calculated?: { expression: string, libraryId?: string | null } | null }>, measures: Array<{ key: string, label: string, format: string }> }> };

export type ReportEntityOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ReportEntityOptionsQuery = { reportEntityOptions: Array<{ id: string, name: string }> };

export type RunReportQueryVariables = Exact<{
  input: RunReportInput;
}>;


export type RunReportQuery = { runReport: { rows: any, hasMore: boolean, executionMs: number, totals?: any | null, columnTotals?: any | null, groupCount?: number | null, columns: Array<{ key: string, label: string, kind: ReportColumnKind, type: string, format?: string | null, table?: string | null }>, comparison?: { start: any, end: any, rows: any } | null } };

export type RunReportDetailQueryVariables = Exact<{
  input: RunReportDetailInput;
}>;


export type RunReportDetailQuery = { runReportDetail: { rows: any, hasMore: boolean, executionMs: number, groupCount?: number | null, columns: Array<{ key: string, label: string, kind: ReportColumnKind, type: string, format?: string | null, table?: string | null }> } };

export type ReportsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type ReportsQuery = { reports: { data: Array<{ sharedWithMe?: boolean | null, id: string, name: string, description?: string | null, datasetKey: string, chartConfig?: any | null, ownerUserId?: string | null, ownerName?: string | null, visibility: ReportVisibility, isSystem: boolean, systemKey?: string | null, createdAt: any, updatedAt?: any | null }>, meta: { totalCount: number, page: number, limit: number } } };

export type ReportQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ReportQuery = { report: { myAccess?: any | null, id: string, name: string, description?: string | null, datasetKey: string, definition: any, chartConfig?: any | null, ownerUserId?: string | null, ownerName?: string | null, visibility: ReportVisibility, isSystem: boolean, systemKey?: string | null, cacheTtlSeconds?: number | null, isSavedDataset: boolean, createdAt: any, updatedAt?: any | null, persistence?: { enabled: boolean, refreshIntervalSeconds: number, lastRefreshedAt?: any | null, status?: string | null, rowCount?: number | null } | null } };

export type SetReportSavedDatasetMutationVariables = Exact<{
  id: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
}>;


export type SetReportSavedDatasetMutation = { setReportSavedDataset: { id: string, isSavedDataset: boolean } };

export type SavedDatasetUsageQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type SavedDatasetUsageQuery = { savedDatasetUsage: { reports: Array<{ id: string, name: string }>, columns: Array<{ id: string, name: string }> } };

export type SetReportCacheTtlMutationVariables = Exact<{
  id: Scalars['String']['input'];
  seconds?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SetReportCacheTtlMutation = { setReportCacheTtl: { id: string, cacheTtlSeconds?: number | null } };

export type SetReportPersistenceMutationVariables = Exact<{
  reportId: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  refreshIntervalSeconds?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SetReportPersistenceMutation = { setReportPersistence: { enabled: boolean, refreshIntervalSeconds: number, lastRefreshedAt?: any | null, status?: string | null, rowCount?: number | null } };

export type RefreshReportPersistenceMutationVariables = Exact<{
  reportId: Scalars['String']['input'];
}>;


export type RefreshReportPersistenceMutation = { refreshReportPersistence: { lastRefreshedAt?: any | null, status?: string | null, rowCount?: number | null } };

export type CreateReportMutationVariables = Exact<{
  input: CreateReportInput;
}>;


export type CreateReportMutation = { createReport: { id: string, name: string, visibility: ReportVisibility } };

export type UpdateReportMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: UpdateReportInput;
}>;


export type UpdateReportMutation = { updateReport: { id: string, name: string, description?: string | null, definition: any, chartConfig?: any | null, visibility: ReportVisibility, updatedAt?: any | null } };

export type DeleteReportMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteReportMutation = { deleteReport: boolean };

export type PublishReportMutationVariables = Exact<{
  id: Scalars['String']['input'];
  visibility: ReportVisibility;
}>;


export type PublishReportMutation = { publishReport: { id: string, visibility: ReportVisibility } };

export type CloneReportMutationVariables = Exact<{
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type CloneReportMutation = { cloneReport: { id: string, name: string } };

export type ExportJobsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ExportJobsQuery = { exportJobs: Array<{ id: string, kind: string, filename: string, status: string, error?: string | null, rowCount?: number | null, byteSize?: number | null, requestedByName?: string | null, createdAt: any, startedAt?: any | null, finishedAt?: any | null, expiresAt?: any | null, downloadUrl?: string | null }> };

export type CreateExportJobMutationVariables = Exact<{
  input: CreateExportJobInput;
}>;


export type CreateExportJobMutation = { createExportJob: { id: string, status: string } };

export type AiAssistEnabledQueryVariables = Exact<{ [key: string]: never; }>;


export type AiAssistEnabledQuery = { aiAssistEnabled: boolean };

export type AiDraftReportQueryVariables = Exact<{
  prompt: Scalars['String']['input'];
  datasetKey?: InputMaybe<Scalars['String']['input']>;
  history?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type AiDraftReportQuery = { aiDraftReport: any };

export type AccessGrantsQueryVariables = Exact<{
  resourceType: Scalars['String']['input'];
  resourceId: Scalars['String']['input'];
}>;


export type AccessGrantsQuery = { accessGrants: Array<{ id: string, subjectType: string, subjectId: string, subjectLabel?: string | null, permission: string, constraints?: any | null, grantedByName?: string | null, createdAt: any }> };

export type ShareableSubjectsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type ShareableSubjectsQuery = { shareableSubjects: any };

export type GrantAccessMutationVariables = Exact<{
  resourceType: Scalars['String']['input'];
  resourceId: Scalars['String']['input'];
  subjectType: Scalars['String']['input'];
  subjectId: Scalars['String']['input'];
  permission?: InputMaybe<Scalars['String']['input']>;
  constraints?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type GrantAccessMutation = { grantAccess: { id: string, subjectLabel?: string | null, permission: string } };

export type RevokeAccessMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RevokeAccessMutation = { revokeAccess: boolean };

export type SqlTablesQueryVariables = Exact<{ [key: string]: never; }>;


export type SqlTablesQuery = { sqlTables: Array<{ table: string, columns: Array<{ name: string, type: string }> }> };

export type RunRawReportQueryVariables = Exact<{
  input: RunRawReportInput;
}>;


export type RunRawReportQuery = { runRawReport: { rows: any, hasMore: boolean, executionMs: number, totals?: any | null, columnTotals?: any | null, groupCount?: number | null, columns: Array<{ key: string, label: string, kind: ReportColumnKind, type: string, format?: string | null, table?: string | null }> } };

export type CreateSqlReportMutationVariables = Exact<{
  input: CreateSqlReportInput;
}>;


export type CreateSqlReportMutation = { createSqlReport: { id: string, name: string } };

export type UpdateSqlReportMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: UpdateSqlReportInput;
}>;


export type UpdateSqlReportMutation = { updateSqlReport: { id: string, name: string, definition: any, chartConfig?: any | null } };

export type RawParameterOptionsQueryVariables = Exact<{
  input: RawParameterOptionsInput;
}>;


export type RawParameterOptionsQuery = { rawParameterOptions: Array<string> };

export type CreateAuditMutationVariables = Exact<{
  createAuditDto: CreateAuditDto;
}>;


export type CreateAuditMutation = { createAudit: { id: string } };

export type GetAllAuditsQueryVariables = Exact<{
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
  limit: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
}>;


export type GetAllAuditsQuery = { getAllAudits: { data: Array<{ id: string, secondaryId: string, type: string, status: string, itemCount: number, lotCount: number, matchedProducts: number, shortProducts: number, shortStockValue: number, excessProducts: number, excessStockValue: number, createdAt: any }>, meta: { limit?: number | null, page?: number | null, total?: number | null, totalCount?: number | null } } };

export type GetAuditQueryVariables = Exact<{
  auditId: Scalars['String']['input'];
}>;


export type GetAuditQuery = { getAudit: { id: string, secondaryId?: number | null, status: AuditStatus, auditProducts?: Array<{ id: string, status: AuditProductStatus, lotCount: number, secondaryId?: number | null, product: { uomFactor?: number | null, name?: string | null, secondaryId?: number | null, id?: string | null } }> | null } };

export type StartAuditMutationVariables = Exact<{
  auditId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
}>;


export type StartAuditMutation = { startAudit: boolean };

export type ScanAuditLotMutationVariables = Exact<{
  scanLotsDto: ScanLotsDto;
}>;


export type ScanAuditLotMutation = { scanAuditLot: boolean };

export type GetAuditProductSummaryQueryVariables = Exact<{
  auditProductId: Scalars['String']['input'];
}>;


export type GetAuditProductSummaryQuery = { getAuditProductSummary: { actualQuantity?: number | null, excessAmount?: number | null, excessCount?: number | null, expectedQuantity?: number | null, matchedCount?: number | null, productId?: string | null, productName?: string | null, remainingLots?: number | null, scannedLots?: number | null, shortAmount?: number | null, shortCount?: number | null, status?: string | null, stockValue?: number | null, totalLots?: number | null } };

export type GetAllAuditLotsQueryVariables = Exact<{
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
  locationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAllAuditLotsQuery = { getAllAuditLots: { data: Array<{ id: string, actionId?: string | null, expectedQuantity?: number | null, actualQuantity?: number | null, lotStockValue?: number | null, status: AuditLotStatus }>, meta: { limit?: number | null, page?: number | null, total?: number | null, totalCount?: number | null } } };

export type CompleteProductAuditMutationVariables = Exact<{
  auditId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
}>;


export type CompleteProductAuditMutation = { completeProductAudit: boolean };

export type CloseAuditMutationVariables = Exact<{
  auditId: Scalars['String']['input'];
  closureReason: Scalars['String']['input'];
}>;


export type CloseAuditMutation = { closeAudit: boolean };

export type LoginUserMutationVariables = Exact<{
  loginUserDto: LoginUserDto;
}>;


export type LoginUserMutation = { loginUser: { token: string, allowedLocations: Array<{ id: string, name: string, type: string, countryId?: string | null }>, tenant: { currency?: string | null, onlineStoreURL?: string | null, logo?: string | null, parentCompanyLogo?: string | null, website?: string | null, qrInvertedLogo?: string | null, invertedLogo?: string | null, accountId: string, id: string, name: string }, permissions: Array<{ id: string, permission: string }>, user: { email: string, firstName: string, id: string, lastName: string, role: { id: string, name: string } } } };

export type AuthenticateTokenQueryVariables = Exact<{ [key: string]: never; }>;


export type AuthenticateTokenQuery = { authenticateToken: { token: string, allowedLocations: Array<{ id: string, name: string, type: string, countryId?: string | null }>, tenant: { currency?: string | null, onlineStoreURL?: string | null, logo?: string | null, parentCompanyLogo?: string | null, website?: string | null, qrInvertedLogo?: string | null, invertedLogo?: string | null, accountId: string, id: string, name: string }, permissions: Array<{ id: string, permission: string }>, user: { email: string, firstName: string, id: string, lastName: string, role: { id: string, name: string } } } };

export type ForgotPasswordMutationVariables = Exact<{
  email: Scalars['String']['input'];
  origin: Scalars['String']['input'];
}>;


export type ForgotPasswordMutation = { forgotPassword: boolean };

export type AcceptInviteMutationVariables = Exact<{
  acceptInviteDto: AcceptInviteDto;
}>;


export type AcceptInviteMutation = { acceptInvite: boolean };

export type ResetPasswordMutationVariables = Exact<{
  resetPasswordId: Scalars['String']['input'];
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
}>;


export type ResetPasswordMutation = { resetPassword: boolean };

export type ValidateEmailTokenMutationVariables = Exact<{
  validateEmailTokenId: Scalars['String']['input'];
  token: Scalars['String']['input'];
}>;


export type ValidateEmailTokenMutation = { validateEmailToken: boolean };

export type ValidateInviteTokenMutationVariables = Exact<{
  validateInviteTokenId: Scalars['String']['input'];
  token: Scalars['String']['input'];
}>;


export type ValidateInviteTokenMutation = { validateInviteToken: boolean };

export type GetBomsQueryVariables = Exact<{
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
}>;


export type GetBomsQuery = { getBoms: { meta: { total?: number | null, page?: number | null, limit?: number | null }, data: Array<{ id: string, secondaryId?: number | null, bomCode: string, bomName: string, productionProcessType: ProductionProcessType, status: BomStatus, outputProductId: string, createdBy?: string | null, createdAt: any, updatedAt: any, outputProduct?: { id?: string | null, name?: string | null, trackingLevel?: TrackingLevel | null } | null }> } };

export type GetBomQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetBomQuery = { getBom: { id: string, secondaryId?: number | null, bomCode: string, bomName: string, productionProcessType: ProductionProcessType, status: BomStatus, outputProduct?: { id?: string | null, name?: string | null, trackingLevel?: TrackingLevel | null } | null, versions?: Array<{ id: string, versionNo: number, versionLabel?: string | null, batchQuantity: number, approvalStatus: BomApprovalStatus, lifecycleStatus: BomLifecycleStatus, effectiveFrom?: any | null, effectiveTo?: any | null, approvedBy?: string | null, approvedAt?: any | null }> | null } };

export type CreateBomMutationVariables = Exact<{
  dto: CreateBomDto;
}>;


export type CreateBomMutation = { createBom: { id: string, bomCode: string } };

export type UpdateBomMutationVariables = Exact<{
  dto: UpdateBomDto;
}>;


export type UpdateBomMutation = { updateBom: { id: string, bomName: string, productionProcessType: ProductionProcessType, status: BomStatus } };

export type UpdateBomStatusMutationVariables = Exact<{
  id: Scalars['String']['input'];
  status: BomStatus;
}>;


export type UpdateBomStatusMutation = { updateBomStatus: { id: string, status: BomStatus } };

export type GetBomVersionsQueryVariables = Exact<{
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  bomId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetBomVersionsQuery = { getBomVersions: { meta: { total?: number | null, page?: number | null, limit?: number | null }, data: Array<{ id: string, bomId: string, versionNo: number, versionLabel?: string | null, batchQuantity: number, locationId?: string | null, approvalStatus: BomApprovalStatus, lifecycleStatus: BomLifecycleStatus, effectiveFrom?: any | null, effectiveTo?: any | null, approvedBy?: string | null, approvedAt?: any | null, rejectedBy?: string | null, rejectedAt?: any | null }> } };

export type GetBomVersionQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetBomVersionQuery = { getBomVersion: { id: string, bomId: string, versionNo: number, versionLabel?: string | null, batchQuantity: number, approvalStatus: BomApprovalStatus, lifecycleStatus: BomLifecycleStatus, effectiveFrom?: any | null, effectiveTo?: any | null, referenceVersionId?: string | null, rejectionReason?: string | null, submittedBy?: string | null, submittedAt?: any | null, approvedBy?: string | null, approvedAt?: any | null, rejectedBy?: string | null, rejectedAt?: any | null, activatedBy?: string | null, activatedAt?: any | null, bom?: { id: string, bomCode: string, bomName: string, outputProduct?: { id?: string | null, name?: string | null, trackingLevel?: TrackingLevel | null } | null } | null, lineItems?: Array<{ id: string, lineNo?: number | null, componentProductId: string, consumableQuantity: number, consumableQuantityPerUnit?: number | null, wastagePercentage: number, isMandatory: boolean, cost?: number | null, costPerUnit?: number | null, componentProduct?: { id?: string | null, name?: string | null, sellingUnit?: UomUnit | null } | null }> | null, location?: { id: string, name: string } | null, submittedByUser?: { firstName?: string | null, lastName?: string | null } | null, rejectedByUser?: { firstName?: string | null, lastName?: string | null } | null, approvedByUser?: { firstName?: string | null, lastName?: string | null } | null, activatedByUser?: { firstName?: string | null, lastName?: string | null } | null } };

export type CreateBomVersionMutationVariables = Exact<{
  dto: CreateBomVersionDto;
}>;


export type CreateBomVersionMutation = { createBomVersion: { id: string, versionNo: number } };

export type UpdateBomVersionMutationVariables = Exact<{
  dto: UpdateBomVersionDto;
}>;


export type UpdateBomVersionMutation = { updateBomVersion: { id: string, versionLabel?: string | null, batchQuantity: number, locationId?: string | null } };

export type SubmitBomVersionForApprovalMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type SubmitBomVersionForApprovalMutation = { submitBomVersionForApproval: { id: string, approvalStatus: BomApprovalStatus, submittedBy?: string | null, submittedAt?: any | null } };

export type ApproveBomVersionMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ApproveBomVersionMutation = { approveBomVersion: { id: string, approvalStatus: BomApprovalStatus, approvedBy?: string | null, approvedAt?: any | null } };

export type RejectBomVersionMutationVariables = Exact<{
  id: Scalars['String']['input'];
  rejectionReason: Scalars['String']['input'];
}>;


export type RejectBomVersionMutation = { rejectBomVersion: { id: string, approvalStatus: BomApprovalStatus, rejectionReason?: string | null } };

export type ActivateBomVersionMutationVariables = Exact<{
  id: Scalars['String']['input'];
  effectiveFrom?: InputMaybe<Scalars['Date']['input']>;
  effectiveTo?: InputMaybe<Scalars['Date']['input']>;
}>;


export type ActivateBomVersionMutation = { activateBomVersion: { id: string, lifecycleStatus: BomLifecycleStatus, activatedBy?: string | null, activatedAt?: any | null, effectiveFrom?: any | null, effectiveTo?: any | null } };

export type ArchiveBomVersionMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ArchiveBomVersionMutation = { archiveBomVersion: { id: string, lifecycleStatus: BomLifecycleStatus } };

export type CreateBomVersionLineItemMutationVariables = Exact<{
  dto: CreateBomVersionLineItemDto;
}>;


export type CreateBomVersionLineItemMutation = { createBomVersionLineItem: { id: string } };

export type UpdateBomVersionLineItemMutationVariables = Exact<{
  dto: UpdateBomVersionLineItemDto;
}>;


export type UpdateBomVersionLineItemMutation = { updateBomVersionLineItem: { id: string } };

export type DeleteBomVersionLineItemMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteBomVersionLineItemMutation = { deleteBomVersionLineItem: boolean };

export type BulkUploadProductsMutationVariables = Exact<{
  input: BulkUploadProductDto;
}>;


export type BulkUploadProductsMutation = { bulkUploadProducts: { successCount: number, createdProductIds: Array<string>, errors?: Array<{ row: number, message: string }> | null } };

export type CalculateCartSummaryQueryVariables = Exact<{
  order: ApplyDiscountDto;
  discountCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type CalculateCartSummaryQuery = { calculateCartSummary: { deliveryCharges: number, platformFee: number, posFees: number, subtotal: number, tax: number, total: number, totalDiscount: number, integrationCharges: number, products?: Array<{ discount?: number | null, discountTitle?: string | null, id?: string | null, secondaryId?: number | null, subTotal?: number | null, tax?: number | null, title: string, total?: number | null }> | null, platformFees?: Array<{ id: string, name: string, isRemovable: boolean, amount: number }> | null, integrations?: Array<{ type: IntegrationType, name?: string | null }> | null, discounts?: Array<{ title: string, amount: number }> | null } };

export type CreateCategoryMutationVariables = Exact<{
  createCategoryDto: CreateCategoryDto;
}>;


export type CreateCategoryMutation = { createCategory: { categoryIcon?: string | null, comment?: string | null, description?: string | null, id: string, imageUrl?: string | null, level?: number | null, name: string, parentId?: string | null, status: string } };

export type UpdateCategoryMutationVariables = Exact<{
  updateCategoryDto: UpdateCategoryDto;
}>;


export type UpdateCategoryMutation = { updateCategory: { categoryIcon?: string | null, comment?: string | null, description?: string | null, id: string, imageUrl?: string | null, level?: number | null, name: string, parentId?: string | null, status: string } };

export type GetCategoryQueryVariables = Exact<{
  getCategoryId: Scalars['String']['input'];
}>;


export type GetCategoryQuery = { getCategory: { categoryIcon?: string | null, comment?: string | null, description?: string | null, id: string, imageUrl?: string | null, level?: number | null, name: string, parentId?: string | null, status: string } };

export type GetCategoriesQueryVariables = Exact<{
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
}>;


export type GetCategoriesQuery = { getCategories: { data: Array<{ id: string, secondaryId?: number | null, categoryIcon?: string | null, comment?: string | null, description?: string | null, imageUrl?: string | null, level?: number | null, name: string, parentId?: string | null, status: string, parentCategory?: { id: string, name: string } | null }>, meta: { limit?: number | null, page?: number | null, totalCount?: number | null } } };

export type GetCategoriesForOptionsQueryVariables = Exact<{
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
}>;


export type GetCategoriesForOptionsQuery = { getCategories: { data: Array<{ id: string, level?: number | null, name: string, parentId?: string | null, status: string }>, meta: { limit?: number | null, page?: number | null, totalCount?: number | null } } };

export type GetCategoryLevelQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCategoryLevelQuery = { getCategoryLevel: { current: number, max: number } };

export type GetCustomersForDiscountQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
}>;


export type GetCustomersForDiscountQuery = { getCustomers: { data: Array<{ id?: string | null, email?: string | null, name: string }>, meta: { limit?: number | null, page?: number | null, totalCount?: number | null } } };

export type GetCustomersListQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
}>;


export type GetCustomersListQuery = { getCustomers: { data: Array<{ additionalNumber?: string | null, secondaryId?: number | null, name: string, id?: string | null, phoneNumber?: string | null, gender?: Gender | null, createdAt: any, partner?: { name: string, id: string } | null }>, meta: { limit?: number | null, page?: number | null, totalCount?: number | null } } };

export type GetCustomersListForOptionsQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
}>;


export type GetCustomersListForOptionsQuery = { getCustomers: { data: Array<{ secondaryId?: number | null, name: string, id?: string | null, phoneNumber?: string | null, gender?: Gender | null }> } };

export type CreateAddressMutationVariables = Exact<{
  createAddressDto: CreateAddressDto;
}>;


export type CreateAddressMutation = { createAddress: { id: string } };

export type UpdateAddressMutationVariables = Exact<{
  updateAddressDto: UpdateAddressDto;
}>;


export type UpdateAddressMutation = { updateAddress: { id: string } };

export type GetCustomerQueryVariables = Exact<{
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  getCustomerId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCustomerQuery = { getCustomer?: { secondaryId?: number | null, id?: string | null, phoneNumber?: string | null, name: string, gender?: Gender | null, birthday?: any | null, commercialRegisterNumber?: string | null, nationalId?: string | null, notes?: string | null, partner?: { id: string, name: string } | null, addresses?: Array<{ id: string, postalCode?: string | null, secondaryId?: number | null, streetName?: string | null, buildingNo?: string | null, districtName?: string | null, customerId: string, additionalNumber?: string | null, streetAddress2?: string | null, streetAddress1?: string | null, state?: string | null, landmark?: string | null, cityId?: string | null, city?: { name?: string | null, id?: string | null, country?: { name?: string | null, id?: string | null } | null } | null }> | null } | null };

export type UpdateCustomerMutationVariables = Exact<{
  updateCustomerDto: UpdateCustomerDto;
}>;


export type UpdateCustomerMutation = { updateCustomer: { id?: string | null } };

export type CreateCustomerMutationVariables = Exact<{
  createCustomerDTO: CreateCustomerDto;
}>;


export type CreateCustomerMutation = { createCustomer: { id?: string | null } };

export type DashboardOverviewQueryVariables = Exact<{
  filter: AnalyticsFilterInput;
}>;


export type DashboardOverviewQuery = { salesOverview: { netSales: number, grossSales: number, totalOrders: number, avgOrderValue: number, totalReturnAmount: number, returnedOrders: number, totalDiscount: number, totalTax: number, totalPlatformFee: number, totalDeliveryCharges: number, totalIntegrationCharges: number, netSalesComparison?: { current: number, previous: number, changePercent: number } | null, grossSalesComparison?: { current: number, previous: number, changePercent: number } | null, totalOrdersComparison?: { current: number, previous: number, changePercent: number } | null, avgOrderValueComparison?: { current: number, previous: number, changePercent: number } | null, totalReturnAmountComparison?: { current: number, previous: number, changePercent: number } | null, returnedOrdersComparison?: { current: number, previous: number, changePercent: number } | null, totalDiscountComparison?: { current: number, previous: number, changePercent: number } | null, totalTaxComparison?: { current: number, previous: number, changePercent: number } | null, totalPlatformFeeComparison?: { current: number, previous: number, changePercent: number } | null, totalDeliveryChargesComparison?: { current: number, previous: number, changePercent: number } | null, totalIntegrationChargesComparison?: { current: number, previous: number, changePercent: number } | null } };

export type DashboardChartsQueryVariables = Exact<{
  filter: AnalyticsFilterInput;
}>;


export type DashboardChartsQuery = { salesOverTime: Array<{ period: any, totalSales: number, netSales: number, orderCount: number }>, ordersByStatus: Array<{ status: string, count: number, totalAmount: number }>, salesByChannel: Array<{ channel: string, totalSales: number, orderCount: number }>, paymentMethodBreakdown: Array<{ paymentMethod: string, totalAmount: number, percentage: number }> };

export type DashboardTablesQueryVariables = Exact<{
  filter: AnalyticsFilterInput;
}>;


export type DashboardTablesQuery = { topProducts: Array<{ productId: string, productName: string, totalQuantity: number, totalRevenue: number, orderCount: number }>, topCustomers: Array<{ customerId: string, customerName: string, phoneNumber?: string | null, totalSpend: number, orderCount: number }>, discountPerformance: Array<{ discountId: string, discountTitle: string, discountCode?: string | null, usageCount: number, totalDiscountAmount: number, totalOrdersAffected: number, avgDiscountAmount: number }> };

export type GetDemandNotesQueryVariables = Exact<{
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
  limit: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
}>;


export type GetDemandNotesQuery = { getDemandNotes: { meta: { limit?: number | null, page?: number | null, total?: number | null, totalCount?: number | null }, data: Array<{ fulfillmentRatio: number, stockValue: number, totalItems: number, totalRequestedQuantity: number, transferSecondaryIds: Array<number>, secondaryId?: number | null, createdAt?: any | null, createdBy: string, deliveryDate?: any | null, fulfillmentStatus: DemandNoteFulfillmentStatus, id: string, type: DemandType, updatedAt?: any | null, requestedFrom: { name: string }, requestedTo: { name: string } }> } };

export type CreateDemandNoteMutationVariables = Exact<{
  createDemandNoteDto: CreateDemandNoteDto;
}>;


export type CreateDemandNoteMutation = { createDemandNote: { id: string } };

export type GetDemandNoteQueryVariables = Exact<{
  secondaryId?: InputMaybe<Scalars['Float']['input']>;
  getDemandNoteId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetDemandNoteQuery = { getDemandNote: { createdAt?: any | null, deliveryDate?: any | null, id: string, secondaryId?: number | null, type: DemandType, fulfillmentStatus: DemandNoteFulfillmentStatus, fulfillmentRatio: number, isPartial: boolean, stockValue: number, totalItems: number, totalRequestedQuantity: number, transferSecondaryIds: Array<number>, requestedFrom: { id: string, name: string }, requestedTo: { name: string, id: string }, demandNoteProducts?: Array<{ id: string, secondaryId?: number | null, currentInventory: number, value: number, requestedQuantity: number, remainingQuantity?: number | null, price: number, product: { secondaryId?: number | null, id?: string | null, name?: string | null, manufacturer?: { name?: string | null } | null } }> | null } };

export type UnopenedProductLotInfoQueryVariables = Exact<{
  locationId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
}>;


export type UnopenedProductLotInfoQuery = { unopenedProductLotInfo: { productStatus?: string | null, unopenedCount: number } };

export type CloseDemandNoteMutationVariables = Exact<{
  closureReason: Scalars['String']['input'];
  closeDemandNoteId: Scalars['String']['input'];
}>;


export type CloseDemandNoteMutation = { closeDemandNote: { id: string } };

export type CreateDiscountMutationVariables = Exact<{
  createDiscountDto: CreateDiscountDto;
}>;


export type CreateDiscountMutation = { createDiscount: { id: string } };

export type UpdateDiscountMutationVariables = Exact<{
  updateDiscountDto: UpdateDiscountDto;
}>;


export type UpdateDiscountMutation = { updateDiscount: { id: string } };

export type GetDiscountsQueryVariables = Exact<{
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
  page: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
}>;


export type GetDiscountsQuery = { getDiscounts: { meta: { limit?: number | null, page?: number | null, totalCount?: number | null }, data: Array<{ value?: number | null, type: DiscountType, title?: string | null, scope?: DiscountScope | null, maxDiscountAmount?: number | null, status: DiscountStatus, id: string, secondaryId?: number | null, limitUses?: number | null, combinable?: boolean | null, code?: string | null, createdAt?: any | null, updatedAt?: any | null }> } };

export type GetDiscountQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetDiscountQuery = { getDiscount?: { buyX?: number | null, code?: string | null, combinable?: boolean | null, createdAt?: any | null, endDate?: any | null, getY?: number | null, getYDiscount?: number | null, id: string, limitUses?: number | null, scope?: DiscountScope | null, maxDiscountAmount?: number | null, minPurchaseAmount?: number | null, minQuantity?: number | null, secondaryId?: number | null, startDate?: any | null, status: DiscountStatus, title?: string | null, type: DiscountType, updatedAt?: any | null, value?: number | null, applicableCategories?: Array<{ name: string, id: string }> | null, applicableCustomers?: Array<{ id?: string | null, name: string }> | null, applicableProducts?: Array<{ id?: string | null, name?: string | null }> | null, applicableTags?: Array<{ id: string, name: string }> | null, locations?: Array<{ name: string, id: string }> | null } | null };

export type DownloadOrderItemReportQueryVariables = Exact<{
  locationId?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
}>;


export type DownloadOrderItemReportQuery = { downloadOrderItemReport: string };

export type DownloadOrderReportQueryVariables = Exact<{
  locationId?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
}>;


export type DownloadOrderReportQuery = { downloadOrderReport: string };

export type DownloadPurchaseOrderItemQueryVariables = Exact<{
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
  locationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type DownloadPurchaseOrderItemQuery = { downloadPurchaseOrderItem: string };

export type DownloadPurchaseOrdersQueryVariables = Exact<{
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
  locationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type DownloadPurchaseOrdersQuery = { downloadPurchaseOrders: string };

export type DownloadTransferItemsQueryVariables = Exact<{
  locationId: Scalars['String']['input'];
}>;


export type DownloadTransferItemsQuery = { downloadTransferItems: string };

export type DownloadGetProductLotStockReportQueryVariables = Exact<{
  filters: ProductStockReportArgs;
}>;


export type DownloadGetProductLotStockReportQuery = { downloadGetProductLotStockReport: string };

export type CreatePartnerFinancialTermsMutationVariables = Exact<{
  createFinancialTermsDto: CreateFinancialTermsDto;
}>;


export type CreatePartnerFinancialTermsMutation = { createPartnerFinancialTerms: { id: string } };

export type UpdatePartnerFinancialTermsMutationVariables = Exact<{
  updateFinancialTermsDto: UpdateFinancialTermsDto;
}>;


export type UpdatePartnerFinancialTermsMutation = { updatePartnerFinancialTerms: { id: string } };

export type GetPartnerFinancialTermsByPartnerQueryVariables = Exact<{
  partnerId: Scalars['String']['input'];
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
}>;


export type GetPartnerFinancialTermsByPartnerQuery = { getPartnerFinancialTermsByPartner: { meta: { page?: number | null, limit?: number | null, totalCount?: number | null, total?: number | null }, data: Array<{ id: string, secondaryId: number, partnerId: string, effectiveFrom: any, effectiveTo?: any | null, coverageModeCode: CoverageModeCode, coveragePercent?: number | null, coverageFixedAmount?: number | null, direction: Direction, isCreditCover: boolean, status: Status, createdAt?: any | null, updatedAt?: any | null }> } };

export type GetPartnerFinancialTermQueryVariables = Exact<{
  getPartnerFinancialTermId: Scalars['String']['input'];
}>;


export type GetPartnerFinancialTermQuery = { getPartnerFinancialTerm?: { id: string, secondaryId: number, partnerId: string, effectiveFrom: any, effectiveTo?: any | null, coverageModeCode: CoverageModeCode, coveragePercent?: number | null, coverageFixedAmount?: number | null, direction: Direction, isCreditCover: boolean, createdAt?: any | null, updatedAt?: any | null } | null };

export type GetPartnerFinancialTermsListQueryVariables = Exact<{
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPartnerFinancialTermsListQuery = { getPartnerFinancialTerms: { meta: { page?: number | null, limit?: number | null, totalCount?: number | null, total?: number | null }, data: Array<{ id: string, secondaryId: number, partnerId: string, effectiveFrom: any, effectiveTo?: any | null, coverageModeCode: CoverageModeCode, coveragePercent?: number | null, coverageFixedAmount?: number | null, direction: Direction, isCreditCover: boolean, createdAt?: any | null, updatedAt?: any | null }> } };

export type CreateFulfillmentOrderMutationVariables = Exact<{
  input: CreateFulfillmentOrderInput;
}>;


export type CreateFulfillmentOrderMutation = { createFulfillmentOrder: Array<{ id: string, secondaryId?: number | null }> };

export type FulfillmentOrdersListQueryVariables = Exact<{
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type FulfillmentOrdersListQuery = { fulfillmentOrders: { data: Array<{ __typename: 'FulfillmentOrder', id: string, secondaryId?: number | null, orderId: string, locationId: string, registerId?: string | null, acceptedByUserId?: string | null, acceptedAt?: any | null, status: FulfillmentOrderStatus, shippingProvider?: string | null, consignmentNumber?: string | null, packedByUserId?: string | null, packedAt?: any | null, completedAt?: any | null, createdBy?: string | null, createdAt?: any | null, updatedAt?: any | null, fulfillmentId?: string | null, trackingUrl?: string | null, location?: { __typename: 'Location', id: string, secondaryId?: number | null, name: string } | null, order: { __typename: 'Order', secondaryId?: number | null, orderType: OrderType, orderSource?: OrderSource | null, orderChannel: OrderChannel, customer: { name: string, phoneNumber?: string | null }, payments?: Array<{ id: string, method: PaymentMethod, status: PaymentStatus }> | null } }>, meta: { page?: number | null, limit?: number | null, totalCount?: number | null, total?: number | null } } };

export type FulfillmentOrderQueryVariables = Exact<{
  fulfillmentOrderId: Scalars['ID']['input'];
}>;


export type FulfillmentOrderQuery = { fulfillmentOrder?: { id: string, secondaryId?: number | null, registerId?: string | null, locationId: string, fulfillmentId?: string | null, acceptedByUserId?: string | null, acceptedAt?: any | null, status: FulfillmentOrderStatus, shippingProvider?: string | null, consignmentNumber?: string | null, packedByUserId?: string | null, packedAt?: any | null, completedAt?: any | null, createdBy?: string | null, createdAt?: any | null, updatedAt?: any | null, trackingUrl?: string | null, location?: { id: string, name: string, secondaryId?: number | null } | null, order: { secondaryId?: number | null, comment?: string | null, customer: { id?: string | null, name: string, phoneNumber?: string | null }, address?: { landmark?: string | null, latitude?: number | null, longitude?: number | null, streetAddress1?: string | null, streetAddress2?: string | null, streetName?: string | null, buildingNo?: string | null, additionalNumber?: string | null, state?: string | null, city?: { name?: string | null, country?: { name?: string | null } | null } | null } | null, payments?: Array<{ id: string, method: PaymentMethod, status: PaymentStatus }> | null }, lines?: Array<{ id: string, secondaryId?: number | null, productId: string, quantity: number, fulfilledQuantity: number, pickerUserId?: string | null, pickerAssignedAt?: any | null, pickerTaskId?: string | null, status: FulfillmentOrderLineStatus, createdAt?: any | null, updatedAt?: any | null, pickerTasks?: Array<{ id: string, status: PickingTaskStatus, scannedQuantity: number, quantityToPick: number, completedAt?: any | null, picker?: { id: string, secondaryId?: number | null, firstName?: string | null, lastName?: string | null } | null }> | null, product?: { name?: string | null } | null }> | null, register?: { name: string, id: string } | null } | null };

export type UnassignFulfillmentOrderLinesMutationVariables = Exact<{
  input: UnassignFulfillmentOrderLinesInput;
}>;


export type UnassignFulfillmentOrderLinesMutation = { unassignFulfillmentOrderLines: { id: string } };

export type AssignFulfillmentOrderLinesMutationVariables = Exact<{
  input: AssignFulfillmentOrderLinesInput;
}>;


export type AssignFulfillmentOrderLinesMutation = { assignFulfillmentOrderLines: { id: string } };

export type AssignPosRegisterMutationVariables = Exact<{
  fulfillmentOrderId: Scalars['ID']['input'];
  registerId: Scalars['ID']['input'];
}>;


export type AssignPosRegisterMutation = { assignPosRegister: boolean };

export type PickerTasksQueryVariables = Exact<{
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
  tabFilter?: InputMaybe<PickerTaskTabFilter>;
}>;


export type PickerTasksQuery = { pickerTasks: { meta: { page?: number | null, limit?: number | null, totalCount?: number | null, total?: number | null }, data: Array<{ orderId: string, orderNumber: number, fulfillmentOrderId?: string | null, fulfillmentId?: string | null, customerName?: string | null, partnerName?: string | null, orderChannel?: string | null, orderSource?: string | null, totalItems: number, pickedItems: number, fulfillmentStatus: FulfillmentStatus, tasks: Array<{ id: string, fulfillmentOrderId: string, status: PickingTaskStatus, quantityToPick: number, scannedQuantity: number, locationId?: string | null, locationName?: string | null, productName?: string | null, productSku?: string | null, productGtin?: string | null, orderCancelled: boolean, startedAt?: any | null, completedAt?: any | null }> }> } };

export type PickerTaskSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type PickerTaskSummaryQuery = { pickerTaskSummary: { toStart: number, inProgress: number, completed: number, cancelled: number, unitsLeft: number } };

export type StartPickerTaskMutationVariables = Exact<{
  startPickerTaskId: Scalars['ID']['input'];
}>;


export type StartPickerTaskMutation = { startPickerTask: { id: string } };

export type ScanPickerTaskUnitMutationVariables = Exact<{
  input: ScanPickerTaskUnitInput;
}>;


export type ScanPickerTaskUnitMutation = { scanPickerTaskUnit: { id: string } };

export type PickerTaskQueryVariables = Exact<{
  pickerTaskId: Scalars['ID']['input'];
}>;


export type PickerTaskQuery = { pickerTask: { scannedQuantity: number, quantityToPick: number, status: PickingTaskStatus, lots?: Array<{ actionId?: string | null, sellableQuantity: number, createdAt?: any | null }> | null, fulfillmentOrderLine?: { product?: { name?: string | null } | null } | null } };

export type FulfillmentOrderListQueryVariables = Exact<{
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  registerId?: InputMaybe<Scalars['String']['input']>;
  isRegisterAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
  tabFilter?: InputMaybe<FulfillmentOrderListFilter>;
}>;


export type FulfillmentOrderListQuery = { fulfillmentOrderList: { meta: { page?: number | null, limit?: number | null, totalCount?: number | null, total?: number | null }, data: Array<{ fulfillmentOrderId: string, fulfillmentId?: string | null, orderId: string, orderNumber: number, customerName?: string | null, partnerName?: string | null, orderChannel?: string | null, orderSource?: string | null, fulfillmentOrderStatus: FulfillmentOrderStatus, shippingProvider?: string | null, consignmentNumber?: string | null, lotsLockedAt?: any | null, registerId?: string | null, createdAt: any, totalPicked: number, totalQuantity: number, totalReady: number, lines: Array<{ lineId: string, taskId?: string | null, productId: string, productName?: string | null, productSku?: string | null, trackingLevel?: TrackingLevel | null, locationName?: string | null, quantity: number, pickedQuantity: number, readyQuantity: number, sentQuantity: number, lineStatus: FulfillmentOrderLineStatus }> }> } };

export type FulfillmentOrderListForBulkDispatchQueryVariables = Exact<{
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
  tabFilter?: InputMaybe<FulfillmentOrderListFilter>;
}>;


export type FulfillmentOrderListForBulkDispatchQuery = { fulfillmentOrderList: { meta: { page?: number | null, limit?: number | null, totalCount?: number | null, total?: number | null }, data: Array<{ fulfillmentOrderId: string, fulfillmentId?: string | null, orderId: string, orderNumber: number, customerName?: string | null, partnerName?: string | null, orderChannel?: string | null, orderSource?: string | null, fulfillmentOrderStatus: FulfillmentOrderStatus, shippingProvider?: string | null, consignmentNumber?: string | null, createdAt: any, totalPicked: number, totalQuantity: number, totalReady: number }> } };

export type RejectLotMutationVariables = Exact<{
  input: RejectLotInput;
}>;


export type RejectLotMutation = { rejectLot: { success: boolean } };

export type FulfillmentOrderPickingProgressQueryVariables = Exact<{
  fulfillmentOrderId: Scalars['ID']['input'];
}>;


export type FulfillmentOrderPickingProgressQuery = { fulfillmentOrderPickingProgress: { fulfillmentOrderId: string, totalUnits: number, pickedUnits: number, beingPickedUnits: number, assignedUnits: number, unassignedUnits: number, readyToDispatchUnits: number, dispatchedUnits: number } };

export type ReadyToDispatchMutationVariables = Exact<{
  input: ReadyToDispatchInput;
}>;


export type ReadyToDispatchMutation = { readyToDispatch: { id: string } };

export type FulfillmentOrderTabCountsQueryVariables = Exact<{
  locationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type FulfillmentOrderTabCountsQuery = { fulfillmentOrderTabCounts: { picking: number, picked: number, readyForDispatch: number, dispatched: number, delivered: number, all: number } };

export type MarkDispatchedMutationVariables = Exact<{
  input: MarkDispatchedInput;
}>;


export type MarkDispatchedMutation = { markDispatched: Array<{ id: string }> };

export type MarkDeliveredMutationVariables = Exact<{
  input: MarkDeliveredInput;
}>;


export type MarkDeliveredMutation = { markDelivered: Array<{ id: string, deliveredAt?: any | null }> };

export type PickerTaskLotsQueryVariables = Exact<{
  taskId: Scalars['ID']['input'];
}>;


export type PickerTaskLotsQuery = { pickerTaskLots: Array<{ id: string, lotId: string, actionId?: string | null, sellableQuantity: number, status: PickerTaskLotStatus, createdAt?: any | null }> };

export type FusionCarrierCostCentresQueryVariables = Exact<{
  connectionId: Scalars['String']['input'];
}>;


export type FusionCarrierCostCentresQuery = { fusionCarrierCostCentres: Array<{ code: string, name?: string | null, cityName?: string | null, pickupAddress?: string | null, returnAddress?: string | null, phoneNumber?: string | null, email?: string | null }> };

export type CreateFusionCarrierCostCentreMutationVariables = Exact<{
  input: CreateFusionCarrierCostCentreInput;
}>;


export type CreateFusionCarrierCostCentreMutation = { createFusionCarrierCostCentre: boolean };

export type FusionCarrierHealthQueryVariables = Exact<{
  connectionId: Scalars['String']['input'];
  probe?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type FusionCarrierHealthQuery = { fusionCarrierHealth: { connectionId: string, status: string, credentialExpiresAt?: any | null, daysUntilExpiry?: number | null, expiringSoon: boolean, message?: string | null } };

export type FusionCarrierLabelQueryVariables = Exact<{
  connectionId: Scalars['String']['input'];
  trackingNumber: Scalars['String']['input'];
}>;


export type FusionCarrierLabelQuery = { fusionCarrierLabel: { consignmentNumber: string, contentType: string, base64Data: string } };

export type FusionCarrierLocationMappingsQueryVariables = Exact<{
  connectionId: Scalars['String']['input'];
}>;


export type FusionCarrierLocationMappingsQuery = { fusionCarrierLocationMappings: Array<{ id: string, locationId: string, locationName: string, costCentreCode?: string | null }> };

export type SetFusionCarrierLocationMappingMutationVariables = Exact<{
  input: SetFusionCarrierLocationMappingInput;
}>;


export type SetFusionCarrierLocationMappingMutation = { setFusionCarrierLocationMapping: { id: string, locationId: string, locationName: string, costCentreCode?: string | null } };

export type RemoveFusionCarrierLocationMappingMutationVariables = Exact<{
  input: RemoveFusionCarrierLocationMappingInput;
}>;


export type RemoveFusionCarrierLocationMappingMutation = { removeFusionCarrierLocationMapping: boolean };

export type IntegrationCatalogueQueryVariables = Exact<{ [key: string]: never; }>;


export type IntegrationCatalogueQuery = { fusionIntegrationCatalogue: Array<{ connectorCode: string, displayName: string, description: string, category: string, entitled: boolean, connectionId?: string | null, supportedEvents: Array<string>, authFlow?: string | null, features: Array<string>, settings: Array<{ key: string, label: string, helpText?: string | null, secret: boolean, required: boolean, inputType: string, defaultValue?: string | null, visibleWhenKey?: string | null, visibleWhenValue?: string | null, options: Array<{ value: string, label: string }> }> }> };

export type MyIntegrationsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyIntegrationsQuery = { myFusionIntegrations: Array<{ id: string, connectorCode: string, displayName: string, environment: string, status: string, mappedLocationCount: number, mappedProductCount: number }> };

export type IntegrationQueryVariables = Exact<{
  connectionId: Scalars['String']['input'];
}>;


export type IntegrationQuery = { fusionIntegration: { capabilities: Array<string>, id: string, connectorCode: string, displayName: string, environment: string, status: string, mappedLocationCount: number, mappedProductCount: number, callbackKey?: string | null, authFlow?: string | null, features: Array<string>, externalAccountId?: string | null, settingSpecs: Array<{ key: string, label: string, helpText?: string | null, secret: boolean, required: boolean, inputType: string, defaultValue?: string | null, visibleWhenKey?: string | null, visibleWhenValue?: string | null, options: Array<{ value: string, label: string }> }>, settings: Array<{ key: string, value: string }> } };

export type ConnectIntegrationMutationVariables = Exact<{
  input: ConnectFusionIntegrationInput;
}>;


export type ConnectIntegrationMutation = { connectFusionIntegration: { id: string, connectorCode: string, displayName: string } };

export type UpdateFusionIntegrationMutationVariables = Exact<{
  input: UpdateFusionIntegrationInput;
}>;


export type UpdateFusionIntegrationMutation = { updateFusionIntegration: { id: string, displayName: string, settings: Array<{ key: string, value: string }> } };

export type IntegrationEventsQueryVariables = Exact<{
  connectionId: Scalars['String']['input'];
}>;


export type IntegrationEventsQuery = { fusionIntegrationEvents: Array<{ eventType: string, enabled: boolean }> };

export type SetIntegrationEventMutationVariables = Exact<{
  input: SetFusionIntegrationEventInput;
}>;


export type SetIntegrationEventMutation = { setFusionIntegrationEvent: { eventType: string, enabled: boolean } };

export type IntegrationLocationsQueryVariables = Exact<{
  connectionId: Scalars['String']['input'];
}>;


export type IntegrationLocationsQuery = { fusionIntegrationLocations: Array<{ locationId: string, name: string, externalVendorId?: string | null }> };

export type IntegrationOperationsQueryVariables = Exact<{
  connectionId: Scalars['String']['input'];
}>;


export type IntegrationOperationsQuery = { fusionIntegrationOperations: Array<{ id: string, operationType: string, oneObjectId: string, externalObjectId?: string | null, status: string, attemptCount: number, error?: string | null, requestPayload: any, responsePayload?: any | null, createdAt: any, completedAt?: any | null }> };

export type IntegrationProductsQueryVariables = Exact<{
  connectionId: Scalars['String']['input'];
}>;


export type IntegrationProductsQuery = { fusionIntegrationProducts: Array<{ productId: string, name: string, barcode?: string | null, active: boolean, externalSku?: string | null, stockBuffer?: number | null, maximumSalesQuantity?: number | null, listingStatus?: string | null, lastError?: string | null, externalUrl?: string | null, lastPushedAt?: any | null }> };

export type IntegrationProductSearchQueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;


export type IntegrationProductSearchQuery = { fusionIntegrationProductSearch: Array<{ productId: string, name: string, barcode?: string | null, active: boolean }> };

export type SetIntegrationLocationMutationVariables = Exact<{
  input: SetFusionIntegrationLocationInput;
}>;


export type SetIntegrationLocationMutation = { setFusionIntegrationLocation: { locationId: string, name: string, externalVendorId?: string | null } };

export type SetIntegrationProductMutationVariables = Exact<{
  input: SetFusionIntegrationProductInput;
}>;


export type SetIntegrationProductMutation = { setFusionIntegrationProduct: { productId: string, name: string, barcode?: string | null, active: boolean, externalSku?: string | null, stockBuffer?: number | null, maximumSalesQuantity?: number | null } };

export type UpdateIntegrationProductMutationVariables = Exact<{
  input: UpdateFusionIntegrationProductInput;
}>;


export type UpdateIntegrationProductMutation = { updateFusionIntegrationProduct: { productId: string, stockBuffer?: number | null, maximumSalesQuantity?: number | null } };

export type RemoveIntegrationLocationMutationVariables = Exact<{
  input: RemoveFusionIntegrationMappingInput;
}>;


export type RemoveIntegrationLocationMutation = { removeFusionIntegrationLocation: boolean };

export type RemoveIntegrationProductMutationVariables = Exact<{
  input: RemoveFusionIntegrationMappingInput;
}>;


export type RemoveIntegrationProductMutation = { removeFusionIntegrationProduct: boolean };

export type SyncIntegrationCatalogMutationVariables = Exact<{
  connectionId: Scalars['String']['input'];
}>;


export type SyncIntegrationCatalogMutation = { syncFusionIntegrationCatalog: Array<{ locationId: string, externalVendorId: string, itemCount: number, batchCount: number, queuedCount: number, jobIds: Array<string>, status: string, error?: string | null }> };

export type IntegrationProductTemplateQueryVariables = Exact<{
  connectionId: Scalars['String']['input'];
}>;


export type IntegrationProductTemplateQuery = { fusionIntegrationProductTemplate: Array<{ productCode: string, name: string, active: boolean, externalSku?: string | null, stockBuffer?: number | null, maximumSalesQuantity?: number | null }> };

export type ImportIntegrationProductsMutationVariables = Exact<{
  input: ImportFusionIntegrationProductsInput;
}>;


export type ImportIntegrationProductsMutation = { importFusionIntegrationProducts: { dryRun: boolean, totalRows: number, created: number, updated: number, unchanged: number, stockBuffersChanged: number, salesLimitsChanged: number, errors: Array<{ rowNumber: number, productCode: string, externalSku: string, message: string }> } };

export type IntegrationExternalLocationsQueryVariables = Exact<{
  connectionId: Scalars['String']['input'];
}>;


export type IntegrationExternalLocationsQuery = { fusionIntegrationExternalLocations: Array<{ id: string, name: string, address?: string | null, isActive: boolean, fulfillsOnlineOrders: boolean, linkedLocationId?: string | null }> };

export type StartIntegrationAuthorizationMutationVariables = Exact<{
  input: StartFusionIntegrationAuthorizationInput;
}>;


export type StartIntegrationAuthorizationMutation = { startFusionIntegrationAuthorization: { authorizeUrl: string } };

export type AddIntegrationProductsMutationVariables = Exact<{
  input: AddFusionIntegrationProductsInput;
}>;


export type AddIntegrationProductsMutation = { addFusionIntegrationProducts: Array<{ productId: string, name: string, barcode?: string | null, active: boolean, externalSku?: string | null, stockBuffer?: number | null, listingStatus?: string | null, lastError?: string | null, externalUrl?: string | null, lastPushedAt?: any | null }> };

export type PushIntegrationProductMutationVariables = Exact<{
  input: FusionIntegrationProductActionInput;
}>;


export type PushIntegrationProductMutation = { pushFusionIntegrationProduct: { productId: string, listingStatus?: string | null, lastError?: string | null, externalUrl?: string | null, lastPushedAt?: any | null } };

export type UnlistIntegrationProductMutationVariables = Exact<{
  input: FusionIntegrationProductActionInput;
}>;


export type UnlistIntegrationProductMutation = { unlistFusionIntegrationProduct: boolean };

export type SyncIntegrationProductsMutationVariables = Exact<{
  connectionId: Scalars['String']['input'];
}>;


export type SyncIntegrationProductsMutation = { syncFusionIntegrationProducts: { pushed: number, failed: number, remaining: number, busy: boolean, lastError?: string | null, onChannel: number, productUpdatesOff: boolean } };

export type FusionRidersQueryVariables = Exact<{
  connectionId: Scalars['String']['input'];
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type FusionRidersQuery = { fusionRiders: Array<{ id: string, name: string, phone: string, vehicle?: string | null, locationId?: string | null, active: boolean }> };

export type CreateFusionRiderMutationVariables = Exact<{
  input: CreateFusionRiderInput;
}>;


export type CreateFusionRiderMutation = { createFusionRider: { id: string, name: string, phone: string, vehicle?: string | null, active: boolean } };

export type SetFusionRiderActiveMutationVariables = Exact<{
  input: SetFusionRiderActiveInput;
}>;


export type SetFusionRiderActiveMutation = { setFusionRiderActive: { id: string, active: boolean } };

export type FusionRiderCodOutstandingQueryVariables = Exact<{
  connectionId: Scalars['String']['input'];
}>;


export type FusionRiderCodOutstandingQuery = { fusionRiderCodOutstanding: Array<{ riderId: string, riderName: string, riderPhone: string, outstandingAmount: string, shipmentCount: number, oldestBookedAt?: any | null }> };

export type SettleFusionRiderCodMutationVariables = Exact<{
  input: SettleFusionRiderCodInput;
}>;


export type SettleFusionRiderCodMutation = { settleFusionRiderCod: { id: string, riderId: string, amount: string, shipmentCount: number, settledAt: any } };

export type FusionShipmentsQueryVariables = Exact<{
  input?: InputMaybe<ListFusionShipmentsInput>;
}>;


export type FusionShipmentsQuery = { fusionShipments: Array<{ id: string, fulfillmentOrderId: string, connectionId: string, carrierCode: string, status: string, direction: string, capabilities: Array<string>, needsAttention: boolean, trackingNumber?: string | null, consignmentUrl?: string | null, quarkSyncedAt?: any | null, bookedAt?: any | null, cancelledAt?: any | null, createdAt: any }> };

export type BookFusionShipmentMutationVariables = Exact<{
  input: BookFusionShipmentInput;
}>;


export type BookFusionShipmentMutation = { bookFusionShipment: { id: string, fulfillmentOrderId: string, connectionId: string, carrierCode: string, status: string, direction: string, capabilities: Array<string>, needsAttention: boolean, trackingNumber?: string | null, consignmentUrl?: string | null, quarkSyncedAt?: any | null, bookedAt?: any | null, cancelledAt?: any | null, createdAt: any } };

export type CancelFusionShipmentMutationVariables = Exact<{
  shipmentId: Scalars['String']['input'];
}>;


export type CancelFusionShipmentMutation = { cancelFusionShipment: { id: string, status: string, needsAttention: boolean, cancelledAt?: any | null } };

export type RetryFusionShipmentQuarkSyncMutationVariables = Exact<{
  shipmentId: Scalars['String']['input'];
}>;


export type RetryFusionShipmentQuarkSyncMutation = { retryFusionShipmentQuarkSync: { id: string, status: string, needsAttention: boolean, quarkSyncedAt?: any | null } };

export type BookFusionReturnShipmentMutationVariables = Exact<{
  returnOrderId: Scalars['String']['input'];
}>;


export type BookFusionReturnShipmentMutation = { bookFusionReturnShipment: { id: string, status: string, trackingNumber?: string | null, bookedAt?: any | null } };

export type GrnSummaryQueryVariables = Exact<{
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
}>;


export type GrnSummaryQuery = { grnSummary: { grn: number, accepted: number, rejected: number, partial: number } };

export type StockIntakeSummaryQueryVariables = Exact<{
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
}>;


export type StockIntakeSummaryQuery = { stockIntakeSummary: { items: number, quantity: number, value: number, gst: number } };

export type CreateGrnMutationVariables = Exact<{
  createGrnDto: CreateGrnDto;
}>;


export type CreateGrnMutation = { createGrn: boolean };

export type UpdateGrnQcStatusMutationVariables = Exact<{
  updateGrnItemStatusDto: UpdateGrnItemStatus;
}>;


export type UpdateGrnQcStatusMutation = { updateGrnQCStatus: boolean };

export type GetAllGrnsListQueryVariables = Exact<{
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
  locationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAllGrnsListQuery = { getAllGrns: { data: Array<{ id: string, secondaryId?: number | null, advanceIncomeTax?: string | null, amount?: number | null, comment?: string | null, discount?: number | null, invoiceDate?: string | null, invoiceNumber?: string | null, poId?: string | null, receivedQuantity?: number | null, stockArrivalDate?: string | null, tax?: number | null, total?: number | null, createdAt: any, updatedAt: any, status: GrnStatusApproval }>, meta: { totalCount?: number | null, page?: number | null, limit?: number | null } } };

export type GetOneGrnDetailsQueryVariables = Exact<{
  grnId: Scalars['String']['input'];
}>;


export type GetOneGrnDetailsQuery = { getOneGrn: { invoiceDate?: string | null, invoiceNumber?: string | null, advanceIncomeTax?: string | null, id: string, secondaryId?: number | null, poId?: string | null, status: GrnStatusApproval, stockArrivalDate?: string | null, createdByName?: string | null, designation?: string | null, purchaseOrder?: { id?: string | null, secondaryId?: number | null, createdAt?: any | null, vendor: { id: string, secondaryId?: number | null, name?: string | null } } | null, grnItems: Array<{ actionId?: string | null, batchExpiry?: string | null, batchNumber?: string | null, comment?: string | null, rejectComment?: string | null, discValue?: number | null, foc?: boolean | null, gstValue?: number | null, id?: string | null, mrp?: number | null, mfgDate?: string | null, receivedQuantity?: number | null, requiredQuantity?: number | null, status: GrnItemStatusApproval, tradePrice?: number | null, uomFactor?: number | null, isManufacturerTracking?: boolean | null, trackingLevel?: TrackingLevel | null, purchaseOrderItem?: { id?: string | null, uom?: string | null, itemConversion?: number | null, product: { id?: string | null, name?: string | null, secondaryId?: number | null, manufacturer?: { name?: string | null } | null } } | null }> } };

export type GetAllGrnItemsQueryVariables = Exact<{
  locationId: Scalars['String']['input'];
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
}>;


export type GetAllGrnItemsQuery = { getAllGrnItems: { data: Array<{ actionId?: string | null, batchExpiry?: string | null, batchNumber?: string | null, comment?: string | null, discValue?: number | null, gstValue?: number | null, foc?: boolean | null, id?: string | null, secondaryId?: number | null, mrp?: number | null, receivedQuantity?: number | null, requiredQuantity?: number | null, status: GrnItemStatusApproval, tradePrice?: number | null, createdAt?: any | null, updatedAt?: any | null, serialNumbers?: Array<string> | null, trackingLevel?: TrackingLevel | null, isManufacturerTracking?: boolean | null, manufacturerCode?: string | null, purchaseOrderItem?: { foc?: boolean | null, grnRemainingQuantity?: number | null, gstPercentage?: number | null, id?: string | null, secondaryId?: number | null, itemConversion?: number | null, uom?: string | null, purchaseOrder?: { id?: string | null, secondaryId?: number | null } | null, product: { id?: string | null, name?: string | null, secondaryId?: number | null } } | null }>, meta: { limit?: number | null, page?: number | null, totalCount?: number | null } } };

export type UpdateGrnItemSerialNumbersMutationVariables = Exact<{
  grnItemId: Scalars['String']['input'];
  serialNumbers: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type UpdateGrnItemSerialNumbersMutation = { updateGrnItemSerialNumbers: boolean };

export type UpdateGrnReceivedStatusMutationVariables = Exact<{
  grnId: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type UpdateGrnReceivedStatusMutation = { updateGrnReceivedStatus: boolean };

export type GetIntegrationsQueryVariables = Exact<{
  locationId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
  page: Scalars['Int']['input'];
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
  limit: Scalars['Int']['input'];
}>;


export type GetIntegrationsQuery = { getIntegrations: { data: Array<{ allowedOrderType?: Array<AllowedOrderType> | null, charges?: number | null, createdAt?: any | null, id?: string | null, integrationId?: string | null, locationId?: string | null, logo?: string | null, name?: string | null, registerId?: string | null, status: string, type: IntegrationType, updatedAt?: any | null }>, meta: { limit?: number | null, page?: number | null, total?: number | null, totalCount?: number | null } } };

export type GetIntegrationQueryVariables = Exact<{
  getIntegrationId: Scalars['ID']['input'];
}>;


export type GetIntegrationQuery = { getIntegration: { allowedOrderType?: Array<AllowedOrderType> | null, charges?: number | null, createdAt?: any | null, id?: string | null, integrationId?: string | null, locationId?: string | null, logo?: string | null, name?: string | null, registerId?: string | null, status: string, type: IntegrationType, updatedAt?: any | null } };

export type CreateIntegrationMutationVariables = Exact<{
  createIntegrationDto: CreateIntegrationConfigDto;
}>;


export type CreateIntegrationMutation = { createIntegration: { id?: string | null } };

export type UpdateIntegrationMutationVariables = Exact<{
  updateIntegrationInput: UpdateIntegrationConfigDto;
}>;


export type UpdateIntegrationMutation = { updateIntegration: { id?: string | null } };

export type GetLocationListForOptionsQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
  locationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetLocationListForOptionsQuery = { getLocations: { meta: { limit?: number | null, page?: number | null, totalCount?: number | null }, data: Array<{ id: string, name: string, type: LocationType }> } };

export type GetLocationsListQueryVariables = Exact<{
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
  limit: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
}>;


export type GetLocationsListQuery = { getLocations: { data: Array<{ id: string, secondaryId?: number | null, name: string, area?: string | null, status: string, type: LocationType, createdAt?: any | null, updatedAt?: any | null, warehouse?: { name: string } | null }> } };

export type GetLocationForDetailsQueryVariables = Exact<{
  getLocationId: Scalars['String']['input'];
}>;


export type GetLocationForDetailsQuery = { getLocation: { area?: string | null, cityId?: string | null, createdAt?: any | null, id: string, name: string, salesTaxNumber?: string | null, secondaryId?: number | null, status: string, taxNumber?: string | null, type: LocationType, updatedAt?: any | null, warehouseId?: string | null, timezone?: string | null, warehouse?: { name: string, id: string } | null, city?: { id?: string | null, name?: string | null, country?: { name?: string | null, id?: string | null } | null } | null } };

export type GetCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCountriesQuery = { getCountries: Array<{ name?: string | null, id?: string | null }> };

export type GetCitiesQueryVariables = Exact<{
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
}>;


export type GetCitiesQuery = { getCities: { meta: { totalCount?: number | null, limit?: number | null, page?: number | null, total?: number | null }, data: Array<{ id?: string | null, name?: string | null, country?: { name?: string | null, id?: string | null } | null }> } };

export type GetCitiesOptionsQueryVariables = Exact<{
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
}>;


export type GetCitiesOptionsQuery = { getCities: { meta: { totalCount?: number | null, limit?: number | null, page?: number | null, total?: number | null }, data: Array<{ id?: string | null, name?: string | null }> } };

export type CreateLocationMutationVariables = Exact<{
  locationDto: LocationDto;
}>;


export type CreateLocationMutation = { createLocation: { id: string } };

export type UpdateLocationMutationVariables = Exact<{
  locationDto: LocationDto;
  updateLocationId: Scalars['String']['input'];
}>;


export type UpdateLocationMutation = { updateLocation: { id: string } };

export type GetLostSalesQueryVariables = Exact<{
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
}>;


export type GetLostSalesQuery = { getLostSales: { meta: { limit?: number | null, page?: number | null, total?: number | null, totalCount?: number | null }, data: Array<{ createdAt?: any | null, createdBy?: string | null, currentInventory?: number | null, id?: string | null, price?: number | null, productName?: string | null, quantity: number, reason?: string | null, secondaryId?: number | null, status?: string | null, type: LostSaleType, updatedAt?: any | null, value?: number | null }> } };

export type GetLostSaleQueryVariables = Exact<{
  getLostSaleId: Scalars['String']['input'];
}>;


export type GetLostSaleQuery = { getLostSale: { createdAt?: any | null, createdBy?: string | null, currentInventory?: number | null, id?: string | null, price?: number | null, productId?: string | null, productName?: string | null, quantity: number, reason?: string | null, secondaryId?: number | null, status?: string | null, type: LostSaleType, updatedAt?: any | null, value?: number | null, product?: { id?: string | null, secondaryId?: number | null, name?: string | null } | null } };

export type CreateLostSaleMutationVariables = Exact<{
  createLostSaleDto: CreateLostSaleDto;
}>;


export type CreateLostSaleMutation = { createLostSale: { id?: string | null } };

export type CreateManufacturerMutationVariables = Exact<{
  createManufacturerDto: CreateManufacturerDto;
}>;


export type CreateManufacturerMutation = { createManufacturer: { description?: string | null, id?: string | null, lastReason?: string | null, lineOfBusiness?: Array<string> | null, name?: string | null, status?: string | null } };

export type UpdateManufacturerMutationVariables = Exact<{
  updateManufacturerDto: UpdateManufacturerDto;
}>;


export type UpdateManufacturerMutation = { updateManufacturer: { description?: string | null, id?: string | null, lastReason?: string | null, lineOfBusiness?: Array<string> | null, name?: string | null, status?: string | null } };

export type GetManufacturerQueryVariables = Exact<{
  getManufacturerId: Scalars['String']['input'];
}>;


export type GetManufacturerQuery = { getManufacturer: { description?: string | null, id?: string | null, lastReason?: string | null, lineOfBusiness?: Array<string> | null, name?: string | null, status?: string | null } };

export type GetManufacturersQueryVariables = Exact<{
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
}>;


export type GetManufacturersQuery = { getManufacturers: { data: Array<{ id?: string | null, secondaryId?: number | null, description?: string | null, lastReason?: string | null, lineOfBusiness?: Array<string> | null, name?: string | null, status?: string | null }>, meta: { limit?: number | null, page?: number | null, totalCount?: number | null } } };

export type GetManufacturersForOptionsQueryVariables = Exact<{
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
}>;


export type GetManufacturersForOptionsQuery = { getManufacturers: { data: Array<{ id?: string | null, name?: string | null }>, meta: { limit?: number | null, page?: number | null, totalCount?: number | null } } };

export type UploadMediaImageMutationVariables = Exact<{
  input: UploadMediaImageInput;
}>;


export type UploadMediaImageMutation = { uploadMediaImage: { id: string, url: string, filename?: string | null, mimeType?: string | null, width?: number | null, height?: number | null } };

export type GetMediaAssetsQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
}>;


export type GetMediaAssetsQuery = { getMediaAssets: { data: Array<{ id: string, url: string, filename?: string | null, mimeType?: string | null, width?: number | null, height?: number | null, createdAt?: any | null }>, meta: { page?: number | null, limit?: number | null, totalCount?: number | null } } };

export type DeleteMediaAssetMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteMediaAssetMutation = { deleteMediaAsset: boolean };

export type CancellationDetailsFragment = { id: string, orderId: string, createdAt: any, cancelledBy?: string | null, reason: CancellationReason, note?: string | null, isFull: boolean, refundAmount: number, refundMethod?: string | null, deliveryCharges: number, platformFee: number, integrationCharges: number, fbrInvoiceId?: string | null, backfilled: boolean, lines?: Array<{ id: string, orderLineItemId: string, productId?: string | null, quantity: number, unitPrice: number, subTotal: number, discount: number, tax: number, totalPrice: number, restockTo: RestockTarget, lots?: Array<{ productLotId: string, quantity: number, source: CancellationLotSource, restockTo: RestockTarget }> | null }> | null };

export type CancelOrderMutationVariables = Exact<{
  input: CancelOrderInput;
}>;


export type CancelOrderMutation = { cancelOrder: { orderCancelled: boolean, fbrCreditNoteRequired: boolean, cancellation: { id: string, orderId: string, createdAt: any, cancelledBy?: string | null, reason: CancellationReason, note?: string | null, isFull: boolean, refundAmount: number, refundMethod?: string | null, deliveryCharges: number, platformFee: number, integrationCharges: number, fbrInvoiceId?: string | null, backfilled: boolean, lines?: Array<{ id: string, orderLineItemId: string, productId?: string | null, quantity: number, unitPrice: number, subTotal: number, discount: number, tax: number, totalPrice: number, restockTo: RestockTarget, lots?: Array<{ productLotId: string, quantity: number, source: CancellationLotSource, restockTo: RestockTarget }> | null }> | null } } };

export type UpdateCancellationFbrInvoiceIdMutationVariables = Exact<{
  cancellationId: Scalars['ID']['input'];
  fbrInvoiceId: Scalars['String']['input'];
}>;


export type UpdateCancellationFbrInvoiceIdMutation = { updateCancellationFbrInvoiceId: boolean };

export type OrderCancellationsQueryVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type OrderCancellationsQuery = { orderCancellations: Array<{ id: string, orderId: string, createdAt: any, cancelledBy?: string | null, reason: CancellationReason, note?: string | null, isFull: boolean, refundAmount: number, refundMethod?: string | null, deliveryCharges: number, platformFee: number, integrationCharges: number, fbrInvoiceId?: string | null, backfilled: boolean, lines?: Array<{ id: string, orderLineItemId: string, productId?: string | null, quantity: number, unitPrice: number, subTotal: number, discount: number, tax: number, totalPrice: number, restockTo: RestockTarget, lots?: Array<{ productLotId: string, quantity: number, source: CancellationLotSource, restockTo: RestockTarget }> | null }> | null }> };

export type FulfillmentOrderEventsQueryVariables = Exact<{
  fulfillmentOrderId: Scalars['ID']['input'];
}>;


export type FulfillmentOrderEventsQuery = { fulfillmentOrderEvents: Array<{ id: string, type: FulfillmentOrderEventType, at: any, createdAt: any, userId?: string | null, reason?: string | null, data?: any | null }> };

export type VoidShipmentBookingMutationVariables = Exact<{
  fulfillmentOrderId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
}>;


export type VoidShipmentBookingMutation = { voidShipmentBooking: { id: string, status: FulfillmentOrderStatus } };

export type UnpackFulfillmentOrderMutationVariables = Exact<{
  fulfillmentOrderId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
}>;


export type UnpackFulfillmentOrderMutation = { unpackFulfillmentOrder: { id: string, status: FulfillmentOrderStatus } };

export type SwapReservedLotMutationVariables = Exact<{
  input: SwapReservedLotInput;
}>;


export type SwapReservedLotMutation = { swapReservedLot: boolean };

export type CompleteRegisterFulfillmentMutationVariables = Exact<{
  input: CompleteRegisterFulfillmentInput;
}>;


export type CompleteRegisterFulfillmentMutation = { completeRegisterFulfillment: { id: string, status: FulfillmentOrderStatus } };

export type MarkDeliveryFailedMutationVariables = Exact<{
  input: MarkDeliveryFailedInput;
}>;


export type MarkDeliveryFailedMutation = { markDeliveryFailed: { id: string, status: FulfillmentOrderStatus } };

export type ReceiveReturnedParcelMutationVariables = Exact<{
  input: ReceiveReturnedParcelInput;
}>;


export type ReceiveReturnedParcelMutation = { receiveReturnedParcel: { orderCancelled: boolean, fbrCreditNoteRequired: boolean, cancellation: { id: string, orderId: string, createdAt: any, cancelledBy?: string | null, reason: CancellationReason, note?: string | null, isFull: boolean, refundAmount: number, refundMethod?: string | null, deliveryCharges: number, platformFee: number, integrationCharges: number, fbrInvoiceId?: string | null, backfilled: boolean, lines?: Array<{ id: string, orderLineItemId: string, productId?: string | null, quantity: number, unitPrice: number, subTotal: number, discount: number, tax: number, totalPrice: number, restockTo: RestockTarget, lots?: Array<{ productLotId: string, quantity: number, source: CancellationLotSource, restockTo: RestockTarget }> | null }> | null } } };

export type OrderFulfillmentOrdersQueryVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type OrderFulfillmentOrdersQuery = { fulfillmentOrderGroup: Array<{ id: string, secondaryId?: number | null, fulfillmentId?: string | null, status: FulfillmentOrderStatus, source: FulfillmentOrderSource, registerId?: string | null, locationId: string, shippingProvider?: string | null, consignmentNumber?: string | null, codAmount?: number | null, lotsLockedAt?: any | null, dispatchedAt?: any | null, deliveredAt?: any | null, createdAt?: any | null, location?: { id: string, name: string } | null, lines?: Array<{ id: string, orderLineItemId: string, productId: string, quantity: number, fulfilledQuantity: number, status: FulfillmentOrderLineStatus }> | null }> };

export type OpenRegisterSessionsQueryVariables = Exact<{
  locationId: Scalars['String']['input'];
}>;


export type OpenRegisterSessionsQuery = { getLocationRegisterSessions: { data: Array<{ id: string, secondaryId?: number | null, openedByUserId?: string | null, register?: { name: string } | null, openedBy?: { firstName?: string | null, lastName?: string | null } | null }> } };

export type ActiveFulfillmentHoldsQueryVariables = Exact<{
  entityId: Scalars['ID']['input'];
}>;


export type ActiveFulfillmentHoldsQuery = { activeHolds: Array<{ id: string, reason: HoldReason, comment?: string | null, heldAt: any }> };

export type PlaceFulfillmentHoldMutationVariables = Exact<{
  entityId: Scalars['ID']['input'];
  reason: HoldReason;
  comment?: InputMaybe<Scalars['String']['input']>;
}>;


export type PlaceFulfillmentHoldMutation = { placeHold: { id: string } };

export type ReleaseFulfillmentHoldMutationVariables = Exact<{
  holdId: Scalars['ID']['input'];
}>;


export type ReleaseFulfillmentHoldMutation = { releaseHold: { id: string } };

export type ReleaseFulfillmentOrderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ReleaseFulfillmentOrderMutation = { cancelFulfillmentOrder: { id: string, status: FulfillmentOrderStatus } };

export type OrderManagementSummaryQueryVariables = Exact<{
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
}>;


export type OrderManagementSummaryQuery = { orderManagementSummary: { orders: number, pending: number, returned: number, partiallyReturned: number, totalAmount: number } };

export type EditOrderMutationVariables = Exact<{
  input: EditOrderDto;
}>;


export type EditOrderMutation = { editOrder: boolean };

export type ConfirmOrderMutationVariables = Exact<{
  input: ConfirmOnlineOrderDto;
}>;


export type ConfirmOrderMutation = { confirmOrder: boolean };

export type CreateOrderMutationVariables = Exact<{
  createOrderDto: CreateOrderDto;
}>;


export type CreateOrderMutation = { createOrder: { id: string, secondaryId?: number | null, createdAt?: any | null, orderType: OrderType, subtotal: number, totalDiscount: number, totalAmount: number, tax: number, deliveryCharges: number, platformFee: number, posFees: number, mrNo?: string | null, comment?: string | null, customer: { name: string, id?: string | null, phoneNumber?: string | null, email?: string | null, addresses?: Array<{ streetAddress1?: string | null, streetAddress2?: string | null, state?: string | null, landmark?: string | null, cityId?: string | null, postalCode?: string | null, buildingNo?: string | null, city?: { id?: string | null, name?: string | null } | null }> | null }, address?: { buildingNo?: string | null, id: string, postalCode?: string | null, state?: string | null, streetName?: string | null, streetAddress2?: string | null, streetAddress1?: string | null, landmark?: string | null, districtName?: string | null, city?: { id?: string | null, name?: string | null, country?: { id?: string | null, name?: string | null } | null } | null } | null, discountLines?: Array<{ discountAmount: number, discount?: { type: DiscountType } | null }> | null, payments?: Array<{ method: PaymentMethod, status: PaymentStatus }> | null, location?: { name: string, area?: string | null, city?: { id?: string | null, name?: string | null, country?: { id?: string | null, name?: string | null } | null } | null } | null, integrationConfigs?: Array<{ type: IntegrationType, name?: string | null, charges?: number | null, apiResponseId?: string | null }> | null, items: Array<{ id: string, name: string, quantity: number, unitPrice: number, discount: number, tax: number, taxRate: number, totalPrice: number, subTotal: number, product: { taxCode?: string | null } }>, orderPlatformFees?: Array<{ amount: number, name: string, id: string }> | null } };

export type GetOrderListQueryVariables = Exact<{
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
  page: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
}>;


export type GetOrderListQuery = { getOrders: { data: Array<{ id: string, status: OrderStatus, createdAt?: any | null, secondaryId?: number | null, orderType: OrderType, fulfillmentStatus: FulfillmentStatus, totalAmount: number, amountDue?: number | null, itemsCount: number, shippingStatus: ShippingStatus, totalDiscount: number, orderSource?: OrderSource | null, orderChannel: OrderChannel, location?: { name: string } | null, customer: { name: string, phoneNumber?: string | null }, payments?: Array<{ method: PaymentMethod, status: PaymentStatus, id: string }> | null }>, meta: { limit?: number | null, page?: number | null, total?: number | null, totalCount?: number | null } } };

export type GetOrderListingItemsQueryVariables = Exact<{
  getOrderId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetOrderListingItemsQuery = { getOrder: { items: Array<{ quantity: number, name: string }> } };

export type GetOrderQueryVariables = Exact<{
  getOrderId: Scalars['String']['input'];
}>;


export type GetOrderQuery = { getOrder: { addressId?: string | null, comment?: string | null, createdAt?: any | null, customerId?: string | null, cancelledReason?: string | null, deliveryCharges: number, fulfillmentStatus: FulfillmentStatus, id: string, integrationCharges: number, locationId?: string | null, mrNo?: string | null, orderChannel: OrderChannel, orderSource?: OrderSource | null, orderType: OrderType, partnerId?: string | null, platformFee: number, posFees: number, registerId?: string | null, secondaryId?: number | null, shippingStatus: ShippingStatus, status: OrderStatus, subtotal: number, tax: number, totalAmount: number, amountDue?: number | null, totalDiscount: number, updatedAt?: any | null, partnerReferenceNo?: string | null, partner?: { id: string, name: string } | null, address?: { buildingNo?: string | null, id: string, postalCode?: string | null, state?: string | null, streetName?: string | null, streetAddress2?: string | null, streetAddress1?: string | null, landmark?: string | null, districtName?: string | null, city?: { id?: string | null, name?: string | null, country?: { id?: string | null, name?: string | null } | null } | null } | null, customer: { id?: string | null, name: string, phoneNumber?: string | null }, discountLines?: Array<{ id: string, discountAmount: number, discount?: { type: DiscountType } | null }> | null, integrationConfigs?: Array<{ type: IntegrationType, apiResponseId?: string | null, charges?: number | null, name?: string | null }> | null, payments?: Array<{ method: PaymentMethod, status: PaymentStatus, id: string, amount: number }> | null, location?: { area?: string | null, name: string, city?: { name?: string | null, id?: string | null, country?: { id?: string | null, name?: string | null } | null } | null } | null, items: Array<{ id: string, name: string, productId?: string | null, image?: string | null, discount: number, secondaryId?: number | null, quantity: number, taxRate: number, tax: number, totalPrice: number, unitPrice: number, subTotal: number, fulfillmentStatus: FulfillmentStatus, cancelledQuantity: number, returnedQuantity: number, lots?: Array<{ id: string, quantity: number, returnedQuantity: number, productLot: { id: string, actionId?: string | null, batchNumber?: string | null, batchExpiry?: string | null, mrpSellingUnit?: number | null } }> | null }>, locationRegisterSession?: { openedBy?: { firstName?: string | null, lastName?: string | null } | null } | null, orderPlatformFees?: Array<{ amount: number, name: string, id: string }> | null } };

export type GetOrderForReturnQueryVariables = Exact<{
  secondaryId?: InputMaybe<Scalars['Float']['input']>;
  getOrderId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetOrderForReturnQuery = { getOrder: { id: string, secondaryId?: number | null, tax: number, subtotal: number, orderSource?: OrderSource | null, status: OrderStatus, orderChannel: OrderChannel, orderType: OrderType, totalAmount: number, totalDiscount: number, locationId?: string | null, partnerId?: string | null, customer: { id?: string | null, name: string, phoneNumber?: string | null, email?: string | null }, payments?: Array<{ method: PaymentMethod, status: PaymentStatus }> | null, items: Array<{ name: string, id: string, discount: number, subTotal: number, tax: number, totalPrice: number, unitPrice: number, taxRate: number, secondaryId?: number | null, quantity: number, returnedQuantity: number, cancelledQuantity: number, lots?: Array<{ id: string, quantity: number, returnedQuantity: number, productLot: { actionId?: string | null } }> | null }> } };

export type GetReturnedOrdersForOrderDetailQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
}>;


export type GetReturnedOrdersForOrderDetailQuery = { getReturnedOrders: { data: Array<{ comment?: string | null, id: string, createdAt?: any | null, parentOrderId?: string | null, secondaryId?: number | null, status: OrderStatus, totalAmount: number, items: Array<{ createdAt?: any | null, id: string, secondaryId?: number | null, productId?: string | null, name: string, quantity: number, discount: number, subTotal: number, totalPrice: number, unitPrice: number, updatedAt?: any | null }>, location?: { name: string } | null, integrationConfigs: Array<{ apiResponseId?: string | null }>, locationRegisterSession?: { openedBy?: { firstName?: string | null, lastName?: string | null } | null } | null, customer?: { name: string, phoneNumber?: string | null } | null }> } };

export type ProcessOrderMutationVariables = Exact<{
  processOrder: ProcessOrderDto;
}>;


export type ProcessOrderMutation = { processOrder: boolean };

export type UpdatePaymentStatusMutationVariables = Exact<{
  paymentStatus: PaymentStatus;
  orderId: Scalars['String']['input'];
}>;


export type UpdatePaymentStatusMutation = { updatePaymentStatus: boolean };

export type ProcessShippingMutationVariables = Exact<{
  processOrder: ProcessShippingDto;
}>;


export type ProcessShippingMutation = { processShipping: boolean };

export type ProcessFulfillmentMutationVariables = Exact<{
  processOrder: ProcessFulfillmentDto;
}>;


export type ProcessFulfillmentMutation = { processFulfillment: boolean };

export type ReturnOrderMutationVariables = Exact<{
  returnOrderDto: ReturnOrderDto;
}>;


export type ReturnOrderMutation = { returnOrder: { id: string, secondaryId?: number | null, totalAmount: number, paymentMethod?: ReturnOrderPaymentMethod | null, status: OrderStatus, createdAt?: any | null, order?: { id: string, secondaryId?: number | null } | null, customer?: { phoneNumber?: string | null, name: string } | null, items: Array<{ id: string, name: string, quantity: number, subTotal: number, totalPrice: number, discount: number, unitPrice: number, product?: { taxCode?: string | null } | null, lots?: Array<{ productLot: { taxSellingUnit?: number | null } }> | null }>, location?: { name: string } | null, locationRegisterSession?: { openedBy?: { firstName?: string | null, secondaryId?: number | null, lastName?: string | null } | null } | null } };

export type GetReturnedOrdersQueryVariables = Exact<{
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
  limit: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
}>;


export type GetReturnedOrdersQuery = { getReturnedOrders: { data: Array<{ secondaryId?: number | null, id: string, parentOrderId?: string | null, status: OrderStatus, comment?: string | null, totalAmount: number, updatedAt?: any | null, createdAt?: any | null, customer?: { id?: string | null, name: string, phoneNumber?: string | null } | null }>, meta: { limit?: number | null, page?: number | null, total?: number | null, totalCount?: number | null } } };

export type UpdateFbrInvoiceIdMutationVariables = Exact<{
  invoiceId: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
}>;


export type UpdateFbrInvoiceIdMutation = { updateFbrInvoiceId: boolean };

export type UpdateReturnFbrInvoiceIdMutationVariables = Exact<{
  invoiceId: Scalars['String']['input'];
  returnOrderId: Scalars['String']['input'];
}>;


export type UpdateReturnFbrInvoiceIdMutation = { updateReturnFbrInvoiceId: boolean };

export type GetReturnOrderQueryVariables = Exact<{
  getReturnOrderId: Scalars['String']['input'];
}>;


export type GetReturnOrderQuery = { getReturnOrder: { comment?: string | null, createdAt?: any | null, id: string, paymentMethod?: ReturnOrderPaymentMethod | null, registerSessionId?: string | null, secondaryId?: number | null, status: OrderStatus, totalAmount: number, updatedAt?: any | null, order?: { secondaryId?: number | null } | null, customer?: { name: string } | null, integrationConfigs: Array<{ apiResponseId?: string | null, type: IntegrationType, name?: string | null, charges?: number | null }>, items: Array<{ createdAt?: any | null, description?: string | null, discount: number, id: string, image?: string | null, name: string, orderId?: string | null, productId?: string | null, quantity: number, secondaryId?: number | null, subTotal: number, totalPrice: number, unitPrice: number, updatedAt?: any | null, lots?: Array<{ productLot: { actionId?: string | null } }> | null }>, locationRegisterSession?: { openedBy?: { firstName?: string | null, lastName?: string | null } | null } | null, location?: { name: string } | null } };

export type GetOrderLineItemLotsListQueryVariables = Exact<{
  orderLineItemId: Scalars['String']['input'];
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetOrderLineItemLotsListQuery = { getOrderLineItemLots: { meta: { page?: number | null, limit?: number | null, totalCount?: number | null, total?: number | null }, data: Array<{ id: string, orderLineItemId?: string | null, productLotId?: string | null, quantity: number, returnedQuantity: number, productLot: { actionId?: string | null, mrpSellingUnit?: number | null } }> } };

export type GetReturnOrderLineItemLotsQueryVariables = Exact<{
  returnOrderLineItemId: Scalars['String']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
}>;


export type GetReturnOrderLineItemLotsQuery = { getReturnOrderLineItemLots: { meta: { page?: number | null, limit?: number | null, totalCount?: number | null, total?: number | null }, data: Array<{ id: string, quantity: number, productLot: { actionId?: string | null }, returnOrderLineItem: { totalPrice: number } }> } };

export type GetPartnersForOptionsQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
}>;


export type GetPartnersForOptionsQuery = { getPartners: { data: Array<{ name: string, id: string, secondaryId: number, status: Status }>, meta: { limit?: number | null, page?: number | null, total?: number | null, totalCount?: number | null } } };

export type GetPartnersListQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
}>;


export type GetPartnersListQuery = { getPartners: { data: Array<{ address?: string | null, contactPerson?: string | null, createdAt?: any | null, email?: string | null, id: string, name: string, phoneNumber?: string | null, secondaryId: number, status: Status, taxId?: string | null, type: PartnerType, websiteUrl?: string | null, city?: { id?: string | null, name?: string | null, country?: { id?: string | null, name?: string | null } | null } | null }>, meta: { limit?: number | null, page?: number | null, total?: number | null, totalCount?: number | null } } };

export type CreatePartnerMutationVariables = Exact<{
  createPartnerDto: CreatePartnerDto;
}>;


export type CreatePartnerMutation = { createPartner: { id: string } };

export type UpdatePartnerMutationVariables = Exact<{
  updatePartnerDto: UpdatePartnerDto;
}>;


export type UpdatePartnerMutation = { updatePartner: { id: string } };

export type GetPartnerQueryVariables = Exact<{
  getPartnerId: Scalars['String']['input'];
}>;


export type GetPartnerQuery = { getPartner?: { id: string, secondaryId: number, cityId?: string | null, name: string, contactPerson?: string | null, phoneNumber?: string | null, email?: string | null, websiteUrl?: string | null, address?: string | null, taxId?: string | null, type: PartnerType, status: Status, createdAt?: any | null, updatedAt?: any | null, city?: { id?: string | null, country?: { id?: string | null } | null } | null } | null };

export type GetPlatformFeeConfigsQueryVariables = Exact<{
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
  limit: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
}>;


export type GetPlatformFeeConfigsQuery = { getPlatformFeeConfigs: { data: Array<{ createdAt: any, id: string, name: string, orderType: string, platformFeeAccountCode?: string | null, platformFeeTaxRate: number, platformFeeTaxable: boolean, platformFeeType: PlatformFeeType, platformFeeValue: number, updatedAt: any, status: Status, isRemovable: boolean }>, meta: { limit?: number | null, page?: number | null, total?: number | null, totalCount?: number | null } } };

export type GetPlatformFeeConfigQueryVariables = Exact<{
  getPlatformFeeConfigId: Scalars['String']['input'];
}>;


export type GetPlatformFeeConfigQuery = { getPlatformFeeConfig: { createdAt: any, id: string, name: string, orderType: string, platformFeeAccountCode?: string | null, platformFeeTaxRate: number, platformFeeTaxable: boolean, platformFeeType: PlatformFeeType, platformFeeValue: number, updatedAt: any, status: Status, isRemovable: boolean } };

export type CreatePlatformFeeConfigMutationVariables = Exact<{
  createPlatformFeeConfigInput: CreatePlatformFeeConfigDto;
}>;


export type CreatePlatformFeeConfigMutation = { createPlatformFeeConfig: { id: string } };

export type UpdatePlatformFeeConfigMutationVariables = Exact<{
  updatePlatformFeeConfigInput: UpdatePlatformFeeConfigDto;
}>;


export type UpdatePlatformFeeConfigMutation = { updatePlatformFeeConfig: { id: string } };

export type PosHeldOrdersQueryVariables = Exact<{
  input: PosHeldOrdersInput;
}>;


export type PosHeldOrdersQuery = { posHeldOrders: { meta: { page?: number | null, limit?: number | null, totalCount?: number | null }, data: Array<{ id: string, identifier: string, heldAt: any, customerName: string, phone: string, totalAmount: number, quantity: number, locationId: string, registerId: string, registerSessionId?: string | null, snapshot: any, createdBy?: string | null }> } };

export type HoldPosOrderMutationVariables = Exact<{
  input: HoldPosOrderInput;
}>;


export type HoldPosOrderMutation = { holdPosOrder: { id: string, identifier: string, heldAt: any, customerName: string, phone: string, totalAmount: number, quantity: number, locationId: string, registerId: string, registerSessionId?: string | null } };

export type ReleasePosOrderMutationVariables = Exact<{
  input: ReleasePosOrderInput;
}>;


export type ReleasePosOrderMutation = { releasePosOrder: { snapshot: any, releasedOrder?: { id: string, identifier: string } | null } };

export type CreatePrinterConfigMutationVariables = Exact<{
  createPrinterConfigDto: CreatePrinterConfigDto;
}>;


export type CreatePrinterConfigMutation = { createPrinterConfig: { id: string } };

export type UpdatePrinterConfigMutationVariables = Exact<{
  updatePrinterConfigDto: UpdatePrinterConfigDto;
}>;


export type UpdatePrinterConfigMutation = { updatePrinterConfig: { id: string } };

export type DeletePrinterConfigMutationVariables = Exact<{
  deletePrinterConfigId: Scalars['String']['input'];
}>;


export type DeletePrinterConfigMutation = { deletePrinterConfig: boolean };

export type GetPrinterConfigsQueryVariables = Exact<{
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPrinterConfigsQuery = { getPrinterConfigs: { data: Array<{ id: string, name: string, isDefault: boolean, columns: number, columnGap: number, labelWidth: number, labelHeight: number, marginTop: number, marginBottom: number, marginLeft: number, marginRight: number, padding: number, qrCodeSize: number, qrCodeMarginRight: number, qrCodeAlignment: string, productNameFontSize: number, batchNumberFontSize: number, expiryFontSize: number, textAlignment: string, productNameWrap: string, productNameMaxLines: number, zoom: number, orientation: string, userId: string }>, meta: { page?: number | null, limit?: number | null, totalCount?: number | null, total?: number | null } } };

export type GetPrinterConfigQueryVariables = Exact<{
  getPrinterConfigId: Scalars['String']['input'];
}>;


export type GetPrinterConfigQuery = { getPrinterConfig: { id: string, name: string, isDefault: boolean, columns: number, columnGap: number, labelWidth: number, labelHeight: number, marginTop: number, marginBottom: number, marginLeft: number, marginRight: number, padding: number, qrCodeSize: number, qrCodeMarginRight: number, qrCodeAlignment: string, productNameFontSize: number, batchNumberFontSize: number, expiryFontSize: number, textAlignment: string, productNameWrap: string, productNameMaxLines: number, zoom: number, orientation: string, userId: string } };

export type GetProductManufacturingPricesQueryVariables = Exact<{
  productId: Scalars['String']['input'];
}>;


export type GetProductManufacturingPricesQuery = { getProductManufacturingPrices: Array<{ id: string, secondaryId?: number | null, productId: string, effectiveFrom: any, effectiveTo?: any | null, tradePriceOutward: number, maximumRetailPrice: number, taxRate: number, updatedAt: any }> };

export type CreateProductManufacturingPriceMutationVariables = Exact<{
  input: CreateProductManufacturingPriceDto;
}>;


export type CreateProductManufacturingPriceMutation = { createProductManufacturingPrice: { id: string, effectiveFrom: any, effectiveTo?: any | null } };

export type UpdateProductManufacturingPriceMutationVariables = Exact<{
  input: UpdateProductManufacturingPriceDto;
}>;


export type UpdateProductManufacturingPriceMutation = { updateProductManufacturingPrice: { id: string, effectiveFrom: any, effectiveTo?: any | null } };

export type ProductSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductSummaryQuery = { productSummary: { totalProductsCount: number, activeProductsCount: number, inactiveProductsCount: number } };

export type GetTaxGroupsQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
  page: Scalars['Int']['input'];
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
}>;


export type GetTaxGroupsQuery = { getTaxGroups: { data: Array<{ id: string, name: string, taxPercentage: number }> } };

export type CreateTaxGroupMutationVariables = Exact<{
  createTaxGroupDto: CreateTaxGroupDto;
}>;


export type CreateTaxGroupMutation = { createTaxGroup: { id: string, name: string, taxPercentage: number } };

export type GetGenericFormulasQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
}>;


export type GetGenericFormulasQuery = { getGenericFormulas: { data: Array<{ id: string, name: string, status: string }>, meta: { limit?: number | null, page?: number | null, totalCount?: number | null } } };

export type CreateGenericFormulaMutationVariables = Exact<{
  createGenericFormulaDto: CreateGenericFormulaDto;
}>;


export type CreateGenericFormulaMutation = { createGenericFormula: { id: string, name: string, status: string } };

export type CreateProductMutationVariables = Exact<{
  createProductDto: CreateProductDto;
}>;


export type CreateProductMutation = { createProduct: { id?: string | null, name?: string | null } };

export type UpdateProductMutationVariables = Exact<{
  updateProductDto: UpdateProductDto;
}>;


export type UpdateProductMutation = { updateProduct: { id?: string | null, name?: string | null, gtin?: string | null, trackingLevel?: TrackingLevel | null, isManufacturerTracking?: boolean | null } };

export type GetProductsListingQueryVariables = Exact<{
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
}>;


export type GetProductsListingQuery = { getProducts: { data: Array<{ id?: string | null, secondaryId?: number | null, itemReleaseChannels?: Array<string> | null, maximumRetailPrice?: number | null, maximumRetailUnitPrice?: number | null, name?: string | null, status: Status, tradePrice?: number | null, purchasingPrice?: number | null, activeLotsCount?: number | null, images?: Array<string> | null, manufacturer?: { id?: string | null, name?: string | null } | null }>, meta: { limit?: number | null, page?: number | null, totalCount?: number | null } } };

export type GetSearchProductForPoQueryVariables = Exact<{
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
}>;


export type GetSearchProductForPoQuery = { getProducts: { data: Array<{ id?: string | null, name?: string | null, vendors?: Array<{ id: string, name?: string | null }> | null }>, meta: { limit?: number | null, page?: number | null, totalCount?: number | null } } };

export type GetProductsForOptionsQueryVariables = Exact<{
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
  locationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetProductsForOptionsQuery = { getProducts: { data: Array<{ id?: string | null, secondaryId?: number | null, name?: string | null, maximumRetailUnitPrice?: number | null, sellingUnit?: UomUnit | null }>, meta: { limit?: number | null, page?: number | null, totalCount?: number | null } } };

export type GetProductsWithTagsQueryVariables = Exact<{
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
  locationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetProductsWithTagsQuery = { getProducts: { data: Array<{ id?: string | null, secondaryId?: number | null, name?: string | null, maximumRetailUnitPrice?: number | null, tags?: Array<{ id: string, name: string }> | null }>, meta: { limit?: number | null, page?: number | null, totalCount?: number | null } } };

export type GetProductsIdOnlyQueryVariables = Exact<{
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
  locationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetProductsIdOnlyQuery = { getProducts: { data: Array<{ id?: string | null, secondaryId?: number | null, name?: string | null, purchasingPrice?: number | null }>, meta: { totalCount?: number | null } } };

export type GetProductsByVendorQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  vendorId: Scalars['String']['input'];
}>;


export type GetProductsByVendorQuery = { getProductsByVendor: { data: Array<{ id?: string | null, secondaryId?: number | null, name?: string | null, tradePrice?: number | null, tradeDiscount?: number | null, buyingUnit?: UomUnit | null, isManufacturerTracking?: boolean | null, trackingLevel?: TrackingLevel | null, manufacturer?: { id?: string | null, name?: string | null } | null, taxGroup?: { taxPercentage: number, name: string, id: string } | null }> } };

export type GetProductQueryVariables = Exact<{
  getProductId: Scalars['String']['input'];
}>;


export type GetProductQuery = { getProduct: { description?: string | null, discountPercentage?: number | null, dosageInstruction?: string | null, drugRegulatorId?: number | null, gtin?: string | null, id?: string | null, images?: Array<string> | null, itemNature?: string | null, itemReleaseChannels?: Array<string> | null, lastUpdatedBy?: string | null, margins?: number | null, maximumRetailPrice?: number | null, maximumRetailUnitPrice?: number | null, name?: string | null, prescriptionRequired?: boolean | null, purchasingPrice?: number | null, seoDescription?: string | null, seoTitle?: string | null, sellingUnit?: UomUnit | null, buyingUnit?: UomUnit | null, seoUrl?: string | null, sideEffects?: string | null, trackingLevel?: TrackingLevel | null, isManufacturerTracking?: boolean | null, skuCode?: string | null, skuDepartment?: string | null, skuMaximumLevel?: number | null, skuMinimumLevel?: number | null, skuReorderLevel?: number | null, skuWarehouseLeadTime?: number | null, sorting?: number | null, status: Status, stockNature?: StockNature | null, taxCode?: string | null, taxGroupId?: string | null, tradeDiscount?: number | null, tradePrice?: number | null, tradePriceOutward?: number | null, isDiscountApplicableOnTax?: boolean | null, isTaxInclusive?: boolean | null, sellingTaxRate?: number | null, isSellable: boolean, isPurchasable: boolean, isManufacturable: boolean, uomType: UomType, weightGrams?: number | null, lengthCm?: number | null, widthCm?: number | null, heightCm?: number | null, taxGroup?: { id: string, name: string, status: string, taxPercentage: number } | null, tags?: Array<{ id: string, name: string, status: string }> | null, manufacturer?: { description?: string | null, id?: string | null, lastReason?: string | null, lineOfBusiness?: Array<string> | null, name?: string | null, status?: string | null } | null, conversions: Array<{ id?: string | null, itemConversion: number, sellingUnit: UomUnit, sorting: number, productId?: string | null }>, categories?: Array<{ banner_image?: string | null, categoryIcon?: string | null, comment?: string | null, description?: string | null, id: string, imageUrl?: string | null, level?: number | null, name: string, parentId?: string | null, status: string, parentCategory?: { id: string, name: string, level?: number | null } | null }> | null, genericFormula?: Array<{ id: string, name: string, status: string }> | null, vendors?: Array<{ name?: string | null, type?: Array<string> | null, id: string }> | null } };

export type GetProductLotForTransferQueryVariables = Exact<{
  locationId: Scalars['String']['input'];
  anyOneActionIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  actionId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetProductLotForTransferQuery = { getProductLot: { isOpened?: boolean | null, status: ProductLotStatus, id: string, baseQuantity?: number | null, actionId?: string | null, product: { id?: string | null, secondaryId?: number | null, name?: string | null } } };

export type GetBulkProductLotForTransferQueryVariables = Exact<{
  locationId: Scalars['String']['input'];
  actionIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  anyOneActionIds?: InputMaybe<Array<Array<Scalars['String']['input']> | Scalars['String']['input']> | Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetBulkProductLotForTransferQuery = { getBulkProductLots: { errors: Array<{ message: string, actionId: string }>, results: Array<{ isOpened?: boolean | null, status: ProductLotStatus, id: string, baseQuantity?: number | null, actionId?: string | null, product: { id?: string | null, secondaryId?: number | null, name?: string | null } }> } };

export type GetProductLotsForBarcodesQueryVariables = Exact<{
  locationId?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
}>;


export type GetProductLotsForBarcodesQuery = { getProductLots: Array<{ id: string, actionId?: string | null, batchExpiry?: string | null, batchNumber?: string | null, mfgDate?: string | null, tradePrice?: number | null, mrpSellingUnit?: number | null, gstValue?: number | null, baseQuantity?: number | null, sellableQuantity?: number | null, grnItem?: { manufacturerCode?: string | null } | null, product: { name?: string | null } }> };

export type GetProductLotQueryVariables = Exact<{
  actionId?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['String']['input'];
  anyOneActionIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetProductLotQuery = { getProductLot: { id: string, status: ProductLotStatus, actionId?: string | null, purchasingPrice?: number | null, mrpSellingUnit?: number | null, sellableQuantity?: number | null, batchExpiry?: string | null, product: { id?: string | null, secondaryId?: number | null, name?: string | null, maximumRetailPrice?: number | null, images?: Array<string> | null } } };

export type BulkValidateProductLotsQueryVariables = Exact<{
  locationId: Scalars['String']['input'];
  scanProductLots: Array<ScanProductLotInput> | ScanProductLotInput;
}>;


export type BulkValidateProductLotsQuery = { bulkValidateProductLots: Array<{ id?: string | null, status: ScanStatus, actionId?: string | null, purchasingPrice?: number | null, mrpSellingUnit?: number | null, sellableQuantity?: number | null, batchExpiry?: string | null, cartQuantity?: number | null, product: { id?: string | null, secondaryId?: number | null, name?: string | null, maximumRetailPrice?: number | null, images?: Array<string> | null } }> };

export type GetProductLotForStockReturnQueryVariables = Exact<{
  actionId?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['String']['input'];
  anyOneActionIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetProductLotForStockReturnQuery = { getProductLot: { id: string, actionId?: string | null, isOpened?: boolean | null, status: ProductLotStatus, baseQuantity?: number | null, product: { id?: string | null, secondaryId?: number | null, name?: string | null }, grnItem?: { purchaseOrderItem?: { purchaseOrder?: { vendor: { id: string, secondaryId?: number | null, name?: string | null } } | null } | null } | null } };

export type GetUnexpiredProductLotsQueryVariables = Exact<{
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
  page: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
}>;


export type GetUnexpiredProductLotsQuery = { getUnexpiredProductLots: Array<{ actionId?: string | null, id: string, batchNumber?: string | null, batchExpiry?: string | null, purchasingPrice?: number | null, mrpSellingUnit?: number | null, taxSellingUnit?: number | null, baseQuantity?: number | null, sellableQuantity?: number | null }> };

export type GetBaseQuantityByProductAndLocationQueryVariables = Exact<{
  productId: Scalars['String']['input'];
}>;


export type GetBaseQuantityByProductAndLocationQuery = { getBaseQuantityByProductAndLocation: Array<{ locationId: string, locationName: string, totalBaseQuantity: number, totalSellableQuantity: number }> };

export type GetProductionPlansQueryVariables = Exact<{
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
}>;


export type GetProductionPlansQuery = { getProductionPlans: { meta: { total?: number | null, page?: number | null, limit?: number | null }, data: Array<{ id: string, secondaryId?: number | null, planCode: string, status: ProductionPlanStatus, productionLocationId: string, sourceLocationId: string, plannedStartDate?: any | null, plannedEndDate?: any | null, demandNoteId?: string | null, notes?: string | null, cancellationReason?: string | null, approvedBy?: string | null, approvedAt?: any | null, issuanceRequestedBy?: string | null, issuanceRequestedAt?: any | null, createdAt: any, productionLocation?: { id: string, name: string } | null, sourceLocation?: { id: string, name: string } | null }> } };

export type GetProductionPlanQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetProductionPlanQuery = { getProductionPlan: { id: string, secondaryId?: number | null, planCode: string, status: ProductionPlanStatus, plannedStartDate?: any | null, plannedEndDate?: any | null, notes?: string | null, cancellationReason?: string | null, approvedBy?: string | null, approvedAt?: any | null, issuanceRequestedBy?: string | null, issuanceRequestedAt?: any | null, productionLocation?: { id: string, name: string } | null, sourceLocation?: { id: string, name: string } | null, productionLines?: Array<{ id: string, secondaryId?: number | null, outputProductId: string, bomVersionId: string, multiplierFactor: number, plannedQty: number, outputProduct?: { id?: string | null, name?: string | null, trackingLevel?: TrackingLevel | null } | null, bomVersion?: { id: string, versionNo: number, versionLabel?: string | null, batchQuantity: number } | null, materialLines?: Array<{ id: string, componentProductId: string, requiredQty: number, isMandatory: boolean, componentProduct?: { id?: string | null, name?: string | null } | null }> | null }> | null, demandNote?: { secondaryId?: number | null, id: string } | null } };

export type CreateProductionPlanMutationVariables = Exact<{
  dto: CreateProductionPlanDto;
}>;


export type CreateProductionPlanMutation = { createProductionPlan: { id: string, planCode: string, status: ProductionPlanStatus } };

export type UpdateProductionPlanMutationVariables = Exact<{
  dto: UpdateProductionPlanDto;
}>;


export type UpdateProductionPlanMutation = { updateProductionPlan: { id: string, status: ProductionPlanStatus } };

export type AddProductionLineMutationVariables = Exact<{
  dto: AddProductionLineDto;
}>;


export type AddProductionLineMutation = { addProductionLine: { id: string, plannedQty: number, materialLines?: Array<{ id: string, componentProductId: string, requiredQty: number, isMandatory: boolean }> | null } };

export type UpdateProductionLineMutationVariables = Exact<{
  dto: UpdateProductionLineDto;
}>;


export type UpdateProductionLineMutation = { updateProductionLine: { id: string, plannedQty: number, multiplierFactor: number } };

export type RemoveProductionLineMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RemoveProductionLineMutation = { removeProductionLine: boolean };

export type SubmitProductionPlanForApprovalMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type SubmitProductionPlanForApprovalMutation = { submitProductionPlanForApproval: { id: string, status: ProductionPlanStatus } };

export type ApproveProductionPlanMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ApproveProductionPlanMutation = { approveProductionPlan: { id: string, status: ProductionPlanStatus, approvedBy?: string | null, approvedAt?: any | null } };

export type RequestProductionPlanIssuanceMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RequestProductionPlanIssuanceMutation = { requestProductionPlanIssuance: { id: string, status: ProductionPlanStatus, demandNoteId?: string | null, issuanceRequestedBy?: string | null, issuanceRequestedAt?: any | null } };

export type CancelProductionPlanMutationVariables = Exact<{
  id: Scalars['String']['input'];
  cancellationReason: Scalars['String']['input'];
}>;


export type CancelProductionPlanMutation = { cancelProductionPlan: { id: string, status: ProductionPlanStatus, cancellationReason?: string | null } };

export type GetProductionOrdersQueryVariables = Exact<{
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
}>;


export type GetProductionOrdersQuery = { getProductionOrders: { meta: { total?: number | null, page?: number | null, limit?: number | null }, data: Array<{ id: string, secondaryId?: number | null, orderCode: string, status: ProductionOrderStatus, productionPlanId?: string | null, plannedQty: number, totalProducedQuantity: number, totalAdjustment: number, qcPassedQty?: number | null, qcRejectedQty?: number | null, createdAt: any, productionPlan?: { id: string, planCode: string } | null, outputProduct?: { id?: string | null, name?: string | null, trackingLevel?: TrackingLevel | null } | null, location?: { id: string, name: string } | null }> } };

export type GetProductionOrderQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetProductionOrderQuery = { getProductionOrder: { id: string, secondaryId?: number | null, orderCode: string, status: ProductionOrderStatus, productionPlanId?: string | null, productionLineId?: string | null, bomVersionId: string, plannedQty: number, totalProducedQuantity: number, totalAdjustment: number, manufacturingCostPerUnit?: number | null, qcPassedQty?: number | null, qcRejectedQty?: number | null, qcNotes?: string | null, qcBy?: string | null, qcAt?: any | null, notes?: string | null, cancellationReason?: string | null, completedAt?: any | null, completedBy?: string | null, productionPlan?: { id: string, planCode: string, status: ProductionPlanStatus } | null, bomVersion?: { id: string, versionNo: number, versionLabel?: string | null, batchQuantity: number } | null, outputProduct?: { id?: string | null, name?: string | null, trackingLevel?: TrackingLevel | null } | null, location?: { id: string, name: string } | null, batches?: Array<{ id: string, batchNumber: string, standardQuantity: number, adjustmentDirection?: AdjustmentDirection | null, adjustmentQuantity?: number | null, qcStatus: BatchQcStatus, qcRejectedQty?: number | null, qcNotes?: string | null, qcBy?: string | null, qcAt?: any | null, submittedToQcBy?: string | null, submittedToQcAt?: any | null }> | null, materials?: Array<{ id: string, componentProductId: string, plannedQty: number, actualQty?: number | null, isMandatory: boolean, isOverridden: boolean, componentProduct?: { id?: string | null, name?: string | null } | null, lots?: Array<{ id: string, productLotId: string, quantity: number, productLot?: { id: string, actionId?: string | null, sellableQuantity?: number | null, batchExpiry?: string | null } | null }> | null }> | null } };

export type GetProductionPlanMaterialReferenceQueryVariables = Exact<{
  productionOrderId: Scalars['String']['input'];
}>;


export type GetProductionPlanMaterialReferenceQuery = { getProductionPlanMaterialReference: Array<{ id: string, componentProductId: string, requiredQty: number, isMandatory: boolean, componentProduct?: { id?: string | null, name?: string | null } | null }> };

export type CreateProductionOrderMutationVariables = Exact<{
  dto: CreateProductionOrderDto;
}>;


export type CreateProductionOrderMutation = { createProductionOrder: { id: string, orderCode: string, status: ProductionOrderStatus, plannedQty: number, batches?: Array<{ id: string, batchNumber: string, standardQuantity: number }> | null, materials?: Array<{ id: string, componentProductId: string, plannedQty: number }> | null } };

export type UpdateProductionOrderMutationVariables = Exact<{
  dto: UpdateProductionOrderDto;
}>;


export type UpdateProductionOrderMutation = { updateProductionOrder: { id: string, notes?: string | null } };

export type UpdateProductionOrderBatchMutationVariables = Exact<{
  dto: UpdateProductionOrderBatchDto;
}>;


export type UpdateProductionOrderBatchMutation = { updateProductionOrderBatch: { id: string, adjustmentDirection?: AdjustmentDirection | null, adjustmentQuantity?: number | null } };

export type UpdateProductionOrderMaterialMutationVariables = Exact<{
  dto: UpdateProductionOrderMaterialDto;
}>;


export type UpdateProductionOrderMaterialMutation = { updateProductionOrderMaterial: { id: string, actualQty?: number | null, isOverridden: boolean, lots?: Array<{ id: string, productLotId: string, quantity: number }> | null } };

export type SubmitProductionOrderToQcMutationVariables = Exact<{
  dto: SubmitToQcDto;
}>;


export type SubmitProductionOrderToQcMutation = { submitProductionOrderToQc: { id: string, status: ProductionOrderStatus, manufacturingCostPerUnit?: number | null, batches?: Array<{ id: string, qcStatus: BatchQcStatus }> | null } };

export type ApproveProductionOrderQcBatchesMutationVariables = Exact<{
  dto: ApproveQcBatchDto;
}>;


export type ApproveProductionOrderQcBatchesMutation = { approveProductionOrderQcBatches: { id: string, status: ProductionOrderStatus, qcPassedQty?: number | null, qcRejectedQty?: number | null, batches?: Array<{ id: string, qcStatus: BatchQcStatus, qcRejectedQty?: number | null }> | null } };

export type ApproveProductionOrderQcBatchesSerialMutationVariables = Exact<{
  dto: ApproveQcSerialDto;
}>;


export type ApproveProductionOrderQcBatchesSerialMutation = { approveProductionOrderQcBatchesSerial: { id: string, status: ProductionOrderStatus, qcPassedQty?: number | null, qcRejectedQty?: number | null, batches?: Array<{ id: string, qcStatus: BatchQcStatus, qcRejectedQty?: number | null }> | null } };

export type CancelProductionOrderMutationVariables = Exact<{
  id: Scalars['String']['input'];
  cancellationReason: Scalars['String']['input'];
}>;


export type CancelProductionOrderMutation = { cancelProductionOrder: { id: string, status: ProductionOrderStatus, cancellationReason?: string | null } };

export type PurchaseOrderSummaryQueryVariables = Exact<{
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
}>;


export type PurchaseOrderSummaryQuery = { purchaseOrderSummary: { purchaseOrder: number, amount: number, pending: number, partial: number, fulfilled: number } };

export type CreatePurchaseOrderMutationVariables = Exact<{
  createPurchaseOrderDto: CreatePurchaseOrderDto;
}>;


export type CreatePurchaseOrderMutation = { createPurchaseOrder: { id?: string | null, orderType: PurchaseOrderType, poType?: string | null, status: PurchaseOrderStatusApproval } };

export type ClosePurchaseOrderMutationVariables = Exact<{
  closePurchaseOrderId: Scalars['String']['input'];
}>;


export type ClosePurchaseOrderMutation = { closePurchaseOrder: { id?: string | null } };

export type GetPurchaseOrdersListingQueryVariables = Exact<{
  locationId: Scalars['String']['input'];
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
}>;


export type GetPurchaseOrdersListingQuery = { getPurchaseOrders: { data: Array<{ id?: string | null, secondaryId?: number | null, netAmount?: number | null, orderType: PurchaseOrderType, salesTax?: number | null, status: PurchaseOrderStatusApproval, totalAmount?: number | null, totalDiscount?: number | null, createdAt?: any | null, createdByName?: string | null, updatedAt?: any | null, vendor: { id: string, name?: string | null }, deliveryLocation: { id: string, name: string } }>, meta: { totalCount?: number | null, page?: number | null, limit?: number | null } } };

export type GetPurchaseOrderForCreateGrnQueryVariables = Exact<{
  secondaryId: Scalars['Int']['input'];
}>;


export type GetPurchaseOrderForCreateGrnQuery = { getPurchaseOrder: { id?: string | null, secondaryId?: number | null, status: PurchaseOrderStatusApproval, createdAt?: any | null, orderItems: Array<{ id?: string | null, secondaryId?: number | null, foc?: boolean | null, grnRemainingQuantity?: number | null, gstPercentage?: number | null, itemConversion?: number | null, requiredQuantity?: number | null, salesTaxPercentage?: number | null, totalPrice?: number | null, tradeDiscountPercentage?: number | null, tradeDiscountValue?: number | null, tradePrice?: number | null, tradePriceAfterApplyingGst?: number | null, tradePriceAfterTradeDiscount?: number | null, product: { id?: string | null, name?: string | null, secondaryId?: number | null, uomFactor?: number | null, isManufacturerTracking?: boolean | null, trackingLevel?: TrackingLevel | null, gtin?: string | null, manufacturer?: { name?: string | null } | null } }>, vendor: { id: string, secondaryId?: number | null, name?: string | null } } };

export type GetPurchaseOrderDetailsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetPurchaseOrderDetailsQuery = { getPurchaseOrder: { id?: string | null, expectedDeliveryDate?: any | null, netAmount?: number | null, orderType: PurchaseOrderType, returnRfid?: string | null, salesTax?: number | null, status: PurchaseOrderStatusApproval, totalAmount?: number | null, totalDiscount?: number | null, additionalTerms?: string | null, createdAt?: any | null, createdByName?: string | null, designation?: string | null, secondaryId?: number | null, orderItems: Array<{ foc?: boolean | null, grnRemainingQuantity?: number | null, gstPercentage?: number | null, id?: string | null, itemConversion?: number | null, requiredQuantity?: number | null, gstAmount?: number | null, totalPrice?: number | null, tradeDiscountPercentage?: number | null, tradeDiscountValue?: number | null, tradePrice?: number | null, tradePriceAfterApplyingGst?: number | null, tradePriceAfterTradeDiscount?: number | null, uom?: string | null, product: { id?: string | null, name?: string | null, secondaryId?: number | null, manufacturer?: { id?: string | null, name?: string | null } | null } }>, deliveryLocation: { id: string, name: string }, vendor: { id: string, name?: string | null } } };

export type GetLocationRegistersQueryVariables = Exact<{
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
  page: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
}>;


export type GetLocationRegistersQuery = { getLocationRegisters: Array<{ id: string, name: string, lastClosedAt?: any | null, lastOpenedAt?: any | null, type: LocationRegisterType, secondaryId?: number | null, status?: string | null, lastClosedBy?: { id: string, lastName?: string | null, firstName?: string | null } | null, lastOpenedBy?: { lastName?: string | null, id: string, firstName?: string | null } | null, session?: { id: string, balance?: number | null, status?: string | null } | null }> };

export type GetLocationRegistersForListQueryVariables = Exact<{
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
  limit: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
}>;


export type GetLocationRegistersForListQuery = { getLocationRegisters: Array<{ createdAt?: any | null, currency?: CurrencyTypeEnum | null, id: string, name: string, printMode?: PrintModeType | null, secondaryId?: number | null, status?: string | null, terminalTaxId?: string | null, type: LocationRegisterType, updatedAt?: any | null }> };

export type GetLocationRegisterQueryVariables = Exact<{
  getLocationRegisterId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
}>;


export type GetLocationRegisterQuery = { getLocationRegister: { id: string, name: string, secondaryId?: number | null, printMode?: PrintModeType | null, status?: string | null, type: LocationRegisterType, receiptTemplate?: ReceiptTemplateType | null, lastClosedAt?: any | null, lastOpenedAt?: any | null, currency?: CurrencyTypeEnum | null, terminalTaxId?: string | null, lastClosedBy?: { id: string, lastName?: string | null, firstName?: string | null } | null, lastOpenedBy?: { lastName?: string | null, id: string, firstName?: string | null } | null, session?: { id: string, balance?: number | null, status?: string | null, note?: string | null, openingAmount?: number | null, secondaryId?: number | null, isAmountMatched?: boolean | null } | null, location?: { name: string, id: string } | null } };

export type OpenLocationRegisterMutationVariables = Exact<{
  createLocationRegisterSessionDto: CreateLocationRegisterSessionDto;
  registerId: Scalars['String']['input'];
}>;


export type OpenLocationRegisterMutation = { openLocationRegister: { id: string } };

export type CloseLocationRegisterMutationVariables = Exact<{
  closeLocationRegisterSessionDto: CloseLocationRegisterSessionDto;
  registerSessionId: Scalars['String']['input'];
}>;


export type CloseLocationRegisterMutation = { closeLocationRegister: { id: string } };

export type GetLocationSessionSummaryByIdQueryVariables = Exact<{
  sessionId: Scalars['String']['input'];
}>;


export type GetLocationSessionSummaryByIdQuery = { getLocationSessionSummaryById: Array<{ discount: number, gross: number, orderCount: number, paymentMethod: PaymentMethod, netAmount: number, returned: number, netSale: number, tax: number }> };

export type GetZReportByLocationAndDateQueryVariables = Exact<{
  endDate: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
}>;


export type GetZReportByLocationAndDateQuery = { getZReportByLocationAndDate: Array<{ discount: number, gross: number, netAmount: number, netSale: number, orderCount: number, paymentMethod: PaymentMethod, returned: number, tax: number, integrationCharges: number, platformFee: number, shippingFee: number }> };

export type GetLocationRegisterSessionsQueryVariables = Exact<{
  registerId?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
  limit: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
}>;


export type GetLocationRegisterSessionsQuery = { getLocationRegisterSessions: { meta: { limit?: number | null, page?: number | null, totalCount?: number | null }, data: Array<{ id: string, secondaryId?: number | null, balance?: number | null, closedAt?: any | null, closingAmount?: number | null, isAmountMatched?: boolean | null, openedAt?: any | null, openingAmount?: number | null, status?: string | null, register?: { name: string } | null, closedBy?: { firstName?: string | null, lastName?: string | null } | null, openedBy?: { lastName?: string | null, firstName?: string | null } | null }> } };

export type GetLocationRegisterBalanceHistoryBySessionIdQueryVariables = Exact<{
  sessionId: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
}>;


export type GetLocationRegisterBalanceHistoryBySessionIdQuery = { getLocationRegisterBalanceHistoryBySessionId: { data: Array<{ amount?: number | null, createdAt?: any | null, id: string, note?: string | null }>, meta: { limit?: number | null, page?: number | null, total?: number | null, totalCount?: number | null } } };

export type GetRegisterSummaryByIdQueryVariables = Exact<{
  sessionId: Scalars['String']['input'];
}>;


export type GetRegisterSummaryByIdQuery = { getRegisterSummaryById: { balance: number, closingAmount: number, id: string, openingAmount: number, returnTotalAmount: number, totalAdditions: number, totalAmount: number, totalDiscount: number, totalWithdrawals: number, cashRefundTotal: number } };

export type CreateLocationRegisterMutationVariables = Exact<{
  createLocationRegisterDto: CreateLocationRegisterDto;
}>;


export type CreateLocationRegisterMutation = { createLocationRegister: { id: string } };

export type UpdateLocationRegisterMutationVariables = Exact<{
  updateLocationRegisterDto: UpdateLocationRegisterDto;
}>;


export type UpdateLocationRegisterMutation = { updateLocationRegister: { id: string } };

export type GetLocationRegistersForOptionsQueryVariables = Exact<{
  locationId?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
}>;


export type GetLocationRegistersForOptionsQuery = { getLocationRegisters: Array<{ name: string, id: string }> };

export type AddWithdrawRegisterBalanceMutationVariables = Exact<{
  registerSessionId: Scalars['String']['input'];
  registerBalanceDto: AddWithdrawBalanceLocationRegisterSession;
}>;


export type AddWithdrawRegisterBalanceMutation = { addWithdrawRegisterBalance: { id: string, balance?: number | null } };

export type GetProductLotStockReportQueryVariables = Exact<{
  productStockReportDto: ProductStockReportArgs;
}>;


export type GetProductLotStockReportQuery = { getProductLotStockReport: { data: Array<{ productId: string, productSecondaryId?: number | null, productName: string, manufacturerName: string, categoryNames?: Array<string> | null, buyingUnit: string, sellingUnit: string, uomFactor?: number | null, taxRate: string, locationName: string, purchasingPrice: number, tradePrice: number, maximumRetailPrice: number, packedStock: number, packedSellableQuantity: number, packedStockValue?: number | null, looseStock: number, looseSellableQuantity: number, looseStockValue: number, totalStockQuantity: number, totalStockValue: number, totalTax: number, totalStockValueExcludingTax: number, inTransitStock: number, inTransitQuantity: number, inTransitStockValue: number }>, meta: { limit?: number | null, page?: number | null, totalCount?: number | null } } };

export type GetRolesQueryVariables = Exact<{
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
  limit: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
}>;


export type GetRolesQuery = { getRoles: { data: Array<{ createdAt?: any | null, id: string, name?: string | null, secondaryId?: number | null, status?: Status | null, updatedAt?: any | null }>, meta: { limit?: number | null, page?: number | null, total?: number | null, totalCount?: number | null } } };

export type GetPermissionsQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
}>;


export type GetPermissionsQuery = { getPermissions: { data: Array<{ action?: string | null, createdAt?: any | null, id: string, module?: string | null, permission?: string | null, status?: Status | null, subModule?: string | null, updatedAt?: any | null }>, meta: { limit?: number | null, page?: number | null, total?: number | null, totalCount?: number | null } } };

export type CreateRoleMutationVariables = Exact<{
  roleInputDto: RoleInputDto;
}>;


export type CreateRoleMutation = { createRole: { id: string, status?: Status | null, name?: string | null } };

export type UpdateRoleMutationVariables = Exact<{
  updateRoleId: Scalars['String']['input'];
  roleInputDto: RoleInputDto;
}>;


export type UpdateRoleMutation = { updateRole: boolean };

export type GetRoleQueryVariables = Exact<{
  getRoleId: Scalars['String']['input'];
}>;


export type GetRoleQuery = { getRole: { name?: string | null, status?: Status | null, id: string } };

export type GetPermissionByRoleIdQueryVariables = Exact<{
  roleId: Scalars['String']['input'];
}>;


export type GetPermissionByRoleIdQuery = { getPermissionByRoleId: Array<{ action?: string | null, createdAt?: any | null, id: string, module?: string | null, permission?: string | null, status?: Status | null, subModule?: string | null, updatedAt?: any | null }> };

export type GetPermissionandandRoleByIdQueryVariables = Exact<{
  roleId: Scalars['String']['input'];
}>;


export type GetPermissionandandRoleByIdQuery = { roles: { name?: string | null, status?: Status | null, id: string }, permissions: Array<{ action?: string | null, createdAt?: any | null, id: string, module?: string | null, permission?: string | null, status?: Status | null, subModule?: string | null, updatedAt?: any | null }> };

export type AddOrRemovePermissionsByRoleIdMutationVariables = Exact<{
  roleId: Scalars['String']['input'];
  permissionIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type AddOrRemovePermissionsByRoleIdMutation = { addOrRemovePermissionsByRoleId: boolean };

export type UploadStockOperationItemImportMutationVariables = Exact<{
  stockOperationId: Scalars['String']['input'];
  fileType: StockOperationImportFileType;
  fileBase64: Scalars['String']['input'];
}>;


export type UploadStockOperationItemImportMutation = { uploadStockOperationItemImport: { id: string, status: StockOperationImportStatus } };

export type StockOperationItemImportJobQueryVariables = Exact<{
  importJobId: Scalars['String']['input'];
}>;


export type StockOperationItemImportJobQuery = { stockOperationItemImportJob: { id: string, status: StockOperationImportStatus, totalRows?: number | null, processedRows?: number | null, successCount?: number | null, errorCount?: number | null, failureReason?: string | null, errors?: Array<{ row: number, message: string, gtin?: string | null, secondaryId?: string | null, skuCode?: string | null, quantity?: number | null }> | null } };

export type GetAllStockOperationsQueryVariables = Exact<{
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
}>;


export type GetAllStockOperationsQuery = { getAllStockOperations: { meta: { limit?: number | null, page?: number | null, totalCount?: number | null }, data: Array<{ id: string, secondaryId?: number | null, operationType: StockOperationType, status: StockOperationStatus, remarks?: string | null, itemCount?: number | null, totalQuantity?: number | null, totalValue?: number | null, createdAt: any, confirmedAt?: any | null, location?: { id: string, name: string } | null }> } };

export type GetOneStockOperationQueryVariables = Exact<{
  stockOperationId: Scalars['String']['input'];
}>;


export type GetOneStockOperationQuery = { getOneStockOperation: { id: string, secondaryId?: number | null, operationType: StockOperationType, status: StockOperationStatus, remarks?: string | null, itemCount?: number | null, totalQuantity?: number | null, totalValue?: number | null, createdAt: any, confirmedAt?: any | null, location?: { id: string, name: string } | null, warehouse?: { id: string, name: string } | null, items?: Array<{ id: string, actionId?: string | null, productLotId?: string | null, trackingLevel: TrackingLevel, quantity: number, batchNumber?: string | null, batchExpiry?: string | null, mfgDate?: string | null, tradePrice?: number | null, gstValue?: number | null, mrp?: number | null, manufacturerCode?: string | null, isManufacturerTracking: boolean, uomFactor?: number | null, createdAt: any, productLot?: { id: string, actionId?: string | null } | null, product: { id?: string | null, name?: string | null, secondaryId?: number | null } }> | null } };

export type CreateStockOperationMutationVariables = Exact<{
  createStockOperationDto: CreateStockOperationDto;
}>;


export type CreateStockOperationMutation = { createStockOperation: { id: string, secondaryId?: number | null, status: StockOperationStatus, operationType: StockOperationType } };

export type AddStockOperationItemsMutationVariables = Exact<{
  addStockOperationItemsDto: Array<AddStockOperationItemDto> | AddStockOperationItemDto;
}>;


export type AddStockOperationItemsMutation = { addStockOperationItems: boolean };

export type UpdateStockOperationMutationVariables = Exact<{
  updateStockOperationDto: UpdateStockOperationDto;
}>;


export type UpdateStockOperationMutation = { updateStockOperation: { id: string, secondaryId?: number | null, operationType: StockOperationType, status: StockOperationStatus, remarks?: string | null, itemCount?: number | null, totalQuantity?: number | null, totalValue?: number | null, createdAt: any, confirmedAt?: any | null, location?: { id: string, name: string } | null, warehouse?: { id: string, name: string } | null } };

export type UpdateStockOperationItemMutationVariables = Exact<{
  updateStockOperationItemDto: UpdateStockOperationItemDto;
}>;


export type UpdateStockOperationItemMutation = { updateStockOperationItem: boolean };

export type RemoveStockOperationItemMutationVariables = Exact<{
  stockOperationItemId: Scalars['String']['input'];
}>;


export type RemoveStockOperationItemMutation = { removeStockOperationItem: boolean };

export type ConfirmStockOperationMutationVariables = Exact<{
  stockOperationId: Scalars['String']['input'];
}>;


export type ConfirmStockOperationMutation = { confirmStockOperation: boolean };

export type GetStockReturnsListQueryVariables = Exact<{
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
  limit: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
}>;


export type GetStockReturnsListQuery = { getStockReturns: { meta: { limit?: number | null, page?: number | null, total?: number | null, totalCount?: number | null }, data?: Array<{ createdAt?: any | null, gatePassNumber: string, id: string, secondaryId?: number | null, status: string, totalProducts?: number | null, totalQty?: number | null, totalValue?: number | null, updatedAt?: any | null, vendorId?: string | null, vendor: { id: string, secondaryId?: number | null, name?: string | null }, location: { name: string } }> | null } };

export type CreateStockReturnMutationVariables = Exact<{
  createStockReturnDto: CreateStockReturnDto;
}>;


export type CreateStockReturnMutation = { createStockReturn: { id: string } };

export type GetStockReturnForDetailsQueryVariables = Exact<{
  getStockReturnId: Scalars['String']['input'];
}>;


export type GetStockReturnForDetailsQuery = { getStockReturn: { createdAt?: any | null, id: string, gatePassNumber: string, secondaryId?: number | null, status: string, totalProducts?: number | null, totalQty?: number | null, totalValue?: number | null, vendor: { secondaryId?: number | null, name?: string | null }, returnItems: Array<{ quantity: number, value?: number | null, product: { secondaryId?: number | null, name?: string | null }, productLot: { actionId?: string | null } }> } };

export type GetPdfStockReturnQueryVariables = Exact<{
  getPdfStockReturnId: Scalars['String']['input'];
}>;


export type GetPdfStockReturnQuery = { getPDFStockReturn: { gatepass?: string | null, returnDate?: any | null, returnId: string, vendorName?: string | null, grandTotal?: number | null, createdByName?: string | null, designation?: string | null, returns?: Array<{ averagePurchasingPrice?: number | null, lotCount?: number | null, productId: string, productName?: string | null, totalPurchasingPrice?: number | null }> | null } };

export type GetTagsQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
}>;


export type GetTagsQuery = { getTags: { data: Array<{ id: string, name: string, status: string }>, meta: { limit?: number | null, page?: number | null, totalCount?: number | null } } };

export type CreateTagMutationVariables = Exact<{
  createTagDto: CreateTagDto;
}>;


export type CreateTagMutation = { createTag: { id: string, name: string, status: string } };

export type GetTransferListQueryVariables = Exact<{
  locationId: Scalars['String']['input'];
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
}>;


export type GetTransferListQuery = { getTransfers: { meta: { limit?: number | null, page?: number | null, totalCount?: number | null }, data: Array<{ id: string, secondaryId?: number | null, description?: string | null, expectedDeliveryDate: string, demandNoteId?: string | null, status: TransferStatus, demandNote?: { id: string, secondaryId?: number | null } | null, locationTo?: { id: string, name: string, type: LocationType } | null, locationFrom?: { id: string, name: string, type: LocationType } | null }> } };

export type CreateTransferMutationVariables = Exact<{
  createTransferDto: CreateTransferDto;
}>;


export type CreateTransferMutation = { createTransfer: { id: string } };

export type ReceiveTransferItemsMutationVariables = Exact<{
  receiveTransferItemsInput: ReceiveTransferItemsInput;
}>;


export type ReceiveTransferItemsMutation = { receiveTransferItems: boolean };

export type GetTransferReceivesListQueryVariables = Exact<{
  locationId: Scalars['String']['input'];
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
}>;


export type GetTransferReceivesListQuery = { getTransferReceives: { data: Array<{ id: string, secondaryId?: number | null, createdAt: any, description?: string | null, expectedDeliveryDate: string, demandNoteId?: string | null, status: TransferStatus, updatedAt: any, locationFrom?: { id: string, name: string, type: LocationType } | null, locationTo?: { id: string, name: string, type: LocationType } | null, demandNote?: { id: string, secondaryId?: number | null } | null }>, meta: { limit?: number | null, page?: number | null, totalCount?: number | null } } };

export type GetTransferForInvoiceQueryVariables = Exact<{
  getTransferId: Scalars['String']['input'];
}>;


export type GetTransferForInvoiceQuery = { getTransfer: { description?: string | null, expectedDeliveryDate: string, id: string, secondaryId?: number | null, demandNoteId?: string | null, status: TransferStatus, updatedAt: any, demandNote?: { id: string, secondaryId?: number | null } | null, locationFrom?: { name: string, id: string } | null, locationTo?: { id: string, name: string } | null, transferItems?: Array<{ status: TransferItemStatus, id: string, quantity: number, productLot?: { id: string, actionId?: string | null, product: { id?: string | null, secondaryId?: number | null, name?: string | null } } | null }> | null } };

export type GetTransferQueryVariables = Exact<{
  getTransferId: Scalars['String']['input'];
}>;


export type GetTransferQuery = { getTransfer: { description?: string | null, expectedDeliveryDate: string, id: string, secondaryId?: number | null, demandNoteId?: string | null, status: TransferStatus, updatedAt: any, demandNote?: { id: string, secondaryId?: number | null } | null, locationFrom?: { name: string, id: string } | null, locationTo?: { id: string, name: string } | null, transferItems?: Array<{ status: TransferItemStatus, id: string, quantity: number, remainingQuantity?: number | null, productLot?: { id: string, actionId?: string | null, product: { id?: string | null, secondaryId?: number | null, name?: string | null } } | null }> | null } };

export type ReceiveAllTransferItemsMutationVariables = Exact<{
  transferId: Scalars['String']['input'];
}>;


export type ReceiveAllTransferItemsMutation = { receiveAllTransferItems: boolean };

export type GetUsersListQueryVariables = Exact<{
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
  limit: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
}>;


export type GetUsersListQuery = { getUsers: { data: Array<{ createdAt?: any | null, email?: string | null, firstName?: string | null, gender?: GenderType | null, id: string, lastName?: string | null, phone?: string | null, designation?: string | null, roleId?: string | null, secondaryId?: number | null, status?: User_Status | null, updatedAt?: any | null, role?: { name?: string | null } | null }>, meta: { limit?: number | null, page?: number | null, total?: number | null, totalCount?: number | null } } };

export type GetPickerUsersQueryVariables = Exact<{
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  registerId?: InputMaybe<Scalars['String']['input']>;
  isRegisterAssigned?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetPickerUsersQuery = { getPickerUsers: { meta: { page?: number | null, limit?: number | null, totalCount?: number | null, total?: number | null }, data: Array<{ id: string, secondaryId?: number | null, firstName?: string | null, lastName?: string | null, gender?: GenderType | null, phone?: string | null }> } };

export type GetUsersListForOptionsQueryVariables = Exact<{
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
  limit: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
}>;


export type GetUsersListForOptionsQuery = { getUsers: { data: Array<{ id: string, firstName?: string | null, lastName?: string | null, phone?: string | null }>, meta: { limit?: number | null, page?: number | null, total?: number | null, totalCount?: number | null } } };

export type GetUserQueryVariables = Exact<{
  getUserId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUserQuery = { getUser: { createdAt?: any | null, email?: string | null, firstName?: string | null, gender?: GenderType | null, id: string, lastName?: string | null, phone?: string | null, designation?: string | null, roleId?: string | null, secondaryId?: number | null, status?: User_Status | null, tokenExpiry?: any | null, updatedAt?: any | null, role?: { id: string, name?: string | null } | null, location?: Array<{ id: string }> | null } };

export type InviteUserMutationVariables = Exact<{
  inviteUser: InviteUserDto;
  locationIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type InviteUserMutation = { inviteUser: { id: string } };

export type ResendInviteMutationVariables = Exact<{
  resendInviteId: Scalars['String']['input'];
  origin: Scalars['String']['input'];
}>;


export type ResendInviteMutation = { resendInvite: boolean };

export type CancelInviteMutationVariables = Exact<{
  cancelInviteId: Scalars['String']['input'];
}>;


export type CancelInviteMutation = { cancelInvite: boolean };

export type ActivateUserMutationVariables = Exact<{
  activateUserId: Scalars['String']['input'];
}>;


export type ActivateUserMutation = { activateUser: boolean };

export type DeactivateUserMutationVariables = Exact<{
  deactivateUserId: Scalars['String']['input'];
}>;


export type DeactivateUserMutation = { deactivateUser: boolean };

export type UpdateUserMutationVariables = Exact<{
  updateUserId: Scalars['String']['input'];
  locationIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  userDto: UserDto;
}>;


export type UpdateUserMutation = { updateUser: boolean };

export type CreateVendorMutationVariables = Exact<{
  createVendorDto: CreateVendorDto;
}>;


export type CreateVendorMutation = { createVendor: { id: string, bankName?: string | null, branchCode?: string | null, businessAddress?: string | null, comment?: string | null, contactPerson?: string | null, document?: string | null, documentExpiryDate?: string | null, drugLicenseNo?: string | null, ibanNumber?: string | null, leadTime?: number | null, paymentMethod?: string | null, paymentTerms?: string | null, primaryEmailAddress?: string | null, primaryPhoneNumber?: string | null, registrationNumber?: string | null, secondaryEmailAddress?: string | null, secondaryPhoneNumber?: string | null, drugSaleLicense: boolean, taxExemption?: boolean | null, stateProvince?: string | null, status: string, stockReturnPolicy?: string | null, strn?: string | null, taxExemptionValidity?: string | null, taxReturn?: boolean | null, taxationNumber?: string | null, classification?: string | null, creditLimit?: number | null, name?: string | null, type?: Array<string> | null, withHoldTaxGroup?: string | null, withHoldTaxPercentage?: string | null, zipCode?: string | null, branchCity?: { id?: string | null, name?: string | null } | null, city?: { id?: string | null, name?: string | null, country?: { id?: string | null, name?: string | null } | null } | null, manufacturers?: Array<{ description?: string | null, id?: string | null, lastReason?: string | null, lineOfBusiness?: Array<string> | null, name?: string | null, status?: string | null }> | null } };

export type UpdateVendorMutationVariables = Exact<{
  updateVendorDto: UpdateVendorDto;
}>;


export type UpdateVendorMutation = { updateVendor: { bankName?: string | null, branchCode?: string | null, businessAddress?: string | null, comment?: string | null, contactPerson?: string | null, document?: string | null, documentExpiryDate?: string | null, drugLicenseNo?: string | null, ibanNumber?: string | null, id: string, leadTime?: number | null, paymentMethod?: string | null, paymentTerms?: string | null, primaryEmailAddress?: string | null, primaryPhoneNumber?: string | null, registrationNumber?: string | null, secondaryEmailAddress?: string | null, secondaryPhoneNumber?: string | null, drugSaleLicense: boolean, taxExemption?: boolean | null, stateProvince?: string | null, status: string, stockReturnPolicy?: string | null, strn?: string | null, taxExemptionValidity?: string | null, taxReturn?: boolean | null, taxationNumber?: string | null, classification?: string | null, creditLimit?: number | null, name?: string | null, type?: Array<string> | null, withHoldTaxGroup?: string | null, withHoldTaxPercentage?: string | null, zipCode?: string | null, branchCity?: { id?: string | null, name?: string | null } | null, city?: { id?: string | null, name?: string | null, country?: { id?: string | null, name?: string | null } | null } | null, manufacturers?: Array<{ description?: string | null, id?: string | null, lastReason?: string | null, lineOfBusiness?: Array<string> | null, name?: string | null, status?: string | null }> | null } };

export type GetVendorsQueryVariables = Exact<{
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type GetVendorsQuery = { getVendors: { meta: { totalCount?: number | null, page?: number | null, limit?: number | null }, data: Array<{ id: string, secondaryId?: number | null, bankName?: string | null, branchCode?: string | null, businessAddress?: string | null, comment?: string | null, contactPerson?: string | null, document?: string | null, documentExpiryDate?: string | null, drugLicenseNo?: string | null, ibanNumber?: string | null, leadTime?: number | null, paymentMethod?: string | null, paymentTerms?: string | null, primaryEmailAddress?: string | null, primaryPhoneNumber?: string | null, registrationNumber?: string | null, secondaryEmailAddress?: string | null, secondaryPhoneNumber?: string | null, drugSaleLicense: boolean, taxExemption?: boolean | null, stateProvince?: string | null, status: string, stockReturnPolicy?: string | null, strn?: string | null, taxExemptionValidity?: string | null, taxReturn?: boolean | null, taxationNumber?: string | null, classification?: string | null, creditLimit?: number | null, name?: string | null, type?: Array<string> | null, withHoldTaxGroup?: string | null, withHoldTaxPercentage?: string | null, zipCode?: string | null, branchCity?: { id?: string | null, name?: string | null } | null, city?: { id?: string | null, name?: string | null, country?: { id?: string | null, name?: string | null } | null } | null, manufacturers?: Array<{ description?: string | null, id?: string | null, lastReason?: string | null, lineOfBusiness?: Array<string> | null, name?: string | null, status?: string | null }> | null }> } };

export type GetVendorsForOptionsQueryVariables = Exact<{
  filter?: InputMaybe<Array<FilterGroup> | FilterGroup>;
  sort?: InputMaybe<Array<SortCondition> | SortCondition>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type GetVendorsForOptionsQuery = { getVendors: { data: Array<{ id: string, name?: string | null, secondaryId?: number | null, type?: Array<string> | null }>, meta: { limit?: number | null, page?: number | null, totalCount?: number | null } } };

export type GetVendorQueryVariables = Exact<{
  getVendorId: Scalars['String']['input'];
}>;


export type GetVendorQuery = { getVendor: { bankName?: string | null, branchCode?: string | null, businessAddress?: string | null, comment?: string | null, contactPerson?: string | null, document?: string | null, documentExpiryDate?: string | null, drugLicenseNo?: string | null, ibanNumber?: string | null, id: string, leadTime?: number | null, paymentMethod?: string | null, paymentTerms?: string | null, primaryEmailAddress?: string | null, primaryPhoneNumber?: string | null, registrationNumber?: string | null, secondaryEmailAddress?: string | null, secondaryPhoneNumber?: string | null, drugSaleLicense: boolean, taxExemption?: boolean | null, stateProvince?: string | null, status: string, stockReturnPolicy?: string | null, strn?: string | null, taxExemptionValidity?: string | null, taxReturn?: boolean | null, taxationNumber?: string | null, classification?: string | null, creditLimit?: number | null, name?: string | null, type?: Array<string> | null, withHoldTaxGroup?: string | null, withHoldTaxPercentage?: string | null, zipCode?: string | null, branchCity?: { id?: string | null, name?: string | null } | null, city?: { id?: string | null, name?: string | null, country?: { id?: string | null, name?: string | null } | null } | null, manufacturers?: Array<{ description?: string | null, id?: string | null, lastReason?: string | null, lineOfBusiness?: Array<string> | null, name?: string | null, status?: string | null }> | null } };

export type GetVendorForPreviewsQueryVariables = Exact<{
  getVendorId: Scalars['String']['input'];
}>;


export type GetVendorForPreviewsQuery = { getVendor: { strn?: string | null, paymentTerms?: string | null, name?: string | null, taxationNumber?: string | null, contactPerson?: string | null, businessAddress?: string | null, status: string, city?: { id?: string | null, name?: string | null, country?: { id?: string | null, name?: string | null } | null } | null } };

export const CancellationDetailsFragmentDoc = gql`
    fragment CancellationDetails on OrderCancellation {
  id
  orderId
  createdAt
  cancelledBy
  reason
  note
  isFull
  refundAmount
  refundMethod
  deliveryCharges
  platformFee
  integrationCharges
  fbrInvoiceId
  backfilled
  lines {
    id
    orderLineItemId
    productId
    quantity
    unitPrice
    subTotal
    discount
    tax
    totalPrice
    restockTo
    lots {
      productLotId
      quantity
      source
      restockTo
    }
  }
}
    `;
export const CreateAccountSubtypeDocument = gql`
    mutation CreateAccountSubtype($createAccountSubtype: CreateAccountSubtypeInput!) {
  createAccountSubtype(createAccountSubtype: $createAccountSubtype) {
    id
    code
    name
    type
    isSystemManaged
    isCashLike
    isControlSubtype
    isReconcilable
    subledgerType
    status
  }
}
    `;
export type CreateAccountSubtypeMutationFn = Apollo.MutationFunction<CreateAccountSubtypeMutation, CreateAccountSubtypeMutationVariables>;

/**
 * __useCreateAccountSubtypeMutation__
 *
 * To run a mutation, you first call `useCreateAccountSubtypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountSubtypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccountSubtypeMutation, { data, loading, error }] = useCreateAccountSubtypeMutation({
 *   variables: {
 *      createAccountSubtype: // value for 'createAccountSubtype'
 *   },
 * });
 */
export function useCreateAccountSubtypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateAccountSubtypeMutation, CreateAccountSubtypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAccountSubtypeMutation, CreateAccountSubtypeMutationVariables>(CreateAccountSubtypeDocument, options);
      }
export type CreateAccountSubtypeMutationHookResult = ReturnType<typeof useCreateAccountSubtypeMutation>;
export type CreateAccountSubtypeMutationResult = Apollo.MutationResult<CreateAccountSubtypeMutation>;
export type CreateAccountSubtypeMutationOptions = Apollo.BaseMutationOptions<CreateAccountSubtypeMutation, CreateAccountSubtypeMutationVariables>;
export const AccountSubtypesDocument = gql`
    query AccountSubtypes($page: Int!, $limit: Int!, $locationId: String, $filter: [FilterGroup!], $sort: [SortCondition!]) {
  accountSubtypes(
    page: $page
    limit: $limit
    locationId: $locationId
    filter: $filter
    sort: $sort
  ) {
    data {
      id
      secondaryId
      code
      name
      type
      isSystemManaged
      isCashLike
      isControlSubtype
      isReconcilable
      subledgerType
      status
    }
    meta {
      page
      limit
      totalCount
      total
    }
  }
}
    `;

/**
 * __useAccountSubtypesQuery__
 *
 * To run a query within a React component, call `useAccountSubtypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountSubtypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountSubtypesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      locationId: // value for 'locationId'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useAccountSubtypesQuery(baseOptions: Apollo.QueryHookOptions<AccountSubtypesQuery, AccountSubtypesQueryVariables> & ({ variables: AccountSubtypesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountSubtypesQuery, AccountSubtypesQueryVariables>(AccountSubtypesDocument, options);
      }
export function useAccountSubtypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountSubtypesQuery, AccountSubtypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountSubtypesQuery, AccountSubtypesQueryVariables>(AccountSubtypesDocument, options);
        }
// @ts-ignore
export function useAccountSubtypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AccountSubtypesQuery, AccountSubtypesQueryVariables>): Apollo.UseSuspenseQueryResult<AccountSubtypesQuery, AccountSubtypesQueryVariables>;
export function useAccountSubtypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountSubtypesQuery, AccountSubtypesQueryVariables>): Apollo.UseSuspenseQueryResult<AccountSubtypesQuery | undefined, AccountSubtypesQueryVariables>;
export function useAccountSubtypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountSubtypesQuery, AccountSubtypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountSubtypesQuery, AccountSubtypesQueryVariables>(AccountSubtypesDocument, options);
        }
export type AccountSubtypesQueryHookResult = ReturnType<typeof useAccountSubtypesQuery>;
export type AccountSubtypesLazyQueryHookResult = ReturnType<typeof useAccountSubtypesLazyQuery>;
export type AccountSubtypesSuspenseQueryHookResult = ReturnType<typeof useAccountSubtypesSuspenseQuery>;
export type AccountSubtypesQueryResult = Apollo.QueryResult<AccountSubtypesQuery, AccountSubtypesQueryVariables>;
export const AccountSubtypesListForOptionsDocument = gql`
    query AccountSubtypesListForOptions($page: Int!, $limit: Int!, $locationId: String, $filter: [FilterGroup!], $sort: [SortCondition!]) {
  accountSubtypes(
    page: $page
    limit: $limit
    locationId: $locationId
    filter: $filter
    sort: $sort
  ) {
    data {
      id
      name
      type
    }
    meta {
      page
      limit
      totalCount
      total
    }
  }
}
    `;

/**
 * __useAccountSubtypesListForOptionsQuery__
 *
 * To run a query within a React component, call `useAccountSubtypesListForOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountSubtypesListForOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountSubtypesListForOptionsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      locationId: // value for 'locationId'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useAccountSubtypesListForOptionsQuery(baseOptions: Apollo.QueryHookOptions<AccountSubtypesListForOptionsQuery, AccountSubtypesListForOptionsQueryVariables> & ({ variables: AccountSubtypesListForOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountSubtypesListForOptionsQuery, AccountSubtypesListForOptionsQueryVariables>(AccountSubtypesListForOptionsDocument, options);
      }
export function useAccountSubtypesListForOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountSubtypesListForOptionsQuery, AccountSubtypesListForOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountSubtypesListForOptionsQuery, AccountSubtypesListForOptionsQueryVariables>(AccountSubtypesListForOptionsDocument, options);
        }
// @ts-ignore
export function useAccountSubtypesListForOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AccountSubtypesListForOptionsQuery, AccountSubtypesListForOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<AccountSubtypesListForOptionsQuery, AccountSubtypesListForOptionsQueryVariables>;
export function useAccountSubtypesListForOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountSubtypesListForOptionsQuery, AccountSubtypesListForOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<AccountSubtypesListForOptionsQuery | undefined, AccountSubtypesListForOptionsQueryVariables>;
export function useAccountSubtypesListForOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountSubtypesListForOptionsQuery, AccountSubtypesListForOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountSubtypesListForOptionsQuery, AccountSubtypesListForOptionsQueryVariables>(AccountSubtypesListForOptionsDocument, options);
        }
export type AccountSubtypesListForOptionsQueryHookResult = ReturnType<typeof useAccountSubtypesListForOptionsQuery>;
export type AccountSubtypesListForOptionsLazyQueryHookResult = ReturnType<typeof useAccountSubtypesListForOptionsLazyQuery>;
export type AccountSubtypesListForOptionsSuspenseQueryHookResult = ReturnType<typeof useAccountSubtypesListForOptionsSuspenseQuery>;
export type AccountSubtypesListForOptionsQueryResult = Apollo.QueryResult<AccountSubtypesListForOptionsQuery, AccountSubtypesListForOptionsQueryVariables>;
export const AccountPayableInvoicesForOptionsDocument = gql`
    query AccountPayableInvoicesForOptions($page: Int!, $limit: Int!, $locationId: String, $filter: [FilterGroup!] = [{conditions: [{operator: EQUAL, field: "status", value: "POSTED"}], logicalOperator: AND}], $sort: [SortCondition!] = [{field: "secondaryId", direction: ASC}]) {
  accountPayableInvoices(
    page: $page
    limit: $limit
    locationId: $locationId
    filter: $filter
    sort: $sort
  ) {
    data {
      id
      secondaryId
      vendorId
      vendorName
      partnerId
      partnerName
    }
    meta {
      page
      limit
      totalCount
      total
    }
  }
}
    `;

/**
 * __useAccountPayableInvoicesForOptionsQuery__
 *
 * To run a query within a React component, call `useAccountPayableInvoicesForOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountPayableInvoicesForOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountPayableInvoicesForOptionsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      locationId: // value for 'locationId'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useAccountPayableInvoicesForOptionsQuery(baseOptions: Apollo.QueryHookOptions<AccountPayableInvoicesForOptionsQuery, AccountPayableInvoicesForOptionsQueryVariables> & ({ variables: AccountPayableInvoicesForOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountPayableInvoicesForOptionsQuery, AccountPayableInvoicesForOptionsQueryVariables>(AccountPayableInvoicesForOptionsDocument, options);
      }
export function useAccountPayableInvoicesForOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountPayableInvoicesForOptionsQuery, AccountPayableInvoicesForOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountPayableInvoicesForOptionsQuery, AccountPayableInvoicesForOptionsQueryVariables>(AccountPayableInvoicesForOptionsDocument, options);
        }
// @ts-ignore
export function useAccountPayableInvoicesForOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AccountPayableInvoicesForOptionsQuery, AccountPayableInvoicesForOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<AccountPayableInvoicesForOptionsQuery, AccountPayableInvoicesForOptionsQueryVariables>;
export function useAccountPayableInvoicesForOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountPayableInvoicesForOptionsQuery, AccountPayableInvoicesForOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<AccountPayableInvoicesForOptionsQuery | undefined, AccountPayableInvoicesForOptionsQueryVariables>;
export function useAccountPayableInvoicesForOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountPayableInvoicesForOptionsQuery, AccountPayableInvoicesForOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountPayableInvoicesForOptionsQuery, AccountPayableInvoicesForOptionsQueryVariables>(AccountPayableInvoicesForOptionsDocument, options);
        }
export type AccountPayableInvoicesForOptionsQueryHookResult = ReturnType<typeof useAccountPayableInvoicesForOptionsQuery>;
export type AccountPayableInvoicesForOptionsLazyQueryHookResult = ReturnType<typeof useAccountPayableInvoicesForOptionsLazyQuery>;
export type AccountPayableInvoicesForOptionsSuspenseQueryHookResult = ReturnType<typeof useAccountPayableInvoicesForOptionsSuspenseQuery>;
export type AccountPayableInvoicesForOptionsQueryResult = Apollo.QueryResult<AccountPayableInvoicesForOptionsQuery, AccountPayableInvoicesForOptionsQueryVariables>;
export const AccountPayableInvoicesDocument = gql`
    query AccountPayableInvoices($sort: [SortCondition!], $page: Int!, $limit: Int!, $locationId: String, $filter: [FilterGroup!]) {
  accountPayableInvoices(
    sort: $sort
    page: $page
    limit: $limit
    locationId: $locationId
    filter: $filter
  ) {
    data {
      id
      secondaryId
      invoiceNo
      invoiceType
      vendorId
      vendorName
      partnerId
      partnerName
      relatedInvoiceId
      relationType
      invoiceDate
      dueDate
      subtotal
      taxAmount
      whtAmount
      totalAmount
      discountAmount
      roundingAdjustment
      outstandingAmount
      status
      notes
      locationId
      locationName
      threeWayMatch
      poId
      entryMethod
      entityId
      createdBy
      createdAt
      updatedAt
      postedBy
      postedAt
      aging
      grnInvoiceNumber
      createdByName
      postedByName
      fiscalPeriodName
      paymentTerms {
        name
      }
      journal {
        journalNo
      }
      entityName
      grnSecondaryId
      poSecondaryId
    }
    meta {
      totalCount
      page
      limit
      total
    }
  }
}
    `;

/**
 * __useAccountPayableInvoicesQuery__
 *
 * To run a query within a React component, call `useAccountPayableInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountPayableInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountPayableInvoicesQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      locationId: // value for 'locationId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAccountPayableInvoicesQuery(baseOptions: Apollo.QueryHookOptions<AccountPayableInvoicesQuery, AccountPayableInvoicesQueryVariables> & ({ variables: AccountPayableInvoicesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountPayableInvoicesQuery, AccountPayableInvoicesQueryVariables>(AccountPayableInvoicesDocument, options);
      }
export function useAccountPayableInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountPayableInvoicesQuery, AccountPayableInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountPayableInvoicesQuery, AccountPayableInvoicesQueryVariables>(AccountPayableInvoicesDocument, options);
        }
// @ts-ignore
export function useAccountPayableInvoicesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AccountPayableInvoicesQuery, AccountPayableInvoicesQueryVariables>): Apollo.UseSuspenseQueryResult<AccountPayableInvoicesQuery, AccountPayableInvoicesQueryVariables>;
export function useAccountPayableInvoicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountPayableInvoicesQuery, AccountPayableInvoicesQueryVariables>): Apollo.UseSuspenseQueryResult<AccountPayableInvoicesQuery | undefined, AccountPayableInvoicesQueryVariables>;
export function useAccountPayableInvoicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountPayableInvoicesQuery, AccountPayableInvoicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountPayableInvoicesQuery, AccountPayableInvoicesQueryVariables>(AccountPayableInvoicesDocument, options);
        }
export type AccountPayableInvoicesQueryHookResult = ReturnType<typeof useAccountPayableInvoicesQuery>;
export type AccountPayableInvoicesLazyQueryHookResult = ReturnType<typeof useAccountPayableInvoicesLazyQuery>;
export type AccountPayableInvoicesSuspenseQueryHookResult = ReturnType<typeof useAccountPayableInvoicesSuspenseQuery>;
export type AccountPayableInvoicesQueryResult = Apollo.QueryResult<AccountPayableInvoicesQuery, AccountPayableInvoicesQueryVariables>;
export const AccountPayableInvoiceDocument = gql`
    query AccountPayableInvoice($accountPayableInvoiceId: ID!) {
  accountPayableInvoice(id: $accountPayableInvoiceId) {
    id
    secondaryId
    invoiceNo
    invoiceType
    vendorId
    vendorName
    partnerId
    partnerName
    relatedInvoiceId
    relationType
    grnId
    invoiceDate
    dueDate
    subtotal
    taxAmount
    whtAmount
    totalAmount
    discountAmount
    roundingAdjustment
    outstandingAmount
    journalId
    status
    notes
    locationId
    locationName
    threeWayMatch
    poId
    entryMethod
    entityId
    createdBy
    createdAt
    updatedAt
    postedBy
    postedAt
    aging
    lines {
      id
      secondaryId
      invoiceId
      description
      qty
      unitPrice
      discountAmount
      taxAmount
      taxType
      lineTotal
      type
      chartOfAccountsId
      chartOfAccounts {
        id
        accountId
        name
      }
      grnId
      grnLineId
      productId
      poId
      poLineId
      locationId
      locationName
      profitCenterId
      costCenterId
      createdAt
      updatedAt
      grossAmount
    }
    paymentTerms {
      id
      name
    }
    createdByName
    fiscalPeriodName
    postedByName
    grnInvoiceNumber
    grnSecondaryId
    entityName
    journalNo
    poSecondaryId
  }
}
    `;

/**
 * __useAccountPayableInvoiceQuery__
 *
 * To run a query within a React component, call `useAccountPayableInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountPayableInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountPayableInvoiceQuery({
 *   variables: {
 *      accountPayableInvoiceId: // value for 'accountPayableInvoiceId'
 *   },
 * });
 */
export function useAccountPayableInvoiceQuery(baseOptions: Apollo.QueryHookOptions<AccountPayableInvoiceQuery, AccountPayableInvoiceQueryVariables> & ({ variables: AccountPayableInvoiceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountPayableInvoiceQuery, AccountPayableInvoiceQueryVariables>(AccountPayableInvoiceDocument, options);
      }
export function useAccountPayableInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountPayableInvoiceQuery, AccountPayableInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountPayableInvoiceQuery, AccountPayableInvoiceQueryVariables>(AccountPayableInvoiceDocument, options);
        }
// @ts-ignore
export function useAccountPayableInvoiceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AccountPayableInvoiceQuery, AccountPayableInvoiceQueryVariables>): Apollo.UseSuspenseQueryResult<AccountPayableInvoiceQuery, AccountPayableInvoiceQueryVariables>;
export function useAccountPayableInvoiceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountPayableInvoiceQuery, AccountPayableInvoiceQueryVariables>): Apollo.UseSuspenseQueryResult<AccountPayableInvoiceQuery | undefined, AccountPayableInvoiceQueryVariables>;
export function useAccountPayableInvoiceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountPayableInvoiceQuery, AccountPayableInvoiceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountPayableInvoiceQuery, AccountPayableInvoiceQueryVariables>(AccountPayableInvoiceDocument, options);
        }
export type AccountPayableInvoiceQueryHookResult = ReturnType<typeof useAccountPayableInvoiceQuery>;
export type AccountPayableInvoiceLazyQueryHookResult = ReturnType<typeof useAccountPayableInvoiceLazyQuery>;
export type AccountPayableInvoiceSuspenseQueryHookResult = ReturnType<typeof useAccountPayableInvoiceSuspenseQuery>;
export type AccountPayableInvoiceQueryResult = Apollo.QueryResult<AccountPayableInvoiceQuery, AccountPayableInvoiceQueryVariables>;
export const AccountPayableWriteoffsDocument = gql`
    query AccountPayableWriteoffs($sort: [SortCondition!], $filter: [FilterGroup!], $page: Int!, $limit: Int!) {
  accountPayableWriteoffs(
    sort: $sort
    filter: $filter
    page: $page
    limit: $limit
  ) {
    data {
      id
      secondaryId
      invoiceId
      amount
      notes
      reasonCode
      status
      entityId
      createdBy
      createdAt
      writeoffDate
      updatedAt
      createdByName
      postedAt
      postedByName
    }
    meta {
      totalCount
      page
      limit
      total
    }
  }
}
    `;

/**
 * __useAccountPayableWriteoffsQuery__
 *
 * To run a query within a React component, call `useAccountPayableWriteoffsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountPayableWriteoffsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountPayableWriteoffsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useAccountPayableWriteoffsQuery(baseOptions: Apollo.QueryHookOptions<AccountPayableWriteoffsQuery, AccountPayableWriteoffsQueryVariables> & ({ variables: AccountPayableWriteoffsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountPayableWriteoffsQuery, AccountPayableWriteoffsQueryVariables>(AccountPayableWriteoffsDocument, options);
      }
export function useAccountPayableWriteoffsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountPayableWriteoffsQuery, AccountPayableWriteoffsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountPayableWriteoffsQuery, AccountPayableWriteoffsQueryVariables>(AccountPayableWriteoffsDocument, options);
        }
// @ts-ignore
export function useAccountPayableWriteoffsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AccountPayableWriteoffsQuery, AccountPayableWriteoffsQueryVariables>): Apollo.UseSuspenseQueryResult<AccountPayableWriteoffsQuery, AccountPayableWriteoffsQueryVariables>;
export function useAccountPayableWriteoffsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountPayableWriteoffsQuery, AccountPayableWriteoffsQueryVariables>): Apollo.UseSuspenseQueryResult<AccountPayableWriteoffsQuery | undefined, AccountPayableWriteoffsQueryVariables>;
export function useAccountPayableWriteoffsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountPayableWriteoffsQuery, AccountPayableWriteoffsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountPayableWriteoffsQuery, AccountPayableWriteoffsQueryVariables>(AccountPayableWriteoffsDocument, options);
        }
export type AccountPayableWriteoffsQueryHookResult = ReturnType<typeof useAccountPayableWriteoffsQuery>;
export type AccountPayableWriteoffsLazyQueryHookResult = ReturnType<typeof useAccountPayableWriteoffsLazyQuery>;
export type AccountPayableWriteoffsSuspenseQueryHookResult = ReturnType<typeof useAccountPayableWriteoffsSuspenseQuery>;
export type AccountPayableWriteoffsQueryResult = Apollo.QueryResult<AccountPayableWriteoffsQuery, AccountPayableWriteoffsQueryVariables>;
export const CreateAccountPayableInvoiceDocument = gql`
    mutation CreateAccountPayableInvoice($createAccountPayableInvoice: CreateAccountPayableInvoiceInput!) {
  createAccountPayableInvoice(
    createAccountPayableInvoice: $createAccountPayableInvoice
  ) {
    id
  }
}
    `;
export type CreateAccountPayableInvoiceMutationFn = Apollo.MutationFunction<CreateAccountPayableInvoiceMutation, CreateAccountPayableInvoiceMutationVariables>;

/**
 * __useCreateAccountPayableInvoiceMutation__
 *
 * To run a mutation, you first call `useCreateAccountPayableInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountPayableInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccountPayableInvoiceMutation, { data, loading, error }] = useCreateAccountPayableInvoiceMutation({
 *   variables: {
 *      createAccountPayableInvoice: // value for 'createAccountPayableInvoice'
 *   },
 * });
 */
export function useCreateAccountPayableInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<CreateAccountPayableInvoiceMutation, CreateAccountPayableInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAccountPayableInvoiceMutation, CreateAccountPayableInvoiceMutationVariables>(CreateAccountPayableInvoiceDocument, options);
      }
export type CreateAccountPayableInvoiceMutationHookResult = ReturnType<typeof useCreateAccountPayableInvoiceMutation>;
export type CreateAccountPayableInvoiceMutationResult = Apollo.MutationResult<CreateAccountPayableInvoiceMutation>;
export type CreateAccountPayableInvoiceMutationOptions = Apollo.BaseMutationOptions<CreateAccountPayableInvoiceMutation, CreateAccountPayableInvoiceMutationVariables>;
export const UpdateAccountPayableInvoiceDocument = gql`
    mutation UpdateAccountPayableInvoice($updateAccountPayableInvoice: UpdateAccountPayableInvoiceInput!) {
  updateAccountPayableInvoice(
    updateAccountPayableInvoice: $updateAccountPayableInvoice
  ) {
    id
  }
}
    `;
export type UpdateAccountPayableInvoiceMutationFn = Apollo.MutationFunction<UpdateAccountPayableInvoiceMutation, UpdateAccountPayableInvoiceMutationVariables>;

/**
 * __useUpdateAccountPayableInvoiceMutation__
 *
 * To run a mutation, you first call `useUpdateAccountPayableInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountPayableInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountPayableInvoiceMutation, { data, loading, error }] = useUpdateAccountPayableInvoiceMutation({
 *   variables: {
 *      updateAccountPayableInvoice: // value for 'updateAccountPayableInvoice'
 *   },
 * });
 */
export function useUpdateAccountPayableInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccountPayableInvoiceMutation, UpdateAccountPayableInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAccountPayableInvoiceMutation, UpdateAccountPayableInvoiceMutationVariables>(UpdateAccountPayableInvoiceDocument, options);
      }
export type UpdateAccountPayableInvoiceMutationHookResult = ReturnType<typeof useUpdateAccountPayableInvoiceMutation>;
export type UpdateAccountPayableInvoiceMutationResult = Apollo.MutationResult<UpdateAccountPayableInvoiceMutation>;
export type UpdateAccountPayableInvoiceMutationOptions = Apollo.BaseMutationOptions<UpdateAccountPayableInvoiceMutation, UpdateAccountPayableInvoiceMutationVariables>;
export const CreateAccountPayableWriteoffDocument = gql`
    mutation CreateAccountPayableWriteoff($createAccountPayableWriteoff: CreateAccountPayableWriteoffInput!) {
  createAccountPayableWriteoff(
    createAccountPayableWriteoff: $createAccountPayableWriteoff
  ) {
    id
    status
  }
}
    `;
export type CreateAccountPayableWriteoffMutationFn = Apollo.MutationFunction<CreateAccountPayableWriteoffMutation, CreateAccountPayableWriteoffMutationVariables>;

/**
 * __useCreateAccountPayableWriteoffMutation__
 *
 * To run a mutation, you first call `useCreateAccountPayableWriteoffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountPayableWriteoffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccountPayableWriteoffMutation, { data, loading, error }] = useCreateAccountPayableWriteoffMutation({
 *   variables: {
 *      createAccountPayableWriteoff: // value for 'createAccountPayableWriteoff'
 *   },
 * });
 */
export function useCreateAccountPayableWriteoffMutation(baseOptions?: Apollo.MutationHookOptions<CreateAccountPayableWriteoffMutation, CreateAccountPayableWriteoffMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAccountPayableWriteoffMutation, CreateAccountPayableWriteoffMutationVariables>(CreateAccountPayableWriteoffDocument, options);
      }
export type CreateAccountPayableWriteoffMutationHookResult = ReturnType<typeof useCreateAccountPayableWriteoffMutation>;
export type CreateAccountPayableWriteoffMutationResult = Apollo.MutationResult<CreateAccountPayableWriteoffMutation>;
export type CreateAccountPayableWriteoffMutationOptions = Apollo.BaseMutationOptions<CreateAccountPayableWriteoffMutation, CreateAccountPayableWriteoffMutationVariables>;
export const UpdateAccountPayableWriteoffDocument = gql`
    mutation UpdateAccountPayableWriteoff($updateAccountPayableWriteoff: UpdateAccountPayableWriteoffInput!) {
  updateAccountPayableWriteoff(
    updateAccountPayableWriteoff: $updateAccountPayableWriteoff
  ) {
    id
    status
    amount
    notes
    reasonCode
    writeoffDate
    updatedAt
  }
}
    `;
export type UpdateAccountPayableWriteoffMutationFn = Apollo.MutationFunction<UpdateAccountPayableWriteoffMutation, UpdateAccountPayableWriteoffMutationVariables>;

/**
 * __useUpdateAccountPayableWriteoffMutation__
 *
 * To run a mutation, you first call `useUpdateAccountPayableWriteoffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountPayableWriteoffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountPayableWriteoffMutation, { data, loading, error }] = useUpdateAccountPayableWriteoffMutation({
 *   variables: {
 *      updateAccountPayableWriteoff: // value for 'updateAccountPayableWriteoff'
 *   },
 * });
 */
export function useUpdateAccountPayableWriteoffMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccountPayableWriteoffMutation, UpdateAccountPayableWriteoffMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAccountPayableWriteoffMutation, UpdateAccountPayableWriteoffMutationVariables>(UpdateAccountPayableWriteoffDocument, options);
      }
export type UpdateAccountPayableWriteoffMutationHookResult = ReturnType<typeof useUpdateAccountPayableWriteoffMutation>;
export type UpdateAccountPayableWriteoffMutationResult = Apollo.MutationResult<UpdateAccountPayableWriteoffMutation>;
export type UpdateAccountPayableWriteoffMutationOptions = Apollo.BaseMutationOptions<UpdateAccountPayableWriteoffMutation, UpdateAccountPayableWriteoffMutationVariables>;
export const OutstandingAccountPayableInvoicesDocument = gql`
    query OutstandingAccountPayableInvoices($filter: OutstandingApInvoiceFilterInput!, $sort: [SortCondition!], $page: Int!, $limit: Int!, $locationId: String) {
  outstandingAccountPayableInvoices(
    filter: $filter
    sort: $sort
    page: $page
    limit: $limit
    locationId: $locationId
  ) {
    data {
      id
      invoiceNo
      type
      invoiceDate
      dueDate
      totalAmount
      outstandingAmount
      aging
    }
  }
}
    `;

/**
 * __useOutstandingAccountPayableInvoicesQuery__
 *
 * To run a query within a React component, call `useOutstandingAccountPayableInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOutstandingAccountPayableInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOutstandingAccountPayableInvoicesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useOutstandingAccountPayableInvoicesQuery(baseOptions: Apollo.QueryHookOptions<OutstandingAccountPayableInvoicesQuery, OutstandingAccountPayableInvoicesQueryVariables> & ({ variables: OutstandingAccountPayableInvoicesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OutstandingAccountPayableInvoicesQuery, OutstandingAccountPayableInvoicesQueryVariables>(OutstandingAccountPayableInvoicesDocument, options);
      }
export function useOutstandingAccountPayableInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OutstandingAccountPayableInvoicesQuery, OutstandingAccountPayableInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OutstandingAccountPayableInvoicesQuery, OutstandingAccountPayableInvoicesQueryVariables>(OutstandingAccountPayableInvoicesDocument, options);
        }
// @ts-ignore
export function useOutstandingAccountPayableInvoicesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OutstandingAccountPayableInvoicesQuery, OutstandingAccountPayableInvoicesQueryVariables>): Apollo.UseSuspenseQueryResult<OutstandingAccountPayableInvoicesQuery, OutstandingAccountPayableInvoicesQueryVariables>;
export function useOutstandingAccountPayableInvoicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OutstandingAccountPayableInvoicesQuery, OutstandingAccountPayableInvoicesQueryVariables>): Apollo.UseSuspenseQueryResult<OutstandingAccountPayableInvoicesQuery | undefined, OutstandingAccountPayableInvoicesQueryVariables>;
export function useOutstandingAccountPayableInvoicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OutstandingAccountPayableInvoicesQuery, OutstandingAccountPayableInvoicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OutstandingAccountPayableInvoicesQuery, OutstandingAccountPayableInvoicesQueryVariables>(OutstandingAccountPayableInvoicesDocument, options);
        }
export type OutstandingAccountPayableInvoicesQueryHookResult = ReturnType<typeof useOutstandingAccountPayableInvoicesQuery>;
export type OutstandingAccountPayableInvoicesLazyQueryHookResult = ReturnType<typeof useOutstandingAccountPayableInvoicesLazyQuery>;
export type OutstandingAccountPayableInvoicesSuspenseQueryHookResult = ReturnType<typeof useOutstandingAccountPayableInvoicesSuspenseQuery>;
export type OutstandingAccountPayableInvoicesQueryResult = Apollo.QueryResult<OutstandingAccountPayableInvoicesQuery, OutstandingAccountPayableInvoicesQueryVariables>;
export const CreateAccountPayablePaymentDocument = gql`
    mutation CreateAccountPayablePayment($createAccountPayablePayment: CreateAccountPayablePaymentInput!) {
  createAccountPayablePayment(
    createAccountPayablePayment: $createAccountPayablePayment
  ) {
    id
  }
}
    `;
export type CreateAccountPayablePaymentMutationFn = Apollo.MutationFunction<CreateAccountPayablePaymentMutation, CreateAccountPayablePaymentMutationVariables>;

/**
 * __useCreateAccountPayablePaymentMutation__
 *
 * To run a mutation, you first call `useCreateAccountPayablePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountPayablePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccountPayablePaymentMutation, { data, loading, error }] = useCreateAccountPayablePaymentMutation({
 *   variables: {
 *      createAccountPayablePayment: // value for 'createAccountPayablePayment'
 *   },
 * });
 */
export function useCreateAccountPayablePaymentMutation(baseOptions?: Apollo.MutationHookOptions<CreateAccountPayablePaymentMutation, CreateAccountPayablePaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAccountPayablePaymentMutation, CreateAccountPayablePaymentMutationVariables>(CreateAccountPayablePaymentDocument, options);
      }
export type CreateAccountPayablePaymentMutationHookResult = ReturnType<typeof useCreateAccountPayablePaymentMutation>;
export type CreateAccountPayablePaymentMutationResult = Apollo.MutationResult<CreateAccountPayablePaymentMutation>;
export type CreateAccountPayablePaymentMutationOptions = Apollo.BaseMutationOptions<CreateAccountPayablePaymentMutation, CreateAccountPayablePaymentMutationVariables>;
export const AccountPayablePaymentDocument = gql`
    query AccountPayablePayment($accountPayablePaymentId: ID!) {
  accountPayablePayment(id: $accountPayablePaymentId) {
    id
    secondaryId
    vendorId
    customerId
    customerName
    partnerId
    paymentDate
    amount
    refId
    challanId
    method
    bankId
    cashId
    bank {
      id
      name
      coaAccount {
        accountId
        name
      }
    }
    cash {
      id
      name
      coaAccount {
        accountId
        name
      }
    }
    chartOfAccountsId
    status
    entityId
    postedBy
    postedAt
    comment
    advancePayment
    advanceDate
    advanceRemarks
    apSettlementLines {
      id
      secondaryId
      fromType
      paymentId
      creditMemoId
      writeoffId
      invoiceId
      allocatedAmount
      fxAllocatedAmount
      chartOfAccountsId
      offsetDescription
      offsetTaxHandling
      allocationDate
      status
      notes
      entityId
      createdBy
      createdAt
      postedAt
      postedBy
      updatedAt
      totalAmount
      settlementAllocatedAmount
      outstandingAmount
      dueDate
      aging
      invoiceSecondaryId
      invoiceDate
    }
    fiscalPeriodName
    createdByName
    createdAt
    offsetTaxHandling
    offsetDescription
    partnerName
    postedByName
    vendorName
    journal {
      id
      journalNo
      lines {
        id
        description
        debit
        credit
        account {
          accountId
          name
        }
      }
    }
    chartOfAccount {
      id
      accountId
      name
    }
  }
}
    `;

/**
 * __useAccountPayablePaymentQuery__
 *
 * To run a query within a React component, call `useAccountPayablePaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountPayablePaymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountPayablePaymentQuery({
 *   variables: {
 *      accountPayablePaymentId: // value for 'accountPayablePaymentId'
 *   },
 * });
 */
export function useAccountPayablePaymentQuery(baseOptions: Apollo.QueryHookOptions<AccountPayablePaymentQuery, AccountPayablePaymentQueryVariables> & ({ variables: AccountPayablePaymentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountPayablePaymentQuery, AccountPayablePaymentQueryVariables>(AccountPayablePaymentDocument, options);
      }
export function useAccountPayablePaymentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountPayablePaymentQuery, AccountPayablePaymentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountPayablePaymentQuery, AccountPayablePaymentQueryVariables>(AccountPayablePaymentDocument, options);
        }
// @ts-ignore
export function useAccountPayablePaymentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AccountPayablePaymentQuery, AccountPayablePaymentQueryVariables>): Apollo.UseSuspenseQueryResult<AccountPayablePaymentQuery, AccountPayablePaymentQueryVariables>;
export function useAccountPayablePaymentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountPayablePaymentQuery, AccountPayablePaymentQueryVariables>): Apollo.UseSuspenseQueryResult<AccountPayablePaymentQuery | undefined, AccountPayablePaymentQueryVariables>;
export function useAccountPayablePaymentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountPayablePaymentQuery, AccountPayablePaymentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountPayablePaymentQuery, AccountPayablePaymentQueryVariables>(AccountPayablePaymentDocument, options);
        }
export type AccountPayablePaymentQueryHookResult = ReturnType<typeof useAccountPayablePaymentQuery>;
export type AccountPayablePaymentLazyQueryHookResult = ReturnType<typeof useAccountPayablePaymentLazyQuery>;
export type AccountPayablePaymentSuspenseQueryHookResult = ReturnType<typeof useAccountPayablePaymentSuspenseQuery>;
export type AccountPayablePaymentQueryResult = Apollo.QueryResult<AccountPayablePaymentQuery, AccountPayablePaymentQueryVariables>;
export const AccountPayablePaymentsDocument = gql`
    query AccountPayablePayments($sort: [SortCondition!], $filter: [FilterGroup!], $page: Int!, $limit: Int!, $locationId: String) {
  accountPayablePayments(
    sort: $sort
    filter: $filter
    page: $page
    limit: $limit
    locationId: $locationId
  ) {
    data {
      id
      secondaryId
      vendorId
      customerId
      partnerId
      paymentDate
      amount
      refId
      challanId
      method
      bankId
      cashId
      chartOfAccountsId
      offsetDescription
      offsetTaxHandling
      journalId
      status
      entityId
      postedAt
      comment
      advancePayment
      advanceDate
      advanceRemarks
      customerName
      createdByName
      createdAt
      fiscalPeriodName
      journal {
        id
        journalNo
      }
      partnerName
      postedByName
      vendorName
    }
    meta {
      page
      limit
      totalCount
      total
    }
  }
}
    `;

/**
 * __useAccountPayablePaymentsQuery__
 *
 * To run a query within a React component, call `useAccountPayablePaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountPayablePaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountPayablePaymentsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useAccountPayablePaymentsQuery(baseOptions: Apollo.QueryHookOptions<AccountPayablePaymentsQuery, AccountPayablePaymentsQueryVariables> & ({ variables: AccountPayablePaymentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountPayablePaymentsQuery, AccountPayablePaymentsQueryVariables>(AccountPayablePaymentsDocument, options);
      }
export function useAccountPayablePaymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountPayablePaymentsQuery, AccountPayablePaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountPayablePaymentsQuery, AccountPayablePaymentsQueryVariables>(AccountPayablePaymentsDocument, options);
        }
// @ts-ignore
export function useAccountPayablePaymentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AccountPayablePaymentsQuery, AccountPayablePaymentsQueryVariables>): Apollo.UseSuspenseQueryResult<AccountPayablePaymentsQuery, AccountPayablePaymentsQueryVariables>;
export function useAccountPayablePaymentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountPayablePaymentsQuery, AccountPayablePaymentsQueryVariables>): Apollo.UseSuspenseQueryResult<AccountPayablePaymentsQuery | undefined, AccountPayablePaymentsQueryVariables>;
export function useAccountPayablePaymentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountPayablePaymentsQuery, AccountPayablePaymentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountPayablePaymentsQuery, AccountPayablePaymentsQueryVariables>(AccountPayablePaymentsDocument, options);
        }
export type AccountPayablePaymentsQueryHookResult = ReturnType<typeof useAccountPayablePaymentsQuery>;
export type AccountPayablePaymentsLazyQueryHookResult = ReturnType<typeof useAccountPayablePaymentsLazyQuery>;
export type AccountPayablePaymentsSuspenseQueryHookResult = ReturnType<typeof useAccountPayablePaymentsSuspenseQuery>;
export type AccountPayablePaymentsQueryResult = Apollo.QueryResult<AccountPayablePaymentsQuery, AccountPayablePaymentsQueryVariables>;
export const UpdateAccountPayablePaymentDocument = gql`
    mutation UpdateAccountPayablePayment($updateAccountPayablePayment: UpdateAccountPayablePaymentInput!) {
  updateAccountPayablePayment(
    updateAccountPayablePayment: $updateAccountPayablePayment
  ) {
    id
  }
}
    `;
export type UpdateAccountPayablePaymentMutationFn = Apollo.MutationFunction<UpdateAccountPayablePaymentMutation, UpdateAccountPayablePaymentMutationVariables>;

/**
 * __useUpdateAccountPayablePaymentMutation__
 *
 * To run a mutation, you first call `useUpdateAccountPayablePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountPayablePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountPayablePaymentMutation, { data, loading, error }] = useUpdateAccountPayablePaymentMutation({
 *   variables: {
 *      updateAccountPayablePayment: // value for 'updateAccountPayablePayment'
 *   },
 * });
 */
export function useUpdateAccountPayablePaymentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccountPayablePaymentMutation, UpdateAccountPayablePaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAccountPayablePaymentMutation, UpdateAccountPayablePaymentMutationVariables>(UpdateAccountPayablePaymentDocument, options);
      }
export type UpdateAccountPayablePaymentMutationHookResult = ReturnType<typeof useUpdateAccountPayablePaymentMutation>;
export type UpdateAccountPayablePaymentMutationResult = Apollo.MutationResult<UpdateAccountPayablePaymentMutation>;
export type UpdateAccountPayablePaymentMutationOptions = Apollo.BaseMutationOptions<UpdateAccountPayablePaymentMutation, UpdateAccountPayablePaymentMutationVariables>;
export const AccountReceivableInvoicesForOptionsDocument = gql`
    query AccountReceivableInvoicesForOptions($page: Int!, $limit: Int!, $locationId: String, $filter: [FilterGroup!] = [{conditions: [{operator: EQUAL, field: "status", value: "POSTED"}], logicalOperator: AND}]) {
  accountReceivableInvoices(
    page: $page
    limit: $limit
    locationId: $locationId
    filter: $filter
  ) {
    data {
      id
      secondaryId
      customerId
      customerName
      partnerId
      partnerName
    }
    meta {
      totalCount
      page
      limit
      total
    }
  }
}
    `;

/**
 * __useAccountReceivableInvoicesForOptionsQuery__
 *
 * To run a query within a React component, call `useAccountReceivableInvoicesForOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountReceivableInvoicesForOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountReceivableInvoicesForOptionsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      locationId: // value for 'locationId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAccountReceivableInvoicesForOptionsQuery(baseOptions: Apollo.QueryHookOptions<AccountReceivableInvoicesForOptionsQuery, AccountReceivableInvoicesForOptionsQueryVariables> & ({ variables: AccountReceivableInvoicesForOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountReceivableInvoicesForOptionsQuery, AccountReceivableInvoicesForOptionsQueryVariables>(AccountReceivableInvoicesForOptionsDocument, options);
      }
export function useAccountReceivableInvoicesForOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountReceivableInvoicesForOptionsQuery, AccountReceivableInvoicesForOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountReceivableInvoicesForOptionsQuery, AccountReceivableInvoicesForOptionsQueryVariables>(AccountReceivableInvoicesForOptionsDocument, options);
        }
// @ts-ignore
export function useAccountReceivableInvoicesForOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AccountReceivableInvoicesForOptionsQuery, AccountReceivableInvoicesForOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<AccountReceivableInvoicesForOptionsQuery, AccountReceivableInvoicesForOptionsQueryVariables>;
export function useAccountReceivableInvoicesForOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountReceivableInvoicesForOptionsQuery, AccountReceivableInvoicesForOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<AccountReceivableInvoicesForOptionsQuery | undefined, AccountReceivableInvoicesForOptionsQueryVariables>;
export function useAccountReceivableInvoicesForOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountReceivableInvoicesForOptionsQuery, AccountReceivableInvoicesForOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountReceivableInvoicesForOptionsQuery, AccountReceivableInvoicesForOptionsQueryVariables>(AccountReceivableInvoicesForOptionsDocument, options);
        }
export type AccountReceivableInvoicesForOptionsQueryHookResult = ReturnType<typeof useAccountReceivableInvoicesForOptionsQuery>;
export type AccountReceivableInvoicesForOptionsLazyQueryHookResult = ReturnType<typeof useAccountReceivableInvoicesForOptionsLazyQuery>;
export type AccountReceivableInvoicesForOptionsSuspenseQueryHookResult = ReturnType<typeof useAccountReceivableInvoicesForOptionsSuspenseQuery>;
export type AccountReceivableInvoicesForOptionsQueryResult = Apollo.QueryResult<AccountReceivableInvoicesForOptionsQuery, AccountReceivableInvoicesForOptionsQueryVariables>;
export const AccountReceivableInvoicesDocument = gql`
    query AccountReceivableInvoices($page: Int!, $limit: Int!, $locationId: String, $sort: [SortCondition!], $filter: [FilterGroup!]) {
  accountReceivableInvoices(
    page: $page
    limit: $limit
    locationId: $locationId
    sort: $sort
    filter: $filter
  ) {
    data {
      id
      secondaryId
      arInvoiceId
      invoiceType
      customerId
      partnerId
      contactOn
      relatedInvoiceId
      relationType
      invoiceDate
      dueDate
      paymentTermsId
      fxRate
      discountTotal
      subtotalAmount
      taxAmount
      whtAmount
      totalAmount
      roundingAdjustment
      outstandingAmount
      writeoffAmount
      journalId
      status
      notes
      locationId
      partnerName
      customerName
      entryMethod
      createdBy
      createdAt
      updatedAt
      lines {
        id
        description
        discountAmount
        lineTotal
        qty
        taxAmount
        unitPrice
        type
      }
      journal {
        journalNo
        id
      }
      locationName
      createdByName
      postedByName
      fiscalPeriodName
      paymentTermsName
      relatedInvoiceSecondaryId
      journalNo
    }
    meta {
      totalCount
      page
      limit
      total
    }
  }
}
    `;

/**
 * __useAccountReceivableInvoicesQuery__
 *
 * To run a query within a React component, call `useAccountReceivableInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountReceivableInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountReceivableInvoicesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      locationId: // value for 'locationId'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAccountReceivableInvoicesQuery(baseOptions: Apollo.QueryHookOptions<AccountReceivableInvoicesQuery, AccountReceivableInvoicesQueryVariables> & ({ variables: AccountReceivableInvoicesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountReceivableInvoicesQuery, AccountReceivableInvoicesQueryVariables>(AccountReceivableInvoicesDocument, options);
      }
export function useAccountReceivableInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountReceivableInvoicesQuery, AccountReceivableInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountReceivableInvoicesQuery, AccountReceivableInvoicesQueryVariables>(AccountReceivableInvoicesDocument, options);
        }
// @ts-ignore
export function useAccountReceivableInvoicesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AccountReceivableInvoicesQuery, AccountReceivableInvoicesQueryVariables>): Apollo.UseSuspenseQueryResult<AccountReceivableInvoicesQuery, AccountReceivableInvoicesQueryVariables>;
export function useAccountReceivableInvoicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountReceivableInvoicesQuery, AccountReceivableInvoicesQueryVariables>): Apollo.UseSuspenseQueryResult<AccountReceivableInvoicesQuery | undefined, AccountReceivableInvoicesQueryVariables>;
export function useAccountReceivableInvoicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountReceivableInvoicesQuery, AccountReceivableInvoicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountReceivableInvoicesQuery, AccountReceivableInvoicesQueryVariables>(AccountReceivableInvoicesDocument, options);
        }
export type AccountReceivableInvoicesQueryHookResult = ReturnType<typeof useAccountReceivableInvoicesQuery>;
export type AccountReceivableInvoicesLazyQueryHookResult = ReturnType<typeof useAccountReceivableInvoicesLazyQuery>;
export type AccountReceivableInvoicesSuspenseQueryHookResult = ReturnType<typeof useAccountReceivableInvoicesSuspenseQuery>;
export type AccountReceivableInvoicesQueryResult = Apollo.QueryResult<AccountReceivableInvoicesQuery, AccountReceivableInvoicesQueryVariables>;
export const AccountReceivableInvoiceDocument = gql`
    query AccountReceivableInvoice($accountReceivableInvoiceId: ID!) {
  accountReceivableInvoice(id: $accountReceivableInvoiceId) {
    id
    secondaryId
    invoiceType
    customerId
    partnerId
    contactOn
    arInvoiceId
    relatedInvoiceId
    relationType
    invoiceDate
    dueDate
    paymentTermsId
    fxRate
    discountTotal
    subtotalAmount
    taxAmount
    whtAmount
    totalAmount
    roundingAdjustment
    outstandingAmount
    writeoffAmount
    journalId
    status
    notes
    locationId
    partnerName
    customerName
    entryMethod
    createdBy
    createdAt
    updatedAt
    aging
    lines {
      id
      secondaryId
      invoiceId
      productId
      description
      qty
      unitPrice
      discountAmount
      taxAmount
      lineTotal
      chartOfAccountsId
      chartOfAccounts {
        id
        accountId
        name
      }
      orderId
      orderLineId
      orderSecondaryId
      type
      locationId
      locationName
      profitCenterId
      costCenterId
      createdAt
      updatedAt
    }
    relatedInvoiceSecondaryId
    paymentTerms {
      id
      name
    }
    locationName
    journalNo
    entityId
  }
}
    `;

/**
 * __useAccountReceivableInvoiceQuery__
 *
 * To run a query within a React component, call `useAccountReceivableInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountReceivableInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountReceivableInvoiceQuery({
 *   variables: {
 *      accountReceivableInvoiceId: // value for 'accountReceivableInvoiceId'
 *   },
 * });
 */
export function useAccountReceivableInvoiceQuery(baseOptions: Apollo.QueryHookOptions<AccountReceivableInvoiceQuery, AccountReceivableInvoiceQueryVariables> & ({ variables: AccountReceivableInvoiceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountReceivableInvoiceQuery, AccountReceivableInvoiceQueryVariables>(AccountReceivableInvoiceDocument, options);
      }
export function useAccountReceivableInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountReceivableInvoiceQuery, AccountReceivableInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountReceivableInvoiceQuery, AccountReceivableInvoiceQueryVariables>(AccountReceivableInvoiceDocument, options);
        }
// @ts-ignore
export function useAccountReceivableInvoiceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AccountReceivableInvoiceQuery, AccountReceivableInvoiceQueryVariables>): Apollo.UseSuspenseQueryResult<AccountReceivableInvoiceQuery, AccountReceivableInvoiceQueryVariables>;
export function useAccountReceivableInvoiceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountReceivableInvoiceQuery, AccountReceivableInvoiceQueryVariables>): Apollo.UseSuspenseQueryResult<AccountReceivableInvoiceQuery | undefined, AccountReceivableInvoiceQueryVariables>;
export function useAccountReceivableInvoiceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountReceivableInvoiceQuery, AccountReceivableInvoiceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountReceivableInvoiceQuery, AccountReceivableInvoiceQueryVariables>(AccountReceivableInvoiceDocument, options);
        }
export type AccountReceivableInvoiceQueryHookResult = ReturnType<typeof useAccountReceivableInvoiceQuery>;
export type AccountReceivableInvoiceLazyQueryHookResult = ReturnType<typeof useAccountReceivableInvoiceLazyQuery>;
export type AccountReceivableInvoiceSuspenseQueryHookResult = ReturnType<typeof useAccountReceivableInvoiceSuspenseQuery>;
export type AccountReceivableInvoiceQueryResult = Apollo.QueryResult<AccountReceivableInvoiceQuery, AccountReceivableInvoiceQueryVariables>;
export const AccountReceivableWriteoffsDocument = gql`
    query AccountReceivableWriteoffs($sort: [SortCondition!], $filter: [FilterGroup!]) {
  accountReceivableWriteoffs(sort: $sort, filter: $filter) {
    data {
      id
      amount
      reason
      reasonCode
      status
      updatedAt
      createdAt
      createdByName
      postedAt
      postedByName
      secondaryId
    }
  }
}
    `;

/**
 * __useAccountReceivableWriteoffsQuery__
 *
 * To run a query within a React component, call `useAccountReceivableWriteoffsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountReceivableWriteoffsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountReceivableWriteoffsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAccountReceivableWriteoffsQuery(baseOptions?: Apollo.QueryHookOptions<AccountReceivableWriteoffsQuery, AccountReceivableWriteoffsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountReceivableWriteoffsQuery, AccountReceivableWriteoffsQueryVariables>(AccountReceivableWriteoffsDocument, options);
      }
export function useAccountReceivableWriteoffsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountReceivableWriteoffsQuery, AccountReceivableWriteoffsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountReceivableWriteoffsQuery, AccountReceivableWriteoffsQueryVariables>(AccountReceivableWriteoffsDocument, options);
        }
// @ts-ignore
export function useAccountReceivableWriteoffsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AccountReceivableWriteoffsQuery, AccountReceivableWriteoffsQueryVariables>): Apollo.UseSuspenseQueryResult<AccountReceivableWriteoffsQuery, AccountReceivableWriteoffsQueryVariables>;
export function useAccountReceivableWriteoffsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountReceivableWriteoffsQuery, AccountReceivableWriteoffsQueryVariables>): Apollo.UseSuspenseQueryResult<AccountReceivableWriteoffsQuery | undefined, AccountReceivableWriteoffsQueryVariables>;
export function useAccountReceivableWriteoffsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountReceivableWriteoffsQuery, AccountReceivableWriteoffsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountReceivableWriteoffsQuery, AccountReceivableWriteoffsQueryVariables>(AccountReceivableWriteoffsDocument, options);
        }
export type AccountReceivableWriteoffsQueryHookResult = ReturnType<typeof useAccountReceivableWriteoffsQuery>;
export type AccountReceivableWriteoffsLazyQueryHookResult = ReturnType<typeof useAccountReceivableWriteoffsLazyQuery>;
export type AccountReceivableWriteoffsSuspenseQueryHookResult = ReturnType<typeof useAccountReceivableWriteoffsSuspenseQuery>;
export type AccountReceivableWriteoffsQueryResult = Apollo.QueryResult<AccountReceivableWriteoffsQuery, AccountReceivableWriteoffsQueryVariables>;
export const CreateAccountReceivableInvoiceDocument = gql`
    mutation CreateAccountReceivableInvoice($createAccountReceivableInvoice: CreateAccountReceivableInvoiceInput!) {
  createAccountReceivableInvoice(
    createAccountReceivableInvoice: $createAccountReceivableInvoice
  ) {
    id
  }
}
    `;
export type CreateAccountReceivableInvoiceMutationFn = Apollo.MutationFunction<CreateAccountReceivableInvoiceMutation, CreateAccountReceivableInvoiceMutationVariables>;

/**
 * __useCreateAccountReceivableInvoiceMutation__
 *
 * To run a mutation, you first call `useCreateAccountReceivableInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountReceivableInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccountReceivableInvoiceMutation, { data, loading, error }] = useCreateAccountReceivableInvoiceMutation({
 *   variables: {
 *      createAccountReceivableInvoice: // value for 'createAccountReceivableInvoice'
 *   },
 * });
 */
export function useCreateAccountReceivableInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<CreateAccountReceivableInvoiceMutation, CreateAccountReceivableInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAccountReceivableInvoiceMutation, CreateAccountReceivableInvoiceMutationVariables>(CreateAccountReceivableInvoiceDocument, options);
      }
export type CreateAccountReceivableInvoiceMutationHookResult = ReturnType<typeof useCreateAccountReceivableInvoiceMutation>;
export type CreateAccountReceivableInvoiceMutationResult = Apollo.MutationResult<CreateAccountReceivableInvoiceMutation>;
export type CreateAccountReceivableInvoiceMutationOptions = Apollo.BaseMutationOptions<CreateAccountReceivableInvoiceMutation, CreateAccountReceivableInvoiceMutationVariables>;
export const UpdateAccountReceivableInvoiceDocument = gql`
    mutation UpdateAccountReceivableInvoice($updateAccountReceivableInvoice: UpdateAccountReceivableInvoiceInput!) {
  updateAccountReceivableInvoice(
    updateAccountReceivableInvoice: $updateAccountReceivableInvoice
  ) {
    id
  }
}
    `;
export type UpdateAccountReceivableInvoiceMutationFn = Apollo.MutationFunction<UpdateAccountReceivableInvoiceMutation, UpdateAccountReceivableInvoiceMutationVariables>;

/**
 * __useUpdateAccountReceivableInvoiceMutation__
 *
 * To run a mutation, you first call `useUpdateAccountReceivableInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountReceivableInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountReceivableInvoiceMutation, { data, loading, error }] = useUpdateAccountReceivableInvoiceMutation({
 *   variables: {
 *      updateAccountReceivableInvoice: // value for 'updateAccountReceivableInvoice'
 *   },
 * });
 */
export function useUpdateAccountReceivableInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccountReceivableInvoiceMutation, UpdateAccountReceivableInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAccountReceivableInvoiceMutation, UpdateAccountReceivableInvoiceMutationVariables>(UpdateAccountReceivableInvoiceDocument, options);
      }
export type UpdateAccountReceivableInvoiceMutationHookResult = ReturnType<typeof useUpdateAccountReceivableInvoiceMutation>;
export type UpdateAccountReceivableInvoiceMutationResult = Apollo.MutationResult<UpdateAccountReceivableInvoiceMutation>;
export type UpdateAccountReceivableInvoiceMutationOptions = Apollo.BaseMutationOptions<UpdateAccountReceivableInvoiceMutation, UpdateAccountReceivableInvoiceMutationVariables>;
export const CreateAccountReceivableWriteoffDocument = gql`
    mutation CreateAccountReceivableWriteoff($createAccountReceivableWriteoff: CreateAccountReceivableWriteoffInput!) {
  createAccountReceivableWriteoff(
    createAccountReceivableWriteoff: $createAccountReceivableWriteoff
  ) {
    id
    status
    amount
    reason
    reasonCode
  }
}
    `;
export type CreateAccountReceivableWriteoffMutationFn = Apollo.MutationFunction<CreateAccountReceivableWriteoffMutation, CreateAccountReceivableWriteoffMutationVariables>;

/**
 * __useCreateAccountReceivableWriteoffMutation__
 *
 * To run a mutation, you first call `useCreateAccountReceivableWriteoffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountReceivableWriteoffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccountReceivableWriteoffMutation, { data, loading, error }] = useCreateAccountReceivableWriteoffMutation({
 *   variables: {
 *      createAccountReceivableWriteoff: // value for 'createAccountReceivableWriteoff'
 *   },
 * });
 */
export function useCreateAccountReceivableWriteoffMutation(baseOptions?: Apollo.MutationHookOptions<CreateAccountReceivableWriteoffMutation, CreateAccountReceivableWriteoffMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAccountReceivableWriteoffMutation, CreateAccountReceivableWriteoffMutationVariables>(CreateAccountReceivableWriteoffDocument, options);
      }
export type CreateAccountReceivableWriteoffMutationHookResult = ReturnType<typeof useCreateAccountReceivableWriteoffMutation>;
export type CreateAccountReceivableWriteoffMutationResult = Apollo.MutationResult<CreateAccountReceivableWriteoffMutation>;
export type CreateAccountReceivableWriteoffMutationOptions = Apollo.BaseMutationOptions<CreateAccountReceivableWriteoffMutation, CreateAccountReceivableWriteoffMutationVariables>;
export const UpdateAccountReceivableWriteoffDocument = gql`
    mutation UpdateAccountReceivableWriteoff($updateAccountReceivableWriteoff: UpdateAccountReceivableWriteoffInput!) {
  updateAccountReceivableWriteoff(
    updateAccountReceivableWriteoff: $updateAccountReceivableWriteoff
  ) {
    id
    status
    amount
    reason
    reasonCode
    updatedAt
  }
}
    `;
export type UpdateAccountReceivableWriteoffMutationFn = Apollo.MutationFunction<UpdateAccountReceivableWriteoffMutation, UpdateAccountReceivableWriteoffMutationVariables>;

/**
 * __useUpdateAccountReceivableWriteoffMutation__
 *
 * To run a mutation, you first call `useUpdateAccountReceivableWriteoffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountReceivableWriteoffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountReceivableWriteoffMutation, { data, loading, error }] = useUpdateAccountReceivableWriteoffMutation({
 *   variables: {
 *      updateAccountReceivableWriteoff: // value for 'updateAccountReceivableWriteoff'
 *   },
 * });
 */
export function useUpdateAccountReceivableWriteoffMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccountReceivableWriteoffMutation, UpdateAccountReceivableWriteoffMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAccountReceivableWriteoffMutation, UpdateAccountReceivableWriteoffMutationVariables>(UpdateAccountReceivableWriteoffDocument, options);
      }
export type UpdateAccountReceivableWriteoffMutationHookResult = ReturnType<typeof useUpdateAccountReceivableWriteoffMutation>;
export type UpdateAccountReceivableWriteoffMutationResult = Apollo.MutationResult<UpdateAccountReceivableWriteoffMutation>;
export type UpdateAccountReceivableWriteoffMutationOptions = Apollo.BaseMutationOptions<UpdateAccountReceivableWriteoffMutation, UpdateAccountReceivableWriteoffMutationVariables>;
export const OutstandingAccountReceivableInvoicesDocument = gql`
    query OutstandingAccountReceivableInvoices($filter: OutstandingInvoiceFilterInput!, $sort: [SortCondition!], $locationId: String, $page: Int, $limit: Int) {
  outstandingAccountReceivableInvoices(
    filter: $filter
    sort: $sort
    locationId: $locationId
    page: $page
    limit: $limit
  ) {
    data {
      id
      invoiceNo
      type
      invoiceDate
      dueDate
      totalAmount
      outstandingAmount
      aging
    }
    meta {
      totalCount
      page
      limit
      total
    }
  }
}
    `;

/**
 * __useOutstandingAccountReceivableInvoicesQuery__
 *
 * To run a query within a React component, call `useOutstandingAccountReceivableInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOutstandingAccountReceivableInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOutstandingAccountReceivableInvoicesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      locationId: // value for 'locationId'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useOutstandingAccountReceivableInvoicesQuery(baseOptions: Apollo.QueryHookOptions<OutstandingAccountReceivableInvoicesQuery, OutstandingAccountReceivableInvoicesQueryVariables> & ({ variables: OutstandingAccountReceivableInvoicesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OutstandingAccountReceivableInvoicesQuery, OutstandingAccountReceivableInvoicesQueryVariables>(OutstandingAccountReceivableInvoicesDocument, options);
      }
export function useOutstandingAccountReceivableInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OutstandingAccountReceivableInvoicesQuery, OutstandingAccountReceivableInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OutstandingAccountReceivableInvoicesQuery, OutstandingAccountReceivableInvoicesQueryVariables>(OutstandingAccountReceivableInvoicesDocument, options);
        }
// @ts-ignore
export function useOutstandingAccountReceivableInvoicesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OutstandingAccountReceivableInvoicesQuery, OutstandingAccountReceivableInvoicesQueryVariables>): Apollo.UseSuspenseQueryResult<OutstandingAccountReceivableInvoicesQuery, OutstandingAccountReceivableInvoicesQueryVariables>;
export function useOutstandingAccountReceivableInvoicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OutstandingAccountReceivableInvoicesQuery, OutstandingAccountReceivableInvoicesQueryVariables>): Apollo.UseSuspenseQueryResult<OutstandingAccountReceivableInvoicesQuery | undefined, OutstandingAccountReceivableInvoicesQueryVariables>;
export function useOutstandingAccountReceivableInvoicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OutstandingAccountReceivableInvoicesQuery, OutstandingAccountReceivableInvoicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OutstandingAccountReceivableInvoicesQuery, OutstandingAccountReceivableInvoicesQueryVariables>(OutstandingAccountReceivableInvoicesDocument, options);
        }
export type OutstandingAccountReceivableInvoicesQueryHookResult = ReturnType<typeof useOutstandingAccountReceivableInvoicesQuery>;
export type OutstandingAccountReceivableInvoicesLazyQueryHookResult = ReturnType<typeof useOutstandingAccountReceivableInvoicesLazyQuery>;
export type OutstandingAccountReceivableInvoicesSuspenseQueryHookResult = ReturnType<typeof useOutstandingAccountReceivableInvoicesSuspenseQuery>;
export type OutstandingAccountReceivableInvoicesQueryResult = Apollo.QueryResult<OutstandingAccountReceivableInvoicesQuery, OutstandingAccountReceivableInvoicesQueryVariables>;
export const CreateAccountReceivableReceiptDocument = gql`
    mutation CreateAccountReceivableReceipt($createAccountReceivableReceipt: CreateAccountReceivableReceiptInput!) {
  createAccountReceivableReceipt(
    createAccountReceivableReceipt: $createAccountReceivableReceipt
  ) {
    __typename
  }
}
    `;
export type CreateAccountReceivableReceiptMutationFn = Apollo.MutationFunction<CreateAccountReceivableReceiptMutation, CreateAccountReceivableReceiptMutationVariables>;

/**
 * __useCreateAccountReceivableReceiptMutation__
 *
 * To run a mutation, you first call `useCreateAccountReceivableReceiptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountReceivableReceiptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccountReceivableReceiptMutation, { data, loading, error }] = useCreateAccountReceivableReceiptMutation({
 *   variables: {
 *      createAccountReceivableReceipt: // value for 'createAccountReceivableReceipt'
 *   },
 * });
 */
export function useCreateAccountReceivableReceiptMutation(baseOptions?: Apollo.MutationHookOptions<CreateAccountReceivableReceiptMutation, CreateAccountReceivableReceiptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAccountReceivableReceiptMutation, CreateAccountReceivableReceiptMutationVariables>(CreateAccountReceivableReceiptDocument, options);
      }
export type CreateAccountReceivableReceiptMutationHookResult = ReturnType<typeof useCreateAccountReceivableReceiptMutation>;
export type CreateAccountReceivableReceiptMutationResult = Apollo.MutationResult<CreateAccountReceivableReceiptMutation>;
export type CreateAccountReceivableReceiptMutationOptions = Apollo.BaseMutationOptions<CreateAccountReceivableReceiptMutation, CreateAccountReceivableReceiptMutationVariables>;
export const UpdateAccountReceivableReceiptDocument = gql`
    mutation UpdateAccountReceivableReceipt($updateAccountReceivableReceipt: UpdateAccountReceivableReceiptInput!) {
  updateAccountReceivableReceipt(
    updateAccountReceivableReceipt: $updateAccountReceivableReceipt
  ) {
    id
  }
}
    `;
export type UpdateAccountReceivableReceiptMutationFn = Apollo.MutationFunction<UpdateAccountReceivableReceiptMutation, UpdateAccountReceivableReceiptMutationVariables>;

/**
 * __useUpdateAccountReceivableReceiptMutation__
 *
 * To run a mutation, you first call `useUpdateAccountReceivableReceiptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountReceivableReceiptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountReceivableReceiptMutation, { data, loading, error }] = useUpdateAccountReceivableReceiptMutation({
 *   variables: {
 *      updateAccountReceivableReceipt: // value for 'updateAccountReceivableReceipt'
 *   },
 * });
 */
export function useUpdateAccountReceivableReceiptMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccountReceivableReceiptMutation, UpdateAccountReceivableReceiptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAccountReceivableReceiptMutation, UpdateAccountReceivableReceiptMutationVariables>(UpdateAccountReceivableReceiptDocument, options);
      }
export type UpdateAccountReceivableReceiptMutationHookResult = ReturnType<typeof useUpdateAccountReceivableReceiptMutation>;
export type UpdateAccountReceivableReceiptMutationResult = Apollo.MutationResult<UpdateAccountReceivableReceiptMutation>;
export type UpdateAccountReceivableReceiptMutationOptions = Apollo.BaseMutationOptions<UpdateAccountReceivableReceiptMutation, UpdateAccountReceivableReceiptMutationVariables>;
export const AccountReceivableReceiptsDocument = gql`
    query AccountReceivableReceipts($sort: [SortCondition!], $filter: [FilterGroup!], $page: Int!, $limit: Int!, $locationId: String) {
  accountReceivableReceipts(
    sort: $sort
    filter: $filter
    page: $page
    limit: $limit
    locationId: $locationId
  ) {
    data {
      id
      secondaryId
      entityId
      arInvoice {
        id
        secondaryId
        arInvoiceId
        invoiceType
        customerId
        partnerId
        invoiceDate
        dueDate
        totalAmount
        outstandingAmount
        status
        customerName
        partnerName
        notes
      }
      customerId
      partnerId
      vendorId
      amountReceived
      mode
      status
      refId
      challanId
      bankId
      bank {
        id
        secondaryId
        name
        accountNumber
      }
      cashId
      chartOfAccountsId
      offsetDescription
      offsetTaxHandling
      journalId
      journal {
        id
        secondaryId
        journalNo
        journalDate
        status
        entityId
      }
      dateReceived
      postedAt
      postedBy
      comment
      advancePayment
      advanceDate
      advanceRemarks
      createdByName
      postedByName
    }
    meta {
      page
      limit
      totalCount
      total
    }
  }
}
    `;

/**
 * __useAccountReceivableReceiptsQuery__
 *
 * To run a query within a React component, call `useAccountReceivableReceiptsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountReceivableReceiptsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountReceivableReceiptsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useAccountReceivableReceiptsQuery(baseOptions: Apollo.QueryHookOptions<AccountReceivableReceiptsQuery, AccountReceivableReceiptsQueryVariables> & ({ variables: AccountReceivableReceiptsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountReceivableReceiptsQuery, AccountReceivableReceiptsQueryVariables>(AccountReceivableReceiptsDocument, options);
      }
export function useAccountReceivableReceiptsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountReceivableReceiptsQuery, AccountReceivableReceiptsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountReceivableReceiptsQuery, AccountReceivableReceiptsQueryVariables>(AccountReceivableReceiptsDocument, options);
        }
// @ts-ignore
export function useAccountReceivableReceiptsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AccountReceivableReceiptsQuery, AccountReceivableReceiptsQueryVariables>): Apollo.UseSuspenseQueryResult<AccountReceivableReceiptsQuery, AccountReceivableReceiptsQueryVariables>;
export function useAccountReceivableReceiptsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountReceivableReceiptsQuery, AccountReceivableReceiptsQueryVariables>): Apollo.UseSuspenseQueryResult<AccountReceivableReceiptsQuery | undefined, AccountReceivableReceiptsQueryVariables>;
export function useAccountReceivableReceiptsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountReceivableReceiptsQuery, AccountReceivableReceiptsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountReceivableReceiptsQuery, AccountReceivableReceiptsQueryVariables>(AccountReceivableReceiptsDocument, options);
        }
export type AccountReceivableReceiptsQueryHookResult = ReturnType<typeof useAccountReceivableReceiptsQuery>;
export type AccountReceivableReceiptsLazyQueryHookResult = ReturnType<typeof useAccountReceivableReceiptsLazyQuery>;
export type AccountReceivableReceiptsSuspenseQueryHookResult = ReturnType<typeof useAccountReceivableReceiptsSuspenseQuery>;
export type AccountReceivableReceiptsQueryResult = Apollo.QueryResult<AccountReceivableReceiptsQuery, AccountReceivableReceiptsQueryVariables>;
export const AccountReceivableReceiptsByInvoiceDocument = gql`
    query AccountReceivableReceiptsByInvoice($arId: ID!, $page: Int!, $limit: Int!, $locationId: String) {
  accountReceivableReceiptsByInvoice(
    arId: $arId
    page: $page
    limit: $limit
    locationId: $locationId
  ) {
    data {
      id
      secondaryId
      customerId
      partnerId
      amountReceived
      mode
      status
      refId
      challanId
      journalId
      dateReceived
      postedAt
      postedBy
      comment
      arInvoice {
        id
      }
    }
    meta {
      page
      limit
      totalCount
      total
    }
  }
}
    `;

/**
 * __useAccountReceivableReceiptsByInvoiceQuery__
 *
 * To run a query within a React component, call `useAccountReceivableReceiptsByInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountReceivableReceiptsByInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountReceivableReceiptsByInvoiceQuery({
 *   variables: {
 *      arId: // value for 'arId'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useAccountReceivableReceiptsByInvoiceQuery(baseOptions: Apollo.QueryHookOptions<AccountReceivableReceiptsByInvoiceQuery, AccountReceivableReceiptsByInvoiceQueryVariables> & ({ variables: AccountReceivableReceiptsByInvoiceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountReceivableReceiptsByInvoiceQuery, AccountReceivableReceiptsByInvoiceQueryVariables>(AccountReceivableReceiptsByInvoiceDocument, options);
      }
export function useAccountReceivableReceiptsByInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountReceivableReceiptsByInvoiceQuery, AccountReceivableReceiptsByInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountReceivableReceiptsByInvoiceQuery, AccountReceivableReceiptsByInvoiceQueryVariables>(AccountReceivableReceiptsByInvoiceDocument, options);
        }
// @ts-ignore
export function useAccountReceivableReceiptsByInvoiceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AccountReceivableReceiptsByInvoiceQuery, AccountReceivableReceiptsByInvoiceQueryVariables>): Apollo.UseSuspenseQueryResult<AccountReceivableReceiptsByInvoiceQuery, AccountReceivableReceiptsByInvoiceQueryVariables>;
export function useAccountReceivableReceiptsByInvoiceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountReceivableReceiptsByInvoiceQuery, AccountReceivableReceiptsByInvoiceQueryVariables>): Apollo.UseSuspenseQueryResult<AccountReceivableReceiptsByInvoiceQuery | undefined, AccountReceivableReceiptsByInvoiceQueryVariables>;
export function useAccountReceivableReceiptsByInvoiceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountReceivableReceiptsByInvoiceQuery, AccountReceivableReceiptsByInvoiceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountReceivableReceiptsByInvoiceQuery, AccountReceivableReceiptsByInvoiceQueryVariables>(AccountReceivableReceiptsByInvoiceDocument, options);
        }
export type AccountReceivableReceiptsByInvoiceQueryHookResult = ReturnType<typeof useAccountReceivableReceiptsByInvoiceQuery>;
export type AccountReceivableReceiptsByInvoiceLazyQueryHookResult = ReturnType<typeof useAccountReceivableReceiptsByInvoiceLazyQuery>;
export type AccountReceivableReceiptsByInvoiceSuspenseQueryHookResult = ReturnType<typeof useAccountReceivableReceiptsByInvoiceSuspenseQuery>;
export type AccountReceivableReceiptsByInvoiceQueryResult = Apollo.QueryResult<AccountReceivableReceiptsByInvoiceQuery, AccountReceivableReceiptsByInvoiceQueryVariables>;
export const AccountReceivableReceiptDocument = gql`
    query AccountReceivableReceipt($accountReceivableReceiptId: ID!) {
  accountReceivableReceipt(id: $accountReceivableReceiptId) {
    id
    secondaryId
    entityId
    arInvoice {
      id
      secondaryId
      arInvoiceId
      invoiceType
      customerId
      partnerId
      contactOn
      invoiceDate
      dueDate
      paymentTermsId
      fxRate
      discountTotal
      subtotalAmount
      taxAmount
      whtAmount
      totalAmount
      roundingAdjustment
      outstandingAmount
      writeoffAmount
      journalId
      status
      notes
      locationId
      partnerName
      customerName
      entryMethod
      createdBy
      createdAt
      updatedAt
      lines {
        id
        secondaryId
        invoiceId
        description
        qty
        unitPrice
        discountAmount
        taxAmount
        lineTotal
        type
      }
    }
    customerId
    customerName
    partnerId
    partnerName
    vendorId
    createdByName
    createdAt
    amountReceived
    mode
    status
    refId
    challanId
    bankId
    bank {
      id
      secondaryId
      name
      accountNumber
      entityId
      entity {
        entityName
      }
      coaAccount {
        accountId
        name
      }
    }
    cashId
    cash {
      id
      code
      name
      coaAccount {
        accountId
        name
      }
    }
    chartOfAccountsId
    chartOfAccounts {
      accountId
      name
    }
    offsetDescription
    offsetTaxHandling
    journalId
    journal {
      id
      secondaryId
      journalNo
      journalDate
      status
      entityId
      lines {
        id
        description
        debit
        credit
        account {
          accountId
          name
        }
      }
    }
    dateReceived
    postedAt
    postedBy
    postedByName
    comment
    advancePayment
    advanceDate
    advanceRemarks
    settlementLines {
      id
      secondaryId
      invoiceId
      invoice {
        id
        secondaryId
        arInvoiceId
        status
      }
      allocatedAmount
      allocationDate
      notes
      fxAllocatedAmount
      fromType
      status
      receiptId
      dueDate
      aging
      outstandingAmount
      totalAmount
      settlementAllocatedAmount
    }
  }
}
    `;

/**
 * __useAccountReceivableReceiptQuery__
 *
 * To run a query within a React component, call `useAccountReceivableReceiptQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountReceivableReceiptQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountReceivableReceiptQuery({
 *   variables: {
 *      accountReceivableReceiptId: // value for 'accountReceivableReceiptId'
 *   },
 * });
 */
export function useAccountReceivableReceiptQuery(baseOptions: Apollo.QueryHookOptions<AccountReceivableReceiptQuery, AccountReceivableReceiptQueryVariables> & ({ variables: AccountReceivableReceiptQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountReceivableReceiptQuery, AccountReceivableReceiptQueryVariables>(AccountReceivableReceiptDocument, options);
      }
export function useAccountReceivableReceiptLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountReceivableReceiptQuery, AccountReceivableReceiptQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountReceivableReceiptQuery, AccountReceivableReceiptQueryVariables>(AccountReceivableReceiptDocument, options);
        }
// @ts-ignore
export function useAccountReceivableReceiptSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AccountReceivableReceiptQuery, AccountReceivableReceiptQueryVariables>): Apollo.UseSuspenseQueryResult<AccountReceivableReceiptQuery, AccountReceivableReceiptQueryVariables>;
export function useAccountReceivableReceiptSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountReceivableReceiptQuery, AccountReceivableReceiptQueryVariables>): Apollo.UseSuspenseQueryResult<AccountReceivableReceiptQuery | undefined, AccountReceivableReceiptQueryVariables>;
export function useAccountReceivableReceiptSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountReceivableReceiptQuery, AccountReceivableReceiptQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountReceivableReceiptQuery, AccountReceivableReceiptQueryVariables>(AccountReceivableReceiptDocument, options);
        }
export type AccountReceivableReceiptQueryHookResult = ReturnType<typeof useAccountReceivableReceiptQuery>;
export type AccountReceivableReceiptLazyQueryHookResult = ReturnType<typeof useAccountReceivableReceiptLazyQuery>;
export type AccountReceivableReceiptSuspenseQueryHookResult = ReturnType<typeof useAccountReceivableReceiptSuspenseQuery>;
export type AccountReceivableReceiptQueryResult = Apollo.QueryResult<AccountReceivableReceiptQuery, AccountReceivableReceiptQueryVariables>;
export const BalanceSheetReportDocument = gql`
    query BalanceSheetReport($entityId: ID!, $asOfDate: DateTime!, $costCenterIds: [ID!], $profitCenterIds: [ID!], $locationIds: [ID!]) {
  balanceSheetReport(
    entityId: $entityId
    asOfDate: $asOfDate
    costCenterIds: $costCenterIds
    profitCenterIds: $profitCenterIds
    locationIds: $locationIds
  ) {
    totalAssets
    totalLiabilities
    totalEquity
    netIncome
    isBalanced
    asOfDate
    currency
    rows {
      accountId
      accountCode
      accountName
      parentAccountId
      level
      isGroup
      accountType
      debit
      credit
      balance
    }
  }
}
    `;

/**
 * __useBalanceSheetReportQuery__
 *
 * To run a query within a React component, call `useBalanceSheetReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useBalanceSheetReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBalanceSheetReportQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      asOfDate: // value for 'asOfDate'
 *      costCenterIds: // value for 'costCenterIds'
 *      profitCenterIds: // value for 'profitCenterIds'
 *      locationIds: // value for 'locationIds'
 *   },
 * });
 */
export function useBalanceSheetReportQuery(baseOptions: Apollo.QueryHookOptions<BalanceSheetReportQuery, BalanceSheetReportQueryVariables> & ({ variables: BalanceSheetReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BalanceSheetReportQuery, BalanceSheetReportQueryVariables>(BalanceSheetReportDocument, options);
      }
export function useBalanceSheetReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BalanceSheetReportQuery, BalanceSheetReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BalanceSheetReportQuery, BalanceSheetReportQueryVariables>(BalanceSheetReportDocument, options);
        }
// @ts-ignore
export function useBalanceSheetReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BalanceSheetReportQuery, BalanceSheetReportQueryVariables>): Apollo.UseSuspenseQueryResult<BalanceSheetReportQuery, BalanceSheetReportQueryVariables>;
export function useBalanceSheetReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BalanceSheetReportQuery, BalanceSheetReportQueryVariables>): Apollo.UseSuspenseQueryResult<BalanceSheetReportQuery | undefined, BalanceSheetReportQueryVariables>;
export function useBalanceSheetReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BalanceSheetReportQuery, BalanceSheetReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BalanceSheetReportQuery, BalanceSheetReportQueryVariables>(BalanceSheetReportDocument, options);
        }
export type BalanceSheetReportQueryHookResult = ReturnType<typeof useBalanceSheetReportQuery>;
export type BalanceSheetReportLazyQueryHookResult = ReturnType<typeof useBalanceSheetReportLazyQuery>;
export type BalanceSheetReportSuspenseQueryHookResult = ReturnType<typeof useBalanceSheetReportSuspenseQuery>;
export type BalanceSheetReportQueryResult = Apollo.QueryResult<BalanceSheetReportQuery, BalanceSheetReportQueryVariables>;
export const CreateBankAccountDocument = gql`
    mutation CreateBankAccount($createBankAccount: CreateBankAccountInput!) {
  createBankAccount(createBankAccount: $createBankAccount) {
    id
  }
}
    `;
export type CreateBankAccountMutationFn = Apollo.MutationFunction<CreateBankAccountMutation, CreateBankAccountMutationVariables>;

/**
 * __useCreateBankAccountMutation__
 *
 * To run a mutation, you first call `useCreateBankAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBankAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBankAccountMutation, { data, loading, error }] = useCreateBankAccountMutation({
 *   variables: {
 *      createBankAccount: // value for 'createBankAccount'
 *   },
 * });
 */
export function useCreateBankAccountMutation(baseOptions?: Apollo.MutationHookOptions<CreateBankAccountMutation, CreateBankAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBankAccountMutation, CreateBankAccountMutationVariables>(CreateBankAccountDocument, options);
      }
export type CreateBankAccountMutationHookResult = ReturnType<typeof useCreateBankAccountMutation>;
export type CreateBankAccountMutationResult = Apollo.MutationResult<CreateBankAccountMutation>;
export type CreateBankAccountMutationOptions = Apollo.BaseMutationOptions<CreateBankAccountMutation, CreateBankAccountMutationVariables>;
export const UpdateBankAccountDocument = gql`
    mutation UpdateBankAccount($updateBankAccount: UpdateBankAccountInput!) {
  updateBankAccount(updateBankAccount: $updateBankAccount) {
    id
  }
}
    `;
export type UpdateBankAccountMutationFn = Apollo.MutationFunction<UpdateBankAccountMutation, UpdateBankAccountMutationVariables>;

/**
 * __useUpdateBankAccountMutation__
 *
 * To run a mutation, you first call `useUpdateBankAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBankAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBankAccountMutation, { data, loading, error }] = useUpdateBankAccountMutation({
 *   variables: {
 *      updateBankAccount: // value for 'updateBankAccount'
 *   },
 * });
 */
export function useUpdateBankAccountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBankAccountMutation, UpdateBankAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBankAccountMutation, UpdateBankAccountMutationVariables>(UpdateBankAccountDocument, options);
      }
export type UpdateBankAccountMutationHookResult = ReturnType<typeof useUpdateBankAccountMutation>;
export type UpdateBankAccountMutationResult = Apollo.MutationResult<UpdateBankAccountMutation>;
export type UpdateBankAccountMutationOptions = Apollo.BaseMutationOptions<UpdateBankAccountMutation, UpdateBankAccountMutationVariables>;
export const DeleteBankAccountDocument = gql`
    mutation DeleteBankAccount($deleteBankAccountId: ID!) {
  deleteBankAccount(id: $deleteBankAccountId)
}
    `;
export type DeleteBankAccountMutationFn = Apollo.MutationFunction<DeleteBankAccountMutation, DeleteBankAccountMutationVariables>;

/**
 * __useDeleteBankAccountMutation__
 *
 * To run a mutation, you first call `useDeleteBankAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBankAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBankAccountMutation, { data, loading, error }] = useDeleteBankAccountMutation({
 *   variables: {
 *      deleteBankAccountId: // value for 'deleteBankAccountId'
 *   },
 * });
 */
export function useDeleteBankAccountMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBankAccountMutation, DeleteBankAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBankAccountMutation, DeleteBankAccountMutationVariables>(DeleteBankAccountDocument, options);
      }
export type DeleteBankAccountMutationHookResult = ReturnType<typeof useDeleteBankAccountMutation>;
export type DeleteBankAccountMutationResult = Apollo.MutationResult<DeleteBankAccountMutation>;
export type DeleteBankAccountMutationOptions = Apollo.BaseMutationOptions<DeleteBankAccountMutation, DeleteBankAccountMutationVariables>;
export const BankAccountsDocument = gql`
    query BankAccounts($locationId: String, $limit: Int!, $page: Int!, $filter: [FilterGroup!], $sort: [SortCondition!]) {
  bankAccounts(
    locationId: $locationId
    limit: $limit
    page: $page
    filter: $filter
    sort: $sort
  ) {
    meta {
      page
      limit
      totalCount
      total
    }
    data {
      id
      secondaryId
      name
      accountNumber
      accountTitle
      currency
      coaAccountId
      openingBalance
      openingBalanceDate
      status
      entityId
      createdAt
      createdByName
      updatedAt
      updatedByName
      coaAccount {
        id
        name
      }
      entity {
        id
        entityName
      }
      locations {
        locationName
        locationId
      }
    }
  }
}
    `;

/**
 * __useBankAccountsQuery__
 *
 * To run a query within a React component, call `useBankAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBankAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBankAccountsQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useBankAccountsQuery(baseOptions: Apollo.QueryHookOptions<BankAccountsQuery, BankAccountsQueryVariables> & ({ variables: BankAccountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BankAccountsQuery, BankAccountsQueryVariables>(BankAccountsDocument, options);
      }
export function useBankAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BankAccountsQuery, BankAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BankAccountsQuery, BankAccountsQueryVariables>(BankAccountsDocument, options);
        }
// @ts-ignore
export function useBankAccountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BankAccountsQuery, BankAccountsQueryVariables>): Apollo.UseSuspenseQueryResult<BankAccountsQuery, BankAccountsQueryVariables>;
export function useBankAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BankAccountsQuery, BankAccountsQueryVariables>): Apollo.UseSuspenseQueryResult<BankAccountsQuery | undefined, BankAccountsQueryVariables>;
export function useBankAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BankAccountsQuery, BankAccountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BankAccountsQuery, BankAccountsQueryVariables>(BankAccountsDocument, options);
        }
export type BankAccountsQueryHookResult = ReturnType<typeof useBankAccountsQuery>;
export type BankAccountsLazyQueryHookResult = ReturnType<typeof useBankAccountsLazyQuery>;
export type BankAccountsSuspenseQueryHookResult = ReturnType<typeof useBankAccountsSuspenseQuery>;
export type BankAccountsQueryResult = Apollo.QueryResult<BankAccountsQuery, BankAccountsQueryVariables>;
export const BankAccountsForOptionsDocument = gql`
    query BankAccountsForOptions($locationId: String, $limit: Int!, $page: Int!, $filter: [FilterGroup!], $sort: [SortCondition!]) {
  bankAccounts(
    locationId: $locationId
    limit: $limit
    page: $page
    filter: $filter
    sort: $sort
  ) {
    meta {
      page
      limit
      totalCount
    }
    data {
      id
      secondaryId
      name
    }
  }
}
    `;

/**
 * __useBankAccountsForOptionsQuery__
 *
 * To run a query within a React component, call `useBankAccountsForOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBankAccountsForOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBankAccountsForOptionsQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useBankAccountsForOptionsQuery(baseOptions: Apollo.QueryHookOptions<BankAccountsForOptionsQuery, BankAccountsForOptionsQueryVariables> & ({ variables: BankAccountsForOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BankAccountsForOptionsQuery, BankAccountsForOptionsQueryVariables>(BankAccountsForOptionsDocument, options);
      }
export function useBankAccountsForOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BankAccountsForOptionsQuery, BankAccountsForOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BankAccountsForOptionsQuery, BankAccountsForOptionsQueryVariables>(BankAccountsForOptionsDocument, options);
        }
// @ts-ignore
export function useBankAccountsForOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BankAccountsForOptionsQuery, BankAccountsForOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<BankAccountsForOptionsQuery, BankAccountsForOptionsQueryVariables>;
export function useBankAccountsForOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BankAccountsForOptionsQuery, BankAccountsForOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<BankAccountsForOptionsQuery | undefined, BankAccountsForOptionsQueryVariables>;
export function useBankAccountsForOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BankAccountsForOptionsQuery, BankAccountsForOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BankAccountsForOptionsQuery, BankAccountsForOptionsQueryVariables>(BankAccountsForOptionsDocument, options);
        }
export type BankAccountsForOptionsQueryHookResult = ReturnType<typeof useBankAccountsForOptionsQuery>;
export type BankAccountsForOptionsLazyQueryHookResult = ReturnType<typeof useBankAccountsForOptionsLazyQuery>;
export type BankAccountsForOptionsSuspenseQueryHookResult = ReturnType<typeof useBankAccountsForOptionsSuspenseQuery>;
export type BankAccountsForOptionsQueryResult = Apollo.QueryResult<BankAccountsForOptionsQuery, BankAccountsForOptionsQueryVariables>;
export const BankAccountDocument = gql`
    query BankAccount($bankAccountId: ID!) {
  bankAccount(id: $bankAccountId) {
    id
    secondaryId
    name
    currency
    accountNumber
    accountTitle
    coaAccountId
    openingBalance
    openingBalanceDate
    status
    entityId
    createdAt
    createdByName
    updatedAt
    updatedByName
    entity {
      id
      entityName
    }
    coaAccount {
      id
      name
    }
    locations {
      locationId
      locationName
      id
    }
  }
}
    `;

/**
 * __useBankAccountQuery__
 *
 * To run a query within a React component, call `useBankAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useBankAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBankAccountQuery({
 *   variables: {
 *      bankAccountId: // value for 'bankAccountId'
 *   },
 * });
 */
export function useBankAccountQuery(baseOptions: Apollo.QueryHookOptions<BankAccountQuery, BankAccountQueryVariables> & ({ variables: BankAccountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BankAccountQuery, BankAccountQueryVariables>(BankAccountDocument, options);
      }
export function useBankAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BankAccountQuery, BankAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BankAccountQuery, BankAccountQueryVariables>(BankAccountDocument, options);
        }
// @ts-ignore
export function useBankAccountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BankAccountQuery, BankAccountQueryVariables>): Apollo.UseSuspenseQueryResult<BankAccountQuery, BankAccountQueryVariables>;
export function useBankAccountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BankAccountQuery, BankAccountQueryVariables>): Apollo.UseSuspenseQueryResult<BankAccountQuery | undefined, BankAccountQueryVariables>;
export function useBankAccountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BankAccountQuery, BankAccountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BankAccountQuery, BankAccountQueryVariables>(BankAccountDocument, options);
        }
export type BankAccountQueryHookResult = ReturnType<typeof useBankAccountQuery>;
export type BankAccountLazyQueryHookResult = ReturnType<typeof useBankAccountLazyQuery>;
export type BankAccountSuspenseQueryHookResult = ReturnType<typeof useBankAccountSuspenseQuery>;
export type BankAccountQueryResult = Apollo.QueryResult<BankAccountQuery, BankAccountQueryVariables>;
export const CreateCashAccountDocument = gql`
    mutation CreateCashAccount($createCashAccount: CreateCashAccountInput!) {
  createCashAccount(createCashAccount: $createCashAccount) {
    id
  }
}
    `;
export type CreateCashAccountMutationFn = Apollo.MutationFunction<CreateCashAccountMutation, CreateCashAccountMutationVariables>;

/**
 * __useCreateCashAccountMutation__
 *
 * To run a mutation, you first call `useCreateCashAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCashAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCashAccountMutation, { data, loading, error }] = useCreateCashAccountMutation({
 *   variables: {
 *      createCashAccount: // value for 'createCashAccount'
 *   },
 * });
 */
export function useCreateCashAccountMutation(baseOptions?: Apollo.MutationHookOptions<CreateCashAccountMutation, CreateCashAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCashAccountMutation, CreateCashAccountMutationVariables>(CreateCashAccountDocument, options);
      }
export type CreateCashAccountMutationHookResult = ReturnType<typeof useCreateCashAccountMutation>;
export type CreateCashAccountMutationResult = Apollo.MutationResult<CreateCashAccountMutation>;
export type CreateCashAccountMutationOptions = Apollo.BaseMutationOptions<CreateCashAccountMutation, CreateCashAccountMutationVariables>;
export const UpdateCashAccountDocument = gql`
    mutation UpdateCashAccount($updateCashAccount: UpdateCashAccountInput!) {
  updateCashAccount(updateCashAccount: $updateCashAccount) {
    id
  }
}
    `;
export type UpdateCashAccountMutationFn = Apollo.MutationFunction<UpdateCashAccountMutation, UpdateCashAccountMutationVariables>;

/**
 * __useUpdateCashAccountMutation__
 *
 * To run a mutation, you first call `useUpdateCashAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCashAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCashAccountMutation, { data, loading, error }] = useUpdateCashAccountMutation({
 *   variables: {
 *      updateCashAccount: // value for 'updateCashAccount'
 *   },
 * });
 */
export function useUpdateCashAccountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCashAccountMutation, UpdateCashAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCashAccountMutation, UpdateCashAccountMutationVariables>(UpdateCashAccountDocument, options);
      }
export type UpdateCashAccountMutationHookResult = ReturnType<typeof useUpdateCashAccountMutation>;
export type UpdateCashAccountMutationResult = Apollo.MutationResult<UpdateCashAccountMutation>;
export type UpdateCashAccountMutationOptions = Apollo.BaseMutationOptions<UpdateCashAccountMutation, UpdateCashAccountMutationVariables>;
export const CashAccountsListDocument = gql`
    query CashAccountsList($locationId: String, $limit: Int!, $page: Int!, $sort: [SortCondition!], $filter: [FilterGroup!]) {
  cashAccounts(
    locationId: $locationId
    limit: $limit
    page: $page
    sort: $sort
    filter: $filter
  ) {
    meta {
      page
      limit
      totalCount
      total
    }
    data {
      id
      secondaryId
      code
      cashRegister
      name
      financeDrawerId
      currency
      coaAccountId
      status
      entityId
      createdAt
      createdBy
      locations {
        locationId
        id
      }
      entity {
        id
        entityName
      }
      coaAccount {
        id
        name
      }
      posRegisterMaps {
        posRegisterId
        id
      }
    }
  }
}
    `;

/**
 * __useCashAccountsListQuery__
 *
 * To run a query within a React component, call `useCashAccountsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCashAccountsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCashAccountsListQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCashAccountsListQuery(baseOptions: Apollo.QueryHookOptions<CashAccountsListQuery, CashAccountsListQueryVariables> & ({ variables: CashAccountsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CashAccountsListQuery, CashAccountsListQueryVariables>(CashAccountsListDocument, options);
      }
export function useCashAccountsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CashAccountsListQuery, CashAccountsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CashAccountsListQuery, CashAccountsListQueryVariables>(CashAccountsListDocument, options);
        }
// @ts-ignore
export function useCashAccountsListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CashAccountsListQuery, CashAccountsListQueryVariables>): Apollo.UseSuspenseQueryResult<CashAccountsListQuery, CashAccountsListQueryVariables>;
export function useCashAccountsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CashAccountsListQuery, CashAccountsListQueryVariables>): Apollo.UseSuspenseQueryResult<CashAccountsListQuery | undefined, CashAccountsListQueryVariables>;
export function useCashAccountsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CashAccountsListQuery, CashAccountsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CashAccountsListQuery, CashAccountsListQueryVariables>(CashAccountsListDocument, options);
        }
export type CashAccountsListQueryHookResult = ReturnType<typeof useCashAccountsListQuery>;
export type CashAccountsListLazyQueryHookResult = ReturnType<typeof useCashAccountsListLazyQuery>;
export type CashAccountsListSuspenseQueryHookResult = ReturnType<typeof useCashAccountsListSuspenseQuery>;
export type CashAccountsListQueryResult = Apollo.QueryResult<CashAccountsListQuery, CashAccountsListQueryVariables>;
export const CashAccountsForOptionsDocument = gql`
    query CashAccountsForOptions($locationId: String, $limit: Int!, $page: Int!, $sort: [SortCondition!], $filter: [FilterGroup!]) {
  cashAccounts(
    locationId: $locationId
    limit: $limit
    page: $page
    sort: $sort
    filter: $filter
  ) {
    meta {
      page
      limit
      totalCount
    }
    data {
      id
      secondaryId
      name
    }
  }
}
    `;

/**
 * __useCashAccountsForOptionsQuery__
 *
 * To run a query within a React component, call `useCashAccountsForOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCashAccountsForOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCashAccountsForOptionsQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCashAccountsForOptionsQuery(baseOptions: Apollo.QueryHookOptions<CashAccountsForOptionsQuery, CashAccountsForOptionsQueryVariables> & ({ variables: CashAccountsForOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CashAccountsForOptionsQuery, CashAccountsForOptionsQueryVariables>(CashAccountsForOptionsDocument, options);
      }
export function useCashAccountsForOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CashAccountsForOptionsQuery, CashAccountsForOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CashAccountsForOptionsQuery, CashAccountsForOptionsQueryVariables>(CashAccountsForOptionsDocument, options);
        }
// @ts-ignore
export function useCashAccountsForOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CashAccountsForOptionsQuery, CashAccountsForOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<CashAccountsForOptionsQuery, CashAccountsForOptionsQueryVariables>;
export function useCashAccountsForOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CashAccountsForOptionsQuery, CashAccountsForOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<CashAccountsForOptionsQuery | undefined, CashAccountsForOptionsQueryVariables>;
export function useCashAccountsForOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CashAccountsForOptionsQuery, CashAccountsForOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CashAccountsForOptionsQuery, CashAccountsForOptionsQueryVariables>(CashAccountsForOptionsDocument, options);
        }
export type CashAccountsForOptionsQueryHookResult = ReturnType<typeof useCashAccountsForOptionsQuery>;
export type CashAccountsForOptionsLazyQueryHookResult = ReturnType<typeof useCashAccountsForOptionsLazyQuery>;
export type CashAccountsForOptionsSuspenseQueryHookResult = ReturnType<typeof useCashAccountsForOptionsSuspenseQuery>;
export type CashAccountsForOptionsQueryResult = Apollo.QueryResult<CashAccountsForOptionsQuery, CashAccountsForOptionsQueryVariables>;
export const CashAccountDetailDocument = gql`
    query CashAccountDetail($cashAccountId: ID!) {
  cashAccount(id: $cashAccountId) {
    id
    secondaryId
    code
    cashRegister
    name
    financeDrawerId
    currency
    coaAccountId
    status
    entityId
    createdAt
    createdBy
    locations {
      locationId
      id
    }
    entity {
      id
      entityName
    }
    coaAccount {
      id
      name
    }
    posRegisterMaps {
      posRegisterId
      id
    }
  }
}
    `;

/**
 * __useCashAccountDetailQuery__
 *
 * To run a query within a React component, call `useCashAccountDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCashAccountDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCashAccountDetailQuery({
 *   variables: {
 *      cashAccountId: // value for 'cashAccountId'
 *   },
 * });
 */
export function useCashAccountDetailQuery(baseOptions: Apollo.QueryHookOptions<CashAccountDetailQuery, CashAccountDetailQueryVariables> & ({ variables: CashAccountDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CashAccountDetailQuery, CashAccountDetailQueryVariables>(CashAccountDetailDocument, options);
      }
export function useCashAccountDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CashAccountDetailQuery, CashAccountDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CashAccountDetailQuery, CashAccountDetailQueryVariables>(CashAccountDetailDocument, options);
        }
// @ts-ignore
export function useCashAccountDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CashAccountDetailQuery, CashAccountDetailQueryVariables>): Apollo.UseSuspenseQueryResult<CashAccountDetailQuery, CashAccountDetailQueryVariables>;
export function useCashAccountDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CashAccountDetailQuery, CashAccountDetailQueryVariables>): Apollo.UseSuspenseQueryResult<CashAccountDetailQuery | undefined, CashAccountDetailQueryVariables>;
export function useCashAccountDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CashAccountDetailQuery, CashAccountDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CashAccountDetailQuery, CashAccountDetailQueryVariables>(CashAccountDetailDocument, options);
        }
export type CashAccountDetailQueryHookResult = ReturnType<typeof useCashAccountDetailQuery>;
export type CashAccountDetailLazyQueryHookResult = ReturnType<typeof useCashAccountDetailLazyQuery>;
export type CashAccountDetailSuspenseQueryHookResult = ReturnType<typeof useCashAccountDetailSuspenseQuery>;
export type CashAccountDetailQueryResult = Apollo.QueryResult<CashAccountDetailQuery, CashAccountDetailQueryVariables>;
export const CashDepositControlsDocument = gql`
    query CashDepositControls($filter: CashDepositControlFilter!) {
  cashDepositControls(filter: $filter) {
    id
    entityId
    locationId
    businessDate
    expectedCashAmount
    netDepositableCashAmount
    alreadyDepositedAmount
    remainingDepositAmount
    status
  }
}
    `;

/**
 * __useCashDepositControlsQuery__
 *
 * To run a query within a React component, call `useCashDepositControlsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCashDepositControlsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCashDepositControlsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCashDepositControlsQuery(baseOptions: Apollo.QueryHookOptions<CashDepositControlsQuery, CashDepositControlsQueryVariables> & ({ variables: CashDepositControlsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CashDepositControlsQuery, CashDepositControlsQueryVariables>(CashDepositControlsDocument, options);
      }
export function useCashDepositControlsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CashDepositControlsQuery, CashDepositControlsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CashDepositControlsQuery, CashDepositControlsQueryVariables>(CashDepositControlsDocument, options);
        }
// @ts-ignore
export function useCashDepositControlsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CashDepositControlsQuery, CashDepositControlsQueryVariables>): Apollo.UseSuspenseQueryResult<CashDepositControlsQuery, CashDepositControlsQueryVariables>;
export function useCashDepositControlsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CashDepositControlsQuery, CashDepositControlsQueryVariables>): Apollo.UseSuspenseQueryResult<CashDepositControlsQuery | undefined, CashDepositControlsQueryVariables>;
export function useCashDepositControlsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CashDepositControlsQuery, CashDepositControlsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CashDepositControlsQuery, CashDepositControlsQueryVariables>(CashDepositControlsDocument, options);
        }
export type CashDepositControlsQueryHookResult = ReturnType<typeof useCashDepositControlsQuery>;
export type CashDepositControlsLazyQueryHookResult = ReturnType<typeof useCashDepositControlsLazyQuery>;
export type CashDepositControlsSuspenseQueryHookResult = ReturnType<typeof useCashDepositControlsSuspenseQuery>;
export type CashDepositControlsQueryResult = Apollo.QueryResult<CashDepositControlsQuery, CashDepositControlsQueryVariables>;
export const CashDepositsDocument = gql`
    query CashDeposits($controlId: ID!) {
  cashDeposits(controlId: $controlId) {
    id
    depositNo
    depositDate
    depositAmount
    bankAccountId
    depositSlipNo
    status
    postedBy
    postedByName
    postedAt
  }
}
    `;

/**
 * __useCashDepositsQuery__
 *
 * To run a query within a React component, call `useCashDepositsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCashDepositsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCashDepositsQuery({
 *   variables: {
 *      controlId: // value for 'controlId'
 *   },
 * });
 */
export function useCashDepositsQuery(baseOptions: Apollo.QueryHookOptions<CashDepositsQuery, CashDepositsQueryVariables> & ({ variables: CashDepositsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CashDepositsQuery, CashDepositsQueryVariables>(CashDepositsDocument, options);
      }
export function useCashDepositsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CashDepositsQuery, CashDepositsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CashDepositsQuery, CashDepositsQueryVariables>(CashDepositsDocument, options);
        }
// @ts-ignore
export function useCashDepositsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CashDepositsQuery, CashDepositsQueryVariables>): Apollo.UseSuspenseQueryResult<CashDepositsQuery, CashDepositsQueryVariables>;
export function useCashDepositsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CashDepositsQuery, CashDepositsQueryVariables>): Apollo.UseSuspenseQueryResult<CashDepositsQuery | undefined, CashDepositsQueryVariables>;
export function useCashDepositsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CashDepositsQuery, CashDepositsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CashDepositsQuery, CashDepositsQueryVariables>(CashDepositsDocument, options);
        }
export type CashDepositsQueryHookResult = ReturnType<typeof useCashDepositsQuery>;
export type CashDepositsLazyQueryHookResult = ReturnType<typeof useCashDepositsLazyQuery>;
export type CashDepositsSuspenseQueryHookResult = ReturnType<typeof useCashDepositsSuspenseQuery>;
export type CashDepositsQueryResult = Apollo.QueryResult<CashDepositsQuery, CashDepositsQueryVariables>;
export const CashDepositConfigDocument = gql`
    query CashDepositConfig($entityId: ID!) {
  cashDepositConfig(entityId: $entityId) {
    id
    entityId
    allowRegisterLines
    allowOverDeposit
    status
  }
}
    `;

/**
 * __useCashDepositConfigQuery__
 *
 * To run a query within a React component, call `useCashDepositConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useCashDepositConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCashDepositConfigQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useCashDepositConfigQuery(baseOptions: Apollo.QueryHookOptions<CashDepositConfigQuery, CashDepositConfigQueryVariables> & ({ variables: CashDepositConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CashDepositConfigQuery, CashDepositConfigQueryVariables>(CashDepositConfigDocument, options);
      }
export function useCashDepositConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CashDepositConfigQuery, CashDepositConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CashDepositConfigQuery, CashDepositConfigQueryVariables>(CashDepositConfigDocument, options);
        }
// @ts-ignore
export function useCashDepositConfigSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CashDepositConfigQuery, CashDepositConfigQueryVariables>): Apollo.UseSuspenseQueryResult<CashDepositConfigQuery, CashDepositConfigQueryVariables>;
export function useCashDepositConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CashDepositConfigQuery, CashDepositConfigQueryVariables>): Apollo.UseSuspenseQueryResult<CashDepositConfigQuery | undefined, CashDepositConfigQueryVariables>;
export function useCashDepositConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CashDepositConfigQuery, CashDepositConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CashDepositConfigQuery, CashDepositConfigQueryVariables>(CashDepositConfigDocument, options);
        }
export type CashDepositConfigQueryHookResult = ReturnType<typeof useCashDepositConfigQuery>;
export type CashDepositConfigLazyQueryHookResult = ReturnType<typeof useCashDepositConfigLazyQuery>;
export type CashDepositConfigSuspenseQueryHookResult = ReturnType<typeof useCashDepositConfigSuspenseQuery>;
export type CashDepositConfigQueryResult = Apollo.QueryResult<CashDepositConfigQuery, CashDepositConfigQueryVariables>;
export const GenerateDepositControlDocument = gql`
    mutation GenerateDepositControl($input: GenerateDepositControlInput!) {
  generateDepositControl(input: $input) {
    id
    status
    expectedCashAmount
    netDepositableCashAmount
  }
}
    `;
export type GenerateDepositControlMutationFn = Apollo.MutationFunction<GenerateDepositControlMutation, GenerateDepositControlMutationVariables>;

/**
 * __useGenerateDepositControlMutation__
 *
 * To run a mutation, you first call `useGenerateDepositControlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateDepositControlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateDepositControlMutation, { data, loading, error }] = useGenerateDepositControlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateDepositControlMutation(baseOptions?: Apollo.MutationHookOptions<GenerateDepositControlMutation, GenerateDepositControlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateDepositControlMutation, GenerateDepositControlMutationVariables>(GenerateDepositControlDocument, options);
      }
export type GenerateDepositControlMutationHookResult = ReturnType<typeof useGenerateDepositControlMutation>;
export type GenerateDepositControlMutationResult = Apollo.MutationResult<GenerateDepositControlMutation>;
export type GenerateDepositControlMutationOptions = Apollo.BaseMutationOptions<GenerateDepositControlMutation, GenerateDepositControlMutationVariables>;
export const CreateCashDepositDraftDocument = gql`
    mutation CreateCashDepositDraft($input: CreateCashDepositInput!) {
  createCashDepositDraft(input: $input) {
    id
    depositNo
    status
  }
}
    `;
export type CreateCashDepositDraftMutationFn = Apollo.MutationFunction<CreateCashDepositDraftMutation, CreateCashDepositDraftMutationVariables>;

/**
 * __useCreateCashDepositDraftMutation__
 *
 * To run a mutation, you first call `useCreateCashDepositDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCashDepositDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCashDepositDraftMutation, { data, loading, error }] = useCreateCashDepositDraftMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCashDepositDraftMutation(baseOptions?: Apollo.MutationHookOptions<CreateCashDepositDraftMutation, CreateCashDepositDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCashDepositDraftMutation, CreateCashDepositDraftMutationVariables>(CreateCashDepositDraftDocument, options);
      }
export type CreateCashDepositDraftMutationHookResult = ReturnType<typeof useCreateCashDepositDraftMutation>;
export type CreateCashDepositDraftMutationResult = Apollo.MutationResult<CreateCashDepositDraftMutation>;
export type CreateCashDepositDraftMutationOptions = Apollo.BaseMutationOptions<CreateCashDepositDraftMutation, CreateCashDepositDraftMutationVariables>;
export const PostCashDepositDocument = gql`
    mutation PostCashDeposit($id: ID!) {
  postCashDeposit(id: $id) {
    id
    status
    journalEntryId
    bankTransactionId
    depositNo
  }
}
    `;
export type PostCashDepositMutationFn = Apollo.MutationFunction<PostCashDepositMutation, PostCashDepositMutationVariables>;

/**
 * __usePostCashDepositMutation__
 *
 * To run a mutation, you first call `usePostCashDepositMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostCashDepositMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postCashDepositMutation, { data, loading, error }] = usePostCashDepositMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePostCashDepositMutation(baseOptions?: Apollo.MutationHookOptions<PostCashDepositMutation, PostCashDepositMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PostCashDepositMutation, PostCashDepositMutationVariables>(PostCashDepositDocument, options);
      }
export type PostCashDepositMutationHookResult = ReturnType<typeof usePostCashDepositMutation>;
export type PostCashDepositMutationResult = Apollo.MutationResult<PostCashDepositMutation>;
export type PostCashDepositMutationOptions = Apollo.BaseMutationOptions<PostCashDepositMutation, PostCashDepositMutationVariables>;
export const CancelCashDepositDocument = gql`
    mutation CancelCashDeposit($id: ID!) {
  cancelCashDeposit(id: $id) {
    id
    status
  }
}
    `;
export type CancelCashDepositMutationFn = Apollo.MutationFunction<CancelCashDepositMutation, CancelCashDepositMutationVariables>;

/**
 * __useCancelCashDepositMutation__
 *
 * To run a mutation, you first call `useCancelCashDepositMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelCashDepositMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelCashDepositMutation, { data, loading, error }] = useCancelCashDepositMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelCashDepositMutation(baseOptions?: Apollo.MutationHookOptions<CancelCashDepositMutation, CancelCashDepositMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelCashDepositMutation, CancelCashDepositMutationVariables>(CancelCashDepositDocument, options);
      }
export type CancelCashDepositMutationHookResult = ReturnType<typeof useCancelCashDepositMutation>;
export type CancelCashDepositMutationResult = Apollo.MutationResult<CancelCashDepositMutation>;
export type CancelCashDepositMutationOptions = Apollo.BaseMutationOptions<CancelCashDepositMutation, CancelCashDepositMutationVariables>;
export const UpsertCashDepositConfigDocument = gql`
    mutation UpsertCashDepositConfig($input: UpsertCashDepositConfigInput!) {
  upsertCashDepositConfig(input: $input) {
    id
    allowRegisterLines
    allowOverDeposit
  }
}
    `;
export type UpsertCashDepositConfigMutationFn = Apollo.MutationFunction<UpsertCashDepositConfigMutation, UpsertCashDepositConfigMutationVariables>;

/**
 * __useUpsertCashDepositConfigMutation__
 *
 * To run a mutation, you first call `useUpsertCashDepositConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertCashDepositConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertCashDepositConfigMutation, { data, loading, error }] = useUpsertCashDepositConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertCashDepositConfigMutation(baseOptions?: Apollo.MutationHookOptions<UpsertCashDepositConfigMutation, UpsertCashDepositConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertCashDepositConfigMutation, UpsertCashDepositConfigMutationVariables>(UpsertCashDepositConfigDocument, options);
      }
export type UpsertCashDepositConfigMutationHookResult = ReturnType<typeof useUpsertCashDepositConfigMutation>;
export type UpsertCashDepositConfigMutationResult = Apollo.MutationResult<UpsertCashDepositConfigMutation>;
export type UpsertCashDepositConfigMutationOptions = Apollo.BaseMutationOptions<UpsertCashDepositConfigMutation, UpsertCashDepositConfigMutationVariables>;
export const ChartOfAccountsDocument = gql`
    query ChartOfAccounts($page: Int, $limit: Int, $locationId: String, $filter: [FilterGroup!], $sort: [SortCondition!]) {
  chartOfAccounts(
    page: $page
    limit: $limit
    locationId: $locationId
    filter: $filter
    sort: $sort
  ) {
    data {
      accountId
      balanceType
      entity {
        entityName
      }
      entityId
      id
      isControl
      isReconciliation
      isSystem
      name
      type
      parentAccount {
        name
      }
      reportingGroup
      status
      createdByName
      createdAt
      subtype {
        id
        name
        code
      }
      updatedByName
      updatedAt
      secondaryId
      parentAccountId
      accountSubtypeId
    }
    meta {
      page
      limit
      totalCount
      total
    }
  }
}
    `;

/**
 * __useChartOfAccountsQuery__
 *
 * To run a query within a React component, call `useChartOfAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChartOfAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChartOfAccountsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      locationId: // value for 'locationId'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useChartOfAccountsQuery(baseOptions?: Apollo.QueryHookOptions<ChartOfAccountsQuery, ChartOfAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChartOfAccountsQuery, ChartOfAccountsQueryVariables>(ChartOfAccountsDocument, options);
      }
export function useChartOfAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChartOfAccountsQuery, ChartOfAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChartOfAccountsQuery, ChartOfAccountsQueryVariables>(ChartOfAccountsDocument, options);
        }
// @ts-ignore
export function useChartOfAccountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ChartOfAccountsQuery, ChartOfAccountsQueryVariables>): Apollo.UseSuspenseQueryResult<ChartOfAccountsQuery, ChartOfAccountsQueryVariables>;
export function useChartOfAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ChartOfAccountsQuery, ChartOfAccountsQueryVariables>): Apollo.UseSuspenseQueryResult<ChartOfAccountsQuery | undefined, ChartOfAccountsQueryVariables>;
export function useChartOfAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ChartOfAccountsQuery, ChartOfAccountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ChartOfAccountsQuery, ChartOfAccountsQueryVariables>(ChartOfAccountsDocument, options);
        }
export type ChartOfAccountsQueryHookResult = ReturnType<typeof useChartOfAccountsQuery>;
export type ChartOfAccountsLazyQueryHookResult = ReturnType<typeof useChartOfAccountsLazyQuery>;
export type ChartOfAccountsSuspenseQueryHookResult = ReturnType<typeof useChartOfAccountsSuspenseQuery>;
export type ChartOfAccountsQueryResult = Apollo.QueryResult<ChartOfAccountsQuery, ChartOfAccountsQueryVariables>;
export const CreateChartOfAccountDocument = gql`
    mutation CreateChartOfAccount($input: CreateChartOfAccountsInput!) {
  createChartOfAccount(input: $input) {
    id
    accountId
    name
    balanceType
    entityId
    type
    parentAccount {
      name
    }
    reportingGroup
    status
    isSystem
    isControl
    isReconciliation
  }
}
    `;
export type CreateChartOfAccountMutationFn = Apollo.MutationFunction<CreateChartOfAccountMutation, CreateChartOfAccountMutationVariables>;

/**
 * __useCreateChartOfAccountMutation__
 *
 * To run a mutation, you first call `useCreateChartOfAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChartOfAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChartOfAccountMutation, { data, loading, error }] = useCreateChartOfAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateChartOfAccountMutation(baseOptions?: Apollo.MutationHookOptions<CreateChartOfAccountMutation, CreateChartOfAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateChartOfAccountMutation, CreateChartOfAccountMutationVariables>(CreateChartOfAccountDocument, options);
      }
export type CreateChartOfAccountMutationHookResult = ReturnType<typeof useCreateChartOfAccountMutation>;
export type CreateChartOfAccountMutationResult = Apollo.MutationResult<CreateChartOfAccountMutation>;
export type CreateChartOfAccountMutationOptions = Apollo.BaseMutationOptions<CreateChartOfAccountMutation, CreateChartOfAccountMutationVariables>;
export const ChartOfAccountsListForOptionsDocument = gql`
    query ChartOfAccountsListForOptions($page: Int!, $limit: Int!, $locationId: String, $filter: [FilterGroup!]) {
  chartOfAccounts(
    page: $page
    limit: $limit
    locationId: $locationId
    filter: $filter
  ) {
    data {
      id
      accountId
      name
      type
      parentAccountId
    }
    meta {
      page
      limit
      totalCount
      total
    }
  }
}
    `;

/**
 * __useChartOfAccountsListForOptionsQuery__
 *
 * To run a query within a React component, call `useChartOfAccountsListForOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChartOfAccountsListForOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChartOfAccountsListForOptionsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      locationId: // value for 'locationId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useChartOfAccountsListForOptionsQuery(baseOptions: Apollo.QueryHookOptions<ChartOfAccountsListForOptionsQuery, ChartOfAccountsListForOptionsQueryVariables> & ({ variables: ChartOfAccountsListForOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChartOfAccountsListForOptionsQuery, ChartOfAccountsListForOptionsQueryVariables>(ChartOfAccountsListForOptionsDocument, options);
      }
export function useChartOfAccountsListForOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChartOfAccountsListForOptionsQuery, ChartOfAccountsListForOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChartOfAccountsListForOptionsQuery, ChartOfAccountsListForOptionsQueryVariables>(ChartOfAccountsListForOptionsDocument, options);
        }
// @ts-ignore
export function useChartOfAccountsListForOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ChartOfAccountsListForOptionsQuery, ChartOfAccountsListForOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<ChartOfAccountsListForOptionsQuery, ChartOfAccountsListForOptionsQueryVariables>;
export function useChartOfAccountsListForOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ChartOfAccountsListForOptionsQuery, ChartOfAccountsListForOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<ChartOfAccountsListForOptionsQuery | undefined, ChartOfAccountsListForOptionsQueryVariables>;
export function useChartOfAccountsListForOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ChartOfAccountsListForOptionsQuery, ChartOfAccountsListForOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ChartOfAccountsListForOptionsQuery, ChartOfAccountsListForOptionsQueryVariables>(ChartOfAccountsListForOptionsDocument, options);
        }
export type ChartOfAccountsListForOptionsQueryHookResult = ReturnType<typeof useChartOfAccountsListForOptionsQuery>;
export type ChartOfAccountsListForOptionsLazyQueryHookResult = ReturnType<typeof useChartOfAccountsListForOptionsLazyQuery>;
export type ChartOfAccountsListForOptionsSuspenseQueryHookResult = ReturnType<typeof useChartOfAccountsListForOptionsSuspenseQuery>;
export type ChartOfAccountsListForOptionsQueryResult = Apollo.QueryResult<ChartOfAccountsListForOptionsQuery, ChartOfAccountsListForOptionsQueryVariables>;
export const CreateCostCenterDocument = gql`
    mutation CreateCostCenter($createCostCenter: CreateCostCenterInput!) {
  createCostCenter(createCostCenter: $createCostCenter) {
    id
  }
}
    `;
export type CreateCostCenterMutationFn = Apollo.MutationFunction<CreateCostCenterMutation, CreateCostCenterMutationVariables>;

/**
 * __useCreateCostCenterMutation__
 *
 * To run a mutation, you first call `useCreateCostCenterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCostCenterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCostCenterMutation, { data, loading, error }] = useCreateCostCenterMutation({
 *   variables: {
 *      createCostCenter: // value for 'createCostCenter'
 *   },
 * });
 */
export function useCreateCostCenterMutation(baseOptions?: Apollo.MutationHookOptions<CreateCostCenterMutation, CreateCostCenterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCostCenterMutation, CreateCostCenterMutationVariables>(CreateCostCenterDocument, options);
      }
export type CreateCostCenterMutationHookResult = ReturnType<typeof useCreateCostCenterMutation>;
export type CreateCostCenterMutationResult = Apollo.MutationResult<CreateCostCenterMutation>;
export type CreateCostCenterMutationOptions = Apollo.BaseMutationOptions<CreateCostCenterMutation, CreateCostCenterMutationVariables>;
export const UpdateCostCenterDocument = gql`
    mutation UpdateCostCenter($updateCostCenter: UpdateCostCenterInput!) {
  updateCostCenter(updateCostCenter: $updateCostCenter) {
    id
  }
}
    `;
export type UpdateCostCenterMutationFn = Apollo.MutationFunction<UpdateCostCenterMutation, UpdateCostCenterMutationVariables>;

/**
 * __useUpdateCostCenterMutation__
 *
 * To run a mutation, you first call `useUpdateCostCenterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCostCenterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCostCenterMutation, { data, loading, error }] = useUpdateCostCenterMutation({
 *   variables: {
 *      updateCostCenter: // value for 'updateCostCenter'
 *   },
 * });
 */
export function useUpdateCostCenterMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCostCenterMutation, UpdateCostCenterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCostCenterMutation, UpdateCostCenterMutationVariables>(UpdateCostCenterDocument, options);
      }
export type UpdateCostCenterMutationHookResult = ReturnType<typeof useUpdateCostCenterMutation>;
export type UpdateCostCenterMutationResult = Apollo.MutationResult<UpdateCostCenterMutation>;
export type UpdateCostCenterMutationOptions = Apollo.BaseMutationOptions<UpdateCostCenterMutation, UpdateCostCenterMutationVariables>;
export const CostCenterDocument = gql`
    query CostCenter($costCenterId: ID!) {
  costCenter(id: $costCenterId) {
    id
    secondaryId
    code
    name
    type
    isDefault
    costBehavior
    effectiveFrom
    effectiveTo
    status
    parentCcId
    managerId
    managerName
    entityId
    createdBy
    createdAt
    updatedBy
    updatedAt
    createdByName
    updatedByName
    locations {
      id
      locationId
      locationName
    }
    parentCc {
      name
      id
    }
    entity {
      id
      entityName
    }
    coaAccounts {
      id
      coaAccountId
      coaAccount {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useCostCenterQuery__
 *
 * To run a query within a React component, call `useCostCenterQuery` and pass it any options that fit your needs.
 * When your component renders, `useCostCenterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCostCenterQuery({
 *   variables: {
 *      costCenterId: // value for 'costCenterId'
 *   },
 * });
 */
export function useCostCenterQuery(baseOptions: Apollo.QueryHookOptions<CostCenterQuery, CostCenterQueryVariables> & ({ variables: CostCenterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CostCenterQuery, CostCenterQueryVariables>(CostCenterDocument, options);
      }
export function useCostCenterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CostCenterQuery, CostCenterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CostCenterQuery, CostCenterQueryVariables>(CostCenterDocument, options);
        }
// @ts-ignore
export function useCostCenterSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CostCenterQuery, CostCenterQueryVariables>): Apollo.UseSuspenseQueryResult<CostCenterQuery, CostCenterQueryVariables>;
export function useCostCenterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CostCenterQuery, CostCenterQueryVariables>): Apollo.UseSuspenseQueryResult<CostCenterQuery | undefined, CostCenterQueryVariables>;
export function useCostCenterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CostCenterQuery, CostCenterQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CostCenterQuery, CostCenterQueryVariables>(CostCenterDocument, options);
        }
export type CostCenterQueryHookResult = ReturnType<typeof useCostCenterQuery>;
export type CostCenterLazyQueryHookResult = ReturnType<typeof useCostCenterLazyQuery>;
export type CostCenterSuspenseQueryHookResult = ReturnType<typeof useCostCenterSuspenseQuery>;
export type CostCenterQueryResult = Apollo.QueryResult<CostCenterQuery, CostCenterQueryVariables>;
export const CostCentersListDocument = gql`
    query CostCentersList($sort: [SortCondition!], $filter: [FilterGroup!], $page: Int!, $limit: Int!, $locationId: String) {
  costCenters(
    sort: $sort
    filter: $filter
    page: $page
    limit: $limit
    locationId: $locationId
  ) {
    meta {
      page
      limit
      totalCount
      total
    }
    data {
      id
      secondaryId
      code
      name
      type
      isDefault
      costBehavior
      effectiveFrom
      effectiveTo
      status
      parentCcId
      managerId
      createdBy
      createdAt
      updatedBy
      updatedAt
      parentCc {
        id
        name
      }
      locations {
        locationId
        locationName
      }
      coaAccounts {
        coaAccount {
          id
          name
        }
      }
      entity {
        id
        entityName
      }
      managerName
      createdByName
      updatedByName
    }
  }
}
    `;

/**
 * __useCostCentersListQuery__
 *
 * To run a query within a React component, call `useCostCentersListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCostCentersListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCostCentersListQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useCostCentersListQuery(baseOptions: Apollo.QueryHookOptions<CostCentersListQuery, CostCentersListQueryVariables> & ({ variables: CostCentersListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CostCentersListQuery, CostCentersListQueryVariables>(CostCentersListDocument, options);
      }
export function useCostCentersListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CostCentersListQuery, CostCentersListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CostCentersListQuery, CostCentersListQueryVariables>(CostCentersListDocument, options);
        }
// @ts-ignore
export function useCostCentersListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CostCentersListQuery, CostCentersListQueryVariables>): Apollo.UseSuspenseQueryResult<CostCentersListQuery, CostCentersListQueryVariables>;
export function useCostCentersListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CostCentersListQuery, CostCentersListQueryVariables>): Apollo.UseSuspenseQueryResult<CostCentersListQuery | undefined, CostCentersListQueryVariables>;
export function useCostCentersListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CostCentersListQuery, CostCentersListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CostCentersListQuery, CostCentersListQueryVariables>(CostCentersListDocument, options);
        }
export type CostCentersListQueryHookResult = ReturnType<typeof useCostCentersListQuery>;
export type CostCentersListLazyQueryHookResult = ReturnType<typeof useCostCentersListLazyQuery>;
export type CostCentersListSuspenseQueryHookResult = ReturnType<typeof useCostCentersListSuspenseQuery>;
export type CostCentersListQueryResult = Apollo.QueryResult<CostCentersListQuery, CostCentersListQueryVariables>;
export const CostCentersListForOptionsDocument = gql`
    query CostCentersListForOptions($locationId: String, $limit: Int!, $page: Int!, $filter: [FilterGroup!], $sort: [SortCondition!]) {
  costCenters(
    locationId: $locationId
    limit: $limit
    page: $page
    filter: $filter
    sort: $sort
  ) {
    meta {
      page
      limit
      totalCount
      total
    }
    data {
      id
      secondaryId
      code
      name
    }
  }
}
    `;

/**
 * __useCostCentersListForOptionsQuery__
 *
 * To run a query within a React component, call `useCostCentersListForOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCostCentersListForOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCostCentersListForOptionsQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useCostCentersListForOptionsQuery(baseOptions: Apollo.QueryHookOptions<CostCentersListForOptionsQuery, CostCentersListForOptionsQueryVariables> & ({ variables: CostCentersListForOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CostCentersListForOptionsQuery, CostCentersListForOptionsQueryVariables>(CostCentersListForOptionsDocument, options);
      }
export function useCostCentersListForOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CostCentersListForOptionsQuery, CostCentersListForOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CostCentersListForOptionsQuery, CostCentersListForOptionsQueryVariables>(CostCentersListForOptionsDocument, options);
        }
// @ts-ignore
export function useCostCentersListForOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CostCentersListForOptionsQuery, CostCentersListForOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<CostCentersListForOptionsQuery, CostCentersListForOptionsQueryVariables>;
export function useCostCentersListForOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CostCentersListForOptionsQuery, CostCentersListForOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<CostCentersListForOptionsQuery | undefined, CostCentersListForOptionsQueryVariables>;
export function useCostCentersListForOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CostCentersListForOptionsQuery, CostCentersListForOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CostCentersListForOptionsQuery, CostCentersListForOptionsQueryVariables>(CostCentersListForOptionsDocument, options);
        }
export type CostCentersListForOptionsQueryHookResult = ReturnType<typeof useCostCentersListForOptionsQuery>;
export type CostCentersListForOptionsLazyQueryHookResult = ReturnType<typeof useCostCentersListForOptionsLazyQuery>;
export type CostCentersListForOptionsSuspenseQueryHookResult = ReturnType<typeof useCostCentersListForOptionsSuspenseQuery>;
export type CostCentersListForOptionsQueryResult = Apollo.QueryResult<CostCentersListForOptionsQuery, CostCentersListForOptionsQueryVariables>;
export const CreateEntityDocument = gql`
    mutation CreateEntity($input: CreateEntityInput!) {
  createEntity(input: $input) {
    id
    country
    entityName
    fiscalYearType
    secondaryId
  }
}
    `;
export type CreateEntityMutationFn = Apollo.MutationFunction<CreateEntityMutation, CreateEntityMutationVariables>;

/**
 * __useCreateEntityMutation__
 *
 * To run a mutation, you first call `useCreateEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEntityMutation, { data, loading, error }] = useCreateEntityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEntityMutation(baseOptions?: Apollo.MutationHookOptions<CreateEntityMutation, CreateEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEntityMutation, CreateEntityMutationVariables>(CreateEntityDocument, options);
      }
export type CreateEntityMutationHookResult = ReturnType<typeof useCreateEntityMutation>;
export type CreateEntityMutationResult = Apollo.MutationResult<CreateEntityMutation>;
export type CreateEntityMutationOptions = Apollo.BaseMutationOptions<CreateEntityMutation, CreateEntityMutationVariables>;
export const EntitiesListDocument = gql`
    query EntitiesList($page: Int!, $limit: Int!, $locationId: String, $filter: [FilterGroup!], $sort: [SortCondition!]) {
  entities(
    page: $page
    limit: $limit
    locationId: $locationId
    filter: $filter
    sort: $sort
  ) {
    data {
      country
      entityName
      fiscalYearType
      secondaryId
      id
    }
    meta {
      page
      limit
      totalCount
      total
    }
  }
}
    `;

/**
 * __useEntitiesListQuery__
 *
 * To run a query within a React component, call `useEntitiesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntitiesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntitiesListQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      locationId: // value for 'locationId'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useEntitiesListQuery(baseOptions: Apollo.QueryHookOptions<EntitiesListQuery, EntitiesListQueryVariables> & ({ variables: EntitiesListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntitiesListQuery, EntitiesListQueryVariables>(EntitiesListDocument, options);
      }
export function useEntitiesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntitiesListQuery, EntitiesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntitiesListQuery, EntitiesListQueryVariables>(EntitiesListDocument, options);
        }
// @ts-ignore
export function useEntitiesListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EntitiesListQuery, EntitiesListQueryVariables>): Apollo.UseSuspenseQueryResult<EntitiesListQuery, EntitiesListQueryVariables>;
export function useEntitiesListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EntitiesListQuery, EntitiesListQueryVariables>): Apollo.UseSuspenseQueryResult<EntitiesListQuery | undefined, EntitiesListQueryVariables>;
export function useEntitiesListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EntitiesListQuery, EntitiesListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntitiesListQuery, EntitiesListQueryVariables>(EntitiesListDocument, options);
        }
export type EntitiesListQueryHookResult = ReturnType<typeof useEntitiesListQuery>;
export type EntitiesListLazyQueryHookResult = ReturnType<typeof useEntitiesListLazyQuery>;
export type EntitiesListSuspenseQueryHookResult = ReturnType<typeof useEntitiesListSuspenseQuery>;
export type EntitiesListQueryResult = Apollo.QueryResult<EntitiesListQuery, EntitiesListQueryVariables>;
export const EntitiesDocument = gql`
    query Entities($page: Int!, $limit: Int!, $locationId: String) {
  entities(page: $page, limit: $limit, locationId: $locationId) {
    data {
      country
      entityName
      fiscalYearType
      secondaryId
      id
    }
    meta {
      page
      limit
      totalCount
      total
    }
  }
}
    `;

/**
 * __useEntitiesQuery__
 *
 * To run a query within a React component, call `useEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntitiesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useEntitiesQuery(baseOptions: Apollo.QueryHookOptions<EntitiesQuery, EntitiesQueryVariables> & ({ variables: EntitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntitiesQuery, EntitiesQueryVariables>(EntitiesDocument, options);
      }
export function useEntitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntitiesQuery, EntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntitiesQuery, EntitiesQueryVariables>(EntitiesDocument, options);
        }
// @ts-ignore
export function useEntitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EntitiesQuery, EntitiesQueryVariables>): Apollo.UseSuspenseQueryResult<EntitiesQuery, EntitiesQueryVariables>;
export function useEntitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EntitiesQuery, EntitiesQueryVariables>): Apollo.UseSuspenseQueryResult<EntitiesQuery | undefined, EntitiesQueryVariables>;
export function useEntitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EntitiesQuery, EntitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntitiesQuery, EntitiesQueryVariables>(EntitiesDocument, options);
        }
export type EntitiesQueryHookResult = ReturnType<typeof useEntitiesQuery>;
export type EntitiesLazyQueryHookResult = ReturnType<typeof useEntitiesLazyQuery>;
export type EntitiesSuspenseQueryHookResult = ReturnType<typeof useEntitiesSuspenseQuery>;
export type EntitiesQueryResult = Apollo.QueryResult<EntitiesQuery, EntitiesQueryVariables>;
export const FinanceStatsDocument = gql`
    query FinanceStats {
  finance_stats {
    openJournalsCount
    receivablesOutstandingAmount
    totalReceivablesCount
    payablesOutstandingAmount
    totalPayablesCount
    currentFiscalPeriod {
      id
      name
      startDate
      endDate
      isOpen
    }
  }
}
    `;

/**
 * __useFinanceStatsQuery__
 *
 * To run a query within a React component, call `useFinanceStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinanceStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinanceStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFinanceStatsQuery(baseOptions?: Apollo.QueryHookOptions<FinanceStatsQuery, FinanceStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FinanceStatsQuery, FinanceStatsQueryVariables>(FinanceStatsDocument, options);
      }
export function useFinanceStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FinanceStatsQuery, FinanceStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FinanceStatsQuery, FinanceStatsQueryVariables>(FinanceStatsDocument, options);
        }
// @ts-ignore
export function useFinanceStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FinanceStatsQuery, FinanceStatsQueryVariables>): Apollo.UseSuspenseQueryResult<FinanceStatsQuery, FinanceStatsQueryVariables>;
export function useFinanceStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FinanceStatsQuery, FinanceStatsQueryVariables>): Apollo.UseSuspenseQueryResult<FinanceStatsQuery | undefined, FinanceStatsQueryVariables>;
export function useFinanceStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FinanceStatsQuery, FinanceStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FinanceStatsQuery, FinanceStatsQueryVariables>(FinanceStatsDocument, options);
        }
export type FinanceStatsQueryHookResult = ReturnType<typeof useFinanceStatsQuery>;
export type FinanceStatsLazyQueryHookResult = ReturnType<typeof useFinanceStatsLazyQuery>;
export type FinanceStatsSuspenseQueryHookResult = ReturnType<typeof useFinanceStatsSuspenseQuery>;
export type FinanceStatsQueryResult = Apollo.QueryResult<FinanceStatsQuery, FinanceStatsQueryVariables>;
export const CreateFiscalYearDocument = gql`
    mutation CreateFiscalYear($createFiscalYear: CreateFiscalYearInput!) {
  createFiscalYear(createFiscalYear: $createFiscalYear) {
    id
  }
}
    `;
export type CreateFiscalYearMutationFn = Apollo.MutationFunction<CreateFiscalYearMutation, CreateFiscalYearMutationVariables>;

/**
 * __useCreateFiscalYearMutation__
 *
 * To run a mutation, you first call `useCreateFiscalYearMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFiscalYearMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFiscalYearMutation, { data, loading, error }] = useCreateFiscalYearMutation({
 *   variables: {
 *      createFiscalYear: // value for 'createFiscalYear'
 *   },
 * });
 */
export function useCreateFiscalYearMutation(baseOptions?: Apollo.MutationHookOptions<CreateFiscalYearMutation, CreateFiscalYearMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFiscalYearMutation, CreateFiscalYearMutationVariables>(CreateFiscalYearDocument, options);
      }
export type CreateFiscalYearMutationHookResult = ReturnType<typeof useCreateFiscalYearMutation>;
export type CreateFiscalYearMutationResult = Apollo.MutationResult<CreateFiscalYearMutation>;
export type CreateFiscalYearMutationOptions = Apollo.BaseMutationOptions<CreateFiscalYearMutation, CreateFiscalYearMutationVariables>;
export const CreateFiscalPeriodDocument = gql`
    mutation CreateFiscalPeriod($createFiscalPeriod: CreateFiscalPeriodInput!) {
  createFiscalPeriod(createFiscalPeriod: $createFiscalPeriod) {
    id
  }
}
    `;
export type CreateFiscalPeriodMutationFn = Apollo.MutationFunction<CreateFiscalPeriodMutation, CreateFiscalPeriodMutationVariables>;

/**
 * __useCreateFiscalPeriodMutation__
 *
 * To run a mutation, you first call `useCreateFiscalPeriodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFiscalPeriodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFiscalPeriodMutation, { data, loading, error }] = useCreateFiscalPeriodMutation({
 *   variables: {
 *      createFiscalPeriod: // value for 'createFiscalPeriod'
 *   },
 * });
 */
export function useCreateFiscalPeriodMutation(baseOptions?: Apollo.MutationHookOptions<CreateFiscalPeriodMutation, CreateFiscalPeriodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFiscalPeriodMutation, CreateFiscalPeriodMutationVariables>(CreateFiscalPeriodDocument, options);
      }
export type CreateFiscalPeriodMutationHookResult = ReturnType<typeof useCreateFiscalPeriodMutation>;
export type CreateFiscalPeriodMutationResult = Apollo.MutationResult<CreateFiscalPeriodMutation>;
export type CreateFiscalPeriodMutationOptions = Apollo.BaseMutationOptions<CreateFiscalPeriodMutation, CreateFiscalPeriodMutationVariables>;
export const UpdateFiscalPeriodDocument = gql`
    mutation UpdateFiscalPeriod($updateFiscalPeriod: UpdateFiscalPeriodInput!) {
  updateFiscalPeriod(updateFiscalPeriod: $updateFiscalPeriod) {
    id
  }
}
    `;
export type UpdateFiscalPeriodMutationFn = Apollo.MutationFunction<UpdateFiscalPeriodMutation, UpdateFiscalPeriodMutationVariables>;

/**
 * __useUpdateFiscalPeriodMutation__
 *
 * To run a mutation, you first call `useUpdateFiscalPeriodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFiscalPeriodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFiscalPeriodMutation, { data, loading, error }] = useUpdateFiscalPeriodMutation({
 *   variables: {
 *      updateFiscalPeriod: // value for 'updateFiscalPeriod'
 *   },
 * });
 */
export function useUpdateFiscalPeriodMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFiscalPeriodMutation, UpdateFiscalPeriodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFiscalPeriodMutation, UpdateFiscalPeriodMutationVariables>(UpdateFiscalPeriodDocument, options);
      }
export type UpdateFiscalPeriodMutationHookResult = ReturnType<typeof useUpdateFiscalPeriodMutation>;
export type UpdateFiscalPeriodMutationResult = Apollo.MutationResult<UpdateFiscalPeriodMutation>;
export type UpdateFiscalPeriodMutationOptions = Apollo.BaseMutationOptions<UpdateFiscalPeriodMutation, UpdateFiscalPeriodMutationVariables>;
export const FiscalYearsListDocument = gql`
    query FiscalYearsList($sort: [SortCondition!], $filter: [FilterGroup!], $page: Int!, $limit: Int!, $locationId: String) {
  fiscalYears(
    sort: $sort
    filter: $filter
    page: $page
    limit: $limit
    locationId: $locationId
  ) {
    meta {
      page
      limit
      totalCount
      total
    }
    data {
      id
      secondaryId
      fiscalYearName
      startDate
      endDate
      entityId
      createdByName
      createdAt
    }
  }
}
    `;

/**
 * __useFiscalYearsListQuery__
 *
 * To run a query within a React component, call `useFiscalYearsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFiscalYearsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFiscalYearsListQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useFiscalYearsListQuery(baseOptions: Apollo.QueryHookOptions<FiscalYearsListQuery, FiscalYearsListQueryVariables> & ({ variables: FiscalYearsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FiscalYearsListQuery, FiscalYearsListQueryVariables>(FiscalYearsListDocument, options);
      }
export function useFiscalYearsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FiscalYearsListQuery, FiscalYearsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FiscalYearsListQuery, FiscalYearsListQueryVariables>(FiscalYearsListDocument, options);
        }
// @ts-ignore
export function useFiscalYearsListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FiscalYearsListQuery, FiscalYearsListQueryVariables>): Apollo.UseSuspenseQueryResult<FiscalYearsListQuery, FiscalYearsListQueryVariables>;
export function useFiscalYearsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FiscalYearsListQuery, FiscalYearsListQueryVariables>): Apollo.UseSuspenseQueryResult<FiscalYearsListQuery | undefined, FiscalYearsListQueryVariables>;
export function useFiscalYearsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FiscalYearsListQuery, FiscalYearsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FiscalYearsListQuery, FiscalYearsListQueryVariables>(FiscalYearsListDocument, options);
        }
export type FiscalYearsListQueryHookResult = ReturnType<typeof useFiscalYearsListQuery>;
export type FiscalYearsListLazyQueryHookResult = ReturnType<typeof useFiscalYearsListLazyQuery>;
export type FiscalYearsListSuspenseQueryHookResult = ReturnType<typeof useFiscalYearsListSuspenseQuery>;
export type FiscalYearsListQueryResult = Apollo.QueryResult<FiscalYearsListQuery, FiscalYearsListQueryVariables>;
export const FiscalPeriodsDocument = gql`
    query FiscalPeriods($sort: [SortCondition!], $filter: [FilterGroup!], $page: Int!, $limit: Int!, $locationId: String) {
  fiscalPeriods(
    sort: $sort
    filter: $filter
    page: $page
    limit: $limit
    locationId: $locationId
  ) {
    data {
      id
      secondaryId
      fiscalYearId
      name
      startDate
      endDate
      isOpen
      createdByName
      createdAt
    }
    meta {
      page
      limit
      totalCount
      total
    }
  }
}
    `;

/**
 * __useFiscalPeriodsQuery__
 *
 * To run a query within a React component, call `useFiscalPeriodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFiscalPeriodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFiscalPeriodsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useFiscalPeriodsQuery(baseOptions: Apollo.QueryHookOptions<FiscalPeriodsQuery, FiscalPeriodsQueryVariables> & ({ variables: FiscalPeriodsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FiscalPeriodsQuery, FiscalPeriodsQueryVariables>(FiscalPeriodsDocument, options);
      }
export function useFiscalPeriodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FiscalPeriodsQuery, FiscalPeriodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FiscalPeriodsQuery, FiscalPeriodsQueryVariables>(FiscalPeriodsDocument, options);
        }
// @ts-ignore
export function useFiscalPeriodsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FiscalPeriodsQuery, FiscalPeriodsQueryVariables>): Apollo.UseSuspenseQueryResult<FiscalPeriodsQuery, FiscalPeriodsQueryVariables>;
export function useFiscalPeriodsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FiscalPeriodsQuery, FiscalPeriodsQueryVariables>): Apollo.UseSuspenseQueryResult<FiscalPeriodsQuery | undefined, FiscalPeriodsQueryVariables>;
export function useFiscalPeriodsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FiscalPeriodsQuery, FiscalPeriodsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FiscalPeriodsQuery, FiscalPeriodsQueryVariables>(FiscalPeriodsDocument, options);
        }
export type FiscalPeriodsQueryHookResult = ReturnType<typeof useFiscalPeriodsQuery>;
export type FiscalPeriodsLazyQueryHookResult = ReturnType<typeof useFiscalPeriodsLazyQuery>;
export type FiscalPeriodsSuspenseQueryHookResult = ReturnType<typeof useFiscalPeriodsSuspenseQuery>;
export type FiscalPeriodsQueryResult = Apollo.QueryResult<FiscalPeriodsQuery, FiscalPeriodsQueryVariables>;
export const GeneralLedgerReportDocument = gql`
    query GeneralLedgerReport($entityId: ID!, $startDate: DateTime!, $endDate: DateTime!, $costCenterIds: [ID!], $profitCenterIds: [ID!], $locationIds: [ID!]) {
  generalLedgerReport(
    entityId: $entityId
    startDate: $startDate
    endDate: $endDate
    costCenterIds: $costCenterIds
    profitCenterIds: $profitCenterIds
    locationIds: $locationIds
  ) {
    totalDebit
    totalCredit
    totalBalance
    startDate
    endDate
    currency
    rows {
      accountId
      accountCode
      accountName
      parentAccountId
      level
      isGroup
      accountType
      debit
      credit
      balance
    }
  }
}
    `;

/**
 * __useGeneralLedgerReportQuery__
 *
 * To run a query within a React component, call `useGeneralLedgerReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGeneralLedgerReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGeneralLedgerReportQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      costCenterIds: // value for 'costCenterIds'
 *      profitCenterIds: // value for 'profitCenterIds'
 *      locationIds: // value for 'locationIds'
 *   },
 * });
 */
export function useGeneralLedgerReportQuery(baseOptions: Apollo.QueryHookOptions<GeneralLedgerReportQuery, GeneralLedgerReportQueryVariables> & ({ variables: GeneralLedgerReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GeneralLedgerReportQuery, GeneralLedgerReportQueryVariables>(GeneralLedgerReportDocument, options);
      }
export function useGeneralLedgerReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GeneralLedgerReportQuery, GeneralLedgerReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GeneralLedgerReportQuery, GeneralLedgerReportQueryVariables>(GeneralLedgerReportDocument, options);
        }
// @ts-ignore
export function useGeneralLedgerReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GeneralLedgerReportQuery, GeneralLedgerReportQueryVariables>): Apollo.UseSuspenseQueryResult<GeneralLedgerReportQuery, GeneralLedgerReportQueryVariables>;
export function useGeneralLedgerReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GeneralLedgerReportQuery, GeneralLedgerReportQueryVariables>): Apollo.UseSuspenseQueryResult<GeneralLedgerReportQuery | undefined, GeneralLedgerReportQueryVariables>;
export function useGeneralLedgerReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GeneralLedgerReportQuery, GeneralLedgerReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GeneralLedgerReportQuery, GeneralLedgerReportQueryVariables>(GeneralLedgerReportDocument, options);
        }
export type GeneralLedgerReportQueryHookResult = ReturnType<typeof useGeneralLedgerReportQuery>;
export type GeneralLedgerReportLazyQueryHookResult = ReturnType<typeof useGeneralLedgerReportLazyQuery>;
export type GeneralLedgerReportSuspenseQueryHookResult = ReturnType<typeof useGeneralLedgerReportSuspenseQuery>;
export type GeneralLedgerReportQueryResult = Apollo.QueryResult<GeneralLedgerReportQuery, GeneralLedgerReportQueryVariables>;
export const IncomeStatementReportDocument = gql`
    query IncomeStatementReport($entityId: ID!, $startDate: DateTime!, $endDate: DateTime!, $costCenterIds: [ID!], $profitCenterIds: [ID!], $locationIds: [ID!]) {
  incomeStatementReport(
    entityId: $entityId
    startDate: $startDate
    endDate: $endDate
    costCenterIds: $costCenterIds
    profitCenterIds: $profitCenterIds
    locationIds: $locationIds
  ) {
    totalRevenue
    totalExpense
    netIncome
    startDate
    endDate
    currency
    rows {
      accountId
      accountCode
      accountName
      parentAccountId
      level
      isGroup
      accountType
      debit
      credit
      balance
    }
  }
}
    `;

/**
 * __useIncomeStatementReportQuery__
 *
 * To run a query within a React component, call `useIncomeStatementReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useIncomeStatementReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIncomeStatementReportQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      costCenterIds: // value for 'costCenterIds'
 *      profitCenterIds: // value for 'profitCenterIds'
 *      locationIds: // value for 'locationIds'
 *   },
 * });
 */
export function useIncomeStatementReportQuery(baseOptions: Apollo.QueryHookOptions<IncomeStatementReportQuery, IncomeStatementReportQueryVariables> & ({ variables: IncomeStatementReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IncomeStatementReportQuery, IncomeStatementReportQueryVariables>(IncomeStatementReportDocument, options);
      }
export function useIncomeStatementReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IncomeStatementReportQuery, IncomeStatementReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IncomeStatementReportQuery, IncomeStatementReportQueryVariables>(IncomeStatementReportDocument, options);
        }
// @ts-ignore
export function useIncomeStatementReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IncomeStatementReportQuery, IncomeStatementReportQueryVariables>): Apollo.UseSuspenseQueryResult<IncomeStatementReportQuery, IncomeStatementReportQueryVariables>;
export function useIncomeStatementReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IncomeStatementReportQuery, IncomeStatementReportQueryVariables>): Apollo.UseSuspenseQueryResult<IncomeStatementReportQuery | undefined, IncomeStatementReportQueryVariables>;
export function useIncomeStatementReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IncomeStatementReportQuery, IncomeStatementReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IncomeStatementReportQuery, IncomeStatementReportQueryVariables>(IncomeStatementReportDocument, options);
        }
export type IncomeStatementReportQueryHookResult = ReturnType<typeof useIncomeStatementReportQuery>;
export type IncomeStatementReportLazyQueryHookResult = ReturnType<typeof useIncomeStatementReportLazyQuery>;
export type IncomeStatementReportSuspenseQueryHookResult = ReturnType<typeof useIncomeStatementReportSuspenseQuery>;
export type IncomeStatementReportQueryResult = Apollo.QueryResult<IncomeStatementReportQuery, IncomeStatementReportQueryVariables>;
export const CreateInvoicePolicyConfigDocument = gql`
    mutation CreateInvoicePolicyConfig($createInvoicePolicyConfigDto: CreateInvoicePolicyConfigDTO!) {
  createInvoicePolicyConfig(
    createInvoicePolicyConfigDTO: $createInvoicePolicyConfigDto
  ) {
    id
  }
}
    `;
export type CreateInvoicePolicyConfigMutationFn = Apollo.MutationFunction<CreateInvoicePolicyConfigMutation, CreateInvoicePolicyConfigMutationVariables>;

/**
 * __useCreateInvoicePolicyConfigMutation__
 *
 * To run a mutation, you first call `useCreateInvoicePolicyConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInvoicePolicyConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInvoicePolicyConfigMutation, { data, loading, error }] = useCreateInvoicePolicyConfigMutation({
 *   variables: {
 *      createInvoicePolicyConfigDto: // value for 'createInvoicePolicyConfigDto'
 *   },
 * });
 */
export function useCreateInvoicePolicyConfigMutation(baseOptions?: Apollo.MutationHookOptions<CreateInvoicePolicyConfigMutation, CreateInvoicePolicyConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInvoicePolicyConfigMutation, CreateInvoicePolicyConfigMutationVariables>(CreateInvoicePolicyConfigDocument, options);
      }
export type CreateInvoicePolicyConfigMutationHookResult = ReturnType<typeof useCreateInvoicePolicyConfigMutation>;
export type CreateInvoicePolicyConfigMutationResult = Apollo.MutationResult<CreateInvoicePolicyConfigMutation>;
export type CreateInvoicePolicyConfigMutationOptions = Apollo.BaseMutationOptions<CreateInvoicePolicyConfigMutation, CreateInvoicePolicyConfigMutationVariables>;
export const UpdateInvoicePolicyConfigDocument = gql`
    mutation UpdateInvoicePolicyConfig($updateInvoicePolicyConfigDto: UpdateInvoicePolicyConfigDTO!) {
  updateInvoicePolicyConfig(
    updateInvoicePolicyConfigDTO: $updateInvoicePolicyConfigDto
  ) {
    id
  }
}
    `;
export type UpdateInvoicePolicyConfigMutationFn = Apollo.MutationFunction<UpdateInvoicePolicyConfigMutation, UpdateInvoicePolicyConfigMutationVariables>;

/**
 * __useUpdateInvoicePolicyConfigMutation__
 *
 * To run a mutation, you first call `useUpdateInvoicePolicyConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInvoicePolicyConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInvoicePolicyConfigMutation, { data, loading, error }] = useUpdateInvoicePolicyConfigMutation({
 *   variables: {
 *      updateInvoicePolicyConfigDto: // value for 'updateInvoicePolicyConfigDto'
 *   },
 * });
 */
export function useUpdateInvoicePolicyConfigMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInvoicePolicyConfigMutation, UpdateInvoicePolicyConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInvoicePolicyConfigMutation, UpdateInvoicePolicyConfigMutationVariables>(UpdateInvoicePolicyConfigDocument, options);
      }
export type UpdateInvoicePolicyConfigMutationHookResult = ReturnType<typeof useUpdateInvoicePolicyConfigMutation>;
export type UpdateInvoicePolicyConfigMutationResult = Apollo.MutationResult<UpdateInvoicePolicyConfigMutation>;
export type UpdateInvoicePolicyConfigMutationOptions = Apollo.BaseMutationOptions<UpdateInvoicePolicyConfigMutation, UpdateInvoicePolicyConfigMutationVariables>;
export const GetInvoicePolicyConfigDocument = gql`
    query GetInvoicePolicyConfig($getInvoicePolicyConfigId: String!) {
  getInvoicePolicyConfig(id: $getInvoicePolicyConfigId) {
    id
    partnerId
    customerId
    invoicePolicyCode
    effectiveDate
    effectiveTillDate
    groupByLocation
    groupByEntity
    groupByBusinessDate
    status
    createdAt
    updatedAt
    updatedByName
    createdByName
    secondaryId
  }
}
    `;

/**
 * __useGetInvoicePolicyConfigQuery__
 *
 * To run a query within a React component, call `useGetInvoicePolicyConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicePolicyConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoicePolicyConfigQuery({
 *   variables: {
 *      getInvoicePolicyConfigId: // value for 'getInvoicePolicyConfigId'
 *   },
 * });
 */
export function useGetInvoicePolicyConfigQuery(baseOptions: Apollo.QueryHookOptions<GetInvoicePolicyConfigQuery, GetInvoicePolicyConfigQueryVariables> & ({ variables: GetInvoicePolicyConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoicePolicyConfigQuery, GetInvoicePolicyConfigQueryVariables>(GetInvoicePolicyConfigDocument, options);
      }
export function useGetInvoicePolicyConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoicePolicyConfigQuery, GetInvoicePolicyConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoicePolicyConfigQuery, GetInvoicePolicyConfigQueryVariables>(GetInvoicePolicyConfigDocument, options);
        }
// @ts-ignore
export function useGetInvoicePolicyConfigSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInvoicePolicyConfigQuery, GetInvoicePolicyConfigQueryVariables>): Apollo.UseSuspenseQueryResult<GetInvoicePolicyConfigQuery, GetInvoicePolicyConfigQueryVariables>;
export function useGetInvoicePolicyConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInvoicePolicyConfigQuery, GetInvoicePolicyConfigQueryVariables>): Apollo.UseSuspenseQueryResult<GetInvoicePolicyConfigQuery | undefined, GetInvoicePolicyConfigQueryVariables>;
export function useGetInvoicePolicyConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInvoicePolicyConfigQuery, GetInvoicePolicyConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInvoicePolicyConfigQuery, GetInvoicePolicyConfigQueryVariables>(GetInvoicePolicyConfigDocument, options);
        }
export type GetInvoicePolicyConfigQueryHookResult = ReturnType<typeof useGetInvoicePolicyConfigQuery>;
export type GetInvoicePolicyConfigLazyQueryHookResult = ReturnType<typeof useGetInvoicePolicyConfigLazyQuery>;
export type GetInvoicePolicyConfigSuspenseQueryHookResult = ReturnType<typeof useGetInvoicePolicyConfigSuspenseQuery>;
export type GetInvoicePolicyConfigQueryResult = Apollo.QueryResult<GetInvoicePolicyConfigQuery, GetInvoicePolicyConfigQueryVariables>;
export const GetInvoicePolicyConfigsListDocument = gql`
    query GetInvoicePolicyConfigsList($sort: [SortCondition!], $filter: [FilterGroup!], $page: Int!, $limit: Int!, $locationId: String) {
  getInvoicePolicyConfigs(
    sort: $sort
    filter: $filter
    page: $page
    limit: $limit
    locationId: $locationId
  ) {
    meta {
      page
      limit
      totalCount
      total
    }
    data {
      id
      partnerId
      customerId
      invoicePolicyCode
      effectiveDate
      effectiveTillDate
      groupByLocation
      groupByEntity
      groupByBusinessDate
      status
      createdAt
      updatedAt
      updatedByName
      createdByName
      secondaryId
      partnerName
      customerName
    }
  }
}
    `;

/**
 * __useGetInvoicePolicyConfigsListQuery__
 *
 * To run a query within a React component, call `useGetInvoicePolicyConfigsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicePolicyConfigsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoicePolicyConfigsListQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useGetInvoicePolicyConfigsListQuery(baseOptions: Apollo.QueryHookOptions<GetInvoicePolicyConfigsListQuery, GetInvoicePolicyConfigsListQueryVariables> & ({ variables: GetInvoicePolicyConfigsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoicePolicyConfigsListQuery, GetInvoicePolicyConfigsListQueryVariables>(GetInvoicePolicyConfigsListDocument, options);
      }
export function useGetInvoicePolicyConfigsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoicePolicyConfigsListQuery, GetInvoicePolicyConfigsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoicePolicyConfigsListQuery, GetInvoicePolicyConfigsListQueryVariables>(GetInvoicePolicyConfigsListDocument, options);
        }
// @ts-ignore
export function useGetInvoicePolicyConfigsListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInvoicePolicyConfigsListQuery, GetInvoicePolicyConfigsListQueryVariables>): Apollo.UseSuspenseQueryResult<GetInvoicePolicyConfigsListQuery, GetInvoicePolicyConfigsListQueryVariables>;
export function useGetInvoicePolicyConfigsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInvoicePolicyConfigsListQuery, GetInvoicePolicyConfigsListQueryVariables>): Apollo.UseSuspenseQueryResult<GetInvoicePolicyConfigsListQuery | undefined, GetInvoicePolicyConfigsListQueryVariables>;
export function useGetInvoicePolicyConfigsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInvoicePolicyConfigsListQuery, GetInvoicePolicyConfigsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInvoicePolicyConfigsListQuery, GetInvoicePolicyConfigsListQueryVariables>(GetInvoicePolicyConfigsListDocument, options);
        }
export type GetInvoicePolicyConfigsListQueryHookResult = ReturnType<typeof useGetInvoicePolicyConfigsListQuery>;
export type GetInvoicePolicyConfigsListLazyQueryHookResult = ReturnType<typeof useGetInvoicePolicyConfigsListLazyQuery>;
export type GetInvoicePolicyConfigsListSuspenseQueryHookResult = ReturnType<typeof useGetInvoicePolicyConfigsListSuspenseQuery>;
export type GetInvoicePolicyConfigsListQueryResult = Apollo.QueryResult<GetInvoicePolicyConfigsListQuery, GetInvoicePolicyConfigsListQueryVariables>;
export const CreateJournalHeaderDocument = gql`
    mutation CreateJournalHeader($input: CreateJournalHeaderInput!) {
  createJournalHeader(input: $input) {
    id
  }
}
    `;
export type CreateJournalHeaderMutationFn = Apollo.MutationFunction<CreateJournalHeaderMutation, CreateJournalHeaderMutationVariables>;

/**
 * __useCreateJournalHeaderMutation__
 *
 * To run a mutation, you first call `useCreateJournalHeaderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJournalHeaderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJournalHeaderMutation, { data, loading, error }] = useCreateJournalHeaderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateJournalHeaderMutation(baseOptions?: Apollo.MutationHookOptions<CreateJournalHeaderMutation, CreateJournalHeaderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateJournalHeaderMutation, CreateJournalHeaderMutationVariables>(CreateJournalHeaderDocument, options);
      }
export type CreateJournalHeaderMutationHookResult = ReturnType<typeof useCreateJournalHeaderMutation>;
export type CreateJournalHeaderMutationResult = Apollo.MutationResult<CreateJournalHeaderMutation>;
export type CreateJournalHeaderMutationOptions = Apollo.BaseMutationOptions<CreateJournalHeaderMutation, CreateJournalHeaderMutationVariables>;
export const UpdateJournalHeaderDocument = gql`
    mutation UpdateJournalHeader($input: UpdateJournalHeaderInput!) {
  updateJournalHeader(input: $input) {
    id
  }
}
    `;
export type UpdateJournalHeaderMutationFn = Apollo.MutationFunction<UpdateJournalHeaderMutation, UpdateJournalHeaderMutationVariables>;

/**
 * __useUpdateJournalHeaderMutation__
 *
 * To run a mutation, you first call `useUpdateJournalHeaderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJournalHeaderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJournalHeaderMutation, { data, loading, error }] = useUpdateJournalHeaderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateJournalHeaderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJournalHeaderMutation, UpdateJournalHeaderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateJournalHeaderMutation, UpdateJournalHeaderMutationVariables>(UpdateJournalHeaderDocument, options);
      }
export type UpdateJournalHeaderMutationHookResult = ReturnType<typeof useUpdateJournalHeaderMutation>;
export type UpdateJournalHeaderMutationResult = Apollo.MutationResult<UpdateJournalHeaderMutation>;
export type UpdateJournalHeaderMutationOptions = Apollo.BaseMutationOptions<UpdateJournalHeaderMutation, UpdateJournalHeaderMutationVariables>;
export const JournalHeaderByIdDocument = gql`
    query JournalHeaderById($journalHeaderId: ID!) {
  journalHeader(id: $journalHeaderId) {
    id
    secondaryId
    journalNo
    sourceModuleId
    entryMethod
    sourceDocType
    sourceDocId
    journalDate
    fiscalPeriodId
    status
    reversalRefId
    entityId
    createdBy
    createdByName
    createdAt
    postedBy
    postedByName
    postedAt
    fiscalPeriod {
      id
      name
      secondaryId
    }
    entity {
      id
      entityName
    }
    sourceModule {
      id
      name
    }
  }
}
    `;

/**
 * __useJournalHeaderByIdQuery__
 *
 * To run a query within a React component, call `useJournalHeaderByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useJournalHeaderByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJournalHeaderByIdQuery({
 *   variables: {
 *      journalHeaderId: // value for 'journalHeaderId'
 *   },
 * });
 */
export function useJournalHeaderByIdQuery(baseOptions: Apollo.QueryHookOptions<JournalHeaderByIdQuery, JournalHeaderByIdQueryVariables> & ({ variables: JournalHeaderByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JournalHeaderByIdQuery, JournalHeaderByIdQueryVariables>(JournalHeaderByIdDocument, options);
      }
export function useJournalHeaderByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JournalHeaderByIdQuery, JournalHeaderByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JournalHeaderByIdQuery, JournalHeaderByIdQueryVariables>(JournalHeaderByIdDocument, options);
        }
// @ts-ignore
export function useJournalHeaderByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JournalHeaderByIdQuery, JournalHeaderByIdQueryVariables>): Apollo.UseSuspenseQueryResult<JournalHeaderByIdQuery, JournalHeaderByIdQueryVariables>;
export function useJournalHeaderByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JournalHeaderByIdQuery, JournalHeaderByIdQueryVariables>): Apollo.UseSuspenseQueryResult<JournalHeaderByIdQuery | undefined, JournalHeaderByIdQueryVariables>;
export function useJournalHeaderByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JournalHeaderByIdQuery, JournalHeaderByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JournalHeaderByIdQuery, JournalHeaderByIdQueryVariables>(JournalHeaderByIdDocument, options);
        }
export type JournalHeaderByIdQueryHookResult = ReturnType<typeof useJournalHeaderByIdQuery>;
export type JournalHeaderByIdLazyQueryHookResult = ReturnType<typeof useJournalHeaderByIdLazyQuery>;
export type JournalHeaderByIdSuspenseQueryHookResult = ReturnType<typeof useJournalHeaderByIdSuspenseQuery>;
export type JournalHeaderByIdQueryResult = Apollo.QueryResult<JournalHeaderByIdQuery, JournalHeaderByIdQueryVariables>;
export const JournalHeadersListDocument = gql`
    query JournalHeadersList($locationId: String, $limit: Int!, $page: Int!, $filter: [FilterGroup!], $sort: [SortCondition!]) {
  journalHeaders(
    locationId: $locationId
    limit: $limit
    page: $page
    filter: $filter
    sort: $sort
  ) {
    data {
      id
      secondaryId
      journalNo
      sourceModule {
        id
        name
      }
      journalDate
      fiscalPeriod {
        id
        name
      }
      status
      createdBy
      createdAt
      postedBy
      postedAt
      totalDebit
      totalCredit
      createdByName
      postedByName
    }
    meta {
      page
      limit
      totalCount
      total
    }
  }
}
    `;

/**
 * __useJournalHeadersListQuery__
 *
 * To run a query within a React component, call `useJournalHeadersListQuery` and pass it any options that fit your needs.
 * When your component renders, `useJournalHeadersListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJournalHeadersListQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useJournalHeadersListQuery(baseOptions: Apollo.QueryHookOptions<JournalHeadersListQuery, JournalHeadersListQueryVariables> & ({ variables: JournalHeadersListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JournalHeadersListQuery, JournalHeadersListQueryVariables>(JournalHeadersListDocument, options);
      }
export function useJournalHeadersListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JournalHeadersListQuery, JournalHeadersListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JournalHeadersListQuery, JournalHeadersListQueryVariables>(JournalHeadersListDocument, options);
        }
// @ts-ignore
export function useJournalHeadersListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JournalHeadersListQuery, JournalHeadersListQueryVariables>): Apollo.UseSuspenseQueryResult<JournalHeadersListQuery, JournalHeadersListQueryVariables>;
export function useJournalHeadersListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JournalHeadersListQuery, JournalHeadersListQueryVariables>): Apollo.UseSuspenseQueryResult<JournalHeadersListQuery | undefined, JournalHeadersListQueryVariables>;
export function useJournalHeadersListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JournalHeadersListQuery, JournalHeadersListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JournalHeadersListQuery, JournalHeadersListQueryVariables>(JournalHeadersListDocument, options);
        }
export type JournalHeadersListQueryHookResult = ReturnType<typeof useJournalHeadersListQuery>;
export type JournalHeadersListLazyQueryHookResult = ReturnType<typeof useJournalHeadersListLazyQuery>;
export type JournalHeadersListSuspenseQueryHookResult = ReturnType<typeof useJournalHeadersListSuspenseQuery>;
export type JournalHeadersListQueryResult = Apollo.QueryResult<JournalHeadersListQuery, JournalHeadersListQueryVariables>;
export const JournalLinesByHeaderIdDocument = gql`
    query JournalLinesByHeaderId($journalHeaderId: ID!) {
  journalLinesByHeaderId(journalHeaderId: $journalHeaderId) {
    id
    journalHeaderId
    debit
    credit
    costCenterId
    profitCenterId
    projectId
    partnerId
    customerId
    vendorId
    currencyId
    refId
    description
    profitCenterSource
    costCenterSource
    locationId
    customerName
    vendorName
    partnerName
    locationName
    account {
      id
      accountId
      name
    }
  }
}
    `;

/**
 * __useJournalLinesByHeaderIdQuery__
 *
 * To run a query within a React component, call `useJournalLinesByHeaderIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useJournalLinesByHeaderIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJournalLinesByHeaderIdQuery({
 *   variables: {
 *      journalHeaderId: // value for 'journalHeaderId'
 *   },
 * });
 */
export function useJournalLinesByHeaderIdQuery(baseOptions: Apollo.QueryHookOptions<JournalLinesByHeaderIdQuery, JournalLinesByHeaderIdQueryVariables> & ({ variables: JournalLinesByHeaderIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JournalLinesByHeaderIdQuery, JournalLinesByHeaderIdQueryVariables>(JournalLinesByHeaderIdDocument, options);
      }
export function useJournalLinesByHeaderIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JournalLinesByHeaderIdQuery, JournalLinesByHeaderIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JournalLinesByHeaderIdQuery, JournalLinesByHeaderIdQueryVariables>(JournalLinesByHeaderIdDocument, options);
        }
// @ts-ignore
export function useJournalLinesByHeaderIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JournalLinesByHeaderIdQuery, JournalLinesByHeaderIdQueryVariables>): Apollo.UseSuspenseQueryResult<JournalLinesByHeaderIdQuery, JournalLinesByHeaderIdQueryVariables>;
export function useJournalLinesByHeaderIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JournalLinesByHeaderIdQuery, JournalLinesByHeaderIdQueryVariables>): Apollo.UseSuspenseQueryResult<JournalLinesByHeaderIdQuery | undefined, JournalLinesByHeaderIdQueryVariables>;
export function useJournalLinesByHeaderIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JournalLinesByHeaderIdQuery, JournalLinesByHeaderIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JournalLinesByHeaderIdQuery, JournalLinesByHeaderIdQueryVariables>(JournalLinesByHeaderIdDocument, options);
        }
export type JournalLinesByHeaderIdQueryHookResult = ReturnType<typeof useJournalLinesByHeaderIdQuery>;
export type JournalLinesByHeaderIdLazyQueryHookResult = ReturnType<typeof useJournalLinesByHeaderIdLazyQuery>;
export type JournalLinesByHeaderIdSuspenseQueryHookResult = ReturnType<typeof useJournalLinesByHeaderIdSuspenseQuery>;
export type JournalLinesByHeaderIdQueryResult = Apollo.QueryResult<JournalLinesByHeaderIdQuery, JournalLinesByHeaderIdQueryVariables>;
export const PaymentTermsDocument = gql`
    query PaymentTerms($sort: [SortCondition!], $filter: [FilterGroup!], $page: Int!, $limit: Int!, $locationId: String) {
  paymentTerms(
    sort: $sort
    filter: $filter
    page: $page
    limit: $limit
    locationId: $locationId
  ) {
    meta {
      page
      limit
      totalCount
      total
    }
    data {
      id
      secondaryId
      name
      description
      graceDays
      baseDateType
      baseDate
      isInstallmentBased
      isDiscountApplicable
      applicableOn
      isActive
      entityId
      updatedAt
      createdBy
      createdByName
      updatedByName
      schedules {
        id
        secondaryId
        paymentTermId
        paymentNo
        dueOffsetDays
        duePercent
        fixedAmount
        calculationBasis
        entityId
        updatedAt
        createdBy
      }
      discounts {
        id
        calculationMethod
        discountDays
        discountPercent
      }
    }
  }
}
    `;

/**
 * __usePaymentTermsQuery__
 *
 * To run a query within a React component, call `usePaymentTermsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentTermsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentTermsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function usePaymentTermsQuery(baseOptions: Apollo.QueryHookOptions<PaymentTermsQuery, PaymentTermsQueryVariables> & ({ variables: PaymentTermsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentTermsQuery, PaymentTermsQueryVariables>(PaymentTermsDocument, options);
      }
export function usePaymentTermsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentTermsQuery, PaymentTermsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentTermsQuery, PaymentTermsQueryVariables>(PaymentTermsDocument, options);
        }
// @ts-ignore
export function usePaymentTermsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PaymentTermsQuery, PaymentTermsQueryVariables>): Apollo.UseSuspenseQueryResult<PaymentTermsQuery, PaymentTermsQueryVariables>;
export function usePaymentTermsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaymentTermsQuery, PaymentTermsQueryVariables>): Apollo.UseSuspenseQueryResult<PaymentTermsQuery | undefined, PaymentTermsQueryVariables>;
export function usePaymentTermsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaymentTermsQuery, PaymentTermsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaymentTermsQuery, PaymentTermsQueryVariables>(PaymentTermsDocument, options);
        }
export type PaymentTermsQueryHookResult = ReturnType<typeof usePaymentTermsQuery>;
export type PaymentTermsLazyQueryHookResult = ReturnType<typeof usePaymentTermsLazyQuery>;
export type PaymentTermsSuspenseQueryHookResult = ReturnType<typeof usePaymentTermsSuspenseQuery>;
export type PaymentTermsQueryResult = Apollo.QueryResult<PaymentTermsQuery, PaymentTermsQueryVariables>;
export const PaymentTermsForOptionsDocument = gql`
    query PaymentTermsForOptions($sort: [SortCondition!], $filter: [FilterGroup!], $page: Int!, $limit: Int!, $locationId: String) {
  paymentTerms(
    sort: $sort
    filter: $filter
    page: $page
    limit: $limit
    locationId: $locationId
  ) {
    data {
      id
      name
      graceDays
    }
    meta {
      limit
      page
      totalCount
    }
  }
}
    `;

/**
 * __usePaymentTermsForOptionsQuery__
 *
 * To run a query within a React component, call `usePaymentTermsForOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentTermsForOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentTermsForOptionsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function usePaymentTermsForOptionsQuery(baseOptions: Apollo.QueryHookOptions<PaymentTermsForOptionsQuery, PaymentTermsForOptionsQueryVariables> & ({ variables: PaymentTermsForOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentTermsForOptionsQuery, PaymentTermsForOptionsQueryVariables>(PaymentTermsForOptionsDocument, options);
      }
export function usePaymentTermsForOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentTermsForOptionsQuery, PaymentTermsForOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentTermsForOptionsQuery, PaymentTermsForOptionsQueryVariables>(PaymentTermsForOptionsDocument, options);
        }
// @ts-ignore
export function usePaymentTermsForOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PaymentTermsForOptionsQuery, PaymentTermsForOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<PaymentTermsForOptionsQuery, PaymentTermsForOptionsQueryVariables>;
export function usePaymentTermsForOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaymentTermsForOptionsQuery, PaymentTermsForOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<PaymentTermsForOptionsQuery | undefined, PaymentTermsForOptionsQueryVariables>;
export function usePaymentTermsForOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaymentTermsForOptionsQuery, PaymentTermsForOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaymentTermsForOptionsQuery, PaymentTermsForOptionsQueryVariables>(PaymentTermsForOptionsDocument, options);
        }
export type PaymentTermsForOptionsQueryHookResult = ReturnType<typeof usePaymentTermsForOptionsQuery>;
export type PaymentTermsForOptionsLazyQueryHookResult = ReturnType<typeof usePaymentTermsForOptionsLazyQuery>;
export type PaymentTermsForOptionsSuspenseQueryHookResult = ReturnType<typeof usePaymentTermsForOptionsSuspenseQuery>;
export type PaymentTermsForOptionsQueryResult = Apollo.QueryResult<PaymentTermsForOptionsQuery, PaymentTermsForOptionsQueryVariables>;
export const GetPaymentTermDocument = gql`
    query GetPaymentTerm($paymentTermId: ID!) {
  paymentTerm(id: $paymentTermId) {
    applicableOn
    baseDate
    baseDateType
    description
    entityId
    graceDays
    id
    isActive
    isDiscountApplicable
    isInstallmentBased
    name
    discounts {
      discountDays
      discountPercent
      calculationMethod
    }
    schedules {
      paymentNo
      fixedAmount
      duePercent
      dueOffsetDays
      calculationBasis
    }
  }
}
    `;

/**
 * __useGetPaymentTermQuery__
 *
 * To run a query within a React component, call `useGetPaymentTermQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentTermQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentTermQuery({
 *   variables: {
 *      paymentTermId: // value for 'paymentTermId'
 *   },
 * });
 */
export function useGetPaymentTermQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentTermQuery, GetPaymentTermQueryVariables> & ({ variables: GetPaymentTermQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentTermQuery, GetPaymentTermQueryVariables>(GetPaymentTermDocument, options);
      }
export function useGetPaymentTermLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentTermQuery, GetPaymentTermQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentTermQuery, GetPaymentTermQueryVariables>(GetPaymentTermDocument, options);
        }
// @ts-ignore
export function useGetPaymentTermSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPaymentTermQuery, GetPaymentTermQueryVariables>): Apollo.UseSuspenseQueryResult<GetPaymentTermQuery, GetPaymentTermQueryVariables>;
export function useGetPaymentTermSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaymentTermQuery, GetPaymentTermQueryVariables>): Apollo.UseSuspenseQueryResult<GetPaymentTermQuery | undefined, GetPaymentTermQueryVariables>;
export function useGetPaymentTermSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaymentTermQuery, GetPaymentTermQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaymentTermQuery, GetPaymentTermQueryVariables>(GetPaymentTermDocument, options);
        }
export type GetPaymentTermQueryHookResult = ReturnType<typeof useGetPaymentTermQuery>;
export type GetPaymentTermLazyQueryHookResult = ReturnType<typeof useGetPaymentTermLazyQuery>;
export type GetPaymentTermSuspenseQueryHookResult = ReturnType<typeof useGetPaymentTermSuspenseQuery>;
export type GetPaymentTermQueryResult = Apollo.QueryResult<GetPaymentTermQuery, GetPaymentTermQueryVariables>;
export const CreatePaymentTermsDocument = gql`
    mutation CreatePaymentTerms($createPaymentTerms: CreatePaymentTermsInput!) {
  createPaymentTerms(createPaymentTerms: $createPaymentTerms) {
    id
  }
}
    `;
export type CreatePaymentTermsMutationFn = Apollo.MutationFunction<CreatePaymentTermsMutation, CreatePaymentTermsMutationVariables>;

/**
 * __useCreatePaymentTermsMutation__
 *
 * To run a mutation, you first call `useCreatePaymentTermsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentTermsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentTermsMutation, { data, loading, error }] = useCreatePaymentTermsMutation({
 *   variables: {
 *      createPaymentTerms: // value for 'createPaymentTerms'
 *   },
 * });
 */
export function useCreatePaymentTermsMutation(baseOptions?: Apollo.MutationHookOptions<CreatePaymentTermsMutation, CreatePaymentTermsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePaymentTermsMutation, CreatePaymentTermsMutationVariables>(CreatePaymentTermsDocument, options);
      }
export type CreatePaymentTermsMutationHookResult = ReturnType<typeof useCreatePaymentTermsMutation>;
export type CreatePaymentTermsMutationResult = Apollo.MutationResult<CreatePaymentTermsMutation>;
export type CreatePaymentTermsMutationOptions = Apollo.BaseMutationOptions<CreatePaymentTermsMutation, CreatePaymentTermsMutationVariables>;
export const UpdatePaymentTermsDocument = gql`
    mutation UpdatePaymentTerms($updatePaymentTerms: UpdatePaymentTermsInput!) {
  updatePaymentTerms(updatePaymentTerms: $updatePaymentTerms) {
    id
  }
}
    `;
export type UpdatePaymentTermsMutationFn = Apollo.MutationFunction<UpdatePaymentTermsMutation, UpdatePaymentTermsMutationVariables>;

/**
 * __useUpdatePaymentTermsMutation__
 *
 * To run a mutation, you first call `useUpdatePaymentTermsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaymentTermsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaymentTermsMutation, { data, loading, error }] = useUpdatePaymentTermsMutation({
 *   variables: {
 *      updatePaymentTerms: // value for 'updatePaymentTerms'
 *   },
 * });
 */
export function useUpdatePaymentTermsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePaymentTermsMutation, UpdatePaymentTermsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePaymentTermsMutation, UpdatePaymentTermsMutationVariables>(UpdatePaymentTermsDocument, options);
      }
export type UpdatePaymentTermsMutationHookResult = ReturnType<typeof useUpdatePaymentTermsMutation>;
export type UpdatePaymentTermsMutationResult = Apollo.MutationResult<UpdatePaymentTermsMutation>;
export type UpdatePaymentTermsMutationOptions = Apollo.BaseMutationOptions<UpdatePaymentTermsMutation, UpdatePaymentTermsMutationVariables>;
export const UpdateProfitCenterDocument = gql`
    mutation UpdateProfitCenter($updateProfitCenter: UpdateProfitCenterInput!) {
  updateProfitCenter(updateProfitCenter: $updateProfitCenter) {
    id
  }
}
    `;
export type UpdateProfitCenterMutationFn = Apollo.MutationFunction<UpdateProfitCenterMutation, UpdateProfitCenterMutationVariables>;

/**
 * __useUpdateProfitCenterMutation__
 *
 * To run a mutation, you first call `useUpdateProfitCenterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfitCenterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfitCenterMutation, { data, loading, error }] = useUpdateProfitCenterMutation({
 *   variables: {
 *      updateProfitCenter: // value for 'updateProfitCenter'
 *   },
 * });
 */
export function useUpdateProfitCenterMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProfitCenterMutation, UpdateProfitCenterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProfitCenterMutation, UpdateProfitCenterMutationVariables>(UpdateProfitCenterDocument, options);
      }
export type UpdateProfitCenterMutationHookResult = ReturnType<typeof useUpdateProfitCenterMutation>;
export type UpdateProfitCenterMutationResult = Apollo.MutationResult<UpdateProfitCenterMutation>;
export type UpdateProfitCenterMutationOptions = Apollo.BaseMutationOptions<UpdateProfitCenterMutation, UpdateProfitCenterMutationVariables>;
export const CreateProfitCenterDocument = gql`
    mutation CreateProfitCenter($createProfitCenter: CreateProfitCenterInput!) {
  createProfitCenter(createProfitCenter: $createProfitCenter) {
    id
  }
}
    `;
export type CreateProfitCenterMutationFn = Apollo.MutationFunction<CreateProfitCenterMutation, CreateProfitCenterMutationVariables>;

/**
 * __useCreateProfitCenterMutation__
 *
 * To run a mutation, you first call `useCreateProfitCenterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProfitCenterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProfitCenterMutation, { data, loading, error }] = useCreateProfitCenterMutation({
 *   variables: {
 *      createProfitCenter: // value for 'createProfitCenter'
 *   },
 * });
 */
export function useCreateProfitCenterMutation(baseOptions?: Apollo.MutationHookOptions<CreateProfitCenterMutation, CreateProfitCenterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProfitCenterMutation, CreateProfitCenterMutationVariables>(CreateProfitCenterDocument, options);
      }
export type CreateProfitCenterMutationHookResult = ReturnType<typeof useCreateProfitCenterMutation>;
export type CreateProfitCenterMutationResult = Apollo.MutationResult<CreateProfitCenterMutation>;
export type CreateProfitCenterMutationOptions = Apollo.BaseMutationOptions<CreateProfitCenterMutation, CreateProfitCenterMutationVariables>;
export const ProfitCenterDetailDocument = gql`
    query ProfitCenterDetail($profitCenterId: ID!) {
  profitCenter(id: $profitCenterId) {
    id
    secondaryId
    code
    name
    type
    isDefault
    effectiveFrom
    effectiveTo
    status
    parentPcId
    managerId
    managerName
    entityId
    createdBy
    createdAt
    updatedBy
    updatedAt
    createdByName
    updatedByName
    parentPc {
      id
      name
    }
    entity {
      id
      entityName
    }
    coaAccounts {
      id
      coaAccountId
      coaAccount {
        id
        name
      }
    }
    locations {
      locationId
      id
      locationName
    }
  }
}
    `;

/**
 * __useProfitCenterDetailQuery__
 *
 * To run a query within a React component, call `useProfitCenterDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfitCenterDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfitCenterDetailQuery({
 *   variables: {
 *      profitCenterId: // value for 'profitCenterId'
 *   },
 * });
 */
export function useProfitCenterDetailQuery(baseOptions: Apollo.QueryHookOptions<ProfitCenterDetailQuery, ProfitCenterDetailQueryVariables> & ({ variables: ProfitCenterDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfitCenterDetailQuery, ProfitCenterDetailQueryVariables>(ProfitCenterDetailDocument, options);
      }
export function useProfitCenterDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfitCenterDetailQuery, ProfitCenterDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfitCenterDetailQuery, ProfitCenterDetailQueryVariables>(ProfitCenterDetailDocument, options);
        }
// @ts-ignore
export function useProfitCenterDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProfitCenterDetailQuery, ProfitCenterDetailQueryVariables>): Apollo.UseSuspenseQueryResult<ProfitCenterDetailQuery, ProfitCenterDetailQueryVariables>;
export function useProfitCenterDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProfitCenterDetailQuery, ProfitCenterDetailQueryVariables>): Apollo.UseSuspenseQueryResult<ProfitCenterDetailQuery | undefined, ProfitCenterDetailQueryVariables>;
export function useProfitCenterDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProfitCenterDetailQuery, ProfitCenterDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProfitCenterDetailQuery, ProfitCenterDetailQueryVariables>(ProfitCenterDetailDocument, options);
        }
export type ProfitCenterDetailQueryHookResult = ReturnType<typeof useProfitCenterDetailQuery>;
export type ProfitCenterDetailLazyQueryHookResult = ReturnType<typeof useProfitCenterDetailLazyQuery>;
export type ProfitCenterDetailSuspenseQueryHookResult = ReturnType<typeof useProfitCenterDetailSuspenseQuery>;
export type ProfitCenterDetailQueryResult = Apollo.QueryResult<ProfitCenterDetailQuery, ProfitCenterDetailQueryVariables>;
export const ProfitCentersListDocument = gql`
    query ProfitCentersList($locationId: String, $limit: Int!, $page: Int!, $filter: [FilterGroup!], $sort: [SortCondition!]) {
  profitCenters(
    locationId: $locationId
    limit: $limit
    page: $page
    filter: $filter
    sort: $sort
  ) {
    meta {
      page
      limit
      totalCount
      total
    }
    data {
      id
      secondaryId
      code
      name
      type
      isDefault
      effectiveFrom
      effectiveTo
      status
      parentPcId
      managerId
      entityId
      createdBy
      createdAt
      updatedBy
      updatedAt
      parentPc {
        id
        name
      }
      locations {
        locationId
        id
        locationName
      }
      managerName
      updatedByName
      createdByName
      entity {
        id
        entityName
      }
      coaAccounts {
        coaAccount {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useProfitCentersListQuery__
 *
 * To run a query within a React component, call `useProfitCentersListQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfitCentersListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfitCentersListQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useProfitCentersListQuery(baseOptions: Apollo.QueryHookOptions<ProfitCentersListQuery, ProfitCentersListQueryVariables> & ({ variables: ProfitCentersListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfitCentersListQuery, ProfitCentersListQueryVariables>(ProfitCentersListDocument, options);
      }
export function useProfitCentersListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfitCentersListQuery, ProfitCentersListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfitCentersListQuery, ProfitCentersListQueryVariables>(ProfitCentersListDocument, options);
        }
// @ts-ignore
export function useProfitCentersListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProfitCentersListQuery, ProfitCentersListQueryVariables>): Apollo.UseSuspenseQueryResult<ProfitCentersListQuery, ProfitCentersListQueryVariables>;
export function useProfitCentersListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProfitCentersListQuery, ProfitCentersListQueryVariables>): Apollo.UseSuspenseQueryResult<ProfitCentersListQuery | undefined, ProfitCentersListQueryVariables>;
export function useProfitCentersListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProfitCentersListQuery, ProfitCentersListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProfitCentersListQuery, ProfitCentersListQueryVariables>(ProfitCentersListDocument, options);
        }
export type ProfitCentersListQueryHookResult = ReturnType<typeof useProfitCentersListQuery>;
export type ProfitCentersListLazyQueryHookResult = ReturnType<typeof useProfitCentersListLazyQuery>;
export type ProfitCentersListSuspenseQueryHookResult = ReturnType<typeof useProfitCentersListSuspenseQuery>;
export type ProfitCentersListQueryResult = Apollo.QueryResult<ProfitCentersListQuery, ProfitCentersListQueryVariables>;
export const ProfitCentersListForOptionsDocument = gql`
    query ProfitCentersListForOptions($locationId: String, $limit: Int!, $page: Int!, $filter: [FilterGroup!], $sort: [SortCondition!]) {
  profitCenters(
    locationId: $locationId
    limit: $limit
    page: $page
    filter: $filter
    sort: $sort
  ) {
    meta {
      page
      limit
      totalCount
      total
    }
    data {
      id
      secondaryId
      code
      name
    }
  }
}
    `;

/**
 * __useProfitCentersListForOptionsQuery__
 *
 * To run a query within a React component, call `useProfitCentersListForOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfitCentersListForOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfitCentersListForOptionsQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useProfitCentersListForOptionsQuery(baseOptions: Apollo.QueryHookOptions<ProfitCentersListForOptionsQuery, ProfitCentersListForOptionsQueryVariables> & ({ variables: ProfitCentersListForOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfitCentersListForOptionsQuery, ProfitCentersListForOptionsQueryVariables>(ProfitCentersListForOptionsDocument, options);
      }
export function useProfitCentersListForOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfitCentersListForOptionsQuery, ProfitCentersListForOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfitCentersListForOptionsQuery, ProfitCentersListForOptionsQueryVariables>(ProfitCentersListForOptionsDocument, options);
        }
// @ts-ignore
export function useProfitCentersListForOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProfitCentersListForOptionsQuery, ProfitCentersListForOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<ProfitCentersListForOptionsQuery, ProfitCentersListForOptionsQueryVariables>;
export function useProfitCentersListForOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProfitCentersListForOptionsQuery, ProfitCentersListForOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<ProfitCentersListForOptionsQuery | undefined, ProfitCentersListForOptionsQueryVariables>;
export function useProfitCentersListForOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProfitCentersListForOptionsQuery, ProfitCentersListForOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProfitCentersListForOptionsQuery, ProfitCentersListForOptionsQueryVariables>(ProfitCentersListForOptionsDocument, options);
        }
export type ProfitCentersListForOptionsQueryHookResult = ReturnType<typeof useProfitCentersListForOptionsQuery>;
export type ProfitCentersListForOptionsLazyQueryHookResult = ReturnType<typeof useProfitCentersListForOptionsLazyQuery>;
export type ProfitCentersListForOptionsSuspenseQueryHookResult = ReturnType<typeof useProfitCentersListForOptionsSuspenseQuery>;
export type ProfitCentersListForOptionsQueryResult = Apollo.QueryResult<ProfitCentersListForOptionsQuery, ProfitCentersListForOptionsQueryVariables>;
export const CreateSourceModuleDocument = gql`
    mutation CreateSourceModule($input: CreateSourceModuleInput!) {
  createSourceModule(input: $input) {
    id
  }
}
    `;
export type CreateSourceModuleMutationFn = Apollo.MutationFunction<CreateSourceModuleMutation, CreateSourceModuleMutationVariables>;

/**
 * __useCreateSourceModuleMutation__
 *
 * To run a mutation, you first call `useCreateSourceModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSourceModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSourceModuleMutation, { data, loading, error }] = useCreateSourceModuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSourceModuleMutation(baseOptions?: Apollo.MutationHookOptions<CreateSourceModuleMutation, CreateSourceModuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSourceModuleMutation, CreateSourceModuleMutationVariables>(CreateSourceModuleDocument, options);
      }
export type CreateSourceModuleMutationHookResult = ReturnType<typeof useCreateSourceModuleMutation>;
export type CreateSourceModuleMutationResult = Apollo.MutationResult<CreateSourceModuleMutation>;
export type CreateSourceModuleMutationOptions = Apollo.BaseMutationOptions<CreateSourceModuleMutation, CreateSourceModuleMutationVariables>;
export const DeleteSourceModuleDocument = gql`
    mutation DeleteSourceModule($deleteSourceModuleId: ID!) {
  deleteSourceModule(id: $deleteSourceModuleId)
}
    `;
export type DeleteSourceModuleMutationFn = Apollo.MutationFunction<DeleteSourceModuleMutation, DeleteSourceModuleMutationVariables>;

/**
 * __useDeleteSourceModuleMutation__
 *
 * To run a mutation, you first call `useDeleteSourceModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSourceModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSourceModuleMutation, { data, loading, error }] = useDeleteSourceModuleMutation({
 *   variables: {
 *      deleteSourceModuleId: // value for 'deleteSourceModuleId'
 *   },
 * });
 */
export function useDeleteSourceModuleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSourceModuleMutation, DeleteSourceModuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSourceModuleMutation, DeleteSourceModuleMutationVariables>(DeleteSourceModuleDocument, options);
      }
export type DeleteSourceModuleMutationHookResult = ReturnType<typeof useDeleteSourceModuleMutation>;
export type DeleteSourceModuleMutationResult = Apollo.MutationResult<DeleteSourceModuleMutation>;
export type DeleteSourceModuleMutationOptions = Apollo.BaseMutationOptions<DeleteSourceModuleMutation, DeleteSourceModuleMutationVariables>;
export const UpdateSourceModuleDocument = gql`
    mutation UpdateSourceModule($input: UpdateSourceModuleInput!) {
  updateSourceModule(input: $input) {
    id
  }
}
    `;
export type UpdateSourceModuleMutationFn = Apollo.MutationFunction<UpdateSourceModuleMutation, UpdateSourceModuleMutationVariables>;

/**
 * __useUpdateSourceModuleMutation__
 *
 * To run a mutation, you first call `useUpdateSourceModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSourceModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSourceModuleMutation, { data, loading, error }] = useUpdateSourceModuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSourceModuleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSourceModuleMutation, UpdateSourceModuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSourceModuleMutation, UpdateSourceModuleMutationVariables>(UpdateSourceModuleDocument, options);
      }
export type UpdateSourceModuleMutationHookResult = ReturnType<typeof useUpdateSourceModuleMutation>;
export type UpdateSourceModuleMutationResult = Apollo.MutationResult<UpdateSourceModuleMutation>;
export type UpdateSourceModuleMutationOptions = Apollo.BaseMutationOptions<UpdateSourceModuleMutation, UpdateSourceModuleMutationVariables>;
export const SourceModuleDocument = gql`
    query SourceModule($sourceModuleId: ID!) {
  sourceModule(id: $sourceModuleId) {
    id
    code
    name
    prefix
    autoPostEnabled
    resetCycle
    allowManualNumber
    description
    entityId
    createdBy
    createdAt
    entity {
      entityName
      id
    }
  }
}
    `;

/**
 * __useSourceModuleQuery__
 *
 * To run a query within a React component, call `useSourceModuleQuery` and pass it any options that fit your needs.
 * When your component renders, `useSourceModuleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSourceModuleQuery({
 *   variables: {
 *      sourceModuleId: // value for 'sourceModuleId'
 *   },
 * });
 */
export function useSourceModuleQuery(baseOptions: Apollo.QueryHookOptions<SourceModuleQuery, SourceModuleQueryVariables> & ({ variables: SourceModuleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SourceModuleQuery, SourceModuleQueryVariables>(SourceModuleDocument, options);
      }
export function useSourceModuleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SourceModuleQuery, SourceModuleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SourceModuleQuery, SourceModuleQueryVariables>(SourceModuleDocument, options);
        }
// @ts-ignore
export function useSourceModuleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SourceModuleQuery, SourceModuleQueryVariables>): Apollo.UseSuspenseQueryResult<SourceModuleQuery, SourceModuleQueryVariables>;
export function useSourceModuleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SourceModuleQuery, SourceModuleQueryVariables>): Apollo.UseSuspenseQueryResult<SourceModuleQuery | undefined, SourceModuleQueryVariables>;
export function useSourceModuleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SourceModuleQuery, SourceModuleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SourceModuleQuery, SourceModuleQueryVariables>(SourceModuleDocument, options);
        }
export type SourceModuleQueryHookResult = ReturnType<typeof useSourceModuleQuery>;
export type SourceModuleLazyQueryHookResult = ReturnType<typeof useSourceModuleLazyQuery>;
export type SourceModuleSuspenseQueryHookResult = ReturnType<typeof useSourceModuleSuspenseQuery>;
export type SourceModuleQueryResult = Apollo.QueryResult<SourceModuleQuery, SourceModuleQueryVariables>;
export const SourceModulesListDocument = gql`
    query SourceModulesList($sort: [SortCondition!], $filter: [FilterGroup!], $locationId: String, $limit: Int!, $page: Int!) {
  sourceModules(
    sort: $sort
    filter: $filter
    locationId: $locationId
    limit: $limit
    page: $page
  ) {
    meta {
      page
      limit
      totalCount
      total
    }
    data {
      id
      code
      name
      prefix
      autoPostEnabled
      resetCycle
      allowManualNumber
      description
      createdBy
      createdAt
      secondaryId
      entity {
        id
        entityName
      }
    }
  }
}
    `;

/**
 * __useSourceModulesListQuery__
 *
 * To run a query within a React component, call `useSourceModulesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSourceModulesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSourceModulesListQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      locationId: // value for 'locationId'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useSourceModulesListQuery(baseOptions: Apollo.QueryHookOptions<SourceModulesListQuery, SourceModulesListQueryVariables> & ({ variables: SourceModulesListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SourceModulesListQuery, SourceModulesListQueryVariables>(SourceModulesListDocument, options);
      }
export function useSourceModulesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SourceModulesListQuery, SourceModulesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SourceModulesListQuery, SourceModulesListQueryVariables>(SourceModulesListDocument, options);
        }
// @ts-ignore
export function useSourceModulesListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SourceModulesListQuery, SourceModulesListQueryVariables>): Apollo.UseSuspenseQueryResult<SourceModulesListQuery, SourceModulesListQueryVariables>;
export function useSourceModulesListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SourceModulesListQuery, SourceModulesListQueryVariables>): Apollo.UseSuspenseQueryResult<SourceModulesListQuery | undefined, SourceModulesListQueryVariables>;
export function useSourceModulesListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SourceModulesListQuery, SourceModulesListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SourceModulesListQuery, SourceModulesListQueryVariables>(SourceModulesListDocument, options);
        }
export type SourceModulesListQueryHookResult = ReturnType<typeof useSourceModulesListQuery>;
export type SourceModulesListLazyQueryHookResult = ReturnType<typeof useSourceModulesListLazyQuery>;
export type SourceModulesListSuspenseQueryHookResult = ReturnType<typeof useSourceModulesListSuspenseQuery>;
export type SourceModulesListQueryResult = Apollo.QueryResult<SourceModulesListQuery, SourceModulesListQueryVariables>;
export const SourceModulesListForOptionsDocument = gql`
    query SourceModulesListForOptions($sort: [SortCondition!], $filter: [FilterGroup!], $locationId: String, $limit: Int!, $page: Int!) {
  sourceModules(
    sort: $sort
    filter: $filter
    locationId: $locationId
    limit: $limit
    page: $page
  ) {
    data {
      id
      name
    }
  }
}
    `;

/**
 * __useSourceModulesListForOptionsQuery__
 *
 * To run a query within a React component, call `useSourceModulesListForOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSourceModulesListForOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSourceModulesListForOptionsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      locationId: // value for 'locationId'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useSourceModulesListForOptionsQuery(baseOptions: Apollo.QueryHookOptions<SourceModulesListForOptionsQuery, SourceModulesListForOptionsQueryVariables> & ({ variables: SourceModulesListForOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SourceModulesListForOptionsQuery, SourceModulesListForOptionsQueryVariables>(SourceModulesListForOptionsDocument, options);
      }
export function useSourceModulesListForOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SourceModulesListForOptionsQuery, SourceModulesListForOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SourceModulesListForOptionsQuery, SourceModulesListForOptionsQueryVariables>(SourceModulesListForOptionsDocument, options);
        }
// @ts-ignore
export function useSourceModulesListForOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SourceModulesListForOptionsQuery, SourceModulesListForOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<SourceModulesListForOptionsQuery, SourceModulesListForOptionsQueryVariables>;
export function useSourceModulesListForOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SourceModulesListForOptionsQuery, SourceModulesListForOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<SourceModulesListForOptionsQuery | undefined, SourceModulesListForOptionsQueryVariables>;
export function useSourceModulesListForOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SourceModulesListForOptionsQuery, SourceModulesListForOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SourceModulesListForOptionsQuery, SourceModulesListForOptionsQueryVariables>(SourceModulesListForOptionsDocument, options);
        }
export type SourceModulesListForOptionsQueryHookResult = ReturnType<typeof useSourceModulesListForOptionsQuery>;
export type SourceModulesListForOptionsLazyQueryHookResult = ReturnType<typeof useSourceModulesListForOptionsLazyQuery>;
export type SourceModulesListForOptionsSuspenseQueryHookResult = ReturnType<typeof useSourceModulesListForOptionsSuspenseQuery>;
export type SourceModulesListForOptionsQueryResult = Apollo.QueryResult<SourceModulesListForOptionsQuery, SourceModulesListForOptionsQueryVariables>;
export const TrialBalanceReportExtendedDocument = gql`
    query TrialBalanceReportExtended($entityId: ID!, $startDate: DateTime!, $endDate: DateTime!, $costCenterIds: [ID!], $profitCenterIds: [ID!], $locationIds: [ID!]) {
  trialBalanceReport(
    entityId: $entityId
    startDate: $startDate
    endDate: $endDate
    costCenterIds: $costCenterIds
    profitCenterIds: $profitCenterIds
    locationIds: $locationIds
  ) {
    totalOpeningDebit
    totalOpeningCredit
    totalDebit
    totalCredit
    totalClosingDebit
    totalClosingCredit
    isBalanced
    startDate
    endDate
    currency
    rows {
      accountId
      accountCode
      accountName
      parentAccountId
      level
      isGroup
      accountType
      debit
      credit
      balance
      openingDebit
      openingCredit
      closingDebit
      closingCredit
    }
  }
}
    `;

/**
 * __useTrialBalanceReportExtendedQuery__
 *
 * To run a query within a React component, call `useTrialBalanceReportExtendedQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrialBalanceReportExtendedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrialBalanceReportExtendedQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      costCenterIds: // value for 'costCenterIds'
 *      profitCenterIds: // value for 'profitCenterIds'
 *      locationIds: // value for 'locationIds'
 *   },
 * });
 */
export function useTrialBalanceReportExtendedQuery(baseOptions: Apollo.QueryHookOptions<TrialBalanceReportExtendedQuery, TrialBalanceReportExtendedQueryVariables> & ({ variables: TrialBalanceReportExtendedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrialBalanceReportExtendedQuery, TrialBalanceReportExtendedQueryVariables>(TrialBalanceReportExtendedDocument, options);
      }
export function useTrialBalanceReportExtendedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrialBalanceReportExtendedQuery, TrialBalanceReportExtendedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrialBalanceReportExtendedQuery, TrialBalanceReportExtendedQueryVariables>(TrialBalanceReportExtendedDocument, options);
        }
// @ts-ignore
export function useTrialBalanceReportExtendedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrialBalanceReportExtendedQuery, TrialBalanceReportExtendedQueryVariables>): Apollo.UseSuspenseQueryResult<TrialBalanceReportExtendedQuery, TrialBalanceReportExtendedQueryVariables>;
export function useTrialBalanceReportExtendedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TrialBalanceReportExtendedQuery, TrialBalanceReportExtendedQueryVariables>): Apollo.UseSuspenseQueryResult<TrialBalanceReportExtendedQuery | undefined, TrialBalanceReportExtendedQueryVariables>;
export function useTrialBalanceReportExtendedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TrialBalanceReportExtendedQuery, TrialBalanceReportExtendedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrialBalanceReportExtendedQuery, TrialBalanceReportExtendedQueryVariables>(TrialBalanceReportExtendedDocument, options);
        }
export type TrialBalanceReportExtendedQueryHookResult = ReturnType<typeof useTrialBalanceReportExtendedQuery>;
export type TrialBalanceReportExtendedLazyQueryHookResult = ReturnType<typeof useTrialBalanceReportExtendedLazyQuery>;
export type TrialBalanceReportExtendedSuspenseQueryHookResult = ReturnType<typeof useTrialBalanceReportExtendedSuspenseQuery>;
export type TrialBalanceReportExtendedQueryResult = Apollo.QueryResult<TrialBalanceReportExtendedQuery, TrialBalanceReportExtendedQueryVariables>;
export const GetAdjustmentsListDocument = gql`
    query GetAdjustmentsList($sort: [SortCondition!], $page: Int!, $locationId: String, $limit: Int!, $filter: [FilterGroup!]) {
  getAdjustments(
    sort: $sort
    page: $page
    locationId: $locationId
    limit: $limit
    filter: $filter
  ) {
    meta {
      limit
      page
      total
      totalCount
    }
    data {
      adjustedQuantity
      adjustmentType
      auditId
      id
      createdAt
      createdBy
      itemCount
      lotCount
      remarks
      secondaryId
      status
      stockValue
      stockValueExcludingTax
      taxValue
      title
      updatedAt
      updatedBy
    }
  }
}
    `;

/**
 * __useGetAdjustmentsListQuery__
 *
 * To run a query within a React component, call `useGetAdjustmentsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdjustmentsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdjustmentsListQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      locationId: // value for 'locationId'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetAdjustmentsListQuery(baseOptions: Apollo.QueryHookOptions<GetAdjustmentsListQuery, GetAdjustmentsListQueryVariables> & ({ variables: GetAdjustmentsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdjustmentsListQuery, GetAdjustmentsListQueryVariables>(GetAdjustmentsListDocument, options);
      }
export function useGetAdjustmentsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdjustmentsListQuery, GetAdjustmentsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdjustmentsListQuery, GetAdjustmentsListQueryVariables>(GetAdjustmentsListDocument, options);
        }
// @ts-ignore
export function useGetAdjustmentsListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAdjustmentsListQuery, GetAdjustmentsListQueryVariables>): Apollo.UseSuspenseQueryResult<GetAdjustmentsListQuery, GetAdjustmentsListQueryVariables>;
export function useGetAdjustmentsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAdjustmentsListQuery, GetAdjustmentsListQueryVariables>): Apollo.UseSuspenseQueryResult<GetAdjustmentsListQuery | undefined, GetAdjustmentsListQueryVariables>;
export function useGetAdjustmentsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAdjustmentsListQuery, GetAdjustmentsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAdjustmentsListQuery, GetAdjustmentsListQueryVariables>(GetAdjustmentsListDocument, options);
        }
export type GetAdjustmentsListQueryHookResult = ReturnType<typeof useGetAdjustmentsListQuery>;
export type GetAdjustmentsListLazyQueryHookResult = ReturnType<typeof useGetAdjustmentsListLazyQuery>;
export type GetAdjustmentsListSuspenseQueryHookResult = ReturnType<typeof useGetAdjustmentsListSuspenseQuery>;
export type GetAdjustmentsListQueryResult = Apollo.QueryResult<GetAdjustmentsListQuery, GetAdjustmentsListQueryVariables>;
export const UpdateAdjustmentStatusDocument = gql`
    mutation UpdateAdjustmentStatus($updateAdjustmentStatusId: String!, $status: AdjustmentStatus!) {
  updateAdjustmentStatus(id: $updateAdjustmentStatusId, status: $status)
}
    `;
export type UpdateAdjustmentStatusMutationFn = Apollo.MutationFunction<UpdateAdjustmentStatusMutation, UpdateAdjustmentStatusMutationVariables>;

/**
 * __useUpdateAdjustmentStatusMutation__
 *
 * To run a mutation, you first call `useUpdateAdjustmentStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdjustmentStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdjustmentStatusMutation, { data, loading, error }] = useUpdateAdjustmentStatusMutation({
 *   variables: {
 *      updateAdjustmentStatusId: // value for 'updateAdjustmentStatusId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateAdjustmentStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAdjustmentStatusMutation, UpdateAdjustmentStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAdjustmentStatusMutation, UpdateAdjustmentStatusMutationVariables>(UpdateAdjustmentStatusDocument, options);
      }
export type UpdateAdjustmentStatusMutationHookResult = ReturnType<typeof useUpdateAdjustmentStatusMutation>;
export type UpdateAdjustmentStatusMutationResult = Apollo.MutationResult<UpdateAdjustmentStatusMutation>;
export type UpdateAdjustmentStatusMutationOptions = Apollo.BaseMutationOptions<UpdateAdjustmentStatusMutation, UpdateAdjustmentStatusMutationVariables>;
export const CreateAdjustmentDocument = gql`
    mutation CreateAdjustment($createAdjustmentDto: CreateAdjustmentDto!) {
  createAdjustment(createAdjustmentDto: $createAdjustmentDto)
}
    `;
export type CreateAdjustmentMutationFn = Apollo.MutationFunction<CreateAdjustmentMutation, CreateAdjustmentMutationVariables>;

/**
 * __useCreateAdjustmentMutation__
 *
 * To run a mutation, you first call `useCreateAdjustmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdjustmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdjustmentMutation, { data, loading, error }] = useCreateAdjustmentMutation({
 *   variables: {
 *      createAdjustmentDto: // value for 'createAdjustmentDto'
 *   },
 * });
 */
export function useCreateAdjustmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateAdjustmentMutation, CreateAdjustmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAdjustmentMutation, CreateAdjustmentMutationVariables>(CreateAdjustmentDocument, options);
      }
export type CreateAdjustmentMutationHookResult = ReturnType<typeof useCreateAdjustmentMutation>;
export type CreateAdjustmentMutationResult = Apollo.MutationResult<CreateAdjustmentMutation>;
export type CreateAdjustmentMutationOptions = Apollo.BaseMutationOptions<CreateAdjustmentMutation, CreateAdjustmentMutationVariables>;
export const GetAdjustmentDocument = gql`
    query GetAdjustment($getAdjustmentId: String!) {
  getAdjustment(id: $getAdjustmentId) {
    id
    adjustmentType
    secondaryId
    remarks
    status
    title
    createdAt
    updatedAt
    products {
      id
      locationId
      productName
      netQuantity
      stockValue
      adjustmentLot {
        id
        actionId
        status
        adjustedStatus
        adjustedExpiryDate
        expiryDate
        adjustedQuantity
        damageQuantity
        damageQuantityUnit
        originalQuantity
        adjustedLocation {
          name
        }
        location {
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetAdjustmentQuery__
 *
 * To run a query within a React component, call `useGetAdjustmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdjustmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdjustmentQuery({
 *   variables: {
 *      getAdjustmentId: // value for 'getAdjustmentId'
 *   },
 * });
 */
export function useGetAdjustmentQuery(baseOptions: Apollo.QueryHookOptions<GetAdjustmentQuery, GetAdjustmentQueryVariables> & ({ variables: GetAdjustmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdjustmentQuery, GetAdjustmentQueryVariables>(GetAdjustmentDocument, options);
      }
export function useGetAdjustmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdjustmentQuery, GetAdjustmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdjustmentQuery, GetAdjustmentQueryVariables>(GetAdjustmentDocument, options);
        }
// @ts-ignore
export function useGetAdjustmentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAdjustmentQuery, GetAdjustmentQueryVariables>): Apollo.UseSuspenseQueryResult<GetAdjustmentQuery, GetAdjustmentQueryVariables>;
export function useGetAdjustmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAdjustmentQuery, GetAdjustmentQueryVariables>): Apollo.UseSuspenseQueryResult<GetAdjustmentQuery | undefined, GetAdjustmentQueryVariables>;
export function useGetAdjustmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAdjustmentQuery, GetAdjustmentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAdjustmentQuery, GetAdjustmentQueryVariables>(GetAdjustmentDocument, options);
        }
export type GetAdjustmentQueryHookResult = ReturnType<typeof useGetAdjustmentQuery>;
export type GetAdjustmentLazyQueryHookResult = ReturnType<typeof useGetAdjustmentLazyQuery>;
export type GetAdjustmentSuspenseQueryHookResult = ReturnType<typeof useGetAdjustmentSuspenseQuery>;
export type GetAdjustmentQueryResult = Apollo.QueryResult<GetAdjustmentQuery, GetAdjustmentQueryVariables>;
export const CalculatedColumnFunctionsDocument = gql`
    query CalculatedColumnFunctions {
  calculatedColumnFunctions {
    name
    category
    signature
    description
  }
}
    `;

/**
 * __useCalculatedColumnFunctionsQuery__
 *
 * To run a query within a React component, call `useCalculatedColumnFunctionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalculatedColumnFunctionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalculatedColumnFunctionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCalculatedColumnFunctionsQuery(baseOptions?: Apollo.QueryHookOptions<CalculatedColumnFunctionsQuery, CalculatedColumnFunctionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalculatedColumnFunctionsQuery, CalculatedColumnFunctionsQueryVariables>(CalculatedColumnFunctionsDocument, options);
      }
export function useCalculatedColumnFunctionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalculatedColumnFunctionsQuery, CalculatedColumnFunctionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalculatedColumnFunctionsQuery, CalculatedColumnFunctionsQueryVariables>(CalculatedColumnFunctionsDocument, options);
        }
// @ts-ignore
export function useCalculatedColumnFunctionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CalculatedColumnFunctionsQuery, CalculatedColumnFunctionsQueryVariables>): Apollo.UseSuspenseQueryResult<CalculatedColumnFunctionsQuery, CalculatedColumnFunctionsQueryVariables>;
export function useCalculatedColumnFunctionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CalculatedColumnFunctionsQuery, CalculatedColumnFunctionsQueryVariables>): Apollo.UseSuspenseQueryResult<CalculatedColumnFunctionsQuery | undefined, CalculatedColumnFunctionsQueryVariables>;
export function useCalculatedColumnFunctionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CalculatedColumnFunctionsQuery, CalculatedColumnFunctionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CalculatedColumnFunctionsQuery, CalculatedColumnFunctionsQueryVariables>(CalculatedColumnFunctionsDocument, options);
        }
export type CalculatedColumnFunctionsQueryHookResult = ReturnType<typeof useCalculatedColumnFunctionsQuery>;
export type CalculatedColumnFunctionsLazyQueryHookResult = ReturnType<typeof useCalculatedColumnFunctionsLazyQuery>;
export type CalculatedColumnFunctionsSuspenseQueryHookResult = ReturnType<typeof useCalculatedColumnFunctionsSuspenseQuery>;
export type CalculatedColumnFunctionsQueryResult = Apollo.QueryResult<CalculatedColumnFunctionsQuery, CalculatedColumnFunctionsQueryVariables>;
export const CheckCalculatedColumnDocument = gql`
    query CheckCalculatedColumn($input: CheckCalculatedColumnInput!) {
  checkCalculatedColumn(input: $input) {
    valid
    resultType
    volatile
    error
  }
}
    `;

/**
 * __useCheckCalculatedColumnQuery__
 *
 * To run a query within a React component, call `useCheckCalculatedColumnQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckCalculatedColumnQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckCalculatedColumnQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCheckCalculatedColumnQuery(baseOptions: Apollo.QueryHookOptions<CheckCalculatedColumnQuery, CheckCalculatedColumnQueryVariables> & ({ variables: CheckCalculatedColumnQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckCalculatedColumnQuery, CheckCalculatedColumnQueryVariables>(CheckCalculatedColumnDocument, options);
      }
export function useCheckCalculatedColumnLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckCalculatedColumnQuery, CheckCalculatedColumnQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckCalculatedColumnQuery, CheckCalculatedColumnQueryVariables>(CheckCalculatedColumnDocument, options);
        }
// @ts-ignore
export function useCheckCalculatedColumnSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CheckCalculatedColumnQuery, CheckCalculatedColumnQueryVariables>): Apollo.UseSuspenseQueryResult<CheckCalculatedColumnQuery, CheckCalculatedColumnQueryVariables>;
export function useCheckCalculatedColumnSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckCalculatedColumnQuery, CheckCalculatedColumnQueryVariables>): Apollo.UseSuspenseQueryResult<CheckCalculatedColumnQuery | undefined, CheckCalculatedColumnQueryVariables>;
export function useCheckCalculatedColumnSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckCalculatedColumnQuery, CheckCalculatedColumnQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckCalculatedColumnQuery, CheckCalculatedColumnQueryVariables>(CheckCalculatedColumnDocument, options);
        }
export type CheckCalculatedColumnQueryHookResult = ReturnType<typeof useCheckCalculatedColumnQuery>;
export type CheckCalculatedColumnLazyQueryHookResult = ReturnType<typeof useCheckCalculatedColumnLazyQuery>;
export type CheckCalculatedColumnSuspenseQueryHookResult = ReturnType<typeof useCheckCalculatedColumnSuspenseQuery>;
export type CheckCalculatedColumnQueryResult = Apollo.QueryResult<CheckCalculatedColumnQuery, CheckCalculatedColumnQueryVariables>;
export const CalculatedColumnUsageDocument = gql`
    query CalculatedColumnUsage($id: String!) {
  calculatedColumnUsage(id: $id) {
    reports {
      id
      name
    }
    columns {
      id
      name
    }
  }
}
    `;

/**
 * __useCalculatedColumnUsageQuery__
 *
 * To run a query within a React component, call `useCalculatedColumnUsageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalculatedColumnUsageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalculatedColumnUsageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCalculatedColumnUsageQuery(baseOptions: Apollo.QueryHookOptions<CalculatedColumnUsageQuery, CalculatedColumnUsageQueryVariables> & ({ variables: CalculatedColumnUsageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalculatedColumnUsageQuery, CalculatedColumnUsageQueryVariables>(CalculatedColumnUsageDocument, options);
      }
export function useCalculatedColumnUsageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalculatedColumnUsageQuery, CalculatedColumnUsageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalculatedColumnUsageQuery, CalculatedColumnUsageQueryVariables>(CalculatedColumnUsageDocument, options);
        }
// @ts-ignore
export function useCalculatedColumnUsageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CalculatedColumnUsageQuery, CalculatedColumnUsageQueryVariables>): Apollo.UseSuspenseQueryResult<CalculatedColumnUsageQuery, CalculatedColumnUsageQueryVariables>;
export function useCalculatedColumnUsageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CalculatedColumnUsageQuery, CalculatedColumnUsageQueryVariables>): Apollo.UseSuspenseQueryResult<CalculatedColumnUsageQuery | undefined, CalculatedColumnUsageQueryVariables>;
export function useCalculatedColumnUsageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CalculatedColumnUsageQuery, CalculatedColumnUsageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CalculatedColumnUsageQuery, CalculatedColumnUsageQueryVariables>(CalculatedColumnUsageDocument, options);
        }
export type CalculatedColumnUsageQueryHookResult = ReturnType<typeof useCalculatedColumnUsageQuery>;
export type CalculatedColumnUsageLazyQueryHookResult = ReturnType<typeof useCalculatedColumnUsageLazyQuery>;
export type CalculatedColumnUsageSuspenseQueryHookResult = ReturnType<typeof useCalculatedColumnUsageSuspenseQuery>;
export type CalculatedColumnUsageQueryResult = Apollo.QueryResult<CalculatedColumnUsageQuery, CalculatedColumnUsageQueryVariables>;
export const CreateCalculatedColumnDocument = gql`
    mutation CreateCalculatedColumn($input: CreateCalculatedColumnInput!) {
  createCalculatedColumn(input: $input) {
    id
    key
    label
    expression
    resultType
    format
  }
}
    `;
export type CreateCalculatedColumnMutationFn = Apollo.MutationFunction<CreateCalculatedColumnMutation, CreateCalculatedColumnMutationVariables>;

/**
 * __useCreateCalculatedColumnMutation__
 *
 * To run a mutation, you first call `useCreateCalculatedColumnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCalculatedColumnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCalculatedColumnMutation, { data, loading, error }] = useCreateCalculatedColumnMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCalculatedColumnMutation(baseOptions?: Apollo.MutationHookOptions<CreateCalculatedColumnMutation, CreateCalculatedColumnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCalculatedColumnMutation, CreateCalculatedColumnMutationVariables>(CreateCalculatedColumnDocument, options);
      }
export type CreateCalculatedColumnMutationHookResult = ReturnType<typeof useCreateCalculatedColumnMutation>;
export type CreateCalculatedColumnMutationResult = Apollo.MutationResult<CreateCalculatedColumnMutation>;
export type CreateCalculatedColumnMutationOptions = Apollo.BaseMutationOptions<CreateCalculatedColumnMutation, CreateCalculatedColumnMutationVariables>;
export const UpdateCalculatedColumnDocument = gql`
    mutation UpdateCalculatedColumn($id: String!, $input: UpdateCalculatedColumnInput!) {
  updateCalculatedColumn(id: $id, input: $input) {
    id
    key
    label
    expression
    resultType
    format
  }
}
    `;
export type UpdateCalculatedColumnMutationFn = Apollo.MutationFunction<UpdateCalculatedColumnMutation, UpdateCalculatedColumnMutationVariables>;

/**
 * __useUpdateCalculatedColumnMutation__
 *
 * To run a mutation, you first call `useUpdateCalculatedColumnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCalculatedColumnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCalculatedColumnMutation, { data, loading, error }] = useUpdateCalculatedColumnMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCalculatedColumnMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCalculatedColumnMutation, UpdateCalculatedColumnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCalculatedColumnMutation, UpdateCalculatedColumnMutationVariables>(UpdateCalculatedColumnDocument, options);
      }
export type UpdateCalculatedColumnMutationHookResult = ReturnType<typeof useUpdateCalculatedColumnMutation>;
export type UpdateCalculatedColumnMutationResult = Apollo.MutationResult<UpdateCalculatedColumnMutation>;
export type UpdateCalculatedColumnMutationOptions = Apollo.BaseMutationOptions<UpdateCalculatedColumnMutation, UpdateCalculatedColumnMutationVariables>;
export const DeleteCalculatedColumnDocument = gql`
    mutation DeleteCalculatedColumn($id: String!) {
  deleteCalculatedColumn(id: $id)
}
    `;
export type DeleteCalculatedColumnMutationFn = Apollo.MutationFunction<DeleteCalculatedColumnMutation, DeleteCalculatedColumnMutationVariables>;

/**
 * __useDeleteCalculatedColumnMutation__
 *
 * To run a mutation, you first call `useDeleteCalculatedColumnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCalculatedColumnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCalculatedColumnMutation, { data, loading, error }] = useDeleteCalculatedColumnMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCalculatedColumnMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCalculatedColumnMutation, DeleteCalculatedColumnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCalculatedColumnMutation, DeleteCalculatedColumnMutationVariables>(DeleteCalculatedColumnDocument, options);
      }
export type DeleteCalculatedColumnMutationHookResult = ReturnType<typeof useDeleteCalculatedColumnMutation>;
export type DeleteCalculatedColumnMutationResult = Apollo.MutationResult<DeleteCalculatedColumnMutation>;
export type DeleteCalculatedColumnMutationOptions = Apollo.BaseMutationOptions<DeleteCalculatedColumnMutation, DeleteCalculatedColumnMutationVariables>;
export const ValidateAdjustmentLotsDocument = gql`
    query ValidateAdjustmentLots($validateAdjustmentDto: ValidateAdjustmentDto!) {
  validateAdjustmentLots(validateAdjustmentDto: $validateAdjustmentDto) {
    actionId
    locationId
    errors
  }
}
    `;

/**
 * __useValidateAdjustmentLotsQuery__
 *
 * To run a query within a React component, call `useValidateAdjustmentLotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateAdjustmentLotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateAdjustmentLotsQuery({
 *   variables: {
 *      validateAdjustmentDto: // value for 'validateAdjustmentDto'
 *   },
 * });
 */
export function useValidateAdjustmentLotsQuery(baseOptions: Apollo.QueryHookOptions<ValidateAdjustmentLotsQuery, ValidateAdjustmentLotsQueryVariables> & ({ variables: ValidateAdjustmentLotsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateAdjustmentLotsQuery, ValidateAdjustmentLotsQueryVariables>(ValidateAdjustmentLotsDocument, options);
      }
export function useValidateAdjustmentLotsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateAdjustmentLotsQuery, ValidateAdjustmentLotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateAdjustmentLotsQuery, ValidateAdjustmentLotsQueryVariables>(ValidateAdjustmentLotsDocument, options);
        }
// @ts-ignore
export function useValidateAdjustmentLotsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ValidateAdjustmentLotsQuery, ValidateAdjustmentLotsQueryVariables>): Apollo.UseSuspenseQueryResult<ValidateAdjustmentLotsQuery, ValidateAdjustmentLotsQueryVariables>;
export function useValidateAdjustmentLotsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ValidateAdjustmentLotsQuery, ValidateAdjustmentLotsQueryVariables>): Apollo.UseSuspenseQueryResult<ValidateAdjustmentLotsQuery | undefined, ValidateAdjustmentLotsQueryVariables>;
export function useValidateAdjustmentLotsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ValidateAdjustmentLotsQuery, ValidateAdjustmentLotsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ValidateAdjustmentLotsQuery, ValidateAdjustmentLotsQueryVariables>(ValidateAdjustmentLotsDocument, options);
        }
export type ValidateAdjustmentLotsQueryHookResult = ReturnType<typeof useValidateAdjustmentLotsQuery>;
export type ValidateAdjustmentLotsLazyQueryHookResult = ReturnType<typeof useValidateAdjustmentLotsLazyQuery>;
export type ValidateAdjustmentLotsSuspenseQueryHookResult = ReturnType<typeof useValidateAdjustmentLotsSuspenseQuery>;
export type ValidateAdjustmentLotsQueryResult = Apollo.QueryResult<ValidateAdjustmentLotsQuery, ValidateAdjustmentLotsQueryVariables>;
export const DashboardsDocument = gql`
    query Dashboards($page: Int, $limit: Int, $search: String) {
  dashboards(page: $page, limit: $limit, search: $search) {
    data {
      sharedWithMe
      id
      name
      description
      visibility
      isSystem
      systemKey
      ownerName
      updatedAt
    }
    meta {
      totalCount
      page
      limit
    }
  }
}
    `;

/**
 * __useDashboardsQuery__
 *
 * To run a query within a React component, call `useDashboardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useDashboardsQuery(baseOptions?: Apollo.QueryHookOptions<DashboardsQuery, DashboardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardsQuery, DashboardsQueryVariables>(DashboardsDocument, options);
      }
export function useDashboardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardsQuery, DashboardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardsQuery, DashboardsQueryVariables>(DashboardsDocument, options);
        }
// @ts-ignore
export function useDashboardsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DashboardsQuery, DashboardsQueryVariables>): Apollo.UseSuspenseQueryResult<DashboardsQuery, DashboardsQueryVariables>;
export function useDashboardsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DashboardsQuery, DashboardsQueryVariables>): Apollo.UseSuspenseQueryResult<DashboardsQuery | undefined, DashboardsQueryVariables>;
export function useDashboardsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DashboardsQuery, DashboardsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardsQuery, DashboardsQueryVariables>(DashboardsDocument, options);
        }
export type DashboardsQueryHookResult = ReturnType<typeof useDashboardsQuery>;
export type DashboardsLazyQueryHookResult = ReturnType<typeof useDashboardsLazyQuery>;
export type DashboardsSuspenseQueryHookResult = ReturnType<typeof useDashboardsSuspenseQuery>;
export type DashboardsQueryResult = Apollo.QueryResult<DashboardsQuery, DashboardsQueryVariables>;
export const DashboardDocument = gql`
    query Dashboard($id: String!) {
  dashboard(id: $id) {
    myAccess
    sharedWithMe
    id
    name
    description
    visibility
    isSystem
    ownerUserId
    config
    widgets {
      dashboardId
      id
      span
      sortOrder
      tab
      report {
        id
        name
        datasetKey
        definition
        chartConfig
        persistence {
          lastRefreshedAt
          status
        }
      }
    }
  }
}
    `;

/**
 * __useDashboardQuery__
 *
 * To run a query within a React component, call `useDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDashboardQuery(baseOptions: Apollo.QueryHookOptions<DashboardQuery, DashboardQueryVariables> & ({ variables: DashboardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardQuery, DashboardQueryVariables>(DashboardDocument, options);
      }
export function useDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardQuery, DashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardQuery, DashboardQueryVariables>(DashboardDocument, options);
        }
// @ts-ignore
export function useDashboardSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DashboardQuery, DashboardQueryVariables>): Apollo.UseSuspenseQueryResult<DashboardQuery, DashboardQueryVariables>;
export function useDashboardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DashboardQuery, DashboardQueryVariables>): Apollo.UseSuspenseQueryResult<DashboardQuery | undefined, DashboardQueryVariables>;
export function useDashboardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DashboardQuery, DashboardQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardQuery, DashboardQueryVariables>(DashboardDocument, options);
        }
export type DashboardQueryHookResult = ReturnType<typeof useDashboardQuery>;
export type DashboardLazyQueryHookResult = ReturnType<typeof useDashboardLazyQuery>;
export type DashboardSuspenseQueryHookResult = ReturnType<typeof useDashboardSuspenseQuery>;
export type DashboardQueryResult = Apollo.QueryResult<DashboardQuery, DashboardQueryVariables>;
export const DashboardLocationsDocument = gql`
    query DashboardLocations {
  dashboardLocations {
    id
    name
  }
}
    `;

/**
 * __useDashboardLocationsQuery__
 *
 * To run a query within a React component, call `useDashboardLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardLocationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDashboardLocationsQuery(baseOptions?: Apollo.QueryHookOptions<DashboardLocationsQuery, DashboardLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardLocationsQuery, DashboardLocationsQueryVariables>(DashboardLocationsDocument, options);
      }
export function useDashboardLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardLocationsQuery, DashboardLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardLocationsQuery, DashboardLocationsQueryVariables>(DashboardLocationsDocument, options);
        }
// @ts-ignore
export function useDashboardLocationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DashboardLocationsQuery, DashboardLocationsQueryVariables>): Apollo.UseSuspenseQueryResult<DashboardLocationsQuery, DashboardLocationsQueryVariables>;
export function useDashboardLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DashboardLocationsQuery, DashboardLocationsQueryVariables>): Apollo.UseSuspenseQueryResult<DashboardLocationsQuery | undefined, DashboardLocationsQueryVariables>;
export function useDashboardLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DashboardLocationsQuery, DashboardLocationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardLocationsQuery, DashboardLocationsQueryVariables>(DashboardLocationsDocument, options);
        }
export type DashboardLocationsQueryHookResult = ReturnType<typeof useDashboardLocationsQuery>;
export type DashboardLocationsLazyQueryHookResult = ReturnType<typeof useDashboardLocationsLazyQuery>;
export type DashboardLocationsSuspenseQueryHookResult = ReturnType<typeof useDashboardLocationsSuspenseQuery>;
export type DashboardLocationsQueryResult = Apollo.QueryResult<DashboardLocationsQuery, DashboardLocationsQueryVariables>;
export const CreateDashboardDocument = gql`
    mutation CreateDashboard($input: CreateDashboardInput!) {
  createDashboard(input: $input) {
    id
    name
  }
}
    `;
export type CreateDashboardMutationFn = Apollo.MutationFunction<CreateDashboardMutation, CreateDashboardMutationVariables>;

/**
 * __useCreateDashboardMutation__
 *
 * To run a mutation, you first call `useCreateDashboardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDashboardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDashboardMutation, { data, loading, error }] = useCreateDashboardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDashboardMutation(baseOptions?: Apollo.MutationHookOptions<CreateDashboardMutation, CreateDashboardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDashboardMutation, CreateDashboardMutationVariables>(CreateDashboardDocument, options);
      }
export type CreateDashboardMutationHookResult = ReturnType<typeof useCreateDashboardMutation>;
export type CreateDashboardMutationResult = Apollo.MutationResult<CreateDashboardMutation>;
export type CreateDashboardMutationOptions = Apollo.BaseMutationOptions<CreateDashboardMutation, CreateDashboardMutationVariables>;
export const UpdateDashboardDocument = gql`
    mutation UpdateDashboard($id: String!, $input: UpdateDashboardInput!) {
  updateDashboard(id: $id, input: $input) {
    id
    name
    description
  }
}
    `;
export type UpdateDashboardMutationFn = Apollo.MutationFunction<UpdateDashboardMutation, UpdateDashboardMutationVariables>;

/**
 * __useUpdateDashboardMutation__
 *
 * To run a mutation, you first call `useUpdateDashboardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDashboardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDashboardMutation, { data, loading, error }] = useUpdateDashboardMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDashboardMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDashboardMutation, UpdateDashboardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDashboardMutation, UpdateDashboardMutationVariables>(UpdateDashboardDocument, options);
      }
export type UpdateDashboardMutationHookResult = ReturnType<typeof useUpdateDashboardMutation>;
export type UpdateDashboardMutationResult = Apollo.MutationResult<UpdateDashboardMutation>;
export type UpdateDashboardMutationOptions = Apollo.BaseMutationOptions<UpdateDashboardMutation, UpdateDashboardMutationVariables>;
export const DeleteDashboardDocument = gql`
    mutation DeleteDashboard($id: String!) {
  deleteDashboard(id: $id)
}
    `;
export type DeleteDashboardMutationFn = Apollo.MutationFunction<DeleteDashboardMutation, DeleteDashboardMutationVariables>;

/**
 * __useDeleteDashboardMutation__
 *
 * To run a mutation, you first call `useDeleteDashboardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDashboardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDashboardMutation, { data, loading, error }] = useDeleteDashboardMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDashboardMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDashboardMutation, DeleteDashboardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDashboardMutation, DeleteDashboardMutationVariables>(DeleteDashboardDocument, options);
      }
export type DeleteDashboardMutationHookResult = ReturnType<typeof useDeleteDashboardMutation>;
export type DeleteDashboardMutationResult = Apollo.MutationResult<DeleteDashboardMutation>;
export type DeleteDashboardMutationOptions = Apollo.BaseMutationOptions<DeleteDashboardMutation, DeleteDashboardMutationVariables>;
export const PublishDashboardDocument = gql`
    mutation PublishDashboard($id: String!, $visibility: ReportVisibility!) {
  publishDashboard(id: $id, visibility: $visibility) {
    id
    visibility
  }
}
    `;
export type PublishDashboardMutationFn = Apollo.MutationFunction<PublishDashboardMutation, PublishDashboardMutationVariables>;

/**
 * __usePublishDashboardMutation__
 *
 * To run a mutation, you first call `usePublishDashboardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishDashboardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishDashboardMutation, { data, loading, error }] = usePublishDashboardMutation({
 *   variables: {
 *      id: // value for 'id'
 *      visibility: // value for 'visibility'
 *   },
 * });
 */
export function usePublishDashboardMutation(baseOptions?: Apollo.MutationHookOptions<PublishDashboardMutation, PublishDashboardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishDashboardMutation, PublishDashboardMutationVariables>(PublishDashboardDocument, options);
      }
export type PublishDashboardMutationHookResult = ReturnType<typeof usePublishDashboardMutation>;
export type PublishDashboardMutationResult = Apollo.MutationResult<PublishDashboardMutation>;
export type PublishDashboardMutationOptions = Apollo.BaseMutationOptions<PublishDashboardMutation, PublishDashboardMutationVariables>;
export const AddDashboardWidgetDocument = gql`
    mutation AddDashboardWidget($dashboardId: String!, $reportId: String!, $span: Int, $tab: String) {
  addDashboardWidget(
    dashboardId: $dashboardId
    reportId: $reportId
    span: $span
    tab: $tab
  ) {
    id
  }
}
    `;
export type AddDashboardWidgetMutationFn = Apollo.MutationFunction<AddDashboardWidgetMutation, AddDashboardWidgetMutationVariables>;

/**
 * __useAddDashboardWidgetMutation__
 *
 * To run a mutation, you first call `useAddDashboardWidgetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDashboardWidgetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDashboardWidgetMutation, { data, loading, error }] = useAddDashboardWidgetMutation({
 *   variables: {
 *      dashboardId: // value for 'dashboardId'
 *      reportId: // value for 'reportId'
 *      span: // value for 'span'
 *      tab: // value for 'tab'
 *   },
 * });
 */
export function useAddDashboardWidgetMutation(baseOptions?: Apollo.MutationHookOptions<AddDashboardWidgetMutation, AddDashboardWidgetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddDashboardWidgetMutation, AddDashboardWidgetMutationVariables>(AddDashboardWidgetDocument, options);
      }
export type AddDashboardWidgetMutationHookResult = ReturnType<typeof useAddDashboardWidgetMutation>;
export type AddDashboardWidgetMutationResult = Apollo.MutationResult<AddDashboardWidgetMutation>;
export type AddDashboardWidgetMutationOptions = Apollo.BaseMutationOptions<AddDashboardWidgetMutation, AddDashboardWidgetMutationVariables>;
export const UpdateDashboardWidgetDocument = gql`
    mutation UpdateDashboardWidget($widgetId: String!, $input: UpdateDashboardWidgetInput!) {
  updateDashboardWidget(widgetId: $widgetId, input: $input) {
    id
    span
    sortOrder
    tab
  }
}
    `;
export type UpdateDashboardWidgetMutationFn = Apollo.MutationFunction<UpdateDashboardWidgetMutation, UpdateDashboardWidgetMutationVariables>;

/**
 * __useUpdateDashboardWidgetMutation__
 *
 * To run a mutation, you first call `useUpdateDashboardWidgetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDashboardWidgetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDashboardWidgetMutation, { data, loading, error }] = useUpdateDashboardWidgetMutation({
 *   variables: {
 *      widgetId: // value for 'widgetId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDashboardWidgetMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDashboardWidgetMutation, UpdateDashboardWidgetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDashboardWidgetMutation, UpdateDashboardWidgetMutationVariables>(UpdateDashboardWidgetDocument, options);
      }
export type UpdateDashboardWidgetMutationHookResult = ReturnType<typeof useUpdateDashboardWidgetMutation>;
export type UpdateDashboardWidgetMutationResult = Apollo.MutationResult<UpdateDashboardWidgetMutation>;
export type UpdateDashboardWidgetMutationOptions = Apollo.BaseMutationOptions<UpdateDashboardWidgetMutation, UpdateDashboardWidgetMutationVariables>;
export const RemoveDashboardWidgetDocument = gql`
    mutation RemoveDashboardWidget($widgetId: String!) {
  removeDashboardWidget(widgetId: $widgetId)
}
    `;
export type RemoveDashboardWidgetMutationFn = Apollo.MutationFunction<RemoveDashboardWidgetMutation, RemoveDashboardWidgetMutationVariables>;

/**
 * __useRemoveDashboardWidgetMutation__
 *
 * To run a mutation, you first call `useRemoveDashboardWidgetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDashboardWidgetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDashboardWidgetMutation, { data, loading, error }] = useRemoveDashboardWidgetMutation({
 *   variables: {
 *      widgetId: // value for 'widgetId'
 *   },
 * });
 */
export function useRemoveDashboardWidgetMutation(baseOptions?: Apollo.MutationHookOptions<RemoveDashboardWidgetMutation, RemoveDashboardWidgetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveDashboardWidgetMutation, RemoveDashboardWidgetMutationVariables>(RemoveDashboardWidgetDocument, options);
      }
export type RemoveDashboardWidgetMutationHookResult = ReturnType<typeof useRemoveDashboardWidgetMutation>;
export type RemoveDashboardWidgetMutationResult = Apollo.MutationResult<RemoveDashboardWidgetMutation>;
export type RemoveDashboardWidgetMutationOptions = Apollo.BaseMutationOptions<RemoveDashboardWidgetMutation, RemoveDashboardWidgetMutationVariables>;
export const DuplicateDashboardTabDocument = gql`
    mutation DuplicateDashboardTab($dashboardId: String!, $tab: String!, $newName: String!) {
  duplicateDashboardTab(dashboardId: $dashboardId, tab: $tab, newName: $newName) {
    id
  }
}
    `;
export type DuplicateDashboardTabMutationFn = Apollo.MutationFunction<DuplicateDashboardTabMutation, DuplicateDashboardTabMutationVariables>;

/**
 * __useDuplicateDashboardTabMutation__
 *
 * To run a mutation, you first call `useDuplicateDashboardTabMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateDashboardTabMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateDashboardTabMutation, { data, loading, error }] = useDuplicateDashboardTabMutation({
 *   variables: {
 *      dashboardId: // value for 'dashboardId'
 *      tab: // value for 'tab'
 *      newName: // value for 'newName'
 *   },
 * });
 */
export function useDuplicateDashboardTabMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateDashboardTabMutation, DuplicateDashboardTabMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateDashboardTabMutation, DuplicateDashboardTabMutationVariables>(DuplicateDashboardTabDocument, options);
      }
export type DuplicateDashboardTabMutationHookResult = ReturnType<typeof useDuplicateDashboardTabMutation>;
export type DuplicateDashboardTabMutationResult = Apollo.MutationResult<DuplicateDashboardTabMutation>;
export type DuplicateDashboardTabMutationOptions = Apollo.BaseMutationOptions<DuplicateDashboardTabMutation, DuplicateDashboardTabMutationVariables>;
export const AutomationFlowsDocument = gql`
    query AutomationFlows($reportId: String, $page: Int, $limit: Int, $search: String) {
  automationFlows(
    reportId: $reportId
    page: $page
    limit: $limit
    search: $search
  ) {
    data {
      id
      name
      description
      reportId
      reportName
      enabled
      armed
      trigger
      intervalSeconds
      cooldownMinutes
      lastValue
      lastTriggeredAt
      lastEvalAt
      lastError
      consecutiveFailures
      createdAt
      updatedAt
    }
    total
  }
}
    `;

/**
 * __useAutomationFlowsQuery__
 *
 * To run a query within a React component, call `useAutomationFlowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutomationFlowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutomationFlowsQuery({
 *   variables: {
 *      reportId: // value for 'reportId'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useAutomationFlowsQuery(baseOptions?: Apollo.QueryHookOptions<AutomationFlowsQuery, AutomationFlowsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AutomationFlowsQuery, AutomationFlowsQueryVariables>(AutomationFlowsDocument, options);
      }
export function useAutomationFlowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AutomationFlowsQuery, AutomationFlowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AutomationFlowsQuery, AutomationFlowsQueryVariables>(AutomationFlowsDocument, options);
        }
// @ts-ignore
export function useAutomationFlowsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AutomationFlowsQuery, AutomationFlowsQueryVariables>): Apollo.UseSuspenseQueryResult<AutomationFlowsQuery, AutomationFlowsQueryVariables>;
export function useAutomationFlowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AutomationFlowsQuery, AutomationFlowsQueryVariables>): Apollo.UseSuspenseQueryResult<AutomationFlowsQuery | undefined, AutomationFlowsQueryVariables>;
export function useAutomationFlowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AutomationFlowsQuery, AutomationFlowsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AutomationFlowsQuery, AutomationFlowsQueryVariables>(AutomationFlowsDocument, options);
        }
export type AutomationFlowsQueryHookResult = ReturnType<typeof useAutomationFlowsQuery>;
export type AutomationFlowsLazyQueryHookResult = ReturnType<typeof useAutomationFlowsLazyQuery>;
export type AutomationFlowsSuspenseQueryHookResult = ReturnType<typeof useAutomationFlowsSuspenseQuery>;
export type AutomationFlowsQueryResult = Apollo.QueryResult<AutomationFlowsQuery, AutomationFlowsQueryVariables>;
export const AutomationFlowDocument = gql`
    query AutomationFlow($id: String!) {
  automationFlow(id: $id) {
    id
    name
    description
    reportId
    reportName
    enabled
    armed
    trigger
    graph
    intervalSeconds
    cooldownMinutes
    lastValue
    lastTriggeredAt
    lastError
    webhookSecret
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useAutomationFlowQuery__
 *
 * To run a query within a React component, call `useAutomationFlowQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutomationFlowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutomationFlowQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAutomationFlowQuery(baseOptions: Apollo.QueryHookOptions<AutomationFlowQuery, AutomationFlowQueryVariables> & ({ variables: AutomationFlowQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AutomationFlowQuery, AutomationFlowQueryVariables>(AutomationFlowDocument, options);
      }
export function useAutomationFlowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AutomationFlowQuery, AutomationFlowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AutomationFlowQuery, AutomationFlowQueryVariables>(AutomationFlowDocument, options);
        }
// @ts-ignore
export function useAutomationFlowSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AutomationFlowQuery, AutomationFlowQueryVariables>): Apollo.UseSuspenseQueryResult<AutomationFlowQuery, AutomationFlowQueryVariables>;
export function useAutomationFlowSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AutomationFlowQuery, AutomationFlowQueryVariables>): Apollo.UseSuspenseQueryResult<AutomationFlowQuery | undefined, AutomationFlowQueryVariables>;
export function useAutomationFlowSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AutomationFlowQuery, AutomationFlowQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AutomationFlowQuery, AutomationFlowQueryVariables>(AutomationFlowDocument, options);
        }
export type AutomationFlowQueryHookResult = ReturnType<typeof useAutomationFlowQuery>;
export type AutomationFlowLazyQueryHookResult = ReturnType<typeof useAutomationFlowLazyQuery>;
export type AutomationFlowSuspenseQueryHookResult = ReturnType<typeof useAutomationFlowSuspenseQuery>;
export type AutomationFlowQueryResult = Apollo.QueryResult<AutomationFlowQuery, AutomationFlowQueryVariables>;
export const FlowRunsDocument = gql`
    query FlowRuns($flowId: String!, $limit: Int) {
  flowRuns(flowId: $flowId, limit: $limit) {
    id
    kind
    status
    triggeredValue
    threshold
    op
    results
    error
    startedAt
    finishedAt
    createdAt
  }
}
    `;

/**
 * __useFlowRunsQuery__
 *
 * To run a query within a React component, call `useFlowRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFlowRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFlowRunsQuery({
 *   variables: {
 *      flowId: // value for 'flowId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useFlowRunsQuery(baseOptions: Apollo.QueryHookOptions<FlowRunsQuery, FlowRunsQueryVariables> & ({ variables: FlowRunsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FlowRunsQuery, FlowRunsQueryVariables>(FlowRunsDocument, options);
      }
export function useFlowRunsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FlowRunsQuery, FlowRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FlowRunsQuery, FlowRunsQueryVariables>(FlowRunsDocument, options);
        }
// @ts-ignore
export function useFlowRunsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FlowRunsQuery, FlowRunsQueryVariables>): Apollo.UseSuspenseQueryResult<FlowRunsQuery, FlowRunsQueryVariables>;
export function useFlowRunsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FlowRunsQuery, FlowRunsQueryVariables>): Apollo.UseSuspenseQueryResult<FlowRunsQuery | undefined, FlowRunsQueryVariables>;
export function useFlowRunsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FlowRunsQuery, FlowRunsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FlowRunsQuery, FlowRunsQueryVariables>(FlowRunsDocument, options);
        }
export type FlowRunsQueryHookResult = ReturnType<typeof useFlowRunsQuery>;
export type FlowRunsLazyQueryHookResult = ReturnType<typeof useFlowRunsLazyQuery>;
export type FlowRunsSuspenseQueryHookResult = ReturnType<typeof useFlowRunsSuspenseQuery>;
export type FlowRunsQueryResult = Apollo.QueryResult<FlowRunsQuery, FlowRunsQueryVariables>;
export const FlowRecipientsDocument = gql`
    query FlowRecipients($search: String) {
  flowRecipients(search: $search)
}
    `;

/**
 * __useFlowRecipientsQuery__
 *
 * To run a query within a React component, call `useFlowRecipientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFlowRecipientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFlowRecipientsQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useFlowRecipientsQuery(baseOptions?: Apollo.QueryHookOptions<FlowRecipientsQuery, FlowRecipientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FlowRecipientsQuery, FlowRecipientsQueryVariables>(FlowRecipientsDocument, options);
      }
export function useFlowRecipientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FlowRecipientsQuery, FlowRecipientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FlowRecipientsQuery, FlowRecipientsQueryVariables>(FlowRecipientsDocument, options);
        }
// @ts-ignore
export function useFlowRecipientsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FlowRecipientsQuery, FlowRecipientsQueryVariables>): Apollo.UseSuspenseQueryResult<FlowRecipientsQuery, FlowRecipientsQueryVariables>;
export function useFlowRecipientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FlowRecipientsQuery, FlowRecipientsQueryVariables>): Apollo.UseSuspenseQueryResult<FlowRecipientsQuery | undefined, FlowRecipientsQueryVariables>;
export function useFlowRecipientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FlowRecipientsQuery, FlowRecipientsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FlowRecipientsQuery, FlowRecipientsQueryVariables>(FlowRecipientsDocument, options);
        }
export type FlowRecipientsQueryHookResult = ReturnType<typeof useFlowRecipientsQuery>;
export type FlowRecipientsLazyQueryHookResult = ReturnType<typeof useFlowRecipientsLazyQuery>;
export type FlowRecipientsSuspenseQueryHookResult = ReturnType<typeof useFlowRecipientsSuspenseQuery>;
export type FlowRecipientsQueryResult = Apollo.QueryResult<FlowRecipientsQuery, FlowRecipientsQueryVariables>;
export const CreateAutomationFlowDocument = gql`
    mutation CreateAutomationFlow($input: CreateAutomationFlowInput!) {
  createAutomationFlow(input: $input) {
    id
  }
}
    `;
export type CreateAutomationFlowMutationFn = Apollo.MutationFunction<CreateAutomationFlowMutation, CreateAutomationFlowMutationVariables>;

/**
 * __useCreateAutomationFlowMutation__
 *
 * To run a mutation, you first call `useCreateAutomationFlowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAutomationFlowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAutomationFlowMutation, { data, loading, error }] = useCreateAutomationFlowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAutomationFlowMutation(baseOptions?: Apollo.MutationHookOptions<CreateAutomationFlowMutation, CreateAutomationFlowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAutomationFlowMutation, CreateAutomationFlowMutationVariables>(CreateAutomationFlowDocument, options);
      }
export type CreateAutomationFlowMutationHookResult = ReturnType<typeof useCreateAutomationFlowMutation>;
export type CreateAutomationFlowMutationResult = Apollo.MutationResult<CreateAutomationFlowMutation>;
export type CreateAutomationFlowMutationOptions = Apollo.BaseMutationOptions<CreateAutomationFlowMutation, CreateAutomationFlowMutationVariables>;
export const UpdateAutomationFlowDocument = gql`
    mutation UpdateAutomationFlow($id: String!, $input: UpdateAutomationFlowInput!) {
  updateAutomationFlow(id: $id, input: $input) {
    id
  }
}
    `;
export type UpdateAutomationFlowMutationFn = Apollo.MutationFunction<UpdateAutomationFlowMutation, UpdateAutomationFlowMutationVariables>;

/**
 * __useUpdateAutomationFlowMutation__
 *
 * To run a mutation, you first call `useUpdateAutomationFlowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAutomationFlowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAutomationFlowMutation, { data, loading, error }] = useUpdateAutomationFlowMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAutomationFlowMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAutomationFlowMutation, UpdateAutomationFlowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAutomationFlowMutation, UpdateAutomationFlowMutationVariables>(UpdateAutomationFlowDocument, options);
      }
export type UpdateAutomationFlowMutationHookResult = ReturnType<typeof useUpdateAutomationFlowMutation>;
export type UpdateAutomationFlowMutationResult = Apollo.MutationResult<UpdateAutomationFlowMutation>;
export type UpdateAutomationFlowMutationOptions = Apollo.BaseMutationOptions<UpdateAutomationFlowMutation, UpdateAutomationFlowMutationVariables>;
export const SetFlowEnabledDocument = gql`
    mutation SetFlowEnabled($id: String!, $enabled: Boolean!) {
  setFlowEnabled(id: $id, enabled: $enabled) {
    id
    enabled
    armed
  }
}
    `;
export type SetFlowEnabledMutationFn = Apollo.MutationFunction<SetFlowEnabledMutation, SetFlowEnabledMutationVariables>;

/**
 * __useSetFlowEnabledMutation__
 *
 * To run a mutation, you first call `useSetFlowEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetFlowEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setFlowEnabledMutation, { data, loading, error }] = useSetFlowEnabledMutation({
 *   variables: {
 *      id: // value for 'id'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useSetFlowEnabledMutation(baseOptions?: Apollo.MutationHookOptions<SetFlowEnabledMutation, SetFlowEnabledMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetFlowEnabledMutation, SetFlowEnabledMutationVariables>(SetFlowEnabledDocument, options);
      }
export type SetFlowEnabledMutationHookResult = ReturnType<typeof useSetFlowEnabledMutation>;
export type SetFlowEnabledMutationResult = Apollo.MutationResult<SetFlowEnabledMutation>;
export type SetFlowEnabledMutationOptions = Apollo.BaseMutationOptions<SetFlowEnabledMutation, SetFlowEnabledMutationVariables>;
export const DeleteAutomationFlowDocument = gql`
    mutation DeleteAutomationFlow($id: String!) {
  deleteAutomationFlow(id: $id)
}
    `;
export type DeleteAutomationFlowMutationFn = Apollo.MutationFunction<DeleteAutomationFlowMutation, DeleteAutomationFlowMutationVariables>;

/**
 * __useDeleteAutomationFlowMutation__
 *
 * To run a mutation, you first call `useDeleteAutomationFlowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAutomationFlowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAutomationFlowMutation, { data, loading, error }] = useDeleteAutomationFlowMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAutomationFlowMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAutomationFlowMutation, DeleteAutomationFlowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAutomationFlowMutation, DeleteAutomationFlowMutationVariables>(DeleteAutomationFlowDocument, options);
      }
export type DeleteAutomationFlowMutationHookResult = ReturnType<typeof useDeleteAutomationFlowMutation>;
export type DeleteAutomationFlowMutationResult = Apollo.MutationResult<DeleteAutomationFlowMutation>;
export type DeleteAutomationFlowMutationOptions = Apollo.BaseMutationOptions<DeleteAutomationFlowMutation, DeleteAutomationFlowMutationVariables>;
export const TestFlowDocument = gql`
    mutation TestFlow($id: String!) {
  testFlow(id: $id) {
    id
    status
    results
    error
  }
}
    `;
export type TestFlowMutationFn = Apollo.MutationFunction<TestFlowMutation, TestFlowMutationVariables>;

/**
 * __useTestFlowMutation__
 *
 * To run a mutation, you first call `useTestFlowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTestFlowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [testFlowMutation, { data, loading, error }] = useTestFlowMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTestFlowMutation(baseOptions?: Apollo.MutationHookOptions<TestFlowMutation, TestFlowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TestFlowMutation, TestFlowMutationVariables>(TestFlowDocument, options);
      }
export type TestFlowMutationHookResult = ReturnType<typeof useTestFlowMutation>;
export type TestFlowMutationResult = Apollo.MutationResult<TestFlowMutation>;
export type TestFlowMutationOptions = Apollo.BaseMutationOptions<TestFlowMutation, TestFlowMutationVariables>;
export const NotificationsDocument = gql`
    query Notifications($unreadOnly: Boolean, $readOnly: Boolean, $page: Int, $limit: Int) {
  notifications(
    unreadOnly: $unreadOnly
    readOnly: $readOnly
    page: $page
    limit: $limit
  ) {
    data {
      id
      title
      body
      severity
      link
      flowName
      readAt
      createdAt
    }
    total
    unread
  }
}
    `;

/**
 * __useNotificationsQuery__
 *
 * To run a query within a React component, call `useNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationsQuery({
 *   variables: {
 *      unreadOnly: // value for 'unreadOnly'
 *      readOnly: // value for 'readOnly'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<NotificationsQuery, NotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, options);
      }
export function useNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationsQuery, NotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, options);
        }
// @ts-ignore
export function useNotificationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NotificationsQuery, NotificationsQueryVariables>): Apollo.UseSuspenseQueryResult<NotificationsQuery, NotificationsQueryVariables>;
export function useNotificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NotificationsQuery, NotificationsQueryVariables>): Apollo.UseSuspenseQueryResult<NotificationsQuery | undefined, NotificationsQueryVariables>;
export function useNotificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NotificationsQuery, NotificationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, options);
        }
export type NotificationsQueryHookResult = ReturnType<typeof useNotificationsQuery>;
export type NotificationsLazyQueryHookResult = ReturnType<typeof useNotificationsLazyQuery>;
export type NotificationsSuspenseQueryHookResult = ReturnType<typeof useNotificationsSuspenseQuery>;
export type NotificationsQueryResult = Apollo.QueryResult<NotificationsQuery, NotificationsQueryVariables>;
export const NotificationCountDocument = gql`
    query NotificationCount {
  notificationCount
}
    `;

/**
 * __useNotificationCountQuery__
 *
 * To run a query within a React component, call `useNotificationCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useNotificationCountQuery(baseOptions?: Apollo.QueryHookOptions<NotificationCountQuery, NotificationCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationCountQuery, NotificationCountQueryVariables>(NotificationCountDocument, options);
      }
export function useNotificationCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationCountQuery, NotificationCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationCountQuery, NotificationCountQueryVariables>(NotificationCountDocument, options);
        }
// @ts-ignore
export function useNotificationCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NotificationCountQuery, NotificationCountQueryVariables>): Apollo.UseSuspenseQueryResult<NotificationCountQuery, NotificationCountQueryVariables>;
export function useNotificationCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NotificationCountQuery, NotificationCountQueryVariables>): Apollo.UseSuspenseQueryResult<NotificationCountQuery | undefined, NotificationCountQueryVariables>;
export function useNotificationCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NotificationCountQuery, NotificationCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NotificationCountQuery, NotificationCountQueryVariables>(NotificationCountDocument, options);
        }
export type NotificationCountQueryHookResult = ReturnType<typeof useNotificationCountQuery>;
export type NotificationCountLazyQueryHookResult = ReturnType<typeof useNotificationCountLazyQuery>;
export type NotificationCountSuspenseQueryHookResult = ReturnType<typeof useNotificationCountSuspenseQuery>;
export type NotificationCountQueryResult = Apollo.QueryResult<NotificationCountQuery, NotificationCountQueryVariables>;
export const MarkNotificationReadDocument = gql`
    mutation MarkNotificationRead($id: String!) {
  markNotificationRead(id: $id)
}
    `;
export type MarkNotificationReadMutationFn = Apollo.MutationFunction<MarkNotificationReadMutation, MarkNotificationReadMutationVariables>;

/**
 * __useMarkNotificationReadMutation__
 *
 * To run a mutation, you first call `useMarkNotificationReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkNotificationReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markNotificationReadMutation, { data, loading, error }] = useMarkNotificationReadMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkNotificationReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkNotificationReadMutation, MarkNotificationReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkNotificationReadMutation, MarkNotificationReadMutationVariables>(MarkNotificationReadDocument, options);
      }
export type MarkNotificationReadMutationHookResult = ReturnType<typeof useMarkNotificationReadMutation>;
export type MarkNotificationReadMutationResult = Apollo.MutationResult<MarkNotificationReadMutation>;
export type MarkNotificationReadMutationOptions = Apollo.BaseMutationOptions<MarkNotificationReadMutation, MarkNotificationReadMutationVariables>;
export const MarkAllNotificationsReadDocument = gql`
    mutation MarkAllNotificationsRead {
  markAllNotificationsRead
}
    `;
export type MarkAllNotificationsReadMutationFn = Apollo.MutationFunction<MarkAllNotificationsReadMutation, MarkAllNotificationsReadMutationVariables>;

/**
 * __useMarkAllNotificationsReadMutation__
 *
 * To run a mutation, you first call `useMarkAllNotificationsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAllNotificationsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAllNotificationsReadMutation, { data, loading, error }] = useMarkAllNotificationsReadMutation({
 *   variables: {
 *   },
 * });
 */
export function useMarkAllNotificationsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkAllNotificationsReadMutation, MarkAllNotificationsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkAllNotificationsReadMutation, MarkAllNotificationsReadMutationVariables>(MarkAllNotificationsReadDocument, options);
      }
export type MarkAllNotificationsReadMutationHookResult = ReturnType<typeof useMarkAllNotificationsReadMutation>;
export type MarkAllNotificationsReadMutationResult = Apollo.MutationResult<MarkAllNotificationsReadMutation>;
export type MarkAllNotificationsReadMutationOptions = Apollo.BaseMutationOptions<MarkAllNotificationsReadMutation, MarkAllNotificationsReadMutationVariables>;
export const ReportDatasetsDocument = gql`
    query ReportDatasets {
  reportDatasets {
    key
    source
    label
    description
    service
    supportsEntity
    supportsLocationScope
    defaultDateDimension
    dimensions {
      key
      label
      type
      supportsGranularity
      supportsBucketing
      filterOnly
      enumValues
      joinTable
      joinLabel
      format
      noAverage
      calculated {
        expression
        libraryId
      }
    }
    measures {
      key
      label
      format
    }
  }
}
    `;

/**
 * __useReportDatasetsQuery__
 *
 * To run a query within a React component, call `useReportDatasetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportDatasetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportDatasetsQuery({
 *   variables: {
 *   },
 * });
 */
export function useReportDatasetsQuery(baseOptions?: Apollo.QueryHookOptions<ReportDatasetsQuery, ReportDatasetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportDatasetsQuery, ReportDatasetsQueryVariables>(ReportDatasetsDocument, options);
      }
export function useReportDatasetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportDatasetsQuery, ReportDatasetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportDatasetsQuery, ReportDatasetsQueryVariables>(ReportDatasetsDocument, options);
        }
// @ts-ignore
export function useReportDatasetsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ReportDatasetsQuery, ReportDatasetsQueryVariables>): Apollo.UseSuspenseQueryResult<ReportDatasetsQuery, ReportDatasetsQueryVariables>;
export function useReportDatasetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportDatasetsQuery, ReportDatasetsQueryVariables>): Apollo.UseSuspenseQueryResult<ReportDatasetsQuery | undefined, ReportDatasetsQueryVariables>;
export function useReportDatasetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportDatasetsQuery, ReportDatasetsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportDatasetsQuery, ReportDatasetsQueryVariables>(ReportDatasetsDocument, options);
        }
export type ReportDatasetsQueryHookResult = ReturnType<typeof useReportDatasetsQuery>;
export type ReportDatasetsLazyQueryHookResult = ReturnType<typeof useReportDatasetsLazyQuery>;
export type ReportDatasetsSuspenseQueryHookResult = ReturnType<typeof useReportDatasetsSuspenseQuery>;
export type ReportDatasetsQueryResult = Apollo.QueryResult<ReportDatasetsQuery, ReportDatasetsQueryVariables>;
export const ReportEntityOptionsDocument = gql`
    query ReportEntityOptions {
  reportEntityOptions {
    id
    name
  }
}
    `;

/**
 * __useReportEntityOptionsQuery__
 *
 * To run a query within a React component, call `useReportEntityOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportEntityOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportEntityOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useReportEntityOptionsQuery(baseOptions?: Apollo.QueryHookOptions<ReportEntityOptionsQuery, ReportEntityOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportEntityOptionsQuery, ReportEntityOptionsQueryVariables>(ReportEntityOptionsDocument, options);
      }
export function useReportEntityOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportEntityOptionsQuery, ReportEntityOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportEntityOptionsQuery, ReportEntityOptionsQueryVariables>(ReportEntityOptionsDocument, options);
        }
// @ts-ignore
export function useReportEntityOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ReportEntityOptionsQuery, ReportEntityOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<ReportEntityOptionsQuery, ReportEntityOptionsQueryVariables>;
export function useReportEntityOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportEntityOptionsQuery, ReportEntityOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<ReportEntityOptionsQuery | undefined, ReportEntityOptionsQueryVariables>;
export function useReportEntityOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportEntityOptionsQuery, ReportEntityOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportEntityOptionsQuery, ReportEntityOptionsQueryVariables>(ReportEntityOptionsDocument, options);
        }
export type ReportEntityOptionsQueryHookResult = ReturnType<typeof useReportEntityOptionsQuery>;
export type ReportEntityOptionsLazyQueryHookResult = ReturnType<typeof useReportEntityOptionsLazyQuery>;
export type ReportEntityOptionsSuspenseQueryHookResult = ReturnType<typeof useReportEntityOptionsSuspenseQuery>;
export type ReportEntityOptionsQueryResult = Apollo.QueryResult<ReportEntityOptionsQuery, ReportEntityOptionsQueryVariables>;
export const RunReportDocument = gql`
    query RunReport($input: RunReportInput!) {
  runReport(input: $input) {
    columns {
      key
      label
      kind
      type
      format
      table
    }
    rows
    hasMore
    executionMs
    totals
    columnTotals
    groupCount
    comparison {
      start
      end
      rows
    }
  }
}
    `;

/**
 * __useRunReportQuery__
 *
 * To run a query within a React component, call `useRunReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunReportQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRunReportQuery(baseOptions: Apollo.QueryHookOptions<RunReportQuery, RunReportQueryVariables> & ({ variables: RunReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RunReportQuery, RunReportQueryVariables>(RunReportDocument, options);
      }
export function useRunReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RunReportQuery, RunReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RunReportQuery, RunReportQueryVariables>(RunReportDocument, options);
        }
// @ts-ignore
export function useRunReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RunReportQuery, RunReportQueryVariables>): Apollo.UseSuspenseQueryResult<RunReportQuery, RunReportQueryVariables>;
export function useRunReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RunReportQuery, RunReportQueryVariables>): Apollo.UseSuspenseQueryResult<RunReportQuery | undefined, RunReportQueryVariables>;
export function useRunReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RunReportQuery, RunReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RunReportQuery, RunReportQueryVariables>(RunReportDocument, options);
        }
export type RunReportQueryHookResult = ReturnType<typeof useRunReportQuery>;
export type RunReportLazyQueryHookResult = ReturnType<typeof useRunReportLazyQuery>;
export type RunReportSuspenseQueryHookResult = ReturnType<typeof useRunReportSuspenseQuery>;
export type RunReportQueryResult = Apollo.QueryResult<RunReportQuery, RunReportQueryVariables>;
export const RunReportDetailDocument = gql`
    query RunReportDetail($input: RunReportDetailInput!) {
  runReportDetail(input: $input) {
    columns {
      key
      label
      kind
      type
      format
      table
    }
    rows
    hasMore
    executionMs
    groupCount
  }
}
    `;

/**
 * __useRunReportDetailQuery__
 *
 * To run a query within a React component, call `useRunReportDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunReportDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunReportDetailQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRunReportDetailQuery(baseOptions: Apollo.QueryHookOptions<RunReportDetailQuery, RunReportDetailQueryVariables> & ({ variables: RunReportDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RunReportDetailQuery, RunReportDetailQueryVariables>(RunReportDetailDocument, options);
      }
export function useRunReportDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RunReportDetailQuery, RunReportDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RunReportDetailQuery, RunReportDetailQueryVariables>(RunReportDetailDocument, options);
        }
// @ts-ignore
export function useRunReportDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RunReportDetailQuery, RunReportDetailQueryVariables>): Apollo.UseSuspenseQueryResult<RunReportDetailQuery, RunReportDetailQueryVariables>;
export function useRunReportDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RunReportDetailQuery, RunReportDetailQueryVariables>): Apollo.UseSuspenseQueryResult<RunReportDetailQuery | undefined, RunReportDetailQueryVariables>;
export function useRunReportDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RunReportDetailQuery, RunReportDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RunReportDetailQuery, RunReportDetailQueryVariables>(RunReportDetailDocument, options);
        }
export type RunReportDetailQueryHookResult = ReturnType<typeof useRunReportDetailQuery>;
export type RunReportDetailLazyQueryHookResult = ReturnType<typeof useRunReportDetailLazyQuery>;
export type RunReportDetailSuspenseQueryHookResult = ReturnType<typeof useRunReportDetailSuspenseQuery>;
export type RunReportDetailQueryResult = Apollo.QueryResult<RunReportDetailQuery, RunReportDetailQueryVariables>;
export const ReportsDocument = gql`
    query Reports($page: Int, $limit: Int, $search: String) {
  reports(page: $page, limit: $limit, search: $search) {
    data {
      sharedWithMe
      id
      name
      description
      datasetKey
      chartConfig
      ownerUserId
      ownerName
      visibility
      isSystem
      systemKey
      createdAt
      updatedAt
    }
    meta {
      totalCount
      page
      limit
    }
  }
}
    `;

/**
 * __useReportsQuery__
 *
 * To run a query within a React component, call `useReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useReportsQuery(baseOptions?: Apollo.QueryHookOptions<ReportsQuery, ReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportsQuery, ReportsQueryVariables>(ReportsDocument, options);
      }
export function useReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportsQuery, ReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportsQuery, ReportsQueryVariables>(ReportsDocument, options);
        }
// @ts-ignore
export function useReportsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ReportsQuery, ReportsQueryVariables>): Apollo.UseSuspenseQueryResult<ReportsQuery, ReportsQueryVariables>;
export function useReportsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportsQuery, ReportsQueryVariables>): Apollo.UseSuspenseQueryResult<ReportsQuery | undefined, ReportsQueryVariables>;
export function useReportsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportsQuery, ReportsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportsQuery, ReportsQueryVariables>(ReportsDocument, options);
        }
export type ReportsQueryHookResult = ReturnType<typeof useReportsQuery>;
export type ReportsLazyQueryHookResult = ReturnType<typeof useReportsLazyQuery>;
export type ReportsSuspenseQueryHookResult = ReturnType<typeof useReportsSuspenseQuery>;
export type ReportsQueryResult = Apollo.QueryResult<ReportsQuery, ReportsQueryVariables>;
export const ReportDocument = gql`
    query Report($id: String!) {
  report(id: $id) {
    myAccess
    id
    name
    description
    datasetKey
    definition
    chartConfig
    ownerUserId
    ownerName
    visibility
    isSystem
    systemKey
    cacheTtlSeconds
    isSavedDataset
    createdAt
    updatedAt
    persistence {
      enabled
      refreshIntervalSeconds
      lastRefreshedAt
      status
      rowCount
    }
  }
}
    `;

/**
 * __useReportQuery__
 *
 * To run a query within a React component, call `useReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReportQuery(baseOptions: Apollo.QueryHookOptions<ReportQuery, ReportQueryVariables> & ({ variables: ReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportQuery, ReportQueryVariables>(ReportDocument, options);
      }
export function useReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportQuery, ReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportQuery, ReportQueryVariables>(ReportDocument, options);
        }
// @ts-ignore
export function useReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ReportQuery, ReportQueryVariables>): Apollo.UseSuspenseQueryResult<ReportQuery, ReportQueryVariables>;
export function useReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportQuery, ReportQueryVariables>): Apollo.UseSuspenseQueryResult<ReportQuery | undefined, ReportQueryVariables>;
export function useReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportQuery, ReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportQuery, ReportQueryVariables>(ReportDocument, options);
        }
export type ReportQueryHookResult = ReturnType<typeof useReportQuery>;
export type ReportLazyQueryHookResult = ReturnType<typeof useReportLazyQuery>;
export type ReportSuspenseQueryHookResult = ReturnType<typeof useReportSuspenseQuery>;
export type ReportQueryResult = Apollo.QueryResult<ReportQuery, ReportQueryVariables>;
export const SetReportSavedDatasetDocument = gql`
    mutation SetReportSavedDataset($id: String!, $enabled: Boolean!) {
  setReportSavedDataset(id: $id, enabled: $enabled) {
    id
    isSavedDataset
  }
}
    `;
export type SetReportSavedDatasetMutationFn = Apollo.MutationFunction<SetReportSavedDatasetMutation, SetReportSavedDatasetMutationVariables>;

/**
 * __useSetReportSavedDatasetMutation__
 *
 * To run a mutation, you first call `useSetReportSavedDatasetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetReportSavedDatasetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setReportSavedDatasetMutation, { data, loading, error }] = useSetReportSavedDatasetMutation({
 *   variables: {
 *      id: // value for 'id'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useSetReportSavedDatasetMutation(baseOptions?: Apollo.MutationHookOptions<SetReportSavedDatasetMutation, SetReportSavedDatasetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetReportSavedDatasetMutation, SetReportSavedDatasetMutationVariables>(SetReportSavedDatasetDocument, options);
      }
export type SetReportSavedDatasetMutationHookResult = ReturnType<typeof useSetReportSavedDatasetMutation>;
export type SetReportSavedDatasetMutationResult = Apollo.MutationResult<SetReportSavedDatasetMutation>;
export type SetReportSavedDatasetMutationOptions = Apollo.BaseMutationOptions<SetReportSavedDatasetMutation, SetReportSavedDatasetMutationVariables>;
export const SavedDatasetUsageDocument = gql`
    query SavedDatasetUsage($id: String!) {
  savedDatasetUsage(id: $id) {
    reports {
      id
      name
    }
    columns {
      id
      name
    }
  }
}
    `;

/**
 * __useSavedDatasetUsageQuery__
 *
 * To run a query within a React component, call `useSavedDatasetUsageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSavedDatasetUsageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSavedDatasetUsageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSavedDatasetUsageQuery(baseOptions: Apollo.QueryHookOptions<SavedDatasetUsageQuery, SavedDatasetUsageQueryVariables> & ({ variables: SavedDatasetUsageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SavedDatasetUsageQuery, SavedDatasetUsageQueryVariables>(SavedDatasetUsageDocument, options);
      }
export function useSavedDatasetUsageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SavedDatasetUsageQuery, SavedDatasetUsageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SavedDatasetUsageQuery, SavedDatasetUsageQueryVariables>(SavedDatasetUsageDocument, options);
        }
// @ts-ignore
export function useSavedDatasetUsageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SavedDatasetUsageQuery, SavedDatasetUsageQueryVariables>): Apollo.UseSuspenseQueryResult<SavedDatasetUsageQuery, SavedDatasetUsageQueryVariables>;
export function useSavedDatasetUsageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SavedDatasetUsageQuery, SavedDatasetUsageQueryVariables>): Apollo.UseSuspenseQueryResult<SavedDatasetUsageQuery | undefined, SavedDatasetUsageQueryVariables>;
export function useSavedDatasetUsageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SavedDatasetUsageQuery, SavedDatasetUsageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SavedDatasetUsageQuery, SavedDatasetUsageQueryVariables>(SavedDatasetUsageDocument, options);
        }
export type SavedDatasetUsageQueryHookResult = ReturnType<typeof useSavedDatasetUsageQuery>;
export type SavedDatasetUsageLazyQueryHookResult = ReturnType<typeof useSavedDatasetUsageLazyQuery>;
export type SavedDatasetUsageSuspenseQueryHookResult = ReturnType<typeof useSavedDatasetUsageSuspenseQuery>;
export type SavedDatasetUsageQueryResult = Apollo.QueryResult<SavedDatasetUsageQuery, SavedDatasetUsageQueryVariables>;
export const SetReportCacheTtlDocument = gql`
    mutation SetReportCacheTtl($id: String!, $seconds: Int) {
  setReportCacheTtl(id: $id, seconds: $seconds) {
    id
    cacheTtlSeconds
  }
}
    `;
export type SetReportCacheTtlMutationFn = Apollo.MutationFunction<SetReportCacheTtlMutation, SetReportCacheTtlMutationVariables>;

/**
 * __useSetReportCacheTtlMutation__
 *
 * To run a mutation, you first call `useSetReportCacheTtlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetReportCacheTtlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setReportCacheTtlMutation, { data, loading, error }] = useSetReportCacheTtlMutation({
 *   variables: {
 *      id: // value for 'id'
 *      seconds: // value for 'seconds'
 *   },
 * });
 */
export function useSetReportCacheTtlMutation(baseOptions?: Apollo.MutationHookOptions<SetReportCacheTtlMutation, SetReportCacheTtlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetReportCacheTtlMutation, SetReportCacheTtlMutationVariables>(SetReportCacheTtlDocument, options);
      }
export type SetReportCacheTtlMutationHookResult = ReturnType<typeof useSetReportCacheTtlMutation>;
export type SetReportCacheTtlMutationResult = Apollo.MutationResult<SetReportCacheTtlMutation>;
export type SetReportCacheTtlMutationOptions = Apollo.BaseMutationOptions<SetReportCacheTtlMutation, SetReportCacheTtlMutationVariables>;
export const SetReportPersistenceDocument = gql`
    mutation SetReportPersistence($reportId: String!, $enabled: Boolean!, $refreshIntervalSeconds: Int) {
  setReportPersistence(
    reportId: $reportId
    enabled: $enabled
    refreshIntervalSeconds: $refreshIntervalSeconds
  ) {
    enabled
    refreshIntervalSeconds
    lastRefreshedAt
    status
    rowCount
  }
}
    `;
export type SetReportPersistenceMutationFn = Apollo.MutationFunction<SetReportPersistenceMutation, SetReportPersistenceMutationVariables>;

/**
 * __useSetReportPersistenceMutation__
 *
 * To run a mutation, you first call `useSetReportPersistenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetReportPersistenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setReportPersistenceMutation, { data, loading, error }] = useSetReportPersistenceMutation({
 *   variables: {
 *      reportId: // value for 'reportId'
 *      enabled: // value for 'enabled'
 *      refreshIntervalSeconds: // value for 'refreshIntervalSeconds'
 *   },
 * });
 */
export function useSetReportPersistenceMutation(baseOptions?: Apollo.MutationHookOptions<SetReportPersistenceMutation, SetReportPersistenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetReportPersistenceMutation, SetReportPersistenceMutationVariables>(SetReportPersistenceDocument, options);
      }
export type SetReportPersistenceMutationHookResult = ReturnType<typeof useSetReportPersistenceMutation>;
export type SetReportPersistenceMutationResult = Apollo.MutationResult<SetReportPersistenceMutation>;
export type SetReportPersistenceMutationOptions = Apollo.BaseMutationOptions<SetReportPersistenceMutation, SetReportPersistenceMutationVariables>;
export const RefreshReportPersistenceDocument = gql`
    mutation RefreshReportPersistence($reportId: String!) {
  refreshReportPersistence(reportId: $reportId) {
    lastRefreshedAt
    status
    rowCount
  }
}
    `;
export type RefreshReportPersistenceMutationFn = Apollo.MutationFunction<RefreshReportPersistenceMutation, RefreshReportPersistenceMutationVariables>;

/**
 * __useRefreshReportPersistenceMutation__
 *
 * To run a mutation, you first call `useRefreshReportPersistenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshReportPersistenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshReportPersistenceMutation, { data, loading, error }] = useRefreshReportPersistenceMutation({
 *   variables: {
 *      reportId: // value for 'reportId'
 *   },
 * });
 */
export function useRefreshReportPersistenceMutation(baseOptions?: Apollo.MutationHookOptions<RefreshReportPersistenceMutation, RefreshReportPersistenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshReportPersistenceMutation, RefreshReportPersistenceMutationVariables>(RefreshReportPersistenceDocument, options);
      }
export type RefreshReportPersistenceMutationHookResult = ReturnType<typeof useRefreshReportPersistenceMutation>;
export type RefreshReportPersistenceMutationResult = Apollo.MutationResult<RefreshReportPersistenceMutation>;
export type RefreshReportPersistenceMutationOptions = Apollo.BaseMutationOptions<RefreshReportPersistenceMutation, RefreshReportPersistenceMutationVariables>;
export const CreateReportDocument = gql`
    mutation CreateReport($input: CreateReportInput!) {
  createReport(input: $input) {
    id
    name
    visibility
  }
}
    `;
export type CreateReportMutationFn = Apollo.MutationFunction<CreateReportMutation, CreateReportMutationVariables>;

/**
 * __useCreateReportMutation__
 *
 * To run a mutation, you first call `useCreateReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReportMutation, { data, loading, error }] = useCreateReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateReportMutation(baseOptions?: Apollo.MutationHookOptions<CreateReportMutation, CreateReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReportMutation, CreateReportMutationVariables>(CreateReportDocument, options);
      }
export type CreateReportMutationHookResult = ReturnType<typeof useCreateReportMutation>;
export type CreateReportMutationResult = Apollo.MutationResult<CreateReportMutation>;
export type CreateReportMutationOptions = Apollo.BaseMutationOptions<CreateReportMutation, CreateReportMutationVariables>;
export const UpdateReportDocument = gql`
    mutation UpdateReport($id: String!, $input: UpdateReportInput!) {
  updateReport(id: $id, input: $input) {
    id
    name
    description
    definition
    chartConfig
    visibility
    updatedAt
  }
}
    `;
export type UpdateReportMutationFn = Apollo.MutationFunction<UpdateReportMutation, UpdateReportMutationVariables>;

/**
 * __useUpdateReportMutation__
 *
 * To run a mutation, you first call `useUpdateReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportMutation, { data, loading, error }] = useUpdateReportMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReportMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReportMutation, UpdateReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReportMutation, UpdateReportMutationVariables>(UpdateReportDocument, options);
      }
export type UpdateReportMutationHookResult = ReturnType<typeof useUpdateReportMutation>;
export type UpdateReportMutationResult = Apollo.MutationResult<UpdateReportMutation>;
export type UpdateReportMutationOptions = Apollo.BaseMutationOptions<UpdateReportMutation, UpdateReportMutationVariables>;
export const DeleteReportDocument = gql`
    mutation DeleteReport($id: String!) {
  deleteReport(id: $id)
}
    `;
export type DeleteReportMutationFn = Apollo.MutationFunction<DeleteReportMutation, DeleteReportMutationVariables>;

/**
 * __useDeleteReportMutation__
 *
 * To run a mutation, you first call `useDeleteReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReportMutation, { data, loading, error }] = useDeleteReportMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteReportMutation(baseOptions?: Apollo.MutationHookOptions<DeleteReportMutation, DeleteReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteReportMutation, DeleteReportMutationVariables>(DeleteReportDocument, options);
      }
export type DeleteReportMutationHookResult = ReturnType<typeof useDeleteReportMutation>;
export type DeleteReportMutationResult = Apollo.MutationResult<DeleteReportMutation>;
export type DeleteReportMutationOptions = Apollo.BaseMutationOptions<DeleteReportMutation, DeleteReportMutationVariables>;
export const PublishReportDocument = gql`
    mutation PublishReport($id: String!, $visibility: ReportVisibility!) {
  publishReport(id: $id, visibility: $visibility) {
    id
    visibility
  }
}
    `;
export type PublishReportMutationFn = Apollo.MutationFunction<PublishReportMutation, PublishReportMutationVariables>;

/**
 * __usePublishReportMutation__
 *
 * To run a mutation, you first call `usePublishReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishReportMutation, { data, loading, error }] = usePublishReportMutation({
 *   variables: {
 *      id: // value for 'id'
 *      visibility: // value for 'visibility'
 *   },
 * });
 */
export function usePublishReportMutation(baseOptions?: Apollo.MutationHookOptions<PublishReportMutation, PublishReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishReportMutation, PublishReportMutationVariables>(PublishReportDocument, options);
      }
export type PublishReportMutationHookResult = ReturnType<typeof usePublishReportMutation>;
export type PublishReportMutationResult = Apollo.MutationResult<PublishReportMutation>;
export type PublishReportMutationOptions = Apollo.BaseMutationOptions<PublishReportMutation, PublishReportMutationVariables>;
export const CloneReportDocument = gql`
    mutation CloneReport($id: String!, $name: String) {
  cloneReport(id: $id, name: $name) {
    id
    name
  }
}
    `;
export type CloneReportMutationFn = Apollo.MutationFunction<CloneReportMutation, CloneReportMutationVariables>;

/**
 * __useCloneReportMutation__
 *
 * To run a mutation, you first call `useCloneReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneReportMutation, { data, loading, error }] = useCloneReportMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCloneReportMutation(baseOptions?: Apollo.MutationHookOptions<CloneReportMutation, CloneReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloneReportMutation, CloneReportMutationVariables>(CloneReportDocument, options);
      }
export type CloneReportMutationHookResult = ReturnType<typeof useCloneReportMutation>;
export type CloneReportMutationResult = Apollo.MutationResult<CloneReportMutation>;
export type CloneReportMutationOptions = Apollo.BaseMutationOptions<CloneReportMutation, CloneReportMutationVariables>;
export const ExportJobsDocument = gql`
    query ExportJobs($limit: Int) {
  exportJobs(limit: $limit) {
    id
    kind
    filename
    status
    error
    rowCount
    byteSize
    requestedByName
    createdAt
    startedAt
    finishedAt
    expiresAt
    downloadUrl
  }
}
    `;

/**
 * __useExportJobsQuery__
 *
 * To run a query within a React component, call `useExportJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportJobsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useExportJobsQuery(baseOptions?: Apollo.QueryHookOptions<ExportJobsQuery, ExportJobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportJobsQuery, ExportJobsQueryVariables>(ExportJobsDocument, options);
      }
export function useExportJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportJobsQuery, ExportJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportJobsQuery, ExportJobsQueryVariables>(ExportJobsDocument, options);
        }
// @ts-ignore
export function useExportJobsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ExportJobsQuery, ExportJobsQueryVariables>): Apollo.UseSuspenseQueryResult<ExportJobsQuery, ExportJobsQueryVariables>;
export function useExportJobsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportJobsQuery, ExportJobsQueryVariables>): Apollo.UseSuspenseQueryResult<ExportJobsQuery | undefined, ExportJobsQueryVariables>;
export function useExportJobsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportJobsQuery, ExportJobsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExportJobsQuery, ExportJobsQueryVariables>(ExportJobsDocument, options);
        }
export type ExportJobsQueryHookResult = ReturnType<typeof useExportJobsQuery>;
export type ExportJobsLazyQueryHookResult = ReturnType<typeof useExportJobsLazyQuery>;
export type ExportJobsSuspenseQueryHookResult = ReturnType<typeof useExportJobsSuspenseQuery>;
export type ExportJobsQueryResult = Apollo.QueryResult<ExportJobsQuery, ExportJobsQueryVariables>;
export const CreateExportJobDocument = gql`
    mutation CreateExportJob($input: CreateExportJobInput!) {
  createExportJob(input: $input) {
    id
    status
  }
}
    `;
export type CreateExportJobMutationFn = Apollo.MutationFunction<CreateExportJobMutation, CreateExportJobMutationVariables>;

/**
 * __useCreateExportJobMutation__
 *
 * To run a mutation, you first call `useCreateExportJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExportJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExportJobMutation, { data, loading, error }] = useCreateExportJobMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateExportJobMutation(baseOptions?: Apollo.MutationHookOptions<CreateExportJobMutation, CreateExportJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateExportJobMutation, CreateExportJobMutationVariables>(CreateExportJobDocument, options);
      }
export type CreateExportJobMutationHookResult = ReturnType<typeof useCreateExportJobMutation>;
export type CreateExportJobMutationResult = Apollo.MutationResult<CreateExportJobMutation>;
export type CreateExportJobMutationOptions = Apollo.BaseMutationOptions<CreateExportJobMutation, CreateExportJobMutationVariables>;
export const AiAssistEnabledDocument = gql`
    query AiAssistEnabled {
  aiAssistEnabled
}
    `;

/**
 * __useAiAssistEnabledQuery__
 *
 * To run a query within a React component, call `useAiAssistEnabledQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiAssistEnabledQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiAssistEnabledQuery({
 *   variables: {
 *   },
 * });
 */
export function useAiAssistEnabledQuery(baseOptions?: Apollo.QueryHookOptions<AiAssistEnabledQuery, AiAssistEnabledQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AiAssistEnabledQuery, AiAssistEnabledQueryVariables>(AiAssistEnabledDocument, options);
      }
export function useAiAssistEnabledLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AiAssistEnabledQuery, AiAssistEnabledQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AiAssistEnabledQuery, AiAssistEnabledQueryVariables>(AiAssistEnabledDocument, options);
        }
// @ts-ignore
export function useAiAssistEnabledSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AiAssistEnabledQuery, AiAssistEnabledQueryVariables>): Apollo.UseSuspenseQueryResult<AiAssistEnabledQuery, AiAssistEnabledQueryVariables>;
export function useAiAssistEnabledSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AiAssistEnabledQuery, AiAssistEnabledQueryVariables>): Apollo.UseSuspenseQueryResult<AiAssistEnabledQuery | undefined, AiAssistEnabledQueryVariables>;
export function useAiAssistEnabledSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AiAssistEnabledQuery, AiAssistEnabledQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AiAssistEnabledQuery, AiAssistEnabledQueryVariables>(AiAssistEnabledDocument, options);
        }
export type AiAssistEnabledQueryHookResult = ReturnType<typeof useAiAssistEnabledQuery>;
export type AiAssistEnabledLazyQueryHookResult = ReturnType<typeof useAiAssistEnabledLazyQuery>;
export type AiAssistEnabledSuspenseQueryHookResult = ReturnType<typeof useAiAssistEnabledSuspenseQuery>;
export type AiAssistEnabledQueryResult = Apollo.QueryResult<AiAssistEnabledQuery, AiAssistEnabledQueryVariables>;
export const AiDraftReportDocument = gql`
    query AiDraftReport($prompt: String!, $datasetKey: String, $history: JSON) {
  aiDraftReport(prompt: $prompt, datasetKey: $datasetKey, history: $history)
}
    `;

/**
 * __useAiDraftReportQuery__
 *
 * To run a query within a React component, call `useAiDraftReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiDraftReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiDraftReportQuery({
 *   variables: {
 *      prompt: // value for 'prompt'
 *      datasetKey: // value for 'datasetKey'
 *      history: // value for 'history'
 *   },
 * });
 */
export function useAiDraftReportQuery(baseOptions: Apollo.QueryHookOptions<AiDraftReportQuery, AiDraftReportQueryVariables> & ({ variables: AiDraftReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AiDraftReportQuery, AiDraftReportQueryVariables>(AiDraftReportDocument, options);
      }
export function useAiDraftReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AiDraftReportQuery, AiDraftReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AiDraftReportQuery, AiDraftReportQueryVariables>(AiDraftReportDocument, options);
        }
// @ts-ignore
export function useAiDraftReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AiDraftReportQuery, AiDraftReportQueryVariables>): Apollo.UseSuspenseQueryResult<AiDraftReportQuery, AiDraftReportQueryVariables>;
export function useAiDraftReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AiDraftReportQuery, AiDraftReportQueryVariables>): Apollo.UseSuspenseQueryResult<AiDraftReportQuery | undefined, AiDraftReportQueryVariables>;
export function useAiDraftReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AiDraftReportQuery, AiDraftReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AiDraftReportQuery, AiDraftReportQueryVariables>(AiDraftReportDocument, options);
        }
export type AiDraftReportQueryHookResult = ReturnType<typeof useAiDraftReportQuery>;
export type AiDraftReportLazyQueryHookResult = ReturnType<typeof useAiDraftReportLazyQuery>;
export type AiDraftReportSuspenseQueryHookResult = ReturnType<typeof useAiDraftReportSuspenseQuery>;
export type AiDraftReportQueryResult = Apollo.QueryResult<AiDraftReportQuery, AiDraftReportQueryVariables>;
export const AccessGrantsDocument = gql`
    query AccessGrants($resourceType: String!, $resourceId: String!) {
  accessGrants(resourceType: $resourceType, resourceId: $resourceId) {
    id
    subjectType
    subjectId
    subjectLabel
    permission
    constraints
    grantedByName
    createdAt
  }
}
    `;

/**
 * __useAccessGrantsQuery__
 *
 * To run a query within a React component, call `useAccessGrantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccessGrantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccessGrantsQuery({
 *   variables: {
 *      resourceType: // value for 'resourceType'
 *      resourceId: // value for 'resourceId'
 *   },
 * });
 */
export function useAccessGrantsQuery(baseOptions: Apollo.QueryHookOptions<AccessGrantsQuery, AccessGrantsQueryVariables> & ({ variables: AccessGrantsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccessGrantsQuery, AccessGrantsQueryVariables>(AccessGrantsDocument, options);
      }
export function useAccessGrantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccessGrantsQuery, AccessGrantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccessGrantsQuery, AccessGrantsQueryVariables>(AccessGrantsDocument, options);
        }
// @ts-ignore
export function useAccessGrantsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AccessGrantsQuery, AccessGrantsQueryVariables>): Apollo.UseSuspenseQueryResult<AccessGrantsQuery, AccessGrantsQueryVariables>;
export function useAccessGrantsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccessGrantsQuery, AccessGrantsQueryVariables>): Apollo.UseSuspenseQueryResult<AccessGrantsQuery | undefined, AccessGrantsQueryVariables>;
export function useAccessGrantsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccessGrantsQuery, AccessGrantsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccessGrantsQuery, AccessGrantsQueryVariables>(AccessGrantsDocument, options);
        }
export type AccessGrantsQueryHookResult = ReturnType<typeof useAccessGrantsQuery>;
export type AccessGrantsLazyQueryHookResult = ReturnType<typeof useAccessGrantsLazyQuery>;
export type AccessGrantsSuspenseQueryHookResult = ReturnType<typeof useAccessGrantsSuspenseQuery>;
export type AccessGrantsQueryResult = Apollo.QueryResult<AccessGrantsQuery, AccessGrantsQueryVariables>;
export const ShareableSubjectsDocument = gql`
    query ShareableSubjects($search: String) {
  shareableSubjects(search: $search)
}
    `;

/**
 * __useShareableSubjectsQuery__
 *
 * To run a query within a React component, call `useShareableSubjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useShareableSubjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShareableSubjectsQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useShareableSubjectsQuery(baseOptions?: Apollo.QueryHookOptions<ShareableSubjectsQuery, ShareableSubjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShareableSubjectsQuery, ShareableSubjectsQueryVariables>(ShareableSubjectsDocument, options);
      }
export function useShareableSubjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShareableSubjectsQuery, ShareableSubjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShareableSubjectsQuery, ShareableSubjectsQueryVariables>(ShareableSubjectsDocument, options);
        }
// @ts-ignore
export function useShareableSubjectsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ShareableSubjectsQuery, ShareableSubjectsQueryVariables>): Apollo.UseSuspenseQueryResult<ShareableSubjectsQuery, ShareableSubjectsQueryVariables>;
export function useShareableSubjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ShareableSubjectsQuery, ShareableSubjectsQueryVariables>): Apollo.UseSuspenseQueryResult<ShareableSubjectsQuery | undefined, ShareableSubjectsQueryVariables>;
export function useShareableSubjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ShareableSubjectsQuery, ShareableSubjectsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ShareableSubjectsQuery, ShareableSubjectsQueryVariables>(ShareableSubjectsDocument, options);
        }
export type ShareableSubjectsQueryHookResult = ReturnType<typeof useShareableSubjectsQuery>;
export type ShareableSubjectsLazyQueryHookResult = ReturnType<typeof useShareableSubjectsLazyQuery>;
export type ShareableSubjectsSuspenseQueryHookResult = ReturnType<typeof useShareableSubjectsSuspenseQuery>;
export type ShareableSubjectsQueryResult = Apollo.QueryResult<ShareableSubjectsQuery, ShareableSubjectsQueryVariables>;
export const GrantAccessDocument = gql`
    mutation GrantAccess($resourceType: String!, $resourceId: String!, $subjectType: String!, $subjectId: String!, $permission: String, $constraints: JSON) {
  grantAccess(
    resourceType: $resourceType
    resourceId: $resourceId
    subjectType: $subjectType
    subjectId: $subjectId
    permission: $permission
    constraints: $constraints
  ) {
    id
    subjectLabel
    permission
  }
}
    `;
export type GrantAccessMutationFn = Apollo.MutationFunction<GrantAccessMutation, GrantAccessMutationVariables>;

/**
 * __useGrantAccessMutation__
 *
 * To run a mutation, you first call `useGrantAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGrantAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [grantAccessMutation, { data, loading, error }] = useGrantAccessMutation({
 *   variables: {
 *      resourceType: // value for 'resourceType'
 *      resourceId: // value for 'resourceId'
 *      subjectType: // value for 'subjectType'
 *      subjectId: // value for 'subjectId'
 *      permission: // value for 'permission'
 *      constraints: // value for 'constraints'
 *   },
 * });
 */
export function useGrantAccessMutation(baseOptions?: Apollo.MutationHookOptions<GrantAccessMutation, GrantAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GrantAccessMutation, GrantAccessMutationVariables>(GrantAccessDocument, options);
      }
export type GrantAccessMutationHookResult = ReturnType<typeof useGrantAccessMutation>;
export type GrantAccessMutationResult = Apollo.MutationResult<GrantAccessMutation>;
export type GrantAccessMutationOptions = Apollo.BaseMutationOptions<GrantAccessMutation, GrantAccessMutationVariables>;
export const RevokeAccessDocument = gql`
    mutation RevokeAccess($id: String!) {
  revokeAccess(id: $id)
}
    `;
export type RevokeAccessMutationFn = Apollo.MutationFunction<RevokeAccessMutation, RevokeAccessMutationVariables>;

/**
 * __useRevokeAccessMutation__
 *
 * To run a mutation, you first call `useRevokeAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeAccessMutation, { data, loading, error }] = useRevokeAccessMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRevokeAccessMutation(baseOptions?: Apollo.MutationHookOptions<RevokeAccessMutation, RevokeAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeAccessMutation, RevokeAccessMutationVariables>(RevokeAccessDocument, options);
      }
export type RevokeAccessMutationHookResult = ReturnType<typeof useRevokeAccessMutation>;
export type RevokeAccessMutationResult = Apollo.MutationResult<RevokeAccessMutation>;
export type RevokeAccessMutationOptions = Apollo.BaseMutationOptions<RevokeAccessMutation, RevokeAccessMutationVariables>;
export const SqlTablesDocument = gql`
    query SqlTables {
  sqlTables {
    table
    columns {
      name
      type
    }
  }
}
    `;

/**
 * __useSqlTablesQuery__
 *
 * To run a query within a React component, call `useSqlTablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSqlTablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSqlTablesQuery({
 *   variables: {
 *   },
 * });
 */
export function useSqlTablesQuery(baseOptions?: Apollo.QueryHookOptions<SqlTablesQuery, SqlTablesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SqlTablesQuery, SqlTablesQueryVariables>(SqlTablesDocument, options);
      }
export function useSqlTablesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SqlTablesQuery, SqlTablesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SqlTablesQuery, SqlTablesQueryVariables>(SqlTablesDocument, options);
        }
// @ts-ignore
export function useSqlTablesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SqlTablesQuery, SqlTablesQueryVariables>): Apollo.UseSuspenseQueryResult<SqlTablesQuery, SqlTablesQueryVariables>;
export function useSqlTablesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SqlTablesQuery, SqlTablesQueryVariables>): Apollo.UseSuspenseQueryResult<SqlTablesQuery | undefined, SqlTablesQueryVariables>;
export function useSqlTablesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SqlTablesQuery, SqlTablesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SqlTablesQuery, SqlTablesQueryVariables>(SqlTablesDocument, options);
        }
export type SqlTablesQueryHookResult = ReturnType<typeof useSqlTablesQuery>;
export type SqlTablesLazyQueryHookResult = ReturnType<typeof useSqlTablesLazyQuery>;
export type SqlTablesSuspenseQueryHookResult = ReturnType<typeof useSqlTablesSuspenseQuery>;
export type SqlTablesQueryResult = Apollo.QueryResult<SqlTablesQuery, SqlTablesQueryVariables>;
export const RunRawReportDocument = gql`
    query RunRawReport($input: RunRawReportInput!) {
  runRawReport(input: $input) {
    columns {
      key
      label
      kind
      type
      format
      table
    }
    rows
    hasMore
    executionMs
    totals
    columnTotals
    groupCount
  }
}
    `;

/**
 * __useRunRawReportQuery__
 *
 * To run a query within a React component, call `useRunRawReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunRawReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunRawReportQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRunRawReportQuery(baseOptions: Apollo.QueryHookOptions<RunRawReportQuery, RunRawReportQueryVariables> & ({ variables: RunRawReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RunRawReportQuery, RunRawReportQueryVariables>(RunRawReportDocument, options);
      }
export function useRunRawReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RunRawReportQuery, RunRawReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RunRawReportQuery, RunRawReportQueryVariables>(RunRawReportDocument, options);
        }
// @ts-ignore
export function useRunRawReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RunRawReportQuery, RunRawReportQueryVariables>): Apollo.UseSuspenseQueryResult<RunRawReportQuery, RunRawReportQueryVariables>;
export function useRunRawReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RunRawReportQuery, RunRawReportQueryVariables>): Apollo.UseSuspenseQueryResult<RunRawReportQuery | undefined, RunRawReportQueryVariables>;
export function useRunRawReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RunRawReportQuery, RunRawReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RunRawReportQuery, RunRawReportQueryVariables>(RunRawReportDocument, options);
        }
export type RunRawReportQueryHookResult = ReturnType<typeof useRunRawReportQuery>;
export type RunRawReportLazyQueryHookResult = ReturnType<typeof useRunRawReportLazyQuery>;
export type RunRawReportSuspenseQueryHookResult = ReturnType<typeof useRunRawReportSuspenseQuery>;
export type RunRawReportQueryResult = Apollo.QueryResult<RunRawReportQuery, RunRawReportQueryVariables>;
export const CreateSqlReportDocument = gql`
    mutation CreateSqlReport($input: CreateSqlReportInput!) {
  createSqlReport(input: $input) {
    id
    name
  }
}
    `;
export type CreateSqlReportMutationFn = Apollo.MutationFunction<CreateSqlReportMutation, CreateSqlReportMutationVariables>;

/**
 * __useCreateSqlReportMutation__
 *
 * To run a mutation, you first call `useCreateSqlReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSqlReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSqlReportMutation, { data, loading, error }] = useCreateSqlReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSqlReportMutation(baseOptions?: Apollo.MutationHookOptions<CreateSqlReportMutation, CreateSqlReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSqlReportMutation, CreateSqlReportMutationVariables>(CreateSqlReportDocument, options);
      }
export type CreateSqlReportMutationHookResult = ReturnType<typeof useCreateSqlReportMutation>;
export type CreateSqlReportMutationResult = Apollo.MutationResult<CreateSqlReportMutation>;
export type CreateSqlReportMutationOptions = Apollo.BaseMutationOptions<CreateSqlReportMutation, CreateSqlReportMutationVariables>;
export const UpdateSqlReportDocument = gql`
    mutation UpdateSqlReport($id: String!, $input: UpdateSqlReportInput!) {
  updateSqlReport(id: $id, input: $input) {
    id
    name
    definition
    chartConfig
  }
}
    `;
export type UpdateSqlReportMutationFn = Apollo.MutationFunction<UpdateSqlReportMutation, UpdateSqlReportMutationVariables>;

/**
 * __useUpdateSqlReportMutation__
 *
 * To run a mutation, you first call `useUpdateSqlReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSqlReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSqlReportMutation, { data, loading, error }] = useUpdateSqlReportMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSqlReportMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSqlReportMutation, UpdateSqlReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSqlReportMutation, UpdateSqlReportMutationVariables>(UpdateSqlReportDocument, options);
      }
export type UpdateSqlReportMutationHookResult = ReturnType<typeof useUpdateSqlReportMutation>;
export type UpdateSqlReportMutationResult = Apollo.MutationResult<UpdateSqlReportMutation>;
export type UpdateSqlReportMutationOptions = Apollo.BaseMutationOptions<UpdateSqlReportMutation, UpdateSqlReportMutationVariables>;
export const RawParameterOptionsDocument = gql`
    query RawParameterOptions($input: RawParameterOptionsInput!) {
  rawParameterOptions(input: $input)
}
    `;

/**
 * __useRawParameterOptionsQuery__
 *
 * To run a query within a React component, call `useRawParameterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRawParameterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRawParameterOptionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRawParameterOptionsQuery(baseOptions: Apollo.QueryHookOptions<RawParameterOptionsQuery, RawParameterOptionsQueryVariables> & ({ variables: RawParameterOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RawParameterOptionsQuery, RawParameterOptionsQueryVariables>(RawParameterOptionsDocument, options);
      }
export function useRawParameterOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RawParameterOptionsQuery, RawParameterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RawParameterOptionsQuery, RawParameterOptionsQueryVariables>(RawParameterOptionsDocument, options);
        }
// @ts-ignore
export function useRawParameterOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RawParameterOptionsQuery, RawParameterOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<RawParameterOptionsQuery, RawParameterOptionsQueryVariables>;
export function useRawParameterOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RawParameterOptionsQuery, RawParameterOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<RawParameterOptionsQuery | undefined, RawParameterOptionsQueryVariables>;
export function useRawParameterOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RawParameterOptionsQuery, RawParameterOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RawParameterOptionsQuery, RawParameterOptionsQueryVariables>(RawParameterOptionsDocument, options);
        }
export type RawParameterOptionsQueryHookResult = ReturnType<typeof useRawParameterOptionsQuery>;
export type RawParameterOptionsLazyQueryHookResult = ReturnType<typeof useRawParameterOptionsLazyQuery>;
export type RawParameterOptionsSuspenseQueryHookResult = ReturnType<typeof useRawParameterOptionsSuspenseQuery>;
export type RawParameterOptionsQueryResult = Apollo.QueryResult<RawParameterOptionsQuery, RawParameterOptionsQueryVariables>;
export const CreateAuditDocument = gql`
    mutation CreateAudit($createAuditDto: CreateAuditDto!) {
  createAudit(createAuditDto: $createAuditDto) {
    id
  }
}
    `;
export type CreateAuditMutationFn = Apollo.MutationFunction<CreateAuditMutation, CreateAuditMutationVariables>;

/**
 * __useCreateAuditMutation__
 *
 * To run a mutation, you first call `useCreateAuditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAuditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAuditMutation, { data, loading, error }] = useCreateAuditMutation({
 *   variables: {
 *      createAuditDto: // value for 'createAuditDto'
 *   },
 * });
 */
export function useCreateAuditMutation(baseOptions?: Apollo.MutationHookOptions<CreateAuditMutation, CreateAuditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAuditMutation, CreateAuditMutationVariables>(CreateAuditDocument, options);
      }
export type CreateAuditMutationHookResult = ReturnType<typeof useCreateAuditMutation>;
export type CreateAuditMutationResult = Apollo.MutationResult<CreateAuditMutation>;
export type CreateAuditMutationOptions = Apollo.BaseMutationOptions<CreateAuditMutation, CreateAuditMutationVariables>;
export const GetAllAuditsDocument = gql`
    query GetAllAudits($filter: [FilterGroup!], $limit: Int!, $locationId: String, $page: Int!, $sort: [SortCondition!]) {
  getAllAudits(
    filter: $filter
    limit: $limit
    locationId: $locationId
    page: $page
    sort: $sort
  ) {
    data {
      id
      secondaryId
      type
      status
      itemCount
      lotCount
      matchedProducts
      shortProducts
      shortStockValue
      excessProducts
      excessStockValue
      createdAt
    }
    meta {
      limit
      page
      total
      totalCount
    }
  }
}
    `;

/**
 * __useGetAllAuditsQuery__
 *
 * To run a query within a React component, call `useGetAllAuditsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAuditsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllAuditsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      locationId: // value for 'locationId'
 *      page: // value for 'page'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetAllAuditsQuery(baseOptions: Apollo.QueryHookOptions<GetAllAuditsQuery, GetAllAuditsQueryVariables> & ({ variables: GetAllAuditsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllAuditsQuery, GetAllAuditsQueryVariables>(GetAllAuditsDocument, options);
      }
export function useGetAllAuditsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllAuditsQuery, GetAllAuditsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllAuditsQuery, GetAllAuditsQueryVariables>(GetAllAuditsDocument, options);
        }
// @ts-ignore
export function useGetAllAuditsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllAuditsQuery, GetAllAuditsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllAuditsQuery, GetAllAuditsQueryVariables>;
export function useGetAllAuditsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllAuditsQuery, GetAllAuditsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllAuditsQuery | undefined, GetAllAuditsQueryVariables>;
export function useGetAllAuditsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllAuditsQuery, GetAllAuditsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllAuditsQuery, GetAllAuditsQueryVariables>(GetAllAuditsDocument, options);
        }
export type GetAllAuditsQueryHookResult = ReturnType<typeof useGetAllAuditsQuery>;
export type GetAllAuditsLazyQueryHookResult = ReturnType<typeof useGetAllAuditsLazyQuery>;
export type GetAllAuditsSuspenseQueryHookResult = ReturnType<typeof useGetAllAuditsSuspenseQuery>;
export type GetAllAuditsQueryResult = Apollo.QueryResult<GetAllAuditsQuery, GetAllAuditsQueryVariables>;
export const GetAuditDocument = gql`
    query GetAudit($auditId: String!) {
  getAudit(auditId: $auditId) {
    id
    secondaryId
    status
    auditProducts {
      id
      status
      lotCount
      secondaryId
      product {
        uomFactor
        name
        secondaryId
        id
      }
    }
  }
}
    `;

/**
 * __useGetAuditQuery__
 *
 * To run a query within a React component, call `useGetAuditQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuditQuery({
 *   variables: {
 *      auditId: // value for 'auditId'
 *   },
 * });
 */
export function useGetAuditQuery(baseOptions: Apollo.QueryHookOptions<GetAuditQuery, GetAuditQueryVariables> & ({ variables: GetAuditQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAuditQuery, GetAuditQueryVariables>(GetAuditDocument, options);
      }
export function useGetAuditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAuditQuery, GetAuditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAuditQuery, GetAuditQueryVariables>(GetAuditDocument, options);
        }
// @ts-ignore
export function useGetAuditSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAuditQuery, GetAuditQueryVariables>): Apollo.UseSuspenseQueryResult<GetAuditQuery, GetAuditQueryVariables>;
export function useGetAuditSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAuditQuery, GetAuditQueryVariables>): Apollo.UseSuspenseQueryResult<GetAuditQuery | undefined, GetAuditQueryVariables>;
export function useGetAuditSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAuditQuery, GetAuditQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAuditQuery, GetAuditQueryVariables>(GetAuditDocument, options);
        }
export type GetAuditQueryHookResult = ReturnType<typeof useGetAuditQuery>;
export type GetAuditLazyQueryHookResult = ReturnType<typeof useGetAuditLazyQuery>;
export type GetAuditSuspenseQueryHookResult = ReturnType<typeof useGetAuditSuspenseQuery>;
export type GetAuditQueryResult = Apollo.QueryResult<GetAuditQuery, GetAuditQueryVariables>;
export const StartAuditDocument = gql`
    mutation StartAudit($auditId: String!, $productId: String!) {
  startAudit(auditId: $auditId, productId: $productId)
}
    `;
export type StartAuditMutationFn = Apollo.MutationFunction<StartAuditMutation, StartAuditMutationVariables>;

/**
 * __useStartAuditMutation__
 *
 * To run a mutation, you first call `useStartAuditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartAuditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startAuditMutation, { data, loading, error }] = useStartAuditMutation({
 *   variables: {
 *      auditId: // value for 'auditId'
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useStartAuditMutation(baseOptions?: Apollo.MutationHookOptions<StartAuditMutation, StartAuditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartAuditMutation, StartAuditMutationVariables>(StartAuditDocument, options);
      }
export type StartAuditMutationHookResult = ReturnType<typeof useStartAuditMutation>;
export type StartAuditMutationResult = Apollo.MutationResult<StartAuditMutation>;
export type StartAuditMutationOptions = Apollo.BaseMutationOptions<StartAuditMutation, StartAuditMutationVariables>;
export const ScanAuditLotDocument = gql`
    mutation ScanAuditLot($scanLotsDto: ScanLotsDto!) {
  scanAuditLot(scanLotsDto: $scanLotsDto)
}
    `;
export type ScanAuditLotMutationFn = Apollo.MutationFunction<ScanAuditLotMutation, ScanAuditLotMutationVariables>;

/**
 * __useScanAuditLotMutation__
 *
 * To run a mutation, you first call `useScanAuditLotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScanAuditLotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scanAuditLotMutation, { data, loading, error }] = useScanAuditLotMutation({
 *   variables: {
 *      scanLotsDto: // value for 'scanLotsDto'
 *   },
 * });
 */
export function useScanAuditLotMutation(baseOptions?: Apollo.MutationHookOptions<ScanAuditLotMutation, ScanAuditLotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ScanAuditLotMutation, ScanAuditLotMutationVariables>(ScanAuditLotDocument, options);
      }
export type ScanAuditLotMutationHookResult = ReturnType<typeof useScanAuditLotMutation>;
export type ScanAuditLotMutationResult = Apollo.MutationResult<ScanAuditLotMutation>;
export type ScanAuditLotMutationOptions = Apollo.BaseMutationOptions<ScanAuditLotMutation, ScanAuditLotMutationVariables>;
export const GetAuditProductSummaryDocument = gql`
    query GetAuditProductSummary($auditProductId: String!) {
  getAuditProductSummary(auditProductId: $auditProductId) {
    actualQuantity
    excessAmount
    excessCount
    expectedQuantity
    matchedCount
    productId
    productName
    remainingLots
    scannedLots
    shortAmount
    shortCount
    status
    stockValue
    totalLots
  }
}
    `;

/**
 * __useGetAuditProductSummaryQuery__
 *
 * To run a query within a React component, call `useGetAuditProductSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuditProductSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuditProductSummaryQuery({
 *   variables: {
 *      auditProductId: // value for 'auditProductId'
 *   },
 * });
 */
export function useGetAuditProductSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetAuditProductSummaryQuery, GetAuditProductSummaryQueryVariables> & ({ variables: GetAuditProductSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAuditProductSummaryQuery, GetAuditProductSummaryQueryVariables>(GetAuditProductSummaryDocument, options);
      }
export function useGetAuditProductSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAuditProductSummaryQuery, GetAuditProductSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAuditProductSummaryQuery, GetAuditProductSummaryQueryVariables>(GetAuditProductSummaryDocument, options);
        }
// @ts-ignore
export function useGetAuditProductSummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAuditProductSummaryQuery, GetAuditProductSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<GetAuditProductSummaryQuery, GetAuditProductSummaryQueryVariables>;
export function useGetAuditProductSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAuditProductSummaryQuery, GetAuditProductSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<GetAuditProductSummaryQuery | undefined, GetAuditProductSummaryQueryVariables>;
export function useGetAuditProductSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAuditProductSummaryQuery, GetAuditProductSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAuditProductSummaryQuery, GetAuditProductSummaryQueryVariables>(GetAuditProductSummaryDocument, options);
        }
export type GetAuditProductSummaryQueryHookResult = ReturnType<typeof useGetAuditProductSummaryQuery>;
export type GetAuditProductSummaryLazyQueryHookResult = ReturnType<typeof useGetAuditProductSummaryLazyQuery>;
export type GetAuditProductSummarySuspenseQueryHookResult = ReturnType<typeof useGetAuditProductSummarySuspenseQuery>;
export type GetAuditProductSummaryQueryResult = Apollo.QueryResult<GetAuditProductSummaryQuery, GetAuditProductSummaryQueryVariables>;
export const GetAllAuditLotsDocument = gql`
    query GetAllAuditLots($filter: [FilterGroup!], $page: Int!, $limit: Int!, $sort: [SortCondition!], $locationId: String) {
  getAllAuditLots(
    filter: $filter
    page: $page
    limit: $limit
    sort: $sort
    locationId: $locationId
  ) {
    data {
      id
      actionId
      expectedQuantity
      actualQuantity
      lotStockValue
      status
    }
    meta {
      limit
      page
      total
      totalCount
    }
  }
}
    `;

/**
 * __useGetAllAuditLotsQuery__
 *
 * To run a query within a React component, call `useGetAllAuditLotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAuditLotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllAuditLotsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useGetAllAuditLotsQuery(baseOptions: Apollo.QueryHookOptions<GetAllAuditLotsQuery, GetAllAuditLotsQueryVariables> & ({ variables: GetAllAuditLotsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllAuditLotsQuery, GetAllAuditLotsQueryVariables>(GetAllAuditLotsDocument, options);
      }
export function useGetAllAuditLotsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllAuditLotsQuery, GetAllAuditLotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllAuditLotsQuery, GetAllAuditLotsQueryVariables>(GetAllAuditLotsDocument, options);
        }
// @ts-ignore
export function useGetAllAuditLotsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllAuditLotsQuery, GetAllAuditLotsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllAuditLotsQuery, GetAllAuditLotsQueryVariables>;
export function useGetAllAuditLotsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllAuditLotsQuery, GetAllAuditLotsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllAuditLotsQuery | undefined, GetAllAuditLotsQueryVariables>;
export function useGetAllAuditLotsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllAuditLotsQuery, GetAllAuditLotsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllAuditLotsQuery, GetAllAuditLotsQueryVariables>(GetAllAuditLotsDocument, options);
        }
export type GetAllAuditLotsQueryHookResult = ReturnType<typeof useGetAllAuditLotsQuery>;
export type GetAllAuditLotsLazyQueryHookResult = ReturnType<typeof useGetAllAuditLotsLazyQuery>;
export type GetAllAuditLotsSuspenseQueryHookResult = ReturnType<typeof useGetAllAuditLotsSuspenseQuery>;
export type GetAllAuditLotsQueryResult = Apollo.QueryResult<GetAllAuditLotsQuery, GetAllAuditLotsQueryVariables>;
export const CompleteProductAuditDocument = gql`
    mutation CompleteProductAudit($auditId: String!, $productId: String!) {
  completeProductAudit(auditId: $auditId, productId: $productId)
}
    `;
export type CompleteProductAuditMutationFn = Apollo.MutationFunction<CompleteProductAuditMutation, CompleteProductAuditMutationVariables>;

/**
 * __useCompleteProductAuditMutation__
 *
 * To run a mutation, you first call `useCompleteProductAuditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteProductAuditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeProductAuditMutation, { data, loading, error }] = useCompleteProductAuditMutation({
 *   variables: {
 *      auditId: // value for 'auditId'
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useCompleteProductAuditMutation(baseOptions?: Apollo.MutationHookOptions<CompleteProductAuditMutation, CompleteProductAuditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteProductAuditMutation, CompleteProductAuditMutationVariables>(CompleteProductAuditDocument, options);
      }
export type CompleteProductAuditMutationHookResult = ReturnType<typeof useCompleteProductAuditMutation>;
export type CompleteProductAuditMutationResult = Apollo.MutationResult<CompleteProductAuditMutation>;
export type CompleteProductAuditMutationOptions = Apollo.BaseMutationOptions<CompleteProductAuditMutation, CompleteProductAuditMutationVariables>;
export const CloseAuditDocument = gql`
    mutation CloseAudit($auditId: String!, $closureReason: String!) {
  closeAudit(auditId: $auditId, closureReason: $closureReason)
}
    `;
export type CloseAuditMutationFn = Apollo.MutationFunction<CloseAuditMutation, CloseAuditMutationVariables>;

/**
 * __useCloseAuditMutation__
 *
 * To run a mutation, you first call `useCloseAuditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseAuditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeAuditMutation, { data, loading, error }] = useCloseAuditMutation({
 *   variables: {
 *      auditId: // value for 'auditId'
 *      closureReason: // value for 'closureReason'
 *   },
 * });
 */
export function useCloseAuditMutation(baseOptions?: Apollo.MutationHookOptions<CloseAuditMutation, CloseAuditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloseAuditMutation, CloseAuditMutationVariables>(CloseAuditDocument, options);
      }
export type CloseAuditMutationHookResult = ReturnType<typeof useCloseAuditMutation>;
export type CloseAuditMutationResult = Apollo.MutationResult<CloseAuditMutation>;
export type CloseAuditMutationOptions = Apollo.BaseMutationOptions<CloseAuditMutation, CloseAuditMutationVariables>;
export const LoginUserDocument = gql`
    mutation LoginUser($loginUserDto: LoginUserDTO!) {
  loginUser(loginUserDTO: $loginUserDto) {
    allowedLocations {
      id
      name
      type
      countryId
    }
    tenant {
      currency
      onlineStoreURL
      logo
      parentCompanyLogo
      website
      qrInvertedLogo
      invertedLogo
    }
    permissions {
      id
      permission
    }
    tenant {
      accountId
      id
      name
    }
    token
    user {
      email
      firstName
      id
      lastName
      role {
        id
        name
      }
    }
  }
}
    `;
export type LoginUserMutationFn = Apollo.MutationFunction<LoginUserMutation, LoginUserMutationVariables>;

/**
 * __useLoginUserMutation__
 *
 * To run a mutation, you first call `useLoginUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginUserMutation, { data, loading, error }] = useLoginUserMutation({
 *   variables: {
 *      loginUserDto: // value for 'loginUserDto'
 *   },
 * });
 */
export function useLoginUserMutation(baseOptions?: Apollo.MutationHookOptions<LoginUserMutation, LoginUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginUserMutation, LoginUserMutationVariables>(LoginUserDocument, options);
      }
export type LoginUserMutationHookResult = ReturnType<typeof useLoginUserMutation>;
export type LoginUserMutationResult = Apollo.MutationResult<LoginUserMutation>;
export type LoginUserMutationOptions = Apollo.BaseMutationOptions<LoginUserMutation, LoginUserMutationVariables>;
export const AuthenticateTokenDocument = gql`
    query AuthenticateToken {
  authenticateToken {
    allowedLocations {
      id
      name
      type
      countryId
    }
    tenant {
      currency
      onlineStoreURL
      logo
      parentCompanyLogo
      website
      qrInvertedLogo
      invertedLogo
    }
    permissions {
      id
      permission
    }
    tenant {
      accountId
      id
      name
    }
    token
    user {
      email
      firstName
      id
      lastName
      role {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useAuthenticateTokenQuery__
 *
 * To run a query within a React component, call `useAuthenticateTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthenticateTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthenticateTokenQuery({
 *   variables: {
 *   },
 * });
 */
export function useAuthenticateTokenQuery(baseOptions?: Apollo.QueryHookOptions<AuthenticateTokenQuery, AuthenticateTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuthenticateTokenQuery, AuthenticateTokenQueryVariables>(AuthenticateTokenDocument, options);
      }
export function useAuthenticateTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuthenticateTokenQuery, AuthenticateTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuthenticateTokenQuery, AuthenticateTokenQueryVariables>(AuthenticateTokenDocument, options);
        }
// @ts-ignore
export function useAuthenticateTokenSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AuthenticateTokenQuery, AuthenticateTokenQueryVariables>): Apollo.UseSuspenseQueryResult<AuthenticateTokenQuery, AuthenticateTokenQueryVariables>;
export function useAuthenticateTokenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuthenticateTokenQuery, AuthenticateTokenQueryVariables>): Apollo.UseSuspenseQueryResult<AuthenticateTokenQuery | undefined, AuthenticateTokenQueryVariables>;
export function useAuthenticateTokenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuthenticateTokenQuery, AuthenticateTokenQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AuthenticateTokenQuery, AuthenticateTokenQueryVariables>(AuthenticateTokenDocument, options);
        }
export type AuthenticateTokenQueryHookResult = ReturnType<typeof useAuthenticateTokenQuery>;
export type AuthenticateTokenLazyQueryHookResult = ReturnType<typeof useAuthenticateTokenLazyQuery>;
export type AuthenticateTokenSuspenseQueryHookResult = ReturnType<typeof useAuthenticateTokenSuspenseQuery>;
export type AuthenticateTokenQueryResult = Apollo.QueryResult<AuthenticateTokenQuery, AuthenticateTokenQueryVariables>;
export const ForgotPasswordDocument = gql`
    mutation ForgotPassword($email: String!, $origin: String!) {
  forgotPassword(email: $email, origin: $origin)
}
    `;
export type ForgotPasswordMutationFn = Apollo.MutationFunction<ForgotPasswordMutation, ForgotPasswordMutationVariables>;

/**
 * __useForgotPasswordMutation__
 *
 * To run a mutation, you first call `useForgotPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForgotPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forgotPasswordMutation, { data, loading, error }] = useForgotPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *      origin: // value for 'origin'
 *   },
 * });
 */
export function useForgotPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForgotPasswordMutation, ForgotPasswordMutationVariables>(ForgotPasswordDocument, options);
      }
export type ForgotPasswordMutationHookResult = ReturnType<typeof useForgotPasswordMutation>;
export type ForgotPasswordMutationResult = Apollo.MutationResult<ForgotPasswordMutation>;
export type ForgotPasswordMutationOptions = Apollo.BaseMutationOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>;
export const AcceptInviteDocument = gql`
    mutation AcceptInvite($acceptInviteDto: AcceptInviteDTO!) {
  acceptInvite(acceptInviteDTO: $acceptInviteDto)
}
    `;
export type AcceptInviteMutationFn = Apollo.MutationFunction<AcceptInviteMutation, AcceptInviteMutationVariables>;

/**
 * __useAcceptInviteMutation__
 *
 * To run a mutation, you first call `useAcceptInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptInviteMutation, { data, loading, error }] = useAcceptInviteMutation({
 *   variables: {
 *      acceptInviteDto: // value for 'acceptInviteDto'
 *   },
 * });
 */
export function useAcceptInviteMutation(baseOptions?: Apollo.MutationHookOptions<AcceptInviteMutation, AcceptInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptInviteMutation, AcceptInviteMutationVariables>(AcceptInviteDocument, options);
      }
export type AcceptInviteMutationHookResult = ReturnType<typeof useAcceptInviteMutation>;
export type AcceptInviteMutationResult = Apollo.MutationResult<AcceptInviteMutation>;
export type AcceptInviteMutationOptions = Apollo.BaseMutationOptions<AcceptInviteMutation, AcceptInviteMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation ResetPassword($resetPasswordId: String!, $password: String!, $token: String!) {
  resetPassword(id: $resetPasswordId, password: $password, token: $token)
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      resetPasswordId: // value for 'resetPasswordId'
 *      password: // value for 'password'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const ValidateEmailTokenDocument = gql`
    mutation ValidateEmailToken($validateEmailTokenId: String!, $token: String!) {
  validateEmailToken(id: $validateEmailTokenId, token: $token)
}
    `;
export type ValidateEmailTokenMutationFn = Apollo.MutationFunction<ValidateEmailTokenMutation, ValidateEmailTokenMutationVariables>;

/**
 * __useValidateEmailTokenMutation__
 *
 * To run a mutation, you first call `useValidateEmailTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateEmailTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateEmailTokenMutation, { data, loading, error }] = useValidateEmailTokenMutation({
 *   variables: {
 *      validateEmailTokenId: // value for 'validateEmailTokenId'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useValidateEmailTokenMutation(baseOptions?: Apollo.MutationHookOptions<ValidateEmailTokenMutation, ValidateEmailTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateEmailTokenMutation, ValidateEmailTokenMutationVariables>(ValidateEmailTokenDocument, options);
      }
export type ValidateEmailTokenMutationHookResult = ReturnType<typeof useValidateEmailTokenMutation>;
export type ValidateEmailTokenMutationResult = Apollo.MutationResult<ValidateEmailTokenMutation>;
export type ValidateEmailTokenMutationOptions = Apollo.BaseMutationOptions<ValidateEmailTokenMutation, ValidateEmailTokenMutationVariables>;
export const ValidateInviteTokenDocument = gql`
    mutation ValidateInviteToken($validateInviteTokenId: String!, $token: String!) {
  validateInviteToken(id: $validateInviteTokenId, token: $token)
}
    `;
export type ValidateInviteTokenMutationFn = Apollo.MutationFunction<ValidateInviteTokenMutation, ValidateInviteTokenMutationVariables>;

/**
 * __useValidateInviteTokenMutation__
 *
 * To run a mutation, you first call `useValidateInviteTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateInviteTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateInviteTokenMutation, { data, loading, error }] = useValidateInviteTokenMutation({
 *   variables: {
 *      validateInviteTokenId: // value for 'validateInviteTokenId'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useValidateInviteTokenMutation(baseOptions?: Apollo.MutationHookOptions<ValidateInviteTokenMutation, ValidateInviteTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateInviteTokenMutation, ValidateInviteTokenMutationVariables>(ValidateInviteTokenDocument, options);
      }
export type ValidateInviteTokenMutationHookResult = ReturnType<typeof useValidateInviteTokenMutation>;
export type ValidateInviteTokenMutationResult = Apollo.MutationResult<ValidateInviteTokenMutation>;
export type ValidateInviteTokenMutationOptions = Apollo.BaseMutationOptions<ValidateInviteTokenMutation, ValidateInviteTokenMutationVariables>;
export const GetBomsDocument = gql`
    query GetBoms($filter: [FilterGroup!], $page: Int, $limit: Int, $sort: [SortCondition!]) {
  getBoms(filter: $filter, page: $page, limit: $limit, sort: $sort) {
    meta {
      total
      page
      limit
    }
    data {
      id
      secondaryId
      bomCode
      bomName
      productionProcessType
      status
      outputProductId
      outputProduct {
        id
        name
        trackingLevel
      }
      createdBy
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useGetBomsQuery__
 *
 * To run a query within a React component, call `useGetBomsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBomsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBomsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetBomsQuery(baseOptions?: Apollo.QueryHookOptions<GetBomsQuery, GetBomsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBomsQuery, GetBomsQueryVariables>(GetBomsDocument, options);
      }
export function useGetBomsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBomsQuery, GetBomsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBomsQuery, GetBomsQueryVariables>(GetBomsDocument, options);
        }
// @ts-ignore
export function useGetBomsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBomsQuery, GetBomsQueryVariables>): Apollo.UseSuspenseQueryResult<GetBomsQuery, GetBomsQueryVariables>;
export function useGetBomsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBomsQuery, GetBomsQueryVariables>): Apollo.UseSuspenseQueryResult<GetBomsQuery | undefined, GetBomsQueryVariables>;
export function useGetBomsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBomsQuery, GetBomsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBomsQuery, GetBomsQueryVariables>(GetBomsDocument, options);
        }
export type GetBomsQueryHookResult = ReturnType<typeof useGetBomsQuery>;
export type GetBomsLazyQueryHookResult = ReturnType<typeof useGetBomsLazyQuery>;
export type GetBomsSuspenseQueryHookResult = ReturnType<typeof useGetBomsSuspenseQuery>;
export type GetBomsQueryResult = Apollo.QueryResult<GetBomsQuery, GetBomsQueryVariables>;
export const GetBomDocument = gql`
    query GetBom($id: String!) {
  getBom(id: $id) {
    id
    secondaryId
    bomCode
    bomName
    productionProcessType
    status
    outputProduct {
      id
      name
      trackingLevel
    }
    versions {
      id
      versionNo
      versionLabel
      batchQuantity
      approvalStatus
      lifecycleStatus
      effectiveFrom
      effectiveTo
      approvedBy
      approvedAt
    }
  }
}
    `;

/**
 * __useGetBomQuery__
 *
 * To run a query within a React component, call `useGetBomQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBomQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBomQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBomQuery(baseOptions: Apollo.QueryHookOptions<GetBomQuery, GetBomQueryVariables> & ({ variables: GetBomQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBomQuery, GetBomQueryVariables>(GetBomDocument, options);
      }
export function useGetBomLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBomQuery, GetBomQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBomQuery, GetBomQueryVariables>(GetBomDocument, options);
        }
// @ts-ignore
export function useGetBomSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBomQuery, GetBomQueryVariables>): Apollo.UseSuspenseQueryResult<GetBomQuery, GetBomQueryVariables>;
export function useGetBomSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBomQuery, GetBomQueryVariables>): Apollo.UseSuspenseQueryResult<GetBomQuery | undefined, GetBomQueryVariables>;
export function useGetBomSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBomQuery, GetBomQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBomQuery, GetBomQueryVariables>(GetBomDocument, options);
        }
export type GetBomQueryHookResult = ReturnType<typeof useGetBomQuery>;
export type GetBomLazyQueryHookResult = ReturnType<typeof useGetBomLazyQuery>;
export type GetBomSuspenseQueryHookResult = ReturnType<typeof useGetBomSuspenseQuery>;
export type GetBomQueryResult = Apollo.QueryResult<GetBomQuery, GetBomQueryVariables>;
export const CreateBomDocument = gql`
    mutation CreateBom($dto: CreateBomDTO!) {
  createBom(createBomDTO: $dto) {
    id
    bomCode
  }
}
    `;
export type CreateBomMutationFn = Apollo.MutationFunction<CreateBomMutation, CreateBomMutationVariables>;

/**
 * __useCreateBomMutation__
 *
 * To run a mutation, you first call `useCreateBomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBomMutation, { data, loading, error }] = useCreateBomMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useCreateBomMutation(baseOptions?: Apollo.MutationHookOptions<CreateBomMutation, CreateBomMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBomMutation, CreateBomMutationVariables>(CreateBomDocument, options);
      }
export type CreateBomMutationHookResult = ReturnType<typeof useCreateBomMutation>;
export type CreateBomMutationResult = Apollo.MutationResult<CreateBomMutation>;
export type CreateBomMutationOptions = Apollo.BaseMutationOptions<CreateBomMutation, CreateBomMutationVariables>;
export const UpdateBomDocument = gql`
    mutation UpdateBom($dto: UpdateBomDTO!) {
  updateBom(updateBomDTO: $dto) {
    id
    bomName
    productionProcessType
    status
  }
}
    `;
export type UpdateBomMutationFn = Apollo.MutationFunction<UpdateBomMutation, UpdateBomMutationVariables>;

/**
 * __useUpdateBomMutation__
 *
 * To run a mutation, you first call `useUpdateBomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBomMutation, { data, loading, error }] = useUpdateBomMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useUpdateBomMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBomMutation, UpdateBomMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBomMutation, UpdateBomMutationVariables>(UpdateBomDocument, options);
      }
export type UpdateBomMutationHookResult = ReturnType<typeof useUpdateBomMutation>;
export type UpdateBomMutationResult = Apollo.MutationResult<UpdateBomMutation>;
export type UpdateBomMutationOptions = Apollo.BaseMutationOptions<UpdateBomMutation, UpdateBomMutationVariables>;
export const UpdateBomStatusDocument = gql`
    mutation UpdateBomStatus($id: String!, $status: BomStatus!) {
  updateBomStatus(id: $id, status: $status) {
    id
    status
  }
}
    `;
export type UpdateBomStatusMutationFn = Apollo.MutationFunction<UpdateBomStatusMutation, UpdateBomStatusMutationVariables>;

/**
 * __useUpdateBomStatusMutation__
 *
 * To run a mutation, you first call `useUpdateBomStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBomStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBomStatusMutation, { data, loading, error }] = useUpdateBomStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateBomStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBomStatusMutation, UpdateBomStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBomStatusMutation, UpdateBomStatusMutationVariables>(UpdateBomStatusDocument, options);
      }
export type UpdateBomStatusMutationHookResult = ReturnType<typeof useUpdateBomStatusMutation>;
export type UpdateBomStatusMutationResult = Apollo.MutationResult<UpdateBomStatusMutation>;
export type UpdateBomStatusMutationOptions = Apollo.BaseMutationOptions<UpdateBomStatusMutation, UpdateBomStatusMutationVariables>;
export const GetBomVersionsDocument = gql`
    query GetBomVersions($filter: [FilterGroup!], $page: Int, $limit: Int, $bomId: String) {
  getBomVersions(filter: $filter, page: $page, limit: $limit, bomId: $bomId) {
    meta {
      total
      page
      limit
    }
    data {
      id
      bomId
      versionNo
      versionLabel
      batchQuantity
      locationId
      approvalStatus
      lifecycleStatus
      effectiveFrom
      effectiveTo
      approvedBy
      approvedAt
      rejectedBy
      rejectedAt
    }
  }
}
    `;

/**
 * __useGetBomVersionsQuery__
 *
 * To run a query within a React component, call `useGetBomVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBomVersionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBomVersionsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      bomId: // value for 'bomId'
 *   },
 * });
 */
export function useGetBomVersionsQuery(baseOptions?: Apollo.QueryHookOptions<GetBomVersionsQuery, GetBomVersionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBomVersionsQuery, GetBomVersionsQueryVariables>(GetBomVersionsDocument, options);
      }
export function useGetBomVersionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBomVersionsQuery, GetBomVersionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBomVersionsQuery, GetBomVersionsQueryVariables>(GetBomVersionsDocument, options);
        }
// @ts-ignore
export function useGetBomVersionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBomVersionsQuery, GetBomVersionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetBomVersionsQuery, GetBomVersionsQueryVariables>;
export function useGetBomVersionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBomVersionsQuery, GetBomVersionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetBomVersionsQuery | undefined, GetBomVersionsQueryVariables>;
export function useGetBomVersionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBomVersionsQuery, GetBomVersionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBomVersionsQuery, GetBomVersionsQueryVariables>(GetBomVersionsDocument, options);
        }
export type GetBomVersionsQueryHookResult = ReturnType<typeof useGetBomVersionsQuery>;
export type GetBomVersionsLazyQueryHookResult = ReturnType<typeof useGetBomVersionsLazyQuery>;
export type GetBomVersionsSuspenseQueryHookResult = ReturnType<typeof useGetBomVersionsSuspenseQuery>;
export type GetBomVersionsQueryResult = Apollo.QueryResult<GetBomVersionsQuery, GetBomVersionsQueryVariables>;
export const GetBomVersionDocument = gql`
    query GetBomVersion($id: String!) {
  getBomVersion(id: $id) {
    id
    bomId
    bom {
      id
      bomCode
      bomName
      outputProduct {
        id
        name
        trackingLevel
      }
    }
    versionNo
    versionLabel
    batchQuantity
    approvalStatus
    lifecycleStatus
    effectiveFrom
    effectiveTo
    referenceVersionId
    rejectionReason
    submittedBy
    submittedAt
    approvedBy
    approvedAt
    rejectedBy
    rejectedAt
    activatedBy
    activatedAt
    lineItems {
      id
      lineNo
      componentProductId
      componentProduct {
        id
        name
        sellingUnit
      }
      consumableQuantity
      consumableQuantityPerUnit
      wastagePercentage
      isMandatory
      cost
      costPerUnit
    }
    location {
      id
      name
    }
    submittedByUser {
      firstName
      lastName
    }
    rejectedByUser {
      firstName
      lastName
    }
    approvedByUser {
      firstName
      lastName
    }
    activatedByUser {
      firstName
      lastName
    }
  }
}
    `;

/**
 * __useGetBomVersionQuery__
 *
 * To run a query within a React component, call `useGetBomVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBomVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBomVersionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBomVersionQuery(baseOptions: Apollo.QueryHookOptions<GetBomVersionQuery, GetBomVersionQueryVariables> & ({ variables: GetBomVersionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBomVersionQuery, GetBomVersionQueryVariables>(GetBomVersionDocument, options);
      }
export function useGetBomVersionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBomVersionQuery, GetBomVersionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBomVersionQuery, GetBomVersionQueryVariables>(GetBomVersionDocument, options);
        }
// @ts-ignore
export function useGetBomVersionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBomVersionQuery, GetBomVersionQueryVariables>): Apollo.UseSuspenseQueryResult<GetBomVersionQuery, GetBomVersionQueryVariables>;
export function useGetBomVersionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBomVersionQuery, GetBomVersionQueryVariables>): Apollo.UseSuspenseQueryResult<GetBomVersionQuery | undefined, GetBomVersionQueryVariables>;
export function useGetBomVersionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBomVersionQuery, GetBomVersionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBomVersionQuery, GetBomVersionQueryVariables>(GetBomVersionDocument, options);
        }
export type GetBomVersionQueryHookResult = ReturnType<typeof useGetBomVersionQuery>;
export type GetBomVersionLazyQueryHookResult = ReturnType<typeof useGetBomVersionLazyQuery>;
export type GetBomVersionSuspenseQueryHookResult = ReturnType<typeof useGetBomVersionSuspenseQuery>;
export type GetBomVersionQueryResult = Apollo.QueryResult<GetBomVersionQuery, GetBomVersionQueryVariables>;
export const CreateBomVersionDocument = gql`
    mutation CreateBomVersion($dto: CreateBomVersionDTO!) {
  createBomVersion(createBomVersionDTO: $dto) {
    id
    versionNo
  }
}
    `;
export type CreateBomVersionMutationFn = Apollo.MutationFunction<CreateBomVersionMutation, CreateBomVersionMutationVariables>;

/**
 * __useCreateBomVersionMutation__
 *
 * To run a mutation, you first call `useCreateBomVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBomVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBomVersionMutation, { data, loading, error }] = useCreateBomVersionMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useCreateBomVersionMutation(baseOptions?: Apollo.MutationHookOptions<CreateBomVersionMutation, CreateBomVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBomVersionMutation, CreateBomVersionMutationVariables>(CreateBomVersionDocument, options);
      }
export type CreateBomVersionMutationHookResult = ReturnType<typeof useCreateBomVersionMutation>;
export type CreateBomVersionMutationResult = Apollo.MutationResult<CreateBomVersionMutation>;
export type CreateBomVersionMutationOptions = Apollo.BaseMutationOptions<CreateBomVersionMutation, CreateBomVersionMutationVariables>;
export const UpdateBomVersionDocument = gql`
    mutation UpdateBomVersion($dto: UpdateBomVersionDTO!) {
  updateBomVersion(updateBomVersionDTO: $dto) {
    id
    versionLabel
    batchQuantity
    locationId
  }
}
    `;
export type UpdateBomVersionMutationFn = Apollo.MutationFunction<UpdateBomVersionMutation, UpdateBomVersionMutationVariables>;

/**
 * __useUpdateBomVersionMutation__
 *
 * To run a mutation, you first call `useUpdateBomVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBomVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBomVersionMutation, { data, loading, error }] = useUpdateBomVersionMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useUpdateBomVersionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBomVersionMutation, UpdateBomVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBomVersionMutation, UpdateBomVersionMutationVariables>(UpdateBomVersionDocument, options);
      }
export type UpdateBomVersionMutationHookResult = ReturnType<typeof useUpdateBomVersionMutation>;
export type UpdateBomVersionMutationResult = Apollo.MutationResult<UpdateBomVersionMutation>;
export type UpdateBomVersionMutationOptions = Apollo.BaseMutationOptions<UpdateBomVersionMutation, UpdateBomVersionMutationVariables>;
export const SubmitBomVersionForApprovalDocument = gql`
    mutation SubmitBomVersionForApproval($id: String!) {
  submitBomVersionForApproval(id: $id) {
    id
    approvalStatus
    submittedBy
    submittedAt
  }
}
    `;
export type SubmitBomVersionForApprovalMutationFn = Apollo.MutationFunction<SubmitBomVersionForApprovalMutation, SubmitBomVersionForApprovalMutationVariables>;

/**
 * __useSubmitBomVersionForApprovalMutation__
 *
 * To run a mutation, you first call `useSubmitBomVersionForApprovalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitBomVersionForApprovalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitBomVersionForApprovalMutation, { data, loading, error }] = useSubmitBomVersionForApprovalMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSubmitBomVersionForApprovalMutation(baseOptions?: Apollo.MutationHookOptions<SubmitBomVersionForApprovalMutation, SubmitBomVersionForApprovalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitBomVersionForApprovalMutation, SubmitBomVersionForApprovalMutationVariables>(SubmitBomVersionForApprovalDocument, options);
      }
export type SubmitBomVersionForApprovalMutationHookResult = ReturnType<typeof useSubmitBomVersionForApprovalMutation>;
export type SubmitBomVersionForApprovalMutationResult = Apollo.MutationResult<SubmitBomVersionForApprovalMutation>;
export type SubmitBomVersionForApprovalMutationOptions = Apollo.BaseMutationOptions<SubmitBomVersionForApprovalMutation, SubmitBomVersionForApprovalMutationVariables>;
export const ApproveBomVersionDocument = gql`
    mutation ApproveBomVersion($id: String!) {
  approveBomVersion(id: $id) {
    id
    approvalStatus
    approvedBy
    approvedAt
  }
}
    `;
export type ApproveBomVersionMutationFn = Apollo.MutationFunction<ApproveBomVersionMutation, ApproveBomVersionMutationVariables>;

/**
 * __useApproveBomVersionMutation__
 *
 * To run a mutation, you first call `useApproveBomVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveBomVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveBomVersionMutation, { data, loading, error }] = useApproveBomVersionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApproveBomVersionMutation(baseOptions?: Apollo.MutationHookOptions<ApproveBomVersionMutation, ApproveBomVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveBomVersionMutation, ApproveBomVersionMutationVariables>(ApproveBomVersionDocument, options);
      }
export type ApproveBomVersionMutationHookResult = ReturnType<typeof useApproveBomVersionMutation>;
export type ApproveBomVersionMutationResult = Apollo.MutationResult<ApproveBomVersionMutation>;
export type ApproveBomVersionMutationOptions = Apollo.BaseMutationOptions<ApproveBomVersionMutation, ApproveBomVersionMutationVariables>;
export const RejectBomVersionDocument = gql`
    mutation RejectBomVersion($id: String!, $rejectionReason: String!) {
  rejectBomVersion(id: $id, rejectionReason: $rejectionReason) {
    id
    approvalStatus
    rejectionReason
  }
}
    `;
export type RejectBomVersionMutationFn = Apollo.MutationFunction<RejectBomVersionMutation, RejectBomVersionMutationVariables>;

/**
 * __useRejectBomVersionMutation__
 *
 * To run a mutation, you first call `useRejectBomVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectBomVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectBomVersionMutation, { data, loading, error }] = useRejectBomVersionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      rejectionReason: // value for 'rejectionReason'
 *   },
 * });
 */
export function useRejectBomVersionMutation(baseOptions?: Apollo.MutationHookOptions<RejectBomVersionMutation, RejectBomVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectBomVersionMutation, RejectBomVersionMutationVariables>(RejectBomVersionDocument, options);
      }
export type RejectBomVersionMutationHookResult = ReturnType<typeof useRejectBomVersionMutation>;
export type RejectBomVersionMutationResult = Apollo.MutationResult<RejectBomVersionMutation>;
export type RejectBomVersionMutationOptions = Apollo.BaseMutationOptions<RejectBomVersionMutation, RejectBomVersionMutationVariables>;
export const ActivateBomVersionDocument = gql`
    mutation ActivateBomVersion($id: String!, $effectiveFrom: Date, $effectiveTo: Date) {
  activateBomVersion(
    id: $id
    effectiveFrom: $effectiveFrom
    effectiveTo: $effectiveTo
  ) {
    id
    lifecycleStatus
    activatedBy
    activatedAt
    effectiveFrom
    effectiveTo
  }
}
    `;
export type ActivateBomVersionMutationFn = Apollo.MutationFunction<ActivateBomVersionMutation, ActivateBomVersionMutationVariables>;

/**
 * __useActivateBomVersionMutation__
 *
 * To run a mutation, you first call `useActivateBomVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateBomVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateBomVersionMutation, { data, loading, error }] = useActivateBomVersionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      effectiveFrom: // value for 'effectiveFrom'
 *      effectiveTo: // value for 'effectiveTo'
 *   },
 * });
 */
export function useActivateBomVersionMutation(baseOptions?: Apollo.MutationHookOptions<ActivateBomVersionMutation, ActivateBomVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateBomVersionMutation, ActivateBomVersionMutationVariables>(ActivateBomVersionDocument, options);
      }
export type ActivateBomVersionMutationHookResult = ReturnType<typeof useActivateBomVersionMutation>;
export type ActivateBomVersionMutationResult = Apollo.MutationResult<ActivateBomVersionMutation>;
export type ActivateBomVersionMutationOptions = Apollo.BaseMutationOptions<ActivateBomVersionMutation, ActivateBomVersionMutationVariables>;
export const ArchiveBomVersionDocument = gql`
    mutation ArchiveBomVersion($id: String!) {
  archiveBomVersion(id: $id) {
    id
    lifecycleStatus
  }
}
    `;
export type ArchiveBomVersionMutationFn = Apollo.MutationFunction<ArchiveBomVersionMutation, ArchiveBomVersionMutationVariables>;

/**
 * __useArchiveBomVersionMutation__
 *
 * To run a mutation, you first call `useArchiveBomVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveBomVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveBomVersionMutation, { data, loading, error }] = useArchiveBomVersionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveBomVersionMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveBomVersionMutation, ArchiveBomVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveBomVersionMutation, ArchiveBomVersionMutationVariables>(ArchiveBomVersionDocument, options);
      }
export type ArchiveBomVersionMutationHookResult = ReturnType<typeof useArchiveBomVersionMutation>;
export type ArchiveBomVersionMutationResult = Apollo.MutationResult<ArchiveBomVersionMutation>;
export type ArchiveBomVersionMutationOptions = Apollo.BaseMutationOptions<ArchiveBomVersionMutation, ArchiveBomVersionMutationVariables>;
export const CreateBomVersionLineItemDocument = gql`
    mutation CreateBomVersionLineItem($dto: CreateBomVersionLineItemDTO!) {
  createBomVersionLineItem(createBomVersionLineItemDTO: $dto) {
    id
  }
}
    `;
export type CreateBomVersionLineItemMutationFn = Apollo.MutationFunction<CreateBomVersionLineItemMutation, CreateBomVersionLineItemMutationVariables>;

/**
 * __useCreateBomVersionLineItemMutation__
 *
 * To run a mutation, you first call `useCreateBomVersionLineItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBomVersionLineItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBomVersionLineItemMutation, { data, loading, error }] = useCreateBomVersionLineItemMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useCreateBomVersionLineItemMutation(baseOptions?: Apollo.MutationHookOptions<CreateBomVersionLineItemMutation, CreateBomVersionLineItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBomVersionLineItemMutation, CreateBomVersionLineItemMutationVariables>(CreateBomVersionLineItemDocument, options);
      }
export type CreateBomVersionLineItemMutationHookResult = ReturnType<typeof useCreateBomVersionLineItemMutation>;
export type CreateBomVersionLineItemMutationResult = Apollo.MutationResult<CreateBomVersionLineItemMutation>;
export type CreateBomVersionLineItemMutationOptions = Apollo.BaseMutationOptions<CreateBomVersionLineItemMutation, CreateBomVersionLineItemMutationVariables>;
export const UpdateBomVersionLineItemDocument = gql`
    mutation UpdateBomVersionLineItem($dto: UpdateBomVersionLineItemDTO!) {
  updateBomVersionLineItem(updateBomVersionLineItemDTO: $dto) {
    id
  }
}
    `;
export type UpdateBomVersionLineItemMutationFn = Apollo.MutationFunction<UpdateBomVersionLineItemMutation, UpdateBomVersionLineItemMutationVariables>;

/**
 * __useUpdateBomVersionLineItemMutation__
 *
 * To run a mutation, you first call `useUpdateBomVersionLineItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBomVersionLineItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBomVersionLineItemMutation, { data, loading, error }] = useUpdateBomVersionLineItemMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useUpdateBomVersionLineItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBomVersionLineItemMutation, UpdateBomVersionLineItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBomVersionLineItemMutation, UpdateBomVersionLineItemMutationVariables>(UpdateBomVersionLineItemDocument, options);
      }
export type UpdateBomVersionLineItemMutationHookResult = ReturnType<typeof useUpdateBomVersionLineItemMutation>;
export type UpdateBomVersionLineItemMutationResult = Apollo.MutationResult<UpdateBomVersionLineItemMutation>;
export type UpdateBomVersionLineItemMutationOptions = Apollo.BaseMutationOptions<UpdateBomVersionLineItemMutation, UpdateBomVersionLineItemMutationVariables>;
export const DeleteBomVersionLineItemDocument = gql`
    mutation DeleteBomVersionLineItem($id: String!) {
  deleteBomVersionLineItem(id: $id)
}
    `;
export type DeleteBomVersionLineItemMutationFn = Apollo.MutationFunction<DeleteBomVersionLineItemMutation, DeleteBomVersionLineItemMutationVariables>;

/**
 * __useDeleteBomVersionLineItemMutation__
 *
 * To run a mutation, you first call `useDeleteBomVersionLineItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBomVersionLineItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBomVersionLineItemMutation, { data, loading, error }] = useDeleteBomVersionLineItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBomVersionLineItemMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBomVersionLineItemMutation, DeleteBomVersionLineItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBomVersionLineItemMutation, DeleteBomVersionLineItemMutationVariables>(DeleteBomVersionLineItemDocument, options);
      }
export type DeleteBomVersionLineItemMutationHookResult = ReturnType<typeof useDeleteBomVersionLineItemMutation>;
export type DeleteBomVersionLineItemMutationResult = Apollo.MutationResult<DeleteBomVersionLineItemMutation>;
export type DeleteBomVersionLineItemMutationOptions = Apollo.BaseMutationOptions<DeleteBomVersionLineItemMutation, DeleteBomVersionLineItemMutationVariables>;
export const BulkUploadProductsDocument = gql`
    mutation BulkUploadProducts($input: BulkUploadProductDTO!) {
  bulkUploadProducts(input: $input) {
    successCount
    createdProductIds
    errors {
      row
      message
    }
  }
}
    `;
export type BulkUploadProductsMutationFn = Apollo.MutationFunction<BulkUploadProductsMutation, BulkUploadProductsMutationVariables>;

/**
 * __useBulkUploadProductsMutation__
 *
 * To run a mutation, you first call `useBulkUploadProductsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUploadProductsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUploadProductsMutation, { data, loading, error }] = useBulkUploadProductsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkUploadProductsMutation(baseOptions?: Apollo.MutationHookOptions<BulkUploadProductsMutation, BulkUploadProductsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUploadProductsMutation, BulkUploadProductsMutationVariables>(BulkUploadProductsDocument, options);
      }
export type BulkUploadProductsMutationHookResult = ReturnType<typeof useBulkUploadProductsMutation>;
export type BulkUploadProductsMutationResult = Apollo.MutationResult<BulkUploadProductsMutation>;
export type BulkUploadProductsMutationOptions = Apollo.BaseMutationOptions<BulkUploadProductsMutation, BulkUploadProductsMutationVariables>;
export const CalculateCartSummaryDocument = gql`
    query CalculateCartSummary($order: ApplyDiscountDto!, $discountCode: String) {
  calculateCartSummary(order: $order, discountCode: $discountCode) {
    deliveryCharges
    platformFee
    posFees
    subtotal
    tax
    total
    totalDiscount
    products {
      discount
      discountTitle
      id
      secondaryId
      subTotal
      tax
      title
      total
    }
    integrationCharges
    platformFees {
      id
      name
      isRemovable
      amount
    }
    integrations {
      type
      name
    }
    discounts {
      title
      amount
    }
  }
}
    `;

/**
 * __useCalculateCartSummaryQuery__
 *
 * To run a query within a React component, call `useCalculateCartSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalculateCartSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalculateCartSummaryQuery({
 *   variables: {
 *      order: // value for 'order'
 *      discountCode: // value for 'discountCode'
 *   },
 * });
 */
export function useCalculateCartSummaryQuery(baseOptions: Apollo.QueryHookOptions<CalculateCartSummaryQuery, CalculateCartSummaryQueryVariables> & ({ variables: CalculateCartSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalculateCartSummaryQuery, CalculateCartSummaryQueryVariables>(CalculateCartSummaryDocument, options);
      }
export function useCalculateCartSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalculateCartSummaryQuery, CalculateCartSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalculateCartSummaryQuery, CalculateCartSummaryQueryVariables>(CalculateCartSummaryDocument, options);
        }
// @ts-ignore
export function useCalculateCartSummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CalculateCartSummaryQuery, CalculateCartSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<CalculateCartSummaryQuery, CalculateCartSummaryQueryVariables>;
export function useCalculateCartSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CalculateCartSummaryQuery, CalculateCartSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<CalculateCartSummaryQuery | undefined, CalculateCartSummaryQueryVariables>;
export function useCalculateCartSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CalculateCartSummaryQuery, CalculateCartSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CalculateCartSummaryQuery, CalculateCartSummaryQueryVariables>(CalculateCartSummaryDocument, options);
        }
export type CalculateCartSummaryQueryHookResult = ReturnType<typeof useCalculateCartSummaryQuery>;
export type CalculateCartSummaryLazyQueryHookResult = ReturnType<typeof useCalculateCartSummaryLazyQuery>;
export type CalculateCartSummarySuspenseQueryHookResult = ReturnType<typeof useCalculateCartSummarySuspenseQuery>;
export type CalculateCartSummaryQueryResult = Apollo.QueryResult<CalculateCartSummaryQuery, CalculateCartSummaryQueryVariables>;
export const CreateCategoryDocument = gql`
    mutation CreateCategory($createCategoryDto: CreateCategoryDTO!) {
  createCategory(createCategoryDTO: $createCategoryDto) {
    categoryIcon
    comment
    description
    id
    imageUrl
    level
    name
    parentId
    status
  }
}
    `;
export type CreateCategoryMutationFn = Apollo.MutationFunction<CreateCategoryMutation, CreateCategoryMutationVariables>;

/**
 * __useCreateCategoryMutation__
 *
 * To run a mutation, you first call `useCreateCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCategoryMutation, { data, loading, error }] = useCreateCategoryMutation({
 *   variables: {
 *      createCategoryDto: // value for 'createCategoryDto'
 *   },
 * });
 */
export function useCreateCategoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateCategoryMutation, CreateCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCategoryMutation, CreateCategoryMutationVariables>(CreateCategoryDocument, options);
      }
export type CreateCategoryMutationHookResult = ReturnType<typeof useCreateCategoryMutation>;
export type CreateCategoryMutationResult = Apollo.MutationResult<CreateCategoryMutation>;
export type CreateCategoryMutationOptions = Apollo.BaseMutationOptions<CreateCategoryMutation, CreateCategoryMutationVariables>;
export const UpdateCategoryDocument = gql`
    mutation UpdateCategory($updateCategoryDto: UpdateCategoryDTO!) {
  updateCategory(updateCategoryDTO: $updateCategoryDto) {
    categoryIcon
    comment
    description
    id
    imageUrl
    level
    name
    parentId
    status
  }
}
    `;
export type UpdateCategoryMutationFn = Apollo.MutationFunction<UpdateCategoryMutation, UpdateCategoryMutationVariables>;

/**
 * __useUpdateCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCategoryMutation, { data, loading, error }] = useUpdateCategoryMutation({
 *   variables: {
 *      updateCategoryDto: // value for 'updateCategoryDto'
 *   },
 * });
 */
export function useUpdateCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCategoryMutation, UpdateCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCategoryMutation, UpdateCategoryMutationVariables>(UpdateCategoryDocument, options);
      }
export type UpdateCategoryMutationHookResult = ReturnType<typeof useUpdateCategoryMutation>;
export type UpdateCategoryMutationResult = Apollo.MutationResult<UpdateCategoryMutation>;
export type UpdateCategoryMutationOptions = Apollo.BaseMutationOptions<UpdateCategoryMutation, UpdateCategoryMutationVariables>;
export const GetCategoryDocument = gql`
    query GetCategory($getCategoryId: String!) {
  getCategory(id: $getCategoryId) {
    categoryIcon
    comment
    description
    id
    imageUrl
    level
    name
    parentId
    status
  }
}
    `;

/**
 * __useGetCategoryQuery__
 *
 * To run a query within a React component, call `useGetCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoryQuery({
 *   variables: {
 *      getCategoryId: // value for 'getCategoryId'
 *   },
 * });
 */
export function useGetCategoryQuery(baseOptions: Apollo.QueryHookOptions<GetCategoryQuery, GetCategoryQueryVariables> & ({ variables: GetCategoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoryQuery, GetCategoryQueryVariables>(GetCategoryDocument, options);
      }
export function useGetCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoryQuery, GetCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoryQuery, GetCategoryQueryVariables>(GetCategoryDocument, options);
        }
// @ts-ignore
export function useGetCategorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCategoryQuery, GetCategoryQueryVariables>): Apollo.UseSuspenseQueryResult<GetCategoryQuery, GetCategoryQueryVariables>;
export function useGetCategorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCategoryQuery, GetCategoryQueryVariables>): Apollo.UseSuspenseQueryResult<GetCategoryQuery | undefined, GetCategoryQueryVariables>;
export function useGetCategorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCategoryQuery, GetCategoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCategoryQuery, GetCategoryQueryVariables>(GetCategoryDocument, options);
        }
export type GetCategoryQueryHookResult = ReturnType<typeof useGetCategoryQuery>;
export type GetCategoryLazyQueryHookResult = ReturnType<typeof useGetCategoryLazyQuery>;
export type GetCategorySuspenseQueryHookResult = ReturnType<typeof useGetCategorySuspenseQuery>;
export type GetCategoryQueryResult = Apollo.QueryResult<GetCategoryQuery, GetCategoryQueryVariables>;
export const GetCategoriesDocument = gql`
    query GetCategories($sort: [SortCondition!], $page: Int!, $limit: Int!, $filter: [FilterGroup!]) {
  getCategories(sort: $sort, page: $page, limit: $limit, filter: $filter) {
    data {
      id
      secondaryId
      categoryIcon
      comment
      description
      imageUrl
      level
      name
      parentCategory {
        id
        name
      }
      parentId
      status
    }
    meta {
      limit
      page
      totalCount
    }
  }
}
    `;

/**
 * __useGetCategoriesQuery__
 *
 * To run a query within a React component, call `useGetCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoriesQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetCategoriesQuery(baseOptions: Apollo.QueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables> & ({ variables: GetCategoriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
      }
export function useGetCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
        }
// @ts-ignore
export function useGetCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCategoriesQuery, GetCategoriesQueryVariables>;
export function useGetCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCategoriesQuery | undefined, GetCategoriesQueryVariables>;
export function useGetCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
        }
export type GetCategoriesQueryHookResult = ReturnType<typeof useGetCategoriesQuery>;
export type GetCategoriesLazyQueryHookResult = ReturnType<typeof useGetCategoriesLazyQuery>;
export type GetCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetCategoriesSuspenseQuery>;
export type GetCategoriesQueryResult = Apollo.QueryResult<GetCategoriesQuery, GetCategoriesQueryVariables>;
export const GetCategoriesForOptionsDocument = gql`
    query GetCategoriesForOptions($sort: [SortCondition!], $page: Int!, $limit: Int!, $filter: [FilterGroup!]) {
  getCategories(sort: $sort, page: $page, limit: $limit, filter: $filter) {
    data {
      id
      level
      name
      parentId
      status
    }
    meta {
      limit
      page
      totalCount
    }
  }
}
    `;

/**
 * __useGetCategoriesForOptionsQuery__
 *
 * To run a query within a React component, call `useGetCategoriesForOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoriesForOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoriesForOptionsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetCategoriesForOptionsQuery(baseOptions: Apollo.QueryHookOptions<GetCategoriesForOptionsQuery, GetCategoriesForOptionsQueryVariables> & ({ variables: GetCategoriesForOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoriesForOptionsQuery, GetCategoriesForOptionsQueryVariables>(GetCategoriesForOptionsDocument, options);
      }
export function useGetCategoriesForOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoriesForOptionsQuery, GetCategoriesForOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoriesForOptionsQuery, GetCategoriesForOptionsQueryVariables>(GetCategoriesForOptionsDocument, options);
        }
// @ts-ignore
export function useGetCategoriesForOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCategoriesForOptionsQuery, GetCategoriesForOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCategoriesForOptionsQuery, GetCategoriesForOptionsQueryVariables>;
export function useGetCategoriesForOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCategoriesForOptionsQuery, GetCategoriesForOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCategoriesForOptionsQuery | undefined, GetCategoriesForOptionsQueryVariables>;
export function useGetCategoriesForOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCategoriesForOptionsQuery, GetCategoriesForOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCategoriesForOptionsQuery, GetCategoriesForOptionsQueryVariables>(GetCategoriesForOptionsDocument, options);
        }
export type GetCategoriesForOptionsQueryHookResult = ReturnType<typeof useGetCategoriesForOptionsQuery>;
export type GetCategoriesForOptionsLazyQueryHookResult = ReturnType<typeof useGetCategoriesForOptionsLazyQuery>;
export type GetCategoriesForOptionsSuspenseQueryHookResult = ReturnType<typeof useGetCategoriesForOptionsSuspenseQuery>;
export type GetCategoriesForOptionsQueryResult = Apollo.QueryResult<GetCategoriesForOptionsQuery, GetCategoriesForOptionsQueryVariables>;
export const GetCategoryLevelDocument = gql`
    query GetCategoryLevel {
  getCategoryLevel {
    current
    max
  }
}
    `;

/**
 * __useGetCategoryLevelQuery__
 *
 * To run a query within a React component, call `useGetCategoryLevelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoryLevelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoryLevelQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCategoryLevelQuery(baseOptions?: Apollo.QueryHookOptions<GetCategoryLevelQuery, GetCategoryLevelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoryLevelQuery, GetCategoryLevelQueryVariables>(GetCategoryLevelDocument, options);
      }
export function useGetCategoryLevelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoryLevelQuery, GetCategoryLevelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoryLevelQuery, GetCategoryLevelQueryVariables>(GetCategoryLevelDocument, options);
        }
// @ts-ignore
export function useGetCategoryLevelSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCategoryLevelQuery, GetCategoryLevelQueryVariables>): Apollo.UseSuspenseQueryResult<GetCategoryLevelQuery, GetCategoryLevelQueryVariables>;
export function useGetCategoryLevelSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCategoryLevelQuery, GetCategoryLevelQueryVariables>): Apollo.UseSuspenseQueryResult<GetCategoryLevelQuery | undefined, GetCategoryLevelQueryVariables>;
export function useGetCategoryLevelSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCategoryLevelQuery, GetCategoryLevelQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCategoryLevelQuery, GetCategoryLevelQueryVariables>(GetCategoryLevelDocument, options);
        }
export type GetCategoryLevelQueryHookResult = ReturnType<typeof useGetCategoryLevelQuery>;
export type GetCategoryLevelLazyQueryHookResult = ReturnType<typeof useGetCategoryLevelLazyQuery>;
export type GetCategoryLevelSuspenseQueryHookResult = ReturnType<typeof useGetCategoryLevelSuspenseQuery>;
export type GetCategoryLevelQueryResult = Apollo.QueryResult<GetCategoryLevelQuery, GetCategoryLevelQueryVariables>;
export const GetCustomersForDiscountDocument = gql`
    query GetCustomersForDiscount($page: Int!, $sort: [SortCondition!], $locationId: String, $limit: Int!, $filter: [FilterGroup!]) {
  getCustomers(
    page: $page
    sort: $sort
    locationId: $locationId
    limit: $limit
    filter: $filter
  ) {
    data {
      id
      email
      name
    }
    meta {
      limit
      page
      totalCount
    }
  }
}
    `;

/**
 * __useGetCustomersForDiscountQuery__
 *
 * To run a query within a React component, call `useGetCustomersForDiscountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomersForDiscountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomersForDiscountQuery({
 *   variables: {
 *      page: // value for 'page'
 *      sort: // value for 'sort'
 *      locationId: // value for 'locationId'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetCustomersForDiscountQuery(baseOptions: Apollo.QueryHookOptions<GetCustomersForDiscountQuery, GetCustomersForDiscountQueryVariables> & ({ variables: GetCustomersForDiscountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomersForDiscountQuery, GetCustomersForDiscountQueryVariables>(GetCustomersForDiscountDocument, options);
      }
export function useGetCustomersForDiscountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomersForDiscountQuery, GetCustomersForDiscountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomersForDiscountQuery, GetCustomersForDiscountQueryVariables>(GetCustomersForDiscountDocument, options);
        }
// @ts-ignore
export function useGetCustomersForDiscountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomersForDiscountQuery, GetCustomersForDiscountQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomersForDiscountQuery, GetCustomersForDiscountQueryVariables>;
export function useGetCustomersForDiscountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomersForDiscountQuery, GetCustomersForDiscountQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomersForDiscountQuery | undefined, GetCustomersForDiscountQueryVariables>;
export function useGetCustomersForDiscountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomersForDiscountQuery, GetCustomersForDiscountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomersForDiscountQuery, GetCustomersForDiscountQueryVariables>(GetCustomersForDiscountDocument, options);
        }
export type GetCustomersForDiscountQueryHookResult = ReturnType<typeof useGetCustomersForDiscountQuery>;
export type GetCustomersForDiscountLazyQueryHookResult = ReturnType<typeof useGetCustomersForDiscountLazyQuery>;
export type GetCustomersForDiscountSuspenseQueryHookResult = ReturnType<typeof useGetCustomersForDiscountSuspenseQuery>;
export type GetCustomersForDiscountQueryResult = Apollo.QueryResult<GetCustomersForDiscountQuery, GetCustomersForDiscountQueryVariables>;
export const GetCustomersListDocument = gql`
    query GetCustomersList($limit: Int!, $locationId: String, $page: Int!, $filter: [FilterGroup!], $sort: [SortCondition!]) {
  getCustomers(
    limit: $limit
    locationId: $locationId
    page: $page
    filter: $filter
    sort: $sort
  ) {
    data {
      additionalNumber
      secondaryId
      name
      id
      phoneNumber
      gender
      createdAt
      partner {
        name
        id
      }
    }
    meta {
      limit
      page
      totalCount
    }
  }
}
    `;

/**
 * __useGetCustomersListQuery__
 *
 * To run a query within a React component, call `useGetCustomersListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomersListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomersListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      locationId: // value for 'locationId'
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetCustomersListQuery(baseOptions: Apollo.QueryHookOptions<GetCustomersListQuery, GetCustomersListQueryVariables> & ({ variables: GetCustomersListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomersListQuery, GetCustomersListQueryVariables>(GetCustomersListDocument, options);
      }
export function useGetCustomersListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomersListQuery, GetCustomersListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomersListQuery, GetCustomersListQueryVariables>(GetCustomersListDocument, options);
        }
// @ts-ignore
export function useGetCustomersListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomersListQuery, GetCustomersListQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomersListQuery, GetCustomersListQueryVariables>;
export function useGetCustomersListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomersListQuery, GetCustomersListQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomersListQuery | undefined, GetCustomersListQueryVariables>;
export function useGetCustomersListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomersListQuery, GetCustomersListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomersListQuery, GetCustomersListQueryVariables>(GetCustomersListDocument, options);
        }
export type GetCustomersListQueryHookResult = ReturnType<typeof useGetCustomersListQuery>;
export type GetCustomersListLazyQueryHookResult = ReturnType<typeof useGetCustomersListLazyQuery>;
export type GetCustomersListSuspenseQueryHookResult = ReturnType<typeof useGetCustomersListSuspenseQuery>;
export type GetCustomersListQueryResult = Apollo.QueryResult<GetCustomersListQuery, GetCustomersListQueryVariables>;
export const GetCustomersListForOptionsDocument = gql`
    query GetCustomersListForOptions($limit: Int!, $locationId: String, $page: Int!, $filter: [FilterGroup!], $sort: [SortCondition!]) {
  getCustomers(
    limit: $limit
    locationId: $locationId
    page: $page
    filter: $filter
    sort: $sort
  ) {
    data {
      secondaryId
      name
      id
      phoneNumber
      gender
    }
  }
}
    `;

/**
 * __useGetCustomersListForOptionsQuery__
 *
 * To run a query within a React component, call `useGetCustomersListForOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomersListForOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomersListForOptionsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      locationId: // value for 'locationId'
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetCustomersListForOptionsQuery(baseOptions: Apollo.QueryHookOptions<GetCustomersListForOptionsQuery, GetCustomersListForOptionsQueryVariables> & ({ variables: GetCustomersListForOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomersListForOptionsQuery, GetCustomersListForOptionsQueryVariables>(GetCustomersListForOptionsDocument, options);
      }
export function useGetCustomersListForOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomersListForOptionsQuery, GetCustomersListForOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomersListForOptionsQuery, GetCustomersListForOptionsQueryVariables>(GetCustomersListForOptionsDocument, options);
        }
// @ts-ignore
export function useGetCustomersListForOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomersListForOptionsQuery, GetCustomersListForOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomersListForOptionsQuery, GetCustomersListForOptionsQueryVariables>;
export function useGetCustomersListForOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomersListForOptionsQuery, GetCustomersListForOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomersListForOptionsQuery | undefined, GetCustomersListForOptionsQueryVariables>;
export function useGetCustomersListForOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomersListForOptionsQuery, GetCustomersListForOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomersListForOptionsQuery, GetCustomersListForOptionsQueryVariables>(GetCustomersListForOptionsDocument, options);
        }
export type GetCustomersListForOptionsQueryHookResult = ReturnType<typeof useGetCustomersListForOptionsQuery>;
export type GetCustomersListForOptionsLazyQueryHookResult = ReturnType<typeof useGetCustomersListForOptionsLazyQuery>;
export type GetCustomersListForOptionsSuspenseQueryHookResult = ReturnType<typeof useGetCustomersListForOptionsSuspenseQuery>;
export type GetCustomersListForOptionsQueryResult = Apollo.QueryResult<GetCustomersListForOptionsQuery, GetCustomersListForOptionsQueryVariables>;
export const CreateAddressDocument = gql`
    mutation CreateAddress($createAddressDto: CreateAddressDTO!) {
  createAddress(createAddressDTO: $createAddressDto) {
    id
  }
}
    `;
export type CreateAddressMutationFn = Apollo.MutationFunction<CreateAddressMutation, CreateAddressMutationVariables>;

/**
 * __useCreateAddressMutation__
 *
 * To run a mutation, you first call `useCreateAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAddressMutation, { data, loading, error }] = useCreateAddressMutation({
 *   variables: {
 *      createAddressDto: // value for 'createAddressDto'
 *   },
 * });
 */
export function useCreateAddressMutation(baseOptions?: Apollo.MutationHookOptions<CreateAddressMutation, CreateAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAddressMutation, CreateAddressMutationVariables>(CreateAddressDocument, options);
      }
export type CreateAddressMutationHookResult = ReturnType<typeof useCreateAddressMutation>;
export type CreateAddressMutationResult = Apollo.MutationResult<CreateAddressMutation>;
export type CreateAddressMutationOptions = Apollo.BaseMutationOptions<CreateAddressMutation, CreateAddressMutationVariables>;
export const UpdateAddressDocument = gql`
    mutation UpdateAddress($updateAddressDto: UpdateAddressDTO!) {
  updateAddress(updateAddressDTO: $updateAddressDto) {
    id
  }
}
    `;
export type UpdateAddressMutationFn = Apollo.MutationFunction<UpdateAddressMutation, UpdateAddressMutationVariables>;

/**
 * __useUpdateAddressMutation__
 *
 * To run a mutation, you first call `useUpdateAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAddressMutation, { data, loading, error }] = useUpdateAddressMutation({
 *   variables: {
 *      updateAddressDto: // value for 'updateAddressDto'
 *   },
 * });
 */
export function useUpdateAddressMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAddressMutation, UpdateAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAddressMutation, UpdateAddressMutationVariables>(UpdateAddressDocument, options);
      }
export type UpdateAddressMutationHookResult = ReturnType<typeof useUpdateAddressMutation>;
export type UpdateAddressMutationResult = Apollo.MutationResult<UpdateAddressMutation>;
export type UpdateAddressMutationOptions = Apollo.BaseMutationOptions<UpdateAddressMutation, UpdateAddressMutationVariables>;
export const GetCustomerDocument = gql`
    query GetCustomer($phoneNumber: String, $getCustomerId: String, $email: String) {
  getCustomer(phoneNumber: $phoneNumber, id: $getCustomerId, email: $email) {
    secondaryId
    id
    phoneNumber
    name
    gender
    birthday
    commercialRegisterNumber
    nationalId
    notes
    partner {
      id
      name
    }
    addresses {
      id
      postalCode
      secondaryId
      city {
        name
        id
        country {
          name
          id
        }
      }
      streetName
      buildingNo
      districtName
      customerId
      additionalNumber
      streetAddress2
      streetAddress1
      state
      landmark
      cityId
    }
  }
}
    `;

/**
 * __useGetCustomerQuery__
 *
 * To run a query within a React component, call `useGetCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerQuery({
 *   variables: {
 *      phoneNumber: // value for 'phoneNumber'
 *      getCustomerId: // value for 'getCustomerId'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useGetCustomerQuery(baseOptions?: Apollo.QueryHookOptions<GetCustomerQuery, GetCustomerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerQuery, GetCustomerQueryVariables>(GetCustomerDocument, options);
      }
export function useGetCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerQuery, GetCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerQuery, GetCustomerQueryVariables>(GetCustomerDocument, options);
        }
// @ts-ignore
export function useGetCustomerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomerQuery, GetCustomerQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomerQuery, GetCustomerQueryVariables>;
export function useGetCustomerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomerQuery, GetCustomerQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomerQuery | undefined, GetCustomerQueryVariables>;
export function useGetCustomerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomerQuery, GetCustomerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomerQuery, GetCustomerQueryVariables>(GetCustomerDocument, options);
        }
export type GetCustomerQueryHookResult = ReturnType<typeof useGetCustomerQuery>;
export type GetCustomerLazyQueryHookResult = ReturnType<typeof useGetCustomerLazyQuery>;
export type GetCustomerSuspenseQueryHookResult = ReturnType<typeof useGetCustomerSuspenseQuery>;
export type GetCustomerQueryResult = Apollo.QueryResult<GetCustomerQuery, GetCustomerQueryVariables>;
export const UpdateCustomerDocument = gql`
    mutation UpdateCustomer($updateCustomerDto: UpdateCustomerDTO!) {
  updateCustomer(updateCustomerDTO: $updateCustomerDto) {
    id
  }
}
    `;
export type UpdateCustomerMutationFn = Apollo.MutationFunction<UpdateCustomerMutation, UpdateCustomerMutationVariables>;

/**
 * __useUpdateCustomerMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerMutation, { data, loading, error }] = useUpdateCustomerMutation({
 *   variables: {
 *      updateCustomerDto: // value for 'updateCustomerDto'
 *   },
 * });
 */
export function useUpdateCustomerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomerMutation, UpdateCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomerMutation, UpdateCustomerMutationVariables>(UpdateCustomerDocument, options);
      }
export type UpdateCustomerMutationHookResult = ReturnType<typeof useUpdateCustomerMutation>;
export type UpdateCustomerMutationResult = Apollo.MutationResult<UpdateCustomerMutation>;
export type UpdateCustomerMutationOptions = Apollo.BaseMutationOptions<UpdateCustomerMutation, UpdateCustomerMutationVariables>;
export const CreateCustomerDocument = gql`
    mutation CreateCustomer($createCustomerDTO: CreateCustomerDTO!) {
  createCustomer(createCustomerDTO: $createCustomerDTO) {
    id
  }
}
    `;
export type CreateCustomerMutationFn = Apollo.MutationFunction<CreateCustomerMutation, CreateCustomerMutationVariables>;

/**
 * __useCreateCustomerMutation__
 *
 * To run a mutation, you first call `useCreateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerMutation, { data, loading, error }] = useCreateCustomerMutation({
 *   variables: {
 *      createCustomerDTO: // value for 'createCustomerDTO'
 *   },
 * });
 */
export function useCreateCustomerMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomerMutation, CreateCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomerMutation, CreateCustomerMutationVariables>(CreateCustomerDocument, options);
      }
export type CreateCustomerMutationHookResult = ReturnType<typeof useCreateCustomerMutation>;
export type CreateCustomerMutationResult = Apollo.MutationResult<CreateCustomerMutation>;
export type CreateCustomerMutationOptions = Apollo.BaseMutationOptions<CreateCustomerMutation, CreateCustomerMutationVariables>;
export const DashboardOverviewDocument = gql`
    query DashboardOverview($filter: AnalyticsFilterInput!) {
  salesOverview(filter: $filter) {
    netSales
    grossSales
    totalOrders
    avgOrderValue
    totalReturnAmount
    returnedOrders
    totalDiscount
    totalTax
    totalPlatformFee
    totalDeliveryCharges
    totalIntegrationCharges
    netSalesComparison {
      current
      previous
      changePercent
    }
    grossSalesComparison {
      current
      previous
      changePercent
    }
    totalOrdersComparison {
      current
      previous
      changePercent
    }
    avgOrderValueComparison {
      current
      previous
      changePercent
    }
    totalReturnAmountComparison {
      current
      previous
      changePercent
    }
    returnedOrdersComparison {
      current
      previous
      changePercent
    }
    totalDiscountComparison {
      current
      previous
      changePercent
    }
    totalTaxComparison {
      current
      previous
      changePercent
    }
    totalPlatformFeeComparison {
      current
      previous
      changePercent
    }
    totalDeliveryChargesComparison {
      current
      previous
      changePercent
    }
    totalIntegrationChargesComparison {
      current
      previous
      changePercent
    }
  }
}
    `;

/**
 * __useDashboardOverviewQuery__
 *
 * To run a query within a React component, call `useDashboardOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardOverviewQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDashboardOverviewQuery(baseOptions: Apollo.QueryHookOptions<DashboardOverviewQuery, DashboardOverviewQueryVariables> & ({ variables: DashboardOverviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardOverviewQuery, DashboardOverviewQueryVariables>(DashboardOverviewDocument, options);
      }
export function useDashboardOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardOverviewQuery, DashboardOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardOverviewQuery, DashboardOverviewQueryVariables>(DashboardOverviewDocument, options);
        }
// @ts-ignore
export function useDashboardOverviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DashboardOverviewQuery, DashboardOverviewQueryVariables>): Apollo.UseSuspenseQueryResult<DashboardOverviewQuery, DashboardOverviewQueryVariables>;
export function useDashboardOverviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DashboardOverviewQuery, DashboardOverviewQueryVariables>): Apollo.UseSuspenseQueryResult<DashboardOverviewQuery | undefined, DashboardOverviewQueryVariables>;
export function useDashboardOverviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DashboardOverviewQuery, DashboardOverviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardOverviewQuery, DashboardOverviewQueryVariables>(DashboardOverviewDocument, options);
        }
export type DashboardOverviewQueryHookResult = ReturnType<typeof useDashboardOverviewQuery>;
export type DashboardOverviewLazyQueryHookResult = ReturnType<typeof useDashboardOverviewLazyQuery>;
export type DashboardOverviewSuspenseQueryHookResult = ReturnType<typeof useDashboardOverviewSuspenseQuery>;
export type DashboardOverviewQueryResult = Apollo.QueryResult<DashboardOverviewQuery, DashboardOverviewQueryVariables>;
export const DashboardChartsDocument = gql`
    query DashboardCharts($filter: AnalyticsFilterInput!) {
  salesOverTime(filter: $filter) {
    period
    totalSales
    netSales
    orderCount
  }
  ordersByStatus(filter: $filter) {
    status
    count
    totalAmount
  }
  salesByChannel(filter: $filter) {
    channel
    totalSales
    orderCount
  }
  paymentMethodBreakdown(filter: $filter) {
    paymentMethod
    totalAmount
    percentage
  }
}
    `;

/**
 * __useDashboardChartsQuery__
 *
 * To run a query within a React component, call `useDashboardChartsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardChartsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardChartsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDashboardChartsQuery(baseOptions: Apollo.QueryHookOptions<DashboardChartsQuery, DashboardChartsQueryVariables> & ({ variables: DashboardChartsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardChartsQuery, DashboardChartsQueryVariables>(DashboardChartsDocument, options);
      }
export function useDashboardChartsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardChartsQuery, DashboardChartsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardChartsQuery, DashboardChartsQueryVariables>(DashboardChartsDocument, options);
        }
// @ts-ignore
export function useDashboardChartsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DashboardChartsQuery, DashboardChartsQueryVariables>): Apollo.UseSuspenseQueryResult<DashboardChartsQuery, DashboardChartsQueryVariables>;
export function useDashboardChartsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DashboardChartsQuery, DashboardChartsQueryVariables>): Apollo.UseSuspenseQueryResult<DashboardChartsQuery | undefined, DashboardChartsQueryVariables>;
export function useDashboardChartsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DashboardChartsQuery, DashboardChartsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardChartsQuery, DashboardChartsQueryVariables>(DashboardChartsDocument, options);
        }
export type DashboardChartsQueryHookResult = ReturnType<typeof useDashboardChartsQuery>;
export type DashboardChartsLazyQueryHookResult = ReturnType<typeof useDashboardChartsLazyQuery>;
export type DashboardChartsSuspenseQueryHookResult = ReturnType<typeof useDashboardChartsSuspenseQuery>;
export type DashboardChartsQueryResult = Apollo.QueryResult<DashboardChartsQuery, DashboardChartsQueryVariables>;
export const DashboardTablesDocument = gql`
    query DashboardTables($filter: AnalyticsFilterInput!) {
  topProducts(filter: $filter) {
    productId
    productName
    totalQuantity
    totalRevenue
    orderCount
  }
  topCustomers(filter: $filter) {
    customerId
    customerName
    phoneNumber
    totalSpend
    orderCount
  }
  discountPerformance(filter: $filter) {
    discountId
    discountTitle
    discountCode
    usageCount
    totalDiscountAmount
    totalOrdersAffected
    avgDiscountAmount
  }
}
    `;

/**
 * __useDashboardTablesQuery__
 *
 * To run a query within a React component, call `useDashboardTablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardTablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardTablesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDashboardTablesQuery(baseOptions: Apollo.QueryHookOptions<DashboardTablesQuery, DashboardTablesQueryVariables> & ({ variables: DashboardTablesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardTablesQuery, DashboardTablesQueryVariables>(DashboardTablesDocument, options);
      }
export function useDashboardTablesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardTablesQuery, DashboardTablesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardTablesQuery, DashboardTablesQueryVariables>(DashboardTablesDocument, options);
        }
// @ts-ignore
export function useDashboardTablesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DashboardTablesQuery, DashboardTablesQueryVariables>): Apollo.UseSuspenseQueryResult<DashboardTablesQuery, DashboardTablesQueryVariables>;
export function useDashboardTablesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DashboardTablesQuery, DashboardTablesQueryVariables>): Apollo.UseSuspenseQueryResult<DashboardTablesQuery | undefined, DashboardTablesQueryVariables>;
export function useDashboardTablesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DashboardTablesQuery, DashboardTablesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardTablesQuery, DashboardTablesQueryVariables>(DashboardTablesDocument, options);
        }
export type DashboardTablesQueryHookResult = ReturnType<typeof useDashboardTablesQuery>;
export type DashboardTablesLazyQueryHookResult = ReturnType<typeof useDashboardTablesLazyQuery>;
export type DashboardTablesSuspenseQueryHookResult = ReturnType<typeof useDashboardTablesSuspenseQuery>;
export type DashboardTablesQueryResult = Apollo.QueryResult<DashboardTablesQuery, DashboardTablesQueryVariables>;
export const GetDemandNotesDocument = gql`
    query GetDemandNotes($filter: [FilterGroup!], $limit: Int!, $locationId: String, $page: Int!, $sort: [SortCondition!]) {
  getDemandNotes(
    filter: $filter
    limit: $limit
    locationId: $locationId
    page: $page
    sort: $sort
  ) {
    meta {
      limit
      page
      total
      totalCount
    }
    data {
      fulfillmentRatio
      stockValue
      totalItems
      totalRequestedQuantity
      transferSecondaryIds
      secondaryId
      createdAt
      createdBy
      deliveryDate
      fulfillmentStatus
      id
      secondaryId
      type
      updatedAt
      requestedFrom {
        name
      }
      requestedTo {
        name
      }
    }
  }
}
    `;

/**
 * __useGetDemandNotesQuery__
 *
 * To run a query within a React component, call `useGetDemandNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDemandNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDemandNotesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      locationId: // value for 'locationId'
 *      page: // value for 'page'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetDemandNotesQuery(baseOptions: Apollo.QueryHookOptions<GetDemandNotesQuery, GetDemandNotesQueryVariables> & ({ variables: GetDemandNotesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDemandNotesQuery, GetDemandNotesQueryVariables>(GetDemandNotesDocument, options);
      }
export function useGetDemandNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDemandNotesQuery, GetDemandNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDemandNotesQuery, GetDemandNotesQueryVariables>(GetDemandNotesDocument, options);
        }
// @ts-ignore
export function useGetDemandNotesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDemandNotesQuery, GetDemandNotesQueryVariables>): Apollo.UseSuspenseQueryResult<GetDemandNotesQuery, GetDemandNotesQueryVariables>;
export function useGetDemandNotesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDemandNotesQuery, GetDemandNotesQueryVariables>): Apollo.UseSuspenseQueryResult<GetDemandNotesQuery | undefined, GetDemandNotesQueryVariables>;
export function useGetDemandNotesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDemandNotesQuery, GetDemandNotesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDemandNotesQuery, GetDemandNotesQueryVariables>(GetDemandNotesDocument, options);
        }
export type GetDemandNotesQueryHookResult = ReturnType<typeof useGetDemandNotesQuery>;
export type GetDemandNotesLazyQueryHookResult = ReturnType<typeof useGetDemandNotesLazyQuery>;
export type GetDemandNotesSuspenseQueryHookResult = ReturnType<typeof useGetDemandNotesSuspenseQuery>;
export type GetDemandNotesQueryResult = Apollo.QueryResult<GetDemandNotesQuery, GetDemandNotesQueryVariables>;
export const CreateDemandNoteDocument = gql`
    mutation CreateDemandNote($createDemandNoteDto: CreateDemandNoteDTO!) {
  createDemandNote(createDemandNoteDTO: $createDemandNoteDto) {
    id
  }
}
    `;
export type CreateDemandNoteMutationFn = Apollo.MutationFunction<CreateDemandNoteMutation, CreateDemandNoteMutationVariables>;

/**
 * __useCreateDemandNoteMutation__
 *
 * To run a mutation, you first call `useCreateDemandNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDemandNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDemandNoteMutation, { data, loading, error }] = useCreateDemandNoteMutation({
 *   variables: {
 *      createDemandNoteDto: // value for 'createDemandNoteDto'
 *   },
 * });
 */
export function useCreateDemandNoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateDemandNoteMutation, CreateDemandNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDemandNoteMutation, CreateDemandNoteMutationVariables>(CreateDemandNoteDocument, options);
      }
export type CreateDemandNoteMutationHookResult = ReturnType<typeof useCreateDemandNoteMutation>;
export type CreateDemandNoteMutationResult = Apollo.MutationResult<CreateDemandNoteMutation>;
export type CreateDemandNoteMutationOptions = Apollo.BaseMutationOptions<CreateDemandNoteMutation, CreateDemandNoteMutationVariables>;
export const GetDemandNoteDocument = gql`
    query GetDemandNote($secondaryId: Float, $getDemandNoteId: String) {
  getDemandNote(secondaryId: $secondaryId, id: $getDemandNoteId) {
    createdAt
    deliveryDate
    id
    secondaryId
    type
    fulfillmentStatus
    fulfillmentRatio
    isPartial
    stockValue
    totalItems
    totalRequestedQuantity
    transferSecondaryIds
    requestedFrom {
      id
      name
    }
    requestedTo {
      name
      id
    }
    demandNoteProducts {
      id
      secondaryId
      currentInventory
      value
      requestedQuantity
      remainingQuantity
      price
      product {
        manufacturer {
          name
        }
        secondaryId
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetDemandNoteQuery__
 *
 * To run a query within a React component, call `useGetDemandNoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDemandNoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDemandNoteQuery({
 *   variables: {
 *      secondaryId: // value for 'secondaryId'
 *      getDemandNoteId: // value for 'getDemandNoteId'
 *   },
 * });
 */
export function useGetDemandNoteQuery(baseOptions?: Apollo.QueryHookOptions<GetDemandNoteQuery, GetDemandNoteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDemandNoteQuery, GetDemandNoteQueryVariables>(GetDemandNoteDocument, options);
      }
export function useGetDemandNoteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDemandNoteQuery, GetDemandNoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDemandNoteQuery, GetDemandNoteQueryVariables>(GetDemandNoteDocument, options);
        }
// @ts-ignore
export function useGetDemandNoteSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDemandNoteQuery, GetDemandNoteQueryVariables>): Apollo.UseSuspenseQueryResult<GetDemandNoteQuery, GetDemandNoteQueryVariables>;
export function useGetDemandNoteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDemandNoteQuery, GetDemandNoteQueryVariables>): Apollo.UseSuspenseQueryResult<GetDemandNoteQuery | undefined, GetDemandNoteQueryVariables>;
export function useGetDemandNoteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDemandNoteQuery, GetDemandNoteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDemandNoteQuery, GetDemandNoteQueryVariables>(GetDemandNoteDocument, options);
        }
export type GetDemandNoteQueryHookResult = ReturnType<typeof useGetDemandNoteQuery>;
export type GetDemandNoteLazyQueryHookResult = ReturnType<typeof useGetDemandNoteLazyQuery>;
export type GetDemandNoteSuspenseQueryHookResult = ReturnType<typeof useGetDemandNoteSuspenseQuery>;
export type GetDemandNoteQueryResult = Apollo.QueryResult<GetDemandNoteQuery, GetDemandNoteQueryVariables>;
export const UnopenedProductLotInfoDocument = gql`
    query UnopenedProductLotInfo($locationId: String!, $productId: String!) {
  unopenedProductLotInfo(locationId: $locationId, productId: $productId) {
    productStatus
    unopenedCount
  }
}
    `;

/**
 * __useUnopenedProductLotInfoQuery__
 *
 * To run a query within a React component, call `useUnopenedProductLotInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnopenedProductLotInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnopenedProductLotInfoQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useUnopenedProductLotInfoQuery(baseOptions: Apollo.QueryHookOptions<UnopenedProductLotInfoQuery, UnopenedProductLotInfoQueryVariables> & ({ variables: UnopenedProductLotInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UnopenedProductLotInfoQuery, UnopenedProductLotInfoQueryVariables>(UnopenedProductLotInfoDocument, options);
      }
export function useUnopenedProductLotInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UnopenedProductLotInfoQuery, UnopenedProductLotInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UnopenedProductLotInfoQuery, UnopenedProductLotInfoQueryVariables>(UnopenedProductLotInfoDocument, options);
        }
// @ts-ignore
export function useUnopenedProductLotInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UnopenedProductLotInfoQuery, UnopenedProductLotInfoQueryVariables>): Apollo.UseSuspenseQueryResult<UnopenedProductLotInfoQuery, UnopenedProductLotInfoQueryVariables>;
export function useUnopenedProductLotInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UnopenedProductLotInfoQuery, UnopenedProductLotInfoQueryVariables>): Apollo.UseSuspenseQueryResult<UnopenedProductLotInfoQuery | undefined, UnopenedProductLotInfoQueryVariables>;
export function useUnopenedProductLotInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UnopenedProductLotInfoQuery, UnopenedProductLotInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UnopenedProductLotInfoQuery, UnopenedProductLotInfoQueryVariables>(UnopenedProductLotInfoDocument, options);
        }
export type UnopenedProductLotInfoQueryHookResult = ReturnType<typeof useUnopenedProductLotInfoQuery>;
export type UnopenedProductLotInfoLazyQueryHookResult = ReturnType<typeof useUnopenedProductLotInfoLazyQuery>;
export type UnopenedProductLotInfoSuspenseQueryHookResult = ReturnType<typeof useUnopenedProductLotInfoSuspenseQuery>;
export type UnopenedProductLotInfoQueryResult = Apollo.QueryResult<UnopenedProductLotInfoQuery, UnopenedProductLotInfoQueryVariables>;
export const CloseDemandNoteDocument = gql`
    mutation CloseDemandNote($closureReason: String!, $closeDemandNoteId: String!) {
  closeDemandNote(closureReason: $closureReason, id: $closeDemandNoteId) {
    id
  }
}
    `;
export type CloseDemandNoteMutationFn = Apollo.MutationFunction<CloseDemandNoteMutation, CloseDemandNoteMutationVariables>;

/**
 * __useCloseDemandNoteMutation__
 *
 * To run a mutation, you first call `useCloseDemandNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseDemandNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeDemandNoteMutation, { data, loading, error }] = useCloseDemandNoteMutation({
 *   variables: {
 *      closureReason: // value for 'closureReason'
 *      closeDemandNoteId: // value for 'closeDemandNoteId'
 *   },
 * });
 */
export function useCloseDemandNoteMutation(baseOptions?: Apollo.MutationHookOptions<CloseDemandNoteMutation, CloseDemandNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloseDemandNoteMutation, CloseDemandNoteMutationVariables>(CloseDemandNoteDocument, options);
      }
export type CloseDemandNoteMutationHookResult = ReturnType<typeof useCloseDemandNoteMutation>;
export type CloseDemandNoteMutationResult = Apollo.MutationResult<CloseDemandNoteMutation>;
export type CloseDemandNoteMutationOptions = Apollo.BaseMutationOptions<CloseDemandNoteMutation, CloseDemandNoteMutationVariables>;
export const CreateDiscountDocument = gql`
    mutation CreateDiscount($createDiscountDto: CreateDiscountDTO!) {
  createDiscount(createDiscountDto: $createDiscountDto) {
    id
  }
}
    `;
export type CreateDiscountMutationFn = Apollo.MutationFunction<CreateDiscountMutation, CreateDiscountMutationVariables>;

/**
 * __useCreateDiscountMutation__
 *
 * To run a mutation, you first call `useCreateDiscountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDiscountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDiscountMutation, { data, loading, error }] = useCreateDiscountMutation({
 *   variables: {
 *      createDiscountDto: // value for 'createDiscountDto'
 *   },
 * });
 */
export function useCreateDiscountMutation(baseOptions?: Apollo.MutationHookOptions<CreateDiscountMutation, CreateDiscountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDiscountMutation, CreateDiscountMutationVariables>(CreateDiscountDocument, options);
      }
export type CreateDiscountMutationHookResult = ReturnType<typeof useCreateDiscountMutation>;
export type CreateDiscountMutationResult = Apollo.MutationResult<CreateDiscountMutation>;
export type CreateDiscountMutationOptions = Apollo.BaseMutationOptions<CreateDiscountMutation, CreateDiscountMutationVariables>;
export const UpdateDiscountDocument = gql`
    mutation UpdateDiscount($updateDiscountDto: UpdateDiscountDTO!) {
  updateDiscount(updateDiscountDTO: $updateDiscountDto) {
    id
  }
}
    `;
export type UpdateDiscountMutationFn = Apollo.MutationFunction<UpdateDiscountMutation, UpdateDiscountMutationVariables>;

/**
 * __useUpdateDiscountMutation__
 *
 * To run a mutation, you first call `useUpdateDiscountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDiscountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDiscountMutation, { data, loading, error }] = useUpdateDiscountMutation({
 *   variables: {
 *      updateDiscountDto: // value for 'updateDiscountDto'
 *   },
 * });
 */
export function useUpdateDiscountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDiscountMutation, UpdateDiscountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDiscountMutation, UpdateDiscountMutationVariables>(UpdateDiscountDocument, options);
      }
export type UpdateDiscountMutationHookResult = ReturnType<typeof useUpdateDiscountMutation>;
export type UpdateDiscountMutationResult = Apollo.MutationResult<UpdateDiscountMutation>;
export type UpdateDiscountMutationOptions = Apollo.BaseMutationOptions<UpdateDiscountMutation, UpdateDiscountMutationVariables>;
export const GetDiscountsDocument = gql`
    query GetDiscounts($sort: [SortCondition!], $page: Int!, $locationId: String, $limit: Int!, $filter: [FilterGroup!]) {
  getDiscounts(
    sort: $sort
    page: $page
    locationId: $locationId
    limit: $limit
    filter: $filter
  ) {
    meta {
      limit
      page
      totalCount
    }
    data {
      value
      type
      title
      scope
      maxDiscountAmount
      status
      id
      secondaryId
      limitUses
      combinable
      code
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useGetDiscountsQuery__
 *
 * To run a query within a React component, call `useGetDiscountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDiscountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDiscountsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      locationId: // value for 'locationId'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetDiscountsQuery(baseOptions: Apollo.QueryHookOptions<GetDiscountsQuery, GetDiscountsQueryVariables> & ({ variables: GetDiscountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDiscountsQuery, GetDiscountsQueryVariables>(GetDiscountsDocument, options);
      }
export function useGetDiscountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDiscountsQuery, GetDiscountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDiscountsQuery, GetDiscountsQueryVariables>(GetDiscountsDocument, options);
        }
// @ts-ignore
export function useGetDiscountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDiscountsQuery, GetDiscountsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDiscountsQuery, GetDiscountsQueryVariables>;
export function useGetDiscountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDiscountsQuery, GetDiscountsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDiscountsQuery | undefined, GetDiscountsQueryVariables>;
export function useGetDiscountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDiscountsQuery, GetDiscountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDiscountsQuery, GetDiscountsQueryVariables>(GetDiscountsDocument, options);
        }
export type GetDiscountsQueryHookResult = ReturnType<typeof useGetDiscountsQuery>;
export type GetDiscountsLazyQueryHookResult = ReturnType<typeof useGetDiscountsLazyQuery>;
export type GetDiscountsSuspenseQueryHookResult = ReturnType<typeof useGetDiscountsSuspenseQuery>;
export type GetDiscountsQueryResult = Apollo.QueryResult<GetDiscountsQuery, GetDiscountsQueryVariables>;
export const GetDiscountDocument = gql`
    query GetDiscount($id: String, $code: String, $partnerId: String) {
  getDiscount(id: $id, code: $code, partnerId: $partnerId) {
    applicableCategories {
      name
      id
    }
    applicableCustomers {
      id
      name
    }
    applicableProducts {
      id
      name
    }
    applicableTags {
      id
      name
    }
    buyX
    code
    combinable
    createdAt
    endDate
    getY
    getYDiscount
    id
    limitUses
    scope
    maxDiscountAmount
    locations {
      name
      id
    }
    minPurchaseAmount
    minQuantity
    secondaryId
    startDate
    status
    title
    type
    updatedAt
    value
  }
}
    `;

/**
 * __useGetDiscountQuery__
 *
 * To run a query within a React component, call `useGetDiscountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDiscountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDiscountQuery({
 *   variables: {
 *      id: // value for 'id'
 *      code: // value for 'code'
 *      partnerId: // value for 'partnerId'
 *   },
 * });
 */
export function useGetDiscountQuery(baseOptions?: Apollo.QueryHookOptions<GetDiscountQuery, GetDiscountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDiscountQuery, GetDiscountQueryVariables>(GetDiscountDocument, options);
      }
export function useGetDiscountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDiscountQuery, GetDiscountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDiscountQuery, GetDiscountQueryVariables>(GetDiscountDocument, options);
        }
// @ts-ignore
export function useGetDiscountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDiscountQuery, GetDiscountQueryVariables>): Apollo.UseSuspenseQueryResult<GetDiscountQuery, GetDiscountQueryVariables>;
export function useGetDiscountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDiscountQuery, GetDiscountQueryVariables>): Apollo.UseSuspenseQueryResult<GetDiscountQuery | undefined, GetDiscountQueryVariables>;
export function useGetDiscountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDiscountQuery, GetDiscountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDiscountQuery, GetDiscountQueryVariables>(GetDiscountDocument, options);
        }
export type GetDiscountQueryHookResult = ReturnType<typeof useGetDiscountQuery>;
export type GetDiscountLazyQueryHookResult = ReturnType<typeof useGetDiscountLazyQuery>;
export type GetDiscountSuspenseQueryHookResult = ReturnType<typeof useGetDiscountSuspenseQuery>;
export type GetDiscountQueryResult = Apollo.QueryResult<GetDiscountQuery, GetDiscountQueryVariables>;
export const DownloadOrderItemReportDocument = gql`
    query DownloadOrderItemReport($locationId: String, $filter: [FilterGroup!]) {
  downloadOrderItemReport(locationId: $locationId, filter: $filter)
}
    `;

/**
 * __useDownloadOrderItemReportQuery__
 *
 * To run a query within a React component, call `useDownloadOrderItemReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadOrderItemReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadOrderItemReportQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDownloadOrderItemReportQuery(baseOptions?: Apollo.QueryHookOptions<DownloadOrderItemReportQuery, DownloadOrderItemReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadOrderItemReportQuery, DownloadOrderItemReportQueryVariables>(DownloadOrderItemReportDocument, options);
      }
export function useDownloadOrderItemReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadOrderItemReportQuery, DownloadOrderItemReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadOrderItemReportQuery, DownloadOrderItemReportQueryVariables>(DownloadOrderItemReportDocument, options);
        }
// @ts-ignore
export function useDownloadOrderItemReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DownloadOrderItemReportQuery, DownloadOrderItemReportQueryVariables>): Apollo.UseSuspenseQueryResult<DownloadOrderItemReportQuery, DownloadOrderItemReportQueryVariables>;
export function useDownloadOrderItemReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DownloadOrderItemReportQuery, DownloadOrderItemReportQueryVariables>): Apollo.UseSuspenseQueryResult<DownloadOrderItemReportQuery | undefined, DownloadOrderItemReportQueryVariables>;
export function useDownloadOrderItemReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DownloadOrderItemReportQuery, DownloadOrderItemReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DownloadOrderItemReportQuery, DownloadOrderItemReportQueryVariables>(DownloadOrderItemReportDocument, options);
        }
export type DownloadOrderItemReportQueryHookResult = ReturnType<typeof useDownloadOrderItemReportQuery>;
export type DownloadOrderItemReportLazyQueryHookResult = ReturnType<typeof useDownloadOrderItemReportLazyQuery>;
export type DownloadOrderItemReportSuspenseQueryHookResult = ReturnType<typeof useDownloadOrderItemReportSuspenseQuery>;
export type DownloadOrderItemReportQueryResult = Apollo.QueryResult<DownloadOrderItemReportQuery, DownloadOrderItemReportQueryVariables>;
export const DownloadOrderReportDocument = gql`
    query DownloadOrderReport($locationId: String, $filter: [FilterGroup!]) {
  downloadOrderReport(locationId: $locationId, filter: $filter)
}
    `;

/**
 * __useDownloadOrderReportQuery__
 *
 * To run a query within a React component, call `useDownloadOrderReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadOrderReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadOrderReportQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDownloadOrderReportQuery(baseOptions?: Apollo.QueryHookOptions<DownloadOrderReportQuery, DownloadOrderReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadOrderReportQuery, DownloadOrderReportQueryVariables>(DownloadOrderReportDocument, options);
      }
export function useDownloadOrderReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadOrderReportQuery, DownloadOrderReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadOrderReportQuery, DownloadOrderReportQueryVariables>(DownloadOrderReportDocument, options);
        }
// @ts-ignore
export function useDownloadOrderReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DownloadOrderReportQuery, DownloadOrderReportQueryVariables>): Apollo.UseSuspenseQueryResult<DownloadOrderReportQuery, DownloadOrderReportQueryVariables>;
export function useDownloadOrderReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DownloadOrderReportQuery, DownloadOrderReportQueryVariables>): Apollo.UseSuspenseQueryResult<DownloadOrderReportQuery | undefined, DownloadOrderReportQueryVariables>;
export function useDownloadOrderReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DownloadOrderReportQuery, DownloadOrderReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DownloadOrderReportQuery, DownloadOrderReportQueryVariables>(DownloadOrderReportDocument, options);
        }
export type DownloadOrderReportQueryHookResult = ReturnType<typeof useDownloadOrderReportQuery>;
export type DownloadOrderReportLazyQueryHookResult = ReturnType<typeof useDownloadOrderReportLazyQuery>;
export type DownloadOrderReportSuspenseQueryHookResult = ReturnType<typeof useDownloadOrderReportSuspenseQuery>;
export type DownloadOrderReportQueryResult = Apollo.QueryResult<DownloadOrderReportQuery, DownloadOrderReportQueryVariables>;
export const DownloadPurchaseOrderItemDocument = gql`
    query DownloadPurchaseOrderItem($filter: [FilterGroup!], $locationId: String) {
  downloadPurchaseOrderItem(filter: $filter, locationId: $locationId)
}
    `;

/**
 * __useDownloadPurchaseOrderItemQuery__
 *
 * To run a query within a React component, call `useDownloadPurchaseOrderItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadPurchaseOrderItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadPurchaseOrderItemQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useDownloadPurchaseOrderItemQuery(baseOptions?: Apollo.QueryHookOptions<DownloadPurchaseOrderItemQuery, DownloadPurchaseOrderItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadPurchaseOrderItemQuery, DownloadPurchaseOrderItemQueryVariables>(DownloadPurchaseOrderItemDocument, options);
      }
export function useDownloadPurchaseOrderItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadPurchaseOrderItemQuery, DownloadPurchaseOrderItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadPurchaseOrderItemQuery, DownloadPurchaseOrderItemQueryVariables>(DownloadPurchaseOrderItemDocument, options);
        }
// @ts-ignore
export function useDownloadPurchaseOrderItemSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DownloadPurchaseOrderItemQuery, DownloadPurchaseOrderItemQueryVariables>): Apollo.UseSuspenseQueryResult<DownloadPurchaseOrderItemQuery, DownloadPurchaseOrderItemQueryVariables>;
export function useDownloadPurchaseOrderItemSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DownloadPurchaseOrderItemQuery, DownloadPurchaseOrderItemQueryVariables>): Apollo.UseSuspenseQueryResult<DownloadPurchaseOrderItemQuery | undefined, DownloadPurchaseOrderItemQueryVariables>;
export function useDownloadPurchaseOrderItemSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DownloadPurchaseOrderItemQuery, DownloadPurchaseOrderItemQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DownloadPurchaseOrderItemQuery, DownloadPurchaseOrderItemQueryVariables>(DownloadPurchaseOrderItemDocument, options);
        }
export type DownloadPurchaseOrderItemQueryHookResult = ReturnType<typeof useDownloadPurchaseOrderItemQuery>;
export type DownloadPurchaseOrderItemLazyQueryHookResult = ReturnType<typeof useDownloadPurchaseOrderItemLazyQuery>;
export type DownloadPurchaseOrderItemSuspenseQueryHookResult = ReturnType<typeof useDownloadPurchaseOrderItemSuspenseQuery>;
export type DownloadPurchaseOrderItemQueryResult = Apollo.QueryResult<DownloadPurchaseOrderItemQuery, DownloadPurchaseOrderItemQueryVariables>;
export const DownloadPurchaseOrdersDocument = gql`
    query DownloadPurchaseOrders($filter: [FilterGroup!], $locationId: String) {
  downloadPurchaseOrders(filter: $filter, locationId: $locationId)
}
    `;

/**
 * __useDownloadPurchaseOrdersQuery__
 *
 * To run a query within a React component, call `useDownloadPurchaseOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadPurchaseOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadPurchaseOrdersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useDownloadPurchaseOrdersQuery(baseOptions?: Apollo.QueryHookOptions<DownloadPurchaseOrdersQuery, DownloadPurchaseOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadPurchaseOrdersQuery, DownloadPurchaseOrdersQueryVariables>(DownloadPurchaseOrdersDocument, options);
      }
export function useDownloadPurchaseOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadPurchaseOrdersQuery, DownloadPurchaseOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadPurchaseOrdersQuery, DownloadPurchaseOrdersQueryVariables>(DownloadPurchaseOrdersDocument, options);
        }
// @ts-ignore
export function useDownloadPurchaseOrdersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DownloadPurchaseOrdersQuery, DownloadPurchaseOrdersQueryVariables>): Apollo.UseSuspenseQueryResult<DownloadPurchaseOrdersQuery, DownloadPurchaseOrdersQueryVariables>;
export function useDownloadPurchaseOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DownloadPurchaseOrdersQuery, DownloadPurchaseOrdersQueryVariables>): Apollo.UseSuspenseQueryResult<DownloadPurchaseOrdersQuery | undefined, DownloadPurchaseOrdersQueryVariables>;
export function useDownloadPurchaseOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DownloadPurchaseOrdersQuery, DownloadPurchaseOrdersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DownloadPurchaseOrdersQuery, DownloadPurchaseOrdersQueryVariables>(DownloadPurchaseOrdersDocument, options);
        }
export type DownloadPurchaseOrdersQueryHookResult = ReturnType<typeof useDownloadPurchaseOrdersQuery>;
export type DownloadPurchaseOrdersLazyQueryHookResult = ReturnType<typeof useDownloadPurchaseOrdersLazyQuery>;
export type DownloadPurchaseOrdersSuspenseQueryHookResult = ReturnType<typeof useDownloadPurchaseOrdersSuspenseQuery>;
export type DownloadPurchaseOrdersQueryResult = Apollo.QueryResult<DownloadPurchaseOrdersQuery, DownloadPurchaseOrdersQueryVariables>;
export const DownloadTransferItemsDocument = gql`
    query DownloadTransferItems($locationId: String!) {
  downloadTransferItems(locationId: $locationId)
}
    `;

/**
 * __useDownloadTransferItemsQuery__
 *
 * To run a query within a React component, call `useDownloadTransferItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadTransferItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadTransferItemsQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useDownloadTransferItemsQuery(baseOptions: Apollo.QueryHookOptions<DownloadTransferItemsQuery, DownloadTransferItemsQueryVariables> & ({ variables: DownloadTransferItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadTransferItemsQuery, DownloadTransferItemsQueryVariables>(DownloadTransferItemsDocument, options);
      }
export function useDownloadTransferItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadTransferItemsQuery, DownloadTransferItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadTransferItemsQuery, DownloadTransferItemsQueryVariables>(DownloadTransferItemsDocument, options);
        }
// @ts-ignore
export function useDownloadTransferItemsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DownloadTransferItemsQuery, DownloadTransferItemsQueryVariables>): Apollo.UseSuspenseQueryResult<DownloadTransferItemsQuery, DownloadTransferItemsQueryVariables>;
export function useDownloadTransferItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DownloadTransferItemsQuery, DownloadTransferItemsQueryVariables>): Apollo.UseSuspenseQueryResult<DownloadTransferItemsQuery | undefined, DownloadTransferItemsQueryVariables>;
export function useDownloadTransferItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DownloadTransferItemsQuery, DownloadTransferItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DownloadTransferItemsQuery, DownloadTransferItemsQueryVariables>(DownloadTransferItemsDocument, options);
        }
export type DownloadTransferItemsQueryHookResult = ReturnType<typeof useDownloadTransferItemsQuery>;
export type DownloadTransferItemsLazyQueryHookResult = ReturnType<typeof useDownloadTransferItemsLazyQuery>;
export type DownloadTransferItemsSuspenseQueryHookResult = ReturnType<typeof useDownloadTransferItemsSuspenseQuery>;
export type DownloadTransferItemsQueryResult = Apollo.QueryResult<DownloadTransferItemsQuery, DownloadTransferItemsQueryVariables>;
export const DownloadGetProductLotStockReportDocument = gql`
    query DownloadGetProductLotStockReport($filters: ProductStockReportArgs!) {
  downloadGetProductLotStockReport(filters: $filters)
}
    `;

/**
 * __useDownloadGetProductLotStockReportQuery__
 *
 * To run a query within a React component, call `useDownloadGetProductLotStockReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadGetProductLotStockReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadGetProductLotStockReportQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useDownloadGetProductLotStockReportQuery(baseOptions: Apollo.QueryHookOptions<DownloadGetProductLotStockReportQuery, DownloadGetProductLotStockReportQueryVariables> & ({ variables: DownloadGetProductLotStockReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadGetProductLotStockReportQuery, DownloadGetProductLotStockReportQueryVariables>(DownloadGetProductLotStockReportDocument, options);
      }
export function useDownloadGetProductLotStockReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadGetProductLotStockReportQuery, DownloadGetProductLotStockReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadGetProductLotStockReportQuery, DownloadGetProductLotStockReportQueryVariables>(DownloadGetProductLotStockReportDocument, options);
        }
// @ts-ignore
export function useDownloadGetProductLotStockReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DownloadGetProductLotStockReportQuery, DownloadGetProductLotStockReportQueryVariables>): Apollo.UseSuspenseQueryResult<DownloadGetProductLotStockReportQuery, DownloadGetProductLotStockReportQueryVariables>;
export function useDownloadGetProductLotStockReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DownloadGetProductLotStockReportQuery, DownloadGetProductLotStockReportQueryVariables>): Apollo.UseSuspenseQueryResult<DownloadGetProductLotStockReportQuery | undefined, DownloadGetProductLotStockReportQueryVariables>;
export function useDownloadGetProductLotStockReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DownloadGetProductLotStockReportQuery, DownloadGetProductLotStockReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DownloadGetProductLotStockReportQuery, DownloadGetProductLotStockReportQueryVariables>(DownloadGetProductLotStockReportDocument, options);
        }
export type DownloadGetProductLotStockReportQueryHookResult = ReturnType<typeof useDownloadGetProductLotStockReportQuery>;
export type DownloadGetProductLotStockReportLazyQueryHookResult = ReturnType<typeof useDownloadGetProductLotStockReportLazyQuery>;
export type DownloadGetProductLotStockReportSuspenseQueryHookResult = ReturnType<typeof useDownloadGetProductLotStockReportSuspenseQuery>;
export type DownloadGetProductLotStockReportQueryResult = Apollo.QueryResult<DownloadGetProductLotStockReportQuery, DownloadGetProductLotStockReportQueryVariables>;
export const CreatePartnerFinancialTermsDocument = gql`
    mutation CreatePartnerFinancialTerms($createFinancialTermsDto: CreateFinancialTermsDTO!) {
  createPartnerFinancialTerms(createFinancialTermsDTO: $createFinancialTermsDto) {
    id
  }
}
    `;
export type CreatePartnerFinancialTermsMutationFn = Apollo.MutationFunction<CreatePartnerFinancialTermsMutation, CreatePartnerFinancialTermsMutationVariables>;

/**
 * __useCreatePartnerFinancialTermsMutation__
 *
 * To run a mutation, you first call `useCreatePartnerFinancialTermsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePartnerFinancialTermsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPartnerFinancialTermsMutation, { data, loading, error }] = useCreatePartnerFinancialTermsMutation({
 *   variables: {
 *      createFinancialTermsDto: // value for 'createFinancialTermsDto'
 *   },
 * });
 */
export function useCreatePartnerFinancialTermsMutation(baseOptions?: Apollo.MutationHookOptions<CreatePartnerFinancialTermsMutation, CreatePartnerFinancialTermsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePartnerFinancialTermsMutation, CreatePartnerFinancialTermsMutationVariables>(CreatePartnerFinancialTermsDocument, options);
      }
export type CreatePartnerFinancialTermsMutationHookResult = ReturnType<typeof useCreatePartnerFinancialTermsMutation>;
export type CreatePartnerFinancialTermsMutationResult = Apollo.MutationResult<CreatePartnerFinancialTermsMutation>;
export type CreatePartnerFinancialTermsMutationOptions = Apollo.BaseMutationOptions<CreatePartnerFinancialTermsMutation, CreatePartnerFinancialTermsMutationVariables>;
export const UpdatePartnerFinancialTermsDocument = gql`
    mutation UpdatePartnerFinancialTerms($updateFinancialTermsDto: UpdateFinancialTermsDTO!) {
  updatePartnerFinancialTerms(updateFinancialTermsDTO: $updateFinancialTermsDto) {
    id
  }
}
    `;
export type UpdatePartnerFinancialTermsMutationFn = Apollo.MutationFunction<UpdatePartnerFinancialTermsMutation, UpdatePartnerFinancialTermsMutationVariables>;

/**
 * __useUpdatePartnerFinancialTermsMutation__
 *
 * To run a mutation, you first call `useUpdatePartnerFinancialTermsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePartnerFinancialTermsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePartnerFinancialTermsMutation, { data, loading, error }] = useUpdatePartnerFinancialTermsMutation({
 *   variables: {
 *      updateFinancialTermsDto: // value for 'updateFinancialTermsDto'
 *   },
 * });
 */
export function useUpdatePartnerFinancialTermsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePartnerFinancialTermsMutation, UpdatePartnerFinancialTermsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePartnerFinancialTermsMutation, UpdatePartnerFinancialTermsMutationVariables>(UpdatePartnerFinancialTermsDocument, options);
      }
export type UpdatePartnerFinancialTermsMutationHookResult = ReturnType<typeof useUpdatePartnerFinancialTermsMutation>;
export type UpdatePartnerFinancialTermsMutationResult = Apollo.MutationResult<UpdatePartnerFinancialTermsMutation>;
export type UpdatePartnerFinancialTermsMutationOptions = Apollo.BaseMutationOptions<UpdatePartnerFinancialTermsMutation, UpdatePartnerFinancialTermsMutationVariables>;
export const GetPartnerFinancialTermsByPartnerDocument = gql`
    query GetPartnerFinancialTermsByPartner($partnerId: String!, $sort: [SortCondition!], $page: Int!, $limit: Int!, $locationId: String, $filter: [FilterGroup!]) {
  getPartnerFinancialTermsByPartner(
    partnerId: $partnerId
    sort: $sort
    page: $page
    limit: $limit
    locationId: $locationId
    filter: $filter
  ) {
    meta {
      page
      limit
      totalCount
      total
    }
    data {
      id
      secondaryId
      partnerId
      effectiveFrom
      effectiveTo
      coverageModeCode
      coveragePercent
      coverageFixedAmount
      direction
      isCreditCover
      status
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useGetPartnerFinancialTermsByPartnerQuery__
 *
 * To run a query within a React component, call `useGetPartnerFinancialTermsByPartnerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartnerFinancialTermsByPartnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartnerFinancialTermsByPartnerQuery({
 *   variables: {
 *      partnerId: // value for 'partnerId'
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      locationId: // value for 'locationId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetPartnerFinancialTermsByPartnerQuery(baseOptions: Apollo.QueryHookOptions<GetPartnerFinancialTermsByPartnerQuery, GetPartnerFinancialTermsByPartnerQueryVariables> & ({ variables: GetPartnerFinancialTermsByPartnerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPartnerFinancialTermsByPartnerQuery, GetPartnerFinancialTermsByPartnerQueryVariables>(GetPartnerFinancialTermsByPartnerDocument, options);
      }
export function useGetPartnerFinancialTermsByPartnerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPartnerFinancialTermsByPartnerQuery, GetPartnerFinancialTermsByPartnerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPartnerFinancialTermsByPartnerQuery, GetPartnerFinancialTermsByPartnerQueryVariables>(GetPartnerFinancialTermsByPartnerDocument, options);
        }
// @ts-ignore
export function useGetPartnerFinancialTermsByPartnerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPartnerFinancialTermsByPartnerQuery, GetPartnerFinancialTermsByPartnerQueryVariables>): Apollo.UseSuspenseQueryResult<GetPartnerFinancialTermsByPartnerQuery, GetPartnerFinancialTermsByPartnerQueryVariables>;
export function useGetPartnerFinancialTermsByPartnerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPartnerFinancialTermsByPartnerQuery, GetPartnerFinancialTermsByPartnerQueryVariables>): Apollo.UseSuspenseQueryResult<GetPartnerFinancialTermsByPartnerQuery | undefined, GetPartnerFinancialTermsByPartnerQueryVariables>;
export function useGetPartnerFinancialTermsByPartnerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPartnerFinancialTermsByPartnerQuery, GetPartnerFinancialTermsByPartnerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPartnerFinancialTermsByPartnerQuery, GetPartnerFinancialTermsByPartnerQueryVariables>(GetPartnerFinancialTermsByPartnerDocument, options);
        }
export type GetPartnerFinancialTermsByPartnerQueryHookResult = ReturnType<typeof useGetPartnerFinancialTermsByPartnerQuery>;
export type GetPartnerFinancialTermsByPartnerLazyQueryHookResult = ReturnType<typeof useGetPartnerFinancialTermsByPartnerLazyQuery>;
export type GetPartnerFinancialTermsByPartnerSuspenseQueryHookResult = ReturnType<typeof useGetPartnerFinancialTermsByPartnerSuspenseQuery>;
export type GetPartnerFinancialTermsByPartnerQueryResult = Apollo.QueryResult<GetPartnerFinancialTermsByPartnerQuery, GetPartnerFinancialTermsByPartnerQueryVariables>;
export const GetPartnerFinancialTermDocument = gql`
    query GetPartnerFinancialTerm($getPartnerFinancialTermId: String!) {
  getPartnerFinancialTerm(id: $getPartnerFinancialTermId) {
    id
    secondaryId
    partnerId
    effectiveFrom
    effectiveTo
    coverageModeCode
    coveragePercent
    coverageFixedAmount
    direction
    isCreditCover
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetPartnerFinancialTermQuery__
 *
 * To run a query within a React component, call `useGetPartnerFinancialTermQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartnerFinancialTermQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartnerFinancialTermQuery({
 *   variables: {
 *      getPartnerFinancialTermId: // value for 'getPartnerFinancialTermId'
 *   },
 * });
 */
export function useGetPartnerFinancialTermQuery(baseOptions: Apollo.QueryHookOptions<GetPartnerFinancialTermQuery, GetPartnerFinancialTermQueryVariables> & ({ variables: GetPartnerFinancialTermQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPartnerFinancialTermQuery, GetPartnerFinancialTermQueryVariables>(GetPartnerFinancialTermDocument, options);
      }
export function useGetPartnerFinancialTermLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPartnerFinancialTermQuery, GetPartnerFinancialTermQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPartnerFinancialTermQuery, GetPartnerFinancialTermQueryVariables>(GetPartnerFinancialTermDocument, options);
        }
// @ts-ignore
export function useGetPartnerFinancialTermSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPartnerFinancialTermQuery, GetPartnerFinancialTermQueryVariables>): Apollo.UseSuspenseQueryResult<GetPartnerFinancialTermQuery, GetPartnerFinancialTermQueryVariables>;
export function useGetPartnerFinancialTermSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPartnerFinancialTermQuery, GetPartnerFinancialTermQueryVariables>): Apollo.UseSuspenseQueryResult<GetPartnerFinancialTermQuery | undefined, GetPartnerFinancialTermQueryVariables>;
export function useGetPartnerFinancialTermSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPartnerFinancialTermQuery, GetPartnerFinancialTermQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPartnerFinancialTermQuery, GetPartnerFinancialTermQueryVariables>(GetPartnerFinancialTermDocument, options);
        }
export type GetPartnerFinancialTermQueryHookResult = ReturnType<typeof useGetPartnerFinancialTermQuery>;
export type GetPartnerFinancialTermLazyQueryHookResult = ReturnType<typeof useGetPartnerFinancialTermLazyQuery>;
export type GetPartnerFinancialTermSuspenseQueryHookResult = ReturnType<typeof useGetPartnerFinancialTermSuspenseQuery>;
export type GetPartnerFinancialTermQueryResult = Apollo.QueryResult<GetPartnerFinancialTermQuery, GetPartnerFinancialTermQueryVariables>;
export const GetPartnerFinancialTermsListDocument = gql`
    query GetPartnerFinancialTermsList($sort: [SortCondition!], $filter: [FilterGroup!], $page: Int!, $limit: Int!, $locationId: String) {
  getPartnerFinancialTerms(
    sort: $sort
    filter: $filter
    page: $page
    limit: $limit
    locationId: $locationId
  ) {
    meta {
      page
      limit
      totalCount
      total
    }
    data {
      id
      secondaryId
      partnerId
      effectiveFrom
      effectiveTo
      coverageModeCode
      coveragePercent
      coverageFixedAmount
      direction
      isCreditCover
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useGetPartnerFinancialTermsListQuery__
 *
 * To run a query within a React component, call `useGetPartnerFinancialTermsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartnerFinancialTermsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartnerFinancialTermsListQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useGetPartnerFinancialTermsListQuery(baseOptions: Apollo.QueryHookOptions<GetPartnerFinancialTermsListQuery, GetPartnerFinancialTermsListQueryVariables> & ({ variables: GetPartnerFinancialTermsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPartnerFinancialTermsListQuery, GetPartnerFinancialTermsListQueryVariables>(GetPartnerFinancialTermsListDocument, options);
      }
export function useGetPartnerFinancialTermsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPartnerFinancialTermsListQuery, GetPartnerFinancialTermsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPartnerFinancialTermsListQuery, GetPartnerFinancialTermsListQueryVariables>(GetPartnerFinancialTermsListDocument, options);
        }
// @ts-ignore
export function useGetPartnerFinancialTermsListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPartnerFinancialTermsListQuery, GetPartnerFinancialTermsListQueryVariables>): Apollo.UseSuspenseQueryResult<GetPartnerFinancialTermsListQuery, GetPartnerFinancialTermsListQueryVariables>;
export function useGetPartnerFinancialTermsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPartnerFinancialTermsListQuery, GetPartnerFinancialTermsListQueryVariables>): Apollo.UseSuspenseQueryResult<GetPartnerFinancialTermsListQuery | undefined, GetPartnerFinancialTermsListQueryVariables>;
export function useGetPartnerFinancialTermsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPartnerFinancialTermsListQuery, GetPartnerFinancialTermsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPartnerFinancialTermsListQuery, GetPartnerFinancialTermsListQueryVariables>(GetPartnerFinancialTermsListDocument, options);
        }
export type GetPartnerFinancialTermsListQueryHookResult = ReturnType<typeof useGetPartnerFinancialTermsListQuery>;
export type GetPartnerFinancialTermsListLazyQueryHookResult = ReturnType<typeof useGetPartnerFinancialTermsListLazyQuery>;
export type GetPartnerFinancialTermsListSuspenseQueryHookResult = ReturnType<typeof useGetPartnerFinancialTermsListSuspenseQuery>;
export type GetPartnerFinancialTermsListQueryResult = Apollo.QueryResult<GetPartnerFinancialTermsListQuery, GetPartnerFinancialTermsListQueryVariables>;
export const CreateFulfillmentOrderDocument = gql`
    mutation CreateFulfillmentOrder($input: CreateFulfillmentOrderInput!) {
  createFulfillmentOrder(input: $input) {
    id
    secondaryId
  }
}
    `;
export type CreateFulfillmentOrderMutationFn = Apollo.MutationFunction<CreateFulfillmentOrderMutation, CreateFulfillmentOrderMutationVariables>;

/**
 * __useCreateFulfillmentOrderMutation__
 *
 * To run a mutation, you first call `useCreateFulfillmentOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFulfillmentOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFulfillmentOrderMutation, { data, loading, error }] = useCreateFulfillmentOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFulfillmentOrderMutation(baseOptions?: Apollo.MutationHookOptions<CreateFulfillmentOrderMutation, CreateFulfillmentOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFulfillmentOrderMutation, CreateFulfillmentOrderMutationVariables>(CreateFulfillmentOrderDocument, options);
      }
export type CreateFulfillmentOrderMutationHookResult = ReturnType<typeof useCreateFulfillmentOrderMutation>;
export type CreateFulfillmentOrderMutationResult = Apollo.MutationResult<CreateFulfillmentOrderMutation>;
export type CreateFulfillmentOrderMutationOptions = Apollo.BaseMutationOptions<CreateFulfillmentOrderMutation, CreateFulfillmentOrderMutationVariables>;
export const FulfillmentOrdersListDocument = gql`
    query FulfillmentOrdersList($sort: [SortCondition!], $filter: [FilterGroup!], $page: Int!, $limit: Int!, $locationId: String) {
  fulfillmentOrders(
    sort: $sort
    filter: $filter
    page: $page
    limit: $limit
    locationId: $locationId
  ) {
    data {
      id
      secondaryId
      orderId
      locationId
      registerId
      acceptedByUserId
      acceptedAt
      status
      shippingProvider
      consignmentNumber
      packedByUserId
      packedAt
      completedAt
      createdBy
      createdAt
      updatedAt
      fulfillmentId
      location {
        id
        secondaryId
        name
        __typename
      }
      order {
        secondaryId
        __typename
        orderType
        orderSource
        orderChannel
        customer {
          name
          phoneNumber
        }
        payments {
          id
          method
          status
        }
      }
      __typename
      trackingUrl
    }
    meta {
      page
      limit
      totalCount
      total
    }
  }
}
    `;

/**
 * __useFulfillmentOrdersListQuery__
 *
 * To run a query within a React component, call `useFulfillmentOrdersListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFulfillmentOrdersListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFulfillmentOrdersListQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useFulfillmentOrdersListQuery(baseOptions: Apollo.QueryHookOptions<FulfillmentOrdersListQuery, FulfillmentOrdersListQueryVariables> & ({ variables: FulfillmentOrdersListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FulfillmentOrdersListQuery, FulfillmentOrdersListQueryVariables>(FulfillmentOrdersListDocument, options);
      }
export function useFulfillmentOrdersListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FulfillmentOrdersListQuery, FulfillmentOrdersListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FulfillmentOrdersListQuery, FulfillmentOrdersListQueryVariables>(FulfillmentOrdersListDocument, options);
        }
// @ts-ignore
export function useFulfillmentOrdersListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FulfillmentOrdersListQuery, FulfillmentOrdersListQueryVariables>): Apollo.UseSuspenseQueryResult<FulfillmentOrdersListQuery, FulfillmentOrdersListQueryVariables>;
export function useFulfillmentOrdersListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FulfillmentOrdersListQuery, FulfillmentOrdersListQueryVariables>): Apollo.UseSuspenseQueryResult<FulfillmentOrdersListQuery | undefined, FulfillmentOrdersListQueryVariables>;
export function useFulfillmentOrdersListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FulfillmentOrdersListQuery, FulfillmentOrdersListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FulfillmentOrdersListQuery, FulfillmentOrdersListQueryVariables>(FulfillmentOrdersListDocument, options);
        }
export type FulfillmentOrdersListQueryHookResult = ReturnType<typeof useFulfillmentOrdersListQuery>;
export type FulfillmentOrdersListLazyQueryHookResult = ReturnType<typeof useFulfillmentOrdersListLazyQuery>;
export type FulfillmentOrdersListSuspenseQueryHookResult = ReturnType<typeof useFulfillmentOrdersListSuspenseQuery>;
export type FulfillmentOrdersListQueryResult = Apollo.QueryResult<FulfillmentOrdersListQuery, FulfillmentOrdersListQueryVariables>;
export const FulfillmentOrderDocument = gql`
    query FulfillmentOrder($fulfillmentOrderId: ID!) {
  fulfillmentOrder(id: $fulfillmentOrderId) {
    id
    secondaryId
    registerId
    locationId
    fulfillmentId
    acceptedByUserId
    acceptedAt
    status
    shippingProvider
    consignmentNumber
    packedByUserId
    packedAt
    completedAt
    createdBy
    createdAt
    updatedAt
    location {
      id
      name
      secondaryId
    }
    order {
      secondaryId
      comment
      customer {
        id
        name
        phoneNumber
      }
      address {
        landmark
        latitude
        longitude
        streetAddress1
        streetAddress2
        streetName
        buildingNo
        additionalNumber
        state
        city {
          name
          country {
            name
          }
        }
      }
      payments {
        id
        method
        status
      }
    }
    lines {
      id
      secondaryId
      productId
      quantity
      fulfilledQuantity
      pickerUserId
      pickerAssignedAt
      pickerTaskId
      status
      createdAt
      updatedAt
      pickerTasks {
        id
        picker {
          id
          secondaryId
          firstName
          lastName
        }
        status
        scannedQuantity
        quantityToPick
        completedAt
      }
      product {
        name
      }
    }
    trackingUrl
    register {
      name
      id
    }
  }
}
    `;

/**
 * __useFulfillmentOrderQuery__
 *
 * To run a query within a React component, call `useFulfillmentOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useFulfillmentOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFulfillmentOrderQuery({
 *   variables: {
 *      fulfillmentOrderId: // value for 'fulfillmentOrderId'
 *   },
 * });
 */
export function useFulfillmentOrderQuery(baseOptions: Apollo.QueryHookOptions<FulfillmentOrderQuery, FulfillmentOrderQueryVariables> & ({ variables: FulfillmentOrderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FulfillmentOrderQuery, FulfillmentOrderQueryVariables>(FulfillmentOrderDocument, options);
      }
export function useFulfillmentOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FulfillmentOrderQuery, FulfillmentOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FulfillmentOrderQuery, FulfillmentOrderQueryVariables>(FulfillmentOrderDocument, options);
        }
// @ts-ignore
export function useFulfillmentOrderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FulfillmentOrderQuery, FulfillmentOrderQueryVariables>): Apollo.UseSuspenseQueryResult<FulfillmentOrderQuery, FulfillmentOrderQueryVariables>;
export function useFulfillmentOrderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FulfillmentOrderQuery, FulfillmentOrderQueryVariables>): Apollo.UseSuspenseQueryResult<FulfillmentOrderQuery | undefined, FulfillmentOrderQueryVariables>;
export function useFulfillmentOrderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FulfillmentOrderQuery, FulfillmentOrderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FulfillmentOrderQuery, FulfillmentOrderQueryVariables>(FulfillmentOrderDocument, options);
        }
export type FulfillmentOrderQueryHookResult = ReturnType<typeof useFulfillmentOrderQuery>;
export type FulfillmentOrderLazyQueryHookResult = ReturnType<typeof useFulfillmentOrderLazyQuery>;
export type FulfillmentOrderSuspenseQueryHookResult = ReturnType<typeof useFulfillmentOrderSuspenseQuery>;
export type FulfillmentOrderQueryResult = Apollo.QueryResult<FulfillmentOrderQuery, FulfillmentOrderQueryVariables>;
export const UnassignFulfillmentOrderLinesDocument = gql`
    mutation UnassignFulfillmentOrderLines($input: UnassignFulfillmentOrderLinesInput!) {
  unassignFulfillmentOrderLines(input: $input) {
    id
  }
}
    `;
export type UnassignFulfillmentOrderLinesMutationFn = Apollo.MutationFunction<UnassignFulfillmentOrderLinesMutation, UnassignFulfillmentOrderLinesMutationVariables>;

/**
 * __useUnassignFulfillmentOrderLinesMutation__
 *
 * To run a mutation, you first call `useUnassignFulfillmentOrderLinesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnassignFulfillmentOrderLinesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unassignFulfillmentOrderLinesMutation, { data, loading, error }] = useUnassignFulfillmentOrderLinesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnassignFulfillmentOrderLinesMutation(baseOptions?: Apollo.MutationHookOptions<UnassignFulfillmentOrderLinesMutation, UnassignFulfillmentOrderLinesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnassignFulfillmentOrderLinesMutation, UnassignFulfillmentOrderLinesMutationVariables>(UnassignFulfillmentOrderLinesDocument, options);
      }
export type UnassignFulfillmentOrderLinesMutationHookResult = ReturnType<typeof useUnassignFulfillmentOrderLinesMutation>;
export type UnassignFulfillmentOrderLinesMutationResult = Apollo.MutationResult<UnassignFulfillmentOrderLinesMutation>;
export type UnassignFulfillmentOrderLinesMutationOptions = Apollo.BaseMutationOptions<UnassignFulfillmentOrderLinesMutation, UnassignFulfillmentOrderLinesMutationVariables>;
export const AssignFulfillmentOrderLinesDocument = gql`
    mutation AssignFulfillmentOrderLines($input: AssignFulfillmentOrderLinesInput!) {
  assignFulfillmentOrderLines(input: $input) {
    id
  }
}
    `;
export type AssignFulfillmentOrderLinesMutationFn = Apollo.MutationFunction<AssignFulfillmentOrderLinesMutation, AssignFulfillmentOrderLinesMutationVariables>;

/**
 * __useAssignFulfillmentOrderLinesMutation__
 *
 * To run a mutation, you first call `useAssignFulfillmentOrderLinesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignFulfillmentOrderLinesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignFulfillmentOrderLinesMutation, { data, loading, error }] = useAssignFulfillmentOrderLinesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignFulfillmentOrderLinesMutation(baseOptions?: Apollo.MutationHookOptions<AssignFulfillmentOrderLinesMutation, AssignFulfillmentOrderLinesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignFulfillmentOrderLinesMutation, AssignFulfillmentOrderLinesMutationVariables>(AssignFulfillmentOrderLinesDocument, options);
      }
export type AssignFulfillmentOrderLinesMutationHookResult = ReturnType<typeof useAssignFulfillmentOrderLinesMutation>;
export type AssignFulfillmentOrderLinesMutationResult = Apollo.MutationResult<AssignFulfillmentOrderLinesMutation>;
export type AssignFulfillmentOrderLinesMutationOptions = Apollo.BaseMutationOptions<AssignFulfillmentOrderLinesMutation, AssignFulfillmentOrderLinesMutationVariables>;
export const AssignPosRegisterDocument = gql`
    mutation AssignPosRegister($fulfillmentOrderId: ID!, $registerId: ID!) {
  assignPosRegister(
    fulfillmentOrderId: $fulfillmentOrderId
    registerId: $registerId
  )
}
    `;
export type AssignPosRegisterMutationFn = Apollo.MutationFunction<AssignPosRegisterMutation, AssignPosRegisterMutationVariables>;

/**
 * __useAssignPosRegisterMutation__
 *
 * To run a mutation, you first call `useAssignPosRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignPosRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignPosRegisterMutation, { data, loading, error }] = useAssignPosRegisterMutation({
 *   variables: {
 *      fulfillmentOrderId: // value for 'fulfillmentOrderId'
 *      registerId: // value for 'registerId'
 *   },
 * });
 */
export function useAssignPosRegisterMutation(baseOptions?: Apollo.MutationHookOptions<AssignPosRegisterMutation, AssignPosRegisterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignPosRegisterMutation, AssignPosRegisterMutationVariables>(AssignPosRegisterDocument, options);
      }
export type AssignPosRegisterMutationHookResult = ReturnType<typeof useAssignPosRegisterMutation>;
export type AssignPosRegisterMutationResult = Apollo.MutationResult<AssignPosRegisterMutation>;
export type AssignPosRegisterMutationOptions = Apollo.BaseMutationOptions<AssignPosRegisterMutation, AssignPosRegisterMutationVariables>;
export const PickerTasksDocument = gql`
    query PickerTasks($sort: [SortCondition!], $page: Int!, $limit: Int!, $locationId: String, $filter: [FilterGroup!], $tabFilter: PickerTaskTabFilter) {
  pickerTasks(
    sort: $sort
    page: $page
    limit: $limit
    locationId: $locationId
    filter: $filter
    tabFilter: $tabFilter
  ) {
    meta {
      page
      limit
      totalCount
      total
    }
    data {
      orderId
      orderNumber
      fulfillmentOrderId
      fulfillmentId
      customerName
      partnerName
      orderChannel
      orderSource
      totalItems
      pickedItems
      fulfillmentStatus
      tasks {
        id
        fulfillmentOrderId
        status
        quantityToPick
        scannedQuantity
        locationId
        locationName
        productName
        productSku
        productGtin
        orderCancelled
        startedAt
        completedAt
      }
    }
  }
}
    `;

/**
 * __usePickerTasksQuery__
 *
 * To run a query within a React component, call `usePickerTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `usePickerTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePickerTasksQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      locationId: // value for 'locationId'
 *      filter: // value for 'filter'
 *      tabFilter: // value for 'tabFilter'
 *   },
 * });
 */
export function usePickerTasksQuery(baseOptions: Apollo.QueryHookOptions<PickerTasksQuery, PickerTasksQueryVariables> & ({ variables: PickerTasksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PickerTasksQuery, PickerTasksQueryVariables>(PickerTasksDocument, options);
      }
export function usePickerTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PickerTasksQuery, PickerTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PickerTasksQuery, PickerTasksQueryVariables>(PickerTasksDocument, options);
        }
// @ts-ignore
export function usePickerTasksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PickerTasksQuery, PickerTasksQueryVariables>): Apollo.UseSuspenseQueryResult<PickerTasksQuery, PickerTasksQueryVariables>;
export function usePickerTasksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PickerTasksQuery, PickerTasksQueryVariables>): Apollo.UseSuspenseQueryResult<PickerTasksQuery | undefined, PickerTasksQueryVariables>;
export function usePickerTasksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PickerTasksQuery, PickerTasksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PickerTasksQuery, PickerTasksQueryVariables>(PickerTasksDocument, options);
        }
export type PickerTasksQueryHookResult = ReturnType<typeof usePickerTasksQuery>;
export type PickerTasksLazyQueryHookResult = ReturnType<typeof usePickerTasksLazyQuery>;
export type PickerTasksSuspenseQueryHookResult = ReturnType<typeof usePickerTasksSuspenseQuery>;
export type PickerTasksQueryResult = Apollo.QueryResult<PickerTasksQuery, PickerTasksQueryVariables>;
export const PickerTaskSummaryDocument = gql`
    query PickerTaskSummary {
  pickerTaskSummary {
    toStart
    inProgress
    completed
    cancelled
    unitsLeft
  }
}
    `;

/**
 * __usePickerTaskSummaryQuery__
 *
 * To run a query within a React component, call `usePickerTaskSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePickerTaskSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePickerTaskSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function usePickerTaskSummaryQuery(baseOptions?: Apollo.QueryHookOptions<PickerTaskSummaryQuery, PickerTaskSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PickerTaskSummaryQuery, PickerTaskSummaryQueryVariables>(PickerTaskSummaryDocument, options);
      }
export function usePickerTaskSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PickerTaskSummaryQuery, PickerTaskSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PickerTaskSummaryQuery, PickerTaskSummaryQueryVariables>(PickerTaskSummaryDocument, options);
        }
// @ts-ignore
export function usePickerTaskSummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PickerTaskSummaryQuery, PickerTaskSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<PickerTaskSummaryQuery, PickerTaskSummaryQueryVariables>;
export function usePickerTaskSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PickerTaskSummaryQuery, PickerTaskSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<PickerTaskSummaryQuery | undefined, PickerTaskSummaryQueryVariables>;
export function usePickerTaskSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PickerTaskSummaryQuery, PickerTaskSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PickerTaskSummaryQuery, PickerTaskSummaryQueryVariables>(PickerTaskSummaryDocument, options);
        }
export type PickerTaskSummaryQueryHookResult = ReturnType<typeof usePickerTaskSummaryQuery>;
export type PickerTaskSummaryLazyQueryHookResult = ReturnType<typeof usePickerTaskSummaryLazyQuery>;
export type PickerTaskSummarySuspenseQueryHookResult = ReturnType<typeof usePickerTaskSummarySuspenseQuery>;
export type PickerTaskSummaryQueryResult = Apollo.QueryResult<PickerTaskSummaryQuery, PickerTaskSummaryQueryVariables>;
export const StartPickerTaskDocument = gql`
    mutation StartPickerTask($startPickerTaskId: ID!) {
  startPickerTask(id: $startPickerTaskId) {
    id
  }
}
    `;
export type StartPickerTaskMutationFn = Apollo.MutationFunction<StartPickerTaskMutation, StartPickerTaskMutationVariables>;

/**
 * __useStartPickerTaskMutation__
 *
 * To run a mutation, you first call `useStartPickerTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartPickerTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startPickerTaskMutation, { data, loading, error }] = useStartPickerTaskMutation({
 *   variables: {
 *      startPickerTaskId: // value for 'startPickerTaskId'
 *   },
 * });
 */
export function useStartPickerTaskMutation(baseOptions?: Apollo.MutationHookOptions<StartPickerTaskMutation, StartPickerTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartPickerTaskMutation, StartPickerTaskMutationVariables>(StartPickerTaskDocument, options);
      }
export type StartPickerTaskMutationHookResult = ReturnType<typeof useStartPickerTaskMutation>;
export type StartPickerTaskMutationResult = Apollo.MutationResult<StartPickerTaskMutation>;
export type StartPickerTaskMutationOptions = Apollo.BaseMutationOptions<StartPickerTaskMutation, StartPickerTaskMutationVariables>;
export const ScanPickerTaskUnitDocument = gql`
    mutation ScanPickerTaskUnit($input: ScanPickerTaskUnitInput!) {
  scanPickerTaskUnit(input: $input) {
    id
  }
}
    `;
export type ScanPickerTaskUnitMutationFn = Apollo.MutationFunction<ScanPickerTaskUnitMutation, ScanPickerTaskUnitMutationVariables>;

/**
 * __useScanPickerTaskUnitMutation__
 *
 * To run a mutation, you first call `useScanPickerTaskUnitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScanPickerTaskUnitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scanPickerTaskUnitMutation, { data, loading, error }] = useScanPickerTaskUnitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useScanPickerTaskUnitMutation(baseOptions?: Apollo.MutationHookOptions<ScanPickerTaskUnitMutation, ScanPickerTaskUnitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ScanPickerTaskUnitMutation, ScanPickerTaskUnitMutationVariables>(ScanPickerTaskUnitDocument, options);
      }
export type ScanPickerTaskUnitMutationHookResult = ReturnType<typeof useScanPickerTaskUnitMutation>;
export type ScanPickerTaskUnitMutationResult = Apollo.MutationResult<ScanPickerTaskUnitMutation>;
export type ScanPickerTaskUnitMutationOptions = Apollo.BaseMutationOptions<ScanPickerTaskUnitMutation, ScanPickerTaskUnitMutationVariables>;
export const PickerTaskDocument = gql`
    query PickerTask($pickerTaskId: ID!) {
  pickerTask(id: $pickerTaskId) {
    scannedQuantity
    quantityToPick
    lots {
      actionId
      sellableQuantity
      createdAt
    }
    status
    fulfillmentOrderLine {
      product {
        name
      }
    }
  }
}
    `;

/**
 * __usePickerTaskQuery__
 *
 * To run a query within a React component, call `usePickerTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `usePickerTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePickerTaskQuery({
 *   variables: {
 *      pickerTaskId: // value for 'pickerTaskId'
 *   },
 * });
 */
export function usePickerTaskQuery(baseOptions: Apollo.QueryHookOptions<PickerTaskQuery, PickerTaskQueryVariables> & ({ variables: PickerTaskQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PickerTaskQuery, PickerTaskQueryVariables>(PickerTaskDocument, options);
      }
export function usePickerTaskLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PickerTaskQuery, PickerTaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PickerTaskQuery, PickerTaskQueryVariables>(PickerTaskDocument, options);
        }
// @ts-ignore
export function usePickerTaskSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PickerTaskQuery, PickerTaskQueryVariables>): Apollo.UseSuspenseQueryResult<PickerTaskQuery, PickerTaskQueryVariables>;
export function usePickerTaskSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PickerTaskQuery, PickerTaskQueryVariables>): Apollo.UseSuspenseQueryResult<PickerTaskQuery | undefined, PickerTaskQueryVariables>;
export function usePickerTaskSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PickerTaskQuery, PickerTaskQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PickerTaskQuery, PickerTaskQueryVariables>(PickerTaskDocument, options);
        }
export type PickerTaskQueryHookResult = ReturnType<typeof usePickerTaskQuery>;
export type PickerTaskLazyQueryHookResult = ReturnType<typeof usePickerTaskLazyQuery>;
export type PickerTaskSuspenseQueryHookResult = ReturnType<typeof usePickerTaskSuspenseQuery>;
export type PickerTaskQueryResult = Apollo.QueryResult<PickerTaskQuery, PickerTaskQueryVariables>;
export const FulfillmentOrderListDocument = gql`
    query FulfillmentOrderList($sort: [SortCondition!], $locationId: String, $registerId: String, $isRegisterAssigned: Boolean, $limit: Int!, $page: Int!, $filter: [FilterGroup!], $tabFilter: FulfillmentOrderListFilter) {
  fulfillmentOrderList(
    sort: $sort
    locationId: $locationId
    registerId: $registerId
    isRegisterAssigned: $isRegisterAssigned
    limit: $limit
    page: $page
    filter: $filter
    tabFilter: $tabFilter
  ) {
    meta {
      page
      limit
      totalCount
      total
    }
    data {
      fulfillmentOrderId
      fulfillmentId
      orderId
      orderNumber
      customerName
      partnerName
      orderChannel
      orderSource
      fulfillmentOrderStatus
      shippingProvider
      consignmentNumber
      lotsLockedAt
      registerId
      createdAt
      totalPicked
      totalQuantity
      totalReady
      lines {
        lineId
        taskId
        productId
        productName
        productSku
        trackingLevel
        locationName
        quantity
        pickedQuantity
        readyQuantity
        sentQuantity
        lineStatus
      }
    }
  }
}
    `;

/**
 * __useFulfillmentOrderListQuery__
 *
 * To run a query within a React component, call `useFulfillmentOrderListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFulfillmentOrderListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFulfillmentOrderListQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      locationId: // value for 'locationId'
 *      registerId: // value for 'registerId'
 *      isRegisterAssigned: // value for 'isRegisterAssigned'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *      tabFilter: // value for 'tabFilter'
 *   },
 * });
 */
export function useFulfillmentOrderListQuery(baseOptions: Apollo.QueryHookOptions<FulfillmentOrderListQuery, FulfillmentOrderListQueryVariables> & ({ variables: FulfillmentOrderListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FulfillmentOrderListQuery, FulfillmentOrderListQueryVariables>(FulfillmentOrderListDocument, options);
      }
export function useFulfillmentOrderListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FulfillmentOrderListQuery, FulfillmentOrderListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FulfillmentOrderListQuery, FulfillmentOrderListQueryVariables>(FulfillmentOrderListDocument, options);
        }
// @ts-ignore
export function useFulfillmentOrderListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FulfillmentOrderListQuery, FulfillmentOrderListQueryVariables>): Apollo.UseSuspenseQueryResult<FulfillmentOrderListQuery, FulfillmentOrderListQueryVariables>;
export function useFulfillmentOrderListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FulfillmentOrderListQuery, FulfillmentOrderListQueryVariables>): Apollo.UseSuspenseQueryResult<FulfillmentOrderListQuery | undefined, FulfillmentOrderListQueryVariables>;
export function useFulfillmentOrderListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FulfillmentOrderListQuery, FulfillmentOrderListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FulfillmentOrderListQuery, FulfillmentOrderListQueryVariables>(FulfillmentOrderListDocument, options);
        }
export type FulfillmentOrderListQueryHookResult = ReturnType<typeof useFulfillmentOrderListQuery>;
export type FulfillmentOrderListLazyQueryHookResult = ReturnType<typeof useFulfillmentOrderListLazyQuery>;
export type FulfillmentOrderListSuspenseQueryHookResult = ReturnType<typeof useFulfillmentOrderListSuspenseQuery>;
export type FulfillmentOrderListQueryResult = Apollo.QueryResult<FulfillmentOrderListQuery, FulfillmentOrderListQueryVariables>;
export const FulfillmentOrderListForBulkDispatchDocument = gql`
    query FulfillmentOrderListForBulkDispatch($sort: [SortCondition!], $locationId: String, $limit: Int!, $page: Int!, $filter: [FilterGroup!], $tabFilter: FulfillmentOrderListFilter) {
  fulfillmentOrderList(
    sort: $sort
    locationId: $locationId
    limit: $limit
    page: $page
    filter: $filter
    tabFilter: $tabFilter
  ) {
    meta {
      page
      limit
      totalCount
      total
    }
    data {
      fulfillmentOrderId
      fulfillmentId
      orderId
      orderNumber
      customerName
      partnerName
      orderChannel
      orderSource
      fulfillmentOrderStatus
      shippingProvider
      consignmentNumber
      createdAt
      totalPicked
      totalQuantity
      totalReady
    }
  }
}
    `;

/**
 * __useFulfillmentOrderListForBulkDispatchQuery__
 *
 * To run a query within a React component, call `useFulfillmentOrderListForBulkDispatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useFulfillmentOrderListForBulkDispatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFulfillmentOrderListForBulkDispatchQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      locationId: // value for 'locationId'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *      tabFilter: // value for 'tabFilter'
 *   },
 * });
 */
export function useFulfillmentOrderListForBulkDispatchQuery(baseOptions: Apollo.QueryHookOptions<FulfillmentOrderListForBulkDispatchQuery, FulfillmentOrderListForBulkDispatchQueryVariables> & ({ variables: FulfillmentOrderListForBulkDispatchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FulfillmentOrderListForBulkDispatchQuery, FulfillmentOrderListForBulkDispatchQueryVariables>(FulfillmentOrderListForBulkDispatchDocument, options);
      }
export function useFulfillmentOrderListForBulkDispatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FulfillmentOrderListForBulkDispatchQuery, FulfillmentOrderListForBulkDispatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FulfillmentOrderListForBulkDispatchQuery, FulfillmentOrderListForBulkDispatchQueryVariables>(FulfillmentOrderListForBulkDispatchDocument, options);
        }
// @ts-ignore
export function useFulfillmentOrderListForBulkDispatchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FulfillmentOrderListForBulkDispatchQuery, FulfillmentOrderListForBulkDispatchQueryVariables>): Apollo.UseSuspenseQueryResult<FulfillmentOrderListForBulkDispatchQuery, FulfillmentOrderListForBulkDispatchQueryVariables>;
export function useFulfillmentOrderListForBulkDispatchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FulfillmentOrderListForBulkDispatchQuery, FulfillmentOrderListForBulkDispatchQueryVariables>): Apollo.UseSuspenseQueryResult<FulfillmentOrderListForBulkDispatchQuery | undefined, FulfillmentOrderListForBulkDispatchQueryVariables>;
export function useFulfillmentOrderListForBulkDispatchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FulfillmentOrderListForBulkDispatchQuery, FulfillmentOrderListForBulkDispatchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FulfillmentOrderListForBulkDispatchQuery, FulfillmentOrderListForBulkDispatchQueryVariables>(FulfillmentOrderListForBulkDispatchDocument, options);
        }
export type FulfillmentOrderListForBulkDispatchQueryHookResult = ReturnType<typeof useFulfillmentOrderListForBulkDispatchQuery>;
export type FulfillmentOrderListForBulkDispatchLazyQueryHookResult = ReturnType<typeof useFulfillmentOrderListForBulkDispatchLazyQuery>;
export type FulfillmentOrderListForBulkDispatchSuspenseQueryHookResult = ReturnType<typeof useFulfillmentOrderListForBulkDispatchSuspenseQuery>;
export type FulfillmentOrderListForBulkDispatchQueryResult = Apollo.QueryResult<FulfillmentOrderListForBulkDispatchQuery, FulfillmentOrderListForBulkDispatchQueryVariables>;
export const RejectLotDocument = gql`
    mutation RejectLot($input: RejectLotInput!) {
  rejectLot(input: $input) {
    success
  }
}
    `;
export type RejectLotMutationFn = Apollo.MutationFunction<RejectLotMutation, RejectLotMutationVariables>;

/**
 * __useRejectLotMutation__
 *
 * To run a mutation, you first call `useRejectLotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectLotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectLotMutation, { data, loading, error }] = useRejectLotMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRejectLotMutation(baseOptions?: Apollo.MutationHookOptions<RejectLotMutation, RejectLotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectLotMutation, RejectLotMutationVariables>(RejectLotDocument, options);
      }
export type RejectLotMutationHookResult = ReturnType<typeof useRejectLotMutation>;
export type RejectLotMutationResult = Apollo.MutationResult<RejectLotMutation>;
export type RejectLotMutationOptions = Apollo.BaseMutationOptions<RejectLotMutation, RejectLotMutationVariables>;
export const FulfillmentOrderPickingProgressDocument = gql`
    query FulfillmentOrderPickingProgress($fulfillmentOrderId: ID!) {
  fulfillmentOrderPickingProgress(fulfillmentOrderId: $fulfillmentOrderId) {
    fulfillmentOrderId
    totalUnits
    pickedUnits
    beingPickedUnits
    assignedUnits
    unassignedUnits
    readyToDispatchUnits
    dispatchedUnits
  }
}
    `;

/**
 * __useFulfillmentOrderPickingProgressQuery__
 *
 * To run a query within a React component, call `useFulfillmentOrderPickingProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useFulfillmentOrderPickingProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFulfillmentOrderPickingProgressQuery({
 *   variables: {
 *      fulfillmentOrderId: // value for 'fulfillmentOrderId'
 *   },
 * });
 */
export function useFulfillmentOrderPickingProgressQuery(baseOptions: Apollo.QueryHookOptions<FulfillmentOrderPickingProgressQuery, FulfillmentOrderPickingProgressQueryVariables> & ({ variables: FulfillmentOrderPickingProgressQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FulfillmentOrderPickingProgressQuery, FulfillmentOrderPickingProgressQueryVariables>(FulfillmentOrderPickingProgressDocument, options);
      }
export function useFulfillmentOrderPickingProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FulfillmentOrderPickingProgressQuery, FulfillmentOrderPickingProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FulfillmentOrderPickingProgressQuery, FulfillmentOrderPickingProgressQueryVariables>(FulfillmentOrderPickingProgressDocument, options);
        }
// @ts-ignore
export function useFulfillmentOrderPickingProgressSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FulfillmentOrderPickingProgressQuery, FulfillmentOrderPickingProgressQueryVariables>): Apollo.UseSuspenseQueryResult<FulfillmentOrderPickingProgressQuery, FulfillmentOrderPickingProgressQueryVariables>;
export function useFulfillmentOrderPickingProgressSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FulfillmentOrderPickingProgressQuery, FulfillmentOrderPickingProgressQueryVariables>): Apollo.UseSuspenseQueryResult<FulfillmentOrderPickingProgressQuery | undefined, FulfillmentOrderPickingProgressQueryVariables>;
export function useFulfillmentOrderPickingProgressSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FulfillmentOrderPickingProgressQuery, FulfillmentOrderPickingProgressQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FulfillmentOrderPickingProgressQuery, FulfillmentOrderPickingProgressQueryVariables>(FulfillmentOrderPickingProgressDocument, options);
        }
export type FulfillmentOrderPickingProgressQueryHookResult = ReturnType<typeof useFulfillmentOrderPickingProgressQuery>;
export type FulfillmentOrderPickingProgressLazyQueryHookResult = ReturnType<typeof useFulfillmentOrderPickingProgressLazyQuery>;
export type FulfillmentOrderPickingProgressSuspenseQueryHookResult = ReturnType<typeof useFulfillmentOrderPickingProgressSuspenseQuery>;
export type FulfillmentOrderPickingProgressQueryResult = Apollo.QueryResult<FulfillmentOrderPickingProgressQuery, FulfillmentOrderPickingProgressQueryVariables>;
export const ReadyToDispatchDocument = gql`
    mutation ReadyToDispatch($input: ReadyToDispatchInput!) {
  readyToDispatch(input: $input) {
    id
  }
}
    `;
export type ReadyToDispatchMutationFn = Apollo.MutationFunction<ReadyToDispatchMutation, ReadyToDispatchMutationVariables>;

/**
 * __useReadyToDispatchMutation__
 *
 * To run a mutation, you first call `useReadyToDispatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReadyToDispatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [readyToDispatchMutation, { data, loading, error }] = useReadyToDispatchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReadyToDispatchMutation(baseOptions?: Apollo.MutationHookOptions<ReadyToDispatchMutation, ReadyToDispatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReadyToDispatchMutation, ReadyToDispatchMutationVariables>(ReadyToDispatchDocument, options);
      }
export type ReadyToDispatchMutationHookResult = ReturnType<typeof useReadyToDispatchMutation>;
export type ReadyToDispatchMutationResult = Apollo.MutationResult<ReadyToDispatchMutation>;
export type ReadyToDispatchMutationOptions = Apollo.BaseMutationOptions<ReadyToDispatchMutation, ReadyToDispatchMutationVariables>;
export const FulfillmentOrderTabCountsDocument = gql`
    query FulfillmentOrderTabCounts($locationId: String) {
  fulfillmentOrderTabCounts(locationId: $locationId) {
    picking
    picked
    readyForDispatch
    dispatched
    delivered
    all
  }
}
    `;

/**
 * __useFulfillmentOrderTabCountsQuery__
 *
 * To run a query within a React component, call `useFulfillmentOrderTabCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFulfillmentOrderTabCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFulfillmentOrderTabCountsQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useFulfillmentOrderTabCountsQuery(baseOptions?: Apollo.QueryHookOptions<FulfillmentOrderTabCountsQuery, FulfillmentOrderTabCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FulfillmentOrderTabCountsQuery, FulfillmentOrderTabCountsQueryVariables>(FulfillmentOrderTabCountsDocument, options);
      }
export function useFulfillmentOrderTabCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FulfillmentOrderTabCountsQuery, FulfillmentOrderTabCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FulfillmentOrderTabCountsQuery, FulfillmentOrderTabCountsQueryVariables>(FulfillmentOrderTabCountsDocument, options);
        }
// @ts-ignore
export function useFulfillmentOrderTabCountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FulfillmentOrderTabCountsQuery, FulfillmentOrderTabCountsQueryVariables>): Apollo.UseSuspenseQueryResult<FulfillmentOrderTabCountsQuery, FulfillmentOrderTabCountsQueryVariables>;
export function useFulfillmentOrderTabCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FulfillmentOrderTabCountsQuery, FulfillmentOrderTabCountsQueryVariables>): Apollo.UseSuspenseQueryResult<FulfillmentOrderTabCountsQuery | undefined, FulfillmentOrderTabCountsQueryVariables>;
export function useFulfillmentOrderTabCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FulfillmentOrderTabCountsQuery, FulfillmentOrderTabCountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FulfillmentOrderTabCountsQuery, FulfillmentOrderTabCountsQueryVariables>(FulfillmentOrderTabCountsDocument, options);
        }
export type FulfillmentOrderTabCountsQueryHookResult = ReturnType<typeof useFulfillmentOrderTabCountsQuery>;
export type FulfillmentOrderTabCountsLazyQueryHookResult = ReturnType<typeof useFulfillmentOrderTabCountsLazyQuery>;
export type FulfillmentOrderTabCountsSuspenseQueryHookResult = ReturnType<typeof useFulfillmentOrderTabCountsSuspenseQuery>;
export type FulfillmentOrderTabCountsQueryResult = Apollo.QueryResult<FulfillmentOrderTabCountsQuery, FulfillmentOrderTabCountsQueryVariables>;
export const MarkDispatchedDocument = gql`
    mutation MarkDispatched($input: MarkDispatchedInput!) {
  markDispatched(input: $input) {
    id
  }
}
    `;
export type MarkDispatchedMutationFn = Apollo.MutationFunction<MarkDispatchedMutation, MarkDispatchedMutationVariables>;

/**
 * __useMarkDispatchedMutation__
 *
 * To run a mutation, you first call `useMarkDispatchedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkDispatchedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markDispatchedMutation, { data, loading, error }] = useMarkDispatchedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkDispatchedMutation(baseOptions?: Apollo.MutationHookOptions<MarkDispatchedMutation, MarkDispatchedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkDispatchedMutation, MarkDispatchedMutationVariables>(MarkDispatchedDocument, options);
      }
export type MarkDispatchedMutationHookResult = ReturnType<typeof useMarkDispatchedMutation>;
export type MarkDispatchedMutationResult = Apollo.MutationResult<MarkDispatchedMutation>;
export type MarkDispatchedMutationOptions = Apollo.BaseMutationOptions<MarkDispatchedMutation, MarkDispatchedMutationVariables>;
export const MarkDeliveredDocument = gql`
    mutation MarkDelivered($input: MarkDeliveredInput!) {
  markDelivered(input: $input) {
    id
    deliveredAt
  }
}
    `;
export type MarkDeliveredMutationFn = Apollo.MutationFunction<MarkDeliveredMutation, MarkDeliveredMutationVariables>;

/**
 * __useMarkDeliveredMutation__
 *
 * To run a mutation, you first call `useMarkDeliveredMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkDeliveredMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markDeliveredMutation, { data, loading, error }] = useMarkDeliveredMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkDeliveredMutation(baseOptions?: Apollo.MutationHookOptions<MarkDeliveredMutation, MarkDeliveredMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkDeliveredMutation, MarkDeliveredMutationVariables>(MarkDeliveredDocument, options);
      }
export type MarkDeliveredMutationHookResult = ReturnType<typeof useMarkDeliveredMutation>;
export type MarkDeliveredMutationResult = Apollo.MutationResult<MarkDeliveredMutation>;
export type MarkDeliveredMutationOptions = Apollo.BaseMutationOptions<MarkDeliveredMutation, MarkDeliveredMutationVariables>;
export const PickerTaskLotsDocument = gql`
    query PickerTaskLots($taskId: ID!) {
  pickerTaskLots(taskId: $taskId) {
    id
    lotId
    actionId
    sellableQuantity
    status
    createdAt
  }
}
    `;

/**
 * __usePickerTaskLotsQuery__
 *
 * To run a query within a React component, call `usePickerTaskLotsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePickerTaskLotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePickerTaskLotsQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function usePickerTaskLotsQuery(baseOptions: Apollo.QueryHookOptions<PickerTaskLotsQuery, PickerTaskLotsQueryVariables> & ({ variables: PickerTaskLotsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PickerTaskLotsQuery, PickerTaskLotsQueryVariables>(PickerTaskLotsDocument, options);
      }
export function usePickerTaskLotsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PickerTaskLotsQuery, PickerTaskLotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PickerTaskLotsQuery, PickerTaskLotsQueryVariables>(PickerTaskLotsDocument, options);
        }
// @ts-ignore
export function usePickerTaskLotsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PickerTaskLotsQuery, PickerTaskLotsQueryVariables>): Apollo.UseSuspenseQueryResult<PickerTaskLotsQuery, PickerTaskLotsQueryVariables>;
export function usePickerTaskLotsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PickerTaskLotsQuery, PickerTaskLotsQueryVariables>): Apollo.UseSuspenseQueryResult<PickerTaskLotsQuery | undefined, PickerTaskLotsQueryVariables>;
export function usePickerTaskLotsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PickerTaskLotsQuery, PickerTaskLotsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PickerTaskLotsQuery, PickerTaskLotsQueryVariables>(PickerTaskLotsDocument, options);
        }
export type PickerTaskLotsQueryHookResult = ReturnType<typeof usePickerTaskLotsQuery>;
export type PickerTaskLotsLazyQueryHookResult = ReturnType<typeof usePickerTaskLotsLazyQuery>;
export type PickerTaskLotsSuspenseQueryHookResult = ReturnType<typeof usePickerTaskLotsSuspenseQuery>;
export type PickerTaskLotsQueryResult = Apollo.QueryResult<PickerTaskLotsQuery, PickerTaskLotsQueryVariables>;
export const FusionCarrierCostCentresDocument = gql`
    query FusionCarrierCostCentres($connectionId: String!) {
  fusionCarrierCostCentres(connectionId: $connectionId) {
    code
    name
    cityName
    pickupAddress
    returnAddress
    phoneNumber
    email
  }
}
    `;

/**
 * __useFusionCarrierCostCentresQuery__
 *
 * To run a query within a React component, call `useFusionCarrierCostCentresQuery` and pass it any options that fit your needs.
 * When your component renders, `useFusionCarrierCostCentresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFusionCarrierCostCentresQuery({
 *   variables: {
 *      connectionId: // value for 'connectionId'
 *   },
 * });
 */
export function useFusionCarrierCostCentresQuery(baseOptions: Apollo.QueryHookOptions<FusionCarrierCostCentresQuery, FusionCarrierCostCentresQueryVariables> & ({ variables: FusionCarrierCostCentresQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FusionCarrierCostCentresQuery, FusionCarrierCostCentresQueryVariables>(FusionCarrierCostCentresDocument, options);
      }
export function useFusionCarrierCostCentresLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FusionCarrierCostCentresQuery, FusionCarrierCostCentresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FusionCarrierCostCentresQuery, FusionCarrierCostCentresQueryVariables>(FusionCarrierCostCentresDocument, options);
        }
// @ts-ignore
export function useFusionCarrierCostCentresSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FusionCarrierCostCentresQuery, FusionCarrierCostCentresQueryVariables>): Apollo.UseSuspenseQueryResult<FusionCarrierCostCentresQuery, FusionCarrierCostCentresQueryVariables>;
export function useFusionCarrierCostCentresSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FusionCarrierCostCentresQuery, FusionCarrierCostCentresQueryVariables>): Apollo.UseSuspenseQueryResult<FusionCarrierCostCentresQuery | undefined, FusionCarrierCostCentresQueryVariables>;
export function useFusionCarrierCostCentresSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FusionCarrierCostCentresQuery, FusionCarrierCostCentresQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FusionCarrierCostCentresQuery, FusionCarrierCostCentresQueryVariables>(FusionCarrierCostCentresDocument, options);
        }
export type FusionCarrierCostCentresQueryHookResult = ReturnType<typeof useFusionCarrierCostCentresQuery>;
export type FusionCarrierCostCentresLazyQueryHookResult = ReturnType<typeof useFusionCarrierCostCentresLazyQuery>;
export type FusionCarrierCostCentresSuspenseQueryHookResult = ReturnType<typeof useFusionCarrierCostCentresSuspenseQuery>;
export type FusionCarrierCostCentresQueryResult = Apollo.QueryResult<FusionCarrierCostCentresQuery, FusionCarrierCostCentresQueryVariables>;
export const CreateFusionCarrierCostCentreDocument = gql`
    mutation CreateFusionCarrierCostCentre($input: CreateFusionCarrierCostCentreInput!) {
  createFusionCarrierCostCentre(input: $input)
}
    `;
export type CreateFusionCarrierCostCentreMutationFn = Apollo.MutationFunction<CreateFusionCarrierCostCentreMutation, CreateFusionCarrierCostCentreMutationVariables>;

/**
 * __useCreateFusionCarrierCostCentreMutation__
 *
 * To run a mutation, you first call `useCreateFusionCarrierCostCentreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFusionCarrierCostCentreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFusionCarrierCostCentreMutation, { data, loading, error }] = useCreateFusionCarrierCostCentreMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFusionCarrierCostCentreMutation(baseOptions?: Apollo.MutationHookOptions<CreateFusionCarrierCostCentreMutation, CreateFusionCarrierCostCentreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFusionCarrierCostCentreMutation, CreateFusionCarrierCostCentreMutationVariables>(CreateFusionCarrierCostCentreDocument, options);
      }
export type CreateFusionCarrierCostCentreMutationHookResult = ReturnType<typeof useCreateFusionCarrierCostCentreMutation>;
export type CreateFusionCarrierCostCentreMutationResult = Apollo.MutationResult<CreateFusionCarrierCostCentreMutation>;
export type CreateFusionCarrierCostCentreMutationOptions = Apollo.BaseMutationOptions<CreateFusionCarrierCostCentreMutation, CreateFusionCarrierCostCentreMutationVariables>;
export const FusionCarrierHealthDocument = gql`
    query FusionCarrierHealth($connectionId: String!, $probe: Boolean) {
  fusionCarrierHealth(connectionId: $connectionId, probe: $probe) {
    connectionId
    status
    credentialExpiresAt
    daysUntilExpiry
    expiringSoon
    message
  }
}
    `;

/**
 * __useFusionCarrierHealthQuery__
 *
 * To run a query within a React component, call `useFusionCarrierHealthQuery` and pass it any options that fit your needs.
 * When your component renders, `useFusionCarrierHealthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFusionCarrierHealthQuery({
 *   variables: {
 *      connectionId: // value for 'connectionId'
 *      probe: // value for 'probe'
 *   },
 * });
 */
export function useFusionCarrierHealthQuery(baseOptions: Apollo.QueryHookOptions<FusionCarrierHealthQuery, FusionCarrierHealthQueryVariables> & ({ variables: FusionCarrierHealthQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FusionCarrierHealthQuery, FusionCarrierHealthQueryVariables>(FusionCarrierHealthDocument, options);
      }
export function useFusionCarrierHealthLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FusionCarrierHealthQuery, FusionCarrierHealthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FusionCarrierHealthQuery, FusionCarrierHealthQueryVariables>(FusionCarrierHealthDocument, options);
        }
// @ts-ignore
export function useFusionCarrierHealthSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FusionCarrierHealthQuery, FusionCarrierHealthQueryVariables>): Apollo.UseSuspenseQueryResult<FusionCarrierHealthQuery, FusionCarrierHealthQueryVariables>;
export function useFusionCarrierHealthSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FusionCarrierHealthQuery, FusionCarrierHealthQueryVariables>): Apollo.UseSuspenseQueryResult<FusionCarrierHealthQuery | undefined, FusionCarrierHealthQueryVariables>;
export function useFusionCarrierHealthSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FusionCarrierHealthQuery, FusionCarrierHealthQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FusionCarrierHealthQuery, FusionCarrierHealthQueryVariables>(FusionCarrierHealthDocument, options);
        }
export type FusionCarrierHealthQueryHookResult = ReturnType<typeof useFusionCarrierHealthQuery>;
export type FusionCarrierHealthLazyQueryHookResult = ReturnType<typeof useFusionCarrierHealthLazyQuery>;
export type FusionCarrierHealthSuspenseQueryHookResult = ReturnType<typeof useFusionCarrierHealthSuspenseQuery>;
export type FusionCarrierHealthQueryResult = Apollo.QueryResult<FusionCarrierHealthQuery, FusionCarrierHealthQueryVariables>;
export const FusionCarrierLabelDocument = gql`
    query FusionCarrierLabel($connectionId: String!, $trackingNumber: String!) {
  fusionCarrierLabel(connectionId: $connectionId, trackingNumber: $trackingNumber) {
    consignmentNumber
    contentType
    base64Data
  }
}
    `;

/**
 * __useFusionCarrierLabelQuery__
 *
 * To run a query within a React component, call `useFusionCarrierLabelQuery` and pass it any options that fit your needs.
 * When your component renders, `useFusionCarrierLabelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFusionCarrierLabelQuery({
 *   variables: {
 *      connectionId: // value for 'connectionId'
 *      trackingNumber: // value for 'trackingNumber'
 *   },
 * });
 */
export function useFusionCarrierLabelQuery(baseOptions: Apollo.QueryHookOptions<FusionCarrierLabelQuery, FusionCarrierLabelQueryVariables> & ({ variables: FusionCarrierLabelQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FusionCarrierLabelQuery, FusionCarrierLabelQueryVariables>(FusionCarrierLabelDocument, options);
      }
export function useFusionCarrierLabelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FusionCarrierLabelQuery, FusionCarrierLabelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FusionCarrierLabelQuery, FusionCarrierLabelQueryVariables>(FusionCarrierLabelDocument, options);
        }
// @ts-ignore
export function useFusionCarrierLabelSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FusionCarrierLabelQuery, FusionCarrierLabelQueryVariables>): Apollo.UseSuspenseQueryResult<FusionCarrierLabelQuery, FusionCarrierLabelQueryVariables>;
export function useFusionCarrierLabelSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FusionCarrierLabelQuery, FusionCarrierLabelQueryVariables>): Apollo.UseSuspenseQueryResult<FusionCarrierLabelQuery | undefined, FusionCarrierLabelQueryVariables>;
export function useFusionCarrierLabelSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FusionCarrierLabelQuery, FusionCarrierLabelQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FusionCarrierLabelQuery, FusionCarrierLabelQueryVariables>(FusionCarrierLabelDocument, options);
        }
export type FusionCarrierLabelQueryHookResult = ReturnType<typeof useFusionCarrierLabelQuery>;
export type FusionCarrierLabelLazyQueryHookResult = ReturnType<typeof useFusionCarrierLabelLazyQuery>;
export type FusionCarrierLabelSuspenseQueryHookResult = ReturnType<typeof useFusionCarrierLabelSuspenseQuery>;
export type FusionCarrierLabelQueryResult = Apollo.QueryResult<FusionCarrierLabelQuery, FusionCarrierLabelQueryVariables>;
export const FusionCarrierLocationMappingsDocument = gql`
    query FusionCarrierLocationMappings($connectionId: String!) {
  fusionCarrierLocationMappings(connectionId: $connectionId) {
    id
    locationId
    locationName
    costCentreCode
  }
}
    `;

/**
 * __useFusionCarrierLocationMappingsQuery__
 *
 * To run a query within a React component, call `useFusionCarrierLocationMappingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFusionCarrierLocationMappingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFusionCarrierLocationMappingsQuery({
 *   variables: {
 *      connectionId: // value for 'connectionId'
 *   },
 * });
 */
export function useFusionCarrierLocationMappingsQuery(baseOptions: Apollo.QueryHookOptions<FusionCarrierLocationMappingsQuery, FusionCarrierLocationMappingsQueryVariables> & ({ variables: FusionCarrierLocationMappingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FusionCarrierLocationMappingsQuery, FusionCarrierLocationMappingsQueryVariables>(FusionCarrierLocationMappingsDocument, options);
      }
export function useFusionCarrierLocationMappingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FusionCarrierLocationMappingsQuery, FusionCarrierLocationMappingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FusionCarrierLocationMappingsQuery, FusionCarrierLocationMappingsQueryVariables>(FusionCarrierLocationMappingsDocument, options);
        }
// @ts-ignore
export function useFusionCarrierLocationMappingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FusionCarrierLocationMappingsQuery, FusionCarrierLocationMappingsQueryVariables>): Apollo.UseSuspenseQueryResult<FusionCarrierLocationMappingsQuery, FusionCarrierLocationMappingsQueryVariables>;
export function useFusionCarrierLocationMappingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FusionCarrierLocationMappingsQuery, FusionCarrierLocationMappingsQueryVariables>): Apollo.UseSuspenseQueryResult<FusionCarrierLocationMappingsQuery | undefined, FusionCarrierLocationMappingsQueryVariables>;
export function useFusionCarrierLocationMappingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FusionCarrierLocationMappingsQuery, FusionCarrierLocationMappingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FusionCarrierLocationMappingsQuery, FusionCarrierLocationMappingsQueryVariables>(FusionCarrierLocationMappingsDocument, options);
        }
export type FusionCarrierLocationMappingsQueryHookResult = ReturnType<typeof useFusionCarrierLocationMappingsQuery>;
export type FusionCarrierLocationMappingsLazyQueryHookResult = ReturnType<typeof useFusionCarrierLocationMappingsLazyQuery>;
export type FusionCarrierLocationMappingsSuspenseQueryHookResult = ReturnType<typeof useFusionCarrierLocationMappingsSuspenseQuery>;
export type FusionCarrierLocationMappingsQueryResult = Apollo.QueryResult<FusionCarrierLocationMappingsQuery, FusionCarrierLocationMappingsQueryVariables>;
export const SetFusionCarrierLocationMappingDocument = gql`
    mutation SetFusionCarrierLocationMapping($input: SetFusionCarrierLocationMappingInput!) {
  setFusionCarrierLocationMapping(input: $input) {
    id
    locationId
    locationName
    costCentreCode
  }
}
    `;
export type SetFusionCarrierLocationMappingMutationFn = Apollo.MutationFunction<SetFusionCarrierLocationMappingMutation, SetFusionCarrierLocationMappingMutationVariables>;

/**
 * __useSetFusionCarrierLocationMappingMutation__
 *
 * To run a mutation, you first call `useSetFusionCarrierLocationMappingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetFusionCarrierLocationMappingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setFusionCarrierLocationMappingMutation, { data, loading, error }] = useSetFusionCarrierLocationMappingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetFusionCarrierLocationMappingMutation(baseOptions?: Apollo.MutationHookOptions<SetFusionCarrierLocationMappingMutation, SetFusionCarrierLocationMappingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetFusionCarrierLocationMappingMutation, SetFusionCarrierLocationMappingMutationVariables>(SetFusionCarrierLocationMappingDocument, options);
      }
export type SetFusionCarrierLocationMappingMutationHookResult = ReturnType<typeof useSetFusionCarrierLocationMappingMutation>;
export type SetFusionCarrierLocationMappingMutationResult = Apollo.MutationResult<SetFusionCarrierLocationMappingMutation>;
export type SetFusionCarrierLocationMappingMutationOptions = Apollo.BaseMutationOptions<SetFusionCarrierLocationMappingMutation, SetFusionCarrierLocationMappingMutationVariables>;
export const RemoveFusionCarrierLocationMappingDocument = gql`
    mutation RemoveFusionCarrierLocationMapping($input: RemoveFusionCarrierLocationMappingInput!) {
  removeFusionCarrierLocationMapping(input: $input)
}
    `;
export type RemoveFusionCarrierLocationMappingMutationFn = Apollo.MutationFunction<RemoveFusionCarrierLocationMappingMutation, RemoveFusionCarrierLocationMappingMutationVariables>;

/**
 * __useRemoveFusionCarrierLocationMappingMutation__
 *
 * To run a mutation, you first call `useRemoveFusionCarrierLocationMappingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveFusionCarrierLocationMappingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeFusionCarrierLocationMappingMutation, { data, loading, error }] = useRemoveFusionCarrierLocationMappingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveFusionCarrierLocationMappingMutation(baseOptions?: Apollo.MutationHookOptions<RemoveFusionCarrierLocationMappingMutation, RemoveFusionCarrierLocationMappingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveFusionCarrierLocationMappingMutation, RemoveFusionCarrierLocationMappingMutationVariables>(RemoveFusionCarrierLocationMappingDocument, options);
      }
export type RemoveFusionCarrierLocationMappingMutationHookResult = ReturnType<typeof useRemoveFusionCarrierLocationMappingMutation>;
export type RemoveFusionCarrierLocationMappingMutationResult = Apollo.MutationResult<RemoveFusionCarrierLocationMappingMutation>;
export type RemoveFusionCarrierLocationMappingMutationOptions = Apollo.BaseMutationOptions<RemoveFusionCarrierLocationMappingMutation, RemoveFusionCarrierLocationMappingMutationVariables>;
export const IntegrationCatalogueDocument = gql`
    query IntegrationCatalogue {
  fusionIntegrationCatalogue {
    connectorCode
    displayName
    description
    category
    entitled
    connectionId
    supportedEvents
    authFlow
    features
    settings {
      key
      label
      helpText
      secret
      required
      inputType
      options {
        value
        label
      }
      defaultValue
      visibleWhenKey
      visibleWhenValue
    }
  }
}
    `;

/**
 * __useIntegrationCatalogueQuery__
 *
 * To run a query within a React component, call `useIntegrationCatalogueQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationCatalogueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationCatalogueQuery({
 *   variables: {
 *   },
 * });
 */
export function useIntegrationCatalogueQuery(baseOptions?: Apollo.QueryHookOptions<IntegrationCatalogueQuery, IntegrationCatalogueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntegrationCatalogueQuery, IntegrationCatalogueQueryVariables>(IntegrationCatalogueDocument, options);
      }
export function useIntegrationCatalogueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntegrationCatalogueQuery, IntegrationCatalogueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntegrationCatalogueQuery, IntegrationCatalogueQueryVariables>(IntegrationCatalogueDocument, options);
        }
// @ts-ignore
export function useIntegrationCatalogueSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IntegrationCatalogueQuery, IntegrationCatalogueQueryVariables>): Apollo.UseSuspenseQueryResult<IntegrationCatalogueQuery, IntegrationCatalogueQueryVariables>;
export function useIntegrationCatalogueSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IntegrationCatalogueQuery, IntegrationCatalogueQueryVariables>): Apollo.UseSuspenseQueryResult<IntegrationCatalogueQuery | undefined, IntegrationCatalogueQueryVariables>;
export function useIntegrationCatalogueSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IntegrationCatalogueQuery, IntegrationCatalogueQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IntegrationCatalogueQuery, IntegrationCatalogueQueryVariables>(IntegrationCatalogueDocument, options);
        }
export type IntegrationCatalogueQueryHookResult = ReturnType<typeof useIntegrationCatalogueQuery>;
export type IntegrationCatalogueLazyQueryHookResult = ReturnType<typeof useIntegrationCatalogueLazyQuery>;
export type IntegrationCatalogueSuspenseQueryHookResult = ReturnType<typeof useIntegrationCatalogueSuspenseQuery>;
export type IntegrationCatalogueQueryResult = Apollo.QueryResult<IntegrationCatalogueQuery, IntegrationCatalogueQueryVariables>;
export const MyIntegrationsDocument = gql`
    query MyIntegrations {
  myFusionIntegrations {
    id
    connectorCode
    displayName
    environment
    status
    mappedLocationCount
    mappedProductCount
  }
}
    `;

/**
 * __useMyIntegrationsQuery__
 *
 * To run a query within a React component, call `useMyIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyIntegrationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyIntegrationsQuery(baseOptions?: Apollo.QueryHookOptions<MyIntegrationsQuery, MyIntegrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyIntegrationsQuery, MyIntegrationsQueryVariables>(MyIntegrationsDocument, options);
      }
export function useMyIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyIntegrationsQuery, MyIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyIntegrationsQuery, MyIntegrationsQueryVariables>(MyIntegrationsDocument, options);
        }
// @ts-ignore
export function useMyIntegrationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyIntegrationsQuery, MyIntegrationsQueryVariables>): Apollo.UseSuspenseQueryResult<MyIntegrationsQuery, MyIntegrationsQueryVariables>;
export function useMyIntegrationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyIntegrationsQuery, MyIntegrationsQueryVariables>): Apollo.UseSuspenseQueryResult<MyIntegrationsQuery | undefined, MyIntegrationsQueryVariables>;
export function useMyIntegrationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyIntegrationsQuery, MyIntegrationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyIntegrationsQuery, MyIntegrationsQueryVariables>(MyIntegrationsDocument, options);
        }
export type MyIntegrationsQueryHookResult = ReturnType<typeof useMyIntegrationsQuery>;
export type MyIntegrationsLazyQueryHookResult = ReturnType<typeof useMyIntegrationsLazyQuery>;
export type MyIntegrationsSuspenseQueryHookResult = ReturnType<typeof useMyIntegrationsSuspenseQuery>;
export type MyIntegrationsQueryResult = Apollo.QueryResult<MyIntegrationsQuery, MyIntegrationsQueryVariables>;
export const IntegrationDocument = gql`
    query Integration($connectionId: String!) {
  fusionIntegration(connectionId: $connectionId) {
    capabilities
    id
    connectorCode
    displayName
    environment
    status
    mappedLocationCount
    mappedProductCount
    callbackKey
    authFlow
    features
    externalAccountId
    settingSpecs {
      key
      label
      helpText
      secret
      required
      inputType
      options {
        value
        label
      }
      defaultValue
      visibleWhenKey
      visibleWhenValue
    }
    settings {
      key
      value
    }
  }
}
    `;

/**
 * __useIntegrationQuery__
 *
 * To run a query within a React component, call `useIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationQuery({
 *   variables: {
 *      connectionId: // value for 'connectionId'
 *   },
 * });
 */
export function useIntegrationQuery(baseOptions: Apollo.QueryHookOptions<IntegrationQuery, IntegrationQueryVariables> & ({ variables: IntegrationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntegrationQuery, IntegrationQueryVariables>(IntegrationDocument, options);
      }
export function useIntegrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntegrationQuery, IntegrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntegrationQuery, IntegrationQueryVariables>(IntegrationDocument, options);
        }
// @ts-ignore
export function useIntegrationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IntegrationQuery, IntegrationQueryVariables>): Apollo.UseSuspenseQueryResult<IntegrationQuery, IntegrationQueryVariables>;
export function useIntegrationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IntegrationQuery, IntegrationQueryVariables>): Apollo.UseSuspenseQueryResult<IntegrationQuery | undefined, IntegrationQueryVariables>;
export function useIntegrationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IntegrationQuery, IntegrationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IntegrationQuery, IntegrationQueryVariables>(IntegrationDocument, options);
        }
export type IntegrationQueryHookResult = ReturnType<typeof useIntegrationQuery>;
export type IntegrationLazyQueryHookResult = ReturnType<typeof useIntegrationLazyQuery>;
export type IntegrationSuspenseQueryHookResult = ReturnType<typeof useIntegrationSuspenseQuery>;
export type IntegrationQueryResult = Apollo.QueryResult<IntegrationQuery, IntegrationQueryVariables>;
export const ConnectIntegrationDocument = gql`
    mutation ConnectIntegration($input: ConnectFusionIntegrationInput!) {
  connectFusionIntegration(input: $input) {
    id
    connectorCode
    displayName
  }
}
    `;
export type ConnectIntegrationMutationFn = Apollo.MutationFunction<ConnectIntegrationMutation, ConnectIntegrationMutationVariables>;

/**
 * __useConnectIntegrationMutation__
 *
 * To run a mutation, you first call `useConnectIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectIntegrationMutation, { data, loading, error }] = useConnectIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConnectIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<ConnectIntegrationMutation, ConnectIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConnectIntegrationMutation, ConnectIntegrationMutationVariables>(ConnectIntegrationDocument, options);
      }
export type ConnectIntegrationMutationHookResult = ReturnType<typeof useConnectIntegrationMutation>;
export type ConnectIntegrationMutationResult = Apollo.MutationResult<ConnectIntegrationMutation>;
export type ConnectIntegrationMutationOptions = Apollo.BaseMutationOptions<ConnectIntegrationMutation, ConnectIntegrationMutationVariables>;
export const UpdateFusionIntegrationDocument = gql`
    mutation UpdateFusionIntegration($input: UpdateFusionIntegrationInput!) {
  updateFusionIntegration(input: $input) {
    id
    displayName
    settings {
      key
      value
    }
  }
}
    `;
export type UpdateFusionIntegrationMutationFn = Apollo.MutationFunction<UpdateFusionIntegrationMutation, UpdateFusionIntegrationMutationVariables>;

/**
 * __useUpdateFusionIntegrationMutation__
 *
 * To run a mutation, you first call `useUpdateFusionIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFusionIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFusionIntegrationMutation, { data, loading, error }] = useUpdateFusionIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFusionIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFusionIntegrationMutation, UpdateFusionIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFusionIntegrationMutation, UpdateFusionIntegrationMutationVariables>(UpdateFusionIntegrationDocument, options);
      }
export type UpdateFusionIntegrationMutationHookResult = ReturnType<typeof useUpdateFusionIntegrationMutation>;
export type UpdateFusionIntegrationMutationResult = Apollo.MutationResult<UpdateFusionIntegrationMutation>;
export type UpdateFusionIntegrationMutationOptions = Apollo.BaseMutationOptions<UpdateFusionIntegrationMutation, UpdateFusionIntegrationMutationVariables>;
export const IntegrationEventsDocument = gql`
    query IntegrationEvents($connectionId: String!) {
  fusionIntegrationEvents(connectionId: $connectionId) {
    eventType
    enabled
  }
}
    `;

/**
 * __useIntegrationEventsQuery__
 *
 * To run a query within a React component, call `useIntegrationEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationEventsQuery({
 *   variables: {
 *      connectionId: // value for 'connectionId'
 *   },
 * });
 */
export function useIntegrationEventsQuery(baseOptions: Apollo.QueryHookOptions<IntegrationEventsQuery, IntegrationEventsQueryVariables> & ({ variables: IntegrationEventsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntegrationEventsQuery, IntegrationEventsQueryVariables>(IntegrationEventsDocument, options);
      }
export function useIntegrationEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntegrationEventsQuery, IntegrationEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntegrationEventsQuery, IntegrationEventsQueryVariables>(IntegrationEventsDocument, options);
        }
// @ts-ignore
export function useIntegrationEventsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IntegrationEventsQuery, IntegrationEventsQueryVariables>): Apollo.UseSuspenseQueryResult<IntegrationEventsQuery, IntegrationEventsQueryVariables>;
export function useIntegrationEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IntegrationEventsQuery, IntegrationEventsQueryVariables>): Apollo.UseSuspenseQueryResult<IntegrationEventsQuery | undefined, IntegrationEventsQueryVariables>;
export function useIntegrationEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IntegrationEventsQuery, IntegrationEventsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IntegrationEventsQuery, IntegrationEventsQueryVariables>(IntegrationEventsDocument, options);
        }
export type IntegrationEventsQueryHookResult = ReturnType<typeof useIntegrationEventsQuery>;
export type IntegrationEventsLazyQueryHookResult = ReturnType<typeof useIntegrationEventsLazyQuery>;
export type IntegrationEventsSuspenseQueryHookResult = ReturnType<typeof useIntegrationEventsSuspenseQuery>;
export type IntegrationEventsQueryResult = Apollo.QueryResult<IntegrationEventsQuery, IntegrationEventsQueryVariables>;
export const SetIntegrationEventDocument = gql`
    mutation SetIntegrationEvent($input: SetFusionIntegrationEventInput!) {
  setFusionIntegrationEvent(input: $input) {
    eventType
    enabled
  }
}
    `;
export type SetIntegrationEventMutationFn = Apollo.MutationFunction<SetIntegrationEventMutation, SetIntegrationEventMutationVariables>;

/**
 * __useSetIntegrationEventMutation__
 *
 * To run a mutation, you first call `useSetIntegrationEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetIntegrationEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setIntegrationEventMutation, { data, loading, error }] = useSetIntegrationEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetIntegrationEventMutation(baseOptions?: Apollo.MutationHookOptions<SetIntegrationEventMutation, SetIntegrationEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetIntegrationEventMutation, SetIntegrationEventMutationVariables>(SetIntegrationEventDocument, options);
      }
export type SetIntegrationEventMutationHookResult = ReturnType<typeof useSetIntegrationEventMutation>;
export type SetIntegrationEventMutationResult = Apollo.MutationResult<SetIntegrationEventMutation>;
export type SetIntegrationEventMutationOptions = Apollo.BaseMutationOptions<SetIntegrationEventMutation, SetIntegrationEventMutationVariables>;
export const IntegrationLocationsDocument = gql`
    query IntegrationLocations($connectionId: String!) {
  fusionIntegrationLocations(connectionId: $connectionId) {
    locationId
    name
    externalVendorId
  }
}
    `;

/**
 * __useIntegrationLocationsQuery__
 *
 * To run a query within a React component, call `useIntegrationLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationLocationsQuery({
 *   variables: {
 *      connectionId: // value for 'connectionId'
 *   },
 * });
 */
export function useIntegrationLocationsQuery(baseOptions: Apollo.QueryHookOptions<IntegrationLocationsQuery, IntegrationLocationsQueryVariables> & ({ variables: IntegrationLocationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntegrationLocationsQuery, IntegrationLocationsQueryVariables>(IntegrationLocationsDocument, options);
      }
export function useIntegrationLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntegrationLocationsQuery, IntegrationLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntegrationLocationsQuery, IntegrationLocationsQueryVariables>(IntegrationLocationsDocument, options);
        }
// @ts-ignore
export function useIntegrationLocationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IntegrationLocationsQuery, IntegrationLocationsQueryVariables>): Apollo.UseSuspenseQueryResult<IntegrationLocationsQuery, IntegrationLocationsQueryVariables>;
export function useIntegrationLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IntegrationLocationsQuery, IntegrationLocationsQueryVariables>): Apollo.UseSuspenseQueryResult<IntegrationLocationsQuery | undefined, IntegrationLocationsQueryVariables>;
export function useIntegrationLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IntegrationLocationsQuery, IntegrationLocationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IntegrationLocationsQuery, IntegrationLocationsQueryVariables>(IntegrationLocationsDocument, options);
        }
export type IntegrationLocationsQueryHookResult = ReturnType<typeof useIntegrationLocationsQuery>;
export type IntegrationLocationsLazyQueryHookResult = ReturnType<typeof useIntegrationLocationsLazyQuery>;
export type IntegrationLocationsSuspenseQueryHookResult = ReturnType<typeof useIntegrationLocationsSuspenseQuery>;
export type IntegrationLocationsQueryResult = Apollo.QueryResult<IntegrationLocationsQuery, IntegrationLocationsQueryVariables>;
export const IntegrationOperationsDocument = gql`
    query IntegrationOperations($connectionId: String!) {
  fusionIntegrationOperations(connectionId: $connectionId) {
    id
    operationType
    oneObjectId
    externalObjectId
    status
    attemptCount
    error
    requestPayload
    responsePayload
    createdAt
    completedAt
  }
}
    `;

/**
 * __useIntegrationOperationsQuery__
 *
 * To run a query within a React component, call `useIntegrationOperationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationOperationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationOperationsQuery({
 *   variables: {
 *      connectionId: // value for 'connectionId'
 *   },
 * });
 */
export function useIntegrationOperationsQuery(baseOptions: Apollo.QueryHookOptions<IntegrationOperationsQuery, IntegrationOperationsQueryVariables> & ({ variables: IntegrationOperationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntegrationOperationsQuery, IntegrationOperationsQueryVariables>(IntegrationOperationsDocument, options);
      }
export function useIntegrationOperationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntegrationOperationsQuery, IntegrationOperationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntegrationOperationsQuery, IntegrationOperationsQueryVariables>(IntegrationOperationsDocument, options);
        }
// @ts-ignore
export function useIntegrationOperationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IntegrationOperationsQuery, IntegrationOperationsQueryVariables>): Apollo.UseSuspenseQueryResult<IntegrationOperationsQuery, IntegrationOperationsQueryVariables>;
export function useIntegrationOperationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IntegrationOperationsQuery, IntegrationOperationsQueryVariables>): Apollo.UseSuspenseQueryResult<IntegrationOperationsQuery | undefined, IntegrationOperationsQueryVariables>;
export function useIntegrationOperationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IntegrationOperationsQuery, IntegrationOperationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IntegrationOperationsQuery, IntegrationOperationsQueryVariables>(IntegrationOperationsDocument, options);
        }
export type IntegrationOperationsQueryHookResult = ReturnType<typeof useIntegrationOperationsQuery>;
export type IntegrationOperationsLazyQueryHookResult = ReturnType<typeof useIntegrationOperationsLazyQuery>;
export type IntegrationOperationsSuspenseQueryHookResult = ReturnType<typeof useIntegrationOperationsSuspenseQuery>;
export type IntegrationOperationsQueryResult = Apollo.QueryResult<IntegrationOperationsQuery, IntegrationOperationsQueryVariables>;
export const IntegrationProductsDocument = gql`
    query IntegrationProducts($connectionId: String!) {
  fusionIntegrationProducts(connectionId: $connectionId) {
    productId
    name
    barcode
    active
    externalSku
    stockBuffer
    maximumSalesQuantity
    listingStatus
    lastError
    externalUrl
    lastPushedAt
  }
}
    `;

/**
 * __useIntegrationProductsQuery__
 *
 * To run a query within a React component, call `useIntegrationProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationProductsQuery({
 *   variables: {
 *      connectionId: // value for 'connectionId'
 *   },
 * });
 */
export function useIntegrationProductsQuery(baseOptions: Apollo.QueryHookOptions<IntegrationProductsQuery, IntegrationProductsQueryVariables> & ({ variables: IntegrationProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntegrationProductsQuery, IntegrationProductsQueryVariables>(IntegrationProductsDocument, options);
      }
export function useIntegrationProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntegrationProductsQuery, IntegrationProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntegrationProductsQuery, IntegrationProductsQueryVariables>(IntegrationProductsDocument, options);
        }
// @ts-ignore
export function useIntegrationProductsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IntegrationProductsQuery, IntegrationProductsQueryVariables>): Apollo.UseSuspenseQueryResult<IntegrationProductsQuery, IntegrationProductsQueryVariables>;
export function useIntegrationProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IntegrationProductsQuery, IntegrationProductsQueryVariables>): Apollo.UseSuspenseQueryResult<IntegrationProductsQuery | undefined, IntegrationProductsQueryVariables>;
export function useIntegrationProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IntegrationProductsQuery, IntegrationProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IntegrationProductsQuery, IntegrationProductsQueryVariables>(IntegrationProductsDocument, options);
        }
export type IntegrationProductsQueryHookResult = ReturnType<typeof useIntegrationProductsQuery>;
export type IntegrationProductsLazyQueryHookResult = ReturnType<typeof useIntegrationProductsLazyQuery>;
export type IntegrationProductsSuspenseQueryHookResult = ReturnType<typeof useIntegrationProductsSuspenseQuery>;
export type IntegrationProductsQueryResult = Apollo.QueryResult<IntegrationProductsQuery, IntegrationProductsQueryVariables>;
export const IntegrationProductSearchDocument = gql`
    query IntegrationProductSearch($query: String!) {
  fusionIntegrationProductSearch(query: $query) {
    productId
    name
    barcode
    active
  }
}
    `;

/**
 * __useIntegrationProductSearchQuery__
 *
 * To run a query within a React component, call `useIntegrationProductSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationProductSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationProductSearchQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useIntegrationProductSearchQuery(baseOptions: Apollo.QueryHookOptions<IntegrationProductSearchQuery, IntegrationProductSearchQueryVariables> & ({ variables: IntegrationProductSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntegrationProductSearchQuery, IntegrationProductSearchQueryVariables>(IntegrationProductSearchDocument, options);
      }
export function useIntegrationProductSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntegrationProductSearchQuery, IntegrationProductSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntegrationProductSearchQuery, IntegrationProductSearchQueryVariables>(IntegrationProductSearchDocument, options);
        }
// @ts-ignore
export function useIntegrationProductSearchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IntegrationProductSearchQuery, IntegrationProductSearchQueryVariables>): Apollo.UseSuspenseQueryResult<IntegrationProductSearchQuery, IntegrationProductSearchQueryVariables>;
export function useIntegrationProductSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IntegrationProductSearchQuery, IntegrationProductSearchQueryVariables>): Apollo.UseSuspenseQueryResult<IntegrationProductSearchQuery | undefined, IntegrationProductSearchQueryVariables>;
export function useIntegrationProductSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IntegrationProductSearchQuery, IntegrationProductSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IntegrationProductSearchQuery, IntegrationProductSearchQueryVariables>(IntegrationProductSearchDocument, options);
        }
export type IntegrationProductSearchQueryHookResult = ReturnType<typeof useIntegrationProductSearchQuery>;
export type IntegrationProductSearchLazyQueryHookResult = ReturnType<typeof useIntegrationProductSearchLazyQuery>;
export type IntegrationProductSearchSuspenseQueryHookResult = ReturnType<typeof useIntegrationProductSearchSuspenseQuery>;
export type IntegrationProductSearchQueryResult = Apollo.QueryResult<IntegrationProductSearchQuery, IntegrationProductSearchQueryVariables>;
export const SetIntegrationLocationDocument = gql`
    mutation SetIntegrationLocation($input: SetFusionIntegrationLocationInput!) {
  setFusionIntegrationLocation(input: $input) {
    locationId
    name
    externalVendorId
  }
}
    `;
export type SetIntegrationLocationMutationFn = Apollo.MutationFunction<SetIntegrationLocationMutation, SetIntegrationLocationMutationVariables>;

/**
 * __useSetIntegrationLocationMutation__
 *
 * To run a mutation, you first call `useSetIntegrationLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetIntegrationLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setIntegrationLocationMutation, { data, loading, error }] = useSetIntegrationLocationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetIntegrationLocationMutation(baseOptions?: Apollo.MutationHookOptions<SetIntegrationLocationMutation, SetIntegrationLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetIntegrationLocationMutation, SetIntegrationLocationMutationVariables>(SetIntegrationLocationDocument, options);
      }
export type SetIntegrationLocationMutationHookResult = ReturnType<typeof useSetIntegrationLocationMutation>;
export type SetIntegrationLocationMutationResult = Apollo.MutationResult<SetIntegrationLocationMutation>;
export type SetIntegrationLocationMutationOptions = Apollo.BaseMutationOptions<SetIntegrationLocationMutation, SetIntegrationLocationMutationVariables>;
export const SetIntegrationProductDocument = gql`
    mutation SetIntegrationProduct($input: SetFusionIntegrationProductInput!) {
  setFusionIntegrationProduct(input: $input) {
    productId
    name
    barcode
    active
    externalSku
    stockBuffer
    maximumSalesQuantity
  }
}
    `;
export type SetIntegrationProductMutationFn = Apollo.MutationFunction<SetIntegrationProductMutation, SetIntegrationProductMutationVariables>;

/**
 * __useSetIntegrationProductMutation__
 *
 * To run a mutation, you first call `useSetIntegrationProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetIntegrationProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setIntegrationProductMutation, { data, loading, error }] = useSetIntegrationProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetIntegrationProductMutation(baseOptions?: Apollo.MutationHookOptions<SetIntegrationProductMutation, SetIntegrationProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetIntegrationProductMutation, SetIntegrationProductMutationVariables>(SetIntegrationProductDocument, options);
      }
export type SetIntegrationProductMutationHookResult = ReturnType<typeof useSetIntegrationProductMutation>;
export type SetIntegrationProductMutationResult = Apollo.MutationResult<SetIntegrationProductMutation>;
export type SetIntegrationProductMutationOptions = Apollo.BaseMutationOptions<SetIntegrationProductMutation, SetIntegrationProductMutationVariables>;
export const UpdateIntegrationProductDocument = gql`
    mutation UpdateIntegrationProduct($input: UpdateFusionIntegrationProductInput!) {
  updateFusionIntegrationProduct(input: $input) {
    productId
    stockBuffer
    maximumSalesQuantity
  }
}
    `;
export type UpdateIntegrationProductMutationFn = Apollo.MutationFunction<UpdateIntegrationProductMutation, UpdateIntegrationProductMutationVariables>;

/**
 * __useUpdateIntegrationProductMutation__
 *
 * To run a mutation, you first call `useUpdateIntegrationProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIntegrationProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIntegrationProductMutation, { data, loading, error }] = useUpdateIntegrationProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateIntegrationProductMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIntegrationProductMutation, UpdateIntegrationProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIntegrationProductMutation, UpdateIntegrationProductMutationVariables>(UpdateIntegrationProductDocument, options);
      }
export type UpdateIntegrationProductMutationHookResult = ReturnType<typeof useUpdateIntegrationProductMutation>;
export type UpdateIntegrationProductMutationResult = Apollo.MutationResult<UpdateIntegrationProductMutation>;
export type UpdateIntegrationProductMutationOptions = Apollo.BaseMutationOptions<UpdateIntegrationProductMutation, UpdateIntegrationProductMutationVariables>;
export const RemoveIntegrationLocationDocument = gql`
    mutation RemoveIntegrationLocation($input: RemoveFusionIntegrationMappingInput!) {
  removeFusionIntegrationLocation(input: $input)
}
    `;
export type RemoveIntegrationLocationMutationFn = Apollo.MutationFunction<RemoveIntegrationLocationMutation, RemoveIntegrationLocationMutationVariables>;

/**
 * __useRemoveIntegrationLocationMutation__
 *
 * To run a mutation, you first call `useRemoveIntegrationLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveIntegrationLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeIntegrationLocationMutation, { data, loading, error }] = useRemoveIntegrationLocationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveIntegrationLocationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveIntegrationLocationMutation, RemoveIntegrationLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveIntegrationLocationMutation, RemoveIntegrationLocationMutationVariables>(RemoveIntegrationLocationDocument, options);
      }
export type RemoveIntegrationLocationMutationHookResult = ReturnType<typeof useRemoveIntegrationLocationMutation>;
export type RemoveIntegrationLocationMutationResult = Apollo.MutationResult<RemoveIntegrationLocationMutation>;
export type RemoveIntegrationLocationMutationOptions = Apollo.BaseMutationOptions<RemoveIntegrationLocationMutation, RemoveIntegrationLocationMutationVariables>;
export const RemoveIntegrationProductDocument = gql`
    mutation RemoveIntegrationProduct($input: RemoveFusionIntegrationMappingInput!) {
  removeFusionIntegrationProduct(input: $input)
}
    `;
export type RemoveIntegrationProductMutationFn = Apollo.MutationFunction<RemoveIntegrationProductMutation, RemoveIntegrationProductMutationVariables>;

/**
 * __useRemoveIntegrationProductMutation__
 *
 * To run a mutation, you first call `useRemoveIntegrationProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveIntegrationProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeIntegrationProductMutation, { data, loading, error }] = useRemoveIntegrationProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveIntegrationProductMutation(baseOptions?: Apollo.MutationHookOptions<RemoveIntegrationProductMutation, RemoveIntegrationProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveIntegrationProductMutation, RemoveIntegrationProductMutationVariables>(RemoveIntegrationProductDocument, options);
      }
export type RemoveIntegrationProductMutationHookResult = ReturnType<typeof useRemoveIntegrationProductMutation>;
export type RemoveIntegrationProductMutationResult = Apollo.MutationResult<RemoveIntegrationProductMutation>;
export type RemoveIntegrationProductMutationOptions = Apollo.BaseMutationOptions<RemoveIntegrationProductMutation, RemoveIntegrationProductMutationVariables>;
export const SyncIntegrationCatalogDocument = gql`
    mutation SyncIntegrationCatalog($connectionId: String!) {
  syncFusionIntegrationCatalog(connectionId: $connectionId) {
    locationId
    externalVendorId
    itemCount
    batchCount
    queuedCount
    jobIds
    status
    error
  }
}
    `;
export type SyncIntegrationCatalogMutationFn = Apollo.MutationFunction<SyncIntegrationCatalogMutation, SyncIntegrationCatalogMutationVariables>;

/**
 * __useSyncIntegrationCatalogMutation__
 *
 * To run a mutation, you first call `useSyncIntegrationCatalogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncIntegrationCatalogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncIntegrationCatalogMutation, { data, loading, error }] = useSyncIntegrationCatalogMutation({
 *   variables: {
 *      connectionId: // value for 'connectionId'
 *   },
 * });
 */
export function useSyncIntegrationCatalogMutation(baseOptions?: Apollo.MutationHookOptions<SyncIntegrationCatalogMutation, SyncIntegrationCatalogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncIntegrationCatalogMutation, SyncIntegrationCatalogMutationVariables>(SyncIntegrationCatalogDocument, options);
      }
export type SyncIntegrationCatalogMutationHookResult = ReturnType<typeof useSyncIntegrationCatalogMutation>;
export type SyncIntegrationCatalogMutationResult = Apollo.MutationResult<SyncIntegrationCatalogMutation>;
export type SyncIntegrationCatalogMutationOptions = Apollo.BaseMutationOptions<SyncIntegrationCatalogMutation, SyncIntegrationCatalogMutationVariables>;
export const IntegrationProductTemplateDocument = gql`
    query IntegrationProductTemplate($connectionId: String!) {
  fusionIntegrationProductTemplate(connectionId: $connectionId) {
    productCode
    name
    active
    externalSku
    stockBuffer
    maximumSalesQuantity
  }
}
    `;

/**
 * __useIntegrationProductTemplateQuery__
 *
 * To run a query within a React component, call `useIntegrationProductTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationProductTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationProductTemplateQuery({
 *   variables: {
 *      connectionId: // value for 'connectionId'
 *   },
 * });
 */
export function useIntegrationProductTemplateQuery(baseOptions: Apollo.QueryHookOptions<IntegrationProductTemplateQuery, IntegrationProductTemplateQueryVariables> & ({ variables: IntegrationProductTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntegrationProductTemplateQuery, IntegrationProductTemplateQueryVariables>(IntegrationProductTemplateDocument, options);
      }
export function useIntegrationProductTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntegrationProductTemplateQuery, IntegrationProductTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntegrationProductTemplateQuery, IntegrationProductTemplateQueryVariables>(IntegrationProductTemplateDocument, options);
        }
// @ts-ignore
export function useIntegrationProductTemplateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IntegrationProductTemplateQuery, IntegrationProductTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<IntegrationProductTemplateQuery, IntegrationProductTemplateQueryVariables>;
export function useIntegrationProductTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IntegrationProductTemplateQuery, IntegrationProductTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<IntegrationProductTemplateQuery | undefined, IntegrationProductTemplateQueryVariables>;
export function useIntegrationProductTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IntegrationProductTemplateQuery, IntegrationProductTemplateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IntegrationProductTemplateQuery, IntegrationProductTemplateQueryVariables>(IntegrationProductTemplateDocument, options);
        }
export type IntegrationProductTemplateQueryHookResult = ReturnType<typeof useIntegrationProductTemplateQuery>;
export type IntegrationProductTemplateLazyQueryHookResult = ReturnType<typeof useIntegrationProductTemplateLazyQuery>;
export type IntegrationProductTemplateSuspenseQueryHookResult = ReturnType<typeof useIntegrationProductTemplateSuspenseQuery>;
export type IntegrationProductTemplateQueryResult = Apollo.QueryResult<IntegrationProductTemplateQuery, IntegrationProductTemplateQueryVariables>;
export const ImportIntegrationProductsDocument = gql`
    mutation ImportIntegrationProducts($input: ImportFusionIntegrationProductsInput!) {
  importFusionIntegrationProducts(input: $input) {
    dryRun
    totalRows
    created
    updated
    unchanged
    stockBuffersChanged
    salesLimitsChanged
    errors {
      rowNumber
      productCode
      externalSku
      message
    }
  }
}
    `;
export type ImportIntegrationProductsMutationFn = Apollo.MutationFunction<ImportIntegrationProductsMutation, ImportIntegrationProductsMutationVariables>;

/**
 * __useImportIntegrationProductsMutation__
 *
 * To run a mutation, you first call `useImportIntegrationProductsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportIntegrationProductsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importIntegrationProductsMutation, { data, loading, error }] = useImportIntegrationProductsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportIntegrationProductsMutation(baseOptions?: Apollo.MutationHookOptions<ImportIntegrationProductsMutation, ImportIntegrationProductsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportIntegrationProductsMutation, ImportIntegrationProductsMutationVariables>(ImportIntegrationProductsDocument, options);
      }
export type ImportIntegrationProductsMutationHookResult = ReturnType<typeof useImportIntegrationProductsMutation>;
export type ImportIntegrationProductsMutationResult = Apollo.MutationResult<ImportIntegrationProductsMutation>;
export type ImportIntegrationProductsMutationOptions = Apollo.BaseMutationOptions<ImportIntegrationProductsMutation, ImportIntegrationProductsMutationVariables>;
export const IntegrationExternalLocationsDocument = gql`
    query IntegrationExternalLocations($connectionId: String!) {
  fusionIntegrationExternalLocations(connectionId: $connectionId) {
    id
    name
    address
    isActive
    fulfillsOnlineOrders
    linkedLocationId
  }
}
    `;

/**
 * __useIntegrationExternalLocationsQuery__
 *
 * To run a query within a React component, call `useIntegrationExternalLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationExternalLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationExternalLocationsQuery({
 *   variables: {
 *      connectionId: // value for 'connectionId'
 *   },
 * });
 */
export function useIntegrationExternalLocationsQuery(baseOptions: Apollo.QueryHookOptions<IntegrationExternalLocationsQuery, IntegrationExternalLocationsQueryVariables> & ({ variables: IntegrationExternalLocationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntegrationExternalLocationsQuery, IntegrationExternalLocationsQueryVariables>(IntegrationExternalLocationsDocument, options);
      }
export function useIntegrationExternalLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntegrationExternalLocationsQuery, IntegrationExternalLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntegrationExternalLocationsQuery, IntegrationExternalLocationsQueryVariables>(IntegrationExternalLocationsDocument, options);
        }
// @ts-ignore
export function useIntegrationExternalLocationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IntegrationExternalLocationsQuery, IntegrationExternalLocationsQueryVariables>): Apollo.UseSuspenseQueryResult<IntegrationExternalLocationsQuery, IntegrationExternalLocationsQueryVariables>;
export function useIntegrationExternalLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IntegrationExternalLocationsQuery, IntegrationExternalLocationsQueryVariables>): Apollo.UseSuspenseQueryResult<IntegrationExternalLocationsQuery | undefined, IntegrationExternalLocationsQueryVariables>;
export function useIntegrationExternalLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IntegrationExternalLocationsQuery, IntegrationExternalLocationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IntegrationExternalLocationsQuery, IntegrationExternalLocationsQueryVariables>(IntegrationExternalLocationsDocument, options);
        }
export type IntegrationExternalLocationsQueryHookResult = ReturnType<typeof useIntegrationExternalLocationsQuery>;
export type IntegrationExternalLocationsLazyQueryHookResult = ReturnType<typeof useIntegrationExternalLocationsLazyQuery>;
export type IntegrationExternalLocationsSuspenseQueryHookResult = ReturnType<typeof useIntegrationExternalLocationsSuspenseQuery>;
export type IntegrationExternalLocationsQueryResult = Apollo.QueryResult<IntegrationExternalLocationsQuery, IntegrationExternalLocationsQueryVariables>;
export const StartIntegrationAuthorizationDocument = gql`
    mutation StartIntegrationAuthorization($input: StartFusionIntegrationAuthorizationInput!) {
  startFusionIntegrationAuthorization(input: $input) {
    authorizeUrl
  }
}
    `;
export type StartIntegrationAuthorizationMutationFn = Apollo.MutationFunction<StartIntegrationAuthorizationMutation, StartIntegrationAuthorizationMutationVariables>;

/**
 * __useStartIntegrationAuthorizationMutation__
 *
 * To run a mutation, you first call `useStartIntegrationAuthorizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartIntegrationAuthorizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startIntegrationAuthorizationMutation, { data, loading, error }] = useStartIntegrationAuthorizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartIntegrationAuthorizationMutation(baseOptions?: Apollo.MutationHookOptions<StartIntegrationAuthorizationMutation, StartIntegrationAuthorizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartIntegrationAuthorizationMutation, StartIntegrationAuthorizationMutationVariables>(StartIntegrationAuthorizationDocument, options);
      }
export type StartIntegrationAuthorizationMutationHookResult = ReturnType<typeof useStartIntegrationAuthorizationMutation>;
export type StartIntegrationAuthorizationMutationResult = Apollo.MutationResult<StartIntegrationAuthorizationMutation>;
export type StartIntegrationAuthorizationMutationOptions = Apollo.BaseMutationOptions<StartIntegrationAuthorizationMutation, StartIntegrationAuthorizationMutationVariables>;
export const AddIntegrationProductsDocument = gql`
    mutation AddIntegrationProducts($input: AddFusionIntegrationProductsInput!) {
  addFusionIntegrationProducts(input: $input) {
    productId
    name
    barcode
    active
    externalSku
    stockBuffer
    listingStatus
    lastError
    externalUrl
    lastPushedAt
  }
}
    `;
export type AddIntegrationProductsMutationFn = Apollo.MutationFunction<AddIntegrationProductsMutation, AddIntegrationProductsMutationVariables>;

/**
 * __useAddIntegrationProductsMutation__
 *
 * To run a mutation, you first call `useAddIntegrationProductsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddIntegrationProductsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addIntegrationProductsMutation, { data, loading, error }] = useAddIntegrationProductsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddIntegrationProductsMutation(baseOptions?: Apollo.MutationHookOptions<AddIntegrationProductsMutation, AddIntegrationProductsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddIntegrationProductsMutation, AddIntegrationProductsMutationVariables>(AddIntegrationProductsDocument, options);
      }
export type AddIntegrationProductsMutationHookResult = ReturnType<typeof useAddIntegrationProductsMutation>;
export type AddIntegrationProductsMutationResult = Apollo.MutationResult<AddIntegrationProductsMutation>;
export type AddIntegrationProductsMutationOptions = Apollo.BaseMutationOptions<AddIntegrationProductsMutation, AddIntegrationProductsMutationVariables>;
export const PushIntegrationProductDocument = gql`
    mutation PushIntegrationProduct($input: FusionIntegrationProductActionInput!) {
  pushFusionIntegrationProduct(input: $input) {
    productId
    listingStatus
    lastError
    externalUrl
    lastPushedAt
  }
}
    `;
export type PushIntegrationProductMutationFn = Apollo.MutationFunction<PushIntegrationProductMutation, PushIntegrationProductMutationVariables>;

/**
 * __usePushIntegrationProductMutation__
 *
 * To run a mutation, you first call `usePushIntegrationProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePushIntegrationProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pushIntegrationProductMutation, { data, loading, error }] = usePushIntegrationProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePushIntegrationProductMutation(baseOptions?: Apollo.MutationHookOptions<PushIntegrationProductMutation, PushIntegrationProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PushIntegrationProductMutation, PushIntegrationProductMutationVariables>(PushIntegrationProductDocument, options);
      }
export type PushIntegrationProductMutationHookResult = ReturnType<typeof usePushIntegrationProductMutation>;
export type PushIntegrationProductMutationResult = Apollo.MutationResult<PushIntegrationProductMutation>;
export type PushIntegrationProductMutationOptions = Apollo.BaseMutationOptions<PushIntegrationProductMutation, PushIntegrationProductMutationVariables>;
export const UnlistIntegrationProductDocument = gql`
    mutation UnlistIntegrationProduct($input: FusionIntegrationProductActionInput!) {
  unlistFusionIntegrationProduct(input: $input)
}
    `;
export type UnlistIntegrationProductMutationFn = Apollo.MutationFunction<UnlistIntegrationProductMutation, UnlistIntegrationProductMutationVariables>;

/**
 * __useUnlistIntegrationProductMutation__
 *
 * To run a mutation, you first call `useUnlistIntegrationProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlistIntegrationProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlistIntegrationProductMutation, { data, loading, error }] = useUnlistIntegrationProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnlistIntegrationProductMutation(baseOptions?: Apollo.MutationHookOptions<UnlistIntegrationProductMutation, UnlistIntegrationProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlistIntegrationProductMutation, UnlistIntegrationProductMutationVariables>(UnlistIntegrationProductDocument, options);
      }
export type UnlistIntegrationProductMutationHookResult = ReturnType<typeof useUnlistIntegrationProductMutation>;
export type UnlistIntegrationProductMutationResult = Apollo.MutationResult<UnlistIntegrationProductMutation>;
export type UnlistIntegrationProductMutationOptions = Apollo.BaseMutationOptions<UnlistIntegrationProductMutation, UnlistIntegrationProductMutationVariables>;
export const SyncIntegrationProductsDocument = gql`
    mutation SyncIntegrationProducts($connectionId: String!) {
  syncFusionIntegrationProducts(connectionId: $connectionId) {
    pushed
    failed
    remaining
    busy
    lastError
    onChannel
    productUpdatesOff
  }
}
    `;
export type SyncIntegrationProductsMutationFn = Apollo.MutationFunction<SyncIntegrationProductsMutation, SyncIntegrationProductsMutationVariables>;

/**
 * __useSyncIntegrationProductsMutation__
 *
 * To run a mutation, you first call `useSyncIntegrationProductsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncIntegrationProductsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncIntegrationProductsMutation, { data, loading, error }] = useSyncIntegrationProductsMutation({
 *   variables: {
 *      connectionId: // value for 'connectionId'
 *   },
 * });
 */
export function useSyncIntegrationProductsMutation(baseOptions?: Apollo.MutationHookOptions<SyncIntegrationProductsMutation, SyncIntegrationProductsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncIntegrationProductsMutation, SyncIntegrationProductsMutationVariables>(SyncIntegrationProductsDocument, options);
      }
export type SyncIntegrationProductsMutationHookResult = ReturnType<typeof useSyncIntegrationProductsMutation>;
export type SyncIntegrationProductsMutationResult = Apollo.MutationResult<SyncIntegrationProductsMutation>;
export type SyncIntegrationProductsMutationOptions = Apollo.BaseMutationOptions<SyncIntegrationProductsMutation, SyncIntegrationProductsMutationVariables>;
export const FusionRidersDocument = gql`
    query FusionRiders($connectionId: String!, $activeOnly: Boolean) {
  fusionRiders(connectionId: $connectionId, activeOnly: $activeOnly) {
    id
    name
    phone
    vehicle
    locationId
    active
  }
}
    `;

/**
 * __useFusionRidersQuery__
 *
 * To run a query within a React component, call `useFusionRidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFusionRidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFusionRidersQuery({
 *   variables: {
 *      connectionId: // value for 'connectionId'
 *      activeOnly: // value for 'activeOnly'
 *   },
 * });
 */
export function useFusionRidersQuery(baseOptions: Apollo.QueryHookOptions<FusionRidersQuery, FusionRidersQueryVariables> & ({ variables: FusionRidersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FusionRidersQuery, FusionRidersQueryVariables>(FusionRidersDocument, options);
      }
export function useFusionRidersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FusionRidersQuery, FusionRidersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FusionRidersQuery, FusionRidersQueryVariables>(FusionRidersDocument, options);
        }
// @ts-ignore
export function useFusionRidersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FusionRidersQuery, FusionRidersQueryVariables>): Apollo.UseSuspenseQueryResult<FusionRidersQuery, FusionRidersQueryVariables>;
export function useFusionRidersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FusionRidersQuery, FusionRidersQueryVariables>): Apollo.UseSuspenseQueryResult<FusionRidersQuery | undefined, FusionRidersQueryVariables>;
export function useFusionRidersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FusionRidersQuery, FusionRidersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FusionRidersQuery, FusionRidersQueryVariables>(FusionRidersDocument, options);
        }
export type FusionRidersQueryHookResult = ReturnType<typeof useFusionRidersQuery>;
export type FusionRidersLazyQueryHookResult = ReturnType<typeof useFusionRidersLazyQuery>;
export type FusionRidersSuspenseQueryHookResult = ReturnType<typeof useFusionRidersSuspenseQuery>;
export type FusionRidersQueryResult = Apollo.QueryResult<FusionRidersQuery, FusionRidersQueryVariables>;
export const CreateFusionRiderDocument = gql`
    mutation CreateFusionRider($input: CreateFusionRiderInput!) {
  createFusionRider(input: $input) {
    id
    name
    phone
    vehicle
    active
  }
}
    `;
export type CreateFusionRiderMutationFn = Apollo.MutationFunction<CreateFusionRiderMutation, CreateFusionRiderMutationVariables>;

/**
 * __useCreateFusionRiderMutation__
 *
 * To run a mutation, you first call `useCreateFusionRiderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFusionRiderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFusionRiderMutation, { data, loading, error }] = useCreateFusionRiderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFusionRiderMutation(baseOptions?: Apollo.MutationHookOptions<CreateFusionRiderMutation, CreateFusionRiderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFusionRiderMutation, CreateFusionRiderMutationVariables>(CreateFusionRiderDocument, options);
      }
export type CreateFusionRiderMutationHookResult = ReturnType<typeof useCreateFusionRiderMutation>;
export type CreateFusionRiderMutationResult = Apollo.MutationResult<CreateFusionRiderMutation>;
export type CreateFusionRiderMutationOptions = Apollo.BaseMutationOptions<CreateFusionRiderMutation, CreateFusionRiderMutationVariables>;
export const SetFusionRiderActiveDocument = gql`
    mutation SetFusionRiderActive($input: SetFusionRiderActiveInput!) {
  setFusionRiderActive(input: $input) {
    id
    active
  }
}
    `;
export type SetFusionRiderActiveMutationFn = Apollo.MutationFunction<SetFusionRiderActiveMutation, SetFusionRiderActiveMutationVariables>;

/**
 * __useSetFusionRiderActiveMutation__
 *
 * To run a mutation, you first call `useSetFusionRiderActiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetFusionRiderActiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setFusionRiderActiveMutation, { data, loading, error }] = useSetFusionRiderActiveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetFusionRiderActiveMutation(baseOptions?: Apollo.MutationHookOptions<SetFusionRiderActiveMutation, SetFusionRiderActiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetFusionRiderActiveMutation, SetFusionRiderActiveMutationVariables>(SetFusionRiderActiveDocument, options);
      }
export type SetFusionRiderActiveMutationHookResult = ReturnType<typeof useSetFusionRiderActiveMutation>;
export type SetFusionRiderActiveMutationResult = Apollo.MutationResult<SetFusionRiderActiveMutation>;
export type SetFusionRiderActiveMutationOptions = Apollo.BaseMutationOptions<SetFusionRiderActiveMutation, SetFusionRiderActiveMutationVariables>;
export const FusionRiderCodOutstandingDocument = gql`
    query FusionRiderCodOutstanding($connectionId: String!) {
  fusionRiderCodOutstanding(connectionId: $connectionId) {
    riderId
    riderName
    riderPhone
    outstandingAmount
    shipmentCount
    oldestBookedAt
  }
}
    `;

/**
 * __useFusionRiderCodOutstandingQuery__
 *
 * To run a query within a React component, call `useFusionRiderCodOutstandingQuery` and pass it any options that fit your needs.
 * When your component renders, `useFusionRiderCodOutstandingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFusionRiderCodOutstandingQuery({
 *   variables: {
 *      connectionId: // value for 'connectionId'
 *   },
 * });
 */
export function useFusionRiderCodOutstandingQuery(baseOptions: Apollo.QueryHookOptions<FusionRiderCodOutstandingQuery, FusionRiderCodOutstandingQueryVariables> & ({ variables: FusionRiderCodOutstandingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FusionRiderCodOutstandingQuery, FusionRiderCodOutstandingQueryVariables>(FusionRiderCodOutstandingDocument, options);
      }
export function useFusionRiderCodOutstandingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FusionRiderCodOutstandingQuery, FusionRiderCodOutstandingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FusionRiderCodOutstandingQuery, FusionRiderCodOutstandingQueryVariables>(FusionRiderCodOutstandingDocument, options);
        }
// @ts-ignore
export function useFusionRiderCodOutstandingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FusionRiderCodOutstandingQuery, FusionRiderCodOutstandingQueryVariables>): Apollo.UseSuspenseQueryResult<FusionRiderCodOutstandingQuery, FusionRiderCodOutstandingQueryVariables>;
export function useFusionRiderCodOutstandingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FusionRiderCodOutstandingQuery, FusionRiderCodOutstandingQueryVariables>): Apollo.UseSuspenseQueryResult<FusionRiderCodOutstandingQuery | undefined, FusionRiderCodOutstandingQueryVariables>;
export function useFusionRiderCodOutstandingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FusionRiderCodOutstandingQuery, FusionRiderCodOutstandingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FusionRiderCodOutstandingQuery, FusionRiderCodOutstandingQueryVariables>(FusionRiderCodOutstandingDocument, options);
        }
export type FusionRiderCodOutstandingQueryHookResult = ReturnType<typeof useFusionRiderCodOutstandingQuery>;
export type FusionRiderCodOutstandingLazyQueryHookResult = ReturnType<typeof useFusionRiderCodOutstandingLazyQuery>;
export type FusionRiderCodOutstandingSuspenseQueryHookResult = ReturnType<typeof useFusionRiderCodOutstandingSuspenseQuery>;
export type FusionRiderCodOutstandingQueryResult = Apollo.QueryResult<FusionRiderCodOutstandingQuery, FusionRiderCodOutstandingQueryVariables>;
export const SettleFusionRiderCodDocument = gql`
    mutation SettleFusionRiderCod($input: SettleFusionRiderCodInput!) {
  settleFusionRiderCod(input: $input) {
    id
    riderId
    amount
    shipmentCount
    settledAt
  }
}
    `;
export type SettleFusionRiderCodMutationFn = Apollo.MutationFunction<SettleFusionRiderCodMutation, SettleFusionRiderCodMutationVariables>;

/**
 * __useSettleFusionRiderCodMutation__
 *
 * To run a mutation, you first call `useSettleFusionRiderCodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSettleFusionRiderCodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [settleFusionRiderCodMutation, { data, loading, error }] = useSettleFusionRiderCodMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSettleFusionRiderCodMutation(baseOptions?: Apollo.MutationHookOptions<SettleFusionRiderCodMutation, SettleFusionRiderCodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SettleFusionRiderCodMutation, SettleFusionRiderCodMutationVariables>(SettleFusionRiderCodDocument, options);
      }
export type SettleFusionRiderCodMutationHookResult = ReturnType<typeof useSettleFusionRiderCodMutation>;
export type SettleFusionRiderCodMutationResult = Apollo.MutationResult<SettleFusionRiderCodMutation>;
export type SettleFusionRiderCodMutationOptions = Apollo.BaseMutationOptions<SettleFusionRiderCodMutation, SettleFusionRiderCodMutationVariables>;
export const FusionShipmentsDocument = gql`
    query FusionShipments($input: ListFusionShipmentsInput) {
  fusionShipments(input: $input) {
    id
    fulfillmentOrderId
    connectionId
    carrierCode
    status
    direction
    capabilities
    needsAttention
    trackingNumber
    consignmentUrl
    quarkSyncedAt
    bookedAt
    cancelledAt
    createdAt
  }
}
    `;

/**
 * __useFusionShipmentsQuery__
 *
 * To run a query within a React component, call `useFusionShipmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFusionShipmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFusionShipmentsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFusionShipmentsQuery(baseOptions?: Apollo.QueryHookOptions<FusionShipmentsQuery, FusionShipmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FusionShipmentsQuery, FusionShipmentsQueryVariables>(FusionShipmentsDocument, options);
      }
export function useFusionShipmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FusionShipmentsQuery, FusionShipmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FusionShipmentsQuery, FusionShipmentsQueryVariables>(FusionShipmentsDocument, options);
        }
// @ts-ignore
export function useFusionShipmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FusionShipmentsQuery, FusionShipmentsQueryVariables>): Apollo.UseSuspenseQueryResult<FusionShipmentsQuery, FusionShipmentsQueryVariables>;
export function useFusionShipmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FusionShipmentsQuery, FusionShipmentsQueryVariables>): Apollo.UseSuspenseQueryResult<FusionShipmentsQuery | undefined, FusionShipmentsQueryVariables>;
export function useFusionShipmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FusionShipmentsQuery, FusionShipmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FusionShipmentsQuery, FusionShipmentsQueryVariables>(FusionShipmentsDocument, options);
        }
export type FusionShipmentsQueryHookResult = ReturnType<typeof useFusionShipmentsQuery>;
export type FusionShipmentsLazyQueryHookResult = ReturnType<typeof useFusionShipmentsLazyQuery>;
export type FusionShipmentsSuspenseQueryHookResult = ReturnType<typeof useFusionShipmentsSuspenseQuery>;
export type FusionShipmentsQueryResult = Apollo.QueryResult<FusionShipmentsQuery, FusionShipmentsQueryVariables>;
export const BookFusionShipmentDocument = gql`
    mutation BookFusionShipment($input: BookFusionShipmentInput!) {
  bookFusionShipment(input: $input) {
    id
    fulfillmentOrderId
    connectionId
    carrierCode
    status
    direction
    capabilities
    needsAttention
    trackingNumber
    consignmentUrl
    quarkSyncedAt
    bookedAt
    cancelledAt
    createdAt
  }
}
    `;
export type BookFusionShipmentMutationFn = Apollo.MutationFunction<BookFusionShipmentMutation, BookFusionShipmentMutationVariables>;

/**
 * __useBookFusionShipmentMutation__
 *
 * To run a mutation, you first call `useBookFusionShipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookFusionShipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookFusionShipmentMutation, { data, loading, error }] = useBookFusionShipmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBookFusionShipmentMutation(baseOptions?: Apollo.MutationHookOptions<BookFusionShipmentMutation, BookFusionShipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BookFusionShipmentMutation, BookFusionShipmentMutationVariables>(BookFusionShipmentDocument, options);
      }
export type BookFusionShipmentMutationHookResult = ReturnType<typeof useBookFusionShipmentMutation>;
export type BookFusionShipmentMutationResult = Apollo.MutationResult<BookFusionShipmentMutation>;
export type BookFusionShipmentMutationOptions = Apollo.BaseMutationOptions<BookFusionShipmentMutation, BookFusionShipmentMutationVariables>;
export const CancelFusionShipmentDocument = gql`
    mutation CancelFusionShipment($shipmentId: String!) {
  cancelFusionShipment(shipmentId: $shipmentId) {
    id
    status
    needsAttention
    cancelledAt
  }
}
    `;
export type CancelFusionShipmentMutationFn = Apollo.MutationFunction<CancelFusionShipmentMutation, CancelFusionShipmentMutationVariables>;

/**
 * __useCancelFusionShipmentMutation__
 *
 * To run a mutation, you first call `useCancelFusionShipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelFusionShipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelFusionShipmentMutation, { data, loading, error }] = useCancelFusionShipmentMutation({
 *   variables: {
 *      shipmentId: // value for 'shipmentId'
 *   },
 * });
 */
export function useCancelFusionShipmentMutation(baseOptions?: Apollo.MutationHookOptions<CancelFusionShipmentMutation, CancelFusionShipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelFusionShipmentMutation, CancelFusionShipmentMutationVariables>(CancelFusionShipmentDocument, options);
      }
export type CancelFusionShipmentMutationHookResult = ReturnType<typeof useCancelFusionShipmentMutation>;
export type CancelFusionShipmentMutationResult = Apollo.MutationResult<CancelFusionShipmentMutation>;
export type CancelFusionShipmentMutationOptions = Apollo.BaseMutationOptions<CancelFusionShipmentMutation, CancelFusionShipmentMutationVariables>;
export const RetryFusionShipmentQuarkSyncDocument = gql`
    mutation RetryFusionShipmentQuarkSync($shipmentId: String!) {
  retryFusionShipmentQuarkSync(shipmentId: $shipmentId) {
    id
    status
    needsAttention
    quarkSyncedAt
  }
}
    `;
export type RetryFusionShipmentQuarkSyncMutationFn = Apollo.MutationFunction<RetryFusionShipmentQuarkSyncMutation, RetryFusionShipmentQuarkSyncMutationVariables>;

/**
 * __useRetryFusionShipmentQuarkSyncMutation__
 *
 * To run a mutation, you first call `useRetryFusionShipmentQuarkSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryFusionShipmentQuarkSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryFusionShipmentQuarkSyncMutation, { data, loading, error }] = useRetryFusionShipmentQuarkSyncMutation({
 *   variables: {
 *      shipmentId: // value for 'shipmentId'
 *   },
 * });
 */
export function useRetryFusionShipmentQuarkSyncMutation(baseOptions?: Apollo.MutationHookOptions<RetryFusionShipmentQuarkSyncMutation, RetryFusionShipmentQuarkSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetryFusionShipmentQuarkSyncMutation, RetryFusionShipmentQuarkSyncMutationVariables>(RetryFusionShipmentQuarkSyncDocument, options);
      }
export type RetryFusionShipmentQuarkSyncMutationHookResult = ReturnType<typeof useRetryFusionShipmentQuarkSyncMutation>;
export type RetryFusionShipmentQuarkSyncMutationResult = Apollo.MutationResult<RetryFusionShipmentQuarkSyncMutation>;
export type RetryFusionShipmentQuarkSyncMutationOptions = Apollo.BaseMutationOptions<RetryFusionShipmentQuarkSyncMutation, RetryFusionShipmentQuarkSyncMutationVariables>;
export const BookFusionReturnShipmentDocument = gql`
    mutation BookFusionReturnShipment($returnOrderId: String!) {
  bookFusionReturnShipment(returnOrderId: $returnOrderId) {
    id
    status
    trackingNumber
    bookedAt
  }
}
    `;
export type BookFusionReturnShipmentMutationFn = Apollo.MutationFunction<BookFusionReturnShipmentMutation, BookFusionReturnShipmentMutationVariables>;

/**
 * __useBookFusionReturnShipmentMutation__
 *
 * To run a mutation, you first call `useBookFusionReturnShipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookFusionReturnShipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookFusionReturnShipmentMutation, { data, loading, error }] = useBookFusionReturnShipmentMutation({
 *   variables: {
 *      returnOrderId: // value for 'returnOrderId'
 *   },
 * });
 */
export function useBookFusionReturnShipmentMutation(baseOptions?: Apollo.MutationHookOptions<BookFusionReturnShipmentMutation, BookFusionReturnShipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BookFusionReturnShipmentMutation, BookFusionReturnShipmentMutationVariables>(BookFusionReturnShipmentDocument, options);
      }
export type BookFusionReturnShipmentMutationHookResult = ReturnType<typeof useBookFusionReturnShipmentMutation>;
export type BookFusionReturnShipmentMutationResult = Apollo.MutationResult<BookFusionReturnShipmentMutation>;
export type BookFusionReturnShipmentMutationOptions = Apollo.BaseMutationOptions<BookFusionReturnShipmentMutation, BookFusionReturnShipmentMutationVariables>;
export const GrnSummaryDocument = gql`
    query GrnSummary($startDate: String!, $endDate: String!, $locationId: String!) {
  grnSummary(startDate: $startDate, endDate: $endDate, locationId: $locationId) {
    grn
    accepted
    rejected
    partial
  }
}
    `;

/**
 * __useGrnSummaryQuery__
 *
 * To run a query within a React component, call `useGrnSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGrnSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGrnSummaryQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useGrnSummaryQuery(baseOptions: Apollo.QueryHookOptions<GrnSummaryQuery, GrnSummaryQueryVariables> & ({ variables: GrnSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GrnSummaryQuery, GrnSummaryQueryVariables>(GrnSummaryDocument, options);
      }
export function useGrnSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GrnSummaryQuery, GrnSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GrnSummaryQuery, GrnSummaryQueryVariables>(GrnSummaryDocument, options);
        }
// @ts-ignore
export function useGrnSummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GrnSummaryQuery, GrnSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<GrnSummaryQuery, GrnSummaryQueryVariables>;
export function useGrnSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GrnSummaryQuery, GrnSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<GrnSummaryQuery | undefined, GrnSummaryQueryVariables>;
export function useGrnSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GrnSummaryQuery, GrnSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GrnSummaryQuery, GrnSummaryQueryVariables>(GrnSummaryDocument, options);
        }
export type GrnSummaryQueryHookResult = ReturnType<typeof useGrnSummaryQuery>;
export type GrnSummaryLazyQueryHookResult = ReturnType<typeof useGrnSummaryLazyQuery>;
export type GrnSummarySuspenseQueryHookResult = ReturnType<typeof useGrnSummarySuspenseQuery>;
export type GrnSummaryQueryResult = Apollo.QueryResult<GrnSummaryQuery, GrnSummaryQueryVariables>;
export const StockIntakeSummaryDocument = gql`
    query StockIntakeSummary($startDate: String!, $endDate: String!, $locationId: String!) {
  stockIntakeSummary(
    startDate: $startDate
    endDate: $endDate
    locationId: $locationId
  ) {
    items
    quantity
    value
    gst
  }
}
    `;

/**
 * __useStockIntakeSummaryQuery__
 *
 * To run a query within a React component, call `useStockIntakeSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useStockIntakeSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStockIntakeSummaryQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useStockIntakeSummaryQuery(baseOptions: Apollo.QueryHookOptions<StockIntakeSummaryQuery, StockIntakeSummaryQueryVariables> & ({ variables: StockIntakeSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StockIntakeSummaryQuery, StockIntakeSummaryQueryVariables>(StockIntakeSummaryDocument, options);
      }
export function useStockIntakeSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StockIntakeSummaryQuery, StockIntakeSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StockIntakeSummaryQuery, StockIntakeSummaryQueryVariables>(StockIntakeSummaryDocument, options);
        }
// @ts-ignore
export function useStockIntakeSummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StockIntakeSummaryQuery, StockIntakeSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<StockIntakeSummaryQuery, StockIntakeSummaryQueryVariables>;
export function useStockIntakeSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StockIntakeSummaryQuery, StockIntakeSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<StockIntakeSummaryQuery | undefined, StockIntakeSummaryQueryVariables>;
export function useStockIntakeSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StockIntakeSummaryQuery, StockIntakeSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StockIntakeSummaryQuery, StockIntakeSummaryQueryVariables>(StockIntakeSummaryDocument, options);
        }
export type StockIntakeSummaryQueryHookResult = ReturnType<typeof useStockIntakeSummaryQuery>;
export type StockIntakeSummaryLazyQueryHookResult = ReturnType<typeof useStockIntakeSummaryLazyQuery>;
export type StockIntakeSummarySuspenseQueryHookResult = ReturnType<typeof useStockIntakeSummarySuspenseQuery>;
export type StockIntakeSummaryQueryResult = Apollo.QueryResult<StockIntakeSummaryQuery, StockIntakeSummaryQueryVariables>;
export const CreateGrnDocument = gql`
    mutation CreateGrn($createGrnDto: CreateGrnDTO!) {
  createGrn(CreateGrnDTO: $createGrnDto)
}
    `;
export type CreateGrnMutationFn = Apollo.MutationFunction<CreateGrnMutation, CreateGrnMutationVariables>;

/**
 * __useCreateGrnMutation__
 *
 * To run a mutation, you first call `useCreateGrnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGrnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGrnMutation, { data, loading, error }] = useCreateGrnMutation({
 *   variables: {
 *      createGrnDto: // value for 'createGrnDto'
 *   },
 * });
 */
export function useCreateGrnMutation(baseOptions?: Apollo.MutationHookOptions<CreateGrnMutation, CreateGrnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGrnMutation, CreateGrnMutationVariables>(CreateGrnDocument, options);
      }
export type CreateGrnMutationHookResult = ReturnType<typeof useCreateGrnMutation>;
export type CreateGrnMutationResult = Apollo.MutationResult<CreateGrnMutation>;
export type CreateGrnMutationOptions = Apollo.BaseMutationOptions<CreateGrnMutation, CreateGrnMutationVariables>;
export const UpdateGrnQcStatusDocument = gql`
    mutation UpdateGrnQCStatus($updateGrnItemStatusDto: UpdateGrnItemStatus!) {
  updateGrnQCStatus(UpdateGrnItemStatusDTO: $updateGrnItemStatusDto)
}
    `;
export type UpdateGrnQcStatusMutationFn = Apollo.MutationFunction<UpdateGrnQcStatusMutation, UpdateGrnQcStatusMutationVariables>;

/**
 * __useUpdateGrnQcStatusMutation__
 *
 * To run a mutation, you first call `useUpdateGrnQcStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGrnQcStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGrnQcStatusMutation, { data, loading, error }] = useUpdateGrnQcStatusMutation({
 *   variables: {
 *      updateGrnItemStatusDto: // value for 'updateGrnItemStatusDto'
 *   },
 * });
 */
export function useUpdateGrnQcStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGrnQcStatusMutation, UpdateGrnQcStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGrnQcStatusMutation, UpdateGrnQcStatusMutationVariables>(UpdateGrnQcStatusDocument, options);
      }
export type UpdateGrnQcStatusMutationHookResult = ReturnType<typeof useUpdateGrnQcStatusMutation>;
export type UpdateGrnQcStatusMutationResult = Apollo.MutationResult<UpdateGrnQcStatusMutation>;
export type UpdateGrnQcStatusMutationOptions = Apollo.BaseMutationOptions<UpdateGrnQcStatusMutation, UpdateGrnQcStatusMutationVariables>;
export const GetAllGrnsListDocument = gql`
    query GetAllGrnsList($sort: [SortCondition!], $page: Int!, $limit: Int!, $filter: [FilterGroup!], $locationId: String) {
  getAllGrns(
    sort: $sort
    page: $page
    limit: $limit
    filter: $filter
    locationId: $locationId
  ) {
    data {
      id
      secondaryId
      advanceIncomeTax
      amount
      comment
      discount
      invoiceDate
      invoiceNumber
      poId
      receivedQuantity
      stockArrivalDate
      tax
      total
      createdAt
      updatedAt
      status
    }
    meta {
      totalCount
      page
      limit
    }
  }
}
    `;

/**
 * __useGetAllGrnsListQuery__
 *
 * To run a query within a React component, call `useGetAllGrnsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllGrnsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllGrnsListQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useGetAllGrnsListQuery(baseOptions: Apollo.QueryHookOptions<GetAllGrnsListQuery, GetAllGrnsListQueryVariables> & ({ variables: GetAllGrnsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllGrnsListQuery, GetAllGrnsListQueryVariables>(GetAllGrnsListDocument, options);
      }
export function useGetAllGrnsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllGrnsListQuery, GetAllGrnsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllGrnsListQuery, GetAllGrnsListQueryVariables>(GetAllGrnsListDocument, options);
        }
// @ts-ignore
export function useGetAllGrnsListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllGrnsListQuery, GetAllGrnsListQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllGrnsListQuery, GetAllGrnsListQueryVariables>;
export function useGetAllGrnsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllGrnsListQuery, GetAllGrnsListQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllGrnsListQuery | undefined, GetAllGrnsListQueryVariables>;
export function useGetAllGrnsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllGrnsListQuery, GetAllGrnsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllGrnsListQuery, GetAllGrnsListQueryVariables>(GetAllGrnsListDocument, options);
        }
export type GetAllGrnsListQueryHookResult = ReturnType<typeof useGetAllGrnsListQuery>;
export type GetAllGrnsListLazyQueryHookResult = ReturnType<typeof useGetAllGrnsListLazyQuery>;
export type GetAllGrnsListSuspenseQueryHookResult = ReturnType<typeof useGetAllGrnsListSuspenseQuery>;
export type GetAllGrnsListQueryResult = Apollo.QueryResult<GetAllGrnsListQuery, GetAllGrnsListQueryVariables>;
export const GetOneGrnDetailsDocument = gql`
    query GetOneGrnDetails($grnId: String!) {
  getOneGrn(grnId: $grnId) {
    invoiceDate
    invoiceNumber
    advanceIncomeTax
    id
    secondaryId
    poId
    status
    stockArrivalDate
    createdByName
    designation
    purchaseOrder {
      id
      secondaryId
      createdAt
      vendor {
        id
        secondaryId
        name
      }
    }
    grnItems {
      actionId
      batchExpiry
      batchNumber
      comment
      rejectComment
      discValue
      foc
      gstValue
      id
      mrp
      mfgDate
      receivedQuantity
      requiredQuantity
      status
      tradePrice
      uomFactor
      isManufacturerTracking
      trackingLevel
      purchaseOrderItem {
        id
        uom
        itemConversion
        product {
          id
          name
          secondaryId
          manufacturer {
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetOneGrnDetailsQuery__
 *
 * To run a query within a React component, call `useGetOneGrnDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOneGrnDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOneGrnDetailsQuery({
 *   variables: {
 *      grnId: // value for 'grnId'
 *   },
 * });
 */
export function useGetOneGrnDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetOneGrnDetailsQuery, GetOneGrnDetailsQueryVariables> & ({ variables: GetOneGrnDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOneGrnDetailsQuery, GetOneGrnDetailsQueryVariables>(GetOneGrnDetailsDocument, options);
      }
export function useGetOneGrnDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOneGrnDetailsQuery, GetOneGrnDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOneGrnDetailsQuery, GetOneGrnDetailsQueryVariables>(GetOneGrnDetailsDocument, options);
        }
// @ts-ignore
export function useGetOneGrnDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOneGrnDetailsQuery, GetOneGrnDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOneGrnDetailsQuery, GetOneGrnDetailsQueryVariables>;
export function useGetOneGrnDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOneGrnDetailsQuery, GetOneGrnDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOneGrnDetailsQuery | undefined, GetOneGrnDetailsQueryVariables>;
export function useGetOneGrnDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOneGrnDetailsQuery, GetOneGrnDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOneGrnDetailsQuery, GetOneGrnDetailsQueryVariables>(GetOneGrnDetailsDocument, options);
        }
export type GetOneGrnDetailsQueryHookResult = ReturnType<typeof useGetOneGrnDetailsQuery>;
export type GetOneGrnDetailsLazyQueryHookResult = ReturnType<typeof useGetOneGrnDetailsLazyQuery>;
export type GetOneGrnDetailsSuspenseQueryHookResult = ReturnType<typeof useGetOneGrnDetailsSuspenseQuery>;
export type GetOneGrnDetailsQueryResult = Apollo.QueryResult<GetOneGrnDetailsQuery, GetOneGrnDetailsQueryVariables>;
export const GetAllGrnItemsDocument = gql`
    query GetAllGrnItems($locationId: String!, $page: Int!, $limit: Int!, $sort: [SortCondition!], $filter: [FilterGroup!]) {
  getAllGrnItems(
    locationId: $locationId
    page: $page
    limit: $limit
    sort: $sort
    filter: $filter
  ) {
    data {
      actionId
      batchExpiry
      batchNumber
      comment
      discValue
      gstValue
      foc
      id
      secondaryId
      mrp
      receivedQuantity
      requiredQuantity
      status
      tradePrice
      createdAt
      updatedAt
      serialNumbers
      trackingLevel
      isManufacturerTracking
      manufacturerCode
      purchaseOrderItem {
        foc
        grnRemainingQuantity
        gstPercentage
        id
        secondaryId
        itemConversion
        purchaseOrder {
          id
          secondaryId
        }
        product {
          id
          name
          secondaryId
        }
        uom
      }
    }
    meta {
      limit
      page
      totalCount
    }
  }
}
    `;

/**
 * __useGetAllGrnItemsQuery__
 *
 * To run a query within a React component, call `useGetAllGrnItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllGrnItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllGrnItemsQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetAllGrnItemsQuery(baseOptions: Apollo.QueryHookOptions<GetAllGrnItemsQuery, GetAllGrnItemsQueryVariables> & ({ variables: GetAllGrnItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllGrnItemsQuery, GetAllGrnItemsQueryVariables>(GetAllGrnItemsDocument, options);
      }
export function useGetAllGrnItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllGrnItemsQuery, GetAllGrnItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllGrnItemsQuery, GetAllGrnItemsQueryVariables>(GetAllGrnItemsDocument, options);
        }
// @ts-ignore
export function useGetAllGrnItemsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllGrnItemsQuery, GetAllGrnItemsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllGrnItemsQuery, GetAllGrnItemsQueryVariables>;
export function useGetAllGrnItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllGrnItemsQuery, GetAllGrnItemsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllGrnItemsQuery | undefined, GetAllGrnItemsQueryVariables>;
export function useGetAllGrnItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllGrnItemsQuery, GetAllGrnItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllGrnItemsQuery, GetAllGrnItemsQueryVariables>(GetAllGrnItemsDocument, options);
        }
export type GetAllGrnItemsQueryHookResult = ReturnType<typeof useGetAllGrnItemsQuery>;
export type GetAllGrnItemsLazyQueryHookResult = ReturnType<typeof useGetAllGrnItemsLazyQuery>;
export type GetAllGrnItemsSuspenseQueryHookResult = ReturnType<typeof useGetAllGrnItemsSuspenseQuery>;
export type GetAllGrnItemsQueryResult = Apollo.QueryResult<GetAllGrnItemsQuery, GetAllGrnItemsQueryVariables>;
export const UpdateGrnItemSerialNumbersDocument = gql`
    mutation UpdateGrnItemSerialNumbers($grnItemId: String!, $serialNumbers: [String!]!) {
  updateGrnItemSerialNumbers(grnItemId: $grnItemId, serialNumbers: $serialNumbers)
}
    `;
export type UpdateGrnItemSerialNumbersMutationFn = Apollo.MutationFunction<UpdateGrnItemSerialNumbersMutation, UpdateGrnItemSerialNumbersMutationVariables>;

/**
 * __useUpdateGrnItemSerialNumbersMutation__
 *
 * To run a mutation, you first call `useUpdateGrnItemSerialNumbersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGrnItemSerialNumbersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGrnItemSerialNumbersMutation, { data, loading, error }] = useUpdateGrnItemSerialNumbersMutation({
 *   variables: {
 *      grnItemId: // value for 'grnItemId'
 *      serialNumbers: // value for 'serialNumbers'
 *   },
 * });
 */
export function useUpdateGrnItemSerialNumbersMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGrnItemSerialNumbersMutation, UpdateGrnItemSerialNumbersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGrnItemSerialNumbersMutation, UpdateGrnItemSerialNumbersMutationVariables>(UpdateGrnItemSerialNumbersDocument, options);
      }
export type UpdateGrnItemSerialNumbersMutationHookResult = ReturnType<typeof useUpdateGrnItemSerialNumbersMutation>;
export type UpdateGrnItemSerialNumbersMutationResult = Apollo.MutationResult<UpdateGrnItemSerialNumbersMutation>;
export type UpdateGrnItemSerialNumbersMutationOptions = Apollo.BaseMutationOptions<UpdateGrnItemSerialNumbersMutation, UpdateGrnItemSerialNumbersMutationVariables>;
export const UpdateGrnReceivedStatusDocument = gql`
    mutation UpdateGrnReceivedStatus($grnId: [String!]!) {
  updateGrnReceivedStatus(grnId: $grnId)
}
    `;
export type UpdateGrnReceivedStatusMutationFn = Apollo.MutationFunction<UpdateGrnReceivedStatusMutation, UpdateGrnReceivedStatusMutationVariables>;

/**
 * __useUpdateGrnReceivedStatusMutation__
 *
 * To run a mutation, you first call `useUpdateGrnReceivedStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGrnReceivedStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGrnReceivedStatusMutation, { data, loading, error }] = useUpdateGrnReceivedStatusMutation({
 *   variables: {
 *      grnId: // value for 'grnId'
 *   },
 * });
 */
export function useUpdateGrnReceivedStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGrnReceivedStatusMutation, UpdateGrnReceivedStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGrnReceivedStatusMutation, UpdateGrnReceivedStatusMutationVariables>(UpdateGrnReceivedStatusDocument, options);
      }
export type UpdateGrnReceivedStatusMutationHookResult = ReturnType<typeof useUpdateGrnReceivedStatusMutation>;
export type UpdateGrnReceivedStatusMutationResult = Apollo.MutationResult<UpdateGrnReceivedStatusMutation>;
export type UpdateGrnReceivedStatusMutationOptions = Apollo.BaseMutationOptions<UpdateGrnReceivedStatusMutation, UpdateGrnReceivedStatusMutationVariables>;
export const GetIntegrationsDocument = gql`
    query GetIntegrations($locationId: String, $sort: [SortCondition!], $page: Int!, $filter: [FilterGroup!], $limit: Int!) {
  getIntegrations(
    locationId: $locationId
    sort: $sort
    page: $page
    filter: $filter
    limit: $limit
  ) {
    data {
      allowedOrderType
      charges
      createdAt
      id
      integrationId
      locationId
      logo
      name
      registerId
      status
      type
      updatedAt
    }
    meta {
      limit
      page
      total
      totalCount
    }
  }
}
    `;

/**
 * __useGetIntegrationsQuery__
 *
 * To run a query within a React component, call `useGetIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationsQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetIntegrationsQuery(baseOptions: Apollo.QueryHookOptions<GetIntegrationsQuery, GetIntegrationsQueryVariables> & ({ variables: GetIntegrationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIntegrationsQuery, GetIntegrationsQueryVariables>(GetIntegrationsDocument, options);
      }
export function useGetIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIntegrationsQuery, GetIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIntegrationsQuery, GetIntegrationsQueryVariables>(GetIntegrationsDocument, options);
        }
// @ts-ignore
export function useGetIntegrationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetIntegrationsQuery, GetIntegrationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetIntegrationsQuery, GetIntegrationsQueryVariables>;
export function useGetIntegrationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIntegrationsQuery, GetIntegrationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetIntegrationsQuery | undefined, GetIntegrationsQueryVariables>;
export function useGetIntegrationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIntegrationsQuery, GetIntegrationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIntegrationsQuery, GetIntegrationsQueryVariables>(GetIntegrationsDocument, options);
        }
export type GetIntegrationsQueryHookResult = ReturnType<typeof useGetIntegrationsQuery>;
export type GetIntegrationsLazyQueryHookResult = ReturnType<typeof useGetIntegrationsLazyQuery>;
export type GetIntegrationsSuspenseQueryHookResult = ReturnType<typeof useGetIntegrationsSuspenseQuery>;
export type GetIntegrationsQueryResult = Apollo.QueryResult<GetIntegrationsQuery, GetIntegrationsQueryVariables>;
export const GetIntegrationDocument = gql`
    query GetIntegration($getIntegrationId: ID!) {
  getIntegration(id: $getIntegrationId) {
    allowedOrderType
    charges
    createdAt
    id
    integrationId
    locationId
    logo
    name
    registerId
    status
    type
    updatedAt
  }
}
    `;

/**
 * __useGetIntegrationQuery__
 *
 * To run a query within a React component, call `useGetIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationQuery({
 *   variables: {
 *      getIntegrationId: // value for 'getIntegrationId'
 *   },
 * });
 */
export function useGetIntegrationQuery(baseOptions: Apollo.QueryHookOptions<GetIntegrationQuery, GetIntegrationQueryVariables> & ({ variables: GetIntegrationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIntegrationQuery, GetIntegrationQueryVariables>(GetIntegrationDocument, options);
      }
export function useGetIntegrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIntegrationQuery, GetIntegrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIntegrationQuery, GetIntegrationQueryVariables>(GetIntegrationDocument, options);
        }
// @ts-ignore
export function useGetIntegrationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetIntegrationQuery, GetIntegrationQueryVariables>): Apollo.UseSuspenseQueryResult<GetIntegrationQuery, GetIntegrationQueryVariables>;
export function useGetIntegrationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIntegrationQuery, GetIntegrationQueryVariables>): Apollo.UseSuspenseQueryResult<GetIntegrationQuery | undefined, GetIntegrationQueryVariables>;
export function useGetIntegrationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIntegrationQuery, GetIntegrationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIntegrationQuery, GetIntegrationQueryVariables>(GetIntegrationDocument, options);
        }
export type GetIntegrationQueryHookResult = ReturnType<typeof useGetIntegrationQuery>;
export type GetIntegrationLazyQueryHookResult = ReturnType<typeof useGetIntegrationLazyQuery>;
export type GetIntegrationSuspenseQueryHookResult = ReturnType<typeof useGetIntegrationSuspenseQuery>;
export type GetIntegrationQueryResult = Apollo.QueryResult<GetIntegrationQuery, GetIntegrationQueryVariables>;
export const CreateIntegrationDocument = gql`
    mutation CreateIntegration($createIntegrationDto: CreateIntegrationConfigDTO!) {
  createIntegration(createIntegrationDTO: $createIntegrationDto) {
    id
  }
}
    `;
export type CreateIntegrationMutationFn = Apollo.MutationFunction<CreateIntegrationMutation, CreateIntegrationMutationVariables>;

/**
 * __useCreateIntegrationMutation__
 *
 * To run a mutation, you first call `useCreateIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIntegrationMutation, { data, loading, error }] = useCreateIntegrationMutation({
 *   variables: {
 *      createIntegrationDto: // value for 'createIntegrationDto'
 *   },
 * });
 */
export function useCreateIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<CreateIntegrationMutation, CreateIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIntegrationMutation, CreateIntegrationMutationVariables>(CreateIntegrationDocument, options);
      }
export type CreateIntegrationMutationHookResult = ReturnType<typeof useCreateIntegrationMutation>;
export type CreateIntegrationMutationResult = Apollo.MutationResult<CreateIntegrationMutation>;
export type CreateIntegrationMutationOptions = Apollo.BaseMutationOptions<CreateIntegrationMutation, CreateIntegrationMutationVariables>;
export const UpdateIntegrationDocument = gql`
    mutation UpdateIntegration($updateIntegrationInput: UpdateIntegrationConfigDTO!) {
  updateIntegration(updateIntegrationInput: $updateIntegrationInput) {
    id
  }
}
    `;
export type UpdateIntegrationMutationFn = Apollo.MutationFunction<UpdateIntegrationMutation, UpdateIntegrationMutationVariables>;

/**
 * __useUpdateIntegrationMutation__
 *
 * To run a mutation, you first call `useUpdateIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIntegrationMutation, { data, loading, error }] = useUpdateIntegrationMutation({
 *   variables: {
 *      updateIntegrationInput: // value for 'updateIntegrationInput'
 *   },
 * });
 */
export function useUpdateIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIntegrationMutation, UpdateIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIntegrationMutation, UpdateIntegrationMutationVariables>(UpdateIntegrationDocument, options);
      }
export type UpdateIntegrationMutationHookResult = ReturnType<typeof useUpdateIntegrationMutation>;
export type UpdateIntegrationMutationResult = Apollo.MutationResult<UpdateIntegrationMutation>;
export type UpdateIntegrationMutationOptions = Apollo.BaseMutationOptions<UpdateIntegrationMutation, UpdateIntegrationMutationVariables>;
export const GetLocationListForOptionsDocument = gql`
    query GetLocationListForOptions($page: Int!, $limit: Int!, $filter: [FilterGroup!], $sort: [SortCondition!], $locationId: String) {
  getLocations(
    page: $page
    limit: $limit
    filter: $filter
    sort: $sort
    locationId: $locationId
  ) {
    meta {
      limit
      page
      totalCount
    }
    data {
      id
      name
      type
    }
  }
}
    `;

/**
 * __useGetLocationListForOptionsQuery__
 *
 * To run a query within a React component, call `useGetLocationListForOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationListForOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationListForOptionsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useGetLocationListForOptionsQuery(baseOptions: Apollo.QueryHookOptions<GetLocationListForOptionsQuery, GetLocationListForOptionsQueryVariables> & ({ variables: GetLocationListForOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationListForOptionsQuery, GetLocationListForOptionsQueryVariables>(GetLocationListForOptionsDocument, options);
      }
export function useGetLocationListForOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationListForOptionsQuery, GetLocationListForOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationListForOptionsQuery, GetLocationListForOptionsQueryVariables>(GetLocationListForOptionsDocument, options);
        }
// @ts-ignore
export function useGetLocationListForOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLocationListForOptionsQuery, GetLocationListForOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetLocationListForOptionsQuery, GetLocationListForOptionsQueryVariables>;
export function useGetLocationListForOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLocationListForOptionsQuery, GetLocationListForOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetLocationListForOptionsQuery | undefined, GetLocationListForOptionsQueryVariables>;
export function useGetLocationListForOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLocationListForOptionsQuery, GetLocationListForOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLocationListForOptionsQuery, GetLocationListForOptionsQueryVariables>(GetLocationListForOptionsDocument, options);
        }
export type GetLocationListForOptionsQueryHookResult = ReturnType<typeof useGetLocationListForOptionsQuery>;
export type GetLocationListForOptionsLazyQueryHookResult = ReturnType<typeof useGetLocationListForOptionsLazyQuery>;
export type GetLocationListForOptionsSuspenseQueryHookResult = ReturnType<typeof useGetLocationListForOptionsSuspenseQuery>;
export type GetLocationListForOptionsQueryResult = Apollo.QueryResult<GetLocationListForOptionsQuery, GetLocationListForOptionsQueryVariables>;
export const GetLocationsListDocument = gql`
    query GetLocationsList($filter: [FilterGroup!], $limit: Int!, $locationId: String, $page: Int!, $sort: [SortCondition!]) {
  getLocations(
    filter: $filter
    limit: $limit
    locationId: $locationId
    page: $page
    sort: $sort
  ) {
    data {
      id
      secondaryId
      name
      area
      status
      type
      createdAt
      updatedAt
      warehouse {
        name
      }
    }
  }
}
    `;

/**
 * __useGetLocationsListQuery__
 *
 * To run a query within a React component, call `useGetLocationsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationsListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      locationId: // value for 'locationId'
 *      page: // value for 'page'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetLocationsListQuery(baseOptions: Apollo.QueryHookOptions<GetLocationsListQuery, GetLocationsListQueryVariables> & ({ variables: GetLocationsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationsListQuery, GetLocationsListQueryVariables>(GetLocationsListDocument, options);
      }
export function useGetLocationsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationsListQuery, GetLocationsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationsListQuery, GetLocationsListQueryVariables>(GetLocationsListDocument, options);
        }
// @ts-ignore
export function useGetLocationsListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLocationsListQuery, GetLocationsListQueryVariables>): Apollo.UseSuspenseQueryResult<GetLocationsListQuery, GetLocationsListQueryVariables>;
export function useGetLocationsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLocationsListQuery, GetLocationsListQueryVariables>): Apollo.UseSuspenseQueryResult<GetLocationsListQuery | undefined, GetLocationsListQueryVariables>;
export function useGetLocationsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLocationsListQuery, GetLocationsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLocationsListQuery, GetLocationsListQueryVariables>(GetLocationsListDocument, options);
        }
export type GetLocationsListQueryHookResult = ReturnType<typeof useGetLocationsListQuery>;
export type GetLocationsListLazyQueryHookResult = ReturnType<typeof useGetLocationsListLazyQuery>;
export type GetLocationsListSuspenseQueryHookResult = ReturnType<typeof useGetLocationsListSuspenseQuery>;
export type GetLocationsListQueryResult = Apollo.QueryResult<GetLocationsListQuery, GetLocationsListQueryVariables>;
export const GetLocationForDetailsDocument = gql`
    query GetLocationForDetails($getLocationId: String!) {
  getLocation(id: $getLocationId) {
    area
    cityId
    createdAt
    id
    name
    salesTaxNumber
    secondaryId
    status
    taxNumber
    type
    updatedAt
    warehouseId
    timezone
    warehouse {
      name
      id
    }
    city {
      id
      name
      country {
        name
        id
      }
    }
  }
}
    `;

/**
 * __useGetLocationForDetailsQuery__
 *
 * To run a query within a React component, call `useGetLocationForDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationForDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationForDetailsQuery({
 *   variables: {
 *      getLocationId: // value for 'getLocationId'
 *   },
 * });
 */
export function useGetLocationForDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetLocationForDetailsQuery, GetLocationForDetailsQueryVariables> & ({ variables: GetLocationForDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationForDetailsQuery, GetLocationForDetailsQueryVariables>(GetLocationForDetailsDocument, options);
      }
export function useGetLocationForDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationForDetailsQuery, GetLocationForDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationForDetailsQuery, GetLocationForDetailsQueryVariables>(GetLocationForDetailsDocument, options);
        }
// @ts-ignore
export function useGetLocationForDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLocationForDetailsQuery, GetLocationForDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetLocationForDetailsQuery, GetLocationForDetailsQueryVariables>;
export function useGetLocationForDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLocationForDetailsQuery, GetLocationForDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetLocationForDetailsQuery | undefined, GetLocationForDetailsQueryVariables>;
export function useGetLocationForDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLocationForDetailsQuery, GetLocationForDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLocationForDetailsQuery, GetLocationForDetailsQueryVariables>(GetLocationForDetailsDocument, options);
        }
export type GetLocationForDetailsQueryHookResult = ReturnType<typeof useGetLocationForDetailsQuery>;
export type GetLocationForDetailsLazyQueryHookResult = ReturnType<typeof useGetLocationForDetailsLazyQuery>;
export type GetLocationForDetailsSuspenseQueryHookResult = ReturnType<typeof useGetLocationForDetailsSuspenseQuery>;
export type GetLocationForDetailsQueryResult = Apollo.QueryResult<GetLocationForDetailsQuery, GetLocationForDetailsQueryVariables>;
export const GetCountriesDocument = gql`
    query GetCountries {
  getCountries {
    name
    id
  }
}
    `;

/**
 * __useGetCountriesQuery__
 *
 * To run a query within a React component, call `useGetCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCountriesQuery(baseOptions?: Apollo.QueryHookOptions<GetCountriesQuery, GetCountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCountriesQuery, GetCountriesQueryVariables>(GetCountriesDocument, options);
      }
export function useGetCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCountriesQuery, GetCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCountriesQuery, GetCountriesQueryVariables>(GetCountriesDocument, options);
        }
// @ts-ignore
export function useGetCountriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCountriesQuery, GetCountriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCountriesQuery, GetCountriesQueryVariables>;
export function useGetCountriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCountriesQuery, GetCountriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCountriesQuery | undefined, GetCountriesQueryVariables>;
export function useGetCountriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCountriesQuery, GetCountriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCountriesQuery, GetCountriesQueryVariables>(GetCountriesDocument, options);
        }
export type GetCountriesQueryHookResult = ReturnType<typeof useGetCountriesQuery>;
export type GetCountriesLazyQueryHookResult = ReturnType<typeof useGetCountriesLazyQuery>;
export type GetCountriesSuspenseQueryHookResult = ReturnType<typeof useGetCountriesSuspenseQuery>;
export type GetCountriesQueryResult = Apollo.QueryResult<GetCountriesQuery, GetCountriesQueryVariables>;
export const GetCitiesDocument = gql`
    query GetCities($sort: [SortCondition!], $page: Int!, $limit: Int!, $filter: [FilterGroup!]) {
  getCities(sort: $sort, page: $page, limit: $limit, filter: $filter) {
    meta {
      totalCount
      limit
      page
      total
    }
    data {
      id
      name
      country {
        name
        id
      }
    }
  }
}
    `;

/**
 * __useGetCitiesQuery__
 *
 * To run a query within a React component, call `useGetCitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCitiesQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetCitiesQuery(baseOptions: Apollo.QueryHookOptions<GetCitiesQuery, GetCitiesQueryVariables> & ({ variables: GetCitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCitiesQuery, GetCitiesQueryVariables>(GetCitiesDocument, options);
      }
export function useGetCitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCitiesQuery, GetCitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCitiesQuery, GetCitiesQueryVariables>(GetCitiesDocument, options);
        }
// @ts-ignore
export function useGetCitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCitiesQuery, GetCitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCitiesQuery, GetCitiesQueryVariables>;
export function useGetCitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCitiesQuery, GetCitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCitiesQuery | undefined, GetCitiesQueryVariables>;
export function useGetCitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCitiesQuery, GetCitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCitiesQuery, GetCitiesQueryVariables>(GetCitiesDocument, options);
        }
export type GetCitiesQueryHookResult = ReturnType<typeof useGetCitiesQuery>;
export type GetCitiesLazyQueryHookResult = ReturnType<typeof useGetCitiesLazyQuery>;
export type GetCitiesSuspenseQueryHookResult = ReturnType<typeof useGetCitiesSuspenseQuery>;
export type GetCitiesQueryResult = Apollo.QueryResult<GetCitiesQuery, GetCitiesQueryVariables>;
export const GetCitiesOptionsDocument = gql`
    query GetCitiesOptions($sort: [SortCondition!], $page: Int!, $limit: Int!, $filter: [FilterGroup!]) {
  getCities(sort: $sort, page: $page, limit: $limit, filter: $filter) {
    meta {
      totalCount
      limit
      page
      total
    }
    data {
      id
      name
    }
  }
}
    `;

/**
 * __useGetCitiesOptionsQuery__
 *
 * To run a query within a React component, call `useGetCitiesOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCitiesOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCitiesOptionsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetCitiesOptionsQuery(baseOptions: Apollo.QueryHookOptions<GetCitiesOptionsQuery, GetCitiesOptionsQueryVariables> & ({ variables: GetCitiesOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCitiesOptionsQuery, GetCitiesOptionsQueryVariables>(GetCitiesOptionsDocument, options);
      }
export function useGetCitiesOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCitiesOptionsQuery, GetCitiesOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCitiesOptionsQuery, GetCitiesOptionsQueryVariables>(GetCitiesOptionsDocument, options);
        }
// @ts-ignore
export function useGetCitiesOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCitiesOptionsQuery, GetCitiesOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCitiesOptionsQuery, GetCitiesOptionsQueryVariables>;
export function useGetCitiesOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCitiesOptionsQuery, GetCitiesOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCitiesOptionsQuery | undefined, GetCitiesOptionsQueryVariables>;
export function useGetCitiesOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCitiesOptionsQuery, GetCitiesOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCitiesOptionsQuery, GetCitiesOptionsQueryVariables>(GetCitiesOptionsDocument, options);
        }
export type GetCitiesOptionsQueryHookResult = ReturnType<typeof useGetCitiesOptionsQuery>;
export type GetCitiesOptionsLazyQueryHookResult = ReturnType<typeof useGetCitiesOptionsLazyQuery>;
export type GetCitiesOptionsSuspenseQueryHookResult = ReturnType<typeof useGetCitiesOptionsSuspenseQuery>;
export type GetCitiesOptionsQueryResult = Apollo.QueryResult<GetCitiesOptionsQuery, GetCitiesOptionsQueryVariables>;
export const CreateLocationDocument = gql`
    mutation CreateLocation($locationDto: LocationDTO!) {
  createLocation(LocationDTO: $locationDto) {
    id
  }
}
    `;
export type CreateLocationMutationFn = Apollo.MutationFunction<CreateLocationMutation, CreateLocationMutationVariables>;

/**
 * __useCreateLocationMutation__
 *
 * To run a mutation, you first call `useCreateLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLocationMutation, { data, loading, error }] = useCreateLocationMutation({
 *   variables: {
 *      locationDto: // value for 'locationDto'
 *   },
 * });
 */
export function useCreateLocationMutation(baseOptions?: Apollo.MutationHookOptions<CreateLocationMutation, CreateLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLocationMutation, CreateLocationMutationVariables>(CreateLocationDocument, options);
      }
export type CreateLocationMutationHookResult = ReturnType<typeof useCreateLocationMutation>;
export type CreateLocationMutationResult = Apollo.MutationResult<CreateLocationMutation>;
export type CreateLocationMutationOptions = Apollo.BaseMutationOptions<CreateLocationMutation, CreateLocationMutationVariables>;
export const UpdateLocationDocument = gql`
    mutation UpdateLocation($locationDto: LocationDTO!, $updateLocationId: String!) {
  updateLocation(LocationDTO: $locationDto, id: $updateLocationId) {
    id
  }
}
    `;
export type UpdateLocationMutationFn = Apollo.MutationFunction<UpdateLocationMutation, UpdateLocationMutationVariables>;

/**
 * __useUpdateLocationMutation__
 *
 * To run a mutation, you first call `useUpdateLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocationMutation, { data, loading, error }] = useUpdateLocationMutation({
 *   variables: {
 *      locationDto: // value for 'locationDto'
 *      updateLocationId: // value for 'updateLocationId'
 *   },
 * });
 */
export function useUpdateLocationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLocationMutation, UpdateLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLocationMutation, UpdateLocationMutationVariables>(UpdateLocationDocument, options);
      }
export type UpdateLocationMutationHookResult = ReturnType<typeof useUpdateLocationMutation>;
export type UpdateLocationMutationResult = Apollo.MutationResult<UpdateLocationMutation>;
export type UpdateLocationMutationOptions = Apollo.BaseMutationOptions<UpdateLocationMutation, UpdateLocationMutationVariables>;
export const GetLostSalesDocument = gql`
    query GetLostSales($filter: [FilterGroup!], $limit: Int!, $page: Int!, $locationId: String, $sort: [SortCondition!]) {
  getLostSales(
    filter: $filter
    limit: $limit
    page: $page
    locationId: $locationId
    sort: $sort
  ) {
    meta {
      limit
      page
      total
      totalCount
    }
    data {
      createdAt
      createdBy
      currentInventory
      id
      price
      productName
      quantity
      reason
      secondaryId
      status
      type
      updatedAt
      value
    }
  }
}
    `;

/**
 * __useGetLostSalesQuery__
 *
 * To run a query within a React component, call `useGetLostSalesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLostSalesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLostSalesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      locationId: // value for 'locationId'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetLostSalesQuery(baseOptions: Apollo.QueryHookOptions<GetLostSalesQuery, GetLostSalesQueryVariables> & ({ variables: GetLostSalesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLostSalesQuery, GetLostSalesQueryVariables>(GetLostSalesDocument, options);
      }
export function useGetLostSalesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLostSalesQuery, GetLostSalesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLostSalesQuery, GetLostSalesQueryVariables>(GetLostSalesDocument, options);
        }
// @ts-ignore
export function useGetLostSalesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLostSalesQuery, GetLostSalesQueryVariables>): Apollo.UseSuspenseQueryResult<GetLostSalesQuery, GetLostSalesQueryVariables>;
export function useGetLostSalesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLostSalesQuery, GetLostSalesQueryVariables>): Apollo.UseSuspenseQueryResult<GetLostSalesQuery | undefined, GetLostSalesQueryVariables>;
export function useGetLostSalesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLostSalesQuery, GetLostSalesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLostSalesQuery, GetLostSalesQueryVariables>(GetLostSalesDocument, options);
        }
export type GetLostSalesQueryHookResult = ReturnType<typeof useGetLostSalesQuery>;
export type GetLostSalesLazyQueryHookResult = ReturnType<typeof useGetLostSalesLazyQuery>;
export type GetLostSalesSuspenseQueryHookResult = ReturnType<typeof useGetLostSalesSuspenseQuery>;
export type GetLostSalesQueryResult = Apollo.QueryResult<GetLostSalesQuery, GetLostSalesQueryVariables>;
export const GetLostSaleDocument = gql`
    query GetLostSale($getLostSaleId: String!) {
  getLostSale(id: $getLostSaleId) {
    createdAt
    createdBy
    currentInventory
    id
    price
    productId
    productName
    quantity
    reason
    secondaryId
    status
    type
    updatedAt
    value
    product {
      id
      secondaryId
      name
    }
  }
}
    `;

/**
 * __useGetLostSaleQuery__
 *
 * To run a query within a React component, call `useGetLostSaleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLostSaleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLostSaleQuery({
 *   variables: {
 *      getLostSaleId: // value for 'getLostSaleId'
 *   },
 * });
 */
export function useGetLostSaleQuery(baseOptions: Apollo.QueryHookOptions<GetLostSaleQuery, GetLostSaleQueryVariables> & ({ variables: GetLostSaleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLostSaleQuery, GetLostSaleQueryVariables>(GetLostSaleDocument, options);
      }
export function useGetLostSaleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLostSaleQuery, GetLostSaleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLostSaleQuery, GetLostSaleQueryVariables>(GetLostSaleDocument, options);
        }
// @ts-ignore
export function useGetLostSaleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLostSaleQuery, GetLostSaleQueryVariables>): Apollo.UseSuspenseQueryResult<GetLostSaleQuery, GetLostSaleQueryVariables>;
export function useGetLostSaleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLostSaleQuery, GetLostSaleQueryVariables>): Apollo.UseSuspenseQueryResult<GetLostSaleQuery | undefined, GetLostSaleQueryVariables>;
export function useGetLostSaleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLostSaleQuery, GetLostSaleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLostSaleQuery, GetLostSaleQueryVariables>(GetLostSaleDocument, options);
        }
export type GetLostSaleQueryHookResult = ReturnType<typeof useGetLostSaleQuery>;
export type GetLostSaleLazyQueryHookResult = ReturnType<typeof useGetLostSaleLazyQuery>;
export type GetLostSaleSuspenseQueryHookResult = ReturnType<typeof useGetLostSaleSuspenseQuery>;
export type GetLostSaleQueryResult = Apollo.QueryResult<GetLostSaleQuery, GetLostSaleQueryVariables>;
export const CreateLostSaleDocument = gql`
    mutation CreateLostSale($createLostSaleDto: CreateLostSaleDto!) {
  createLostSale(CreateLostSaleDto: $createLostSaleDto) {
    id
  }
}
    `;
export type CreateLostSaleMutationFn = Apollo.MutationFunction<CreateLostSaleMutation, CreateLostSaleMutationVariables>;

/**
 * __useCreateLostSaleMutation__
 *
 * To run a mutation, you first call `useCreateLostSaleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLostSaleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLostSaleMutation, { data, loading, error }] = useCreateLostSaleMutation({
 *   variables: {
 *      createLostSaleDto: // value for 'createLostSaleDto'
 *   },
 * });
 */
export function useCreateLostSaleMutation(baseOptions?: Apollo.MutationHookOptions<CreateLostSaleMutation, CreateLostSaleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLostSaleMutation, CreateLostSaleMutationVariables>(CreateLostSaleDocument, options);
      }
export type CreateLostSaleMutationHookResult = ReturnType<typeof useCreateLostSaleMutation>;
export type CreateLostSaleMutationResult = Apollo.MutationResult<CreateLostSaleMutation>;
export type CreateLostSaleMutationOptions = Apollo.BaseMutationOptions<CreateLostSaleMutation, CreateLostSaleMutationVariables>;
export const CreateManufacturerDocument = gql`
    mutation CreateManufacturer($createManufacturerDto: CreateManufacturerDTO!) {
  createManufacturer(CreateManufacturerDTO: $createManufacturerDto) {
    description
    id
    lastReason
    lineOfBusiness
    name
    status
  }
}
    `;
export type CreateManufacturerMutationFn = Apollo.MutationFunction<CreateManufacturerMutation, CreateManufacturerMutationVariables>;

/**
 * __useCreateManufacturerMutation__
 *
 * To run a mutation, you first call `useCreateManufacturerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateManufacturerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createManufacturerMutation, { data, loading, error }] = useCreateManufacturerMutation({
 *   variables: {
 *      createManufacturerDto: // value for 'createManufacturerDto'
 *   },
 * });
 */
export function useCreateManufacturerMutation(baseOptions?: Apollo.MutationHookOptions<CreateManufacturerMutation, CreateManufacturerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateManufacturerMutation, CreateManufacturerMutationVariables>(CreateManufacturerDocument, options);
      }
export type CreateManufacturerMutationHookResult = ReturnType<typeof useCreateManufacturerMutation>;
export type CreateManufacturerMutationResult = Apollo.MutationResult<CreateManufacturerMutation>;
export type CreateManufacturerMutationOptions = Apollo.BaseMutationOptions<CreateManufacturerMutation, CreateManufacturerMutationVariables>;
export const UpdateManufacturerDocument = gql`
    mutation UpdateManufacturer($updateManufacturerDto: UpdateManufacturerDTO!) {
  updateManufacturer(UpdateManufacturerDTO: $updateManufacturerDto) {
    description
    id
    lastReason
    lineOfBusiness
    name
    status
  }
}
    `;
export type UpdateManufacturerMutationFn = Apollo.MutationFunction<UpdateManufacturerMutation, UpdateManufacturerMutationVariables>;

/**
 * __useUpdateManufacturerMutation__
 *
 * To run a mutation, you first call `useUpdateManufacturerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateManufacturerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateManufacturerMutation, { data, loading, error }] = useUpdateManufacturerMutation({
 *   variables: {
 *      updateManufacturerDto: // value for 'updateManufacturerDto'
 *   },
 * });
 */
export function useUpdateManufacturerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateManufacturerMutation, UpdateManufacturerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateManufacturerMutation, UpdateManufacturerMutationVariables>(UpdateManufacturerDocument, options);
      }
export type UpdateManufacturerMutationHookResult = ReturnType<typeof useUpdateManufacturerMutation>;
export type UpdateManufacturerMutationResult = Apollo.MutationResult<UpdateManufacturerMutation>;
export type UpdateManufacturerMutationOptions = Apollo.BaseMutationOptions<UpdateManufacturerMutation, UpdateManufacturerMutationVariables>;
export const GetManufacturerDocument = gql`
    query GetManufacturer($getManufacturerId: String!) {
  getManufacturer(id: $getManufacturerId) {
    description
    id
    lastReason
    lineOfBusiness
    name
    status
  }
}
    `;

/**
 * __useGetManufacturerQuery__
 *
 * To run a query within a React component, call `useGetManufacturerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManufacturerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManufacturerQuery({
 *   variables: {
 *      getManufacturerId: // value for 'getManufacturerId'
 *   },
 * });
 */
export function useGetManufacturerQuery(baseOptions: Apollo.QueryHookOptions<GetManufacturerQuery, GetManufacturerQueryVariables> & ({ variables: GetManufacturerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetManufacturerQuery, GetManufacturerQueryVariables>(GetManufacturerDocument, options);
      }
export function useGetManufacturerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetManufacturerQuery, GetManufacturerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetManufacturerQuery, GetManufacturerQueryVariables>(GetManufacturerDocument, options);
        }
// @ts-ignore
export function useGetManufacturerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetManufacturerQuery, GetManufacturerQueryVariables>): Apollo.UseSuspenseQueryResult<GetManufacturerQuery, GetManufacturerQueryVariables>;
export function useGetManufacturerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetManufacturerQuery, GetManufacturerQueryVariables>): Apollo.UseSuspenseQueryResult<GetManufacturerQuery | undefined, GetManufacturerQueryVariables>;
export function useGetManufacturerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetManufacturerQuery, GetManufacturerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetManufacturerQuery, GetManufacturerQueryVariables>(GetManufacturerDocument, options);
        }
export type GetManufacturerQueryHookResult = ReturnType<typeof useGetManufacturerQuery>;
export type GetManufacturerLazyQueryHookResult = ReturnType<typeof useGetManufacturerLazyQuery>;
export type GetManufacturerSuspenseQueryHookResult = ReturnType<typeof useGetManufacturerSuspenseQuery>;
export type GetManufacturerQueryResult = Apollo.QueryResult<GetManufacturerQuery, GetManufacturerQueryVariables>;
export const GetManufacturersDocument = gql`
    query GetManufacturers($filter: [FilterGroup!], $limit: Int!, $page: Int!, $sort: [SortCondition!]) {
  getManufacturers(filter: $filter, limit: $limit, page: $page, sort: $sort) {
    data {
      id
      secondaryId
      description
      lastReason
      lineOfBusiness
      name
      status
    }
    meta {
      limit
      page
      totalCount
    }
  }
}
    `;

/**
 * __useGetManufacturersQuery__
 *
 * To run a query within a React component, call `useGetManufacturersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManufacturersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManufacturersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetManufacturersQuery(baseOptions: Apollo.QueryHookOptions<GetManufacturersQuery, GetManufacturersQueryVariables> & ({ variables: GetManufacturersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetManufacturersQuery, GetManufacturersQueryVariables>(GetManufacturersDocument, options);
      }
export function useGetManufacturersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetManufacturersQuery, GetManufacturersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetManufacturersQuery, GetManufacturersQueryVariables>(GetManufacturersDocument, options);
        }
// @ts-ignore
export function useGetManufacturersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetManufacturersQuery, GetManufacturersQueryVariables>): Apollo.UseSuspenseQueryResult<GetManufacturersQuery, GetManufacturersQueryVariables>;
export function useGetManufacturersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetManufacturersQuery, GetManufacturersQueryVariables>): Apollo.UseSuspenseQueryResult<GetManufacturersQuery | undefined, GetManufacturersQueryVariables>;
export function useGetManufacturersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetManufacturersQuery, GetManufacturersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetManufacturersQuery, GetManufacturersQueryVariables>(GetManufacturersDocument, options);
        }
export type GetManufacturersQueryHookResult = ReturnType<typeof useGetManufacturersQuery>;
export type GetManufacturersLazyQueryHookResult = ReturnType<typeof useGetManufacturersLazyQuery>;
export type GetManufacturersSuspenseQueryHookResult = ReturnType<typeof useGetManufacturersSuspenseQuery>;
export type GetManufacturersQueryResult = Apollo.QueryResult<GetManufacturersQuery, GetManufacturersQueryVariables>;
export const GetManufacturersForOptionsDocument = gql`
    query GetManufacturersForOptions($filter: [FilterGroup!], $limit: Int!, $page: Int!, $sort: [SortCondition!]) {
  getManufacturers(filter: $filter, limit: $limit, page: $page, sort: $sort) {
    data {
      id
      name
    }
    meta {
      limit
      page
      totalCount
    }
  }
}
    `;

/**
 * __useGetManufacturersForOptionsQuery__
 *
 * To run a query within a React component, call `useGetManufacturersForOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManufacturersForOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManufacturersForOptionsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetManufacturersForOptionsQuery(baseOptions: Apollo.QueryHookOptions<GetManufacturersForOptionsQuery, GetManufacturersForOptionsQueryVariables> & ({ variables: GetManufacturersForOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetManufacturersForOptionsQuery, GetManufacturersForOptionsQueryVariables>(GetManufacturersForOptionsDocument, options);
      }
export function useGetManufacturersForOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetManufacturersForOptionsQuery, GetManufacturersForOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetManufacturersForOptionsQuery, GetManufacturersForOptionsQueryVariables>(GetManufacturersForOptionsDocument, options);
        }
// @ts-ignore
export function useGetManufacturersForOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetManufacturersForOptionsQuery, GetManufacturersForOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetManufacturersForOptionsQuery, GetManufacturersForOptionsQueryVariables>;
export function useGetManufacturersForOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetManufacturersForOptionsQuery, GetManufacturersForOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetManufacturersForOptionsQuery | undefined, GetManufacturersForOptionsQueryVariables>;
export function useGetManufacturersForOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetManufacturersForOptionsQuery, GetManufacturersForOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetManufacturersForOptionsQuery, GetManufacturersForOptionsQueryVariables>(GetManufacturersForOptionsDocument, options);
        }
export type GetManufacturersForOptionsQueryHookResult = ReturnType<typeof useGetManufacturersForOptionsQuery>;
export type GetManufacturersForOptionsLazyQueryHookResult = ReturnType<typeof useGetManufacturersForOptionsLazyQuery>;
export type GetManufacturersForOptionsSuspenseQueryHookResult = ReturnType<typeof useGetManufacturersForOptionsSuspenseQuery>;
export type GetManufacturersForOptionsQueryResult = Apollo.QueryResult<GetManufacturersForOptionsQuery, GetManufacturersForOptionsQueryVariables>;
export const UploadMediaImageDocument = gql`
    mutation UploadMediaImage($input: UploadMediaImageInput!) {
  uploadMediaImage(input: $input) {
    id
    url
    filename
    mimeType
    width
    height
  }
}
    `;
export type UploadMediaImageMutationFn = Apollo.MutationFunction<UploadMediaImageMutation, UploadMediaImageMutationVariables>;

/**
 * __useUploadMediaImageMutation__
 *
 * To run a mutation, you first call `useUploadMediaImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadMediaImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadMediaImageMutation, { data, loading, error }] = useUploadMediaImageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadMediaImageMutation(baseOptions?: Apollo.MutationHookOptions<UploadMediaImageMutation, UploadMediaImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadMediaImageMutation, UploadMediaImageMutationVariables>(UploadMediaImageDocument, options);
      }
export type UploadMediaImageMutationHookResult = ReturnType<typeof useUploadMediaImageMutation>;
export type UploadMediaImageMutationResult = Apollo.MutationResult<UploadMediaImageMutation>;
export type UploadMediaImageMutationOptions = Apollo.BaseMutationOptions<UploadMediaImageMutation, UploadMediaImageMutationVariables>;
export const GetMediaAssetsDocument = gql`
    query GetMediaAssets($page: Int!, $limit: Int!, $sort: [SortCondition!], $filter: [FilterGroup!]) {
  getMediaAssets(page: $page, limit: $limit, sort: $sort, filter: $filter) {
    data {
      id
      url
      filename
      mimeType
      width
      height
      createdAt
    }
    meta {
      page
      limit
      totalCount
    }
  }
}
    `;

/**
 * __useGetMediaAssetsQuery__
 *
 * To run a query within a React component, call `useGetMediaAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMediaAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMediaAssetsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetMediaAssetsQuery(baseOptions: Apollo.QueryHookOptions<GetMediaAssetsQuery, GetMediaAssetsQueryVariables> & ({ variables: GetMediaAssetsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMediaAssetsQuery, GetMediaAssetsQueryVariables>(GetMediaAssetsDocument, options);
      }
export function useGetMediaAssetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMediaAssetsQuery, GetMediaAssetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMediaAssetsQuery, GetMediaAssetsQueryVariables>(GetMediaAssetsDocument, options);
        }
// @ts-ignore
export function useGetMediaAssetsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMediaAssetsQuery, GetMediaAssetsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMediaAssetsQuery, GetMediaAssetsQueryVariables>;
export function useGetMediaAssetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMediaAssetsQuery, GetMediaAssetsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMediaAssetsQuery | undefined, GetMediaAssetsQueryVariables>;
export function useGetMediaAssetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMediaAssetsQuery, GetMediaAssetsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMediaAssetsQuery, GetMediaAssetsQueryVariables>(GetMediaAssetsDocument, options);
        }
export type GetMediaAssetsQueryHookResult = ReturnType<typeof useGetMediaAssetsQuery>;
export type GetMediaAssetsLazyQueryHookResult = ReturnType<typeof useGetMediaAssetsLazyQuery>;
export type GetMediaAssetsSuspenseQueryHookResult = ReturnType<typeof useGetMediaAssetsSuspenseQuery>;
export type GetMediaAssetsQueryResult = Apollo.QueryResult<GetMediaAssetsQuery, GetMediaAssetsQueryVariables>;
export const DeleteMediaAssetDocument = gql`
    mutation DeleteMediaAsset($id: String!) {
  deleteMediaAsset(id: $id)
}
    `;
export type DeleteMediaAssetMutationFn = Apollo.MutationFunction<DeleteMediaAssetMutation, DeleteMediaAssetMutationVariables>;

/**
 * __useDeleteMediaAssetMutation__
 *
 * To run a mutation, you first call `useDeleteMediaAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMediaAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMediaAssetMutation, { data, loading, error }] = useDeleteMediaAssetMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMediaAssetMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMediaAssetMutation, DeleteMediaAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMediaAssetMutation, DeleteMediaAssetMutationVariables>(DeleteMediaAssetDocument, options);
      }
export type DeleteMediaAssetMutationHookResult = ReturnType<typeof useDeleteMediaAssetMutation>;
export type DeleteMediaAssetMutationResult = Apollo.MutationResult<DeleteMediaAssetMutation>;
export type DeleteMediaAssetMutationOptions = Apollo.BaseMutationOptions<DeleteMediaAssetMutation, DeleteMediaAssetMutationVariables>;
export const CancelOrderDocument = gql`
    mutation CancelOrder($input: CancelOrderInput!) {
  cancelOrder(input: $input) {
    orderCancelled
    fbrCreditNoteRequired
    cancellation {
      ...CancellationDetails
    }
  }
}
    ${CancellationDetailsFragmentDoc}`;
export type CancelOrderMutationFn = Apollo.MutationFunction<CancelOrderMutation, CancelOrderMutationVariables>;

/**
 * __useCancelOrderMutation__
 *
 * To run a mutation, you first call `useCancelOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelOrderMutation, { data, loading, error }] = useCancelOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelOrderMutation(baseOptions?: Apollo.MutationHookOptions<CancelOrderMutation, CancelOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelOrderMutation, CancelOrderMutationVariables>(CancelOrderDocument, options);
      }
export type CancelOrderMutationHookResult = ReturnType<typeof useCancelOrderMutation>;
export type CancelOrderMutationResult = Apollo.MutationResult<CancelOrderMutation>;
export type CancelOrderMutationOptions = Apollo.BaseMutationOptions<CancelOrderMutation, CancelOrderMutationVariables>;
export const UpdateCancellationFbrInvoiceIdDocument = gql`
    mutation UpdateCancellationFbrInvoiceId($cancellationId: ID!, $fbrInvoiceId: String!) {
  updateCancellationFbrInvoiceId(
    cancellationId: $cancellationId
    fbrInvoiceId: $fbrInvoiceId
  )
}
    `;
export type UpdateCancellationFbrInvoiceIdMutationFn = Apollo.MutationFunction<UpdateCancellationFbrInvoiceIdMutation, UpdateCancellationFbrInvoiceIdMutationVariables>;

/**
 * __useUpdateCancellationFbrInvoiceIdMutation__
 *
 * To run a mutation, you first call `useUpdateCancellationFbrInvoiceIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCancellationFbrInvoiceIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCancellationFbrInvoiceIdMutation, { data, loading, error }] = useUpdateCancellationFbrInvoiceIdMutation({
 *   variables: {
 *      cancellationId: // value for 'cancellationId'
 *      fbrInvoiceId: // value for 'fbrInvoiceId'
 *   },
 * });
 */
export function useUpdateCancellationFbrInvoiceIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCancellationFbrInvoiceIdMutation, UpdateCancellationFbrInvoiceIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCancellationFbrInvoiceIdMutation, UpdateCancellationFbrInvoiceIdMutationVariables>(UpdateCancellationFbrInvoiceIdDocument, options);
      }
export type UpdateCancellationFbrInvoiceIdMutationHookResult = ReturnType<typeof useUpdateCancellationFbrInvoiceIdMutation>;
export type UpdateCancellationFbrInvoiceIdMutationResult = Apollo.MutationResult<UpdateCancellationFbrInvoiceIdMutation>;
export type UpdateCancellationFbrInvoiceIdMutationOptions = Apollo.BaseMutationOptions<UpdateCancellationFbrInvoiceIdMutation, UpdateCancellationFbrInvoiceIdMutationVariables>;
export const OrderCancellationsDocument = gql`
    query OrderCancellations($orderId: ID!) {
  orderCancellations(orderId: $orderId) {
    ...CancellationDetails
  }
}
    ${CancellationDetailsFragmentDoc}`;

/**
 * __useOrderCancellationsQuery__
 *
 * To run a query within a React component, call `useOrderCancellationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderCancellationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderCancellationsQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useOrderCancellationsQuery(baseOptions: Apollo.QueryHookOptions<OrderCancellationsQuery, OrderCancellationsQueryVariables> & ({ variables: OrderCancellationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderCancellationsQuery, OrderCancellationsQueryVariables>(OrderCancellationsDocument, options);
      }
export function useOrderCancellationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderCancellationsQuery, OrderCancellationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderCancellationsQuery, OrderCancellationsQueryVariables>(OrderCancellationsDocument, options);
        }
// @ts-ignore
export function useOrderCancellationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrderCancellationsQuery, OrderCancellationsQueryVariables>): Apollo.UseSuspenseQueryResult<OrderCancellationsQuery, OrderCancellationsQueryVariables>;
export function useOrderCancellationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrderCancellationsQuery, OrderCancellationsQueryVariables>): Apollo.UseSuspenseQueryResult<OrderCancellationsQuery | undefined, OrderCancellationsQueryVariables>;
export function useOrderCancellationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrderCancellationsQuery, OrderCancellationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrderCancellationsQuery, OrderCancellationsQueryVariables>(OrderCancellationsDocument, options);
        }
export type OrderCancellationsQueryHookResult = ReturnType<typeof useOrderCancellationsQuery>;
export type OrderCancellationsLazyQueryHookResult = ReturnType<typeof useOrderCancellationsLazyQuery>;
export type OrderCancellationsSuspenseQueryHookResult = ReturnType<typeof useOrderCancellationsSuspenseQuery>;
export type OrderCancellationsQueryResult = Apollo.QueryResult<OrderCancellationsQuery, OrderCancellationsQueryVariables>;
export const FulfillmentOrderEventsDocument = gql`
    query FulfillmentOrderEvents($fulfillmentOrderId: ID!) {
  fulfillmentOrderEvents(fulfillmentOrderId: $fulfillmentOrderId) {
    id
    type
    at
    createdAt
    userId
    reason
    data
  }
}
    `;

/**
 * __useFulfillmentOrderEventsQuery__
 *
 * To run a query within a React component, call `useFulfillmentOrderEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFulfillmentOrderEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFulfillmentOrderEventsQuery({
 *   variables: {
 *      fulfillmentOrderId: // value for 'fulfillmentOrderId'
 *   },
 * });
 */
export function useFulfillmentOrderEventsQuery(baseOptions: Apollo.QueryHookOptions<FulfillmentOrderEventsQuery, FulfillmentOrderEventsQueryVariables> & ({ variables: FulfillmentOrderEventsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FulfillmentOrderEventsQuery, FulfillmentOrderEventsQueryVariables>(FulfillmentOrderEventsDocument, options);
      }
export function useFulfillmentOrderEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FulfillmentOrderEventsQuery, FulfillmentOrderEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FulfillmentOrderEventsQuery, FulfillmentOrderEventsQueryVariables>(FulfillmentOrderEventsDocument, options);
        }
// @ts-ignore
export function useFulfillmentOrderEventsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FulfillmentOrderEventsQuery, FulfillmentOrderEventsQueryVariables>): Apollo.UseSuspenseQueryResult<FulfillmentOrderEventsQuery, FulfillmentOrderEventsQueryVariables>;
export function useFulfillmentOrderEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FulfillmentOrderEventsQuery, FulfillmentOrderEventsQueryVariables>): Apollo.UseSuspenseQueryResult<FulfillmentOrderEventsQuery | undefined, FulfillmentOrderEventsQueryVariables>;
export function useFulfillmentOrderEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FulfillmentOrderEventsQuery, FulfillmentOrderEventsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FulfillmentOrderEventsQuery, FulfillmentOrderEventsQueryVariables>(FulfillmentOrderEventsDocument, options);
        }
export type FulfillmentOrderEventsQueryHookResult = ReturnType<typeof useFulfillmentOrderEventsQuery>;
export type FulfillmentOrderEventsLazyQueryHookResult = ReturnType<typeof useFulfillmentOrderEventsLazyQuery>;
export type FulfillmentOrderEventsSuspenseQueryHookResult = ReturnType<typeof useFulfillmentOrderEventsSuspenseQuery>;
export type FulfillmentOrderEventsQueryResult = Apollo.QueryResult<FulfillmentOrderEventsQuery, FulfillmentOrderEventsQueryVariables>;
export const VoidShipmentBookingDocument = gql`
    mutation VoidShipmentBooking($fulfillmentOrderId: ID!, $reason: String!) {
  voidShipmentBooking(fulfillmentOrderId: $fulfillmentOrderId, reason: $reason) {
    id
    status
  }
}
    `;
export type VoidShipmentBookingMutationFn = Apollo.MutationFunction<VoidShipmentBookingMutation, VoidShipmentBookingMutationVariables>;

/**
 * __useVoidShipmentBookingMutation__
 *
 * To run a mutation, you first call `useVoidShipmentBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVoidShipmentBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [voidShipmentBookingMutation, { data, loading, error }] = useVoidShipmentBookingMutation({
 *   variables: {
 *      fulfillmentOrderId: // value for 'fulfillmentOrderId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useVoidShipmentBookingMutation(baseOptions?: Apollo.MutationHookOptions<VoidShipmentBookingMutation, VoidShipmentBookingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VoidShipmentBookingMutation, VoidShipmentBookingMutationVariables>(VoidShipmentBookingDocument, options);
      }
export type VoidShipmentBookingMutationHookResult = ReturnType<typeof useVoidShipmentBookingMutation>;
export type VoidShipmentBookingMutationResult = Apollo.MutationResult<VoidShipmentBookingMutation>;
export type VoidShipmentBookingMutationOptions = Apollo.BaseMutationOptions<VoidShipmentBookingMutation, VoidShipmentBookingMutationVariables>;
export const UnpackFulfillmentOrderDocument = gql`
    mutation UnpackFulfillmentOrder($fulfillmentOrderId: ID!, $reason: String!) {
  unpackFulfillmentOrder(fulfillmentOrderId: $fulfillmentOrderId, reason: $reason) {
    id
    status
  }
}
    `;
export type UnpackFulfillmentOrderMutationFn = Apollo.MutationFunction<UnpackFulfillmentOrderMutation, UnpackFulfillmentOrderMutationVariables>;

/**
 * __useUnpackFulfillmentOrderMutation__
 *
 * To run a mutation, you first call `useUnpackFulfillmentOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnpackFulfillmentOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unpackFulfillmentOrderMutation, { data, loading, error }] = useUnpackFulfillmentOrderMutation({
 *   variables: {
 *      fulfillmentOrderId: // value for 'fulfillmentOrderId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useUnpackFulfillmentOrderMutation(baseOptions?: Apollo.MutationHookOptions<UnpackFulfillmentOrderMutation, UnpackFulfillmentOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnpackFulfillmentOrderMutation, UnpackFulfillmentOrderMutationVariables>(UnpackFulfillmentOrderDocument, options);
      }
export type UnpackFulfillmentOrderMutationHookResult = ReturnType<typeof useUnpackFulfillmentOrderMutation>;
export type UnpackFulfillmentOrderMutationResult = Apollo.MutationResult<UnpackFulfillmentOrderMutation>;
export type UnpackFulfillmentOrderMutationOptions = Apollo.BaseMutationOptions<UnpackFulfillmentOrderMutation, UnpackFulfillmentOrderMutationVariables>;
export const SwapReservedLotDocument = gql`
    mutation SwapReservedLot($input: SwapReservedLotInput!) {
  swapReservedLot(input: $input)
}
    `;
export type SwapReservedLotMutationFn = Apollo.MutationFunction<SwapReservedLotMutation, SwapReservedLotMutationVariables>;

/**
 * __useSwapReservedLotMutation__
 *
 * To run a mutation, you first call `useSwapReservedLotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwapReservedLotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [swapReservedLotMutation, { data, loading, error }] = useSwapReservedLotMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSwapReservedLotMutation(baseOptions?: Apollo.MutationHookOptions<SwapReservedLotMutation, SwapReservedLotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SwapReservedLotMutation, SwapReservedLotMutationVariables>(SwapReservedLotDocument, options);
      }
export type SwapReservedLotMutationHookResult = ReturnType<typeof useSwapReservedLotMutation>;
export type SwapReservedLotMutationResult = Apollo.MutationResult<SwapReservedLotMutation>;
export type SwapReservedLotMutationOptions = Apollo.BaseMutationOptions<SwapReservedLotMutation, SwapReservedLotMutationVariables>;
export const CompleteRegisterFulfillmentDocument = gql`
    mutation CompleteRegisterFulfillment($input: CompleteRegisterFulfillmentInput!) {
  completeRegisterFulfillment(input: $input) {
    id
    status
  }
}
    `;
export type CompleteRegisterFulfillmentMutationFn = Apollo.MutationFunction<CompleteRegisterFulfillmentMutation, CompleteRegisterFulfillmentMutationVariables>;

/**
 * __useCompleteRegisterFulfillmentMutation__
 *
 * To run a mutation, you first call `useCompleteRegisterFulfillmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteRegisterFulfillmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeRegisterFulfillmentMutation, { data, loading, error }] = useCompleteRegisterFulfillmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompleteRegisterFulfillmentMutation(baseOptions?: Apollo.MutationHookOptions<CompleteRegisterFulfillmentMutation, CompleteRegisterFulfillmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteRegisterFulfillmentMutation, CompleteRegisterFulfillmentMutationVariables>(CompleteRegisterFulfillmentDocument, options);
      }
export type CompleteRegisterFulfillmentMutationHookResult = ReturnType<typeof useCompleteRegisterFulfillmentMutation>;
export type CompleteRegisterFulfillmentMutationResult = Apollo.MutationResult<CompleteRegisterFulfillmentMutation>;
export type CompleteRegisterFulfillmentMutationOptions = Apollo.BaseMutationOptions<CompleteRegisterFulfillmentMutation, CompleteRegisterFulfillmentMutationVariables>;
export const MarkDeliveryFailedDocument = gql`
    mutation MarkDeliveryFailed($input: MarkDeliveryFailedInput!) {
  markDeliveryFailed(input: $input) {
    id
    status
  }
}
    `;
export type MarkDeliveryFailedMutationFn = Apollo.MutationFunction<MarkDeliveryFailedMutation, MarkDeliveryFailedMutationVariables>;

/**
 * __useMarkDeliveryFailedMutation__
 *
 * To run a mutation, you first call `useMarkDeliveryFailedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkDeliveryFailedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markDeliveryFailedMutation, { data, loading, error }] = useMarkDeliveryFailedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkDeliveryFailedMutation(baseOptions?: Apollo.MutationHookOptions<MarkDeliveryFailedMutation, MarkDeliveryFailedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkDeliveryFailedMutation, MarkDeliveryFailedMutationVariables>(MarkDeliveryFailedDocument, options);
      }
export type MarkDeliveryFailedMutationHookResult = ReturnType<typeof useMarkDeliveryFailedMutation>;
export type MarkDeliveryFailedMutationResult = Apollo.MutationResult<MarkDeliveryFailedMutation>;
export type MarkDeliveryFailedMutationOptions = Apollo.BaseMutationOptions<MarkDeliveryFailedMutation, MarkDeliveryFailedMutationVariables>;
export const ReceiveReturnedParcelDocument = gql`
    mutation ReceiveReturnedParcel($input: ReceiveReturnedParcelInput!) {
  receiveReturnedParcel(input: $input) {
    orderCancelled
    fbrCreditNoteRequired
    cancellation {
      ...CancellationDetails
    }
  }
}
    ${CancellationDetailsFragmentDoc}`;
export type ReceiveReturnedParcelMutationFn = Apollo.MutationFunction<ReceiveReturnedParcelMutation, ReceiveReturnedParcelMutationVariables>;

/**
 * __useReceiveReturnedParcelMutation__
 *
 * To run a mutation, you first call `useReceiveReturnedParcelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReceiveReturnedParcelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [receiveReturnedParcelMutation, { data, loading, error }] = useReceiveReturnedParcelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReceiveReturnedParcelMutation(baseOptions?: Apollo.MutationHookOptions<ReceiveReturnedParcelMutation, ReceiveReturnedParcelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReceiveReturnedParcelMutation, ReceiveReturnedParcelMutationVariables>(ReceiveReturnedParcelDocument, options);
      }
export type ReceiveReturnedParcelMutationHookResult = ReturnType<typeof useReceiveReturnedParcelMutation>;
export type ReceiveReturnedParcelMutationResult = Apollo.MutationResult<ReceiveReturnedParcelMutation>;
export type ReceiveReturnedParcelMutationOptions = Apollo.BaseMutationOptions<ReceiveReturnedParcelMutation, ReceiveReturnedParcelMutationVariables>;
export const OrderFulfillmentOrdersDocument = gql`
    query OrderFulfillmentOrders($orderId: ID!) {
  fulfillmentOrderGroup(orderId: $orderId) {
    id
    secondaryId
    fulfillmentId
    status
    source
    registerId
    locationId
    location {
      id
      name
    }
    shippingProvider
    consignmentNumber
    codAmount
    lotsLockedAt
    dispatchedAt
    deliveredAt
    createdAt
    lines {
      id
      orderLineItemId
      productId
      quantity
      fulfilledQuantity
      status
    }
  }
}
    `;

/**
 * __useOrderFulfillmentOrdersQuery__
 *
 * To run a query within a React component, call `useOrderFulfillmentOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderFulfillmentOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderFulfillmentOrdersQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useOrderFulfillmentOrdersQuery(baseOptions: Apollo.QueryHookOptions<OrderFulfillmentOrdersQuery, OrderFulfillmentOrdersQueryVariables> & ({ variables: OrderFulfillmentOrdersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderFulfillmentOrdersQuery, OrderFulfillmentOrdersQueryVariables>(OrderFulfillmentOrdersDocument, options);
      }
export function useOrderFulfillmentOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderFulfillmentOrdersQuery, OrderFulfillmentOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderFulfillmentOrdersQuery, OrderFulfillmentOrdersQueryVariables>(OrderFulfillmentOrdersDocument, options);
        }
// @ts-ignore
export function useOrderFulfillmentOrdersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrderFulfillmentOrdersQuery, OrderFulfillmentOrdersQueryVariables>): Apollo.UseSuspenseQueryResult<OrderFulfillmentOrdersQuery, OrderFulfillmentOrdersQueryVariables>;
export function useOrderFulfillmentOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrderFulfillmentOrdersQuery, OrderFulfillmentOrdersQueryVariables>): Apollo.UseSuspenseQueryResult<OrderFulfillmentOrdersQuery | undefined, OrderFulfillmentOrdersQueryVariables>;
export function useOrderFulfillmentOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrderFulfillmentOrdersQuery, OrderFulfillmentOrdersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrderFulfillmentOrdersQuery, OrderFulfillmentOrdersQueryVariables>(OrderFulfillmentOrdersDocument, options);
        }
export type OrderFulfillmentOrdersQueryHookResult = ReturnType<typeof useOrderFulfillmentOrdersQuery>;
export type OrderFulfillmentOrdersLazyQueryHookResult = ReturnType<typeof useOrderFulfillmentOrdersLazyQuery>;
export type OrderFulfillmentOrdersSuspenseQueryHookResult = ReturnType<typeof useOrderFulfillmentOrdersSuspenseQuery>;
export type OrderFulfillmentOrdersQueryResult = Apollo.QueryResult<OrderFulfillmentOrdersQuery, OrderFulfillmentOrdersQueryVariables>;
export const OpenRegisterSessionsDocument = gql`
    query OpenRegisterSessions($locationId: String!) {
  getLocationRegisterSessions(
    locationId: $locationId
    page: 1
    limit: 50
    filter: [{logicalOperator: AND, conditions: [{field: "status", operator: EQUAL, value: "OPENED"}]}]
  ) {
    data {
      id
      secondaryId
      openedByUserId
      register {
        name
      }
      openedBy {
        firstName
        lastName
      }
    }
  }
}
    `;

/**
 * __useOpenRegisterSessionsQuery__
 *
 * To run a query within a React component, call `useOpenRegisterSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpenRegisterSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpenRegisterSessionsQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useOpenRegisterSessionsQuery(baseOptions: Apollo.QueryHookOptions<OpenRegisterSessionsQuery, OpenRegisterSessionsQueryVariables> & ({ variables: OpenRegisterSessionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpenRegisterSessionsQuery, OpenRegisterSessionsQueryVariables>(OpenRegisterSessionsDocument, options);
      }
export function useOpenRegisterSessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpenRegisterSessionsQuery, OpenRegisterSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpenRegisterSessionsQuery, OpenRegisterSessionsQueryVariables>(OpenRegisterSessionsDocument, options);
        }
// @ts-ignore
export function useOpenRegisterSessionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OpenRegisterSessionsQuery, OpenRegisterSessionsQueryVariables>): Apollo.UseSuspenseQueryResult<OpenRegisterSessionsQuery, OpenRegisterSessionsQueryVariables>;
export function useOpenRegisterSessionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OpenRegisterSessionsQuery, OpenRegisterSessionsQueryVariables>): Apollo.UseSuspenseQueryResult<OpenRegisterSessionsQuery | undefined, OpenRegisterSessionsQueryVariables>;
export function useOpenRegisterSessionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OpenRegisterSessionsQuery, OpenRegisterSessionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OpenRegisterSessionsQuery, OpenRegisterSessionsQueryVariables>(OpenRegisterSessionsDocument, options);
        }
export type OpenRegisterSessionsQueryHookResult = ReturnType<typeof useOpenRegisterSessionsQuery>;
export type OpenRegisterSessionsLazyQueryHookResult = ReturnType<typeof useOpenRegisterSessionsLazyQuery>;
export type OpenRegisterSessionsSuspenseQueryHookResult = ReturnType<typeof useOpenRegisterSessionsSuspenseQuery>;
export type OpenRegisterSessionsQueryResult = Apollo.QueryResult<OpenRegisterSessionsQuery, OpenRegisterSessionsQueryVariables>;
export const ActiveFulfillmentHoldsDocument = gql`
    query ActiveFulfillmentHolds($entityId: ID!) {
  activeHolds(entityType: FULFILLMENT_ORDER, entityId: $entityId) {
    id
    reason
    comment
    heldAt
  }
}
    `;

/**
 * __useActiveFulfillmentHoldsQuery__
 *
 * To run a query within a React component, call `useActiveFulfillmentHoldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveFulfillmentHoldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveFulfillmentHoldsQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useActiveFulfillmentHoldsQuery(baseOptions: Apollo.QueryHookOptions<ActiveFulfillmentHoldsQuery, ActiveFulfillmentHoldsQueryVariables> & ({ variables: ActiveFulfillmentHoldsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActiveFulfillmentHoldsQuery, ActiveFulfillmentHoldsQueryVariables>(ActiveFulfillmentHoldsDocument, options);
      }
export function useActiveFulfillmentHoldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActiveFulfillmentHoldsQuery, ActiveFulfillmentHoldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActiveFulfillmentHoldsQuery, ActiveFulfillmentHoldsQueryVariables>(ActiveFulfillmentHoldsDocument, options);
        }
// @ts-ignore
export function useActiveFulfillmentHoldsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ActiveFulfillmentHoldsQuery, ActiveFulfillmentHoldsQueryVariables>): Apollo.UseSuspenseQueryResult<ActiveFulfillmentHoldsQuery, ActiveFulfillmentHoldsQueryVariables>;
export function useActiveFulfillmentHoldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActiveFulfillmentHoldsQuery, ActiveFulfillmentHoldsQueryVariables>): Apollo.UseSuspenseQueryResult<ActiveFulfillmentHoldsQuery | undefined, ActiveFulfillmentHoldsQueryVariables>;
export function useActiveFulfillmentHoldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActiveFulfillmentHoldsQuery, ActiveFulfillmentHoldsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActiveFulfillmentHoldsQuery, ActiveFulfillmentHoldsQueryVariables>(ActiveFulfillmentHoldsDocument, options);
        }
export type ActiveFulfillmentHoldsQueryHookResult = ReturnType<typeof useActiveFulfillmentHoldsQuery>;
export type ActiveFulfillmentHoldsLazyQueryHookResult = ReturnType<typeof useActiveFulfillmentHoldsLazyQuery>;
export type ActiveFulfillmentHoldsSuspenseQueryHookResult = ReturnType<typeof useActiveFulfillmentHoldsSuspenseQuery>;
export type ActiveFulfillmentHoldsQueryResult = Apollo.QueryResult<ActiveFulfillmentHoldsQuery, ActiveFulfillmentHoldsQueryVariables>;
export const PlaceFulfillmentHoldDocument = gql`
    mutation PlaceFulfillmentHold($entityId: ID!, $reason: HoldReason!, $comment: String) {
  placeHold(
    entityType: FULFILLMENT_ORDER
    entityId: $entityId
    reason: $reason
    comment: $comment
  ) {
    id
  }
}
    `;
export type PlaceFulfillmentHoldMutationFn = Apollo.MutationFunction<PlaceFulfillmentHoldMutation, PlaceFulfillmentHoldMutationVariables>;

/**
 * __usePlaceFulfillmentHoldMutation__
 *
 * To run a mutation, you first call `usePlaceFulfillmentHoldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlaceFulfillmentHoldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [placeFulfillmentHoldMutation, { data, loading, error }] = usePlaceFulfillmentHoldMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      reason: // value for 'reason'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function usePlaceFulfillmentHoldMutation(baseOptions?: Apollo.MutationHookOptions<PlaceFulfillmentHoldMutation, PlaceFulfillmentHoldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PlaceFulfillmentHoldMutation, PlaceFulfillmentHoldMutationVariables>(PlaceFulfillmentHoldDocument, options);
      }
export type PlaceFulfillmentHoldMutationHookResult = ReturnType<typeof usePlaceFulfillmentHoldMutation>;
export type PlaceFulfillmentHoldMutationResult = Apollo.MutationResult<PlaceFulfillmentHoldMutation>;
export type PlaceFulfillmentHoldMutationOptions = Apollo.BaseMutationOptions<PlaceFulfillmentHoldMutation, PlaceFulfillmentHoldMutationVariables>;
export const ReleaseFulfillmentHoldDocument = gql`
    mutation ReleaseFulfillmentHold($holdId: ID!) {
  releaseHold(holdId: $holdId) {
    id
  }
}
    `;
export type ReleaseFulfillmentHoldMutationFn = Apollo.MutationFunction<ReleaseFulfillmentHoldMutation, ReleaseFulfillmentHoldMutationVariables>;

/**
 * __useReleaseFulfillmentHoldMutation__
 *
 * To run a mutation, you first call `useReleaseFulfillmentHoldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReleaseFulfillmentHoldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [releaseFulfillmentHoldMutation, { data, loading, error }] = useReleaseFulfillmentHoldMutation({
 *   variables: {
 *      holdId: // value for 'holdId'
 *   },
 * });
 */
export function useReleaseFulfillmentHoldMutation(baseOptions?: Apollo.MutationHookOptions<ReleaseFulfillmentHoldMutation, ReleaseFulfillmentHoldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReleaseFulfillmentHoldMutation, ReleaseFulfillmentHoldMutationVariables>(ReleaseFulfillmentHoldDocument, options);
      }
export type ReleaseFulfillmentHoldMutationHookResult = ReturnType<typeof useReleaseFulfillmentHoldMutation>;
export type ReleaseFulfillmentHoldMutationResult = Apollo.MutationResult<ReleaseFulfillmentHoldMutation>;
export type ReleaseFulfillmentHoldMutationOptions = Apollo.BaseMutationOptions<ReleaseFulfillmentHoldMutation, ReleaseFulfillmentHoldMutationVariables>;
export const ReleaseFulfillmentOrderDocument = gql`
    mutation ReleaseFulfillmentOrder($id: ID!) {
  cancelFulfillmentOrder(id: $id) {
    id
    status
  }
}
    `;
export type ReleaseFulfillmentOrderMutationFn = Apollo.MutationFunction<ReleaseFulfillmentOrderMutation, ReleaseFulfillmentOrderMutationVariables>;

/**
 * __useReleaseFulfillmentOrderMutation__
 *
 * To run a mutation, you first call `useReleaseFulfillmentOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReleaseFulfillmentOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [releaseFulfillmentOrderMutation, { data, loading, error }] = useReleaseFulfillmentOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReleaseFulfillmentOrderMutation(baseOptions?: Apollo.MutationHookOptions<ReleaseFulfillmentOrderMutation, ReleaseFulfillmentOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReleaseFulfillmentOrderMutation, ReleaseFulfillmentOrderMutationVariables>(ReleaseFulfillmentOrderDocument, options);
      }
export type ReleaseFulfillmentOrderMutationHookResult = ReturnType<typeof useReleaseFulfillmentOrderMutation>;
export type ReleaseFulfillmentOrderMutationResult = Apollo.MutationResult<ReleaseFulfillmentOrderMutation>;
export type ReleaseFulfillmentOrderMutationOptions = Apollo.BaseMutationOptions<ReleaseFulfillmentOrderMutation, ReleaseFulfillmentOrderMutationVariables>;
export const OrderManagementSummaryDocument = gql`
    query OrderManagementSummary($startDate: String!, $endDate: String!, $locationId: String!) {
  orderManagementSummary(
    startDate: $startDate
    endDate: $endDate
    locationId: $locationId
  ) {
    orders
    pending
    returned
    partiallyReturned
    totalAmount
  }
}
    `;

/**
 * __useOrderManagementSummaryQuery__
 *
 * To run a query within a React component, call `useOrderManagementSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderManagementSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderManagementSummaryQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useOrderManagementSummaryQuery(baseOptions: Apollo.QueryHookOptions<OrderManagementSummaryQuery, OrderManagementSummaryQueryVariables> & ({ variables: OrderManagementSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderManagementSummaryQuery, OrderManagementSummaryQueryVariables>(OrderManagementSummaryDocument, options);
      }
export function useOrderManagementSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderManagementSummaryQuery, OrderManagementSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderManagementSummaryQuery, OrderManagementSummaryQueryVariables>(OrderManagementSummaryDocument, options);
        }
// @ts-ignore
export function useOrderManagementSummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrderManagementSummaryQuery, OrderManagementSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<OrderManagementSummaryQuery, OrderManagementSummaryQueryVariables>;
export function useOrderManagementSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrderManagementSummaryQuery, OrderManagementSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<OrderManagementSummaryQuery | undefined, OrderManagementSummaryQueryVariables>;
export function useOrderManagementSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrderManagementSummaryQuery, OrderManagementSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrderManagementSummaryQuery, OrderManagementSummaryQueryVariables>(OrderManagementSummaryDocument, options);
        }
export type OrderManagementSummaryQueryHookResult = ReturnType<typeof useOrderManagementSummaryQuery>;
export type OrderManagementSummaryLazyQueryHookResult = ReturnType<typeof useOrderManagementSummaryLazyQuery>;
export type OrderManagementSummarySuspenseQueryHookResult = ReturnType<typeof useOrderManagementSummarySuspenseQuery>;
export type OrderManagementSummaryQueryResult = Apollo.QueryResult<OrderManagementSummaryQuery, OrderManagementSummaryQueryVariables>;
export const EditOrderDocument = gql`
    mutation EditOrder($input: EditOrderDTO!) {
  editOrder(input: $input)
}
    `;
export type EditOrderMutationFn = Apollo.MutationFunction<EditOrderMutation, EditOrderMutationVariables>;

/**
 * __useEditOrderMutation__
 *
 * To run a mutation, you first call `useEditOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editOrderMutation, { data, loading, error }] = useEditOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditOrderMutation(baseOptions?: Apollo.MutationHookOptions<EditOrderMutation, EditOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditOrderMutation, EditOrderMutationVariables>(EditOrderDocument, options);
      }
export type EditOrderMutationHookResult = ReturnType<typeof useEditOrderMutation>;
export type EditOrderMutationResult = Apollo.MutationResult<EditOrderMutation>;
export type EditOrderMutationOptions = Apollo.BaseMutationOptions<EditOrderMutation, EditOrderMutationVariables>;
export const ConfirmOrderDocument = gql`
    mutation ConfirmOrder($input: ConfirmOnlineOrderDTO!) {
  confirmOrder(input: $input)
}
    `;
export type ConfirmOrderMutationFn = Apollo.MutationFunction<ConfirmOrderMutation, ConfirmOrderMutationVariables>;

/**
 * __useConfirmOrderMutation__
 *
 * To run a mutation, you first call `useConfirmOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmOrderMutation, { data, loading, error }] = useConfirmOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfirmOrderMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmOrderMutation, ConfirmOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmOrderMutation, ConfirmOrderMutationVariables>(ConfirmOrderDocument, options);
      }
export type ConfirmOrderMutationHookResult = ReturnType<typeof useConfirmOrderMutation>;
export type ConfirmOrderMutationResult = Apollo.MutationResult<ConfirmOrderMutation>;
export type ConfirmOrderMutationOptions = Apollo.BaseMutationOptions<ConfirmOrderMutation, ConfirmOrderMutationVariables>;
export const CreateOrderDocument = gql`
    mutation CreateOrder($createOrderDto: CreateOrderDTO!) {
  createOrder(CreateOrderDTO: $createOrderDto) {
    id
    secondaryId
    createdAt
    orderType
    customer {
      name
      id
      phoneNumber
      email
      addresses {
        streetAddress1
        streetAddress2
        state
        landmark
        cityId
        postalCode
        buildingNo
        city {
          id
          name
        }
      }
    }
    address {
      buildingNo
      id
      postalCode
      state
      streetName
      streetAddress2
      streetAddress1
      state
      landmark
      city {
        id
        name
        country {
          id
          name
        }
      }
      districtName
    }
    subtotal
    totalDiscount
    totalAmount
    discountLines {
      discountAmount
      discount {
        type
      }
    }
    tax
    deliveryCharges
    platformFee
    posFees
    payments {
      method
      status
    }
    mrNo
    comment
    location {
      name
      city {
        id
        name
        country {
          id
          name
        }
      }
      area
    }
    integrationConfigs {
      type
      name
      charges
      apiResponseId
    }
    items {
      id
      name
      quantity
      unitPrice
      discount
      tax
      taxRate
      totalPrice
      subTotal
      product {
        taxCode
      }
    }
    orderPlatformFees {
      amount
      name
      id
    }
  }
}
    `;
export type CreateOrderMutationFn = Apollo.MutationFunction<CreateOrderMutation, CreateOrderMutationVariables>;

/**
 * __useCreateOrderMutation__
 *
 * To run a mutation, you first call `useCreateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderMutation, { data, loading, error }] = useCreateOrderMutation({
 *   variables: {
 *      createOrderDto: // value for 'createOrderDto'
 *   },
 * });
 */
export function useCreateOrderMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrderMutation, CreateOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrderMutation, CreateOrderMutationVariables>(CreateOrderDocument, options);
      }
export type CreateOrderMutationHookResult = ReturnType<typeof useCreateOrderMutation>;
export type CreateOrderMutationResult = Apollo.MutationResult<CreateOrderMutation>;
export type CreateOrderMutationOptions = Apollo.BaseMutationOptions<CreateOrderMutation, CreateOrderMutationVariables>;
export const GetOrderListDocument = gql`
    query getOrderList($sort: [SortCondition!], $page: Int!, $locationId: String, $limit: Int!, $filter: [FilterGroup!]) {
  getOrders(
    sort: $sort
    page: $page
    locationId: $locationId
    limit: $limit
    filter: $filter
  ) {
    data {
      id
      status
      createdAt
      secondaryId
      orderType
      fulfillmentStatus
      totalAmount
      amountDue
      itemsCount
      location {
        name
      }
      customer {
        name
        phoneNumber
      }
      shippingStatus
      payments {
        method
        status
        id
      }
      totalDiscount
      orderSource
      orderChannel
    }
    meta {
      limit
      page
      total
      totalCount
    }
  }
}
    `;

/**
 * __useGetOrderListQuery__
 *
 * To run a query within a React component, call `useGetOrderListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderListQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      locationId: // value for 'locationId'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetOrderListQuery(baseOptions: Apollo.QueryHookOptions<GetOrderListQuery, GetOrderListQueryVariables> & ({ variables: GetOrderListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrderListQuery, GetOrderListQueryVariables>(GetOrderListDocument, options);
      }
export function useGetOrderListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrderListQuery, GetOrderListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrderListQuery, GetOrderListQueryVariables>(GetOrderListDocument, options);
        }
// @ts-ignore
export function useGetOrderListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrderListQuery, GetOrderListQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrderListQuery, GetOrderListQueryVariables>;
export function useGetOrderListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrderListQuery, GetOrderListQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrderListQuery | undefined, GetOrderListQueryVariables>;
export function useGetOrderListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrderListQuery, GetOrderListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrderListQuery, GetOrderListQueryVariables>(GetOrderListDocument, options);
        }
export type GetOrderListQueryHookResult = ReturnType<typeof useGetOrderListQuery>;
export type GetOrderListLazyQueryHookResult = ReturnType<typeof useGetOrderListLazyQuery>;
export type GetOrderListSuspenseQueryHookResult = ReturnType<typeof useGetOrderListSuspenseQuery>;
export type GetOrderListQueryResult = Apollo.QueryResult<GetOrderListQuery, GetOrderListQueryVariables>;
export const GetOrderListingItemsDocument = gql`
    query GetOrderListingItems($getOrderId: String) {
  getOrder(id: $getOrderId) {
    items {
      quantity
      name
    }
  }
}
    `;

/**
 * __useGetOrderListingItemsQuery__
 *
 * To run a query within a React component, call `useGetOrderListingItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderListingItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderListingItemsQuery({
 *   variables: {
 *      getOrderId: // value for 'getOrderId'
 *   },
 * });
 */
export function useGetOrderListingItemsQuery(baseOptions?: Apollo.QueryHookOptions<GetOrderListingItemsQuery, GetOrderListingItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrderListingItemsQuery, GetOrderListingItemsQueryVariables>(GetOrderListingItemsDocument, options);
      }
export function useGetOrderListingItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrderListingItemsQuery, GetOrderListingItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrderListingItemsQuery, GetOrderListingItemsQueryVariables>(GetOrderListingItemsDocument, options);
        }
// @ts-ignore
export function useGetOrderListingItemsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrderListingItemsQuery, GetOrderListingItemsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrderListingItemsQuery, GetOrderListingItemsQueryVariables>;
export function useGetOrderListingItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrderListingItemsQuery, GetOrderListingItemsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrderListingItemsQuery | undefined, GetOrderListingItemsQueryVariables>;
export function useGetOrderListingItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrderListingItemsQuery, GetOrderListingItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrderListingItemsQuery, GetOrderListingItemsQueryVariables>(GetOrderListingItemsDocument, options);
        }
export type GetOrderListingItemsQueryHookResult = ReturnType<typeof useGetOrderListingItemsQuery>;
export type GetOrderListingItemsLazyQueryHookResult = ReturnType<typeof useGetOrderListingItemsLazyQuery>;
export type GetOrderListingItemsSuspenseQueryHookResult = ReturnType<typeof useGetOrderListingItemsSuspenseQuery>;
export type GetOrderListingItemsQueryResult = Apollo.QueryResult<GetOrderListingItemsQuery, GetOrderListingItemsQueryVariables>;
export const GetOrderDocument = gql`
    query GetOrder($getOrderId: String!) {
  getOrder(id: $getOrderId) {
    addressId
    comment
    createdAt
    customerId
    cancelledReason
    deliveryCharges
    fulfillmentStatus
    id
    integrationCharges
    locationId
    mrNo
    orderChannel
    orderSource
    orderType
    partnerId
    platformFee
    posFees
    registerId
    secondaryId
    shippingStatus
    status
    subtotal
    tax
    totalAmount
    amountDue
    totalDiscount
    updatedAt
    partnerReferenceNo
    partner {
      id
      name
    }
    address {
      buildingNo
      id
      postalCode
      state
      streetName
      streetAddress2
      streetAddress1
      state
      landmark
      city {
        id
        name
        country {
          id
          name
        }
      }
      districtName
    }
    customer {
      id
      name
      phoneNumber
    }
    discountLines {
      id
      discountAmount
      discount {
        type
      }
    }
    integrationConfigs {
      type
      apiResponseId
      charges
      name
    }
    payments {
      method
      status
      id
      amount
    }
    location {
      area
      name
      city {
        name
        id
        country {
          id
          name
        }
      }
    }
    items {
      id
      name
      productId
      image
      discount
      secondaryId
      quantity
      taxRate
      tax
      totalPrice
      unitPrice
      subTotal
      fulfillmentStatus
      cancelledQuantity
      returnedQuantity
      lots {
        id
        quantity
        returnedQuantity
        productLot {
          id
          actionId
          batchNumber
          batchExpiry
          mrpSellingUnit
        }
      }
    }
    locationRegisterSession {
      openedBy {
        firstName
        lastName
      }
    }
    orderPlatformFees {
      amount
      name
      id
    }
  }
}
    `;

/**
 * __useGetOrderQuery__
 *
 * To run a query within a React component, call `useGetOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderQuery({
 *   variables: {
 *      getOrderId: // value for 'getOrderId'
 *   },
 * });
 */
export function useGetOrderQuery(baseOptions: Apollo.QueryHookOptions<GetOrderQuery, GetOrderQueryVariables> & ({ variables: GetOrderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrderQuery, GetOrderQueryVariables>(GetOrderDocument, options);
      }
export function useGetOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrderQuery, GetOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrderQuery, GetOrderQueryVariables>(GetOrderDocument, options);
        }
// @ts-ignore
export function useGetOrderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrderQuery, GetOrderQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrderQuery, GetOrderQueryVariables>;
export function useGetOrderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrderQuery, GetOrderQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrderQuery | undefined, GetOrderQueryVariables>;
export function useGetOrderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrderQuery, GetOrderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrderQuery, GetOrderQueryVariables>(GetOrderDocument, options);
        }
export type GetOrderQueryHookResult = ReturnType<typeof useGetOrderQuery>;
export type GetOrderLazyQueryHookResult = ReturnType<typeof useGetOrderLazyQuery>;
export type GetOrderSuspenseQueryHookResult = ReturnType<typeof useGetOrderSuspenseQuery>;
export type GetOrderQueryResult = Apollo.QueryResult<GetOrderQuery, GetOrderQueryVariables>;
export const GetOrderForReturnDocument = gql`
    query GetOrderForReturn($secondaryId: Float, $getOrderId: String) {
  getOrder(secondaryId: $secondaryId, id: $getOrderId) {
    id
    secondaryId
    tax
    subtotal
    customer {
      id
      name
      phoneNumber
      email
    }
    orderSource
    status
    orderChannel
    orderType
    totalAmount
    totalDiscount
    locationId
    partnerId
    payments {
      method
      status
    }
    items {
      name
      id
      discount
      subTotal
      tax
      totalPrice
      unitPrice
      taxRate
      secondaryId
      quantity
      returnedQuantity
      cancelledQuantity
      lots {
        id
        quantity
        returnedQuantity
        productLot {
          actionId
        }
      }
    }
  }
}
    `;

/**
 * __useGetOrderForReturnQuery__
 *
 * To run a query within a React component, call `useGetOrderForReturnQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderForReturnQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderForReturnQuery({
 *   variables: {
 *      secondaryId: // value for 'secondaryId'
 *      getOrderId: // value for 'getOrderId'
 *   },
 * });
 */
export function useGetOrderForReturnQuery(baseOptions?: Apollo.QueryHookOptions<GetOrderForReturnQuery, GetOrderForReturnQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrderForReturnQuery, GetOrderForReturnQueryVariables>(GetOrderForReturnDocument, options);
      }
export function useGetOrderForReturnLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrderForReturnQuery, GetOrderForReturnQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrderForReturnQuery, GetOrderForReturnQueryVariables>(GetOrderForReturnDocument, options);
        }
// @ts-ignore
export function useGetOrderForReturnSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrderForReturnQuery, GetOrderForReturnQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrderForReturnQuery, GetOrderForReturnQueryVariables>;
export function useGetOrderForReturnSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrderForReturnQuery, GetOrderForReturnQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrderForReturnQuery | undefined, GetOrderForReturnQueryVariables>;
export function useGetOrderForReturnSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrderForReturnQuery, GetOrderForReturnQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrderForReturnQuery, GetOrderForReturnQueryVariables>(GetOrderForReturnDocument, options);
        }
export type GetOrderForReturnQueryHookResult = ReturnType<typeof useGetOrderForReturnQuery>;
export type GetOrderForReturnLazyQueryHookResult = ReturnType<typeof useGetOrderForReturnLazyQuery>;
export type GetOrderForReturnSuspenseQueryHookResult = ReturnType<typeof useGetOrderForReturnSuspenseQuery>;
export type GetOrderForReturnQueryResult = Apollo.QueryResult<GetOrderForReturnQuery, GetOrderForReturnQueryVariables>;
export const GetReturnedOrdersForOrderDetailDocument = gql`
    query GetReturnedOrdersForOrderDetail($page: Int!, $limit: Int!, $locationId: String, $filter: [FilterGroup!]) {
  getReturnedOrders(
    page: $page
    limit: $limit
    locationId: $locationId
    filter: $filter
  ) {
    data {
      comment
      id
      createdAt
      parentOrderId
      secondaryId
      status
      totalAmount
      items {
        createdAt
        id
        secondaryId
        productId
        name
        quantity
        discount
        subTotal
        totalPrice
        unitPrice
        updatedAt
      }
      location {
        name
      }
      integrationConfigs {
        apiResponseId
      }
      locationRegisterSession {
        openedBy {
          firstName
          lastName
        }
      }
      customer {
        name
        phoneNumber
      }
    }
  }
}
    `;

/**
 * __useGetReturnedOrdersForOrderDetailQuery__
 *
 * To run a query within a React component, call `useGetReturnedOrdersForOrderDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReturnedOrdersForOrderDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReturnedOrdersForOrderDetailQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      locationId: // value for 'locationId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetReturnedOrdersForOrderDetailQuery(baseOptions: Apollo.QueryHookOptions<GetReturnedOrdersForOrderDetailQuery, GetReturnedOrdersForOrderDetailQueryVariables> & ({ variables: GetReturnedOrdersForOrderDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReturnedOrdersForOrderDetailQuery, GetReturnedOrdersForOrderDetailQueryVariables>(GetReturnedOrdersForOrderDetailDocument, options);
      }
export function useGetReturnedOrdersForOrderDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReturnedOrdersForOrderDetailQuery, GetReturnedOrdersForOrderDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReturnedOrdersForOrderDetailQuery, GetReturnedOrdersForOrderDetailQueryVariables>(GetReturnedOrdersForOrderDetailDocument, options);
        }
// @ts-ignore
export function useGetReturnedOrdersForOrderDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetReturnedOrdersForOrderDetailQuery, GetReturnedOrdersForOrderDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GetReturnedOrdersForOrderDetailQuery, GetReturnedOrdersForOrderDetailQueryVariables>;
export function useGetReturnedOrdersForOrderDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReturnedOrdersForOrderDetailQuery, GetReturnedOrdersForOrderDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GetReturnedOrdersForOrderDetailQuery | undefined, GetReturnedOrdersForOrderDetailQueryVariables>;
export function useGetReturnedOrdersForOrderDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReturnedOrdersForOrderDetailQuery, GetReturnedOrdersForOrderDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReturnedOrdersForOrderDetailQuery, GetReturnedOrdersForOrderDetailQueryVariables>(GetReturnedOrdersForOrderDetailDocument, options);
        }
export type GetReturnedOrdersForOrderDetailQueryHookResult = ReturnType<typeof useGetReturnedOrdersForOrderDetailQuery>;
export type GetReturnedOrdersForOrderDetailLazyQueryHookResult = ReturnType<typeof useGetReturnedOrdersForOrderDetailLazyQuery>;
export type GetReturnedOrdersForOrderDetailSuspenseQueryHookResult = ReturnType<typeof useGetReturnedOrdersForOrderDetailSuspenseQuery>;
export type GetReturnedOrdersForOrderDetailQueryResult = Apollo.QueryResult<GetReturnedOrdersForOrderDetailQuery, GetReturnedOrdersForOrderDetailQueryVariables>;
export const ProcessOrderDocument = gql`
    mutation ProcessOrder($processOrder: ProcessOrderDTO!) {
  processOrder(processOrder: $processOrder)
}
    `;
export type ProcessOrderMutationFn = Apollo.MutationFunction<ProcessOrderMutation, ProcessOrderMutationVariables>;

/**
 * __useProcessOrderMutation__
 *
 * To run a mutation, you first call `useProcessOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processOrderMutation, { data, loading, error }] = useProcessOrderMutation({
 *   variables: {
 *      processOrder: // value for 'processOrder'
 *   },
 * });
 */
export function useProcessOrderMutation(baseOptions?: Apollo.MutationHookOptions<ProcessOrderMutation, ProcessOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessOrderMutation, ProcessOrderMutationVariables>(ProcessOrderDocument, options);
      }
export type ProcessOrderMutationHookResult = ReturnType<typeof useProcessOrderMutation>;
export type ProcessOrderMutationResult = Apollo.MutationResult<ProcessOrderMutation>;
export type ProcessOrderMutationOptions = Apollo.BaseMutationOptions<ProcessOrderMutation, ProcessOrderMutationVariables>;
export const UpdatePaymentStatusDocument = gql`
    mutation UpdatePaymentStatus($paymentStatus: PaymentStatus!, $orderId: String!) {
  updatePaymentStatus(paymentStatus: $paymentStatus, orderId: $orderId)
}
    `;
export type UpdatePaymentStatusMutationFn = Apollo.MutationFunction<UpdatePaymentStatusMutation, UpdatePaymentStatusMutationVariables>;

/**
 * __useUpdatePaymentStatusMutation__
 *
 * To run a mutation, you first call `useUpdatePaymentStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaymentStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaymentStatusMutation, { data, loading, error }] = useUpdatePaymentStatusMutation({
 *   variables: {
 *      paymentStatus: // value for 'paymentStatus'
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useUpdatePaymentStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePaymentStatusMutation, UpdatePaymentStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePaymentStatusMutation, UpdatePaymentStatusMutationVariables>(UpdatePaymentStatusDocument, options);
      }
export type UpdatePaymentStatusMutationHookResult = ReturnType<typeof useUpdatePaymentStatusMutation>;
export type UpdatePaymentStatusMutationResult = Apollo.MutationResult<UpdatePaymentStatusMutation>;
export type UpdatePaymentStatusMutationOptions = Apollo.BaseMutationOptions<UpdatePaymentStatusMutation, UpdatePaymentStatusMutationVariables>;
export const ProcessShippingDocument = gql`
    mutation ProcessShipping($processOrder: ProcessShippingDTO!) {
  processShipping(processOrder: $processOrder)
}
    `;
export type ProcessShippingMutationFn = Apollo.MutationFunction<ProcessShippingMutation, ProcessShippingMutationVariables>;

/**
 * __useProcessShippingMutation__
 *
 * To run a mutation, you first call `useProcessShippingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessShippingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processShippingMutation, { data, loading, error }] = useProcessShippingMutation({
 *   variables: {
 *      processOrder: // value for 'processOrder'
 *   },
 * });
 */
export function useProcessShippingMutation(baseOptions?: Apollo.MutationHookOptions<ProcessShippingMutation, ProcessShippingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessShippingMutation, ProcessShippingMutationVariables>(ProcessShippingDocument, options);
      }
export type ProcessShippingMutationHookResult = ReturnType<typeof useProcessShippingMutation>;
export type ProcessShippingMutationResult = Apollo.MutationResult<ProcessShippingMutation>;
export type ProcessShippingMutationOptions = Apollo.BaseMutationOptions<ProcessShippingMutation, ProcessShippingMutationVariables>;
export const ProcessFulfillmentDocument = gql`
    mutation ProcessFulfillment($processOrder: ProcessFulfillmentDTO!) {
  processFulfillment(processOrder: $processOrder)
}
    `;
export type ProcessFulfillmentMutationFn = Apollo.MutationFunction<ProcessFulfillmentMutation, ProcessFulfillmentMutationVariables>;

/**
 * __useProcessFulfillmentMutation__
 *
 * To run a mutation, you first call `useProcessFulfillmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessFulfillmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processFulfillmentMutation, { data, loading, error }] = useProcessFulfillmentMutation({
 *   variables: {
 *      processOrder: // value for 'processOrder'
 *   },
 * });
 */
export function useProcessFulfillmentMutation(baseOptions?: Apollo.MutationHookOptions<ProcessFulfillmentMutation, ProcessFulfillmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessFulfillmentMutation, ProcessFulfillmentMutationVariables>(ProcessFulfillmentDocument, options);
      }
export type ProcessFulfillmentMutationHookResult = ReturnType<typeof useProcessFulfillmentMutation>;
export type ProcessFulfillmentMutationResult = Apollo.MutationResult<ProcessFulfillmentMutation>;
export type ProcessFulfillmentMutationOptions = Apollo.BaseMutationOptions<ProcessFulfillmentMutation, ProcessFulfillmentMutationVariables>;
export const ReturnOrderDocument = gql`
    mutation ReturnOrder($returnOrderDto: ReturnOrderDto!) {
  returnOrder(ReturnOrderDto: $returnOrderDto) {
    id
    secondaryId
    order {
      id
      secondaryId
    }
    customer {
      phoneNumber
      name
    }
    items {
      id
      name
      quantity
      subTotal
      totalPrice
      discount
      unitPrice
      product {
        taxCode
      }
      lots {
        productLot {
          taxSellingUnit
        }
      }
    }
    location {
      name
    }
    totalAmount
    paymentMethod
    locationRegisterSession {
      openedBy {
        firstName
        secondaryId
        lastName
      }
    }
    status
    createdAt
  }
}
    `;
export type ReturnOrderMutationFn = Apollo.MutationFunction<ReturnOrderMutation, ReturnOrderMutationVariables>;

/**
 * __useReturnOrderMutation__
 *
 * To run a mutation, you first call `useReturnOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReturnOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [returnOrderMutation, { data, loading, error }] = useReturnOrderMutation({
 *   variables: {
 *      returnOrderDto: // value for 'returnOrderDto'
 *   },
 * });
 */
export function useReturnOrderMutation(baseOptions?: Apollo.MutationHookOptions<ReturnOrderMutation, ReturnOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReturnOrderMutation, ReturnOrderMutationVariables>(ReturnOrderDocument, options);
      }
export type ReturnOrderMutationHookResult = ReturnType<typeof useReturnOrderMutation>;
export type ReturnOrderMutationResult = Apollo.MutationResult<ReturnOrderMutation>;
export type ReturnOrderMutationOptions = Apollo.BaseMutationOptions<ReturnOrderMutation, ReturnOrderMutationVariables>;
export const GetReturnedOrdersDocument = gql`
    query GetReturnedOrders($filter: [FilterGroup!], $limit: Int!, $locationId: String, $page: Int!, $sort: [SortCondition!]) {
  getReturnedOrders(
    filter: $filter
    limit: $limit
    locationId: $locationId
    page: $page
    sort: $sort
  ) {
    data {
      customer {
        id
        name
        phoneNumber
      }
      secondaryId
      id
      parentOrderId
      status
      comment
      totalAmount
      updatedAt
      createdAt
    }
    meta {
      limit
      page
      total
      totalCount
    }
  }
}
    `;

/**
 * __useGetReturnedOrdersQuery__
 *
 * To run a query within a React component, call `useGetReturnedOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReturnedOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReturnedOrdersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      locationId: // value for 'locationId'
 *      page: // value for 'page'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetReturnedOrdersQuery(baseOptions: Apollo.QueryHookOptions<GetReturnedOrdersQuery, GetReturnedOrdersQueryVariables> & ({ variables: GetReturnedOrdersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReturnedOrdersQuery, GetReturnedOrdersQueryVariables>(GetReturnedOrdersDocument, options);
      }
export function useGetReturnedOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReturnedOrdersQuery, GetReturnedOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReturnedOrdersQuery, GetReturnedOrdersQueryVariables>(GetReturnedOrdersDocument, options);
        }
// @ts-ignore
export function useGetReturnedOrdersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetReturnedOrdersQuery, GetReturnedOrdersQueryVariables>): Apollo.UseSuspenseQueryResult<GetReturnedOrdersQuery, GetReturnedOrdersQueryVariables>;
export function useGetReturnedOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReturnedOrdersQuery, GetReturnedOrdersQueryVariables>): Apollo.UseSuspenseQueryResult<GetReturnedOrdersQuery | undefined, GetReturnedOrdersQueryVariables>;
export function useGetReturnedOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReturnedOrdersQuery, GetReturnedOrdersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReturnedOrdersQuery, GetReturnedOrdersQueryVariables>(GetReturnedOrdersDocument, options);
        }
export type GetReturnedOrdersQueryHookResult = ReturnType<typeof useGetReturnedOrdersQuery>;
export type GetReturnedOrdersLazyQueryHookResult = ReturnType<typeof useGetReturnedOrdersLazyQuery>;
export type GetReturnedOrdersSuspenseQueryHookResult = ReturnType<typeof useGetReturnedOrdersSuspenseQuery>;
export type GetReturnedOrdersQueryResult = Apollo.QueryResult<GetReturnedOrdersQuery, GetReturnedOrdersQueryVariables>;
export const UpdateFbrInvoiceIdDocument = gql`
    mutation UpdateFbrInvoiceId($invoiceId: String!, $orderId: String!) {
  updateFbrInvoiceId(invoiceId: $invoiceId, orderId: $orderId)
}
    `;
export type UpdateFbrInvoiceIdMutationFn = Apollo.MutationFunction<UpdateFbrInvoiceIdMutation, UpdateFbrInvoiceIdMutationVariables>;

/**
 * __useUpdateFbrInvoiceIdMutation__
 *
 * To run a mutation, you first call `useUpdateFbrInvoiceIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFbrInvoiceIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFbrInvoiceIdMutation, { data, loading, error }] = useUpdateFbrInvoiceIdMutation({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useUpdateFbrInvoiceIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFbrInvoiceIdMutation, UpdateFbrInvoiceIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFbrInvoiceIdMutation, UpdateFbrInvoiceIdMutationVariables>(UpdateFbrInvoiceIdDocument, options);
      }
export type UpdateFbrInvoiceIdMutationHookResult = ReturnType<typeof useUpdateFbrInvoiceIdMutation>;
export type UpdateFbrInvoiceIdMutationResult = Apollo.MutationResult<UpdateFbrInvoiceIdMutation>;
export type UpdateFbrInvoiceIdMutationOptions = Apollo.BaseMutationOptions<UpdateFbrInvoiceIdMutation, UpdateFbrInvoiceIdMutationVariables>;
export const UpdateReturnFbrInvoiceIdDocument = gql`
    mutation UpdateReturnFbrInvoiceId($invoiceId: String!, $returnOrderId: String!) {
  updateReturnFbrInvoiceId(invoiceId: $invoiceId, returnOrderId: $returnOrderId)
}
    `;
export type UpdateReturnFbrInvoiceIdMutationFn = Apollo.MutationFunction<UpdateReturnFbrInvoiceIdMutation, UpdateReturnFbrInvoiceIdMutationVariables>;

/**
 * __useUpdateReturnFbrInvoiceIdMutation__
 *
 * To run a mutation, you first call `useUpdateReturnFbrInvoiceIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReturnFbrInvoiceIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReturnFbrInvoiceIdMutation, { data, loading, error }] = useUpdateReturnFbrInvoiceIdMutation({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *      returnOrderId: // value for 'returnOrderId'
 *   },
 * });
 */
export function useUpdateReturnFbrInvoiceIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReturnFbrInvoiceIdMutation, UpdateReturnFbrInvoiceIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReturnFbrInvoiceIdMutation, UpdateReturnFbrInvoiceIdMutationVariables>(UpdateReturnFbrInvoiceIdDocument, options);
      }
export type UpdateReturnFbrInvoiceIdMutationHookResult = ReturnType<typeof useUpdateReturnFbrInvoiceIdMutation>;
export type UpdateReturnFbrInvoiceIdMutationResult = Apollo.MutationResult<UpdateReturnFbrInvoiceIdMutation>;
export type UpdateReturnFbrInvoiceIdMutationOptions = Apollo.BaseMutationOptions<UpdateReturnFbrInvoiceIdMutation, UpdateReturnFbrInvoiceIdMutationVariables>;
export const GetReturnOrderDocument = gql`
    query GetReturnOrder($getReturnOrderId: String!) {
  getReturnOrder(id: $getReturnOrderId) {
    comment
    createdAt
    id
    order {
      secondaryId
    }
    customer {
      name
    }
    integrationConfigs {
      apiResponseId
      type
      name
      charges
    }
    paymentMethod
    registerSessionId
    secondaryId
    status
    totalAmount
    updatedAt
    items {
      createdAt
      description
      discount
      id
      image
      name
      orderId
      productId
      quantity
      secondaryId
      subTotal
      totalPrice
      unitPrice
      updatedAt
      lots {
        productLot {
          actionId
        }
      }
    }
    locationRegisterSession {
      openedBy {
        firstName
        lastName
      }
    }
    location {
      name
    }
  }
}
    `;

/**
 * __useGetReturnOrderQuery__
 *
 * To run a query within a React component, call `useGetReturnOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReturnOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReturnOrderQuery({
 *   variables: {
 *      getReturnOrderId: // value for 'getReturnOrderId'
 *   },
 * });
 */
export function useGetReturnOrderQuery(baseOptions: Apollo.QueryHookOptions<GetReturnOrderQuery, GetReturnOrderQueryVariables> & ({ variables: GetReturnOrderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReturnOrderQuery, GetReturnOrderQueryVariables>(GetReturnOrderDocument, options);
      }
export function useGetReturnOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReturnOrderQuery, GetReturnOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReturnOrderQuery, GetReturnOrderQueryVariables>(GetReturnOrderDocument, options);
        }
// @ts-ignore
export function useGetReturnOrderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetReturnOrderQuery, GetReturnOrderQueryVariables>): Apollo.UseSuspenseQueryResult<GetReturnOrderQuery, GetReturnOrderQueryVariables>;
export function useGetReturnOrderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReturnOrderQuery, GetReturnOrderQueryVariables>): Apollo.UseSuspenseQueryResult<GetReturnOrderQuery | undefined, GetReturnOrderQueryVariables>;
export function useGetReturnOrderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReturnOrderQuery, GetReturnOrderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReturnOrderQuery, GetReturnOrderQueryVariables>(GetReturnOrderDocument, options);
        }
export type GetReturnOrderQueryHookResult = ReturnType<typeof useGetReturnOrderQuery>;
export type GetReturnOrderLazyQueryHookResult = ReturnType<typeof useGetReturnOrderLazyQuery>;
export type GetReturnOrderSuspenseQueryHookResult = ReturnType<typeof useGetReturnOrderSuspenseQuery>;
export type GetReturnOrderQueryResult = Apollo.QueryResult<GetReturnOrderQuery, GetReturnOrderQueryVariables>;
export const GetOrderLineItemLotsListDocument = gql`
    query GetOrderLineItemLotsList($orderLineItemId: String!, $sort: [SortCondition!], $filter: [FilterGroup!], $page: Int!, $limit: Int!, $locationId: String) {
  getOrderLineItemLots(
    orderLineItemId: $orderLineItemId
    sort: $sort
    filter: $filter
    page: $page
    limit: $limit
    locationId: $locationId
  ) {
    meta {
      page
      limit
      totalCount
      total
    }
    data {
      id
      orderLineItemId
      productLotId
      quantity
      returnedQuantity
      productLot {
        actionId
        mrpSellingUnit
      }
    }
  }
}
    `;

/**
 * __useGetOrderLineItemLotsListQuery__
 *
 * To run a query within a React component, call `useGetOrderLineItemLotsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderLineItemLotsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderLineItemLotsListQuery({
 *   variables: {
 *      orderLineItemId: // value for 'orderLineItemId'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useGetOrderLineItemLotsListQuery(baseOptions: Apollo.QueryHookOptions<GetOrderLineItemLotsListQuery, GetOrderLineItemLotsListQueryVariables> & ({ variables: GetOrderLineItemLotsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrderLineItemLotsListQuery, GetOrderLineItemLotsListQueryVariables>(GetOrderLineItemLotsListDocument, options);
      }
export function useGetOrderLineItemLotsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrderLineItemLotsListQuery, GetOrderLineItemLotsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrderLineItemLotsListQuery, GetOrderLineItemLotsListQueryVariables>(GetOrderLineItemLotsListDocument, options);
        }
// @ts-ignore
export function useGetOrderLineItemLotsListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrderLineItemLotsListQuery, GetOrderLineItemLotsListQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrderLineItemLotsListQuery, GetOrderLineItemLotsListQueryVariables>;
export function useGetOrderLineItemLotsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrderLineItemLotsListQuery, GetOrderLineItemLotsListQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrderLineItemLotsListQuery | undefined, GetOrderLineItemLotsListQueryVariables>;
export function useGetOrderLineItemLotsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrderLineItemLotsListQuery, GetOrderLineItemLotsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrderLineItemLotsListQuery, GetOrderLineItemLotsListQueryVariables>(GetOrderLineItemLotsListDocument, options);
        }
export type GetOrderLineItemLotsListQueryHookResult = ReturnType<typeof useGetOrderLineItemLotsListQuery>;
export type GetOrderLineItemLotsListLazyQueryHookResult = ReturnType<typeof useGetOrderLineItemLotsListLazyQuery>;
export type GetOrderLineItemLotsListSuspenseQueryHookResult = ReturnType<typeof useGetOrderLineItemLotsListSuspenseQuery>;
export type GetOrderLineItemLotsListQueryResult = Apollo.QueryResult<GetOrderLineItemLotsListQuery, GetOrderLineItemLotsListQueryVariables>;
export const GetReturnOrderLineItemLotsDocument = gql`
    query GetReturnOrderLineItemLots($returnOrderLineItemId: String!, $locationId: String, $limit: Int!, $page: Int!, $filter: [FilterGroup!], $sort: [SortCondition!]) {
  getReturnOrderLineItemLots(
    returnOrderLineItemId: $returnOrderLineItemId
    locationId: $locationId
    limit: $limit
    page: $page
    filter: $filter
    sort: $sort
  ) {
    meta {
      page
      limit
      totalCount
      total
    }
    data {
      id
      quantity
      productLot {
        actionId
      }
      returnOrderLineItem {
        totalPrice
      }
    }
  }
}
    `;

/**
 * __useGetReturnOrderLineItemLotsQuery__
 *
 * To run a query within a React component, call `useGetReturnOrderLineItemLotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReturnOrderLineItemLotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReturnOrderLineItemLotsQuery({
 *   variables: {
 *      returnOrderLineItemId: // value for 'returnOrderLineItemId'
 *      locationId: // value for 'locationId'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetReturnOrderLineItemLotsQuery(baseOptions: Apollo.QueryHookOptions<GetReturnOrderLineItemLotsQuery, GetReturnOrderLineItemLotsQueryVariables> & ({ variables: GetReturnOrderLineItemLotsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReturnOrderLineItemLotsQuery, GetReturnOrderLineItemLotsQueryVariables>(GetReturnOrderLineItemLotsDocument, options);
      }
export function useGetReturnOrderLineItemLotsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReturnOrderLineItemLotsQuery, GetReturnOrderLineItemLotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReturnOrderLineItemLotsQuery, GetReturnOrderLineItemLotsQueryVariables>(GetReturnOrderLineItemLotsDocument, options);
        }
// @ts-ignore
export function useGetReturnOrderLineItemLotsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetReturnOrderLineItemLotsQuery, GetReturnOrderLineItemLotsQueryVariables>): Apollo.UseSuspenseQueryResult<GetReturnOrderLineItemLotsQuery, GetReturnOrderLineItemLotsQueryVariables>;
export function useGetReturnOrderLineItemLotsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReturnOrderLineItemLotsQuery, GetReturnOrderLineItemLotsQueryVariables>): Apollo.UseSuspenseQueryResult<GetReturnOrderLineItemLotsQuery | undefined, GetReturnOrderLineItemLotsQueryVariables>;
export function useGetReturnOrderLineItemLotsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReturnOrderLineItemLotsQuery, GetReturnOrderLineItemLotsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReturnOrderLineItemLotsQuery, GetReturnOrderLineItemLotsQueryVariables>(GetReturnOrderLineItemLotsDocument, options);
        }
export type GetReturnOrderLineItemLotsQueryHookResult = ReturnType<typeof useGetReturnOrderLineItemLotsQuery>;
export type GetReturnOrderLineItemLotsLazyQueryHookResult = ReturnType<typeof useGetReturnOrderLineItemLotsLazyQuery>;
export type GetReturnOrderLineItemLotsSuspenseQueryHookResult = ReturnType<typeof useGetReturnOrderLineItemLotsSuspenseQuery>;
export type GetReturnOrderLineItemLotsQueryResult = Apollo.QueryResult<GetReturnOrderLineItemLotsQuery, GetReturnOrderLineItemLotsQueryVariables>;
export const GetPartnersForOptionsDocument = gql`
    query GetPartnersForOptions($page: Int!, $limit: Int!, $locationId: String, $filter: [FilterGroup!], $sort: [SortCondition!]) {
  getPartners(
    page: $page
    limit: $limit
    locationId: $locationId
    filter: $filter
    sort: $sort
  ) {
    data {
      name
      id
      secondaryId
      status
    }
    meta {
      limit
      page
      total
      totalCount
    }
  }
}
    `;

/**
 * __useGetPartnersForOptionsQuery__
 *
 * To run a query within a React component, call `useGetPartnersForOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartnersForOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartnersForOptionsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      locationId: // value for 'locationId'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetPartnersForOptionsQuery(baseOptions: Apollo.QueryHookOptions<GetPartnersForOptionsQuery, GetPartnersForOptionsQueryVariables> & ({ variables: GetPartnersForOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPartnersForOptionsQuery, GetPartnersForOptionsQueryVariables>(GetPartnersForOptionsDocument, options);
      }
export function useGetPartnersForOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPartnersForOptionsQuery, GetPartnersForOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPartnersForOptionsQuery, GetPartnersForOptionsQueryVariables>(GetPartnersForOptionsDocument, options);
        }
// @ts-ignore
export function useGetPartnersForOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPartnersForOptionsQuery, GetPartnersForOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPartnersForOptionsQuery, GetPartnersForOptionsQueryVariables>;
export function useGetPartnersForOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPartnersForOptionsQuery, GetPartnersForOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPartnersForOptionsQuery | undefined, GetPartnersForOptionsQueryVariables>;
export function useGetPartnersForOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPartnersForOptionsQuery, GetPartnersForOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPartnersForOptionsQuery, GetPartnersForOptionsQueryVariables>(GetPartnersForOptionsDocument, options);
        }
export type GetPartnersForOptionsQueryHookResult = ReturnType<typeof useGetPartnersForOptionsQuery>;
export type GetPartnersForOptionsLazyQueryHookResult = ReturnType<typeof useGetPartnersForOptionsLazyQuery>;
export type GetPartnersForOptionsSuspenseQueryHookResult = ReturnType<typeof useGetPartnersForOptionsSuspenseQuery>;
export type GetPartnersForOptionsQueryResult = Apollo.QueryResult<GetPartnersForOptionsQuery, GetPartnersForOptionsQueryVariables>;
export const GetPartnersListDocument = gql`
    query GetPartnersList($limit: Int!, $filter: [FilterGroup!], $locationId: String, $page: Int!, $sort: [SortCondition!]) {
  getPartners(
    limit: $limit
    filter: $filter
    locationId: $locationId
    page: $page
    sort: $sort
  ) {
    data {
      address
      city {
        id
        name
        country {
          id
          name
        }
      }
      contactPerson
      createdAt
      email
      id
      name
      phoneNumber
      secondaryId
      status
      taxId
      type
      websiteUrl
    }
    meta {
      limit
      page
      total
      totalCount
    }
  }
}
    `;

/**
 * __useGetPartnersListQuery__
 *
 * To run a query within a React component, call `useGetPartnersListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartnersListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartnersListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      locationId: // value for 'locationId'
 *      page: // value for 'page'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetPartnersListQuery(baseOptions: Apollo.QueryHookOptions<GetPartnersListQuery, GetPartnersListQueryVariables> & ({ variables: GetPartnersListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPartnersListQuery, GetPartnersListQueryVariables>(GetPartnersListDocument, options);
      }
export function useGetPartnersListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPartnersListQuery, GetPartnersListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPartnersListQuery, GetPartnersListQueryVariables>(GetPartnersListDocument, options);
        }
// @ts-ignore
export function useGetPartnersListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPartnersListQuery, GetPartnersListQueryVariables>): Apollo.UseSuspenseQueryResult<GetPartnersListQuery, GetPartnersListQueryVariables>;
export function useGetPartnersListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPartnersListQuery, GetPartnersListQueryVariables>): Apollo.UseSuspenseQueryResult<GetPartnersListQuery | undefined, GetPartnersListQueryVariables>;
export function useGetPartnersListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPartnersListQuery, GetPartnersListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPartnersListQuery, GetPartnersListQueryVariables>(GetPartnersListDocument, options);
        }
export type GetPartnersListQueryHookResult = ReturnType<typeof useGetPartnersListQuery>;
export type GetPartnersListLazyQueryHookResult = ReturnType<typeof useGetPartnersListLazyQuery>;
export type GetPartnersListSuspenseQueryHookResult = ReturnType<typeof useGetPartnersListSuspenseQuery>;
export type GetPartnersListQueryResult = Apollo.QueryResult<GetPartnersListQuery, GetPartnersListQueryVariables>;
export const CreatePartnerDocument = gql`
    mutation CreatePartner($createPartnerDto: CreatePartnerDTO!) {
  createPartner(createPartnerDTO: $createPartnerDto) {
    id
  }
}
    `;
export type CreatePartnerMutationFn = Apollo.MutationFunction<CreatePartnerMutation, CreatePartnerMutationVariables>;

/**
 * __useCreatePartnerMutation__
 *
 * To run a mutation, you first call `useCreatePartnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePartnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPartnerMutation, { data, loading, error }] = useCreatePartnerMutation({
 *   variables: {
 *      createPartnerDto: // value for 'createPartnerDto'
 *   },
 * });
 */
export function useCreatePartnerMutation(baseOptions?: Apollo.MutationHookOptions<CreatePartnerMutation, CreatePartnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePartnerMutation, CreatePartnerMutationVariables>(CreatePartnerDocument, options);
      }
export type CreatePartnerMutationHookResult = ReturnType<typeof useCreatePartnerMutation>;
export type CreatePartnerMutationResult = Apollo.MutationResult<CreatePartnerMutation>;
export type CreatePartnerMutationOptions = Apollo.BaseMutationOptions<CreatePartnerMutation, CreatePartnerMutationVariables>;
export const UpdatePartnerDocument = gql`
    mutation UpdatePartner($updatePartnerDto: UpdatePartnerDTO!) {
  updatePartner(updatePartnerDTO: $updatePartnerDto) {
    id
  }
}
    `;
export type UpdatePartnerMutationFn = Apollo.MutationFunction<UpdatePartnerMutation, UpdatePartnerMutationVariables>;

/**
 * __useUpdatePartnerMutation__
 *
 * To run a mutation, you first call `useUpdatePartnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePartnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePartnerMutation, { data, loading, error }] = useUpdatePartnerMutation({
 *   variables: {
 *      updatePartnerDto: // value for 'updatePartnerDto'
 *   },
 * });
 */
export function useUpdatePartnerMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePartnerMutation, UpdatePartnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePartnerMutation, UpdatePartnerMutationVariables>(UpdatePartnerDocument, options);
      }
export type UpdatePartnerMutationHookResult = ReturnType<typeof useUpdatePartnerMutation>;
export type UpdatePartnerMutationResult = Apollo.MutationResult<UpdatePartnerMutation>;
export type UpdatePartnerMutationOptions = Apollo.BaseMutationOptions<UpdatePartnerMutation, UpdatePartnerMutationVariables>;
export const GetPartnerDocument = gql`
    query GetPartner($getPartnerId: String!) {
  getPartner(id: $getPartnerId) {
    id
    secondaryId
    cityId
    name
    contactPerson
    phoneNumber
    email
    websiteUrl
    address
    taxId
    type
    status
    createdAt
    updatedAt
    city {
      id
      country {
        id
      }
    }
  }
}
    `;

/**
 * __useGetPartnerQuery__
 *
 * To run a query within a React component, call `useGetPartnerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartnerQuery({
 *   variables: {
 *      getPartnerId: // value for 'getPartnerId'
 *   },
 * });
 */
export function useGetPartnerQuery(baseOptions: Apollo.QueryHookOptions<GetPartnerQuery, GetPartnerQueryVariables> & ({ variables: GetPartnerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPartnerQuery, GetPartnerQueryVariables>(GetPartnerDocument, options);
      }
export function useGetPartnerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPartnerQuery, GetPartnerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPartnerQuery, GetPartnerQueryVariables>(GetPartnerDocument, options);
        }
// @ts-ignore
export function useGetPartnerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPartnerQuery, GetPartnerQueryVariables>): Apollo.UseSuspenseQueryResult<GetPartnerQuery, GetPartnerQueryVariables>;
export function useGetPartnerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPartnerQuery, GetPartnerQueryVariables>): Apollo.UseSuspenseQueryResult<GetPartnerQuery | undefined, GetPartnerQueryVariables>;
export function useGetPartnerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPartnerQuery, GetPartnerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPartnerQuery, GetPartnerQueryVariables>(GetPartnerDocument, options);
        }
export type GetPartnerQueryHookResult = ReturnType<typeof useGetPartnerQuery>;
export type GetPartnerLazyQueryHookResult = ReturnType<typeof useGetPartnerLazyQuery>;
export type GetPartnerSuspenseQueryHookResult = ReturnType<typeof useGetPartnerSuspenseQuery>;
export type GetPartnerQueryResult = Apollo.QueryResult<GetPartnerQuery, GetPartnerQueryVariables>;
export const GetPlatformFeeConfigsDocument = gql`
    query GetPlatformFeeConfigs($filter: [FilterGroup!], $limit: Int!, $locationId: String, $page: Int!, $sort: [SortCondition!]) {
  getPlatformFeeConfigs(
    filter: $filter
    limit: $limit
    locationId: $locationId
    page: $page
    sort: $sort
  ) {
    data {
      createdAt
      id
      name
      orderType
      platformFeeAccountCode
      platformFeeTaxRate
      platformFeeTaxable
      platformFeeType
      platformFeeValue
      updatedAt
      status
      isRemovable
    }
    meta {
      limit
      page
      total
      totalCount
    }
  }
}
    `;

/**
 * __useGetPlatformFeeConfigsQuery__
 *
 * To run a query within a React component, call `useGetPlatformFeeConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlatformFeeConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlatformFeeConfigsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      locationId: // value for 'locationId'
 *      page: // value for 'page'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetPlatformFeeConfigsQuery(baseOptions: Apollo.QueryHookOptions<GetPlatformFeeConfigsQuery, GetPlatformFeeConfigsQueryVariables> & ({ variables: GetPlatformFeeConfigsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlatformFeeConfigsQuery, GetPlatformFeeConfigsQueryVariables>(GetPlatformFeeConfigsDocument, options);
      }
export function useGetPlatformFeeConfigsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlatformFeeConfigsQuery, GetPlatformFeeConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlatformFeeConfigsQuery, GetPlatformFeeConfigsQueryVariables>(GetPlatformFeeConfigsDocument, options);
        }
// @ts-ignore
export function useGetPlatformFeeConfigsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPlatformFeeConfigsQuery, GetPlatformFeeConfigsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPlatformFeeConfigsQuery, GetPlatformFeeConfigsQueryVariables>;
export function useGetPlatformFeeConfigsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlatformFeeConfigsQuery, GetPlatformFeeConfigsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPlatformFeeConfigsQuery | undefined, GetPlatformFeeConfigsQueryVariables>;
export function useGetPlatformFeeConfigsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlatformFeeConfigsQuery, GetPlatformFeeConfigsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPlatformFeeConfigsQuery, GetPlatformFeeConfigsQueryVariables>(GetPlatformFeeConfigsDocument, options);
        }
export type GetPlatformFeeConfigsQueryHookResult = ReturnType<typeof useGetPlatformFeeConfigsQuery>;
export type GetPlatformFeeConfigsLazyQueryHookResult = ReturnType<typeof useGetPlatformFeeConfigsLazyQuery>;
export type GetPlatformFeeConfigsSuspenseQueryHookResult = ReturnType<typeof useGetPlatformFeeConfigsSuspenseQuery>;
export type GetPlatformFeeConfigsQueryResult = Apollo.QueryResult<GetPlatformFeeConfigsQuery, GetPlatformFeeConfigsQueryVariables>;
export const GetPlatformFeeConfigDocument = gql`
    query GetPlatformFeeConfig($getPlatformFeeConfigId: String!) {
  getPlatformFeeConfig(id: $getPlatformFeeConfigId) {
    createdAt
    id
    name
    orderType
    platformFeeAccountCode
    platformFeeTaxRate
    platformFeeTaxable
    platformFeeType
    platformFeeValue
    updatedAt
    status
    isRemovable
  }
}
    `;

/**
 * __useGetPlatformFeeConfigQuery__
 *
 * To run a query within a React component, call `useGetPlatformFeeConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlatformFeeConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlatformFeeConfigQuery({
 *   variables: {
 *      getPlatformFeeConfigId: // value for 'getPlatformFeeConfigId'
 *   },
 * });
 */
export function useGetPlatformFeeConfigQuery(baseOptions: Apollo.QueryHookOptions<GetPlatformFeeConfigQuery, GetPlatformFeeConfigQueryVariables> & ({ variables: GetPlatformFeeConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlatformFeeConfigQuery, GetPlatformFeeConfigQueryVariables>(GetPlatformFeeConfigDocument, options);
      }
export function useGetPlatformFeeConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlatformFeeConfigQuery, GetPlatformFeeConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlatformFeeConfigQuery, GetPlatformFeeConfigQueryVariables>(GetPlatformFeeConfigDocument, options);
        }
// @ts-ignore
export function useGetPlatformFeeConfigSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPlatformFeeConfigQuery, GetPlatformFeeConfigQueryVariables>): Apollo.UseSuspenseQueryResult<GetPlatformFeeConfigQuery, GetPlatformFeeConfigQueryVariables>;
export function useGetPlatformFeeConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlatformFeeConfigQuery, GetPlatformFeeConfigQueryVariables>): Apollo.UseSuspenseQueryResult<GetPlatformFeeConfigQuery | undefined, GetPlatformFeeConfigQueryVariables>;
export function useGetPlatformFeeConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlatformFeeConfigQuery, GetPlatformFeeConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPlatformFeeConfigQuery, GetPlatformFeeConfigQueryVariables>(GetPlatformFeeConfigDocument, options);
        }
export type GetPlatformFeeConfigQueryHookResult = ReturnType<typeof useGetPlatformFeeConfigQuery>;
export type GetPlatformFeeConfigLazyQueryHookResult = ReturnType<typeof useGetPlatformFeeConfigLazyQuery>;
export type GetPlatformFeeConfigSuspenseQueryHookResult = ReturnType<typeof useGetPlatformFeeConfigSuspenseQuery>;
export type GetPlatformFeeConfigQueryResult = Apollo.QueryResult<GetPlatformFeeConfigQuery, GetPlatformFeeConfigQueryVariables>;
export const CreatePlatformFeeConfigDocument = gql`
    mutation CreatePlatformFeeConfig($createPlatformFeeConfigInput: CreatePlatformFeeConfigDTO!) {
  createPlatformFeeConfig(
    createPlatformFeeConfigInput: $createPlatformFeeConfigInput
  ) {
    id
  }
}
    `;
export type CreatePlatformFeeConfigMutationFn = Apollo.MutationFunction<CreatePlatformFeeConfigMutation, CreatePlatformFeeConfigMutationVariables>;

/**
 * __useCreatePlatformFeeConfigMutation__
 *
 * To run a mutation, you first call `useCreatePlatformFeeConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePlatformFeeConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPlatformFeeConfigMutation, { data, loading, error }] = useCreatePlatformFeeConfigMutation({
 *   variables: {
 *      createPlatformFeeConfigInput: // value for 'createPlatformFeeConfigInput'
 *   },
 * });
 */
export function useCreatePlatformFeeConfigMutation(baseOptions?: Apollo.MutationHookOptions<CreatePlatformFeeConfigMutation, CreatePlatformFeeConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePlatformFeeConfigMutation, CreatePlatformFeeConfigMutationVariables>(CreatePlatformFeeConfigDocument, options);
      }
export type CreatePlatformFeeConfigMutationHookResult = ReturnType<typeof useCreatePlatformFeeConfigMutation>;
export type CreatePlatformFeeConfigMutationResult = Apollo.MutationResult<CreatePlatformFeeConfigMutation>;
export type CreatePlatformFeeConfigMutationOptions = Apollo.BaseMutationOptions<CreatePlatformFeeConfigMutation, CreatePlatformFeeConfigMutationVariables>;
export const UpdatePlatformFeeConfigDocument = gql`
    mutation UpdatePlatformFeeConfig($updatePlatformFeeConfigInput: UpdatePlatformFeeConfigDTO!) {
  updatePlatformFeeConfig(
    updatePlatformFeeConfigInput: $updatePlatformFeeConfigInput
  ) {
    id
  }
}
    `;
export type UpdatePlatformFeeConfigMutationFn = Apollo.MutationFunction<UpdatePlatformFeeConfigMutation, UpdatePlatformFeeConfigMutationVariables>;

/**
 * __useUpdatePlatformFeeConfigMutation__
 *
 * To run a mutation, you first call `useUpdatePlatformFeeConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlatformFeeConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlatformFeeConfigMutation, { data, loading, error }] = useUpdatePlatformFeeConfigMutation({
 *   variables: {
 *      updatePlatformFeeConfigInput: // value for 'updatePlatformFeeConfigInput'
 *   },
 * });
 */
export function useUpdatePlatformFeeConfigMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePlatformFeeConfigMutation, UpdatePlatformFeeConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePlatformFeeConfigMutation, UpdatePlatformFeeConfigMutationVariables>(UpdatePlatformFeeConfigDocument, options);
      }
export type UpdatePlatformFeeConfigMutationHookResult = ReturnType<typeof useUpdatePlatformFeeConfigMutation>;
export type UpdatePlatformFeeConfigMutationResult = Apollo.MutationResult<UpdatePlatformFeeConfigMutation>;
export type UpdatePlatformFeeConfigMutationOptions = Apollo.BaseMutationOptions<UpdatePlatformFeeConfigMutation, UpdatePlatformFeeConfigMutationVariables>;
export const PosHeldOrdersDocument = gql`
    query PosHeldOrders($input: PosHeldOrdersInput!) {
  posHeldOrders(input: $input) {
    meta {
      page
      limit
      totalCount
    }
    data {
      id
      identifier
      heldAt
      customerName
      phone
      totalAmount
      quantity
      locationId
      registerId
      registerSessionId
      snapshot
      createdBy
    }
  }
}
    `;

/**
 * __usePosHeldOrdersQuery__
 *
 * To run a query within a React component, call `usePosHeldOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePosHeldOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePosHeldOrdersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePosHeldOrdersQuery(baseOptions: Apollo.QueryHookOptions<PosHeldOrdersQuery, PosHeldOrdersQueryVariables> & ({ variables: PosHeldOrdersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PosHeldOrdersQuery, PosHeldOrdersQueryVariables>(PosHeldOrdersDocument, options);
      }
export function usePosHeldOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PosHeldOrdersQuery, PosHeldOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PosHeldOrdersQuery, PosHeldOrdersQueryVariables>(PosHeldOrdersDocument, options);
        }
// @ts-ignore
export function usePosHeldOrdersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PosHeldOrdersQuery, PosHeldOrdersQueryVariables>): Apollo.UseSuspenseQueryResult<PosHeldOrdersQuery, PosHeldOrdersQueryVariables>;
export function usePosHeldOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PosHeldOrdersQuery, PosHeldOrdersQueryVariables>): Apollo.UseSuspenseQueryResult<PosHeldOrdersQuery | undefined, PosHeldOrdersQueryVariables>;
export function usePosHeldOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PosHeldOrdersQuery, PosHeldOrdersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PosHeldOrdersQuery, PosHeldOrdersQueryVariables>(PosHeldOrdersDocument, options);
        }
export type PosHeldOrdersQueryHookResult = ReturnType<typeof usePosHeldOrdersQuery>;
export type PosHeldOrdersLazyQueryHookResult = ReturnType<typeof usePosHeldOrdersLazyQuery>;
export type PosHeldOrdersSuspenseQueryHookResult = ReturnType<typeof usePosHeldOrdersSuspenseQuery>;
export type PosHeldOrdersQueryResult = Apollo.QueryResult<PosHeldOrdersQuery, PosHeldOrdersQueryVariables>;
export const HoldPosOrderDocument = gql`
    mutation HoldPosOrder($input: HoldPosOrderInput!) {
  holdPosOrder(input: $input) {
    id
    identifier
    heldAt
    customerName
    phone
    totalAmount
    quantity
    locationId
    registerId
    registerSessionId
  }
}
    `;
export type HoldPosOrderMutationFn = Apollo.MutationFunction<HoldPosOrderMutation, HoldPosOrderMutationVariables>;

/**
 * __useHoldPosOrderMutation__
 *
 * To run a mutation, you first call `useHoldPosOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHoldPosOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [holdPosOrderMutation, { data, loading, error }] = useHoldPosOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHoldPosOrderMutation(baseOptions?: Apollo.MutationHookOptions<HoldPosOrderMutation, HoldPosOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HoldPosOrderMutation, HoldPosOrderMutationVariables>(HoldPosOrderDocument, options);
      }
export type HoldPosOrderMutationHookResult = ReturnType<typeof useHoldPosOrderMutation>;
export type HoldPosOrderMutationResult = Apollo.MutationResult<HoldPosOrderMutation>;
export type HoldPosOrderMutationOptions = Apollo.BaseMutationOptions<HoldPosOrderMutation, HoldPosOrderMutationVariables>;
export const ReleasePosOrderDocument = gql`
    mutation ReleasePosOrder($input: ReleasePosOrderInput!) {
  releasePosOrder(input: $input) {
    snapshot
    releasedOrder {
      id
      identifier
    }
  }
}
    `;
export type ReleasePosOrderMutationFn = Apollo.MutationFunction<ReleasePosOrderMutation, ReleasePosOrderMutationVariables>;

/**
 * __useReleasePosOrderMutation__
 *
 * To run a mutation, you first call `useReleasePosOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReleasePosOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [releasePosOrderMutation, { data, loading, error }] = useReleasePosOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReleasePosOrderMutation(baseOptions?: Apollo.MutationHookOptions<ReleasePosOrderMutation, ReleasePosOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReleasePosOrderMutation, ReleasePosOrderMutationVariables>(ReleasePosOrderDocument, options);
      }
export type ReleasePosOrderMutationHookResult = ReturnType<typeof useReleasePosOrderMutation>;
export type ReleasePosOrderMutationResult = Apollo.MutationResult<ReleasePosOrderMutation>;
export type ReleasePosOrderMutationOptions = Apollo.BaseMutationOptions<ReleasePosOrderMutation, ReleasePosOrderMutationVariables>;
export const CreatePrinterConfigDocument = gql`
    mutation CreatePrinterConfig($createPrinterConfigDto: CreatePrinterConfigDTO!) {
  createPrinterConfig(createPrinterConfigDTO: $createPrinterConfigDto) {
    id
  }
}
    `;
export type CreatePrinterConfigMutationFn = Apollo.MutationFunction<CreatePrinterConfigMutation, CreatePrinterConfigMutationVariables>;

/**
 * __useCreatePrinterConfigMutation__
 *
 * To run a mutation, you first call `useCreatePrinterConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePrinterConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPrinterConfigMutation, { data, loading, error }] = useCreatePrinterConfigMutation({
 *   variables: {
 *      createPrinterConfigDto: // value for 'createPrinterConfigDto'
 *   },
 * });
 */
export function useCreatePrinterConfigMutation(baseOptions?: Apollo.MutationHookOptions<CreatePrinterConfigMutation, CreatePrinterConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePrinterConfigMutation, CreatePrinterConfigMutationVariables>(CreatePrinterConfigDocument, options);
      }
export type CreatePrinterConfigMutationHookResult = ReturnType<typeof useCreatePrinterConfigMutation>;
export type CreatePrinterConfigMutationResult = Apollo.MutationResult<CreatePrinterConfigMutation>;
export type CreatePrinterConfigMutationOptions = Apollo.BaseMutationOptions<CreatePrinterConfigMutation, CreatePrinterConfigMutationVariables>;
export const UpdatePrinterConfigDocument = gql`
    mutation UpdatePrinterConfig($updatePrinterConfigDto: UpdatePrinterConfigDTO!) {
  updatePrinterConfig(updatePrinterConfigDTO: $updatePrinterConfigDto) {
    id
  }
}
    `;
export type UpdatePrinterConfigMutationFn = Apollo.MutationFunction<UpdatePrinterConfigMutation, UpdatePrinterConfigMutationVariables>;

/**
 * __useUpdatePrinterConfigMutation__
 *
 * To run a mutation, you first call `useUpdatePrinterConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePrinterConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePrinterConfigMutation, { data, loading, error }] = useUpdatePrinterConfigMutation({
 *   variables: {
 *      updatePrinterConfigDto: // value for 'updatePrinterConfigDto'
 *   },
 * });
 */
export function useUpdatePrinterConfigMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePrinterConfigMutation, UpdatePrinterConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePrinterConfigMutation, UpdatePrinterConfigMutationVariables>(UpdatePrinterConfigDocument, options);
      }
export type UpdatePrinterConfigMutationHookResult = ReturnType<typeof useUpdatePrinterConfigMutation>;
export type UpdatePrinterConfigMutationResult = Apollo.MutationResult<UpdatePrinterConfigMutation>;
export type UpdatePrinterConfigMutationOptions = Apollo.BaseMutationOptions<UpdatePrinterConfigMutation, UpdatePrinterConfigMutationVariables>;
export const DeletePrinterConfigDocument = gql`
    mutation DeletePrinterConfig($deletePrinterConfigId: String!) {
  deletePrinterConfig(id: $deletePrinterConfigId)
}
    `;
export type DeletePrinterConfigMutationFn = Apollo.MutationFunction<DeletePrinterConfigMutation, DeletePrinterConfigMutationVariables>;

/**
 * __useDeletePrinterConfigMutation__
 *
 * To run a mutation, you first call `useDeletePrinterConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePrinterConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePrinterConfigMutation, { data, loading, error }] = useDeletePrinterConfigMutation({
 *   variables: {
 *      deletePrinterConfigId: // value for 'deletePrinterConfigId'
 *   },
 * });
 */
export function useDeletePrinterConfigMutation(baseOptions?: Apollo.MutationHookOptions<DeletePrinterConfigMutation, DeletePrinterConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePrinterConfigMutation, DeletePrinterConfigMutationVariables>(DeletePrinterConfigDocument, options);
      }
export type DeletePrinterConfigMutationHookResult = ReturnType<typeof useDeletePrinterConfigMutation>;
export type DeletePrinterConfigMutationResult = Apollo.MutationResult<DeletePrinterConfigMutation>;
export type DeletePrinterConfigMutationOptions = Apollo.BaseMutationOptions<DeletePrinterConfigMutation, DeletePrinterConfigMutationVariables>;
export const GetPrinterConfigsDocument = gql`
    query GetPrinterConfigs($sort: [SortCondition!], $filter: [FilterGroup!], $page: Int!, $limit: Int!, $locationId: String) {
  getPrinterConfigs(
    sort: $sort
    filter: $filter
    page: $page
    limit: $limit
    locationId: $locationId
  ) {
    data {
      id
      name
      isDefault
      columns
      columnGap
      labelWidth
      labelHeight
      marginTop
      marginBottom
      marginLeft
      marginRight
      padding
      qrCodeSize
      qrCodeMarginRight
      qrCodeAlignment
      productNameFontSize
      batchNumberFontSize
      expiryFontSize
      textAlignment
      productNameWrap
      productNameMaxLines
      zoom
      orientation
      userId
    }
    meta {
      page
      limit
      totalCount
      total
    }
  }
}
    `;

/**
 * __useGetPrinterConfigsQuery__
 *
 * To run a query within a React component, call `useGetPrinterConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPrinterConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrinterConfigsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useGetPrinterConfigsQuery(baseOptions: Apollo.QueryHookOptions<GetPrinterConfigsQuery, GetPrinterConfigsQueryVariables> & ({ variables: GetPrinterConfigsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPrinterConfigsQuery, GetPrinterConfigsQueryVariables>(GetPrinterConfigsDocument, options);
      }
export function useGetPrinterConfigsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPrinterConfigsQuery, GetPrinterConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPrinterConfigsQuery, GetPrinterConfigsQueryVariables>(GetPrinterConfigsDocument, options);
        }
// @ts-ignore
export function useGetPrinterConfigsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPrinterConfigsQuery, GetPrinterConfigsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPrinterConfigsQuery, GetPrinterConfigsQueryVariables>;
export function useGetPrinterConfigsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPrinterConfigsQuery, GetPrinterConfigsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPrinterConfigsQuery | undefined, GetPrinterConfigsQueryVariables>;
export function useGetPrinterConfigsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPrinterConfigsQuery, GetPrinterConfigsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPrinterConfigsQuery, GetPrinterConfigsQueryVariables>(GetPrinterConfigsDocument, options);
        }
export type GetPrinterConfigsQueryHookResult = ReturnType<typeof useGetPrinterConfigsQuery>;
export type GetPrinterConfigsLazyQueryHookResult = ReturnType<typeof useGetPrinterConfigsLazyQuery>;
export type GetPrinterConfigsSuspenseQueryHookResult = ReturnType<typeof useGetPrinterConfigsSuspenseQuery>;
export type GetPrinterConfigsQueryResult = Apollo.QueryResult<GetPrinterConfigsQuery, GetPrinterConfigsQueryVariables>;
export const GetPrinterConfigDocument = gql`
    query GetPrinterConfig($getPrinterConfigId: String!) {
  getPrinterConfig(id: $getPrinterConfigId) {
    id
    name
    isDefault
    columns
    columnGap
    labelWidth
    labelHeight
    marginTop
    marginBottom
    marginLeft
    marginRight
    padding
    qrCodeSize
    qrCodeMarginRight
    qrCodeAlignment
    productNameFontSize
    batchNumberFontSize
    expiryFontSize
    textAlignment
    productNameWrap
    productNameMaxLines
    zoom
    orientation
    userId
  }
}
    `;

/**
 * __useGetPrinterConfigQuery__
 *
 * To run a query within a React component, call `useGetPrinterConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPrinterConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrinterConfigQuery({
 *   variables: {
 *      getPrinterConfigId: // value for 'getPrinterConfigId'
 *   },
 * });
 */
export function useGetPrinterConfigQuery(baseOptions: Apollo.QueryHookOptions<GetPrinterConfigQuery, GetPrinterConfigQueryVariables> & ({ variables: GetPrinterConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPrinterConfigQuery, GetPrinterConfigQueryVariables>(GetPrinterConfigDocument, options);
      }
export function useGetPrinterConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPrinterConfigQuery, GetPrinterConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPrinterConfigQuery, GetPrinterConfigQueryVariables>(GetPrinterConfigDocument, options);
        }
// @ts-ignore
export function useGetPrinterConfigSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPrinterConfigQuery, GetPrinterConfigQueryVariables>): Apollo.UseSuspenseQueryResult<GetPrinterConfigQuery, GetPrinterConfigQueryVariables>;
export function useGetPrinterConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPrinterConfigQuery, GetPrinterConfigQueryVariables>): Apollo.UseSuspenseQueryResult<GetPrinterConfigQuery | undefined, GetPrinterConfigQueryVariables>;
export function useGetPrinterConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPrinterConfigQuery, GetPrinterConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPrinterConfigQuery, GetPrinterConfigQueryVariables>(GetPrinterConfigDocument, options);
        }
export type GetPrinterConfigQueryHookResult = ReturnType<typeof useGetPrinterConfigQuery>;
export type GetPrinterConfigLazyQueryHookResult = ReturnType<typeof useGetPrinterConfigLazyQuery>;
export type GetPrinterConfigSuspenseQueryHookResult = ReturnType<typeof useGetPrinterConfigSuspenseQuery>;
export type GetPrinterConfigQueryResult = Apollo.QueryResult<GetPrinterConfigQuery, GetPrinterConfigQueryVariables>;
export const GetProductManufacturingPricesDocument = gql`
    query GetProductManufacturingPrices($productId: String!) {
  getProductManufacturingPrices(productId: $productId) {
    id
    secondaryId
    productId
    effectiveFrom
    effectiveTo
    tradePriceOutward
    maximumRetailPrice
    taxRate
    updatedAt
  }
}
    `;

/**
 * __useGetProductManufacturingPricesQuery__
 *
 * To run a query within a React component, call `useGetProductManufacturingPricesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductManufacturingPricesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductManufacturingPricesQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useGetProductManufacturingPricesQuery(baseOptions: Apollo.QueryHookOptions<GetProductManufacturingPricesQuery, GetProductManufacturingPricesQueryVariables> & ({ variables: GetProductManufacturingPricesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductManufacturingPricesQuery, GetProductManufacturingPricesQueryVariables>(GetProductManufacturingPricesDocument, options);
      }
export function useGetProductManufacturingPricesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductManufacturingPricesQuery, GetProductManufacturingPricesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductManufacturingPricesQuery, GetProductManufacturingPricesQueryVariables>(GetProductManufacturingPricesDocument, options);
        }
// @ts-ignore
export function useGetProductManufacturingPricesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductManufacturingPricesQuery, GetProductManufacturingPricesQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductManufacturingPricesQuery, GetProductManufacturingPricesQueryVariables>;
export function useGetProductManufacturingPricesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductManufacturingPricesQuery, GetProductManufacturingPricesQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductManufacturingPricesQuery | undefined, GetProductManufacturingPricesQueryVariables>;
export function useGetProductManufacturingPricesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductManufacturingPricesQuery, GetProductManufacturingPricesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductManufacturingPricesQuery, GetProductManufacturingPricesQueryVariables>(GetProductManufacturingPricesDocument, options);
        }
export type GetProductManufacturingPricesQueryHookResult = ReturnType<typeof useGetProductManufacturingPricesQuery>;
export type GetProductManufacturingPricesLazyQueryHookResult = ReturnType<typeof useGetProductManufacturingPricesLazyQuery>;
export type GetProductManufacturingPricesSuspenseQueryHookResult = ReturnType<typeof useGetProductManufacturingPricesSuspenseQuery>;
export type GetProductManufacturingPricesQueryResult = Apollo.QueryResult<GetProductManufacturingPricesQuery, GetProductManufacturingPricesQueryVariables>;
export const CreateProductManufacturingPriceDocument = gql`
    mutation CreateProductManufacturingPrice($input: CreateProductManufacturingPriceDTO!) {
  createProductManufacturingPrice(input: $input) {
    id
    effectiveFrom
    effectiveTo
  }
}
    `;
export type CreateProductManufacturingPriceMutationFn = Apollo.MutationFunction<CreateProductManufacturingPriceMutation, CreateProductManufacturingPriceMutationVariables>;

/**
 * __useCreateProductManufacturingPriceMutation__
 *
 * To run a mutation, you first call `useCreateProductManufacturingPriceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductManufacturingPriceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductManufacturingPriceMutation, { data, loading, error }] = useCreateProductManufacturingPriceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProductManufacturingPriceMutation(baseOptions?: Apollo.MutationHookOptions<CreateProductManufacturingPriceMutation, CreateProductManufacturingPriceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProductManufacturingPriceMutation, CreateProductManufacturingPriceMutationVariables>(CreateProductManufacturingPriceDocument, options);
      }
export type CreateProductManufacturingPriceMutationHookResult = ReturnType<typeof useCreateProductManufacturingPriceMutation>;
export type CreateProductManufacturingPriceMutationResult = Apollo.MutationResult<CreateProductManufacturingPriceMutation>;
export type CreateProductManufacturingPriceMutationOptions = Apollo.BaseMutationOptions<CreateProductManufacturingPriceMutation, CreateProductManufacturingPriceMutationVariables>;
export const UpdateProductManufacturingPriceDocument = gql`
    mutation UpdateProductManufacturingPrice($input: UpdateProductManufacturingPriceDTO!) {
  updateProductManufacturingPrice(input: $input) {
    id
    effectiveFrom
    effectiveTo
  }
}
    `;
export type UpdateProductManufacturingPriceMutationFn = Apollo.MutationFunction<UpdateProductManufacturingPriceMutation, UpdateProductManufacturingPriceMutationVariables>;

/**
 * __useUpdateProductManufacturingPriceMutation__
 *
 * To run a mutation, you first call `useUpdateProductManufacturingPriceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductManufacturingPriceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductManufacturingPriceMutation, { data, loading, error }] = useUpdateProductManufacturingPriceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProductManufacturingPriceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductManufacturingPriceMutation, UpdateProductManufacturingPriceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductManufacturingPriceMutation, UpdateProductManufacturingPriceMutationVariables>(UpdateProductManufacturingPriceDocument, options);
      }
export type UpdateProductManufacturingPriceMutationHookResult = ReturnType<typeof useUpdateProductManufacturingPriceMutation>;
export type UpdateProductManufacturingPriceMutationResult = Apollo.MutationResult<UpdateProductManufacturingPriceMutation>;
export type UpdateProductManufacturingPriceMutationOptions = Apollo.BaseMutationOptions<UpdateProductManufacturingPriceMutation, UpdateProductManufacturingPriceMutationVariables>;
export const ProductSummaryDocument = gql`
    query ProductSummary {
  productSummary {
    totalProductsCount
    activeProductsCount
    inactiveProductsCount
  }
}
    `;

/**
 * __useProductSummaryQuery__
 *
 * To run a query within a React component, call `useProductSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductSummaryQuery(baseOptions?: Apollo.QueryHookOptions<ProductSummaryQuery, ProductSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductSummaryQuery, ProductSummaryQueryVariables>(ProductSummaryDocument, options);
      }
export function useProductSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductSummaryQuery, ProductSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductSummaryQuery, ProductSummaryQueryVariables>(ProductSummaryDocument, options);
        }
// @ts-ignore
export function useProductSummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProductSummaryQuery, ProductSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<ProductSummaryQuery, ProductSummaryQueryVariables>;
export function useProductSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductSummaryQuery, ProductSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<ProductSummaryQuery | undefined, ProductSummaryQueryVariables>;
export function useProductSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductSummaryQuery, ProductSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductSummaryQuery, ProductSummaryQueryVariables>(ProductSummaryDocument, options);
        }
export type ProductSummaryQueryHookResult = ReturnType<typeof useProductSummaryQuery>;
export type ProductSummaryLazyQueryHookResult = ReturnType<typeof useProductSummaryLazyQuery>;
export type ProductSummarySuspenseQueryHookResult = ReturnType<typeof useProductSummarySuspenseQuery>;
export type ProductSummaryQueryResult = Apollo.QueryResult<ProductSummaryQuery, ProductSummaryQueryVariables>;
export const GetTaxGroupsDocument = gql`
    query GetTaxGroups($limit: Int!, $sort: [SortCondition!], $page: Int!, $filter: [FilterGroup!]) {
  getTaxGroups(limit: $limit, sort: $sort, page: $page, filter: $filter) {
    data {
      id
      name
      taxPercentage
    }
  }
}
    `;

/**
 * __useGetTaxGroupsQuery__
 *
 * To run a query within a React component, call `useGetTaxGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaxGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaxGroupsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetTaxGroupsQuery(baseOptions: Apollo.QueryHookOptions<GetTaxGroupsQuery, GetTaxGroupsQueryVariables> & ({ variables: GetTaxGroupsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaxGroupsQuery, GetTaxGroupsQueryVariables>(GetTaxGroupsDocument, options);
      }
export function useGetTaxGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaxGroupsQuery, GetTaxGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaxGroupsQuery, GetTaxGroupsQueryVariables>(GetTaxGroupsDocument, options);
        }
// @ts-ignore
export function useGetTaxGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTaxGroupsQuery, GetTaxGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTaxGroupsQuery, GetTaxGroupsQueryVariables>;
export function useGetTaxGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTaxGroupsQuery, GetTaxGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTaxGroupsQuery | undefined, GetTaxGroupsQueryVariables>;
export function useGetTaxGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTaxGroupsQuery, GetTaxGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTaxGroupsQuery, GetTaxGroupsQueryVariables>(GetTaxGroupsDocument, options);
        }
export type GetTaxGroupsQueryHookResult = ReturnType<typeof useGetTaxGroupsQuery>;
export type GetTaxGroupsLazyQueryHookResult = ReturnType<typeof useGetTaxGroupsLazyQuery>;
export type GetTaxGroupsSuspenseQueryHookResult = ReturnType<typeof useGetTaxGroupsSuspenseQuery>;
export type GetTaxGroupsQueryResult = Apollo.QueryResult<GetTaxGroupsQuery, GetTaxGroupsQueryVariables>;
export const CreateTaxGroupDocument = gql`
    mutation CreateTaxGroup($createTaxGroupDto: CreateTaxGroupDTO!) {
  createTaxGroup(createTaxGroupDTO: $createTaxGroupDto) {
    id
    name
    taxPercentage
  }
}
    `;
export type CreateTaxGroupMutationFn = Apollo.MutationFunction<CreateTaxGroupMutation, CreateTaxGroupMutationVariables>;

/**
 * __useCreateTaxGroupMutation__
 *
 * To run a mutation, you first call `useCreateTaxGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaxGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaxGroupMutation, { data, loading, error }] = useCreateTaxGroupMutation({
 *   variables: {
 *      createTaxGroupDto: // value for 'createTaxGroupDto'
 *   },
 * });
 */
export function useCreateTaxGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateTaxGroupMutation, CreateTaxGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTaxGroupMutation, CreateTaxGroupMutationVariables>(CreateTaxGroupDocument, options);
      }
export type CreateTaxGroupMutationHookResult = ReturnType<typeof useCreateTaxGroupMutation>;
export type CreateTaxGroupMutationResult = Apollo.MutationResult<CreateTaxGroupMutation>;
export type CreateTaxGroupMutationOptions = Apollo.BaseMutationOptions<CreateTaxGroupMutation, CreateTaxGroupMutationVariables>;
export const GetGenericFormulasDocument = gql`
    query GetGenericFormulas($limit: Int!, $sort: [SortCondition!], $filter: [FilterGroup!]) {
  getGenericFormulas(limit: $limit, sort: $sort, filter: $filter) {
    data {
      id
      name
      status
    }
    meta {
      limit
      page
      totalCount
    }
  }
}
    `;

/**
 * __useGetGenericFormulasQuery__
 *
 * To run a query within a React component, call `useGetGenericFormulasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGenericFormulasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGenericFormulasQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetGenericFormulasQuery(baseOptions: Apollo.QueryHookOptions<GetGenericFormulasQuery, GetGenericFormulasQueryVariables> & ({ variables: GetGenericFormulasQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGenericFormulasQuery, GetGenericFormulasQueryVariables>(GetGenericFormulasDocument, options);
      }
export function useGetGenericFormulasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGenericFormulasQuery, GetGenericFormulasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGenericFormulasQuery, GetGenericFormulasQueryVariables>(GetGenericFormulasDocument, options);
        }
// @ts-ignore
export function useGetGenericFormulasSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGenericFormulasQuery, GetGenericFormulasQueryVariables>): Apollo.UseSuspenseQueryResult<GetGenericFormulasQuery, GetGenericFormulasQueryVariables>;
export function useGetGenericFormulasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGenericFormulasQuery, GetGenericFormulasQueryVariables>): Apollo.UseSuspenseQueryResult<GetGenericFormulasQuery | undefined, GetGenericFormulasQueryVariables>;
export function useGetGenericFormulasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGenericFormulasQuery, GetGenericFormulasQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGenericFormulasQuery, GetGenericFormulasQueryVariables>(GetGenericFormulasDocument, options);
        }
export type GetGenericFormulasQueryHookResult = ReturnType<typeof useGetGenericFormulasQuery>;
export type GetGenericFormulasLazyQueryHookResult = ReturnType<typeof useGetGenericFormulasLazyQuery>;
export type GetGenericFormulasSuspenseQueryHookResult = ReturnType<typeof useGetGenericFormulasSuspenseQuery>;
export type GetGenericFormulasQueryResult = Apollo.QueryResult<GetGenericFormulasQuery, GetGenericFormulasQueryVariables>;
export const CreateGenericFormulaDocument = gql`
    mutation CreateGenericFormula($createGenericFormulaDto: CreateGenericFormulaDTO!) {
  createGenericFormula(createGenericFormulaDTO: $createGenericFormulaDto) {
    id
    name
    status
  }
}
    `;
export type CreateGenericFormulaMutationFn = Apollo.MutationFunction<CreateGenericFormulaMutation, CreateGenericFormulaMutationVariables>;

/**
 * __useCreateGenericFormulaMutation__
 *
 * To run a mutation, you first call `useCreateGenericFormulaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGenericFormulaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGenericFormulaMutation, { data, loading, error }] = useCreateGenericFormulaMutation({
 *   variables: {
 *      createGenericFormulaDto: // value for 'createGenericFormulaDto'
 *   },
 * });
 */
export function useCreateGenericFormulaMutation(baseOptions?: Apollo.MutationHookOptions<CreateGenericFormulaMutation, CreateGenericFormulaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGenericFormulaMutation, CreateGenericFormulaMutationVariables>(CreateGenericFormulaDocument, options);
      }
export type CreateGenericFormulaMutationHookResult = ReturnType<typeof useCreateGenericFormulaMutation>;
export type CreateGenericFormulaMutationResult = Apollo.MutationResult<CreateGenericFormulaMutation>;
export type CreateGenericFormulaMutationOptions = Apollo.BaseMutationOptions<CreateGenericFormulaMutation, CreateGenericFormulaMutationVariables>;
export const CreateProductDocument = gql`
    mutation CreateProduct($createProductDto: CreateProductDTO!) {
  createProduct(createProductDTO: $createProductDto) {
    id
    name
  }
}
    `;
export type CreateProductMutationFn = Apollo.MutationFunction<CreateProductMutation, CreateProductMutationVariables>;

/**
 * __useCreateProductMutation__
 *
 * To run a mutation, you first call `useCreateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductMutation, { data, loading, error }] = useCreateProductMutation({
 *   variables: {
 *      createProductDto: // value for 'createProductDto'
 *   },
 * });
 */
export function useCreateProductMutation(baseOptions?: Apollo.MutationHookOptions<CreateProductMutation, CreateProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProductMutation, CreateProductMutationVariables>(CreateProductDocument, options);
      }
export type CreateProductMutationHookResult = ReturnType<typeof useCreateProductMutation>;
export type CreateProductMutationResult = Apollo.MutationResult<CreateProductMutation>;
export type CreateProductMutationOptions = Apollo.BaseMutationOptions<CreateProductMutation, CreateProductMutationVariables>;
export const UpdateProductDocument = gql`
    mutation UpdateProduct($updateProductDto: UpdateProductDTO!) {
  updateProduct(updateProductDTO: $updateProductDto) {
    id
    name
    gtin
    trackingLevel
    isManufacturerTracking
  }
}
    `;
export type UpdateProductMutationFn = Apollo.MutationFunction<UpdateProductMutation, UpdateProductMutationVariables>;

/**
 * __useUpdateProductMutation__
 *
 * To run a mutation, you first call `useUpdateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductMutation, { data, loading, error }] = useUpdateProductMutation({
 *   variables: {
 *      updateProductDto: // value for 'updateProductDto'
 *   },
 * });
 */
export function useUpdateProductMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductMutation, UpdateProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductMutation, UpdateProductMutationVariables>(UpdateProductDocument, options);
      }
export type UpdateProductMutationHookResult = ReturnType<typeof useUpdateProductMutation>;
export type UpdateProductMutationResult = Apollo.MutationResult<UpdateProductMutation>;
export type UpdateProductMutationOptions = Apollo.BaseMutationOptions<UpdateProductMutation, UpdateProductMutationVariables>;
export const GetProductsListingDocument = gql`
    query GetProductsListing($sort: [SortCondition!], $page: Int!, $limit: Int!, $locationId: String, $filter: [FilterGroup!]) {
  getProducts(
    sort: $sort
    page: $page
    limit: $limit
    locationId: $locationId
    filter: $filter
  ) {
    data {
      id
      secondaryId
      itemReleaseChannels
      maximumRetailPrice
      maximumRetailUnitPrice
      name
      status
      tradePrice
      purchasingPrice
      activeLotsCount
      images
      manufacturer {
        id
        name
      }
    }
    meta {
      limit
      page
      totalCount
    }
  }
}
    `;

/**
 * __useGetProductsListingQuery__
 *
 * To run a query within a React component, call `useGetProductsListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsListingQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      locationId: // value for 'locationId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetProductsListingQuery(baseOptions: Apollo.QueryHookOptions<GetProductsListingQuery, GetProductsListingQueryVariables> & ({ variables: GetProductsListingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductsListingQuery, GetProductsListingQueryVariables>(GetProductsListingDocument, options);
      }
export function useGetProductsListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductsListingQuery, GetProductsListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductsListingQuery, GetProductsListingQueryVariables>(GetProductsListingDocument, options);
        }
// @ts-ignore
export function useGetProductsListingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductsListingQuery, GetProductsListingQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductsListingQuery, GetProductsListingQueryVariables>;
export function useGetProductsListingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductsListingQuery, GetProductsListingQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductsListingQuery | undefined, GetProductsListingQueryVariables>;
export function useGetProductsListingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductsListingQuery, GetProductsListingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductsListingQuery, GetProductsListingQueryVariables>(GetProductsListingDocument, options);
        }
export type GetProductsListingQueryHookResult = ReturnType<typeof useGetProductsListingQuery>;
export type GetProductsListingLazyQueryHookResult = ReturnType<typeof useGetProductsListingLazyQuery>;
export type GetProductsListingSuspenseQueryHookResult = ReturnType<typeof useGetProductsListingSuspenseQuery>;
export type GetProductsListingQueryResult = Apollo.QueryResult<GetProductsListingQuery, GetProductsListingQueryVariables>;
export const GetSearchProductForPoDocument = gql`
    query GetSearchProductForPO($sort: [SortCondition!], $page: Int!, $limit: Int!, $locationId: String, $filter: [FilterGroup!]) {
  getProducts(
    sort: $sort
    page: $page
    limit: $limit
    filter: $filter
    locationId: $locationId
  ) {
    data {
      id
      name
      vendors {
        id
        name
      }
    }
    meta {
      limit
      page
      totalCount
    }
  }
}
    `;

/**
 * __useGetSearchProductForPoQuery__
 *
 * To run a query within a React component, call `useGetSearchProductForPoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchProductForPoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchProductForPoQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      locationId: // value for 'locationId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetSearchProductForPoQuery(baseOptions: Apollo.QueryHookOptions<GetSearchProductForPoQuery, GetSearchProductForPoQueryVariables> & ({ variables: GetSearchProductForPoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchProductForPoQuery, GetSearchProductForPoQueryVariables>(GetSearchProductForPoDocument, options);
      }
export function useGetSearchProductForPoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchProductForPoQuery, GetSearchProductForPoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchProductForPoQuery, GetSearchProductForPoQueryVariables>(GetSearchProductForPoDocument, options);
        }
// @ts-ignore
export function useGetSearchProductForPoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSearchProductForPoQuery, GetSearchProductForPoQueryVariables>): Apollo.UseSuspenseQueryResult<GetSearchProductForPoQuery, GetSearchProductForPoQueryVariables>;
export function useGetSearchProductForPoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSearchProductForPoQuery, GetSearchProductForPoQueryVariables>): Apollo.UseSuspenseQueryResult<GetSearchProductForPoQuery | undefined, GetSearchProductForPoQueryVariables>;
export function useGetSearchProductForPoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSearchProductForPoQuery, GetSearchProductForPoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSearchProductForPoQuery, GetSearchProductForPoQueryVariables>(GetSearchProductForPoDocument, options);
        }
export type GetSearchProductForPoQueryHookResult = ReturnType<typeof useGetSearchProductForPoQuery>;
export type GetSearchProductForPoLazyQueryHookResult = ReturnType<typeof useGetSearchProductForPoLazyQuery>;
export type GetSearchProductForPoSuspenseQueryHookResult = ReturnType<typeof useGetSearchProductForPoSuspenseQuery>;
export type GetSearchProductForPoQueryResult = Apollo.QueryResult<GetSearchProductForPoQuery, GetSearchProductForPoQueryVariables>;
export const GetProductsForOptionsDocument = gql`
    query GetProductsForOptions($sort: [SortCondition!], $page: Int!, $limit: Int!, $filter: [FilterGroup!], $locationId: String) {
  getProducts(
    sort: $sort
    page: $page
    limit: $limit
    filter: $filter
    locationId: $locationId
  ) {
    data {
      id
      secondaryId
      name
      maximumRetailUnitPrice
      sellingUnit
    }
    meta {
      limit
      page
      totalCount
    }
  }
}
    `;

/**
 * __useGetProductsForOptionsQuery__
 *
 * To run a query within a React component, call `useGetProductsForOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsForOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsForOptionsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useGetProductsForOptionsQuery(baseOptions: Apollo.QueryHookOptions<GetProductsForOptionsQuery, GetProductsForOptionsQueryVariables> & ({ variables: GetProductsForOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductsForOptionsQuery, GetProductsForOptionsQueryVariables>(GetProductsForOptionsDocument, options);
      }
export function useGetProductsForOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductsForOptionsQuery, GetProductsForOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductsForOptionsQuery, GetProductsForOptionsQueryVariables>(GetProductsForOptionsDocument, options);
        }
// @ts-ignore
export function useGetProductsForOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductsForOptionsQuery, GetProductsForOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductsForOptionsQuery, GetProductsForOptionsQueryVariables>;
export function useGetProductsForOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductsForOptionsQuery, GetProductsForOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductsForOptionsQuery | undefined, GetProductsForOptionsQueryVariables>;
export function useGetProductsForOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductsForOptionsQuery, GetProductsForOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductsForOptionsQuery, GetProductsForOptionsQueryVariables>(GetProductsForOptionsDocument, options);
        }
export type GetProductsForOptionsQueryHookResult = ReturnType<typeof useGetProductsForOptionsQuery>;
export type GetProductsForOptionsLazyQueryHookResult = ReturnType<typeof useGetProductsForOptionsLazyQuery>;
export type GetProductsForOptionsSuspenseQueryHookResult = ReturnType<typeof useGetProductsForOptionsSuspenseQuery>;
export type GetProductsForOptionsQueryResult = Apollo.QueryResult<GetProductsForOptionsQuery, GetProductsForOptionsQueryVariables>;
export const GetProductsWithTagsDocument = gql`
    query GetProductsWithTags($sort: [SortCondition!], $page: Int!, $limit: Int!, $filter: [FilterGroup!], $locationId: String) {
  getProducts(
    sort: $sort
    page: $page
    limit: $limit
    filter: $filter
    locationId: $locationId
  ) {
    data {
      id
      secondaryId
      name
      maximumRetailUnitPrice
      tags {
        id
        name
      }
    }
    meta {
      limit
      page
      totalCount
    }
  }
}
    `;

/**
 * __useGetProductsWithTagsQuery__
 *
 * To run a query within a React component, call `useGetProductsWithTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsWithTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsWithTagsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useGetProductsWithTagsQuery(baseOptions: Apollo.QueryHookOptions<GetProductsWithTagsQuery, GetProductsWithTagsQueryVariables> & ({ variables: GetProductsWithTagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductsWithTagsQuery, GetProductsWithTagsQueryVariables>(GetProductsWithTagsDocument, options);
      }
export function useGetProductsWithTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductsWithTagsQuery, GetProductsWithTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductsWithTagsQuery, GetProductsWithTagsQueryVariables>(GetProductsWithTagsDocument, options);
        }
// @ts-ignore
export function useGetProductsWithTagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductsWithTagsQuery, GetProductsWithTagsQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductsWithTagsQuery, GetProductsWithTagsQueryVariables>;
export function useGetProductsWithTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductsWithTagsQuery, GetProductsWithTagsQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductsWithTagsQuery | undefined, GetProductsWithTagsQueryVariables>;
export function useGetProductsWithTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductsWithTagsQuery, GetProductsWithTagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductsWithTagsQuery, GetProductsWithTagsQueryVariables>(GetProductsWithTagsDocument, options);
        }
export type GetProductsWithTagsQueryHookResult = ReturnType<typeof useGetProductsWithTagsQuery>;
export type GetProductsWithTagsLazyQueryHookResult = ReturnType<typeof useGetProductsWithTagsLazyQuery>;
export type GetProductsWithTagsSuspenseQueryHookResult = ReturnType<typeof useGetProductsWithTagsSuspenseQuery>;
export type GetProductsWithTagsQueryResult = Apollo.QueryResult<GetProductsWithTagsQuery, GetProductsWithTagsQueryVariables>;
export const GetProductsIdOnlyDocument = gql`
    query GetProductsIdOnly($sort: [SortCondition!], $page: Int!, $limit: Int!, $filter: [FilterGroup!], $locationId: String) {
  getProducts(
    sort: $sort
    page: $page
    limit: $limit
    filter: $filter
    locationId: $locationId
  ) {
    data {
      id
      secondaryId
      name
      purchasingPrice
    }
    meta {
      totalCount
    }
  }
}
    `;

/**
 * __useGetProductsIdOnlyQuery__
 *
 * To run a query within a React component, call `useGetProductsIdOnlyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsIdOnlyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsIdOnlyQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useGetProductsIdOnlyQuery(baseOptions: Apollo.QueryHookOptions<GetProductsIdOnlyQuery, GetProductsIdOnlyQueryVariables> & ({ variables: GetProductsIdOnlyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductsIdOnlyQuery, GetProductsIdOnlyQueryVariables>(GetProductsIdOnlyDocument, options);
      }
export function useGetProductsIdOnlyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductsIdOnlyQuery, GetProductsIdOnlyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductsIdOnlyQuery, GetProductsIdOnlyQueryVariables>(GetProductsIdOnlyDocument, options);
        }
// @ts-ignore
export function useGetProductsIdOnlySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductsIdOnlyQuery, GetProductsIdOnlyQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductsIdOnlyQuery, GetProductsIdOnlyQueryVariables>;
export function useGetProductsIdOnlySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductsIdOnlyQuery, GetProductsIdOnlyQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductsIdOnlyQuery | undefined, GetProductsIdOnlyQueryVariables>;
export function useGetProductsIdOnlySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductsIdOnlyQuery, GetProductsIdOnlyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductsIdOnlyQuery, GetProductsIdOnlyQueryVariables>(GetProductsIdOnlyDocument, options);
        }
export type GetProductsIdOnlyQueryHookResult = ReturnType<typeof useGetProductsIdOnlyQuery>;
export type GetProductsIdOnlyLazyQueryHookResult = ReturnType<typeof useGetProductsIdOnlyLazyQuery>;
export type GetProductsIdOnlySuspenseQueryHookResult = ReturnType<typeof useGetProductsIdOnlySuspenseQuery>;
export type GetProductsIdOnlyQueryResult = Apollo.QueryResult<GetProductsIdOnlyQuery, GetProductsIdOnlyQueryVariables>;
export const GetProductsByVendorDocument = gql`
    query GetProductsByVendor($limit: Int!, $page: Int!, $vendorId: String!) {
  getProductsByVendor(limit: $limit, page: $page, vendorId: $vendorId) {
    data {
      id
      secondaryId
      name
      tradePrice
      tradeDiscount
      buyingUnit
      isManufacturerTracking
      trackingLevel
      manufacturer {
        id
        name
      }
      taxGroup {
        taxPercentage
        name
        id
      }
    }
  }
}
    `;

/**
 * __useGetProductsByVendorQuery__
 *
 * To run a query within a React component, call `useGetProductsByVendorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsByVendorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsByVendorQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useGetProductsByVendorQuery(baseOptions: Apollo.QueryHookOptions<GetProductsByVendorQuery, GetProductsByVendorQueryVariables> & ({ variables: GetProductsByVendorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductsByVendorQuery, GetProductsByVendorQueryVariables>(GetProductsByVendorDocument, options);
      }
export function useGetProductsByVendorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductsByVendorQuery, GetProductsByVendorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductsByVendorQuery, GetProductsByVendorQueryVariables>(GetProductsByVendorDocument, options);
        }
// @ts-ignore
export function useGetProductsByVendorSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductsByVendorQuery, GetProductsByVendorQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductsByVendorQuery, GetProductsByVendorQueryVariables>;
export function useGetProductsByVendorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductsByVendorQuery, GetProductsByVendorQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductsByVendorQuery | undefined, GetProductsByVendorQueryVariables>;
export function useGetProductsByVendorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductsByVendorQuery, GetProductsByVendorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductsByVendorQuery, GetProductsByVendorQueryVariables>(GetProductsByVendorDocument, options);
        }
export type GetProductsByVendorQueryHookResult = ReturnType<typeof useGetProductsByVendorQuery>;
export type GetProductsByVendorLazyQueryHookResult = ReturnType<typeof useGetProductsByVendorLazyQuery>;
export type GetProductsByVendorSuspenseQueryHookResult = ReturnType<typeof useGetProductsByVendorSuspenseQuery>;
export type GetProductsByVendorQueryResult = Apollo.QueryResult<GetProductsByVendorQuery, GetProductsByVendorQueryVariables>;
export const GetProductDocument = gql`
    query GetProduct($getProductId: String!) {
  getProduct(id: $getProductId) {
    description
    discountPercentage
    dosageInstruction
    drugRegulatorId
    gtin
    id
    images
    itemNature
    itemReleaseChannels
    lastUpdatedBy
    margins
    maximumRetailPrice
    maximumRetailUnitPrice
    name
    prescriptionRequired
    purchasingPrice
    seoDescription
    seoTitle
    sellingUnit
    buyingUnit
    seoUrl
    sideEffects
    trackingLevel
    isManufacturerTracking
    skuCode
    skuDepartment
    skuMaximumLevel
    skuMinimumLevel
    skuReorderLevel
    skuWarehouseLeadTime
    sorting
    status
    stockNature
    taxCode
    taxGroupId
    tradeDiscount
    tradePrice
    tradePriceOutward
    isDiscountApplicableOnTax
    isTaxInclusive
    sellingTaxRate
    taxGroup {
      id
      name
      status
      taxPercentage
    }
    tags {
      id
      name
      status
    }
    manufacturer {
      description
      id
      lastReason
      lineOfBusiness
      name
      status
    }
    conversions {
      id
      itemConversion
      sellingUnit
      sorting
      productId
    }
    categories {
      banner_image
      categoryIcon
      comment
      description
      id
      imageUrl
      level
      name
      parentId
      status
      parentCategory {
        id
        name
        level
      }
    }
    genericFormula {
      id
      name
      status
    }
    vendors {
      name
      type
      id
    }
    isSellable
    isPurchasable
    isManufacturable
    uomType
    weightGrams
    lengthCm
    widthCm
    heightCm
  }
}
    `;

/**
 * __useGetProductQuery__
 *
 * To run a query within a React component, call `useGetProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductQuery({
 *   variables: {
 *      getProductId: // value for 'getProductId'
 *   },
 * });
 */
export function useGetProductQuery(baseOptions: Apollo.QueryHookOptions<GetProductQuery, GetProductQueryVariables> & ({ variables: GetProductQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductQuery, GetProductQueryVariables>(GetProductDocument, options);
      }
export function useGetProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductQuery, GetProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductQuery, GetProductQueryVariables>(GetProductDocument, options);
        }
// @ts-ignore
export function useGetProductSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductQuery, GetProductQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductQuery, GetProductQueryVariables>;
export function useGetProductSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductQuery, GetProductQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductQuery | undefined, GetProductQueryVariables>;
export function useGetProductSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductQuery, GetProductQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductQuery, GetProductQueryVariables>(GetProductDocument, options);
        }
export type GetProductQueryHookResult = ReturnType<typeof useGetProductQuery>;
export type GetProductLazyQueryHookResult = ReturnType<typeof useGetProductLazyQuery>;
export type GetProductSuspenseQueryHookResult = ReturnType<typeof useGetProductSuspenseQuery>;
export type GetProductQueryResult = Apollo.QueryResult<GetProductQuery, GetProductQueryVariables>;
export const GetProductLotForTransferDocument = gql`
    query GetProductLotForTransfer($locationId: String!, $anyOneActionIds: [String!], $actionId: String) {
  getProductLot(
    locationId: $locationId
    anyOneActionIds: $anyOneActionIds
    actionId: $actionId
  ) {
    isOpened
    status
    id
    status
    baseQuantity
    actionId
    product {
      id
      secondaryId
      name
    }
  }
}
    `;

/**
 * __useGetProductLotForTransferQuery__
 *
 * To run a query within a React component, call `useGetProductLotForTransferQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductLotForTransferQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductLotForTransferQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      anyOneActionIds: // value for 'anyOneActionIds'
 *      actionId: // value for 'actionId'
 *   },
 * });
 */
export function useGetProductLotForTransferQuery(baseOptions: Apollo.QueryHookOptions<GetProductLotForTransferQuery, GetProductLotForTransferQueryVariables> & ({ variables: GetProductLotForTransferQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductLotForTransferQuery, GetProductLotForTransferQueryVariables>(GetProductLotForTransferDocument, options);
      }
export function useGetProductLotForTransferLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductLotForTransferQuery, GetProductLotForTransferQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductLotForTransferQuery, GetProductLotForTransferQueryVariables>(GetProductLotForTransferDocument, options);
        }
// @ts-ignore
export function useGetProductLotForTransferSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductLotForTransferQuery, GetProductLotForTransferQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductLotForTransferQuery, GetProductLotForTransferQueryVariables>;
export function useGetProductLotForTransferSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductLotForTransferQuery, GetProductLotForTransferQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductLotForTransferQuery | undefined, GetProductLotForTransferQueryVariables>;
export function useGetProductLotForTransferSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductLotForTransferQuery, GetProductLotForTransferQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductLotForTransferQuery, GetProductLotForTransferQueryVariables>(GetProductLotForTransferDocument, options);
        }
export type GetProductLotForTransferQueryHookResult = ReturnType<typeof useGetProductLotForTransferQuery>;
export type GetProductLotForTransferLazyQueryHookResult = ReturnType<typeof useGetProductLotForTransferLazyQuery>;
export type GetProductLotForTransferSuspenseQueryHookResult = ReturnType<typeof useGetProductLotForTransferSuspenseQuery>;
export type GetProductLotForTransferQueryResult = Apollo.QueryResult<GetProductLotForTransferQuery, GetProductLotForTransferQueryVariables>;
export const GetBulkProductLotForTransferDocument = gql`
    query GetBulkProductLotForTransfer($locationId: String!, $actionIds: [String!], $anyOneActionIds: [[String!]!]) {
  getBulkProductLots(
    locationId: $locationId
    actionIds: $actionIds
    anyOneActionIds: $anyOneActionIds
  ) {
    errors {
      message
      actionId
    }
    results {
      isOpened
      status
      id
      status
      baseQuantity
      actionId
      product {
        id
        secondaryId
        name
      }
    }
  }
}
    `;

/**
 * __useGetBulkProductLotForTransferQuery__
 *
 * To run a query within a React component, call `useGetBulkProductLotForTransferQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBulkProductLotForTransferQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBulkProductLotForTransferQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      actionIds: // value for 'actionIds'
 *      anyOneActionIds: // value for 'anyOneActionIds'
 *   },
 * });
 */
export function useGetBulkProductLotForTransferQuery(baseOptions: Apollo.QueryHookOptions<GetBulkProductLotForTransferQuery, GetBulkProductLotForTransferQueryVariables> & ({ variables: GetBulkProductLotForTransferQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBulkProductLotForTransferQuery, GetBulkProductLotForTransferQueryVariables>(GetBulkProductLotForTransferDocument, options);
      }
export function useGetBulkProductLotForTransferLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBulkProductLotForTransferQuery, GetBulkProductLotForTransferQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBulkProductLotForTransferQuery, GetBulkProductLotForTransferQueryVariables>(GetBulkProductLotForTransferDocument, options);
        }
// @ts-ignore
export function useGetBulkProductLotForTransferSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBulkProductLotForTransferQuery, GetBulkProductLotForTransferQueryVariables>): Apollo.UseSuspenseQueryResult<GetBulkProductLotForTransferQuery, GetBulkProductLotForTransferQueryVariables>;
export function useGetBulkProductLotForTransferSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBulkProductLotForTransferQuery, GetBulkProductLotForTransferQueryVariables>): Apollo.UseSuspenseQueryResult<GetBulkProductLotForTransferQuery | undefined, GetBulkProductLotForTransferQueryVariables>;
export function useGetBulkProductLotForTransferSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBulkProductLotForTransferQuery, GetBulkProductLotForTransferQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBulkProductLotForTransferQuery, GetBulkProductLotForTransferQueryVariables>(GetBulkProductLotForTransferDocument, options);
        }
export type GetBulkProductLotForTransferQueryHookResult = ReturnType<typeof useGetBulkProductLotForTransferQuery>;
export type GetBulkProductLotForTransferLazyQueryHookResult = ReturnType<typeof useGetBulkProductLotForTransferLazyQuery>;
export type GetBulkProductLotForTransferSuspenseQueryHookResult = ReturnType<typeof useGetBulkProductLotForTransferSuspenseQuery>;
export type GetBulkProductLotForTransferQueryResult = Apollo.QueryResult<GetBulkProductLotForTransferQuery, GetBulkProductLotForTransferQueryVariables>;
export const GetProductLotsForBarcodesDocument = gql`
    query GetProductLotsForBarcodes($locationId: String, $filter: [FilterGroup!], $limit: Int!, $page: Int!, $sort: [SortCondition!]) {
  getProductLots(
    locationId: $locationId
    filter: $filter
    limit: $limit
    page: $page
    sort: $sort
  ) {
    id
    actionId
    batchExpiry
    batchNumber
    mfgDate
    tradePrice
    mrpSellingUnit
    gstValue
    baseQuantity
    sellableQuantity
    grnItem {
      manufacturerCode
    }
    product {
      name
    }
  }
}
    `;

/**
 * __useGetProductLotsForBarcodesQuery__
 *
 * To run a query within a React component, call `useGetProductLotsForBarcodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductLotsForBarcodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductLotsForBarcodesQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetProductLotsForBarcodesQuery(baseOptions: Apollo.QueryHookOptions<GetProductLotsForBarcodesQuery, GetProductLotsForBarcodesQueryVariables> & ({ variables: GetProductLotsForBarcodesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductLotsForBarcodesQuery, GetProductLotsForBarcodesQueryVariables>(GetProductLotsForBarcodesDocument, options);
      }
export function useGetProductLotsForBarcodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductLotsForBarcodesQuery, GetProductLotsForBarcodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductLotsForBarcodesQuery, GetProductLotsForBarcodesQueryVariables>(GetProductLotsForBarcodesDocument, options);
        }
// @ts-ignore
export function useGetProductLotsForBarcodesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductLotsForBarcodesQuery, GetProductLotsForBarcodesQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductLotsForBarcodesQuery, GetProductLotsForBarcodesQueryVariables>;
export function useGetProductLotsForBarcodesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductLotsForBarcodesQuery, GetProductLotsForBarcodesQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductLotsForBarcodesQuery | undefined, GetProductLotsForBarcodesQueryVariables>;
export function useGetProductLotsForBarcodesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductLotsForBarcodesQuery, GetProductLotsForBarcodesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductLotsForBarcodesQuery, GetProductLotsForBarcodesQueryVariables>(GetProductLotsForBarcodesDocument, options);
        }
export type GetProductLotsForBarcodesQueryHookResult = ReturnType<typeof useGetProductLotsForBarcodesQuery>;
export type GetProductLotsForBarcodesLazyQueryHookResult = ReturnType<typeof useGetProductLotsForBarcodesLazyQuery>;
export type GetProductLotsForBarcodesSuspenseQueryHookResult = ReturnType<typeof useGetProductLotsForBarcodesSuspenseQuery>;
export type GetProductLotsForBarcodesQueryResult = Apollo.QueryResult<GetProductLotsForBarcodesQuery, GetProductLotsForBarcodesQueryVariables>;
export const GetProductLotDocument = gql`
    query GetProductLot($actionId: String, $locationId: String!, $anyOneActionIds: [String!]) {
  getProductLot(
    actionId: $actionId
    locationId: $locationId
    anyOneActionIds: $anyOneActionIds
  ) {
    id
    status
    actionId
    purchasingPrice
    mrpSellingUnit
    sellableQuantity
    batchExpiry
    status
    product {
      id
      secondaryId
      name
      maximumRetailPrice
      images
    }
  }
}
    `;

/**
 * __useGetProductLotQuery__
 *
 * To run a query within a React component, call `useGetProductLotQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductLotQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductLotQuery({
 *   variables: {
 *      actionId: // value for 'actionId'
 *      locationId: // value for 'locationId'
 *      anyOneActionIds: // value for 'anyOneActionIds'
 *   },
 * });
 */
export function useGetProductLotQuery(baseOptions: Apollo.QueryHookOptions<GetProductLotQuery, GetProductLotQueryVariables> & ({ variables: GetProductLotQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductLotQuery, GetProductLotQueryVariables>(GetProductLotDocument, options);
      }
export function useGetProductLotLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductLotQuery, GetProductLotQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductLotQuery, GetProductLotQueryVariables>(GetProductLotDocument, options);
        }
// @ts-ignore
export function useGetProductLotSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductLotQuery, GetProductLotQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductLotQuery, GetProductLotQueryVariables>;
export function useGetProductLotSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductLotQuery, GetProductLotQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductLotQuery | undefined, GetProductLotQueryVariables>;
export function useGetProductLotSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductLotQuery, GetProductLotQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductLotQuery, GetProductLotQueryVariables>(GetProductLotDocument, options);
        }
export type GetProductLotQueryHookResult = ReturnType<typeof useGetProductLotQuery>;
export type GetProductLotLazyQueryHookResult = ReturnType<typeof useGetProductLotLazyQuery>;
export type GetProductLotSuspenseQueryHookResult = ReturnType<typeof useGetProductLotSuspenseQuery>;
export type GetProductLotQueryResult = Apollo.QueryResult<GetProductLotQuery, GetProductLotQueryVariables>;
export const BulkValidateProductLotsDocument = gql`
    query BulkValidateProductLots($locationId: String!, $scanProductLots: [ScanProductLotInput!]!) {
  bulkValidateProductLots(
    locationId: $locationId
    scanProductLots: $scanProductLots
  ) {
    id
    status
    actionId
    purchasingPrice
    mrpSellingUnit
    sellableQuantity
    batchExpiry
    cartQuantity
    status
    product {
      id
      secondaryId
      name
      maximumRetailPrice
      images
    }
  }
}
    `;

/**
 * __useBulkValidateProductLotsQuery__
 *
 * To run a query within a React component, call `useBulkValidateProductLotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBulkValidateProductLotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBulkValidateProductLotsQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      scanProductLots: // value for 'scanProductLots'
 *   },
 * });
 */
export function useBulkValidateProductLotsQuery(baseOptions: Apollo.QueryHookOptions<BulkValidateProductLotsQuery, BulkValidateProductLotsQueryVariables> & ({ variables: BulkValidateProductLotsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BulkValidateProductLotsQuery, BulkValidateProductLotsQueryVariables>(BulkValidateProductLotsDocument, options);
      }
export function useBulkValidateProductLotsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BulkValidateProductLotsQuery, BulkValidateProductLotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BulkValidateProductLotsQuery, BulkValidateProductLotsQueryVariables>(BulkValidateProductLotsDocument, options);
        }
// @ts-ignore
export function useBulkValidateProductLotsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BulkValidateProductLotsQuery, BulkValidateProductLotsQueryVariables>): Apollo.UseSuspenseQueryResult<BulkValidateProductLotsQuery, BulkValidateProductLotsQueryVariables>;
export function useBulkValidateProductLotsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BulkValidateProductLotsQuery, BulkValidateProductLotsQueryVariables>): Apollo.UseSuspenseQueryResult<BulkValidateProductLotsQuery | undefined, BulkValidateProductLotsQueryVariables>;
export function useBulkValidateProductLotsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BulkValidateProductLotsQuery, BulkValidateProductLotsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BulkValidateProductLotsQuery, BulkValidateProductLotsQueryVariables>(BulkValidateProductLotsDocument, options);
        }
export type BulkValidateProductLotsQueryHookResult = ReturnType<typeof useBulkValidateProductLotsQuery>;
export type BulkValidateProductLotsLazyQueryHookResult = ReturnType<typeof useBulkValidateProductLotsLazyQuery>;
export type BulkValidateProductLotsSuspenseQueryHookResult = ReturnType<typeof useBulkValidateProductLotsSuspenseQuery>;
export type BulkValidateProductLotsQueryResult = Apollo.QueryResult<BulkValidateProductLotsQuery, BulkValidateProductLotsQueryVariables>;
export const GetProductLotForStockReturnDocument = gql`
    query GetProductLotForStockReturn($actionId: String, $locationId: String!, $anyOneActionIds: [String!]) {
  getProductLot(
    actionId: $actionId
    locationId: $locationId
    anyOneActionIds: $anyOneActionIds
  ) {
    id
    actionId
    isOpened
    status
    baseQuantity
    product {
      id
      secondaryId
      name
    }
    grnItem {
      purchaseOrderItem {
        purchaseOrder {
          vendor {
            id
            secondaryId
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetProductLotForStockReturnQuery__
 *
 * To run a query within a React component, call `useGetProductLotForStockReturnQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductLotForStockReturnQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductLotForStockReturnQuery({
 *   variables: {
 *      actionId: // value for 'actionId'
 *      locationId: // value for 'locationId'
 *      anyOneActionIds: // value for 'anyOneActionIds'
 *   },
 * });
 */
export function useGetProductLotForStockReturnQuery(baseOptions: Apollo.QueryHookOptions<GetProductLotForStockReturnQuery, GetProductLotForStockReturnQueryVariables> & ({ variables: GetProductLotForStockReturnQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductLotForStockReturnQuery, GetProductLotForStockReturnQueryVariables>(GetProductLotForStockReturnDocument, options);
      }
export function useGetProductLotForStockReturnLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductLotForStockReturnQuery, GetProductLotForStockReturnQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductLotForStockReturnQuery, GetProductLotForStockReturnQueryVariables>(GetProductLotForStockReturnDocument, options);
        }
// @ts-ignore
export function useGetProductLotForStockReturnSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductLotForStockReturnQuery, GetProductLotForStockReturnQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductLotForStockReturnQuery, GetProductLotForStockReturnQueryVariables>;
export function useGetProductLotForStockReturnSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductLotForStockReturnQuery, GetProductLotForStockReturnQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductLotForStockReturnQuery | undefined, GetProductLotForStockReturnQueryVariables>;
export function useGetProductLotForStockReturnSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductLotForStockReturnQuery, GetProductLotForStockReturnQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductLotForStockReturnQuery, GetProductLotForStockReturnQueryVariables>(GetProductLotForStockReturnDocument, options);
        }
export type GetProductLotForStockReturnQueryHookResult = ReturnType<typeof useGetProductLotForStockReturnQuery>;
export type GetProductLotForStockReturnLazyQueryHookResult = ReturnType<typeof useGetProductLotForStockReturnLazyQuery>;
export type GetProductLotForStockReturnSuspenseQueryHookResult = ReturnType<typeof useGetProductLotForStockReturnSuspenseQuery>;
export type GetProductLotForStockReturnQueryResult = Apollo.QueryResult<GetProductLotForStockReturnQuery, GetProductLotForStockReturnQueryVariables>;
export const GetUnexpiredProductLotsDocument = gql`
    query GetUnexpiredProductLots($sort: [SortCondition!], $page: Int!, $locationId: String, $limit: Int!, $filter: [FilterGroup!]) {
  getUnexpiredProductLots(
    sort: $sort
    page: $page
    locationId: $locationId
    limit: $limit
    filter: $filter
  ) {
    actionId
    id
    batchNumber
    batchExpiry
    purchasingPrice
    mrpSellingUnit
    taxSellingUnit
    baseQuantity
    sellableQuantity
  }
}
    `;

/**
 * __useGetUnexpiredProductLotsQuery__
 *
 * To run a query within a React component, call `useGetUnexpiredProductLotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnexpiredProductLotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnexpiredProductLotsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      locationId: // value for 'locationId'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetUnexpiredProductLotsQuery(baseOptions: Apollo.QueryHookOptions<GetUnexpiredProductLotsQuery, GetUnexpiredProductLotsQueryVariables> & ({ variables: GetUnexpiredProductLotsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnexpiredProductLotsQuery, GetUnexpiredProductLotsQueryVariables>(GetUnexpiredProductLotsDocument, options);
      }
export function useGetUnexpiredProductLotsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnexpiredProductLotsQuery, GetUnexpiredProductLotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnexpiredProductLotsQuery, GetUnexpiredProductLotsQueryVariables>(GetUnexpiredProductLotsDocument, options);
        }
// @ts-ignore
export function useGetUnexpiredProductLotsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUnexpiredProductLotsQuery, GetUnexpiredProductLotsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUnexpiredProductLotsQuery, GetUnexpiredProductLotsQueryVariables>;
export function useGetUnexpiredProductLotsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUnexpiredProductLotsQuery, GetUnexpiredProductLotsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUnexpiredProductLotsQuery | undefined, GetUnexpiredProductLotsQueryVariables>;
export function useGetUnexpiredProductLotsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUnexpiredProductLotsQuery, GetUnexpiredProductLotsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUnexpiredProductLotsQuery, GetUnexpiredProductLotsQueryVariables>(GetUnexpiredProductLotsDocument, options);
        }
export type GetUnexpiredProductLotsQueryHookResult = ReturnType<typeof useGetUnexpiredProductLotsQuery>;
export type GetUnexpiredProductLotsLazyQueryHookResult = ReturnType<typeof useGetUnexpiredProductLotsLazyQuery>;
export type GetUnexpiredProductLotsSuspenseQueryHookResult = ReturnType<typeof useGetUnexpiredProductLotsSuspenseQuery>;
export type GetUnexpiredProductLotsQueryResult = Apollo.QueryResult<GetUnexpiredProductLotsQuery, GetUnexpiredProductLotsQueryVariables>;
export const GetBaseQuantityByProductAndLocationDocument = gql`
    query GetBaseQuantityByProductAndLocation($productId: String!) {
  getBaseQuantityByProductAndLocation(productId: $productId) {
    locationId
    locationName
    totalBaseQuantity
    totalSellableQuantity
  }
}
    `;

/**
 * __useGetBaseQuantityByProductAndLocationQuery__
 *
 * To run a query within a React component, call `useGetBaseQuantityByProductAndLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBaseQuantityByProductAndLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBaseQuantityByProductAndLocationQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useGetBaseQuantityByProductAndLocationQuery(baseOptions: Apollo.QueryHookOptions<GetBaseQuantityByProductAndLocationQuery, GetBaseQuantityByProductAndLocationQueryVariables> & ({ variables: GetBaseQuantityByProductAndLocationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBaseQuantityByProductAndLocationQuery, GetBaseQuantityByProductAndLocationQueryVariables>(GetBaseQuantityByProductAndLocationDocument, options);
      }
export function useGetBaseQuantityByProductAndLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBaseQuantityByProductAndLocationQuery, GetBaseQuantityByProductAndLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBaseQuantityByProductAndLocationQuery, GetBaseQuantityByProductAndLocationQueryVariables>(GetBaseQuantityByProductAndLocationDocument, options);
        }
// @ts-ignore
export function useGetBaseQuantityByProductAndLocationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBaseQuantityByProductAndLocationQuery, GetBaseQuantityByProductAndLocationQueryVariables>): Apollo.UseSuspenseQueryResult<GetBaseQuantityByProductAndLocationQuery, GetBaseQuantityByProductAndLocationQueryVariables>;
export function useGetBaseQuantityByProductAndLocationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBaseQuantityByProductAndLocationQuery, GetBaseQuantityByProductAndLocationQueryVariables>): Apollo.UseSuspenseQueryResult<GetBaseQuantityByProductAndLocationQuery | undefined, GetBaseQuantityByProductAndLocationQueryVariables>;
export function useGetBaseQuantityByProductAndLocationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBaseQuantityByProductAndLocationQuery, GetBaseQuantityByProductAndLocationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBaseQuantityByProductAndLocationQuery, GetBaseQuantityByProductAndLocationQueryVariables>(GetBaseQuantityByProductAndLocationDocument, options);
        }
export type GetBaseQuantityByProductAndLocationQueryHookResult = ReturnType<typeof useGetBaseQuantityByProductAndLocationQuery>;
export type GetBaseQuantityByProductAndLocationLazyQueryHookResult = ReturnType<typeof useGetBaseQuantityByProductAndLocationLazyQuery>;
export type GetBaseQuantityByProductAndLocationSuspenseQueryHookResult = ReturnType<typeof useGetBaseQuantityByProductAndLocationSuspenseQuery>;
export type GetBaseQuantityByProductAndLocationQueryResult = Apollo.QueryResult<GetBaseQuantityByProductAndLocationQuery, GetBaseQuantityByProductAndLocationQueryVariables>;
export const GetProductionPlansDocument = gql`
    query GetProductionPlans($filter: [FilterGroup!], $page: Int, $limit: Int, $sort: [SortCondition!]) {
  getProductionPlans(filter: $filter, page: $page, limit: $limit, sort: $sort) {
    meta {
      total
      page
      limit
    }
    data {
      id
      secondaryId
      planCode
      status
      productionLocationId
      sourceLocationId
      productionLocation {
        id
        name
      }
      sourceLocation {
        id
        name
      }
      plannedStartDate
      plannedEndDate
      demandNoteId
      notes
      cancellationReason
      approvedBy
      approvedAt
      issuanceRequestedBy
      issuanceRequestedAt
      createdAt
    }
  }
}
    `;

/**
 * __useGetProductionPlansQuery__
 *
 * To run a query within a React component, call `useGetProductionPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductionPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductionPlansQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetProductionPlansQuery(baseOptions?: Apollo.QueryHookOptions<GetProductionPlansQuery, GetProductionPlansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductionPlansQuery, GetProductionPlansQueryVariables>(GetProductionPlansDocument, options);
      }
export function useGetProductionPlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductionPlansQuery, GetProductionPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductionPlansQuery, GetProductionPlansQueryVariables>(GetProductionPlansDocument, options);
        }
// @ts-ignore
export function useGetProductionPlansSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductionPlansQuery, GetProductionPlansQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductionPlansQuery, GetProductionPlansQueryVariables>;
export function useGetProductionPlansSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductionPlansQuery, GetProductionPlansQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductionPlansQuery | undefined, GetProductionPlansQueryVariables>;
export function useGetProductionPlansSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductionPlansQuery, GetProductionPlansQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductionPlansQuery, GetProductionPlansQueryVariables>(GetProductionPlansDocument, options);
        }
export type GetProductionPlansQueryHookResult = ReturnType<typeof useGetProductionPlansQuery>;
export type GetProductionPlansLazyQueryHookResult = ReturnType<typeof useGetProductionPlansLazyQuery>;
export type GetProductionPlansSuspenseQueryHookResult = ReturnType<typeof useGetProductionPlansSuspenseQuery>;
export type GetProductionPlansQueryResult = Apollo.QueryResult<GetProductionPlansQuery, GetProductionPlansQueryVariables>;
export const GetProductionPlanDocument = gql`
    query GetProductionPlan($id: String!) {
  getProductionPlan(id: $id) {
    id
    secondaryId
    planCode
    status
    productionLocation {
      id
      name
    }
    sourceLocation {
      id
      name
    }
    plannedStartDate
    plannedEndDate
    notes
    cancellationReason
    approvedBy
    approvedAt
    issuanceRequestedBy
    issuanceRequestedAt
    productionLines {
      id
      secondaryId
      outputProductId
      outputProduct {
        id
        name
        trackingLevel
      }
      bomVersionId
      bomVersion {
        id
        versionNo
        versionLabel
        batchQuantity
      }
      multiplierFactor
      plannedQty
      materialLines {
        id
        componentProductId
        componentProduct {
          id
          name
        }
        requiredQty
        isMandatory
      }
    }
    demandNote {
      secondaryId
      id
    }
  }
}
    `;

/**
 * __useGetProductionPlanQuery__
 *
 * To run a query within a React component, call `useGetProductionPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductionPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductionPlanQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProductionPlanQuery(baseOptions: Apollo.QueryHookOptions<GetProductionPlanQuery, GetProductionPlanQueryVariables> & ({ variables: GetProductionPlanQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductionPlanQuery, GetProductionPlanQueryVariables>(GetProductionPlanDocument, options);
      }
export function useGetProductionPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductionPlanQuery, GetProductionPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductionPlanQuery, GetProductionPlanQueryVariables>(GetProductionPlanDocument, options);
        }
// @ts-ignore
export function useGetProductionPlanSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductionPlanQuery, GetProductionPlanQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductionPlanQuery, GetProductionPlanQueryVariables>;
export function useGetProductionPlanSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductionPlanQuery, GetProductionPlanQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductionPlanQuery | undefined, GetProductionPlanQueryVariables>;
export function useGetProductionPlanSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductionPlanQuery, GetProductionPlanQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductionPlanQuery, GetProductionPlanQueryVariables>(GetProductionPlanDocument, options);
        }
export type GetProductionPlanQueryHookResult = ReturnType<typeof useGetProductionPlanQuery>;
export type GetProductionPlanLazyQueryHookResult = ReturnType<typeof useGetProductionPlanLazyQuery>;
export type GetProductionPlanSuspenseQueryHookResult = ReturnType<typeof useGetProductionPlanSuspenseQuery>;
export type GetProductionPlanQueryResult = Apollo.QueryResult<GetProductionPlanQuery, GetProductionPlanQueryVariables>;
export const CreateProductionPlanDocument = gql`
    mutation CreateProductionPlan($dto: CreateProductionPlanDTO!) {
  createProductionPlan(createProductionPlanDTO: $dto) {
    id
    planCode
    status
  }
}
    `;
export type CreateProductionPlanMutationFn = Apollo.MutationFunction<CreateProductionPlanMutation, CreateProductionPlanMutationVariables>;

/**
 * __useCreateProductionPlanMutation__
 *
 * To run a mutation, you first call `useCreateProductionPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductionPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductionPlanMutation, { data, loading, error }] = useCreateProductionPlanMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useCreateProductionPlanMutation(baseOptions?: Apollo.MutationHookOptions<CreateProductionPlanMutation, CreateProductionPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProductionPlanMutation, CreateProductionPlanMutationVariables>(CreateProductionPlanDocument, options);
      }
export type CreateProductionPlanMutationHookResult = ReturnType<typeof useCreateProductionPlanMutation>;
export type CreateProductionPlanMutationResult = Apollo.MutationResult<CreateProductionPlanMutation>;
export type CreateProductionPlanMutationOptions = Apollo.BaseMutationOptions<CreateProductionPlanMutation, CreateProductionPlanMutationVariables>;
export const UpdateProductionPlanDocument = gql`
    mutation UpdateProductionPlan($dto: UpdateProductionPlanDTO!) {
  updateProductionPlan(updateProductionPlanDTO: $dto) {
    id
    status
  }
}
    `;
export type UpdateProductionPlanMutationFn = Apollo.MutationFunction<UpdateProductionPlanMutation, UpdateProductionPlanMutationVariables>;

/**
 * __useUpdateProductionPlanMutation__
 *
 * To run a mutation, you first call `useUpdateProductionPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductionPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductionPlanMutation, { data, loading, error }] = useUpdateProductionPlanMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useUpdateProductionPlanMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductionPlanMutation, UpdateProductionPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductionPlanMutation, UpdateProductionPlanMutationVariables>(UpdateProductionPlanDocument, options);
      }
export type UpdateProductionPlanMutationHookResult = ReturnType<typeof useUpdateProductionPlanMutation>;
export type UpdateProductionPlanMutationResult = Apollo.MutationResult<UpdateProductionPlanMutation>;
export type UpdateProductionPlanMutationOptions = Apollo.BaseMutationOptions<UpdateProductionPlanMutation, UpdateProductionPlanMutationVariables>;
export const AddProductionLineDocument = gql`
    mutation AddProductionLine($dto: AddProductionLineDTO!) {
  addProductionLine(addProductionLineDTO: $dto) {
    id
    plannedQty
    materialLines {
      id
      componentProductId
      requiredQty
      isMandatory
    }
  }
}
    `;
export type AddProductionLineMutationFn = Apollo.MutationFunction<AddProductionLineMutation, AddProductionLineMutationVariables>;

/**
 * __useAddProductionLineMutation__
 *
 * To run a mutation, you first call `useAddProductionLineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProductionLineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProductionLineMutation, { data, loading, error }] = useAddProductionLineMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useAddProductionLineMutation(baseOptions?: Apollo.MutationHookOptions<AddProductionLineMutation, AddProductionLineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProductionLineMutation, AddProductionLineMutationVariables>(AddProductionLineDocument, options);
      }
export type AddProductionLineMutationHookResult = ReturnType<typeof useAddProductionLineMutation>;
export type AddProductionLineMutationResult = Apollo.MutationResult<AddProductionLineMutation>;
export type AddProductionLineMutationOptions = Apollo.BaseMutationOptions<AddProductionLineMutation, AddProductionLineMutationVariables>;
export const UpdateProductionLineDocument = gql`
    mutation UpdateProductionLine($dto: UpdateProductionLineDTO!) {
  updateProductionLine(updateProductionLineDTO: $dto) {
    id
    plannedQty
    multiplierFactor
  }
}
    `;
export type UpdateProductionLineMutationFn = Apollo.MutationFunction<UpdateProductionLineMutation, UpdateProductionLineMutationVariables>;

/**
 * __useUpdateProductionLineMutation__
 *
 * To run a mutation, you first call `useUpdateProductionLineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductionLineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductionLineMutation, { data, loading, error }] = useUpdateProductionLineMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useUpdateProductionLineMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductionLineMutation, UpdateProductionLineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductionLineMutation, UpdateProductionLineMutationVariables>(UpdateProductionLineDocument, options);
      }
export type UpdateProductionLineMutationHookResult = ReturnType<typeof useUpdateProductionLineMutation>;
export type UpdateProductionLineMutationResult = Apollo.MutationResult<UpdateProductionLineMutation>;
export type UpdateProductionLineMutationOptions = Apollo.BaseMutationOptions<UpdateProductionLineMutation, UpdateProductionLineMutationVariables>;
export const RemoveProductionLineDocument = gql`
    mutation RemoveProductionLine($id: String!) {
  removeProductionLine(id: $id)
}
    `;
export type RemoveProductionLineMutationFn = Apollo.MutationFunction<RemoveProductionLineMutation, RemoveProductionLineMutationVariables>;

/**
 * __useRemoveProductionLineMutation__
 *
 * To run a mutation, you first call `useRemoveProductionLineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveProductionLineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeProductionLineMutation, { data, loading, error }] = useRemoveProductionLineMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveProductionLineMutation(baseOptions?: Apollo.MutationHookOptions<RemoveProductionLineMutation, RemoveProductionLineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveProductionLineMutation, RemoveProductionLineMutationVariables>(RemoveProductionLineDocument, options);
      }
export type RemoveProductionLineMutationHookResult = ReturnType<typeof useRemoveProductionLineMutation>;
export type RemoveProductionLineMutationResult = Apollo.MutationResult<RemoveProductionLineMutation>;
export type RemoveProductionLineMutationOptions = Apollo.BaseMutationOptions<RemoveProductionLineMutation, RemoveProductionLineMutationVariables>;
export const SubmitProductionPlanForApprovalDocument = gql`
    mutation SubmitProductionPlanForApproval($id: String!) {
  submitProductionPlanForApproval(id: $id) {
    id
    status
  }
}
    `;
export type SubmitProductionPlanForApprovalMutationFn = Apollo.MutationFunction<SubmitProductionPlanForApprovalMutation, SubmitProductionPlanForApprovalMutationVariables>;

/**
 * __useSubmitProductionPlanForApprovalMutation__
 *
 * To run a mutation, you first call `useSubmitProductionPlanForApprovalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitProductionPlanForApprovalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitProductionPlanForApprovalMutation, { data, loading, error }] = useSubmitProductionPlanForApprovalMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSubmitProductionPlanForApprovalMutation(baseOptions?: Apollo.MutationHookOptions<SubmitProductionPlanForApprovalMutation, SubmitProductionPlanForApprovalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitProductionPlanForApprovalMutation, SubmitProductionPlanForApprovalMutationVariables>(SubmitProductionPlanForApprovalDocument, options);
      }
export type SubmitProductionPlanForApprovalMutationHookResult = ReturnType<typeof useSubmitProductionPlanForApprovalMutation>;
export type SubmitProductionPlanForApprovalMutationResult = Apollo.MutationResult<SubmitProductionPlanForApprovalMutation>;
export type SubmitProductionPlanForApprovalMutationOptions = Apollo.BaseMutationOptions<SubmitProductionPlanForApprovalMutation, SubmitProductionPlanForApprovalMutationVariables>;
export const ApproveProductionPlanDocument = gql`
    mutation ApproveProductionPlan($id: String!) {
  approveProductionPlan(id: $id) {
    id
    status
    approvedBy
    approvedAt
  }
}
    `;
export type ApproveProductionPlanMutationFn = Apollo.MutationFunction<ApproveProductionPlanMutation, ApproveProductionPlanMutationVariables>;

/**
 * __useApproveProductionPlanMutation__
 *
 * To run a mutation, you first call `useApproveProductionPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveProductionPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveProductionPlanMutation, { data, loading, error }] = useApproveProductionPlanMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApproveProductionPlanMutation(baseOptions?: Apollo.MutationHookOptions<ApproveProductionPlanMutation, ApproveProductionPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveProductionPlanMutation, ApproveProductionPlanMutationVariables>(ApproveProductionPlanDocument, options);
      }
export type ApproveProductionPlanMutationHookResult = ReturnType<typeof useApproveProductionPlanMutation>;
export type ApproveProductionPlanMutationResult = Apollo.MutationResult<ApproveProductionPlanMutation>;
export type ApproveProductionPlanMutationOptions = Apollo.BaseMutationOptions<ApproveProductionPlanMutation, ApproveProductionPlanMutationVariables>;
export const RequestProductionPlanIssuanceDocument = gql`
    mutation RequestProductionPlanIssuance($id: String!) {
  requestProductionPlanIssuance(id: $id) {
    id
    status
    demandNoteId
    issuanceRequestedBy
    issuanceRequestedAt
  }
}
    `;
export type RequestProductionPlanIssuanceMutationFn = Apollo.MutationFunction<RequestProductionPlanIssuanceMutation, RequestProductionPlanIssuanceMutationVariables>;

/**
 * __useRequestProductionPlanIssuanceMutation__
 *
 * To run a mutation, you first call `useRequestProductionPlanIssuanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestProductionPlanIssuanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestProductionPlanIssuanceMutation, { data, loading, error }] = useRequestProductionPlanIssuanceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRequestProductionPlanIssuanceMutation(baseOptions?: Apollo.MutationHookOptions<RequestProductionPlanIssuanceMutation, RequestProductionPlanIssuanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestProductionPlanIssuanceMutation, RequestProductionPlanIssuanceMutationVariables>(RequestProductionPlanIssuanceDocument, options);
      }
export type RequestProductionPlanIssuanceMutationHookResult = ReturnType<typeof useRequestProductionPlanIssuanceMutation>;
export type RequestProductionPlanIssuanceMutationResult = Apollo.MutationResult<RequestProductionPlanIssuanceMutation>;
export type RequestProductionPlanIssuanceMutationOptions = Apollo.BaseMutationOptions<RequestProductionPlanIssuanceMutation, RequestProductionPlanIssuanceMutationVariables>;
export const CancelProductionPlanDocument = gql`
    mutation CancelProductionPlan($id: String!, $cancellationReason: String!) {
  cancelProductionPlan(id: $id, cancellationReason: $cancellationReason) {
    id
    status
    cancellationReason
  }
}
    `;
export type CancelProductionPlanMutationFn = Apollo.MutationFunction<CancelProductionPlanMutation, CancelProductionPlanMutationVariables>;

/**
 * __useCancelProductionPlanMutation__
 *
 * To run a mutation, you first call `useCancelProductionPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelProductionPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelProductionPlanMutation, { data, loading, error }] = useCancelProductionPlanMutation({
 *   variables: {
 *      id: // value for 'id'
 *      cancellationReason: // value for 'cancellationReason'
 *   },
 * });
 */
export function useCancelProductionPlanMutation(baseOptions?: Apollo.MutationHookOptions<CancelProductionPlanMutation, CancelProductionPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelProductionPlanMutation, CancelProductionPlanMutationVariables>(CancelProductionPlanDocument, options);
      }
export type CancelProductionPlanMutationHookResult = ReturnType<typeof useCancelProductionPlanMutation>;
export type CancelProductionPlanMutationResult = Apollo.MutationResult<CancelProductionPlanMutation>;
export type CancelProductionPlanMutationOptions = Apollo.BaseMutationOptions<CancelProductionPlanMutation, CancelProductionPlanMutationVariables>;
export const GetProductionOrdersDocument = gql`
    query GetProductionOrders($filter: [FilterGroup!], $page: Int, $limit: Int, $sort: [SortCondition!]) {
  getProductionOrders(filter: $filter, page: $page, limit: $limit, sort: $sort) {
    meta {
      total
      page
      limit
    }
    data {
      id
      secondaryId
      orderCode
      status
      productionPlanId
      productionPlan {
        id
        planCode
      }
      outputProduct {
        id
        name
        trackingLevel
      }
      location {
        id
        name
      }
      plannedQty
      totalProducedQuantity
      totalAdjustment
      qcPassedQty
      qcRejectedQty
      createdAt
    }
  }
}
    `;

/**
 * __useGetProductionOrdersQuery__
 *
 * To run a query within a React component, call `useGetProductionOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductionOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductionOrdersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetProductionOrdersQuery(baseOptions?: Apollo.QueryHookOptions<GetProductionOrdersQuery, GetProductionOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductionOrdersQuery, GetProductionOrdersQueryVariables>(GetProductionOrdersDocument, options);
      }
export function useGetProductionOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductionOrdersQuery, GetProductionOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductionOrdersQuery, GetProductionOrdersQueryVariables>(GetProductionOrdersDocument, options);
        }
// @ts-ignore
export function useGetProductionOrdersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductionOrdersQuery, GetProductionOrdersQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductionOrdersQuery, GetProductionOrdersQueryVariables>;
export function useGetProductionOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductionOrdersQuery, GetProductionOrdersQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductionOrdersQuery | undefined, GetProductionOrdersQueryVariables>;
export function useGetProductionOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductionOrdersQuery, GetProductionOrdersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductionOrdersQuery, GetProductionOrdersQueryVariables>(GetProductionOrdersDocument, options);
        }
export type GetProductionOrdersQueryHookResult = ReturnType<typeof useGetProductionOrdersQuery>;
export type GetProductionOrdersLazyQueryHookResult = ReturnType<typeof useGetProductionOrdersLazyQuery>;
export type GetProductionOrdersSuspenseQueryHookResult = ReturnType<typeof useGetProductionOrdersSuspenseQuery>;
export type GetProductionOrdersQueryResult = Apollo.QueryResult<GetProductionOrdersQuery, GetProductionOrdersQueryVariables>;
export const GetProductionOrderDocument = gql`
    query GetProductionOrder($id: String!) {
  getProductionOrder(id: $id) {
    id
    secondaryId
    orderCode
    status
    productionPlanId
    productionLineId
    productionPlan {
      id
      planCode
      status
    }
    bomVersionId
    bomVersion {
      id
      versionNo
      versionLabel
      batchQuantity
    }
    outputProduct {
      id
      name
      trackingLevel
    }
    location {
      id
      name
    }
    plannedQty
    totalProducedQuantity
    totalAdjustment
    manufacturingCostPerUnit
    qcPassedQty
    qcRejectedQty
    qcNotes
    qcBy
    qcAt
    notes
    cancellationReason
    completedAt
    completedBy
    batches {
      id
      batchNumber
      standardQuantity
      adjustmentDirection
      adjustmentQuantity
      qcStatus
      qcRejectedQty
      qcNotes
      qcBy
      qcAt
      submittedToQcBy
      submittedToQcAt
    }
    materials {
      id
      componentProductId
      componentProduct {
        id
        name
      }
      plannedQty
      actualQty
      isMandatory
      isOverridden
      lots {
        id
        productLotId
        quantity
        productLot {
          id
          actionId
          sellableQuantity
          batchExpiry
        }
      }
    }
  }
}
    `;

/**
 * __useGetProductionOrderQuery__
 *
 * To run a query within a React component, call `useGetProductionOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductionOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductionOrderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProductionOrderQuery(baseOptions: Apollo.QueryHookOptions<GetProductionOrderQuery, GetProductionOrderQueryVariables> & ({ variables: GetProductionOrderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductionOrderQuery, GetProductionOrderQueryVariables>(GetProductionOrderDocument, options);
      }
export function useGetProductionOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductionOrderQuery, GetProductionOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductionOrderQuery, GetProductionOrderQueryVariables>(GetProductionOrderDocument, options);
        }
// @ts-ignore
export function useGetProductionOrderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductionOrderQuery, GetProductionOrderQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductionOrderQuery, GetProductionOrderQueryVariables>;
export function useGetProductionOrderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductionOrderQuery, GetProductionOrderQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductionOrderQuery | undefined, GetProductionOrderQueryVariables>;
export function useGetProductionOrderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductionOrderQuery, GetProductionOrderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductionOrderQuery, GetProductionOrderQueryVariables>(GetProductionOrderDocument, options);
        }
export type GetProductionOrderQueryHookResult = ReturnType<typeof useGetProductionOrderQuery>;
export type GetProductionOrderLazyQueryHookResult = ReturnType<typeof useGetProductionOrderLazyQuery>;
export type GetProductionOrderSuspenseQueryHookResult = ReturnType<typeof useGetProductionOrderSuspenseQuery>;
export type GetProductionOrderQueryResult = Apollo.QueryResult<GetProductionOrderQuery, GetProductionOrderQueryVariables>;
export const GetProductionPlanMaterialReferenceDocument = gql`
    query GetProductionPlanMaterialReference($productionOrderId: String!) {
  getProductionPlanMaterialReference(productionOrderId: $productionOrderId) {
    id
    componentProductId
    componentProduct {
      id
      name
    }
    requiredQty
    isMandatory
  }
}
    `;

/**
 * __useGetProductionPlanMaterialReferenceQuery__
 *
 * To run a query within a React component, call `useGetProductionPlanMaterialReferenceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductionPlanMaterialReferenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductionPlanMaterialReferenceQuery({
 *   variables: {
 *      productionOrderId: // value for 'productionOrderId'
 *   },
 * });
 */
export function useGetProductionPlanMaterialReferenceQuery(baseOptions: Apollo.QueryHookOptions<GetProductionPlanMaterialReferenceQuery, GetProductionPlanMaterialReferenceQueryVariables> & ({ variables: GetProductionPlanMaterialReferenceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductionPlanMaterialReferenceQuery, GetProductionPlanMaterialReferenceQueryVariables>(GetProductionPlanMaterialReferenceDocument, options);
      }
export function useGetProductionPlanMaterialReferenceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductionPlanMaterialReferenceQuery, GetProductionPlanMaterialReferenceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductionPlanMaterialReferenceQuery, GetProductionPlanMaterialReferenceQueryVariables>(GetProductionPlanMaterialReferenceDocument, options);
        }
// @ts-ignore
export function useGetProductionPlanMaterialReferenceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductionPlanMaterialReferenceQuery, GetProductionPlanMaterialReferenceQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductionPlanMaterialReferenceQuery, GetProductionPlanMaterialReferenceQueryVariables>;
export function useGetProductionPlanMaterialReferenceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductionPlanMaterialReferenceQuery, GetProductionPlanMaterialReferenceQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductionPlanMaterialReferenceQuery | undefined, GetProductionPlanMaterialReferenceQueryVariables>;
export function useGetProductionPlanMaterialReferenceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductionPlanMaterialReferenceQuery, GetProductionPlanMaterialReferenceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductionPlanMaterialReferenceQuery, GetProductionPlanMaterialReferenceQueryVariables>(GetProductionPlanMaterialReferenceDocument, options);
        }
export type GetProductionPlanMaterialReferenceQueryHookResult = ReturnType<typeof useGetProductionPlanMaterialReferenceQuery>;
export type GetProductionPlanMaterialReferenceLazyQueryHookResult = ReturnType<typeof useGetProductionPlanMaterialReferenceLazyQuery>;
export type GetProductionPlanMaterialReferenceSuspenseQueryHookResult = ReturnType<typeof useGetProductionPlanMaterialReferenceSuspenseQuery>;
export type GetProductionPlanMaterialReferenceQueryResult = Apollo.QueryResult<GetProductionPlanMaterialReferenceQuery, GetProductionPlanMaterialReferenceQueryVariables>;
export const CreateProductionOrderDocument = gql`
    mutation CreateProductionOrder($dto: CreateProductionOrderDTO!) {
  createProductionOrder(createProductionOrderDTO: $dto) {
    id
    orderCode
    status
    plannedQty
    batches {
      id
      batchNumber
      standardQuantity
    }
    materials {
      id
      componentProductId
      plannedQty
    }
  }
}
    `;
export type CreateProductionOrderMutationFn = Apollo.MutationFunction<CreateProductionOrderMutation, CreateProductionOrderMutationVariables>;

/**
 * __useCreateProductionOrderMutation__
 *
 * To run a mutation, you first call `useCreateProductionOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductionOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductionOrderMutation, { data, loading, error }] = useCreateProductionOrderMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useCreateProductionOrderMutation(baseOptions?: Apollo.MutationHookOptions<CreateProductionOrderMutation, CreateProductionOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProductionOrderMutation, CreateProductionOrderMutationVariables>(CreateProductionOrderDocument, options);
      }
export type CreateProductionOrderMutationHookResult = ReturnType<typeof useCreateProductionOrderMutation>;
export type CreateProductionOrderMutationResult = Apollo.MutationResult<CreateProductionOrderMutation>;
export type CreateProductionOrderMutationOptions = Apollo.BaseMutationOptions<CreateProductionOrderMutation, CreateProductionOrderMutationVariables>;
export const UpdateProductionOrderDocument = gql`
    mutation UpdateProductionOrder($dto: UpdateProductionOrderDTO!) {
  updateProductionOrder(updateProductionOrderDTO: $dto) {
    id
    notes
  }
}
    `;
export type UpdateProductionOrderMutationFn = Apollo.MutationFunction<UpdateProductionOrderMutation, UpdateProductionOrderMutationVariables>;

/**
 * __useUpdateProductionOrderMutation__
 *
 * To run a mutation, you first call `useUpdateProductionOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductionOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductionOrderMutation, { data, loading, error }] = useUpdateProductionOrderMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useUpdateProductionOrderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductionOrderMutation, UpdateProductionOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductionOrderMutation, UpdateProductionOrderMutationVariables>(UpdateProductionOrderDocument, options);
      }
export type UpdateProductionOrderMutationHookResult = ReturnType<typeof useUpdateProductionOrderMutation>;
export type UpdateProductionOrderMutationResult = Apollo.MutationResult<UpdateProductionOrderMutation>;
export type UpdateProductionOrderMutationOptions = Apollo.BaseMutationOptions<UpdateProductionOrderMutation, UpdateProductionOrderMutationVariables>;
export const UpdateProductionOrderBatchDocument = gql`
    mutation UpdateProductionOrderBatch($dto: UpdateProductionOrderBatchDTO!) {
  updateProductionOrderBatch(updateProductionOrderBatchDTO: $dto) {
    id
    adjustmentDirection
    adjustmentQuantity
  }
}
    `;
export type UpdateProductionOrderBatchMutationFn = Apollo.MutationFunction<UpdateProductionOrderBatchMutation, UpdateProductionOrderBatchMutationVariables>;

/**
 * __useUpdateProductionOrderBatchMutation__
 *
 * To run a mutation, you first call `useUpdateProductionOrderBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductionOrderBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductionOrderBatchMutation, { data, loading, error }] = useUpdateProductionOrderBatchMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useUpdateProductionOrderBatchMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductionOrderBatchMutation, UpdateProductionOrderBatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductionOrderBatchMutation, UpdateProductionOrderBatchMutationVariables>(UpdateProductionOrderBatchDocument, options);
      }
export type UpdateProductionOrderBatchMutationHookResult = ReturnType<typeof useUpdateProductionOrderBatchMutation>;
export type UpdateProductionOrderBatchMutationResult = Apollo.MutationResult<UpdateProductionOrderBatchMutation>;
export type UpdateProductionOrderBatchMutationOptions = Apollo.BaseMutationOptions<UpdateProductionOrderBatchMutation, UpdateProductionOrderBatchMutationVariables>;
export const UpdateProductionOrderMaterialDocument = gql`
    mutation UpdateProductionOrderMaterial($dto: UpdateProductionOrderMaterialDTO!) {
  updateProductionOrderMaterial(updateProductionOrderMaterialDTO: $dto) {
    id
    actualQty
    isOverridden
    lots {
      id
      productLotId
      quantity
    }
  }
}
    `;
export type UpdateProductionOrderMaterialMutationFn = Apollo.MutationFunction<UpdateProductionOrderMaterialMutation, UpdateProductionOrderMaterialMutationVariables>;

/**
 * __useUpdateProductionOrderMaterialMutation__
 *
 * To run a mutation, you first call `useUpdateProductionOrderMaterialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductionOrderMaterialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductionOrderMaterialMutation, { data, loading, error }] = useUpdateProductionOrderMaterialMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useUpdateProductionOrderMaterialMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductionOrderMaterialMutation, UpdateProductionOrderMaterialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductionOrderMaterialMutation, UpdateProductionOrderMaterialMutationVariables>(UpdateProductionOrderMaterialDocument, options);
      }
export type UpdateProductionOrderMaterialMutationHookResult = ReturnType<typeof useUpdateProductionOrderMaterialMutation>;
export type UpdateProductionOrderMaterialMutationResult = Apollo.MutationResult<UpdateProductionOrderMaterialMutation>;
export type UpdateProductionOrderMaterialMutationOptions = Apollo.BaseMutationOptions<UpdateProductionOrderMaterialMutation, UpdateProductionOrderMaterialMutationVariables>;
export const SubmitProductionOrderToQcDocument = gql`
    mutation SubmitProductionOrderToQc($dto: SubmitToQcDTO!) {
  submitProductionOrderToQc(submitToQcDTO: $dto) {
    id
    status
    manufacturingCostPerUnit
    batches {
      id
      qcStatus
    }
  }
}
    `;
export type SubmitProductionOrderToQcMutationFn = Apollo.MutationFunction<SubmitProductionOrderToQcMutation, SubmitProductionOrderToQcMutationVariables>;

/**
 * __useSubmitProductionOrderToQcMutation__
 *
 * To run a mutation, you first call `useSubmitProductionOrderToQcMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitProductionOrderToQcMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitProductionOrderToQcMutation, { data, loading, error }] = useSubmitProductionOrderToQcMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useSubmitProductionOrderToQcMutation(baseOptions?: Apollo.MutationHookOptions<SubmitProductionOrderToQcMutation, SubmitProductionOrderToQcMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitProductionOrderToQcMutation, SubmitProductionOrderToQcMutationVariables>(SubmitProductionOrderToQcDocument, options);
      }
export type SubmitProductionOrderToQcMutationHookResult = ReturnType<typeof useSubmitProductionOrderToQcMutation>;
export type SubmitProductionOrderToQcMutationResult = Apollo.MutationResult<SubmitProductionOrderToQcMutation>;
export type SubmitProductionOrderToQcMutationOptions = Apollo.BaseMutationOptions<SubmitProductionOrderToQcMutation, SubmitProductionOrderToQcMutationVariables>;
export const ApproveProductionOrderQcBatchesDocument = gql`
    mutation ApproveProductionOrderQcBatches($dto: ApproveQcBatchDTO!) {
  approveProductionOrderQcBatches(approveQcBatchDTO: $dto) {
    id
    status
    qcPassedQty
    qcRejectedQty
    batches {
      id
      qcStatus
      qcRejectedQty
    }
  }
}
    `;
export type ApproveProductionOrderQcBatchesMutationFn = Apollo.MutationFunction<ApproveProductionOrderQcBatchesMutation, ApproveProductionOrderQcBatchesMutationVariables>;

/**
 * __useApproveProductionOrderQcBatchesMutation__
 *
 * To run a mutation, you first call `useApproveProductionOrderQcBatchesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveProductionOrderQcBatchesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveProductionOrderQcBatchesMutation, { data, loading, error }] = useApproveProductionOrderQcBatchesMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useApproveProductionOrderQcBatchesMutation(baseOptions?: Apollo.MutationHookOptions<ApproveProductionOrderQcBatchesMutation, ApproveProductionOrderQcBatchesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveProductionOrderQcBatchesMutation, ApproveProductionOrderQcBatchesMutationVariables>(ApproveProductionOrderQcBatchesDocument, options);
      }
export type ApproveProductionOrderQcBatchesMutationHookResult = ReturnType<typeof useApproveProductionOrderQcBatchesMutation>;
export type ApproveProductionOrderQcBatchesMutationResult = Apollo.MutationResult<ApproveProductionOrderQcBatchesMutation>;
export type ApproveProductionOrderQcBatchesMutationOptions = Apollo.BaseMutationOptions<ApproveProductionOrderQcBatchesMutation, ApproveProductionOrderQcBatchesMutationVariables>;
export const ApproveProductionOrderQcBatchesSerialDocument = gql`
    mutation ApproveProductionOrderQcBatchesSerial($dto: ApproveQcSerialDTO!) {
  approveProductionOrderQcBatchesSerial(approveQcSerialDTO: $dto) {
    id
    status
    qcPassedQty
    qcRejectedQty
    batches {
      id
      qcStatus
      qcRejectedQty
    }
  }
}
    `;
export type ApproveProductionOrderQcBatchesSerialMutationFn = Apollo.MutationFunction<ApproveProductionOrderQcBatchesSerialMutation, ApproveProductionOrderQcBatchesSerialMutationVariables>;

/**
 * __useApproveProductionOrderQcBatchesSerialMutation__
 *
 * To run a mutation, you first call `useApproveProductionOrderQcBatchesSerialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveProductionOrderQcBatchesSerialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveProductionOrderQcBatchesSerialMutation, { data, loading, error }] = useApproveProductionOrderQcBatchesSerialMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useApproveProductionOrderQcBatchesSerialMutation(baseOptions?: Apollo.MutationHookOptions<ApproveProductionOrderQcBatchesSerialMutation, ApproveProductionOrderQcBatchesSerialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveProductionOrderQcBatchesSerialMutation, ApproveProductionOrderQcBatchesSerialMutationVariables>(ApproveProductionOrderQcBatchesSerialDocument, options);
      }
export type ApproveProductionOrderQcBatchesSerialMutationHookResult = ReturnType<typeof useApproveProductionOrderQcBatchesSerialMutation>;
export type ApproveProductionOrderQcBatchesSerialMutationResult = Apollo.MutationResult<ApproveProductionOrderQcBatchesSerialMutation>;
export type ApproveProductionOrderQcBatchesSerialMutationOptions = Apollo.BaseMutationOptions<ApproveProductionOrderQcBatchesSerialMutation, ApproveProductionOrderQcBatchesSerialMutationVariables>;
export const CancelProductionOrderDocument = gql`
    mutation CancelProductionOrder($id: String!, $cancellationReason: String!) {
  cancelProductionOrder(id: $id, cancellationReason: $cancellationReason) {
    id
    status
    cancellationReason
  }
}
    `;
export type CancelProductionOrderMutationFn = Apollo.MutationFunction<CancelProductionOrderMutation, CancelProductionOrderMutationVariables>;

/**
 * __useCancelProductionOrderMutation__
 *
 * To run a mutation, you first call `useCancelProductionOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelProductionOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelProductionOrderMutation, { data, loading, error }] = useCancelProductionOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      cancellationReason: // value for 'cancellationReason'
 *   },
 * });
 */
export function useCancelProductionOrderMutation(baseOptions?: Apollo.MutationHookOptions<CancelProductionOrderMutation, CancelProductionOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelProductionOrderMutation, CancelProductionOrderMutationVariables>(CancelProductionOrderDocument, options);
      }
export type CancelProductionOrderMutationHookResult = ReturnType<typeof useCancelProductionOrderMutation>;
export type CancelProductionOrderMutationResult = Apollo.MutationResult<CancelProductionOrderMutation>;
export type CancelProductionOrderMutationOptions = Apollo.BaseMutationOptions<CancelProductionOrderMutation, CancelProductionOrderMutationVariables>;
export const PurchaseOrderSummaryDocument = gql`
    query PurchaseOrderSummary($startDate: String!, $endDate: String!, $locationId: String!) {
  purchaseOrderSummary(
    startDate: $startDate
    endDate: $endDate
    locationId: $locationId
  ) {
    purchaseOrder
    amount
    pending
    partial
    fulfilled
  }
}
    `;

/**
 * __usePurchaseOrderSummaryQuery__
 *
 * To run a query within a React component, call `usePurchaseOrderSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePurchaseOrderSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePurchaseOrderSummaryQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function usePurchaseOrderSummaryQuery(baseOptions: Apollo.QueryHookOptions<PurchaseOrderSummaryQuery, PurchaseOrderSummaryQueryVariables> & ({ variables: PurchaseOrderSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PurchaseOrderSummaryQuery, PurchaseOrderSummaryQueryVariables>(PurchaseOrderSummaryDocument, options);
      }
export function usePurchaseOrderSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PurchaseOrderSummaryQuery, PurchaseOrderSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PurchaseOrderSummaryQuery, PurchaseOrderSummaryQueryVariables>(PurchaseOrderSummaryDocument, options);
        }
// @ts-ignore
export function usePurchaseOrderSummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PurchaseOrderSummaryQuery, PurchaseOrderSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<PurchaseOrderSummaryQuery, PurchaseOrderSummaryQueryVariables>;
export function usePurchaseOrderSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PurchaseOrderSummaryQuery, PurchaseOrderSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<PurchaseOrderSummaryQuery | undefined, PurchaseOrderSummaryQueryVariables>;
export function usePurchaseOrderSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PurchaseOrderSummaryQuery, PurchaseOrderSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PurchaseOrderSummaryQuery, PurchaseOrderSummaryQueryVariables>(PurchaseOrderSummaryDocument, options);
        }
export type PurchaseOrderSummaryQueryHookResult = ReturnType<typeof usePurchaseOrderSummaryQuery>;
export type PurchaseOrderSummaryLazyQueryHookResult = ReturnType<typeof usePurchaseOrderSummaryLazyQuery>;
export type PurchaseOrderSummarySuspenseQueryHookResult = ReturnType<typeof usePurchaseOrderSummarySuspenseQuery>;
export type PurchaseOrderSummaryQueryResult = Apollo.QueryResult<PurchaseOrderSummaryQuery, PurchaseOrderSummaryQueryVariables>;
export const CreatePurchaseOrderDocument = gql`
    mutation CreatePurchaseOrder($createPurchaseOrderDto: CreatePurchaseOrderDTO!) {
  createPurchaseOrder(createPurchaseOrderDTO: $createPurchaseOrderDto) {
    id
    orderType
    poType
    status
  }
}
    `;
export type CreatePurchaseOrderMutationFn = Apollo.MutationFunction<CreatePurchaseOrderMutation, CreatePurchaseOrderMutationVariables>;

/**
 * __useCreatePurchaseOrderMutation__
 *
 * To run a mutation, you first call `useCreatePurchaseOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePurchaseOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPurchaseOrderMutation, { data, loading, error }] = useCreatePurchaseOrderMutation({
 *   variables: {
 *      createPurchaseOrderDto: // value for 'createPurchaseOrderDto'
 *   },
 * });
 */
export function useCreatePurchaseOrderMutation(baseOptions?: Apollo.MutationHookOptions<CreatePurchaseOrderMutation, CreatePurchaseOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePurchaseOrderMutation, CreatePurchaseOrderMutationVariables>(CreatePurchaseOrderDocument, options);
      }
export type CreatePurchaseOrderMutationHookResult = ReturnType<typeof useCreatePurchaseOrderMutation>;
export type CreatePurchaseOrderMutationResult = Apollo.MutationResult<CreatePurchaseOrderMutation>;
export type CreatePurchaseOrderMutationOptions = Apollo.BaseMutationOptions<CreatePurchaseOrderMutation, CreatePurchaseOrderMutationVariables>;
export const ClosePurchaseOrderDocument = gql`
    mutation ClosePurchaseOrder($closePurchaseOrderId: String!) {
  closePurchaseOrder(id: $closePurchaseOrderId) {
    id
  }
}
    `;
export type ClosePurchaseOrderMutationFn = Apollo.MutationFunction<ClosePurchaseOrderMutation, ClosePurchaseOrderMutationVariables>;

/**
 * __useClosePurchaseOrderMutation__
 *
 * To run a mutation, you first call `useClosePurchaseOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClosePurchaseOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closePurchaseOrderMutation, { data, loading, error }] = useClosePurchaseOrderMutation({
 *   variables: {
 *      closePurchaseOrderId: // value for 'closePurchaseOrderId'
 *   },
 * });
 */
export function useClosePurchaseOrderMutation(baseOptions?: Apollo.MutationHookOptions<ClosePurchaseOrderMutation, ClosePurchaseOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClosePurchaseOrderMutation, ClosePurchaseOrderMutationVariables>(ClosePurchaseOrderDocument, options);
      }
export type ClosePurchaseOrderMutationHookResult = ReturnType<typeof useClosePurchaseOrderMutation>;
export type ClosePurchaseOrderMutationResult = Apollo.MutationResult<ClosePurchaseOrderMutation>;
export type ClosePurchaseOrderMutationOptions = Apollo.BaseMutationOptions<ClosePurchaseOrderMutation, ClosePurchaseOrderMutationVariables>;
export const GetPurchaseOrdersListingDocument = gql`
    query GetPurchaseOrdersListing($locationId: String!, $page: Int!, $limit: Int!, $sort: [SortCondition!], $filter: [FilterGroup!]) {
  getPurchaseOrders(
    locationId: $locationId
    page: $page
    limit: $limit
    sort: $sort
    filter: $filter
  ) {
    data {
      id
      secondaryId
      netAmount
      orderType
      salesTax
      status
      totalAmount
      totalDiscount
      createdAt
      createdByName
      updatedAt
      vendor {
        id
        name
      }
      deliveryLocation {
        id
        name
      }
    }
    meta {
      totalCount
      page
      limit
    }
  }
}
    `;

/**
 * __useGetPurchaseOrdersListingQuery__
 *
 * To run a query within a React component, call `useGetPurchaseOrdersListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPurchaseOrdersListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPurchaseOrdersListingQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetPurchaseOrdersListingQuery(baseOptions: Apollo.QueryHookOptions<GetPurchaseOrdersListingQuery, GetPurchaseOrdersListingQueryVariables> & ({ variables: GetPurchaseOrdersListingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPurchaseOrdersListingQuery, GetPurchaseOrdersListingQueryVariables>(GetPurchaseOrdersListingDocument, options);
      }
export function useGetPurchaseOrdersListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPurchaseOrdersListingQuery, GetPurchaseOrdersListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPurchaseOrdersListingQuery, GetPurchaseOrdersListingQueryVariables>(GetPurchaseOrdersListingDocument, options);
        }
// @ts-ignore
export function useGetPurchaseOrdersListingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPurchaseOrdersListingQuery, GetPurchaseOrdersListingQueryVariables>): Apollo.UseSuspenseQueryResult<GetPurchaseOrdersListingQuery, GetPurchaseOrdersListingQueryVariables>;
export function useGetPurchaseOrdersListingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPurchaseOrdersListingQuery, GetPurchaseOrdersListingQueryVariables>): Apollo.UseSuspenseQueryResult<GetPurchaseOrdersListingQuery | undefined, GetPurchaseOrdersListingQueryVariables>;
export function useGetPurchaseOrdersListingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPurchaseOrdersListingQuery, GetPurchaseOrdersListingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPurchaseOrdersListingQuery, GetPurchaseOrdersListingQueryVariables>(GetPurchaseOrdersListingDocument, options);
        }
export type GetPurchaseOrdersListingQueryHookResult = ReturnType<typeof useGetPurchaseOrdersListingQuery>;
export type GetPurchaseOrdersListingLazyQueryHookResult = ReturnType<typeof useGetPurchaseOrdersListingLazyQuery>;
export type GetPurchaseOrdersListingSuspenseQueryHookResult = ReturnType<typeof useGetPurchaseOrdersListingSuspenseQuery>;
export type GetPurchaseOrdersListingQueryResult = Apollo.QueryResult<GetPurchaseOrdersListingQuery, GetPurchaseOrdersListingQueryVariables>;
export const GetPurchaseOrderForCreateGrnDocument = gql`
    query GetPurchaseOrderForCreateGRN($secondaryId: Int!) {
  getPurchaseOrder(secondaryId: $secondaryId) {
    id
    secondaryId
    status
    createdAt
    orderItems {
      id
      secondaryId
      foc
      grnRemainingQuantity
      gstPercentage
      itemConversion
      product {
        id
        name
        secondaryId
        uomFactor
        isManufacturerTracking
        trackingLevel
        gtin
        manufacturer {
          name
        }
      }
      requiredQuantity
      salesTaxPercentage
      totalPrice
      tradeDiscountPercentage
      tradeDiscountValue
      tradePrice
      tradePriceAfterApplyingGst
      tradePriceAfterTradeDiscount
    }
    vendor {
      id
      secondaryId
      name
    }
  }
}
    `;

/**
 * __useGetPurchaseOrderForCreateGrnQuery__
 *
 * To run a query within a React component, call `useGetPurchaseOrderForCreateGrnQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPurchaseOrderForCreateGrnQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPurchaseOrderForCreateGrnQuery({
 *   variables: {
 *      secondaryId: // value for 'secondaryId'
 *   },
 * });
 */
export function useGetPurchaseOrderForCreateGrnQuery(baseOptions: Apollo.QueryHookOptions<GetPurchaseOrderForCreateGrnQuery, GetPurchaseOrderForCreateGrnQueryVariables> & ({ variables: GetPurchaseOrderForCreateGrnQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPurchaseOrderForCreateGrnQuery, GetPurchaseOrderForCreateGrnQueryVariables>(GetPurchaseOrderForCreateGrnDocument, options);
      }
export function useGetPurchaseOrderForCreateGrnLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPurchaseOrderForCreateGrnQuery, GetPurchaseOrderForCreateGrnQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPurchaseOrderForCreateGrnQuery, GetPurchaseOrderForCreateGrnQueryVariables>(GetPurchaseOrderForCreateGrnDocument, options);
        }
// @ts-ignore
export function useGetPurchaseOrderForCreateGrnSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPurchaseOrderForCreateGrnQuery, GetPurchaseOrderForCreateGrnQueryVariables>): Apollo.UseSuspenseQueryResult<GetPurchaseOrderForCreateGrnQuery, GetPurchaseOrderForCreateGrnQueryVariables>;
export function useGetPurchaseOrderForCreateGrnSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPurchaseOrderForCreateGrnQuery, GetPurchaseOrderForCreateGrnQueryVariables>): Apollo.UseSuspenseQueryResult<GetPurchaseOrderForCreateGrnQuery | undefined, GetPurchaseOrderForCreateGrnQueryVariables>;
export function useGetPurchaseOrderForCreateGrnSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPurchaseOrderForCreateGrnQuery, GetPurchaseOrderForCreateGrnQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPurchaseOrderForCreateGrnQuery, GetPurchaseOrderForCreateGrnQueryVariables>(GetPurchaseOrderForCreateGrnDocument, options);
        }
export type GetPurchaseOrderForCreateGrnQueryHookResult = ReturnType<typeof useGetPurchaseOrderForCreateGrnQuery>;
export type GetPurchaseOrderForCreateGrnLazyQueryHookResult = ReturnType<typeof useGetPurchaseOrderForCreateGrnLazyQuery>;
export type GetPurchaseOrderForCreateGrnSuspenseQueryHookResult = ReturnType<typeof useGetPurchaseOrderForCreateGrnSuspenseQuery>;
export type GetPurchaseOrderForCreateGrnQueryResult = Apollo.QueryResult<GetPurchaseOrderForCreateGrnQuery, GetPurchaseOrderForCreateGrnQueryVariables>;
export const GetPurchaseOrderDetailsDocument = gql`
    query GetPurchaseOrderDetails($id: String!) {
  getPurchaseOrder(id: $id) {
    id
    expectedDeliveryDate
    netAmount
    orderType
    returnRfid
    salesTax
    status
    totalAmount
    totalDiscount
    additionalTerms
    createdAt
    createdByName
    designation
    secondaryId
    orderItems {
      foc
      grnRemainingQuantity
      gstPercentage
      id
      itemConversion
      requiredQuantity
      gstPercentage
      gstAmount
      totalPrice
      tradeDiscountPercentage
      tradeDiscountValue
      tradePrice
      tradePriceAfterApplyingGst
      tradePriceAfterTradeDiscount
      uom
      product {
        id
        name
        secondaryId
        manufacturer {
          id
          name
        }
      }
    }
    deliveryLocation {
      id
      name
    }
    vendor {
      id
      name
    }
  }
}
    `;

/**
 * __useGetPurchaseOrderDetailsQuery__
 *
 * To run a query within a React component, call `useGetPurchaseOrderDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPurchaseOrderDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPurchaseOrderDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPurchaseOrderDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetPurchaseOrderDetailsQuery, GetPurchaseOrderDetailsQueryVariables> & ({ variables: GetPurchaseOrderDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPurchaseOrderDetailsQuery, GetPurchaseOrderDetailsQueryVariables>(GetPurchaseOrderDetailsDocument, options);
      }
export function useGetPurchaseOrderDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPurchaseOrderDetailsQuery, GetPurchaseOrderDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPurchaseOrderDetailsQuery, GetPurchaseOrderDetailsQueryVariables>(GetPurchaseOrderDetailsDocument, options);
        }
// @ts-ignore
export function useGetPurchaseOrderDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPurchaseOrderDetailsQuery, GetPurchaseOrderDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPurchaseOrderDetailsQuery, GetPurchaseOrderDetailsQueryVariables>;
export function useGetPurchaseOrderDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPurchaseOrderDetailsQuery, GetPurchaseOrderDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPurchaseOrderDetailsQuery | undefined, GetPurchaseOrderDetailsQueryVariables>;
export function useGetPurchaseOrderDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPurchaseOrderDetailsQuery, GetPurchaseOrderDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPurchaseOrderDetailsQuery, GetPurchaseOrderDetailsQueryVariables>(GetPurchaseOrderDetailsDocument, options);
        }
export type GetPurchaseOrderDetailsQueryHookResult = ReturnType<typeof useGetPurchaseOrderDetailsQuery>;
export type GetPurchaseOrderDetailsLazyQueryHookResult = ReturnType<typeof useGetPurchaseOrderDetailsLazyQuery>;
export type GetPurchaseOrderDetailsSuspenseQueryHookResult = ReturnType<typeof useGetPurchaseOrderDetailsSuspenseQuery>;
export type GetPurchaseOrderDetailsQueryResult = Apollo.QueryResult<GetPurchaseOrderDetailsQuery, GetPurchaseOrderDetailsQueryVariables>;
export const GetLocationRegistersDocument = gql`
    query GetLocationRegisters($sort: [SortCondition!], $page: Int!, $locationId: String, $limit: Int!, $filter: [FilterGroup!]) {
  getLocationRegisters(
    sort: $sort
    page: $page
    locationId: $locationId
    limit: $limit
    filter: $filter
  ) {
    id
    name
    lastClosedBy {
      id
      lastName
      firstName
    }
    lastOpenedBy {
      lastName
      id
      firstName
    }
    lastClosedAt
    lastOpenedAt
    type
    secondaryId
    status
    session {
      id
      balance
      status
    }
  }
}
    `;

/**
 * __useGetLocationRegistersQuery__
 *
 * To run a query within a React component, call `useGetLocationRegistersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationRegistersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationRegistersQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      locationId: // value for 'locationId'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetLocationRegistersQuery(baseOptions: Apollo.QueryHookOptions<GetLocationRegistersQuery, GetLocationRegistersQueryVariables> & ({ variables: GetLocationRegistersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationRegistersQuery, GetLocationRegistersQueryVariables>(GetLocationRegistersDocument, options);
      }
export function useGetLocationRegistersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationRegistersQuery, GetLocationRegistersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationRegistersQuery, GetLocationRegistersQueryVariables>(GetLocationRegistersDocument, options);
        }
// @ts-ignore
export function useGetLocationRegistersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLocationRegistersQuery, GetLocationRegistersQueryVariables>): Apollo.UseSuspenseQueryResult<GetLocationRegistersQuery, GetLocationRegistersQueryVariables>;
export function useGetLocationRegistersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLocationRegistersQuery, GetLocationRegistersQueryVariables>): Apollo.UseSuspenseQueryResult<GetLocationRegistersQuery | undefined, GetLocationRegistersQueryVariables>;
export function useGetLocationRegistersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLocationRegistersQuery, GetLocationRegistersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLocationRegistersQuery, GetLocationRegistersQueryVariables>(GetLocationRegistersDocument, options);
        }
export type GetLocationRegistersQueryHookResult = ReturnType<typeof useGetLocationRegistersQuery>;
export type GetLocationRegistersLazyQueryHookResult = ReturnType<typeof useGetLocationRegistersLazyQuery>;
export type GetLocationRegistersSuspenseQueryHookResult = ReturnType<typeof useGetLocationRegistersSuspenseQuery>;
export type GetLocationRegistersQueryResult = Apollo.QueryResult<GetLocationRegistersQuery, GetLocationRegistersQueryVariables>;
export const GetLocationRegistersForListDocument = gql`
    query GetLocationRegistersForList($filter: [FilterGroup!], $limit: Int!, $locationId: String, $page: Int!, $sort: [SortCondition!]) {
  getLocationRegisters(
    filter: $filter
    limit: $limit
    locationId: $locationId
    page: $page
    sort: $sort
  ) {
    createdAt
    currency
    id
    name
    printMode
    secondaryId
    status
    terminalTaxId
    type
    updatedAt
  }
}
    `;

/**
 * __useGetLocationRegistersForListQuery__
 *
 * To run a query within a React component, call `useGetLocationRegistersForListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationRegistersForListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationRegistersForListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      locationId: // value for 'locationId'
 *      page: // value for 'page'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetLocationRegistersForListQuery(baseOptions: Apollo.QueryHookOptions<GetLocationRegistersForListQuery, GetLocationRegistersForListQueryVariables> & ({ variables: GetLocationRegistersForListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationRegistersForListQuery, GetLocationRegistersForListQueryVariables>(GetLocationRegistersForListDocument, options);
      }
export function useGetLocationRegistersForListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationRegistersForListQuery, GetLocationRegistersForListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationRegistersForListQuery, GetLocationRegistersForListQueryVariables>(GetLocationRegistersForListDocument, options);
        }
// @ts-ignore
export function useGetLocationRegistersForListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLocationRegistersForListQuery, GetLocationRegistersForListQueryVariables>): Apollo.UseSuspenseQueryResult<GetLocationRegistersForListQuery, GetLocationRegistersForListQueryVariables>;
export function useGetLocationRegistersForListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLocationRegistersForListQuery, GetLocationRegistersForListQueryVariables>): Apollo.UseSuspenseQueryResult<GetLocationRegistersForListQuery | undefined, GetLocationRegistersForListQueryVariables>;
export function useGetLocationRegistersForListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLocationRegistersForListQuery, GetLocationRegistersForListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLocationRegistersForListQuery, GetLocationRegistersForListQueryVariables>(GetLocationRegistersForListDocument, options);
        }
export type GetLocationRegistersForListQueryHookResult = ReturnType<typeof useGetLocationRegistersForListQuery>;
export type GetLocationRegistersForListLazyQueryHookResult = ReturnType<typeof useGetLocationRegistersForListLazyQuery>;
export type GetLocationRegistersForListSuspenseQueryHookResult = ReturnType<typeof useGetLocationRegistersForListSuspenseQuery>;
export type GetLocationRegistersForListQueryResult = Apollo.QueryResult<GetLocationRegistersForListQuery, GetLocationRegistersForListQueryVariables>;
export const GetLocationRegisterDocument = gql`
    query GetLocationRegister($getLocationRegisterId: String!, $locationId: String!) {
  getLocationRegister(id: $getLocationRegisterId, locationId: $locationId) {
    id
    name
    secondaryId
    printMode
    status
    type
    receiptTemplate
    lastClosedBy {
      id
      lastName
      firstName
    }
    lastOpenedBy {
      lastName
      id
      firstName
    }
    lastClosedAt
    lastOpenedAt
    session {
      id
      balance
      status
      note
      openingAmount
      secondaryId
      isAmountMatched
    }
    location {
      name
      id
    }
    currency
    terminalTaxId
  }
}
    `;

/**
 * __useGetLocationRegisterQuery__
 *
 * To run a query within a React component, call `useGetLocationRegisterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationRegisterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationRegisterQuery({
 *   variables: {
 *      getLocationRegisterId: // value for 'getLocationRegisterId'
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useGetLocationRegisterQuery(baseOptions: Apollo.QueryHookOptions<GetLocationRegisterQuery, GetLocationRegisterQueryVariables> & ({ variables: GetLocationRegisterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationRegisterQuery, GetLocationRegisterQueryVariables>(GetLocationRegisterDocument, options);
      }
export function useGetLocationRegisterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationRegisterQuery, GetLocationRegisterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationRegisterQuery, GetLocationRegisterQueryVariables>(GetLocationRegisterDocument, options);
        }
// @ts-ignore
export function useGetLocationRegisterSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLocationRegisterQuery, GetLocationRegisterQueryVariables>): Apollo.UseSuspenseQueryResult<GetLocationRegisterQuery, GetLocationRegisterQueryVariables>;
export function useGetLocationRegisterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLocationRegisterQuery, GetLocationRegisterQueryVariables>): Apollo.UseSuspenseQueryResult<GetLocationRegisterQuery | undefined, GetLocationRegisterQueryVariables>;
export function useGetLocationRegisterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLocationRegisterQuery, GetLocationRegisterQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLocationRegisterQuery, GetLocationRegisterQueryVariables>(GetLocationRegisterDocument, options);
        }
export type GetLocationRegisterQueryHookResult = ReturnType<typeof useGetLocationRegisterQuery>;
export type GetLocationRegisterLazyQueryHookResult = ReturnType<typeof useGetLocationRegisterLazyQuery>;
export type GetLocationRegisterSuspenseQueryHookResult = ReturnType<typeof useGetLocationRegisterSuspenseQuery>;
export type GetLocationRegisterQueryResult = Apollo.QueryResult<GetLocationRegisterQuery, GetLocationRegisterQueryVariables>;
export const OpenLocationRegisterDocument = gql`
    mutation OpenLocationRegister($createLocationRegisterSessionDto: CreateLocationRegisterSessionDto!, $registerId: String!) {
  openLocationRegister(
    createLocationRegisterSessionDto: $createLocationRegisterSessionDto
    registerId: $registerId
  ) {
    id
  }
}
    `;
export type OpenLocationRegisterMutationFn = Apollo.MutationFunction<OpenLocationRegisterMutation, OpenLocationRegisterMutationVariables>;

/**
 * __useOpenLocationRegisterMutation__
 *
 * To run a mutation, you first call `useOpenLocationRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOpenLocationRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [openLocationRegisterMutation, { data, loading, error }] = useOpenLocationRegisterMutation({
 *   variables: {
 *      createLocationRegisterSessionDto: // value for 'createLocationRegisterSessionDto'
 *      registerId: // value for 'registerId'
 *   },
 * });
 */
export function useOpenLocationRegisterMutation(baseOptions?: Apollo.MutationHookOptions<OpenLocationRegisterMutation, OpenLocationRegisterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OpenLocationRegisterMutation, OpenLocationRegisterMutationVariables>(OpenLocationRegisterDocument, options);
      }
export type OpenLocationRegisterMutationHookResult = ReturnType<typeof useOpenLocationRegisterMutation>;
export type OpenLocationRegisterMutationResult = Apollo.MutationResult<OpenLocationRegisterMutation>;
export type OpenLocationRegisterMutationOptions = Apollo.BaseMutationOptions<OpenLocationRegisterMutation, OpenLocationRegisterMutationVariables>;
export const CloseLocationRegisterDocument = gql`
    mutation CloseLocationRegister($closeLocationRegisterSessionDto: CloseLocationRegisterSessionDto!, $registerSessionId: String!) {
  closeLocationRegister(
    closeLocationRegisterSessionDto: $closeLocationRegisterSessionDto
    registerSessionId: $registerSessionId
  ) {
    id
  }
}
    `;
export type CloseLocationRegisterMutationFn = Apollo.MutationFunction<CloseLocationRegisterMutation, CloseLocationRegisterMutationVariables>;

/**
 * __useCloseLocationRegisterMutation__
 *
 * To run a mutation, you first call `useCloseLocationRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseLocationRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeLocationRegisterMutation, { data, loading, error }] = useCloseLocationRegisterMutation({
 *   variables: {
 *      closeLocationRegisterSessionDto: // value for 'closeLocationRegisterSessionDto'
 *      registerSessionId: // value for 'registerSessionId'
 *   },
 * });
 */
export function useCloseLocationRegisterMutation(baseOptions?: Apollo.MutationHookOptions<CloseLocationRegisterMutation, CloseLocationRegisterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloseLocationRegisterMutation, CloseLocationRegisterMutationVariables>(CloseLocationRegisterDocument, options);
      }
export type CloseLocationRegisterMutationHookResult = ReturnType<typeof useCloseLocationRegisterMutation>;
export type CloseLocationRegisterMutationResult = Apollo.MutationResult<CloseLocationRegisterMutation>;
export type CloseLocationRegisterMutationOptions = Apollo.BaseMutationOptions<CloseLocationRegisterMutation, CloseLocationRegisterMutationVariables>;
export const GetLocationSessionSummaryByIdDocument = gql`
    query GetLocationSessionSummaryById($sessionId: String!) {
  getLocationSessionSummaryById(sessionId: $sessionId) {
    discount
    gross
    orderCount
    paymentMethod
    netAmount
    returned
    netSale
    tax
  }
}
    `;

/**
 * __useGetLocationSessionSummaryByIdQuery__
 *
 * To run a query within a React component, call `useGetLocationSessionSummaryByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationSessionSummaryByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationSessionSummaryByIdQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useGetLocationSessionSummaryByIdQuery(baseOptions: Apollo.QueryHookOptions<GetLocationSessionSummaryByIdQuery, GetLocationSessionSummaryByIdQueryVariables> & ({ variables: GetLocationSessionSummaryByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationSessionSummaryByIdQuery, GetLocationSessionSummaryByIdQueryVariables>(GetLocationSessionSummaryByIdDocument, options);
      }
export function useGetLocationSessionSummaryByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationSessionSummaryByIdQuery, GetLocationSessionSummaryByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationSessionSummaryByIdQuery, GetLocationSessionSummaryByIdQueryVariables>(GetLocationSessionSummaryByIdDocument, options);
        }
// @ts-ignore
export function useGetLocationSessionSummaryByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLocationSessionSummaryByIdQuery, GetLocationSessionSummaryByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetLocationSessionSummaryByIdQuery, GetLocationSessionSummaryByIdQueryVariables>;
export function useGetLocationSessionSummaryByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLocationSessionSummaryByIdQuery, GetLocationSessionSummaryByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetLocationSessionSummaryByIdQuery | undefined, GetLocationSessionSummaryByIdQueryVariables>;
export function useGetLocationSessionSummaryByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLocationSessionSummaryByIdQuery, GetLocationSessionSummaryByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLocationSessionSummaryByIdQuery, GetLocationSessionSummaryByIdQueryVariables>(GetLocationSessionSummaryByIdDocument, options);
        }
export type GetLocationSessionSummaryByIdQueryHookResult = ReturnType<typeof useGetLocationSessionSummaryByIdQuery>;
export type GetLocationSessionSummaryByIdLazyQueryHookResult = ReturnType<typeof useGetLocationSessionSummaryByIdLazyQuery>;
export type GetLocationSessionSummaryByIdSuspenseQueryHookResult = ReturnType<typeof useGetLocationSessionSummaryByIdSuspenseQuery>;
export type GetLocationSessionSummaryByIdQueryResult = Apollo.QueryResult<GetLocationSessionSummaryByIdQuery, GetLocationSessionSummaryByIdQueryVariables>;
export const GetZReportByLocationAndDateDocument = gql`
    query GetZReportByLocationAndDate($endDate: String!, $locationId: String!, $startDate: String!) {
  getZReportByLocationAndDate(
    endDate: $endDate
    locationId: $locationId
    startDate: $startDate
  ) {
    discount
    gross
    netAmount
    netSale
    orderCount
    paymentMethod
    returned
    tax
    integrationCharges
    platformFee
    shippingFee
  }
}
    `;

/**
 * __useGetZReportByLocationAndDateQuery__
 *
 * To run a query within a React component, call `useGetZReportByLocationAndDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetZReportByLocationAndDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetZReportByLocationAndDateQuery({
 *   variables: {
 *      endDate: // value for 'endDate'
 *      locationId: // value for 'locationId'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useGetZReportByLocationAndDateQuery(baseOptions: Apollo.QueryHookOptions<GetZReportByLocationAndDateQuery, GetZReportByLocationAndDateQueryVariables> & ({ variables: GetZReportByLocationAndDateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetZReportByLocationAndDateQuery, GetZReportByLocationAndDateQueryVariables>(GetZReportByLocationAndDateDocument, options);
      }
export function useGetZReportByLocationAndDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetZReportByLocationAndDateQuery, GetZReportByLocationAndDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetZReportByLocationAndDateQuery, GetZReportByLocationAndDateQueryVariables>(GetZReportByLocationAndDateDocument, options);
        }
// @ts-ignore
export function useGetZReportByLocationAndDateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetZReportByLocationAndDateQuery, GetZReportByLocationAndDateQueryVariables>): Apollo.UseSuspenseQueryResult<GetZReportByLocationAndDateQuery, GetZReportByLocationAndDateQueryVariables>;
export function useGetZReportByLocationAndDateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetZReportByLocationAndDateQuery, GetZReportByLocationAndDateQueryVariables>): Apollo.UseSuspenseQueryResult<GetZReportByLocationAndDateQuery | undefined, GetZReportByLocationAndDateQueryVariables>;
export function useGetZReportByLocationAndDateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetZReportByLocationAndDateQuery, GetZReportByLocationAndDateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetZReportByLocationAndDateQuery, GetZReportByLocationAndDateQueryVariables>(GetZReportByLocationAndDateDocument, options);
        }
export type GetZReportByLocationAndDateQueryHookResult = ReturnType<typeof useGetZReportByLocationAndDateQuery>;
export type GetZReportByLocationAndDateLazyQueryHookResult = ReturnType<typeof useGetZReportByLocationAndDateLazyQuery>;
export type GetZReportByLocationAndDateSuspenseQueryHookResult = ReturnType<typeof useGetZReportByLocationAndDateSuspenseQuery>;
export type GetZReportByLocationAndDateQueryResult = Apollo.QueryResult<GetZReportByLocationAndDateQuery, GetZReportByLocationAndDateQueryVariables>;
export const GetLocationRegisterSessionsDocument = gql`
    query GetLocationRegisterSessions($registerId: String, $filter: [FilterGroup!], $limit: Int!, $locationId: String, $page: Int!, $sort: [SortCondition!]) {
  getLocationRegisterSessions(
    registerId: $registerId
    filter: $filter
    limit: $limit
    locationId: $locationId
    page: $page
    sort: $sort
  ) {
    meta {
      limit
      page
      totalCount
    }
    data {
      id
      secondaryId
      balance
      closedAt
      closingAmount
      isAmountMatched
      openedAt
      openingAmount
      register {
        name
      }
      status
      closedBy {
        firstName
        lastName
      }
      openedBy {
        lastName
        firstName
      }
    }
  }
}
    `;

/**
 * __useGetLocationRegisterSessionsQuery__
 *
 * To run a query within a React component, call `useGetLocationRegisterSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationRegisterSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationRegisterSessionsQuery({
 *   variables: {
 *      registerId: // value for 'registerId'
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      locationId: // value for 'locationId'
 *      page: // value for 'page'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetLocationRegisterSessionsQuery(baseOptions: Apollo.QueryHookOptions<GetLocationRegisterSessionsQuery, GetLocationRegisterSessionsQueryVariables> & ({ variables: GetLocationRegisterSessionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationRegisterSessionsQuery, GetLocationRegisterSessionsQueryVariables>(GetLocationRegisterSessionsDocument, options);
      }
export function useGetLocationRegisterSessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationRegisterSessionsQuery, GetLocationRegisterSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationRegisterSessionsQuery, GetLocationRegisterSessionsQueryVariables>(GetLocationRegisterSessionsDocument, options);
        }
// @ts-ignore
export function useGetLocationRegisterSessionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLocationRegisterSessionsQuery, GetLocationRegisterSessionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetLocationRegisterSessionsQuery, GetLocationRegisterSessionsQueryVariables>;
export function useGetLocationRegisterSessionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLocationRegisterSessionsQuery, GetLocationRegisterSessionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetLocationRegisterSessionsQuery | undefined, GetLocationRegisterSessionsQueryVariables>;
export function useGetLocationRegisterSessionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLocationRegisterSessionsQuery, GetLocationRegisterSessionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLocationRegisterSessionsQuery, GetLocationRegisterSessionsQueryVariables>(GetLocationRegisterSessionsDocument, options);
        }
export type GetLocationRegisterSessionsQueryHookResult = ReturnType<typeof useGetLocationRegisterSessionsQuery>;
export type GetLocationRegisterSessionsLazyQueryHookResult = ReturnType<typeof useGetLocationRegisterSessionsLazyQuery>;
export type GetLocationRegisterSessionsSuspenseQueryHookResult = ReturnType<typeof useGetLocationRegisterSessionsSuspenseQuery>;
export type GetLocationRegisterSessionsQueryResult = Apollo.QueryResult<GetLocationRegisterSessionsQuery, GetLocationRegisterSessionsQueryVariables>;
export const GetLocationRegisterBalanceHistoryBySessionIdDocument = gql`
    query GetLocationRegisterBalanceHistoryBySessionId($sessionId: String!, $limit: Int!, $page: Int!, $locationId: String, $sort: [SortCondition!]) {
  getLocationRegisterBalanceHistoryBySessionId(
    sessionId: $sessionId
    limit: $limit
    page: $page
    locationId: $locationId
    sort: $sort
  ) {
    data {
      amount
      createdAt
      id
      note
    }
    meta {
      limit
      page
      total
      totalCount
    }
  }
}
    `;

/**
 * __useGetLocationRegisterBalanceHistoryBySessionIdQuery__
 *
 * To run a query within a React component, call `useGetLocationRegisterBalanceHistoryBySessionIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationRegisterBalanceHistoryBySessionIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationRegisterBalanceHistoryBySessionIdQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      locationId: // value for 'locationId'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetLocationRegisterBalanceHistoryBySessionIdQuery(baseOptions: Apollo.QueryHookOptions<GetLocationRegisterBalanceHistoryBySessionIdQuery, GetLocationRegisterBalanceHistoryBySessionIdQueryVariables> & ({ variables: GetLocationRegisterBalanceHistoryBySessionIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationRegisterBalanceHistoryBySessionIdQuery, GetLocationRegisterBalanceHistoryBySessionIdQueryVariables>(GetLocationRegisterBalanceHistoryBySessionIdDocument, options);
      }
export function useGetLocationRegisterBalanceHistoryBySessionIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationRegisterBalanceHistoryBySessionIdQuery, GetLocationRegisterBalanceHistoryBySessionIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationRegisterBalanceHistoryBySessionIdQuery, GetLocationRegisterBalanceHistoryBySessionIdQueryVariables>(GetLocationRegisterBalanceHistoryBySessionIdDocument, options);
        }
// @ts-ignore
export function useGetLocationRegisterBalanceHistoryBySessionIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLocationRegisterBalanceHistoryBySessionIdQuery, GetLocationRegisterBalanceHistoryBySessionIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetLocationRegisterBalanceHistoryBySessionIdQuery, GetLocationRegisterBalanceHistoryBySessionIdQueryVariables>;
export function useGetLocationRegisterBalanceHistoryBySessionIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLocationRegisterBalanceHistoryBySessionIdQuery, GetLocationRegisterBalanceHistoryBySessionIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetLocationRegisterBalanceHistoryBySessionIdQuery | undefined, GetLocationRegisterBalanceHistoryBySessionIdQueryVariables>;
export function useGetLocationRegisterBalanceHistoryBySessionIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLocationRegisterBalanceHistoryBySessionIdQuery, GetLocationRegisterBalanceHistoryBySessionIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLocationRegisterBalanceHistoryBySessionIdQuery, GetLocationRegisterBalanceHistoryBySessionIdQueryVariables>(GetLocationRegisterBalanceHistoryBySessionIdDocument, options);
        }
export type GetLocationRegisterBalanceHistoryBySessionIdQueryHookResult = ReturnType<typeof useGetLocationRegisterBalanceHistoryBySessionIdQuery>;
export type GetLocationRegisterBalanceHistoryBySessionIdLazyQueryHookResult = ReturnType<typeof useGetLocationRegisterBalanceHistoryBySessionIdLazyQuery>;
export type GetLocationRegisterBalanceHistoryBySessionIdSuspenseQueryHookResult = ReturnType<typeof useGetLocationRegisterBalanceHistoryBySessionIdSuspenseQuery>;
export type GetLocationRegisterBalanceHistoryBySessionIdQueryResult = Apollo.QueryResult<GetLocationRegisterBalanceHistoryBySessionIdQuery, GetLocationRegisterBalanceHistoryBySessionIdQueryVariables>;
export const GetRegisterSummaryByIdDocument = gql`
    query GetRegisterSummaryById($sessionId: String!) {
  getRegisterSummaryById(sessionId: $sessionId) {
    balance
    closingAmount
    id
    openingAmount
    returnTotalAmount
    totalAdditions
    totalAmount
    totalDiscount
    totalWithdrawals
    cashRefundTotal
  }
}
    `;

/**
 * __useGetRegisterSummaryByIdQuery__
 *
 * To run a query within a React component, call `useGetRegisterSummaryByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegisterSummaryByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegisterSummaryByIdQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useGetRegisterSummaryByIdQuery(baseOptions: Apollo.QueryHookOptions<GetRegisterSummaryByIdQuery, GetRegisterSummaryByIdQueryVariables> & ({ variables: GetRegisterSummaryByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRegisterSummaryByIdQuery, GetRegisterSummaryByIdQueryVariables>(GetRegisterSummaryByIdDocument, options);
      }
export function useGetRegisterSummaryByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRegisterSummaryByIdQuery, GetRegisterSummaryByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRegisterSummaryByIdQuery, GetRegisterSummaryByIdQueryVariables>(GetRegisterSummaryByIdDocument, options);
        }
// @ts-ignore
export function useGetRegisterSummaryByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRegisterSummaryByIdQuery, GetRegisterSummaryByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetRegisterSummaryByIdQuery, GetRegisterSummaryByIdQueryVariables>;
export function useGetRegisterSummaryByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRegisterSummaryByIdQuery, GetRegisterSummaryByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetRegisterSummaryByIdQuery | undefined, GetRegisterSummaryByIdQueryVariables>;
export function useGetRegisterSummaryByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRegisterSummaryByIdQuery, GetRegisterSummaryByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRegisterSummaryByIdQuery, GetRegisterSummaryByIdQueryVariables>(GetRegisterSummaryByIdDocument, options);
        }
export type GetRegisterSummaryByIdQueryHookResult = ReturnType<typeof useGetRegisterSummaryByIdQuery>;
export type GetRegisterSummaryByIdLazyQueryHookResult = ReturnType<typeof useGetRegisterSummaryByIdLazyQuery>;
export type GetRegisterSummaryByIdSuspenseQueryHookResult = ReturnType<typeof useGetRegisterSummaryByIdSuspenseQuery>;
export type GetRegisterSummaryByIdQueryResult = Apollo.QueryResult<GetRegisterSummaryByIdQuery, GetRegisterSummaryByIdQueryVariables>;
export const CreateLocationRegisterDocument = gql`
    mutation CreateLocationRegister($createLocationRegisterDto: CreateLocationRegisterDTO!) {
  createLocationRegister(createLocationRegisterDTO: $createLocationRegisterDto) {
    id
  }
}
    `;
export type CreateLocationRegisterMutationFn = Apollo.MutationFunction<CreateLocationRegisterMutation, CreateLocationRegisterMutationVariables>;

/**
 * __useCreateLocationRegisterMutation__
 *
 * To run a mutation, you first call `useCreateLocationRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLocationRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLocationRegisterMutation, { data, loading, error }] = useCreateLocationRegisterMutation({
 *   variables: {
 *      createLocationRegisterDto: // value for 'createLocationRegisterDto'
 *   },
 * });
 */
export function useCreateLocationRegisterMutation(baseOptions?: Apollo.MutationHookOptions<CreateLocationRegisterMutation, CreateLocationRegisterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLocationRegisterMutation, CreateLocationRegisterMutationVariables>(CreateLocationRegisterDocument, options);
      }
export type CreateLocationRegisterMutationHookResult = ReturnType<typeof useCreateLocationRegisterMutation>;
export type CreateLocationRegisterMutationResult = Apollo.MutationResult<CreateLocationRegisterMutation>;
export type CreateLocationRegisterMutationOptions = Apollo.BaseMutationOptions<CreateLocationRegisterMutation, CreateLocationRegisterMutationVariables>;
export const UpdateLocationRegisterDocument = gql`
    mutation UpdateLocationRegister($updateLocationRegisterDto: UpdateLocationRegisterDTO!) {
  updateLocationRegister(updateLocationRegisterDTO: $updateLocationRegisterDto) {
    id
  }
}
    `;
export type UpdateLocationRegisterMutationFn = Apollo.MutationFunction<UpdateLocationRegisterMutation, UpdateLocationRegisterMutationVariables>;

/**
 * __useUpdateLocationRegisterMutation__
 *
 * To run a mutation, you first call `useUpdateLocationRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocationRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocationRegisterMutation, { data, loading, error }] = useUpdateLocationRegisterMutation({
 *   variables: {
 *      updateLocationRegisterDto: // value for 'updateLocationRegisterDto'
 *   },
 * });
 */
export function useUpdateLocationRegisterMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLocationRegisterMutation, UpdateLocationRegisterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLocationRegisterMutation, UpdateLocationRegisterMutationVariables>(UpdateLocationRegisterDocument, options);
      }
export type UpdateLocationRegisterMutationHookResult = ReturnType<typeof useUpdateLocationRegisterMutation>;
export type UpdateLocationRegisterMutationResult = Apollo.MutationResult<UpdateLocationRegisterMutation>;
export type UpdateLocationRegisterMutationOptions = Apollo.BaseMutationOptions<UpdateLocationRegisterMutation, UpdateLocationRegisterMutationVariables>;
export const GetLocationRegistersForOptionsDocument = gql`
    query GetLocationRegistersForOptions($locationId: String, $limit: Int!, $page: Int!) {
  getLocationRegisters(locationId: $locationId, limit: $limit, page: $page) {
    name
    id
  }
}
    `;

/**
 * __useGetLocationRegistersForOptionsQuery__
 *
 * To run a query within a React component, call `useGetLocationRegistersForOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationRegistersForOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationRegistersForOptionsQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGetLocationRegistersForOptionsQuery(baseOptions: Apollo.QueryHookOptions<GetLocationRegistersForOptionsQuery, GetLocationRegistersForOptionsQueryVariables> & ({ variables: GetLocationRegistersForOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationRegistersForOptionsQuery, GetLocationRegistersForOptionsQueryVariables>(GetLocationRegistersForOptionsDocument, options);
      }
export function useGetLocationRegistersForOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationRegistersForOptionsQuery, GetLocationRegistersForOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationRegistersForOptionsQuery, GetLocationRegistersForOptionsQueryVariables>(GetLocationRegistersForOptionsDocument, options);
        }
// @ts-ignore
export function useGetLocationRegistersForOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLocationRegistersForOptionsQuery, GetLocationRegistersForOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetLocationRegistersForOptionsQuery, GetLocationRegistersForOptionsQueryVariables>;
export function useGetLocationRegistersForOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLocationRegistersForOptionsQuery, GetLocationRegistersForOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetLocationRegistersForOptionsQuery | undefined, GetLocationRegistersForOptionsQueryVariables>;
export function useGetLocationRegistersForOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLocationRegistersForOptionsQuery, GetLocationRegistersForOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLocationRegistersForOptionsQuery, GetLocationRegistersForOptionsQueryVariables>(GetLocationRegistersForOptionsDocument, options);
        }
export type GetLocationRegistersForOptionsQueryHookResult = ReturnType<typeof useGetLocationRegistersForOptionsQuery>;
export type GetLocationRegistersForOptionsLazyQueryHookResult = ReturnType<typeof useGetLocationRegistersForOptionsLazyQuery>;
export type GetLocationRegistersForOptionsSuspenseQueryHookResult = ReturnType<typeof useGetLocationRegistersForOptionsSuspenseQuery>;
export type GetLocationRegistersForOptionsQueryResult = Apollo.QueryResult<GetLocationRegistersForOptionsQuery, GetLocationRegistersForOptionsQueryVariables>;
export const AddWithdrawRegisterBalanceDocument = gql`
    mutation AddWithdrawRegisterBalance($registerSessionId: String!, $registerBalanceDto: AddWithdrawBalanceLocationRegisterSession!) {
  addWithdrawRegisterBalance(
    registerSessionId: $registerSessionId
    registerBalanceDTO: $registerBalanceDto
  ) {
    id
    balance
  }
}
    `;
export type AddWithdrawRegisterBalanceMutationFn = Apollo.MutationFunction<AddWithdrawRegisterBalanceMutation, AddWithdrawRegisterBalanceMutationVariables>;

/**
 * __useAddWithdrawRegisterBalanceMutation__
 *
 * To run a mutation, you first call `useAddWithdrawRegisterBalanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddWithdrawRegisterBalanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addWithdrawRegisterBalanceMutation, { data, loading, error }] = useAddWithdrawRegisterBalanceMutation({
 *   variables: {
 *      registerSessionId: // value for 'registerSessionId'
 *      registerBalanceDto: // value for 'registerBalanceDto'
 *   },
 * });
 */
export function useAddWithdrawRegisterBalanceMutation(baseOptions?: Apollo.MutationHookOptions<AddWithdrawRegisterBalanceMutation, AddWithdrawRegisterBalanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddWithdrawRegisterBalanceMutation, AddWithdrawRegisterBalanceMutationVariables>(AddWithdrawRegisterBalanceDocument, options);
      }
export type AddWithdrawRegisterBalanceMutationHookResult = ReturnType<typeof useAddWithdrawRegisterBalanceMutation>;
export type AddWithdrawRegisterBalanceMutationResult = Apollo.MutationResult<AddWithdrawRegisterBalanceMutation>;
export type AddWithdrawRegisterBalanceMutationOptions = Apollo.BaseMutationOptions<AddWithdrawRegisterBalanceMutation, AddWithdrawRegisterBalanceMutationVariables>;
export const GetProductLotStockReportDocument = gql`
    query GetProductLotStockReport($productStockReportDto: ProductStockReportArgs!) {
  getProductLotStockReport(productStockReportDTO: $productStockReportDto) {
    data {
      productId
      productSecondaryId
      productName
      manufacturerName
      categoryNames
      buyingUnit
      sellingUnit
      uomFactor
      taxRate
      locationName
      purchasingPrice
      tradePrice
      maximumRetailPrice
      packedStock
      packedSellableQuantity
      packedStockValue
      looseStock
      looseSellableQuantity
      looseStockValue
      totalStockQuantity
      totalStockValue
      totalTax
      totalStockValueExcludingTax
      inTransitStock
      inTransitQuantity
      inTransitStockValue
    }
    meta {
      limit
      page
      totalCount
    }
  }
}
    `;

/**
 * __useGetProductLotStockReportQuery__
 *
 * To run a query within a React component, call `useGetProductLotStockReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductLotStockReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductLotStockReportQuery({
 *   variables: {
 *      productStockReportDto: // value for 'productStockReportDto'
 *   },
 * });
 */
export function useGetProductLotStockReportQuery(baseOptions: Apollo.QueryHookOptions<GetProductLotStockReportQuery, GetProductLotStockReportQueryVariables> & ({ variables: GetProductLotStockReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductLotStockReportQuery, GetProductLotStockReportQueryVariables>(GetProductLotStockReportDocument, options);
      }
export function useGetProductLotStockReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductLotStockReportQuery, GetProductLotStockReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductLotStockReportQuery, GetProductLotStockReportQueryVariables>(GetProductLotStockReportDocument, options);
        }
// @ts-ignore
export function useGetProductLotStockReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductLotStockReportQuery, GetProductLotStockReportQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductLotStockReportQuery, GetProductLotStockReportQueryVariables>;
export function useGetProductLotStockReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductLotStockReportQuery, GetProductLotStockReportQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductLotStockReportQuery | undefined, GetProductLotStockReportQueryVariables>;
export function useGetProductLotStockReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductLotStockReportQuery, GetProductLotStockReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductLotStockReportQuery, GetProductLotStockReportQueryVariables>(GetProductLotStockReportDocument, options);
        }
export type GetProductLotStockReportQueryHookResult = ReturnType<typeof useGetProductLotStockReportQuery>;
export type GetProductLotStockReportLazyQueryHookResult = ReturnType<typeof useGetProductLotStockReportLazyQuery>;
export type GetProductLotStockReportSuspenseQueryHookResult = ReturnType<typeof useGetProductLotStockReportSuspenseQuery>;
export type GetProductLotStockReportQueryResult = Apollo.QueryResult<GetProductLotStockReportQuery, GetProductLotStockReportQueryVariables>;
export const GetRolesDocument = gql`
    query GetRoles($filter: [FilterGroup!], $limit: Int!, $locationId: String, $page: Int!, $sort: [SortCondition!]) {
  getRoles(
    filter: $filter
    limit: $limit
    locationId: $locationId
    page: $page
    sort: $sort
  ) {
    data {
      createdAt
      id
      name
      secondaryId
      status
      updatedAt
    }
    meta {
      limit
      page
      total
      totalCount
    }
  }
}
    `;

/**
 * __useGetRolesQuery__
 *
 * To run a query within a React component, call `useGetRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRolesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      locationId: // value for 'locationId'
 *      page: // value for 'page'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetRolesQuery(baseOptions: Apollo.QueryHookOptions<GetRolesQuery, GetRolesQueryVariables> & ({ variables: GetRolesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRolesQuery, GetRolesQueryVariables>(GetRolesDocument, options);
      }
export function useGetRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRolesQuery, GetRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRolesQuery, GetRolesQueryVariables>(GetRolesDocument, options);
        }
// @ts-ignore
export function useGetRolesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRolesQuery, GetRolesQueryVariables>): Apollo.UseSuspenseQueryResult<GetRolesQuery, GetRolesQueryVariables>;
export function useGetRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRolesQuery, GetRolesQueryVariables>): Apollo.UseSuspenseQueryResult<GetRolesQuery | undefined, GetRolesQueryVariables>;
export function useGetRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRolesQuery, GetRolesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRolesQuery, GetRolesQueryVariables>(GetRolesDocument, options);
        }
export type GetRolesQueryHookResult = ReturnType<typeof useGetRolesQuery>;
export type GetRolesLazyQueryHookResult = ReturnType<typeof useGetRolesLazyQuery>;
export type GetRolesSuspenseQueryHookResult = ReturnType<typeof useGetRolesSuspenseQuery>;
export type GetRolesQueryResult = Apollo.QueryResult<GetRolesQuery, GetRolesQueryVariables>;
export const GetPermissionsDocument = gql`
    query GetPermissions($limit: Int!, $page: Int!, $filter: [FilterGroup!], $locationId: String, $sort: [SortCondition!]) {
  getPermissions(
    limit: $limit
    page: $page
    filter: $filter
    locationId: $locationId
    sort: $sort
  ) {
    data {
      action
      createdAt
      id
      module
      permission
      status
      subModule
      updatedAt
    }
    meta {
      limit
      page
      total
      totalCount
    }
  }
}
    `;

/**
 * __useGetPermissionsQuery__
 *
 * To run a query within a React component, call `useGetPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPermissionsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *      locationId: // value for 'locationId'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetPermissionsQuery(baseOptions: Apollo.QueryHookOptions<GetPermissionsQuery, GetPermissionsQueryVariables> & ({ variables: GetPermissionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPermissionsQuery, GetPermissionsQueryVariables>(GetPermissionsDocument, options);
      }
export function useGetPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPermissionsQuery, GetPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPermissionsQuery, GetPermissionsQueryVariables>(GetPermissionsDocument, options);
        }
// @ts-ignore
export function useGetPermissionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPermissionsQuery, GetPermissionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPermissionsQuery, GetPermissionsQueryVariables>;
export function useGetPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPermissionsQuery, GetPermissionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPermissionsQuery | undefined, GetPermissionsQueryVariables>;
export function useGetPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPermissionsQuery, GetPermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPermissionsQuery, GetPermissionsQueryVariables>(GetPermissionsDocument, options);
        }
export type GetPermissionsQueryHookResult = ReturnType<typeof useGetPermissionsQuery>;
export type GetPermissionsLazyQueryHookResult = ReturnType<typeof useGetPermissionsLazyQuery>;
export type GetPermissionsSuspenseQueryHookResult = ReturnType<typeof useGetPermissionsSuspenseQuery>;
export type GetPermissionsQueryResult = Apollo.QueryResult<GetPermissionsQuery, GetPermissionsQueryVariables>;
export const CreateRoleDocument = gql`
    mutation CreateRole($roleInputDto: RoleInputDTO!) {
  createRole(roleInputDTO: $roleInputDto) {
    id
    status
    name
  }
}
    `;
export type CreateRoleMutationFn = Apollo.MutationFunction<CreateRoleMutation, CreateRoleMutationVariables>;

/**
 * __useCreateRoleMutation__
 *
 * To run a mutation, you first call `useCreateRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRoleMutation, { data, loading, error }] = useCreateRoleMutation({
 *   variables: {
 *      roleInputDto: // value for 'roleInputDto'
 *   },
 * });
 */
export function useCreateRoleMutation(baseOptions?: Apollo.MutationHookOptions<CreateRoleMutation, CreateRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRoleMutation, CreateRoleMutationVariables>(CreateRoleDocument, options);
      }
export type CreateRoleMutationHookResult = ReturnType<typeof useCreateRoleMutation>;
export type CreateRoleMutationResult = Apollo.MutationResult<CreateRoleMutation>;
export type CreateRoleMutationOptions = Apollo.BaseMutationOptions<CreateRoleMutation, CreateRoleMutationVariables>;
export const UpdateRoleDocument = gql`
    mutation UpdateRole($updateRoleId: String!, $roleInputDto: RoleInputDTO!) {
  updateRole(id: $updateRoleId, roleInputDTO: $roleInputDto)
}
    `;
export type UpdateRoleMutationFn = Apollo.MutationFunction<UpdateRoleMutation, UpdateRoleMutationVariables>;

/**
 * __useUpdateRoleMutation__
 *
 * To run a mutation, you first call `useUpdateRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoleMutation, { data, loading, error }] = useUpdateRoleMutation({
 *   variables: {
 *      updateRoleId: // value for 'updateRoleId'
 *      roleInputDto: // value for 'roleInputDto'
 *   },
 * });
 */
export function useUpdateRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRoleMutation, UpdateRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRoleMutation, UpdateRoleMutationVariables>(UpdateRoleDocument, options);
      }
export type UpdateRoleMutationHookResult = ReturnType<typeof useUpdateRoleMutation>;
export type UpdateRoleMutationResult = Apollo.MutationResult<UpdateRoleMutation>;
export type UpdateRoleMutationOptions = Apollo.BaseMutationOptions<UpdateRoleMutation, UpdateRoleMutationVariables>;
export const GetRoleDocument = gql`
    query GetRole($getRoleId: String!) {
  getRole(id: $getRoleId) {
    name
    status
    id
  }
}
    `;

/**
 * __useGetRoleQuery__
 *
 * To run a query within a React component, call `useGetRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoleQuery({
 *   variables: {
 *      getRoleId: // value for 'getRoleId'
 *   },
 * });
 */
export function useGetRoleQuery(baseOptions: Apollo.QueryHookOptions<GetRoleQuery, GetRoleQueryVariables> & ({ variables: GetRoleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRoleQuery, GetRoleQueryVariables>(GetRoleDocument, options);
      }
export function useGetRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRoleQuery, GetRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRoleQuery, GetRoleQueryVariables>(GetRoleDocument, options);
        }
// @ts-ignore
export function useGetRoleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRoleQuery, GetRoleQueryVariables>): Apollo.UseSuspenseQueryResult<GetRoleQuery, GetRoleQueryVariables>;
export function useGetRoleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRoleQuery, GetRoleQueryVariables>): Apollo.UseSuspenseQueryResult<GetRoleQuery | undefined, GetRoleQueryVariables>;
export function useGetRoleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRoleQuery, GetRoleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRoleQuery, GetRoleQueryVariables>(GetRoleDocument, options);
        }
export type GetRoleQueryHookResult = ReturnType<typeof useGetRoleQuery>;
export type GetRoleLazyQueryHookResult = ReturnType<typeof useGetRoleLazyQuery>;
export type GetRoleSuspenseQueryHookResult = ReturnType<typeof useGetRoleSuspenseQuery>;
export type GetRoleQueryResult = Apollo.QueryResult<GetRoleQuery, GetRoleQueryVariables>;
export const GetPermissionByRoleIdDocument = gql`
    query GetPermissionByRoleId($roleId: String!) {
  getPermissionByRoleId(role_id: $roleId) {
    action
    createdAt
    id
    module
    permission
    status
    subModule
    updatedAt
  }
}
    `;

/**
 * __useGetPermissionByRoleIdQuery__
 *
 * To run a query within a React component, call `useGetPermissionByRoleIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPermissionByRoleIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPermissionByRoleIdQuery({
 *   variables: {
 *      roleId: // value for 'roleId'
 *   },
 * });
 */
export function useGetPermissionByRoleIdQuery(baseOptions: Apollo.QueryHookOptions<GetPermissionByRoleIdQuery, GetPermissionByRoleIdQueryVariables> & ({ variables: GetPermissionByRoleIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPermissionByRoleIdQuery, GetPermissionByRoleIdQueryVariables>(GetPermissionByRoleIdDocument, options);
      }
export function useGetPermissionByRoleIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPermissionByRoleIdQuery, GetPermissionByRoleIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPermissionByRoleIdQuery, GetPermissionByRoleIdQueryVariables>(GetPermissionByRoleIdDocument, options);
        }
// @ts-ignore
export function useGetPermissionByRoleIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPermissionByRoleIdQuery, GetPermissionByRoleIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetPermissionByRoleIdQuery, GetPermissionByRoleIdQueryVariables>;
export function useGetPermissionByRoleIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPermissionByRoleIdQuery, GetPermissionByRoleIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetPermissionByRoleIdQuery | undefined, GetPermissionByRoleIdQueryVariables>;
export function useGetPermissionByRoleIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPermissionByRoleIdQuery, GetPermissionByRoleIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPermissionByRoleIdQuery, GetPermissionByRoleIdQueryVariables>(GetPermissionByRoleIdDocument, options);
        }
export type GetPermissionByRoleIdQueryHookResult = ReturnType<typeof useGetPermissionByRoleIdQuery>;
export type GetPermissionByRoleIdLazyQueryHookResult = ReturnType<typeof useGetPermissionByRoleIdLazyQuery>;
export type GetPermissionByRoleIdSuspenseQueryHookResult = ReturnType<typeof useGetPermissionByRoleIdSuspenseQuery>;
export type GetPermissionByRoleIdQueryResult = Apollo.QueryResult<GetPermissionByRoleIdQuery, GetPermissionByRoleIdQueryVariables>;
export const GetPermissionandandRoleByIdDocument = gql`
    query GetPermissionandandRoleById($roleId: String!) {
  roles: getRole(id: $roleId) {
    name
    status
    id
  }
  permissions: getPermissionByRoleId(role_id: $roleId) {
    action
    createdAt
    id
    module
    permission
    status
    subModule
    updatedAt
  }
}
    `;

/**
 * __useGetPermissionandandRoleByIdQuery__
 *
 * To run a query within a React component, call `useGetPermissionandandRoleByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPermissionandandRoleByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPermissionandandRoleByIdQuery({
 *   variables: {
 *      roleId: // value for 'roleId'
 *   },
 * });
 */
export function useGetPermissionandandRoleByIdQuery(baseOptions: Apollo.QueryHookOptions<GetPermissionandandRoleByIdQuery, GetPermissionandandRoleByIdQueryVariables> & ({ variables: GetPermissionandandRoleByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPermissionandandRoleByIdQuery, GetPermissionandandRoleByIdQueryVariables>(GetPermissionandandRoleByIdDocument, options);
      }
export function useGetPermissionandandRoleByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPermissionandandRoleByIdQuery, GetPermissionandandRoleByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPermissionandandRoleByIdQuery, GetPermissionandandRoleByIdQueryVariables>(GetPermissionandandRoleByIdDocument, options);
        }
// @ts-ignore
export function useGetPermissionandandRoleByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPermissionandandRoleByIdQuery, GetPermissionandandRoleByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetPermissionandandRoleByIdQuery, GetPermissionandandRoleByIdQueryVariables>;
export function useGetPermissionandandRoleByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPermissionandandRoleByIdQuery, GetPermissionandandRoleByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetPermissionandandRoleByIdQuery | undefined, GetPermissionandandRoleByIdQueryVariables>;
export function useGetPermissionandandRoleByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPermissionandandRoleByIdQuery, GetPermissionandandRoleByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPermissionandandRoleByIdQuery, GetPermissionandandRoleByIdQueryVariables>(GetPermissionandandRoleByIdDocument, options);
        }
export type GetPermissionandandRoleByIdQueryHookResult = ReturnType<typeof useGetPermissionandandRoleByIdQuery>;
export type GetPermissionandandRoleByIdLazyQueryHookResult = ReturnType<typeof useGetPermissionandandRoleByIdLazyQuery>;
export type GetPermissionandandRoleByIdSuspenseQueryHookResult = ReturnType<typeof useGetPermissionandandRoleByIdSuspenseQuery>;
export type GetPermissionandandRoleByIdQueryResult = Apollo.QueryResult<GetPermissionandandRoleByIdQuery, GetPermissionandandRoleByIdQueryVariables>;
export const AddOrRemovePermissionsByRoleIdDocument = gql`
    mutation AddOrRemovePermissionsByRoleId($roleId: String!, $permissionIds: [String!]!) {
  addOrRemovePermissionsByRoleId(roleId: $roleId, permissionIds: $permissionIds)
}
    `;
export type AddOrRemovePermissionsByRoleIdMutationFn = Apollo.MutationFunction<AddOrRemovePermissionsByRoleIdMutation, AddOrRemovePermissionsByRoleIdMutationVariables>;

/**
 * __useAddOrRemovePermissionsByRoleIdMutation__
 *
 * To run a mutation, you first call `useAddOrRemovePermissionsByRoleIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOrRemovePermissionsByRoleIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOrRemovePermissionsByRoleIdMutation, { data, loading, error }] = useAddOrRemovePermissionsByRoleIdMutation({
 *   variables: {
 *      roleId: // value for 'roleId'
 *      permissionIds: // value for 'permissionIds'
 *   },
 * });
 */
export function useAddOrRemovePermissionsByRoleIdMutation(baseOptions?: Apollo.MutationHookOptions<AddOrRemovePermissionsByRoleIdMutation, AddOrRemovePermissionsByRoleIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddOrRemovePermissionsByRoleIdMutation, AddOrRemovePermissionsByRoleIdMutationVariables>(AddOrRemovePermissionsByRoleIdDocument, options);
      }
export type AddOrRemovePermissionsByRoleIdMutationHookResult = ReturnType<typeof useAddOrRemovePermissionsByRoleIdMutation>;
export type AddOrRemovePermissionsByRoleIdMutationResult = Apollo.MutationResult<AddOrRemovePermissionsByRoleIdMutation>;
export type AddOrRemovePermissionsByRoleIdMutationOptions = Apollo.BaseMutationOptions<AddOrRemovePermissionsByRoleIdMutation, AddOrRemovePermissionsByRoleIdMutationVariables>;
export const UploadStockOperationItemImportDocument = gql`
    mutation UploadStockOperationItemImport($stockOperationId: String!, $fileType: StockOperationImportFileType!, $fileBase64: String!) {
  uploadStockOperationItemImport(
    stockOperationId: $stockOperationId
    fileType: $fileType
    fileBase64: $fileBase64
  ) {
    id
    status
  }
}
    `;
export type UploadStockOperationItemImportMutationFn = Apollo.MutationFunction<UploadStockOperationItemImportMutation, UploadStockOperationItemImportMutationVariables>;

/**
 * __useUploadStockOperationItemImportMutation__
 *
 * To run a mutation, you first call `useUploadStockOperationItemImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadStockOperationItemImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadStockOperationItemImportMutation, { data, loading, error }] = useUploadStockOperationItemImportMutation({
 *   variables: {
 *      stockOperationId: // value for 'stockOperationId'
 *      fileType: // value for 'fileType'
 *      fileBase64: // value for 'fileBase64'
 *   },
 * });
 */
export function useUploadStockOperationItemImportMutation(baseOptions?: Apollo.MutationHookOptions<UploadStockOperationItemImportMutation, UploadStockOperationItemImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadStockOperationItemImportMutation, UploadStockOperationItemImportMutationVariables>(UploadStockOperationItemImportDocument, options);
      }
export type UploadStockOperationItemImportMutationHookResult = ReturnType<typeof useUploadStockOperationItemImportMutation>;
export type UploadStockOperationItemImportMutationResult = Apollo.MutationResult<UploadStockOperationItemImportMutation>;
export type UploadStockOperationItemImportMutationOptions = Apollo.BaseMutationOptions<UploadStockOperationItemImportMutation, UploadStockOperationItemImportMutationVariables>;
export const StockOperationItemImportJobDocument = gql`
    query StockOperationItemImportJob($importJobId: String!) {
  stockOperationItemImportJob(importJobId: $importJobId) {
    id
    status
    totalRows
    processedRows
    successCount
    errorCount
    errors {
      row
      message
      gtin
      secondaryId
      skuCode
      quantity
    }
    failureReason
  }
}
    `;

/**
 * __useStockOperationItemImportJobQuery__
 *
 * To run a query within a React component, call `useStockOperationItemImportJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useStockOperationItemImportJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStockOperationItemImportJobQuery({
 *   variables: {
 *      importJobId: // value for 'importJobId'
 *   },
 * });
 */
export function useStockOperationItemImportJobQuery(baseOptions: Apollo.QueryHookOptions<StockOperationItemImportJobQuery, StockOperationItemImportJobQueryVariables> & ({ variables: StockOperationItemImportJobQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StockOperationItemImportJobQuery, StockOperationItemImportJobQueryVariables>(StockOperationItemImportJobDocument, options);
      }
export function useStockOperationItemImportJobLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StockOperationItemImportJobQuery, StockOperationItemImportJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StockOperationItemImportJobQuery, StockOperationItemImportJobQueryVariables>(StockOperationItemImportJobDocument, options);
        }
// @ts-ignore
export function useStockOperationItemImportJobSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StockOperationItemImportJobQuery, StockOperationItemImportJobQueryVariables>): Apollo.UseSuspenseQueryResult<StockOperationItemImportJobQuery, StockOperationItemImportJobQueryVariables>;
export function useStockOperationItemImportJobSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StockOperationItemImportJobQuery, StockOperationItemImportJobQueryVariables>): Apollo.UseSuspenseQueryResult<StockOperationItemImportJobQuery | undefined, StockOperationItemImportJobQueryVariables>;
export function useStockOperationItemImportJobSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StockOperationItemImportJobQuery, StockOperationItemImportJobQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StockOperationItemImportJobQuery, StockOperationItemImportJobQueryVariables>(StockOperationItemImportJobDocument, options);
        }
export type StockOperationItemImportJobQueryHookResult = ReturnType<typeof useStockOperationItemImportJobQuery>;
export type StockOperationItemImportJobLazyQueryHookResult = ReturnType<typeof useStockOperationItemImportJobLazyQuery>;
export type StockOperationItemImportJobSuspenseQueryHookResult = ReturnType<typeof useStockOperationItemImportJobSuspenseQuery>;
export type StockOperationItemImportJobQueryResult = Apollo.QueryResult<StockOperationItemImportJobQuery, StockOperationItemImportJobQueryVariables>;
export const GetAllStockOperationsDocument = gql`
    query GetAllStockOperations($sort: [SortCondition!], $page: Int!, $limit: Int!, $locationId: String, $filter: [FilterGroup!]) {
  getAllStockOperations(
    sort: $sort
    page: $page
    limit: $limit
    locationId: $locationId
    filter: $filter
  ) {
    meta {
      limit
      page
      totalCount
    }
    data {
      id
      secondaryId
      operationType
      status
      remarks
      itemCount
      totalQuantity
      totalValue
      createdAt
      confirmedAt
      location {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetAllStockOperationsQuery__
 *
 * To run a query within a React component, call `useGetAllStockOperationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllStockOperationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllStockOperationsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      locationId: // value for 'locationId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetAllStockOperationsQuery(baseOptions: Apollo.QueryHookOptions<GetAllStockOperationsQuery, GetAllStockOperationsQueryVariables> & ({ variables: GetAllStockOperationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllStockOperationsQuery, GetAllStockOperationsQueryVariables>(GetAllStockOperationsDocument, options);
      }
export function useGetAllStockOperationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllStockOperationsQuery, GetAllStockOperationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllStockOperationsQuery, GetAllStockOperationsQueryVariables>(GetAllStockOperationsDocument, options);
        }
// @ts-ignore
export function useGetAllStockOperationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllStockOperationsQuery, GetAllStockOperationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllStockOperationsQuery, GetAllStockOperationsQueryVariables>;
export function useGetAllStockOperationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllStockOperationsQuery, GetAllStockOperationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllStockOperationsQuery | undefined, GetAllStockOperationsQueryVariables>;
export function useGetAllStockOperationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllStockOperationsQuery, GetAllStockOperationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllStockOperationsQuery, GetAllStockOperationsQueryVariables>(GetAllStockOperationsDocument, options);
        }
export type GetAllStockOperationsQueryHookResult = ReturnType<typeof useGetAllStockOperationsQuery>;
export type GetAllStockOperationsLazyQueryHookResult = ReturnType<typeof useGetAllStockOperationsLazyQuery>;
export type GetAllStockOperationsSuspenseQueryHookResult = ReturnType<typeof useGetAllStockOperationsSuspenseQuery>;
export type GetAllStockOperationsQueryResult = Apollo.QueryResult<GetAllStockOperationsQuery, GetAllStockOperationsQueryVariables>;
export const GetOneStockOperationDocument = gql`
    query GetOneStockOperation($stockOperationId: String!) {
  getOneStockOperation(stockOperationId: $stockOperationId) {
    id
    secondaryId
    operationType
    status
    remarks
    itemCount
    totalQuantity
    totalValue
    createdAt
    confirmedAt
    location {
      id
      name
    }
    warehouse {
      id
      name
    }
    items {
      id
      actionId
      productLotId
      trackingLevel
      quantity
      batchNumber
      batchExpiry
      mfgDate
      tradePrice
      gstValue
      mrp
      manufacturerCode
      isManufacturerTracking
      uomFactor
      productLot {
        id
        actionId
      }
      product {
        id
        name
        secondaryId
      }
      createdAt
    }
  }
}
    `;

/**
 * __useGetOneStockOperationQuery__
 *
 * To run a query within a React component, call `useGetOneStockOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOneStockOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOneStockOperationQuery({
 *   variables: {
 *      stockOperationId: // value for 'stockOperationId'
 *   },
 * });
 */
export function useGetOneStockOperationQuery(baseOptions: Apollo.QueryHookOptions<GetOneStockOperationQuery, GetOneStockOperationQueryVariables> & ({ variables: GetOneStockOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOneStockOperationQuery, GetOneStockOperationQueryVariables>(GetOneStockOperationDocument, options);
      }
export function useGetOneStockOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOneStockOperationQuery, GetOneStockOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOneStockOperationQuery, GetOneStockOperationQueryVariables>(GetOneStockOperationDocument, options);
        }
// @ts-ignore
export function useGetOneStockOperationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOneStockOperationQuery, GetOneStockOperationQueryVariables>): Apollo.UseSuspenseQueryResult<GetOneStockOperationQuery, GetOneStockOperationQueryVariables>;
export function useGetOneStockOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOneStockOperationQuery, GetOneStockOperationQueryVariables>): Apollo.UseSuspenseQueryResult<GetOneStockOperationQuery | undefined, GetOneStockOperationQueryVariables>;
export function useGetOneStockOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOneStockOperationQuery, GetOneStockOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOneStockOperationQuery, GetOneStockOperationQueryVariables>(GetOneStockOperationDocument, options);
        }
export type GetOneStockOperationQueryHookResult = ReturnType<typeof useGetOneStockOperationQuery>;
export type GetOneStockOperationLazyQueryHookResult = ReturnType<typeof useGetOneStockOperationLazyQuery>;
export type GetOneStockOperationSuspenseQueryHookResult = ReturnType<typeof useGetOneStockOperationSuspenseQuery>;
export type GetOneStockOperationQueryResult = Apollo.QueryResult<GetOneStockOperationQuery, GetOneStockOperationQueryVariables>;
export const CreateStockOperationDocument = gql`
    mutation CreateStockOperation($createStockOperationDto: CreateStockOperationDTO!) {
  createStockOperation(CreateStockOperationDTO: $createStockOperationDto) {
    id
    secondaryId
    status
    operationType
  }
}
    `;
export type CreateStockOperationMutationFn = Apollo.MutationFunction<CreateStockOperationMutation, CreateStockOperationMutationVariables>;

/**
 * __useCreateStockOperationMutation__
 *
 * To run a mutation, you first call `useCreateStockOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStockOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStockOperationMutation, { data, loading, error }] = useCreateStockOperationMutation({
 *   variables: {
 *      createStockOperationDto: // value for 'createStockOperationDto'
 *   },
 * });
 */
export function useCreateStockOperationMutation(baseOptions?: Apollo.MutationHookOptions<CreateStockOperationMutation, CreateStockOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStockOperationMutation, CreateStockOperationMutationVariables>(CreateStockOperationDocument, options);
      }
export type CreateStockOperationMutationHookResult = ReturnType<typeof useCreateStockOperationMutation>;
export type CreateStockOperationMutationResult = Apollo.MutationResult<CreateStockOperationMutation>;
export type CreateStockOperationMutationOptions = Apollo.BaseMutationOptions<CreateStockOperationMutation, CreateStockOperationMutationVariables>;
export const AddStockOperationItemsDocument = gql`
    mutation AddStockOperationItems($addStockOperationItemsDto: [AddStockOperationItemDTO!]!) {
  addStockOperationItems(AddStockOperationItemsDTO: $addStockOperationItemsDto)
}
    `;
export type AddStockOperationItemsMutationFn = Apollo.MutationFunction<AddStockOperationItemsMutation, AddStockOperationItemsMutationVariables>;

/**
 * __useAddStockOperationItemsMutation__
 *
 * To run a mutation, you first call `useAddStockOperationItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddStockOperationItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addStockOperationItemsMutation, { data, loading, error }] = useAddStockOperationItemsMutation({
 *   variables: {
 *      addStockOperationItemsDto: // value for 'addStockOperationItemsDto'
 *   },
 * });
 */
export function useAddStockOperationItemsMutation(baseOptions?: Apollo.MutationHookOptions<AddStockOperationItemsMutation, AddStockOperationItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddStockOperationItemsMutation, AddStockOperationItemsMutationVariables>(AddStockOperationItemsDocument, options);
      }
export type AddStockOperationItemsMutationHookResult = ReturnType<typeof useAddStockOperationItemsMutation>;
export type AddStockOperationItemsMutationResult = Apollo.MutationResult<AddStockOperationItemsMutation>;
export type AddStockOperationItemsMutationOptions = Apollo.BaseMutationOptions<AddStockOperationItemsMutation, AddStockOperationItemsMutationVariables>;
export const UpdateStockOperationDocument = gql`
    mutation UpdateStockOperation($updateStockOperationDto: UpdateStockOperationDTO!) {
  updateStockOperation(UpdateStockOperationDTO: $updateStockOperationDto) {
    id
    secondaryId
    operationType
    status
    remarks
    itemCount
    totalQuantity
    totalValue
    createdAt
    confirmedAt
    location {
      id
      name
    }
    warehouse {
      id
      name
    }
  }
}
    `;
export type UpdateStockOperationMutationFn = Apollo.MutationFunction<UpdateStockOperationMutation, UpdateStockOperationMutationVariables>;

/**
 * __useUpdateStockOperationMutation__
 *
 * To run a mutation, you first call `useUpdateStockOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStockOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStockOperationMutation, { data, loading, error }] = useUpdateStockOperationMutation({
 *   variables: {
 *      updateStockOperationDto: // value for 'updateStockOperationDto'
 *   },
 * });
 */
export function useUpdateStockOperationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStockOperationMutation, UpdateStockOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStockOperationMutation, UpdateStockOperationMutationVariables>(UpdateStockOperationDocument, options);
      }
export type UpdateStockOperationMutationHookResult = ReturnType<typeof useUpdateStockOperationMutation>;
export type UpdateStockOperationMutationResult = Apollo.MutationResult<UpdateStockOperationMutation>;
export type UpdateStockOperationMutationOptions = Apollo.BaseMutationOptions<UpdateStockOperationMutation, UpdateStockOperationMutationVariables>;
export const UpdateStockOperationItemDocument = gql`
    mutation UpdateStockOperationItem($updateStockOperationItemDto: UpdateStockOperationItemDTO!) {
  updateStockOperationItem(
    UpdateStockOperationItemDTO: $updateStockOperationItemDto
  )
}
    `;
export type UpdateStockOperationItemMutationFn = Apollo.MutationFunction<UpdateStockOperationItemMutation, UpdateStockOperationItemMutationVariables>;

/**
 * __useUpdateStockOperationItemMutation__
 *
 * To run a mutation, you first call `useUpdateStockOperationItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStockOperationItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStockOperationItemMutation, { data, loading, error }] = useUpdateStockOperationItemMutation({
 *   variables: {
 *      updateStockOperationItemDto: // value for 'updateStockOperationItemDto'
 *   },
 * });
 */
export function useUpdateStockOperationItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStockOperationItemMutation, UpdateStockOperationItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStockOperationItemMutation, UpdateStockOperationItemMutationVariables>(UpdateStockOperationItemDocument, options);
      }
export type UpdateStockOperationItemMutationHookResult = ReturnType<typeof useUpdateStockOperationItemMutation>;
export type UpdateStockOperationItemMutationResult = Apollo.MutationResult<UpdateStockOperationItemMutation>;
export type UpdateStockOperationItemMutationOptions = Apollo.BaseMutationOptions<UpdateStockOperationItemMutation, UpdateStockOperationItemMutationVariables>;
export const RemoveStockOperationItemDocument = gql`
    mutation RemoveStockOperationItem($stockOperationItemId: String!) {
  removeStockOperationItem(stockOperationItemId: $stockOperationItemId)
}
    `;
export type RemoveStockOperationItemMutationFn = Apollo.MutationFunction<RemoveStockOperationItemMutation, RemoveStockOperationItemMutationVariables>;

/**
 * __useRemoveStockOperationItemMutation__
 *
 * To run a mutation, you first call `useRemoveStockOperationItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveStockOperationItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeStockOperationItemMutation, { data, loading, error }] = useRemoveStockOperationItemMutation({
 *   variables: {
 *      stockOperationItemId: // value for 'stockOperationItemId'
 *   },
 * });
 */
export function useRemoveStockOperationItemMutation(baseOptions?: Apollo.MutationHookOptions<RemoveStockOperationItemMutation, RemoveStockOperationItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveStockOperationItemMutation, RemoveStockOperationItemMutationVariables>(RemoveStockOperationItemDocument, options);
      }
export type RemoveStockOperationItemMutationHookResult = ReturnType<typeof useRemoveStockOperationItemMutation>;
export type RemoveStockOperationItemMutationResult = Apollo.MutationResult<RemoveStockOperationItemMutation>;
export type RemoveStockOperationItemMutationOptions = Apollo.BaseMutationOptions<RemoveStockOperationItemMutation, RemoveStockOperationItemMutationVariables>;
export const ConfirmStockOperationDocument = gql`
    mutation ConfirmStockOperation($stockOperationId: String!) {
  confirmStockOperation(stockOperationId: $stockOperationId)
}
    `;
export type ConfirmStockOperationMutationFn = Apollo.MutationFunction<ConfirmStockOperationMutation, ConfirmStockOperationMutationVariables>;

/**
 * __useConfirmStockOperationMutation__
 *
 * To run a mutation, you first call `useConfirmStockOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmStockOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmStockOperationMutation, { data, loading, error }] = useConfirmStockOperationMutation({
 *   variables: {
 *      stockOperationId: // value for 'stockOperationId'
 *   },
 * });
 */
export function useConfirmStockOperationMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmStockOperationMutation, ConfirmStockOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmStockOperationMutation, ConfirmStockOperationMutationVariables>(ConfirmStockOperationDocument, options);
      }
export type ConfirmStockOperationMutationHookResult = ReturnType<typeof useConfirmStockOperationMutation>;
export type ConfirmStockOperationMutationResult = Apollo.MutationResult<ConfirmStockOperationMutation>;
export type ConfirmStockOperationMutationOptions = Apollo.BaseMutationOptions<ConfirmStockOperationMutation, ConfirmStockOperationMutationVariables>;
export const GetStockReturnsListDocument = gql`
    query GetStockReturnsList($filter: [FilterGroup!], $limit: Int!, $locationId: String, $page: Int!, $sort: [SortCondition!]) {
  getStockReturns(
    filter: $filter
    limit: $limit
    locationId: $locationId
    page: $page
    sort: $sort
  ) {
    meta {
      limit
      page
      total
      totalCount
    }
    data {
      createdAt
      gatePassNumber
      id
      secondaryId
      status
      totalProducts
      totalQty
      totalValue
      updatedAt
      vendorId
      vendor {
        id
        secondaryId
        name
      }
      location {
        name
      }
    }
  }
}
    `;

/**
 * __useGetStockReturnsListQuery__
 *
 * To run a query within a React component, call `useGetStockReturnsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStockReturnsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStockReturnsListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      locationId: // value for 'locationId'
 *      page: // value for 'page'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetStockReturnsListQuery(baseOptions: Apollo.QueryHookOptions<GetStockReturnsListQuery, GetStockReturnsListQueryVariables> & ({ variables: GetStockReturnsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStockReturnsListQuery, GetStockReturnsListQueryVariables>(GetStockReturnsListDocument, options);
      }
export function useGetStockReturnsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStockReturnsListQuery, GetStockReturnsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStockReturnsListQuery, GetStockReturnsListQueryVariables>(GetStockReturnsListDocument, options);
        }
// @ts-ignore
export function useGetStockReturnsListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStockReturnsListQuery, GetStockReturnsListQueryVariables>): Apollo.UseSuspenseQueryResult<GetStockReturnsListQuery, GetStockReturnsListQueryVariables>;
export function useGetStockReturnsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStockReturnsListQuery, GetStockReturnsListQueryVariables>): Apollo.UseSuspenseQueryResult<GetStockReturnsListQuery | undefined, GetStockReturnsListQueryVariables>;
export function useGetStockReturnsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStockReturnsListQuery, GetStockReturnsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStockReturnsListQuery, GetStockReturnsListQueryVariables>(GetStockReturnsListDocument, options);
        }
export type GetStockReturnsListQueryHookResult = ReturnType<typeof useGetStockReturnsListQuery>;
export type GetStockReturnsListLazyQueryHookResult = ReturnType<typeof useGetStockReturnsListLazyQuery>;
export type GetStockReturnsListSuspenseQueryHookResult = ReturnType<typeof useGetStockReturnsListSuspenseQuery>;
export type GetStockReturnsListQueryResult = Apollo.QueryResult<GetStockReturnsListQuery, GetStockReturnsListQueryVariables>;
export const CreateStockReturnDocument = gql`
    mutation CreateStockReturn($createStockReturnDto: CreateStockReturnDTO!) {
  createStockReturn(createStockReturnDTO: $createStockReturnDto) {
    id
  }
}
    `;
export type CreateStockReturnMutationFn = Apollo.MutationFunction<CreateStockReturnMutation, CreateStockReturnMutationVariables>;

/**
 * __useCreateStockReturnMutation__
 *
 * To run a mutation, you first call `useCreateStockReturnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStockReturnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStockReturnMutation, { data, loading, error }] = useCreateStockReturnMutation({
 *   variables: {
 *      createStockReturnDto: // value for 'createStockReturnDto'
 *   },
 * });
 */
export function useCreateStockReturnMutation(baseOptions?: Apollo.MutationHookOptions<CreateStockReturnMutation, CreateStockReturnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStockReturnMutation, CreateStockReturnMutationVariables>(CreateStockReturnDocument, options);
      }
export type CreateStockReturnMutationHookResult = ReturnType<typeof useCreateStockReturnMutation>;
export type CreateStockReturnMutationResult = Apollo.MutationResult<CreateStockReturnMutation>;
export type CreateStockReturnMutationOptions = Apollo.BaseMutationOptions<CreateStockReturnMutation, CreateStockReturnMutationVariables>;
export const GetStockReturnForDetailsDocument = gql`
    query GetStockReturnForDetails($getStockReturnId: String!) {
  getStockReturn(id: $getStockReturnId) {
    createdAt
    id
    gatePassNumber
    secondaryId
    status
    totalProducts
    totalQty
    totalValue
    vendor {
      secondaryId
      name
    }
    returnItems {
      quantity
      value
      product {
        secondaryId
        name
      }
      productLot {
        actionId
      }
    }
  }
}
    `;

/**
 * __useGetStockReturnForDetailsQuery__
 *
 * To run a query within a React component, call `useGetStockReturnForDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStockReturnForDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStockReturnForDetailsQuery({
 *   variables: {
 *      getStockReturnId: // value for 'getStockReturnId'
 *   },
 * });
 */
export function useGetStockReturnForDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetStockReturnForDetailsQuery, GetStockReturnForDetailsQueryVariables> & ({ variables: GetStockReturnForDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStockReturnForDetailsQuery, GetStockReturnForDetailsQueryVariables>(GetStockReturnForDetailsDocument, options);
      }
export function useGetStockReturnForDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStockReturnForDetailsQuery, GetStockReturnForDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStockReturnForDetailsQuery, GetStockReturnForDetailsQueryVariables>(GetStockReturnForDetailsDocument, options);
        }
// @ts-ignore
export function useGetStockReturnForDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStockReturnForDetailsQuery, GetStockReturnForDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetStockReturnForDetailsQuery, GetStockReturnForDetailsQueryVariables>;
export function useGetStockReturnForDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStockReturnForDetailsQuery, GetStockReturnForDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetStockReturnForDetailsQuery | undefined, GetStockReturnForDetailsQueryVariables>;
export function useGetStockReturnForDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStockReturnForDetailsQuery, GetStockReturnForDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStockReturnForDetailsQuery, GetStockReturnForDetailsQueryVariables>(GetStockReturnForDetailsDocument, options);
        }
export type GetStockReturnForDetailsQueryHookResult = ReturnType<typeof useGetStockReturnForDetailsQuery>;
export type GetStockReturnForDetailsLazyQueryHookResult = ReturnType<typeof useGetStockReturnForDetailsLazyQuery>;
export type GetStockReturnForDetailsSuspenseQueryHookResult = ReturnType<typeof useGetStockReturnForDetailsSuspenseQuery>;
export type GetStockReturnForDetailsQueryResult = Apollo.QueryResult<GetStockReturnForDetailsQuery, GetStockReturnForDetailsQueryVariables>;
export const GetPdfStockReturnDocument = gql`
    query GetPDFStockReturn($getPdfStockReturnId: String!) {
  getPDFStockReturn(id: $getPdfStockReturnId) {
    gatepass
    returnDate
    returnId
    vendorName
    grandTotal
    createdByName
    designation
    returns {
      averagePurchasingPrice
      lotCount
      productId
      productName
      totalPurchasingPrice
    }
  }
}
    `;

/**
 * __useGetPdfStockReturnQuery__
 *
 * To run a query within a React component, call `useGetPdfStockReturnQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPdfStockReturnQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPdfStockReturnQuery({
 *   variables: {
 *      getPdfStockReturnId: // value for 'getPdfStockReturnId'
 *   },
 * });
 */
export function useGetPdfStockReturnQuery(baseOptions: Apollo.QueryHookOptions<GetPdfStockReturnQuery, GetPdfStockReturnQueryVariables> & ({ variables: GetPdfStockReturnQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPdfStockReturnQuery, GetPdfStockReturnQueryVariables>(GetPdfStockReturnDocument, options);
      }
export function useGetPdfStockReturnLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPdfStockReturnQuery, GetPdfStockReturnQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPdfStockReturnQuery, GetPdfStockReturnQueryVariables>(GetPdfStockReturnDocument, options);
        }
// @ts-ignore
export function useGetPdfStockReturnSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPdfStockReturnQuery, GetPdfStockReturnQueryVariables>): Apollo.UseSuspenseQueryResult<GetPdfStockReturnQuery, GetPdfStockReturnQueryVariables>;
export function useGetPdfStockReturnSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPdfStockReturnQuery, GetPdfStockReturnQueryVariables>): Apollo.UseSuspenseQueryResult<GetPdfStockReturnQuery | undefined, GetPdfStockReturnQueryVariables>;
export function useGetPdfStockReturnSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPdfStockReturnQuery, GetPdfStockReturnQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPdfStockReturnQuery, GetPdfStockReturnQueryVariables>(GetPdfStockReturnDocument, options);
        }
export type GetPdfStockReturnQueryHookResult = ReturnType<typeof useGetPdfStockReturnQuery>;
export type GetPdfStockReturnLazyQueryHookResult = ReturnType<typeof useGetPdfStockReturnLazyQuery>;
export type GetPdfStockReturnSuspenseQueryHookResult = ReturnType<typeof useGetPdfStockReturnSuspenseQuery>;
export type GetPdfStockReturnQueryResult = Apollo.QueryResult<GetPdfStockReturnQuery, GetPdfStockReturnQueryVariables>;
export const GetTagsDocument = gql`
    query GetTags($page: Int!, $limit: Int!, $sort: [SortCondition!], $filter: [FilterGroup!]) {
  getTags(page: $page, limit: $limit, sort: $sort, filter: $filter) {
    data {
      id
      name
      status
    }
    meta {
      limit
      page
      totalCount
    }
  }
}
    `;

/**
 * __useGetTagsQuery__
 *
 * To run a query within a React component, call `useGetTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetTagsQuery(baseOptions: Apollo.QueryHookOptions<GetTagsQuery, GetTagsQueryVariables> & ({ variables: GetTagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTagsQuery, GetTagsQueryVariables>(GetTagsDocument, options);
      }
export function useGetTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTagsQuery, GetTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTagsQuery, GetTagsQueryVariables>(GetTagsDocument, options);
        }
// @ts-ignore
export function useGetTagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTagsQuery, GetTagsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTagsQuery, GetTagsQueryVariables>;
export function useGetTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTagsQuery, GetTagsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTagsQuery | undefined, GetTagsQueryVariables>;
export function useGetTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTagsQuery, GetTagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTagsQuery, GetTagsQueryVariables>(GetTagsDocument, options);
        }
export type GetTagsQueryHookResult = ReturnType<typeof useGetTagsQuery>;
export type GetTagsLazyQueryHookResult = ReturnType<typeof useGetTagsLazyQuery>;
export type GetTagsSuspenseQueryHookResult = ReturnType<typeof useGetTagsSuspenseQuery>;
export type GetTagsQueryResult = Apollo.QueryResult<GetTagsQuery, GetTagsQueryVariables>;
export const CreateTagDocument = gql`
    mutation CreateTag($createTagDto: CreateTagDTO!) {
  createTag(createTagDTO: $createTagDto) {
    id
    name
    status
  }
}
    `;
export type CreateTagMutationFn = Apollo.MutationFunction<CreateTagMutation, CreateTagMutationVariables>;

/**
 * __useCreateTagMutation__
 *
 * To run a mutation, you first call `useCreateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTagMutation, { data, loading, error }] = useCreateTagMutation({
 *   variables: {
 *      createTagDto: // value for 'createTagDto'
 *   },
 * });
 */
export function useCreateTagMutation(baseOptions?: Apollo.MutationHookOptions<CreateTagMutation, CreateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTagMutation, CreateTagMutationVariables>(CreateTagDocument, options);
      }
export type CreateTagMutationHookResult = ReturnType<typeof useCreateTagMutation>;
export type CreateTagMutationResult = Apollo.MutationResult<CreateTagMutation>;
export type CreateTagMutationOptions = Apollo.BaseMutationOptions<CreateTagMutation, CreateTagMutationVariables>;
export const GetTransferListDocument = gql`
    query GetTransferList($locationId: String!, $sort: [SortCondition!], $limit: Int!, $page: Int!, $filter: [FilterGroup!]) {
  getTransfers(
    locationId: $locationId
    sort: $sort
    limit: $limit
    page: $page
    filter: $filter
  ) {
    meta {
      limit
      page
      totalCount
    }
    data {
      id
      secondaryId
      description
      expectedDeliveryDate
      demandNoteId
      demandNote {
        id
        secondaryId
      }
      status
      locationTo {
        id
        name
        type
      }
      locationFrom {
        id
        name
        type
      }
    }
  }
}
    `;

/**
 * __useGetTransferListQuery__
 *
 * To run a query within a React component, call `useGetTransferListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransferListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransferListQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetTransferListQuery(baseOptions: Apollo.QueryHookOptions<GetTransferListQuery, GetTransferListQueryVariables> & ({ variables: GetTransferListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTransferListQuery, GetTransferListQueryVariables>(GetTransferListDocument, options);
      }
export function useGetTransferListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransferListQuery, GetTransferListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTransferListQuery, GetTransferListQueryVariables>(GetTransferListDocument, options);
        }
// @ts-ignore
export function useGetTransferListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTransferListQuery, GetTransferListQueryVariables>): Apollo.UseSuspenseQueryResult<GetTransferListQuery, GetTransferListQueryVariables>;
export function useGetTransferListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTransferListQuery, GetTransferListQueryVariables>): Apollo.UseSuspenseQueryResult<GetTransferListQuery | undefined, GetTransferListQueryVariables>;
export function useGetTransferListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTransferListQuery, GetTransferListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTransferListQuery, GetTransferListQueryVariables>(GetTransferListDocument, options);
        }
export type GetTransferListQueryHookResult = ReturnType<typeof useGetTransferListQuery>;
export type GetTransferListLazyQueryHookResult = ReturnType<typeof useGetTransferListLazyQuery>;
export type GetTransferListSuspenseQueryHookResult = ReturnType<typeof useGetTransferListSuspenseQuery>;
export type GetTransferListQueryResult = Apollo.QueryResult<GetTransferListQuery, GetTransferListQueryVariables>;
export const CreateTransferDocument = gql`
    mutation CreateTransfer($createTransferDto: CreateTransferDTO!) {
  createTransfer(createTransferDTO: $createTransferDto) {
    id
  }
}
    `;
export type CreateTransferMutationFn = Apollo.MutationFunction<CreateTransferMutation, CreateTransferMutationVariables>;

/**
 * __useCreateTransferMutation__
 *
 * To run a mutation, you first call `useCreateTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTransferMutation, { data, loading, error }] = useCreateTransferMutation({
 *   variables: {
 *      createTransferDto: // value for 'createTransferDto'
 *   },
 * });
 */
export function useCreateTransferMutation(baseOptions?: Apollo.MutationHookOptions<CreateTransferMutation, CreateTransferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTransferMutation, CreateTransferMutationVariables>(CreateTransferDocument, options);
      }
export type CreateTransferMutationHookResult = ReturnType<typeof useCreateTransferMutation>;
export type CreateTransferMutationResult = Apollo.MutationResult<CreateTransferMutation>;
export type CreateTransferMutationOptions = Apollo.BaseMutationOptions<CreateTransferMutation, CreateTransferMutationVariables>;
export const ReceiveTransferItemsDocument = gql`
    mutation ReceiveTransferItems($receiveTransferItemsInput: ReceiveTransferItemsInput!) {
  receiveTransferItems(receiveTransferItemsInput: $receiveTransferItemsInput)
}
    `;
export type ReceiveTransferItemsMutationFn = Apollo.MutationFunction<ReceiveTransferItemsMutation, ReceiveTransferItemsMutationVariables>;

/**
 * __useReceiveTransferItemsMutation__
 *
 * To run a mutation, you first call `useReceiveTransferItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReceiveTransferItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [receiveTransferItemsMutation, { data, loading, error }] = useReceiveTransferItemsMutation({
 *   variables: {
 *      receiveTransferItemsInput: // value for 'receiveTransferItemsInput'
 *   },
 * });
 */
export function useReceiveTransferItemsMutation(baseOptions?: Apollo.MutationHookOptions<ReceiveTransferItemsMutation, ReceiveTransferItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReceiveTransferItemsMutation, ReceiveTransferItemsMutationVariables>(ReceiveTransferItemsDocument, options);
      }
export type ReceiveTransferItemsMutationHookResult = ReturnType<typeof useReceiveTransferItemsMutation>;
export type ReceiveTransferItemsMutationResult = Apollo.MutationResult<ReceiveTransferItemsMutation>;
export type ReceiveTransferItemsMutationOptions = Apollo.BaseMutationOptions<ReceiveTransferItemsMutation, ReceiveTransferItemsMutationVariables>;
export const GetTransferReceivesListDocument = gql`
    query GetTransferReceivesList($locationId: String!, $filter: [FilterGroup!], $limit: Int!, $page: Int!, $sort: [SortCondition!]) {
  getTransferReceives(
    locationId: $locationId
    filter: $filter
    limit: $limit
    page: $page
    sort: $sort
  ) {
    data {
      id
      secondaryId
      createdAt
      description
      expectedDeliveryDate
      locationFrom {
        id
        name
        type
      }
      locationTo {
        id
        name
        type
      }
      demandNoteId
      demandNote {
        id
        secondaryId
      }
      status
      updatedAt
    }
    meta {
      limit
      page
      totalCount
    }
  }
}
    `;

/**
 * __useGetTransferReceivesListQuery__
 *
 * To run a query within a React component, call `useGetTransferReceivesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransferReceivesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransferReceivesListQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetTransferReceivesListQuery(baseOptions: Apollo.QueryHookOptions<GetTransferReceivesListQuery, GetTransferReceivesListQueryVariables> & ({ variables: GetTransferReceivesListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTransferReceivesListQuery, GetTransferReceivesListQueryVariables>(GetTransferReceivesListDocument, options);
      }
export function useGetTransferReceivesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransferReceivesListQuery, GetTransferReceivesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTransferReceivesListQuery, GetTransferReceivesListQueryVariables>(GetTransferReceivesListDocument, options);
        }
// @ts-ignore
export function useGetTransferReceivesListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTransferReceivesListQuery, GetTransferReceivesListQueryVariables>): Apollo.UseSuspenseQueryResult<GetTransferReceivesListQuery, GetTransferReceivesListQueryVariables>;
export function useGetTransferReceivesListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTransferReceivesListQuery, GetTransferReceivesListQueryVariables>): Apollo.UseSuspenseQueryResult<GetTransferReceivesListQuery | undefined, GetTransferReceivesListQueryVariables>;
export function useGetTransferReceivesListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTransferReceivesListQuery, GetTransferReceivesListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTransferReceivesListQuery, GetTransferReceivesListQueryVariables>(GetTransferReceivesListDocument, options);
        }
export type GetTransferReceivesListQueryHookResult = ReturnType<typeof useGetTransferReceivesListQuery>;
export type GetTransferReceivesListLazyQueryHookResult = ReturnType<typeof useGetTransferReceivesListLazyQuery>;
export type GetTransferReceivesListSuspenseQueryHookResult = ReturnType<typeof useGetTransferReceivesListSuspenseQuery>;
export type GetTransferReceivesListQueryResult = Apollo.QueryResult<GetTransferReceivesListQuery, GetTransferReceivesListQueryVariables>;
export const GetTransferForInvoiceDocument = gql`
    query GetTransferForInvoice($getTransferId: String!) {
  getTransfer(id: $getTransferId) {
    description
    expectedDeliveryDate
    id
    secondaryId
    demandNoteId
    demandNote {
      id
      secondaryId
    }
    status
    updatedAt
    locationFrom {
      name
      id
    }
    locationTo {
      id
      name
    }
    transferItems {
      status
      id
      quantity
      productLot {
        id
        actionId
        product {
          id
          secondaryId
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetTransferForInvoiceQuery__
 *
 * To run a query within a React component, call `useGetTransferForInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransferForInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransferForInvoiceQuery({
 *   variables: {
 *      getTransferId: // value for 'getTransferId'
 *   },
 * });
 */
export function useGetTransferForInvoiceQuery(baseOptions: Apollo.QueryHookOptions<GetTransferForInvoiceQuery, GetTransferForInvoiceQueryVariables> & ({ variables: GetTransferForInvoiceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTransferForInvoiceQuery, GetTransferForInvoiceQueryVariables>(GetTransferForInvoiceDocument, options);
      }
export function useGetTransferForInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransferForInvoiceQuery, GetTransferForInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTransferForInvoiceQuery, GetTransferForInvoiceQueryVariables>(GetTransferForInvoiceDocument, options);
        }
// @ts-ignore
export function useGetTransferForInvoiceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTransferForInvoiceQuery, GetTransferForInvoiceQueryVariables>): Apollo.UseSuspenseQueryResult<GetTransferForInvoiceQuery, GetTransferForInvoiceQueryVariables>;
export function useGetTransferForInvoiceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTransferForInvoiceQuery, GetTransferForInvoiceQueryVariables>): Apollo.UseSuspenseQueryResult<GetTransferForInvoiceQuery | undefined, GetTransferForInvoiceQueryVariables>;
export function useGetTransferForInvoiceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTransferForInvoiceQuery, GetTransferForInvoiceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTransferForInvoiceQuery, GetTransferForInvoiceQueryVariables>(GetTransferForInvoiceDocument, options);
        }
export type GetTransferForInvoiceQueryHookResult = ReturnType<typeof useGetTransferForInvoiceQuery>;
export type GetTransferForInvoiceLazyQueryHookResult = ReturnType<typeof useGetTransferForInvoiceLazyQuery>;
export type GetTransferForInvoiceSuspenseQueryHookResult = ReturnType<typeof useGetTransferForInvoiceSuspenseQuery>;
export type GetTransferForInvoiceQueryResult = Apollo.QueryResult<GetTransferForInvoiceQuery, GetTransferForInvoiceQueryVariables>;
export const GetTransferDocument = gql`
    query GetTransfer($getTransferId: String!) {
  getTransfer(id: $getTransferId) {
    description
    expectedDeliveryDate
    id
    secondaryId
    demandNoteId
    demandNote {
      id
      secondaryId
    }
    status
    updatedAt
    locationFrom {
      name
      id
    }
    locationTo {
      id
      name
    }
    transferItems {
      status
      id
      quantity
      remainingQuantity
      productLot {
        id
        actionId
        product {
          id
          secondaryId
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetTransferQuery__
 *
 * To run a query within a React component, call `useGetTransferQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransferQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransferQuery({
 *   variables: {
 *      getTransferId: // value for 'getTransferId'
 *   },
 * });
 */
export function useGetTransferQuery(baseOptions: Apollo.QueryHookOptions<GetTransferQuery, GetTransferQueryVariables> & ({ variables: GetTransferQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTransferQuery, GetTransferQueryVariables>(GetTransferDocument, options);
      }
export function useGetTransferLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransferQuery, GetTransferQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTransferQuery, GetTransferQueryVariables>(GetTransferDocument, options);
        }
// @ts-ignore
export function useGetTransferSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTransferQuery, GetTransferQueryVariables>): Apollo.UseSuspenseQueryResult<GetTransferQuery, GetTransferQueryVariables>;
export function useGetTransferSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTransferQuery, GetTransferQueryVariables>): Apollo.UseSuspenseQueryResult<GetTransferQuery | undefined, GetTransferQueryVariables>;
export function useGetTransferSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTransferQuery, GetTransferQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTransferQuery, GetTransferQueryVariables>(GetTransferDocument, options);
        }
export type GetTransferQueryHookResult = ReturnType<typeof useGetTransferQuery>;
export type GetTransferLazyQueryHookResult = ReturnType<typeof useGetTransferLazyQuery>;
export type GetTransferSuspenseQueryHookResult = ReturnType<typeof useGetTransferSuspenseQuery>;
export type GetTransferQueryResult = Apollo.QueryResult<GetTransferQuery, GetTransferQueryVariables>;
export const ReceiveAllTransferItemsDocument = gql`
    mutation ReceiveAllTransferItems($transferId: String!) {
  receiveAllTransferItems(transferId: $transferId)
}
    `;
export type ReceiveAllTransferItemsMutationFn = Apollo.MutationFunction<ReceiveAllTransferItemsMutation, ReceiveAllTransferItemsMutationVariables>;

/**
 * __useReceiveAllTransferItemsMutation__
 *
 * To run a mutation, you first call `useReceiveAllTransferItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReceiveAllTransferItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [receiveAllTransferItemsMutation, { data, loading, error }] = useReceiveAllTransferItemsMutation({
 *   variables: {
 *      transferId: // value for 'transferId'
 *   },
 * });
 */
export function useReceiveAllTransferItemsMutation(baseOptions?: Apollo.MutationHookOptions<ReceiveAllTransferItemsMutation, ReceiveAllTransferItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReceiveAllTransferItemsMutation, ReceiveAllTransferItemsMutationVariables>(ReceiveAllTransferItemsDocument, options);
      }
export type ReceiveAllTransferItemsMutationHookResult = ReturnType<typeof useReceiveAllTransferItemsMutation>;
export type ReceiveAllTransferItemsMutationResult = Apollo.MutationResult<ReceiveAllTransferItemsMutation>;
export type ReceiveAllTransferItemsMutationOptions = Apollo.BaseMutationOptions<ReceiveAllTransferItemsMutation, ReceiveAllTransferItemsMutationVariables>;
export const GetUsersListDocument = gql`
    query GetUsersList($filter: [FilterGroup!], $limit: Int!, $locationId: String, $page: Int!, $sort: [SortCondition!]) {
  getUsers(
    filter: $filter
    limit: $limit
    locationId: $locationId
    page: $page
    sort: $sort
  ) {
    data {
      createdAt
      email
      firstName
      gender
      id
      lastName
      phone
      designation
      roleId
      secondaryId
      status
      updatedAt
      role {
        name
      }
    }
    meta {
      limit
      page
      total
      totalCount
    }
  }
}
    `;

/**
 * __useGetUsersListQuery__
 *
 * To run a query within a React component, call `useGetUsersListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      locationId: // value for 'locationId'
 *      page: // value for 'page'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetUsersListQuery(baseOptions: Apollo.QueryHookOptions<GetUsersListQuery, GetUsersListQueryVariables> & ({ variables: GetUsersListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersListQuery, GetUsersListQueryVariables>(GetUsersListDocument, options);
      }
export function useGetUsersListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersListQuery, GetUsersListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersListQuery, GetUsersListQueryVariables>(GetUsersListDocument, options);
        }
// @ts-ignore
export function useGetUsersListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUsersListQuery, GetUsersListQueryVariables>): Apollo.UseSuspenseQueryResult<GetUsersListQuery, GetUsersListQueryVariables>;
export function useGetUsersListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsersListQuery, GetUsersListQueryVariables>): Apollo.UseSuspenseQueryResult<GetUsersListQuery | undefined, GetUsersListQueryVariables>;
export function useGetUsersListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsersListQuery, GetUsersListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUsersListQuery, GetUsersListQueryVariables>(GetUsersListDocument, options);
        }
export type GetUsersListQueryHookResult = ReturnType<typeof useGetUsersListQuery>;
export type GetUsersListLazyQueryHookResult = ReturnType<typeof useGetUsersListLazyQuery>;
export type GetUsersListSuspenseQueryHookResult = ReturnType<typeof useGetUsersListSuspenseQuery>;
export type GetUsersListQueryResult = Apollo.QueryResult<GetUsersListQuery, GetUsersListQueryVariables>;
export const GetPickerUsersDocument = gql`
    query GetPickerUsers($sort: [SortCondition!], $filter: [FilterGroup!], $page: Int!, $limit: Int!, $locationId: String, $registerId: String, $isRegisterAssigned: Boolean) {
  getPickerUsers(
    sort: $sort
    filter: $filter
    page: $page
    limit: $limit
    locationId: $locationId
    registerId: $registerId
    isRegisterAssigned: $isRegisterAssigned
  ) {
    meta {
      page
      limit
      totalCount
      total
    }
    data {
      id
      secondaryId
      firstName
      lastName
      gender
      phone
    }
  }
}
    `;

/**
 * __useGetPickerUsersQuery__
 *
 * To run a query within a React component, call `useGetPickerUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPickerUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPickerUsersQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      locationId: // value for 'locationId'
 *      registerId: // value for 'registerId'
 *      isRegisterAssigned: // value for 'isRegisterAssigned'
 *   },
 * });
 */
export function useGetPickerUsersQuery(baseOptions: Apollo.QueryHookOptions<GetPickerUsersQuery, GetPickerUsersQueryVariables> & ({ variables: GetPickerUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPickerUsersQuery, GetPickerUsersQueryVariables>(GetPickerUsersDocument, options);
      }
export function useGetPickerUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPickerUsersQuery, GetPickerUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPickerUsersQuery, GetPickerUsersQueryVariables>(GetPickerUsersDocument, options);
        }
// @ts-ignore
export function useGetPickerUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPickerUsersQuery, GetPickerUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GetPickerUsersQuery, GetPickerUsersQueryVariables>;
export function useGetPickerUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPickerUsersQuery, GetPickerUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GetPickerUsersQuery | undefined, GetPickerUsersQueryVariables>;
export function useGetPickerUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPickerUsersQuery, GetPickerUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPickerUsersQuery, GetPickerUsersQueryVariables>(GetPickerUsersDocument, options);
        }
export type GetPickerUsersQueryHookResult = ReturnType<typeof useGetPickerUsersQuery>;
export type GetPickerUsersLazyQueryHookResult = ReturnType<typeof useGetPickerUsersLazyQuery>;
export type GetPickerUsersSuspenseQueryHookResult = ReturnType<typeof useGetPickerUsersSuspenseQuery>;
export type GetPickerUsersQueryResult = Apollo.QueryResult<GetPickerUsersQuery, GetPickerUsersQueryVariables>;
export const GetUsersListForOptionsDocument = gql`
    query GetUsersListForOptions($filter: [FilterGroup!], $limit: Int!, $locationId: String, $page: Int!, $sort: [SortCondition!]) {
  getUsers(
    filter: $filter
    limit: $limit
    locationId: $locationId
    page: $page
    sort: $sort
  ) {
    data {
      id
      firstName
      lastName
      phone
    }
    meta {
      limit
      page
      total
      totalCount
    }
  }
}
    `;

/**
 * __useGetUsersListForOptionsQuery__
 *
 * To run a query within a React component, call `useGetUsersListForOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersListForOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersListForOptionsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      locationId: // value for 'locationId'
 *      page: // value for 'page'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetUsersListForOptionsQuery(baseOptions: Apollo.QueryHookOptions<GetUsersListForOptionsQuery, GetUsersListForOptionsQueryVariables> & ({ variables: GetUsersListForOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersListForOptionsQuery, GetUsersListForOptionsQueryVariables>(GetUsersListForOptionsDocument, options);
      }
export function useGetUsersListForOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersListForOptionsQuery, GetUsersListForOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersListForOptionsQuery, GetUsersListForOptionsQueryVariables>(GetUsersListForOptionsDocument, options);
        }
// @ts-ignore
export function useGetUsersListForOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUsersListForOptionsQuery, GetUsersListForOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUsersListForOptionsQuery, GetUsersListForOptionsQueryVariables>;
export function useGetUsersListForOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsersListForOptionsQuery, GetUsersListForOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUsersListForOptionsQuery | undefined, GetUsersListForOptionsQueryVariables>;
export function useGetUsersListForOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsersListForOptionsQuery, GetUsersListForOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUsersListForOptionsQuery, GetUsersListForOptionsQueryVariables>(GetUsersListForOptionsDocument, options);
        }
export type GetUsersListForOptionsQueryHookResult = ReturnType<typeof useGetUsersListForOptionsQuery>;
export type GetUsersListForOptionsLazyQueryHookResult = ReturnType<typeof useGetUsersListForOptionsLazyQuery>;
export type GetUsersListForOptionsSuspenseQueryHookResult = ReturnType<typeof useGetUsersListForOptionsSuspenseQuery>;
export type GetUsersListForOptionsQueryResult = Apollo.QueryResult<GetUsersListForOptionsQuery, GetUsersListForOptionsQueryVariables>;
export const GetUserDocument = gql`
    query GetUser($getUserId: String) {
  getUser(id: $getUserId) {
    createdAt
    email
    firstName
    gender
    id
    lastName
    phone
    designation
    roleId
    secondaryId
    status
    tokenExpiry
    updatedAt
    role {
      id
      name
    }
    location {
      id
    }
  }
}
    `;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      getUserId: // value for 'getUserId'
 *   },
 * });
 */
export function useGetUserQuery(baseOptions?: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
// @ts-ignore
export function useGetUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserQuery, GetUserQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserQuery, GetUserQueryVariables>;
export function useGetUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserQuery, GetUserQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserQuery | undefined, GetUserQueryVariables>;
export function useGetUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserSuspenseQueryHookResult = ReturnType<typeof useGetUserSuspenseQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const InviteUserDocument = gql`
    mutation InviteUser($inviteUser: InviteUserDTO!, $locationIds: [String!]!) {
  inviteUser(inviteUser: $inviteUser, locationIds: $locationIds) {
    id
  }
}
    `;
export type InviteUserMutationFn = Apollo.MutationFunction<InviteUserMutation, InviteUserMutationVariables>;

/**
 * __useInviteUserMutation__
 *
 * To run a mutation, you first call `useInviteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteUserMutation, { data, loading, error }] = useInviteUserMutation({
 *   variables: {
 *      inviteUser: // value for 'inviteUser'
 *      locationIds: // value for 'locationIds'
 *   },
 * });
 */
export function useInviteUserMutation(baseOptions?: Apollo.MutationHookOptions<InviteUserMutation, InviteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteUserMutation, InviteUserMutationVariables>(InviteUserDocument, options);
      }
export type InviteUserMutationHookResult = ReturnType<typeof useInviteUserMutation>;
export type InviteUserMutationResult = Apollo.MutationResult<InviteUserMutation>;
export type InviteUserMutationOptions = Apollo.BaseMutationOptions<InviteUserMutation, InviteUserMutationVariables>;
export const ResendInviteDocument = gql`
    mutation ResendInvite($resendInviteId: String!, $origin: String!) {
  resendInvite(id: $resendInviteId, origin: $origin)
}
    `;
export type ResendInviteMutationFn = Apollo.MutationFunction<ResendInviteMutation, ResendInviteMutationVariables>;

/**
 * __useResendInviteMutation__
 *
 * To run a mutation, you first call `useResendInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendInviteMutation, { data, loading, error }] = useResendInviteMutation({
 *   variables: {
 *      resendInviteId: // value for 'resendInviteId'
 *      origin: // value for 'origin'
 *   },
 * });
 */
export function useResendInviteMutation(baseOptions?: Apollo.MutationHookOptions<ResendInviteMutation, ResendInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendInviteMutation, ResendInviteMutationVariables>(ResendInviteDocument, options);
      }
export type ResendInviteMutationHookResult = ReturnType<typeof useResendInviteMutation>;
export type ResendInviteMutationResult = Apollo.MutationResult<ResendInviteMutation>;
export type ResendInviteMutationOptions = Apollo.BaseMutationOptions<ResendInviteMutation, ResendInviteMutationVariables>;
export const CancelInviteDocument = gql`
    mutation CancelInvite($cancelInviteId: String!) {
  cancelInvite(id: $cancelInviteId)
}
    `;
export type CancelInviteMutationFn = Apollo.MutationFunction<CancelInviteMutation, CancelInviteMutationVariables>;

/**
 * __useCancelInviteMutation__
 *
 * To run a mutation, you first call `useCancelInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelInviteMutation, { data, loading, error }] = useCancelInviteMutation({
 *   variables: {
 *      cancelInviteId: // value for 'cancelInviteId'
 *   },
 * });
 */
export function useCancelInviteMutation(baseOptions?: Apollo.MutationHookOptions<CancelInviteMutation, CancelInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelInviteMutation, CancelInviteMutationVariables>(CancelInviteDocument, options);
      }
export type CancelInviteMutationHookResult = ReturnType<typeof useCancelInviteMutation>;
export type CancelInviteMutationResult = Apollo.MutationResult<CancelInviteMutation>;
export type CancelInviteMutationOptions = Apollo.BaseMutationOptions<CancelInviteMutation, CancelInviteMutationVariables>;
export const ActivateUserDocument = gql`
    mutation ActivateUser($activateUserId: String!) {
  activateUser(id: $activateUserId)
}
    `;
export type ActivateUserMutationFn = Apollo.MutationFunction<ActivateUserMutation, ActivateUserMutationVariables>;

/**
 * __useActivateUserMutation__
 *
 * To run a mutation, you first call `useActivateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateUserMutation, { data, loading, error }] = useActivateUserMutation({
 *   variables: {
 *      activateUserId: // value for 'activateUserId'
 *   },
 * });
 */
export function useActivateUserMutation(baseOptions?: Apollo.MutationHookOptions<ActivateUserMutation, ActivateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateUserMutation, ActivateUserMutationVariables>(ActivateUserDocument, options);
      }
export type ActivateUserMutationHookResult = ReturnType<typeof useActivateUserMutation>;
export type ActivateUserMutationResult = Apollo.MutationResult<ActivateUserMutation>;
export type ActivateUserMutationOptions = Apollo.BaseMutationOptions<ActivateUserMutation, ActivateUserMutationVariables>;
export const DeactivateUserDocument = gql`
    mutation DeactivateUser($deactivateUserId: String!) {
  deactivateUser(id: $deactivateUserId)
}
    `;
export type DeactivateUserMutationFn = Apollo.MutationFunction<DeactivateUserMutation, DeactivateUserMutationVariables>;

/**
 * __useDeactivateUserMutation__
 *
 * To run a mutation, you first call `useDeactivateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateUserMutation, { data, loading, error }] = useDeactivateUserMutation({
 *   variables: {
 *      deactivateUserId: // value for 'deactivateUserId'
 *   },
 * });
 */
export function useDeactivateUserMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateUserMutation, DeactivateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateUserMutation, DeactivateUserMutationVariables>(DeactivateUserDocument, options);
      }
export type DeactivateUserMutationHookResult = ReturnType<typeof useDeactivateUserMutation>;
export type DeactivateUserMutationResult = Apollo.MutationResult<DeactivateUserMutation>;
export type DeactivateUserMutationOptions = Apollo.BaseMutationOptions<DeactivateUserMutation, DeactivateUserMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($updateUserId: String!, $locationIds: [String!]!, $userDto: UserDTO!) {
  updateUser(id: $updateUserId, locationIds: $locationIds, userDTO: $userDto)
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      updateUserId: // value for 'updateUserId'
 *      locationIds: // value for 'locationIds'
 *      userDto: // value for 'userDto'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const CreateVendorDocument = gql`
    mutation CreateVendor($createVendorDto: CreateVendorDTO!) {
  createVendor(createVendorDTO: $createVendorDto) {
    id
    bankName
    branchCity {
      id
      name
    }
    branchCode
    businessAddress
    city {
      id
      name
      country {
        id
        name
      }
    }
    comment
    contactPerson
    document
    documentExpiryDate
    drugLicenseNo
    ibanNumber
    leadTime
    manufacturers {
      description
      id
      lastReason
      lineOfBusiness
      name
      status
    }
    paymentMethod
    paymentTerms
    primaryEmailAddress
    primaryPhoneNumber
    registrationNumber
    secondaryEmailAddress
    secondaryPhoneNumber
    drugSaleLicense
    taxExemption
    stateProvince
    status
    stockReturnPolicy
    strn
    taxExemptionValidity
    taxReturn
    taxationNumber
    classification
    creditLimit
    name
    type
    withHoldTaxGroup
    withHoldTaxPercentage
    zipCode
  }
}
    `;
export type CreateVendorMutationFn = Apollo.MutationFunction<CreateVendorMutation, CreateVendorMutationVariables>;

/**
 * __useCreateVendorMutation__
 *
 * To run a mutation, you first call `useCreateVendorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVendorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVendorMutation, { data, loading, error }] = useCreateVendorMutation({
 *   variables: {
 *      createVendorDto: // value for 'createVendorDto'
 *   },
 * });
 */
export function useCreateVendorMutation(baseOptions?: Apollo.MutationHookOptions<CreateVendorMutation, CreateVendorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVendorMutation, CreateVendorMutationVariables>(CreateVendorDocument, options);
      }
export type CreateVendorMutationHookResult = ReturnType<typeof useCreateVendorMutation>;
export type CreateVendorMutationResult = Apollo.MutationResult<CreateVendorMutation>;
export type CreateVendorMutationOptions = Apollo.BaseMutationOptions<CreateVendorMutation, CreateVendorMutationVariables>;
export const UpdateVendorDocument = gql`
    mutation UpdateVendor($updateVendorDto: UpdateVendorDTO!) {
  updateVendor(updateVendorDTO: $updateVendorDto) {
    bankName
    branchCity {
      id
      name
    }
    branchCode
    businessAddress
    city {
      id
      name
      country {
        id
        name
      }
    }
    comment
    contactPerson
    document
    documentExpiryDate
    drugLicenseNo
    ibanNumber
    id
    leadTime
    manufacturers {
      description
      id
      lastReason
      lineOfBusiness
      name
      status
    }
    paymentMethod
    paymentTerms
    primaryEmailAddress
    primaryPhoneNumber
    registrationNumber
    secondaryEmailAddress
    secondaryPhoneNumber
    drugSaleLicense
    taxExemption
    stateProvince
    status
    stockReturnPolicy
    strn
    taxExemptionValidity
    taxReturn
    taxationNumber
    classification
    creditLimit
    name
    type
    withHoldTaxGroup
    withHoldTaxPercentage
    zipCode
  }
}
    `;
export type UpdateVendorMutationFn = Apollo.MutationFunction<UpdateVendorMutation, UpdateVendorMutationVariables>;

/**
 * __useUpdateVendorMutation__
 *
 * To run a mutation, you first call `useUpdateVendorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVendorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVendorMutation, { data, loading, error }] = useUpdateVendorMutation({
 *   variables: {
 *      updateVendorDto: // value for 'updateVendorDto'
 *   },
 * });
 */
export function useUpdateVendorMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVendorMutation, UpdateVendorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVendorMutation, UpdateVendorMutationVariables>(UpdateVendorDocument, options);
      }
export type UpdateVendorMutationHookResult = ReturnType<typeof useUpdateVendorMutation>;
export type UpdateVendorMutationResult = Apollo.MutationResult<UpdateVendorMutation>;
export type UpdateVendorMutationOptions = Apollo.BaseMutationOptions<UpdateVendorMutation, UpdateVendorMutationVariables>;
export const GetVendorsDocument = gql`
    query GetVendors($filter: [FilterGroup!], $sort: [SortCondition!], $page: Int!, $limit: Int!) {
  getVendors(filter: $filter, sort: $sort, page: $page, limit: $limit) {
    meta {
      totalCount
      page
      limit
    }
    data {
      id
      secondaryId
      bankName
      branchCity {
        id
        name
      }
      branchCode
      businessAddress
      city {
        id
        name
        country {
          id
          name
        }
      }
      comment
      contactPerson
      document
      documentExpiryDate
      drugLicenseNo
      ibanNumber
      leadTime
      manufacturers {
        description
        id
        lastReason
        lineOfBusiness
        name
        status
      }
      paymentMethod
      paymentTerms
      primaryEmailAddress
      primaryPhoneNumber
      registrationNumber
      secondaryEmailAddress
      secondaryPhoneNumber
      drugSaleLicense
      taxExemption
      stateProvince
      status
      stockReturnPolicy
      strn
      taxExemptionValidity
      taxReturn
      taxationNumber
      classification
      creditLimit
      name
      type
      withHoldTaxGroup
      withHoldTaxPercentage
      zipCode
    }
  }
}
    `;

/**
 * __useGetVendorsQuery__
 *
 * To run a query within a React component, call `useGetVendorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVendorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVendorsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetVendorsQuery(baseOptions: Apollo.QueryHookOptions<GetVendorsQuery, GetVendorsQueryVariables> & ({ variables: GetVendorsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVendorsQuery, GetVendorsQueryVariables>(GetVendorsDocument, options);
      }
export function useGetVendorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVendorsQuery, GetVendorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVendorsQuery, GetVendorsQueryVariables>(GetVendorsDocument, options);
        }
// @ts-ignore
export function useGetVendorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVendorsQuery, GetVendorsQueryVariables>): Apollo.UseSuspenseQueryResult<GetVendorsQuery, GetVendorsQueryVariables>;
export function useGetVendorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVendorsQuery, GetVendorsQueryVariables>): Apollo.UseSuspenseQueryResult<GetVendorsQuery | undefined, GetVendorsQueryVariables>;
export function useGetVendorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVendorsQuery, GetVendorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVendorsQuery, GetVendorsQueryVariables>(GetVendorsDocument, options);
        }
export type GetVendorsQueryHookResult = ReturnType<typeof useGetVendorsQuery>;
export type GetVendorsLazyQueryHookResult = ReturnType<typeof useGetVendorsLazyQuery>;
export type GetVendorsSuspenseQueryHookResult = ReturnType<typeof useGetVendorsSuspenseQuery>;
export type GetVendorsQueryResult = Apollo.QueryResult<GetVendorsQuery, GetVendorsQueryVariables>;
export const GetVendorsForOptionsDocument = gql`
    query GetVendorsForOptions($filter: [FilterGroup!], $sort: [SortCondition!], $page: Int!, $limit: Int!) {
  getVendors(filter: $filter, sort: $sort, page: $page, limit: $limit) {
    data {
      id
      name
      secondaryId
      type
    }
    meta {
      limit
      page
      totalCount
    }
  }
}
    `;

/**
 * __useGetVendorsForOptionsQuery__
 *
 * To run a query within a React component, call `useGetVendorsForOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVendorsForOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVendorsForOptionsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetVendorsForOptionsQuery(baseOptions: Apollo.QueryHookOptions<GetVendorsForOptionsQuery, GetVendorsForOptionsQueryVariables> & ({ variables: GetVendorsForOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVendorsForOptionsQuery, GetVendorsForOptionsQueryVariables>(GetVendorsForOptionsDocument, options);
      }
export function useGetVendorsForOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVendorsForOptionsQuery, GetVendorsForOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVendorsForOptionsQuery, GetVendorsForOptionsQueryVariables>(GetVendorsForOptionsDocument, options);
        }
// @ts-ignore
export function useGetVendorsForOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVendorsForOptionsQuery, GetVendorsForOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetVendorsForOptionsQuery, GetVendorsForOptionsQueryVariables>;
export function useGetVendorsForOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVendorsForOptionsQuery, GetVendorsForOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetVendorsForOptionsQuery | undefined, GetVendorsForOptionsQueryVariables>;
export function useGetVendorsForOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVendorsForOptionsQuery, GetVendorsForOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVendorsForOptionsQuery, GetVendorsForOptionsQueryVariables>(GetVendorsForOptionsDocument, options);
        }
export type GetVendorsForOptionsQueryHookResult = ReturnType<typeof useGetVendorsForOptionsQuery>;
export type GetVendorsForOptionsLazyQueryHookResult = ReturnType<typeof useGetVendorsForOptionsLazyQuery>;
export type GetVendorsForOptionsSuspenseQueryHookResult = ReturnType<typeof useGetVendorsForOptionsSuspenseQuery>;
export type GetVendorsForOptionsQueryResult = Apollo.QueryResult<GetVendorsForOptionsQuery, GetVendorsForOptionsQueryVariables>;
export const GetVendorDocument = gql`
    query GetVendor($getVendorId: String!) {
  getVendor(id: $getVendorId) {
    bankName
    branchCity {
      id
      name
    }
    branchCode
    businessAddress
    city {
      id
      name
      country {
        id
        name
      }
    }
    comment
    contactPerson
    document
    documentExpiryDate
    drugLicenseNo
    ibanNumber
    id
    leadTime
    manufacturers {
      description
      id
      lastReason
      lineOfBusiness
      name
      status
    }
    paymentMethod
    paymentTerms
    primaryEmailAddress
    primaryPhoneNumber
    registrationNumber
    secondaryEmailAddress
    secondaryPhoneNumber
    drugSaleLicense
    taxExemption
    stateProvince
    status
    stockReturnPolicy
    strn
    taxExemptionValidity
    taxReturn
    taxationNumber
    classification
    creditLimit
    name
    type
    withHoldTaxGroup
    withHoldTaxPercentage
    zipCode
  }
}
    `;

/**
 * __useGetVendorQuery__
 *
 * To run a query within a React component, call `useGetVendorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVendorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVendorQuery({
 *   variables: {
 *      getVendorId: // value for 'getVendorId'
 *   },
 * });
 */
export function useGetVendorQuery(baseOptions: Apollo.QueryHookOptions<GetVendorQuery, GetVendorQueryVariables> & ({ variables: GetVendorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVendorQuery, GetVendorQueryVariables>(GetVendorDocument, options);
      }
export function useGetVendorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVendorQuery, GetVendorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVendorQuery, GetVendorQueryVariables>(GetVendorDocument, options);
        }
// @ts-ignore
export function useGetVendorSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVendorQuery, GetVendorQueryVariables>): Apollo.UseSuspenseQueryResult<GetVendorQuery, GetVendorQueryVariables>;
export function useGetVendorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVendorQuery, GetVendorQueryVariables>): Apollo.UseSuspenseQueryResult<GetVendorQuery | undefined, GetVendorQueryVariables>;
export function useGetVendorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVendorQuery, GetVendorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVendorQuery, GetVendorQueryVariables>(GetVendorDocument, options);
        }
export type GetVendorQueryHookResult = ReturnType<typeof useGetVendorQuery>;
export type GetVendorLazyQueryHookResult = ReturnType<typeof useGetVendorLazyQuery>;
export type GetVendorSuspenseQueryHookResult = ReturnType<typeof useGetVendorSuspenseQuery>;
export type GetVendorQueryResult = Apollo.QueryResult<GetVendorQuery, GetVendorQueryVariables>;
export const GetVendorForPreviewsDocument = gql`
    query GetVendorForPreviews($getVendorId: String!) {
  getVendor(id: $getVendorId) {
    strn
    paymentTerms
    name
    taxationNumber
    contactPerson
    city {
      id
      name
      country {
        id
        name
      }
    }
    businessAddress
    status
  }
}
    `;

/**
 * __useGetVendorForPreviewsQuery__
 *
 * To run a query within a React component, call `useGetVendorForPreviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVendorForPreviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVendorForPreviewsQuery({
 *   variables: {
 *      getVendorId: // value for 'getVendorId'
 *   },
 * });
 */
export function useGetVendorForPreviewsQuery(baseOptions: Apollo.QueryHookOptions<GetVendorForPreviewsQuery, GetVendorForPreviewsQueryVariables> & ({ variables: GetVendorForPreviewsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVendorForPreviewsQuery, GetVendorForPreviewsQueryVariables>(GetVendorForPreviewsDocument, options);
      }
export function useGetVendorForPreviewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVendorForPreviewsQuery, GetVendorForPreviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVendorForPreviewsQuery, GetVendorForPreviewsQueryVariables>(GetVendorForPreviewsDocument, options);
        }
// @ts-ignore
export function useGetVendorForPreviewsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVendorForPreviewsQuery, GetVendorForPreviewsQueryVariables>): Apollo.UseSuspenseQueryResult<GetVendorForPreviewsQuery, GetVendorForPreviewsQueryVariables>;
export function useGetVendorForPreviewsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVendorForPreviewsQuery, GetVendorForPreviewsQueryVariables>): Apollo.UseSuspenseQueryResult<GetVendorForPreviewsQuery | undefined, GetVendorForPreviewsQueryVariables>;
export function useGetVendorForPreviewsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVendorForPreviewsQuery, GetVendorForPreviewsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVendorForPreviewsQuery, GetVendorForPreviewsQueryVariables>(GetVendorForPreviewsDocument, options);
        }
export type GetVendorForPreviewsQueryHookResult = ReturnType<typeof useGetVendorForPreviewsQuery>;
export type GetVendorForPreviewsLazyQueryHookResult = ReturnType<typeof useGetVendorForPreviewsLazyQuery>;
export type GetVendorForPreviewsSuspenseQueryHookResult = ReturnType<typeof useGetVendorForPreviewsSuspenseQuery>;
export type GetVendorForPreviewsQueryResult = Apollo.QueryResult<GetVendorForPreviewsQuery, GetVendorForPreviewsQueryVariables>;